/******/ (() => {
	// webpackBootstrap
	/******/ var __webpack_modules__ = {
		/***/ 646: /***/ (__unused_webpack_module, exports) => {
			"use strict";

			Object.defineProperty(exports, "__esModule", { value: true });
			/**
			 * Reads the content property on the documentElement ::before pseudo element
			 * for a string of ordered, comma-separated, breakpoint names.
			 *
			 * @returns An ordered array of strings representing the breakpoint names
			 *
			 */
			function readCSSBreakpoints() {
				return window
					.getComputedStyle(document.documentElement, ":before")
					.getPropertyValue("content")
					.replace(/"/g, "")
					.split(",");
			}
			/**
			 * Reads the content property on the documentElement ::after pseudo element
			 * for a string of the current breakpoint name. This value is updated using
			 * dynamically using media queries and should match a value found in
			 * the ::before pseudo element.
			 *
			 * @returns A string representing the current breakpoint name
			 *
			 */
			function readCSSCurrentBreakpoint() {
				return window
					.getComputedStyle(document.documentElement, ":after")
					.getPropertyValue("content")
					.replace(/"/g, "");
			}
			var callbacks = [];
			var cssBreakpoints = readCSSBreakpoints();
			var CSSBreakpoint = /** @class */ (function () {
				function CSSBreakpoint(cssBreakpoint) {
					this.cssBreakpoint = cssBreakpoint;
				}
				Object.defineProperty(CSSBreakpoint.prototype, "value", {
					get: function () {
						return this.cssBreakpoint;
					},
					enumerable: true,
					configurable: true,
				});
				/**
				 * Checks whether this breakpoint is at least the input breakpoint
				 *
				 * @param breakpointName - The input breakpoint name
				 * @returns Whether this breakpoint is the same or greater than the input breakpoint
				 *
				 */
				CSSBreakpoint.prototype.min = function (breakpointName) {
					var comparison =
						cssBreakpoints.indexOf(this.value) -
						cssBreakpoints.indexOf(breakpointName);
					return comparison >= 0;
				};
				/**
				 * Checks whether this breakpoint is at most the input breakpoint
				 *
				 * @param breakpointName - The input breakpoint name
				 * @returns Whether this breakpoint is the same or less than the input breakpoint
				 *
				 */
				CSSBreakpoint.prototype.max = function (breakpointName) {
					var comparison =
						cssBreakpoints.indexOf(this.value) -
						cssBreakpoints.indexOf(breakpointName);
					return comparison <= 0;
				};
				/**
				 * Checks whether this breakpoint is at within the input breakpoint start
				 * and input breakpoint end, inclusive
				 *
				 * @param breakpointNameStart - The starting input breakpoint name
				 * @param breakpointNameEnd - The ending input breakpoint name
				 * @returns Whether this breakpoint is the same or greater than the starting input
				 *          breakpoint and the same or less than the ending input breakpoint
				 *
				 */
				CSSBreakpoint.prototype.range = function (
					breakpointNameStart,
					breakpointNameEnd
				) {
					var indexCurrent = cssBreakpoints.indexOf(this.value);
					var indexStart = cssBreakpoints.indexOf(breakpointNameStart);
					var indexEnd = cssBreakpoints.indexOf(breakpointNameEnd);
					return indexStart <= indexCurrent && indexCurrent <= indexEnd;
				};
				/**
				 * Checks whether this breakpoint is one of the input breakpoints
				 *
				 * @param breakpointNames - One or more input breakpoint names
				 * @returns Whether this breakpoint is one of the input breakpoints
				 *
				 */
				CSSBreakpoint.prototype.is = function () {
					var _this = this;
					var breakpointNames = [];
					for (var _i = 0; _i < arguments.length; _i++) {
						breakpointNames[_i] = arguments[_i];
					}
					return breakpointNames.some(function (breakpoint) {
						return breakpoint === _this.value;
					});
				};
				return CSSBreakpoint;
			})();
			var breakpoints = {
				previous: new CSSBreakpoint(readCSSCurrentBreakpoint()),
				current: new CSSBreakpoint(readCSSCurrentBreakpoint()),
			};
			/**
			 * Gets the breakpoints
			 *
			 * @returns The current and previous breakpoint
			 *
			 */
			function get() {
				return breakpoints;
			}
			exports.get = get;
			/**
			 * Adds an event listener to be called when a breakpoint changes
			 *
			 * @param callback - The function to be called when a breakpoint changes
			 *
			 */
			function onChange(callback) {
				if (callbacks.indexOf(callback) === -1) {
					callbacks.push(callback);
				}
			}
			exports.onChange = onChange;
			/**
			 * Removes an event listener to be called when a breakpoint changes
			 *
			 * @param callback - The function to be removed from the set of event listeners
			 *
			 */
			function offChange(callback) {
				var index = callbacks.indexOf(callback);
				if (index !== -1) {
					callbacks.splice(index, 1);
				}
			}
			exports.offChange = offChange;
			var currentMin = function (breakpointName) {
				return breakpoints.current.min(breakpointName);
			};
			exports.min = currentMin;
			var currentMax = function (breakpointName) {
				return breakpoints.current.max(breakpointName);
			};
			exports.max = currentMax;
			var currentRange = function (breakpointNameStart, breakpointNameEnd) {
				return breakpoints.current.range(
					breakpointNameStart,
					breakpointNameEnd
				);
			};
			exports.range = currentRange;
			var currentIs = function () {
				var _a;
				var breakpointNames = [];
				for (var _i = 0; _i < arguments.length; _i++) {
					breakpointNames[_i] = arguments[_i];
				}
				return (_a = breakpoints.current).is.apply(_a, breakpointNames);
			};
			exports.is = currentIs;
			/*
			 * document.styleSheets is considered experimental technology; however,
			 * the majority of current browsers implement this functionality.
			 *
			 * One drawback is under certain conditions, stylesheets may become
			 * available due to security rules in the browser and we must be able to
			 * fallback gracefully.
			 */
			var styleSheetList = document.styleSheets;
			var mediaLists = Object.keys(styleSheetList).reduce(function (
				accumulator,
				key
			) {
				var stylesheet = styleSheetList[key];
				if (!stylesheet.href || stylesheet.href.indexOf("theme") === -1) {
					return accumulator;
				}
				try {
					var cssRules = stylesheet.cssRules;
					for (var i = 0; i < cssRules.length; i++) {
						var cssRule = stylesheet.cssRules[i];
						if (!(cssRule instanceof CSSMediaRule)) {
							continue;
						}
						for (var j = 0; j < cssRules.length; j++) {
							var cssMediaCssRule = cssRule.cssRules[j];
							if (!(cssMediaCssRule instanceof CSSStyleRule)) {
								continue;
							}
							if (
								cssMediaCssRule.selectorText &&
								cssMediaCssRule.selectorText.indexOf("html::after") !== -1
							) {
								accumulator.push(cssRule.media);
							}
						}
					}
				} catch (_a) {
					return accumulator;
				}
				return accumulator;
			},
			[]);
			/*
			 * Use window.matchMedia when stylesheets are accessible in the browser.
			 * matchMedia is theoretically more performant than listening to every resize
			 * event because it only fires when a media query boundary is crossed.
			 *
			 * If stylesheets aren't available, revert back to using the resize event.
			 */
			if (mediaLists.length > 0) {
				mediaLists.forEach(function (mediaList) {
					var mql = window.matchMedia(mediaList.mediaText);
					mql.addListener(function () {
						var cssCurrentBreakpoint = readCSSCurrentBreakpoint();
						if (breakpoints.current.value !== cssCurrentBreakpoint) {
							breakpoints.previous = breakpoints.current;
							breakpoints.current = new CSSBreakpoint(cssCurrentBreakpoint);
							callbacks.forEach(function (callback) {
								return callback(breakpoints);
							});
						}
					});
				});
			} else {
				window.addEventListener("resize", function () {
					var cssCurrentBreakpoint = readCSSCurrentBreakpoint();
					if (breakpoints.current.value !== cssCurrentBreakpoint) {
						breakpoints.previous = breakpoints.current;
						breakpoints.current = new CSSBreakpoint(cssCurrentBreakpoint);
						callbacks.forEach(function (callback) {
							return callback(breakpoints);
						});
					}
				});
			}

			/***/
		},

		/***/ 766: /***/ (__unused_webpack_module, exports) => {
			"use strict";
			var __webpack_unused_export__;

			__webpack_unused_export__ = true;
			var EventHandler = /** @class */ (function () {
				function EventHandler() {
					this.events = [];
				}
				EventHandler.prototype.register = function (el, event, listener) {
					if (!el || !event || !listener) return null;
					this.events.push({ el: el, event: event, listener: listener });
					el.addEventListener(event, listener);
					return { el: el, event: event, listener: listener };
				};
				EventHandler.prototype.unregister = function (_a) {
					var el = _a.el,
						event = _a.event,
						listener = _a.listener;
					if (!el || !event || !listener) return null;
					this.events = this.events.filter(function (e) {
						return el !== e.el || event !== e.event || listener !== e.listener;
					});
					el.removeEventListener(event, listener);
					return { el: el, event: event, listener: listener };
				};
				EventHandler.prototype.unregisterAll = function () {
					this.events.forEach(function (_a) {
						var el = _a.el,
							event = _a.event,
							listener = _a.listener;
						return el.removeEventListener(event, listener);
					});
					this.events = [];
				};
				return EventHandler;
			})();
			exports.Z = EventHandler;

			/***/
		},

		/***/ 722: /***/ () => {
			class VariantSelection extends HTMLElement {
				static get observedAttributes() {
					return ["variant"];
				}

				constructor() {
					super();
					this._loaded = false;
					this._productFetcher = Promise.resolve(false);

					this._onMainElChange = (event) => {
						this.variant = event.currentTarget.value;
					};

					const mainInputEl = this.querySelector("input[data-variants]");
					this._mainEl =
						mainInputEl || this.querySelector("select[data-variants]");
				}

				set variant(value) {
					if (value) {
						this.setAttribute("variant", value);
					} else {
						this.removeAttribute("variant");
					}
				}

				get variant() {
					return this.getAttribute("variant");
				}

				connectedCallback() {
					this._productFetcher = this._fetchProduct();
					const mainInputEl = this.querySelector("input[data-variants]");
					this._mainEl =
						mainInputEl || this.querySelector("select[data-variants]");

					this._mainEl.addEventListener("change", this._onMainElChange);

					this.variant = this._mainEl.value;
				}

				disconnectedCallback() {
					this._mainEl.removeEventListener("change", this._onMainElChange);

					this._mainEl = null;
				}

				attributeChangedCallback(name, oldValue, newValue) {
					if (oldValue === newValue) return;

					switch (name) {
						case "variant":
							this._changeVariant(newValue);

							break;
					}
				}

				getProduct() {
					return this._loaded
						? Promise.resolve(this._product)
						: this._productFetcher;
				}

				getVariant() {
					return this.getProduct()
						.then((product) =>
							product
								? product.variants.find(
										(v) => v.id.toString() === this.variant
								  ) || false
								: false
						)
						.catch(() => false);
				}

				getState() {
					return this.getVariant().then((variant) =>
						variant ? "selected" : this.getAttribute("variant")
					);
				}

				_changeVariant(value) {
					this._dispatchEvent(value).then(() => {
						this._mainEl.value = value;
					});
				}

				_fetchProduct() {
					return fetch(this.getAttribute("product-url"))
						.then((response) => response.json())
						.then((product) => {
							this._product = product;
							return product;
						})
						.catch(() => {
							this._product = null;
						})
						.finally(() => {
							this._loaded = true;
						});
				}

				_dispatchEvent(value) {
					return this.getProduct().then((product) => {
						const variant = product
							? product.variants.find((v) => v.id.toString() === value) || false
							: false;
						const state = variant ? "selected" : value;
						const event = new CustomEvent("variant-change", {
							detail: {
								product,
								variant,
								state,
							},
						});
						this.dispatchEvent(event);
					});
				}
			}

			const valueElementType = {
				select: "option",
				radio: 'input[type="radio"]',
			};

			function setSelectedOptions(
				selectOptions,
				radioOptions,
				selectedOptions
			) {
				selectOptions.forEach(({ option }) => {
					option.value =
						selectedOptions[parseInt(option.dataset.variantOptionIndex, 10)];
				});
				radioOptions.forEach(({ values }) => {
					values.forEach((value) => {
						value.checked =
							value.value ===
							selectedOptions[
								parseInt(value.dataset.variantOptionValueIndex, 10)
							];
					});
				});
			}

			function getOptions(optionsEls) {
				const select = [];
				const radio = [];

				for (let i = 0; i < optionsEls.length; i++) {
					const optionEl = optionsEls[i];
					const wrappers = optionEl.matches(
						"[data-variant-option-value-wrapper]"
					)
						? [optionEl]
						: Array.prototype.slice.call(
								optionEl.querySelectorAll("[data-variant-option-value-wrapper]")
						  );
					const values = optionEl.matches("[data-variant-option-value]")
						? [optionEl]
						: Array.prototype.slice.call(
								optionEl.querySelectorAll("[data-variant-option-value]")
						  );
					if (!values.length) break;
					const option = {
						option: optionEl,
						wrappers,
						values,
					};

					if (values[0].matches(valueElementType.select)) {
						select.push(option);
					} else if (values[0].matches(valueElementType.radio)) {
						radio.push(option);
					}
				}

				return {
					select,
					radio,
				};
			}

			function getSelectedOptions(product, selectOptions, radioOptions) {
				const options = product.options.map(() => "not-selected");
				selectOptions.forEach(({ option }) => {
					if (option.value !== "not-selected") {
						options[parseInt(option.dataset.variantOptionIndex, 10)] =
							option.value;
					}
				});
				radioOptions.forEach(({ values }) => {
					values.forEach((value) => {
						if (value.checked) {
							options[parseInt(value.dataset.variantOptionValueIndex, 10)] =
								value.value;
						}
					});
				});
				return options;
			}

			function getVariantFromSelectedOptions(variants, selectedOptions) {
				for (let i = 0; i < variants.length; i++) {
					const variant = variants[i];
					const isVariant = variant.options.every(
						(option, index) => option === selectedOptions[index]
					);
					if (isVariant) return variant; // We found the variant
				}

				return false;
			}

			function _getVariant(variants, options) {
				return variants.find((variant) =>
					variant.options.every((option, index) => option === options[index])
				);
			}

			function _setOptionsMap(
				product,
				selectedOptions,
				optionsMap,
				option1,
				option2 = null,
				option3 = null
			) {
				const updatedOptionsMap = {
					...optionsMap,
				};
				const options = [option1, option2, option3].filter(
					(option) => !!option
				);

				const variant = _getVariant(product.variants, options);

				const variantOptionMatches = options.filter(
					(option, index) => option === selectedOptions[index]
				).length;
				const isCurrentVariant =
					variantOptionMatches === product.options.length;
				const isNeighbor = variantOptionMatches === product.options.length - 1;

				for (let i = 0; i < options.length; i++) {
					const option = options[i];

					if (option) {
						let { setByCurrentVariant, setByNeighbor, accessible, available } =
							optionsMap[i][option];

						if (variant) {
							accessible = variant.available || accessible; // The current variant is always
							// the priority for option availability

							if (isCurrentVariant) {
								setByCurrentVariant = true;
								({ available } = variant);
							} else if (!setByCurrentVariant && isNeighbor) {
								// If the variant is a neighbor
								// And the option doesn't belong to the variant
								// Use its availability information for the option
								// If multiple neighbors exist, prefer true
								available = setByNeighbor
									? available || variant.available
									: variant.available;
								setByNeighbor = true;
							}
						} else if (isCurrentVariant) {
							// Catch case where current variant doesn't exist
							// Ensure availability is false
							setByCurrentVariant = true;
							available = false;
						} else if (!setByCurrentVariant && isNeighbor) {
							// Catch case where neighbor doesn't exist
							// Ensure availability is false
							// If multiple neighbors exist, prefer true
							available = setByNeighbor ? available : false;
							setByNeighbor = true;
						} // If the option isn't set by either
						// the current variant or a neighbor
						// default to general accessibility

						if (!setByCurrentVariant && !setByNeighbor) {
							available = accessible;
						}

						updatedOptionsMap[i][option] = {
							setByCurrentVariant,
							setByNeighbor,
							accessible,
							available,
						};
					}
				}

				return updatedOptionsMap;
			}

			function getOptionsAccessibility(product, selectedOptions) {
				let optionsMap = product.options.map(() => ({}));

				for (let i = 0; i < product.options.length; i++) {
					for (let j = 0; j < product.variants.length; j++) {
						const variant = product.variants[j];
						const option = variant.options[i];
						optionsMap[i][option] = {
							setByCurrentVariant: false,
							setByNeighbor: false,
							accessible: false,
							available: false,
						};
					}
				}

				const option1Values =
					optionsMap.length >= 1 ? Object.keys(optionsMap[0]) : [];
				const option2Values =
					optionsMap.length >= 2 ? Object.keys(optionsMap[1]) : [];
				const option3Values =
					optionsMap.length >= 3 ? Object.keys(optionsMap[2]) : [];
				option1Values.forEach((option1Value) => {
					option2Values.forEach((option2Value) => {
						option3Values.forEach((option3Value) => {
							optionsMap = _setOptionsMap(
								product,
								selectedOptions,
								optionsMap,
								option1Value,
								option2Value,
								option3Value
							);
						});

						if (!option3Values.length) {
							optionsMap = _setOptionsMap(
								product,
								selectedOptions,
								optionsMap,
								option1Value,
								option2Value
							);
						}
					});

					if (!option2Values.length) {
						optionsMap = _setOptionsMap(
							product,
							selectedOptions,
							optionsMap,
							option1Value
						);
					}
				});
				return optionsMap;
			}

			function updateOptions(
				product,
				selectOptions,
				radioOptions,
				selectedOptions,
				disableUnavailableOptions,
				removeUnavailableOptions
			) {
				const options = [...selectOptions, ...radioOptions];

				if (options.length === 0) {
					return;
				}

				const optionsAccessibility = getOptionsAccessibility(
					product,
					selectedOptions
				); // Iterate over each option type

				for (let i = 0; i < product.options.length; i++) {
					// Corresponding select dropdown, if it exists
					const optionValues = options.find(({ option }) => {
						if (parseInt(option.dataset.variantOptionIndex, 10) === i) {
							return true;
						}

						return false;
					});

					if (optionValues) {
						const fragment = document.createDocumentFragment();
						const { option, wrappers, values } = optionValues;

						for (let j = values.length - 1; j >= 0; j--) {
							const wrapper = wrappers[j];
							const optionValue = values[j];
							const { value } = optionValue;
							const { available } =
								value in optionsAccessibility[i]
									? optionsAccessibility[i][value]
									: false;
							const { accessible } =
								value in optionsAccessibility[i]
									? optionsAccessibility[i][value]
									: false;
							const isChooseOption = value === "not-selected"; // Option element to indicate unchosen option
							// Disable unavailable options

							optionValue.disabled =
								isChooseOption || (disableUnavailableOptions && !accessible);
							optionValue.dataset.variantOptionAccessible = accessible;
							optionValue.dataset.variantOptionAvailable = available;

							if (!removeUnavailableOptions || accessible || isChooseOption) {
								fragment.insertBefore(wrapper, fragment.firstElementChild);
							}
						}

						option.innerHTML = "";
						option.appendChild(fragment);
						const chosenValue = values.find(
							(value) => value.selected || value.checked
						);
						option.dataset.variantOptionChosenValue =
							chosenValue && chosenValue.value !== "not-selected"
								? chosenValue.value
								: false;
					}
				}
			}

			class OptionsSelection extends HTMLElement {
				static get observedAttributes() {
					return [
						"variant-selection",
						"disable-unavailable",
						"remove-unavailable",
					];
				}

				static synchronize(mainOptionsSelection) {
					const mainVariantSelection =
						mainOptionsSelection.getVariantSelection(); // Fast return if we aren't associated with a variant selection

					if (!mainVariantSelection) return Promise.resolve(false);
					return mainOptionsSelection
						.getSelectedOptions()
						.then((selectedOptions) => {
							// Update all other options selects associated with the same variant ui
							const optionsSelections =
								document.querySelectorAll("options-selection");
							optionsSelections.forEach((optionsSelection) => {
								if (
									optionsSelection !== mainOptionsSelection &&
									optionsSelection.getVariantSelection() ===
										mainVariantSelection
								) {
									optionsSelection.setSelectedOptions(selectedOptions);
								}
							});
						})
						.then(() => true);
				}

				constructor() {
					super();
					this.style.display = "";
					this._events = [];
					this._onChangeFn = this._onOptionChange.bind(this);
					this._optionsEls = this.querySelectorAll("[data-variant-option]");
					({ select: this._selectOptions, radio: this._radioOptions } =
						getOptions(this._optionsEls));

					this._associateVariantSelection(
						this.getAttribute("variant-selection")
					);
				}

				set variantSelection(value) {
					if (value) {
						this.setAttribute("variant-selection", value);
					} else {
						this.removeAttribute("variant-selection");
					}
				}

				get variantSelection() {
					return this.getAttribute("variant-selection");
				}

				connectedCallback() {
					this._optionsEls = this.querySelectorAll("[data-variant-option]");
					({ select: this._selectOptions, radio: this._radioOptions } =
						getOptions(this._optionsEls));

					this._associateVariantSelection(
						this.getAttribute("variant-selection")
					);

					this._selectOptions.forEach(({ option }) => {
						option.addEventListener("change", this._onChangeFn);

						this._events.push({
							el: option,
							fn: this._onChangeFn,
						});
					});

					this._radioOptions.forEach(({ values }) => {
						values.forEach((value) => {
							value.addEventListener("change", this._onChangeFn);

							this._events.push({
								el: value,
								fn: this._onChangeFn,
							});
						});
					});

					this._onOptionChange();
				}

				disconnectedCallback() {
					this._resetOptions();

					this._events.forEach(({ el, fn }) =>
						el.removeEventListener("change", fn)
					);

					this._events = [];
				}

				attributeChangedCallback(name, _oldValue, newValue) {
					switch (name) {
						case "variant-selection":
							this._associateVariantSelection(newValue);

							break;

						case "disable-unavailable":
						case "remove-unavailable":
							this._updateOptions(
								this.hasAttribute("disable-unavailable"),
								this.hasAttribute("remove-unavailable")
							);

							break;
					}
				}

				getSelectedOptions() {
					if (!this._variantSelection) return Promise.resolve(null);
					return this._variantSelection.getProduct().then((product) => {
						if (!product) return null;
						return getSelectedOptions(
							product,
							this._selectOptions,
							this._radioOptions
						);
					});
				}

				getVariantSelection() {
					return this._variantSelection;
				}

				setSelectedOptions(selectedOptions) {
					setSelectedOptions(
						this._selectOptions,
						this._radioOptions,
						selectedOptions
					);
					return this._updateOptions(
						this.hasAttribute("disable-unavailable"),
						this.hasAttribute("remove-unavailable"),
						selectedOptions
					);
				}

				_associateVariantSelection(id) {
					this._variantSelection = id
						? document.getElementById(id)
						: this.closest("variant-selection");
				}

				_updateLabels() {
					// Update any labels
					for (let i = 0; i < this._optionsEls.length; i++) {
						const optionsEl = this._optionsEls[i];
						let optionsNameEl = null;
						let { parentElement } = optionsEl;

						while (parentElement && !optionsNameEl) {
							const tmpOptionsNameEl = parentElement.querySelector(
								"[data-variant-option-name]"
							);

							if (tmpOptionsNameEl) {
								optionsNameEl = tmpOptionsNameEl;
							}

							({ parentElement } = parentElement);
						}

						if (optionsNameEl) {
							optionsNameEl.dataset.variantOptionChosenValue =
								optionsEl.dataset.variantOptionChosenValue;

							if (optionsEl.dataset.variantOptionChosenValue !== "false") {
								optionsNameEl.innerHTML =
									optionsNameEl.dataset.variantOptionName;
								const optionNameValueSpan = optionsNameEl.querySelector("span");

								if (optionNameValueSpan) {
									optionNameValueSpan.innerHTML =
										optionsEl.dataset.variantOptionChosenValue;
								}
							} else {
								optionsNameEl.innerHTML =
									optionsNameEl.dataset.variantOptionChooseName;
							}
						}
					}
				}

				_resetOptions() {
					return this._updateOptions(false, false);
				}

				_updateOptions(
					disableUnavailableOptions,
					removeUnavailableOptions,
					selectedOptions = null
				) {
					if (!this._variantSelection) return Promise.resolve(false);
					return this._variantSelection
						.getProduct()
						.then((product) => {
							updateOptions(
								product,
								this._selectOptions,
								this._radioOptions,
								selectedOptions ||
									getSelectedOptions(
										product,
										this._selectOptions,
										this._radioOptions
									),
								disableUnavailableOptions,
								removeUnavailableOptions
							);

							this._updateLabels();
						})
						.then(() => true);
				}

				_updateVariantSelection(product, selectedOptions) {
					if (!this._variantSelection) return;
					const variant = getVariantFromSelectedOptions(
						product.variants,
						selectedOptions
					);
					const isNotSelected = selectedOptions.some(
						(option) => option === "not-selected"
					); // Update master select

					if (variant) {
						this._variantSelection.variant = variant.id;
					} else {
						this._variantSelection.variant = isNotSelected
							? "not-selected"
							: "unavailable";
					}
				}

				_onOptionChange() {
					if (!this._variantSelection) return;

					this._variantSelection.getProduct().then((product) => {
						if (!product) return;
						const selectedOptions = getSelectedOptions(
							product,
							this._selectOptions,
							this._radioOptions
						);

						this._updateOptions(
							this.hasAttribute("disable-unavailable"),
							this.hasAttribute("remove-unavailable"),
							selectedOptions
						);

						this._updateVariantSelection(product, selectedOptions);

						OptionsSelection.synchronize(this);
					});
				}
			}

			if (!customElements.get("variant-selection")) {
				customElements.define("variant-selection", VariantSelection);
			}

			if (!customElements.get("options-selection")) {
				customElements.define("options-selection", OptionsSelection);
			}

			/***/
		},

		/***/ 741: /***/ (module, exports, __webpack_require__) => {
			var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
			/**
			 * matchesSelector v2.0.2
			 * matchesSelector( element, '.selector' )
			 * MIT license
			 */

			/*jshint browser: true, strict: true, undef: true, unused: true */

			(function (window, factory) {
				/*global define: false, module: false */
				"use strict";
				// universal module definition
				if (true) {
					// AMD
					!((__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
					(__WEBPACK_AMD_DEFINE_RESULT__ =
						typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
							? __WEBPACK_AMD_DEFINE_FACTORY__.call(
									exports,
									__webpack_require__,
									exports,
									module
							  )
							: __WEBPACK_AMD_DEFINE_FACTORY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(window, function factory() {
				"use strict";

				var matchesMethod = (function () {
					var ElemProto = window.Element.prototype;
					// check for the standard method name first
					if (ElemProto.matches) {
						return "matches";
					}
					// check un-prefixed
					if (ElemProto.matchesSelector) {
						return "matchesSelector";
					}
					// check vendor prefixes
					var prefixes = ["webkit", "moz", "ms", "o"];

					for (var i = 0; i < prefixes.length; i++) {
						var prefix = prefixes[i];
						var method = prefix + "MatchesSelector";
						if (ElemProto[method]) {
							return method;
						}
					}
				})();

				return function matchesSelector(elem, selector) {
					return elem[matchesMethod](selector);
				};
			});

			/***/
		},

		/***/ 158: /***/ function (module, exports, __webpack_require__) {
			var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
			/**
			 * EvEmitter v1.1.0
			 * Lil' event emitter
			 * MIT License
			 */

			/* jshint unused: true, undef: true, strict: true */

			(function (global, factory) {
				// universal module definition
				/* jshint strict: false */ /* globals define, module, window */
				if (true) {
					// AMD - RequireJS
					!((__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
					(__WEBPACK_AMD_DEFINE_RESULT__ =
						typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
							? __WEBPACK_AMD_DEFINE_FACTORY__.call(
									exports,
									__webpack_require__,
									exports,
									module
							  )
							: __WEBPACK_AMD_DEFINE_FACTORY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(typeof window != "undefined" ? window : this, function () {
				"use strict";

				function EvEmitter() {}

				var proto = EvEmitter.prototype;

				proto.on = function (eventName, listener) {
					if (!eventName || !listener) {
						return;
					}
					// set events hash
					var events = (this._events = this._events || {});
					// set listeners array
					var listeners = (events[eventName] = events[eventName] || []);
					// only add once
					if (listeners.indexOf(listener) == -1) {
						listeners.push(listener);
					}

					return this;
				};

				proto.once = function (eventName, listener) {
					if (!eventName || !listener) {
						return;
					}
					// add event
					this.on(eventName, listener);
					// set once flag
					// set onceEvents hash
					var onceEvents = (this._onceEvents = this._onceEvents || {});
					// set onceListeners object
					var onceListeners = (onceEvents[eventName] =
						onceEvents[eventName] || {});
					// set flag
					onceListeners[listener] = true;

					return this;
				};

				proto.off = function (eventName, listener) {
					var listeners = this._events && this._events[eventName];
					if (!listeners || !listeners.length) {
						return;
					}
					var index = listeners.indexOf(listener);
					if (index != -1) {
						listeners.splice(index, 1);
					}

					return this;
				};

				proto.emitEvent = function (eventName, args) {
					var listeners = this._events && this._events[eventName];
					if (!listeners || !listeners.length) {
						return;
					}
					// copy over to avoid interference if .off() in listener
					listeners = listeners.slice(0);
					args = args || [];
					// once stuff
					var onceListeners = this._onceEvents && this._onceEvents[eventName];

					for (var i = 0; i < listeners.length; i++) {
						var listener = listeners[i];
						var isOnce = onceListeners && onceListeners[listener];
						if (isOnce) {
							// remove listener
							// remove before trigger to prevent recursion
							this.off(eventName, listener);
							// unset once flag
							delete onceListeners[listener];
						}
						// trigger listener
						listener.apply(this, args);
					}

					return this;
				};

				proto.allOff = function () {
					delete this._events;
					delete this._onceEvents;
				};

				return EvEmitter;
			});

			/***/
		},

		/***/ 729: /***/ (module) => {
			var selectors = [
				'iframe[src*="player.vimeo.com"]',
				'iframe[src*="youtube.com"]',
				'iframe[src*="youtube-nocookie.com"]',
				'iframe[src*="kickstarter.com"][src*="video.html"]',
				"object",
			];

			var css =
				".fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}";

			module.exports = function (parentSelector, opts) {
				parentSelector = parentSelector || "body";
				opts = opts || {};

				if (isObject(parentSelector)) {
					opts = parentSelector;
					parentSelector = "body";
				}

				opts.ignore = opts.ignore || "";
				opts.players = opts.players || "";

				var containers = queryAll(parentSelector);
				if (!hasLength(containers)) return;

				if (!document.getElementById("fit-vids-style")) {
					var head = document.head || document.getElementsByTagName("head")[0];
					head.appendChild(styles());
				}

				var custom = toSelectorArray(opts.players);
				var ignored = toSelectorArray(opts.ignore);
				var ignoredSelector = ignored.length > 0 ? ignored.join() : null;
				var selector = selectors.concat(custom).join();

				if (!hasLength(selector)) {
					return;
				}

				containers.forEach(function (container) {
					var videos = queryAll(container, selector);

					videos.forEach(function (video) {
						if (ignoredSelector && video.matches(ignoredSelector)) {
							return;
						}
						wrap(video);
					});
				});
			};

			function queryAll(el, selector) {
				if (typeof el === "string") {
					selector = el;
					el = document;
				}
				return Array.prototype.slice.call(el.querySelectorAll(selector));
			}

			function toSelectorArray(input) {
				if (typeof input === "string") {
					return input.split(",").map(trim).filter(hasLength);
				} else if (isArray(input)) {
					return flatten(input.map(toSelectorArray).filter(hasLength));
				}
				return input || [];
			}

			function wrap(el) {
				if (/fluid-width-video-wrapper/.test(el.parentNode.className)) {
					return;
				}

				var widthAttr = parseInt(el.getAttribute("width"), 10);
				var heightAttr = parseInt(el.getAttribute("height"), 10);

				var width = !isNaN(widthAttr) ? widthAttr : el.clientWidth;
				var height = !isNaN(heightAttr) ? heightAttr : el.clientHeight;
				var aspect = height / width;

				el.removeAttribute("width");
				el.removeAttribute("height");

				var wrapper = document.createElement("div");
				el.parentNode.insertBefore(wrapper, el);
				wrapper.className = "fluid-width-video-wrapper";
				wrapper.style.paddingTop = aspect * 100 + "%";
				wrapper.appendChild(el);
			}

			function styles() {
				var div = document.createElement("div");
				div.innerHTML =
					'<p>x</p><style id="fit-vids-style">' + css + "</style>";
				return div.childNodes[1];
			}

			function hasLength(input) {
				return input.length > 0;
			}

			function trim(str) {
				return str.replace(/^\s+|\s+$/g, "");
			}

			function flatten(input) {
				return [].concat.apply([], input);
			}

			function isObject(input) {
				return Object.prototype.toString.call(input) === "[object Object]";
			}

			function isArray(input) {
				return Object.prototype.toString.call(input) === "[object Array]";
			}

			/***/
		},

		/***/ 47: /***/ (module, exports, __webpack_require__) => {
			var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
			/**
			 * Fizzy UI utils v2.0.7
			 * MIT license
			 */

			/*jshint browser: true, undef: true, unused: true, strict: true */

			(function (window, factory) {
				// universal module definition
				/*jshint strict: false */ /*globals define, module, require */

				if (true) {
					// AMD
					!((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(741)]),
					(__WEBPACK_AMD_DEFINE_RESULT__ = function (matchesSelector) {
						return factory(window, matchesSelector);
					}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(window, function factory(window, matchesSelector) {
				"use strict";

				var utils = {};

				// ----- extend ----- //

				// extends objects
				utils.extend = function (a, b) {
					for (var prop in b) {
						a[prop] = b[prop];
					}
					return a;
				};

				// ----- modulo ----- //

				utils.modulo = function (num, div) {
					return ((num % div) + div) % div;
				};

				// ----- makeArray ----- //

				var arraySlice = Array.prototype.slice;

				// turn element or nodeList into an array
				utils.makeArray = function (obj) {
					if (Array.isArray(obj)) {
						// use object if already an array
						return obj;
					}
					// return empty array if undefined or null. #6
					if (obj === null || obj === undefined) {
						return [];
					}

					var isArrayLike =
						typeof obj == "object" && typeof obj.length == "number";
					if (isArrayLike) {
						// convert nodeList to array
						return arraySlice.call(obj);
					}

					// array of single index
					return [obj];
				};

				// ----- removeFrom ----- //

				utils.removeFrom = function (ary, obj) {
					var index = ary.indexOf(obj);
					if (index != -1) {
						ary.splice(index, 1);
					}
				};

				// ----- getParent ----- //

				utils.getParent = function (elem, selector) {
					while (elem.parentNode && elem != document.body) {
						elem = elem.parentNode;
						if (matchesSelector(elem, selector)) {
							return elem;
						}
					}
				};

				// ----- getQueryElement ----- //

				// use element as selector string
				utils.getQueryElement = function (elem) {
					if (typeof elem == "string") {
						return document.querySelector(elem);
					}
					return elem;
				};

				// ----- handleEvent ----- //

				// enable .ontype to trigger from .addEventListener( elem, 'type' )
				utils.handleEvent = function (event) {
					var method = "on" + event.type;
					if (this[method]) {
						this[method](event);
					}
				};

				// ----- filterFindElements ----- //

				utils.filterFindElements = function (elems, selector) {
					// make array of elems
					elems = utils.makeArray(elems);
					var ffElems = [];

					elems.forEach(function (elem) {
						// check that elem is an actual element
						if (!(elem instanceof HTMLElement)) {
							return;
						}
						// add elem if no selector
						if (!selector) {
							ffElems.push(elem);
							return;
						}
						// filter & find items if we have a selector
						// filter
						if (matchesSelector(elem, selector)) {
							ffElems.push(elem);
						}
						// find children
						var childElems = elem.querySelectorAll(selector);
						// concat childElems to filterFound array
						for (var i = 0; i < childElems.length; i++) {
							ffElems.push(childElems[i]);
						}
					});

					return ffElems;
				};

				// ----- debounceMethod ----- //

				utils.debounceMethod = function (_class, methodName, threshold) {
					threshold = threshold || 100;
					// original method
					var method = _class.prototype[methodName];
					var timeoutName = methodName + "Timeout";

					_class.prototype[methodName] = function () {
						var timeout = this[timeoutName];
						clearTimeout(timeout);

						var args = arguments;
						var _this = this;
						this[timeoutName] = setTimeout(function () {
							method.apply(_this, args);
							delete _this[timeoutName];
						}, threshold);
					};
				};

				// ----- docReady ----- //

				utils.docReady = function (callback) {
					var readyState = document.readyState;
					if (readyState == "complete" || readyState == "interactive") {
						// do async to allow for other scripts to run. metafizzy/flickity#441
						setTimeout(callback);
					} else {
						document.addEventListener("DOMContentLoaded", callback);
					}
				};

				// ----- htmlInit ----- //

				// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
				utils.toDashed = function (str) {
					return str
						.replace(/(.)([A-Z])/g, function (match, $1, $2) {
							return $1 + "-" + $2;
						})
						.toLowerCase();
				};

				var console = window.console;
				/**
				 * allow user to initialize classes via [data-namespace] or .js-namespace class
				 * htmlInit( Widget, 'widgetName' )
				 * options are parsed from data-namespace-options
				 */
				utils.htmlInit = function (WidgetClass, namespace) {
					utils.docReady(function () {
						var dashedNamespace = utils.toDashed(namespace);
						var dataAttr = "data-" + dashedNamespace;
						var dataAttrElems = document.querySelectorAll("[" + dataAttr + "]");
						var jsDashElems = document.querySelectorAll(
							".js-" + dashedNamespace
						);
						var elems = utils
							.makeArray(dataAttrElems)
							.concat(utils.makeArray(jsDashElems));
						var dataOptionsAttr = dataAttr + "-options";
						var jQuery = window.jQuery;

						elems.forEach(function (elem) {
							var attr =
								elem.getAttribute(dataAttr) ||
								elem.getAttribute(dataOptionsAttr);
							var options;
							try {
								options = attr && JSON.parse(attr);
							} catch (error) {
								// log error, do not initialize
								if (console) {
									console.error(
										"Error parsing " +
											dataAttr +
											" on " +
											elem.className +
											": " +
											error
									);
								}
								return;
							}
							// initialize
							var instance = new WidgetClass(elem, options);
							// make available via $().data('namespace')
							if (jQuery) {
								jQuery.data(elem, namespace, instance);
							}
						});
					});
				};

				// -----  ----- //

				return utils;
			});

			/***/
		},

		/***/ 597: /***/ (module, exports, __webpack_require__) => {
			var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // add, remove cell
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (true) {
					// AMD
					!((__WEBPACK_AMD_DEFINE_ARRAY__ = [
						__webpack_require__(217),
						__webpack_require__(47),
					]),
					(__WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, utils) {
						return factory(window, Flickity, utils);
					}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(window, function factory(window, Flickity, utils) {
				"use strict";

				// append cells to a document fragment
				function getCellsFragment(cells) {
					var fragment = document.createDocumentFragment();
					cells.forEach(function (cell) {
						fragment.appendChild(cell.element);
					});
					return fragment;
				}

				// -------------------------- add/remove cell prototype -------------------------- //

				var proto = Flickity.prototype;

				/**
				 * Insert, prepend, or append cells
				 * @param {Element, Array, NodeList} elems
				 * @param {Integer} index
				 */
				proto.insert = function (elems, index) {
					var cells = this._makeCells(elems);
					if (!cells || !cells.length) {
						return;
					}
					var len = this.cells.length;
					// default to append
					index = index === undefined ? len : index;
					// add cells with document fragment
					var fragment = getCellsFragment(cells);
					// append to slider
					var isAppend = index == len;
					if (isAppend) {
						this.slider.appendChild(fragment);
					} else {
						var insertCellElement = this.cells[index].element;
						this.slider.insertBefore(fragment, insertCellElement);
					}
					// add to this.cells
					if (index === 0) {
						// prepend, add to start
						this.cells = cells.concat(this.cells);
					} else if (isAppend) {
						// append, add to end
						this.cells = this.cells.concat(cells);
					} else {
						// insert in this.cells
						var endCells = this.cells.splice(index, len - index);
						this.cells = this.cells.concat(cells).concat(endCells);
					}

					this._sizeCells(cells);
					this.cellChange(index, true);
				};

				proto.append = function (elems) {
					this.insert(elems, this.cells.length);
				};

				proto.prepend = function (elems) {
					this.insert(elems, 0);
				};

				/**
				 * Remove cells
				 * @param {Element, Array, NodeList} elems
				 */
				proto.remove = function (elems) {
					var cells = this.getCells(elems);
					if (!cells || !cells.length) {
						return;
					}

					var minCellIndex = this.cells.length - 1;
					// remove cells from collection & DOM
					cells.forEach(function (cell) {
						cell.remove();
						var index = this.cells.indexOf(cell);
						minCellIndex = Math.min(index, minCellIndex);
						utils.removeFrom(this.cells, cell);
					}, this);

					this.cellChange(minCellIndex, true);
				};

				/**
				 * logic to be run after a cell's size changes
				 * @param {Element} elem - cell's element
				 */
				proto.cellSizeChange = function (elem) {
					var cell = this.getCell(elem);
					if (!cell) {
						return;
					}
					cell.getSize();

					var index = this.cells.indexOf(cell);
					this.cellChange(index);
				};

				/**
				 * logic any time a cell is changed: added, removed, or size changed
				 * @param {Integer} changedCellIndex - index of the changed cell, optional
				 */
				proto.cellChange = function (changedCellIndex, isPositioningSlider) {
					var prevSelectedElem = this.selectedElement;
					this._positionCells(changedCellIndex);
					this._getWrapShiftCells();
					this.setGallerySize();
					// update selectedIndex
					// try to maintain position & select previous selected element
					var cell = this.getCell(prevSelectedElem);
					if (cell) {
						this.selectedIndex = this.getCellSlideIndex(cell);
					}
					this.selectedIndex = Math.min(
						this.slides.length - 1,
						this.selectedIndex
					);

					this.emitEvent("cellChange", [changedCellIndex]);
					// position slider
					this.select(this.selectedIndex);
					// do not position slider after lazy load
					if (isPositioningSlider) {
						this.positionSliderAtSelected();
					}
				};

				// -----  ----- //

				return Flickity;
			});

			/***/
		},

		/***/ 880: /***/ (module, exports, __webpack_require__) => {
			var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // animate
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (true) {
					// AMD
					!((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(47)]),
					(__WEBPACK_AMD_DEFINE_RESULT__ = function (utils) {
						return factory(window, utils);
					}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(window, function factory(window, utils) {
				"use strict";

				// -------------------------- animate -------------------------- //

				var proto = {};

				proto.startAnimation = function () {
					if (this.isAnimating) {
						return;
					}

					this.isAnimating = true;
					this.restingFrames = 0;
					this.animate();
				};

				proto.animate = function () {
					this.applyDragForce();
					this.applySelectedAttraction();

					var previousX = this.x;

					this.integratePhysics();
					this.positionSlider();
					this.settle(previousX);
					// animate next frame
					if (this.isAnimating) {
						var _this = this;
						requestAnimationFrame(function animateFrame() {
							_this.animate();
						});
					}
				};

				proto.positionSlider = function () {
					var x = this.x;
					// wrap position around
					if (this.options.wrapAround && this.cells.length > 1) {
						x = utils.modulo(x, this.slideableWidth);
						x = x - this.slideableWidth;
						this.shiftWrapCells(x);
					}

					this.setTranslateX(x, this.isAnimating);
					this.dispatchScrollEvent();
				};

				proto.setTranslateX = function (x, is3d) {
					x += this.cursorPosition;
					// reverse if right-to-left and using transform
					x = this.options.rightToLeft ? -x : x;
					var translateX = this.getPositionValue(x);
					// use 3D tranforms for hardware acceleration on iOS
					// but use 2D when settled, for better font-rendering
					this.slider.style.transform = is3d
						? "translate3d(" + translateX + ",0,0)"
						: "translateX(" + translateX + ")";
				};

				proto.dispatchScrollEvent = function () {
					var firstSlide = this.slides[0];
					if (!firstSlide) {
						return;
					}
					var positionX = -this.x - firstSlide.target;
					var progress = positionX / this.slidesWidth;
					this.dispatchEvent("scroll", null, [progress, positionX]);
				};

				proto.positionSliderAtSelected = function () {
					if (!this.cells.length) {
						return;
					}
					this.x = -this.selectedSlide.target;
					this.velocity = 0; // stop wobble
					this.positionSlider();
				};

				proto.getPositionValue = function (position) {
					if (this.options.percentPosition) {
						// percent position, round to 2 digits, like 12.34%
						return (
							Math.round((position / this.size.innerWidth) * 10000) * 0.01 + "%"
						);
					} else {
						// pixel positioning
						return Math.round(position) + "px";
					}
				};

				proto.settle = function (previousX) {
					// keep track of frames where x hasn't moved
					if (
						!this.isPointerDown &&
						Math.round(this.x * 100) == Math.round(previousX * 100)
					) {
						this.restingFrames++;
					}
					// stop animating if resting for 3 or more frames
					if (this.restingFrames > 2) {
						this.isAnimating = false;
						delete this.isFreeScrolling;
						// render position with translateX when settled
						this.positionSlider();
						this.dispatchEvent("settle", null, [this.selectedIndex]);
					}
				};

				proto.shiftWrapCells = function (x) {
					// shift before cells
					var beforeGap = this.cursorPosition + x;
					this._shiftCells(this.beforeShiftCells, beforeGap, -1);
					// shift after cells
					var afterGap =
						this.size.innerWidth -
						(x + this.slideableWidth + this.cursorPosition);
					this._shiftCells(this.afterShiftCells, afterGap, 1);
				};

				proto._shiftCells = function (cells, gap, shift) {
					for (var i = 0; i < cells.length; i++) {
						var cell = cells[i];
						var cellShift = gap > 0 ? shift : 0;
						cell.wrapShift(cellShift);
						gap -= cell.size.outerWidth;
					}
				};

				proto._unshiftCells = function (cells) {
					if (!cells || !cells.length) {
						return;
					}
					for (var i = 0; i < cells.length; i++) {
						cells[i].wrapShift(0);
					}
				};

				// -------------------------- physics -------------------------- //

				proto.integratePhysics = function () {
					this.x += this.velocity;
					this.velocity *= this.getFrictionFactor();
				};

				proto.applyForce = function (force) {
					this.velocity += force;
				};

				proto.getFrictionFactor = function () {
					return (
						1 -
						this.options[
							this.isFreeScrolling ? "freeScrollFriction" : "friction"
						]
					);
				};

				proto.getRestingPosition = function () {
					// my thanks to Steven Wittens, who simplified this math greatly
					return this.x + this.velocity / (1 - this.getFrictionFactor());
				};

				proto.applyDragForce = function () {
					if (!this.isDraggable || !this.isPointerDown) {
						return;
					}
					// change the position to drag position by applying force
					var dragVelocity = this.dragX - this.x;
					var dragForce = dragVelocity - this.velocity;
					this.applyForce(dragForce);
				};

				proto.applySelectedAttraction = function () {
					// do not attract if pointer down or no slides
					var dragDown = this.isDraggable && this.isPointerDown;
					if (dragDown || this.isFreeScrolling || !this.slides.length) {
						return;
					}
					var distance = this.selectedSlide.target * -1 - this.x;
					var force = distance * this.options.selectedAttraction;
					this.applyForce(force);
				};

				return proto;
			});

			/***/
		},

		/***/ 229: /***/ (module, exports, __webpack_require__) => {
			var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // Flickity.Cell
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (true) {
					// AMD
					!((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(131)]),
					(__WEBPACK_AMD_DEFINE_RESULT__ = function (getSize) {
						return factory(window, getSize);
					}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(window, function factory(window, getSize) {
				"use strict";

				function Cell(elem, parent) {
					this.element = elem;
					this.parent = parent;

					this.create();
				}

				var proto = Cell.prototype;

				proto.create = function () {
					this.element.style.position = "absolute";
					this.element.setAttribute("aria-hidden", "true");
					this.x = 0;
					this.shift = 0;
				};

				proto.destroy = function () {
					// reset style
					this.unselect();
					this.element.style.position = "";
					var side = this.parent.originSide;
					this.element.style[side] = "";
				};

				proto.getSize = function () {
					this.size = getSize(this.element);
				};

				proto.setPosition = function (x) {
					this.x = x;
					this.updateTarget();
					this.renderPosition(x);
				};

				// setDefaultTarget v1 method, backwards compatibility, remove in v3
				proto.updateTarget = proto.setDefaultTarget = function () {
					var marginProperty =
						this.parent.originSide == "left" ? "marginLeft" : "marginRight";
					this.target =
						this.x +
						this.size[marginProperty] +
						this.size.width * this.parent.cellAlign;
				};

				proto.renderPosition = function (x) {
					// render position of cell with in slider
					var side = this.parent.originSide;
					this.element.style[side] = this.parent.getPositionValue(x);
				};

				proto.select = function () {
					this.element.classList.add("is-selected");
					this.element.removeAttribute("aria-hidden");
				};

				proto.unselect = function () {
					this.element.classList.remove("is-selected");
					this.element.setAttribute("aria-hidden", "true");
				};

				/**
				 * @param {Integer} factor - 0, 1, or -1
				 **/
				proto.wrapShift = function (shift) {
					this.shift = shift;
					this.renderPosition(this.x + this.parent.slideableWidth * shift);
				};

				proto.remove = function () {
					this.element.parentNode.removeChild(this.element);
				};

				return Cell;
			});

			/***/
		},

		/***/ 690: /***/ (module, exports, __webpack_require__) => {
			var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // drag
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (true) {
					// AMD
					!((__WEBPACK_AMD_DEFINE_ARRAY__ = [
						__webpack_require__(217),
						__webpack_require__(842),
						__webpack_require__(47),
					]),
					(__WEBPACK_AMD_DEFINE_RESULT__ = function (
						Flickity,
						Unidragger,
						utils
					) {
						return factory(window, Flickity, Unidragger, utils);
					}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(window, function factory(window, Flickity, Unidragger, utils) {
				"use strict";

				// ----- defaults ----- //

				utils.extend(Flickity.defaults, {
					draggable: ">1",
					dragThreshold: 3,
				});

				// ----- create ----- //

				Flickity.createMethods.push("_createDrag");

				// -------------------------- drag prototype -------------------------- //

				var proto = Flickity.prototype;
				utils.extend(proto, Unidragger.prototype);
				proto._touchActionValue = "pan-y";

				// --------------------------  -------------------------- //

				var isTouch = "createTouch" in document;
				var isTouchmoveScrollCanceled = false;

				proto._createDrag = function () {
					this.on("activate", this.onActivateDrag);
					this.on("uiChange", this._uiChangeDrag);
					this.on("deactivate", this.onDeactivateDrag);
					this.on("cellChange", this.updateDraggable);
					// TODO updateDraggable on resize? if groupCells & slides change
					// HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
					// #457, RubaXa/Sortable#973
					if (isTouch && !isTouchmoveScrollCanceled) {
						window.addEventListener("touchmove", function () {});
						isTouchmoveScrollCanceled = true;
					}
				};

				proto.onActivateDrag = function () {
					this.handles = [this.viewport];
					this.bindHandles();
					this.updateDraggable();
				};

				proto.onDeactivateDrag = function () {
					this.unbindHandles();
					this.element.classList.remove("is-draggable");
				};

				proto.updateDraggable = function () {
					// disable dragging if less than 2 slides. #278
					if (this.options.draggable == ">1") {
						this.isDraggable = this.slides.length > 1;
					} else {
						this.isDraggable = this.options.draggable;
					}
					if (this.isDraggable) {
						this.element.classList.add("is-draggable");
					} else {
						this.element.classList.remove("is-draggable");
					}
				};

				// backwards compatibility
				proto.bindDrag = function () {
					this.options.draggable = true;
					this.updateDraggable();
				};

				proto.unbindDrag = function () {
					this.options.draggable = false;
					this.updateDraggable();
				};

				proto._uiChangeDrag = function () {
					delete this.isFreeScrolling;
				};

				// -------------------------- pointer events -------------------------- //

				proto.pointerDown = function (event, pointer) {
					if (!this.isDraggable) {
						this._pointerDownDefault(event, pointer);
						return;
					}
					var isOkay = this.okayPointerDown(event);
					if (!isOkay) {
						return;
					}

					this._pointerDownPreventDefault(event);
					this.pointerDownFocus(event);
					// blur
					if (document.activeElement != this.element) {
						// do not blur if already focused
						this.pointerDownBlur();
					}

					// stop if it was moving
					this.dragX = this.x;
					this.viewport.classList.add("is-pointer-down");
					// track scrolling
					this.pointerDownScroll = getScrollPosition();
					window.addEventListener("scroll", this);

					this._pointerDownDefault(event, pointer);
				};

				// default pointerDown logic, used for staticClick
				proto._pointerDownDefault = function (event, pointer) {
					// track start event position
					// Safari 9 overrides pageX and pageY. These values needs to be copied. #779
					this.pointerDownPointer = {
						pageX: pointer.pageX,
						pageY: pointer.pageY,
					};
					// bind move and end events
					this._bindPostStartEvents(event);
					this.dispatchEvent("pointerDown", event, [pointer]);
				};

				var focusNodes = {
					INPUT: true,
					TEXTAREA: true,
					SELECT: true,
				};

				proto.pointerDownFocus = function (event) {
					var isFocusNode = focusNodes[event.target.nodeName];
					if (!isFocusNode) {
						this.focus();
					}
				};

				proto._pointerDownPreventDefault = function (event) {
					var isTouchStart = event.type == "touchstart";
					var isTouchPointer = event.pointerType == "touch";
					var isFocusNode = focusNodes[event.target.nodeName];
					if (!isTouchStart && !isTouchPointer && !isFocusNode) {
						event.preventDefault();
					}
				};

				// ----- move ----- //

				proto.hasDragStarted = function (moveVector) {
					return Math.abs(moveVector.x) > this.options.dragThreshold;
				};

				// ----- up ----- //

				proto.pointerUp = function (event, pointer) {
					delete this.isTouchScrolling;
					this.viewport.classList.remove("is-pointer-down");
					this.dispatchEvent("pointerUp", event, [pointer]);
					this._dragPointerUp(event, pointer);
				};

				proto.pointerDone = function () {
					window.removeEventListener("scroll", this);
					delete this.pointerDownScroll;
				};

				// -------------------------- dragging -------------------------- //

				proto.dragStart = function (event, pointer) {
					if (!this.isDraggable) {
						return;
					}
					this.dragStartPosition = this.x;
					this.startAnimation();
					window.removeEventListener("scroll", this);
					this.dispatchEvent("dragStart", event, [pointer]);
				};

				proto.pointerMove = function (event, pointer) {
					var moveVector = this._dragPointerMove(event, pointer);
					this.dispatchEvent("pointerMove", event, [pointer, moveVector]);
					this._dragMove(event, pointer, moveVector);
				};

				proto.dragMove = function (event, pointer, moveVector) {
					if (!this.isDraggable) {
						return;
					}
					event.preventDefault();

					this.previousDragX = this.dragX;
					// reverse if right-to-left
					var direction = this.options.rightToLeft ? -1 : 1;
					if (this.options.wrapAround) {
						// wrap around move. #589
						moveVector.x = moveVector.x % this.slideableWidth;
					}
					var dragX = this.dragStartPosition + moveVector.x * direction;

					if (!this.options.wrapAround && this.slides.length) {
						// slow drag
						var originBound = Math.max(
							-this.slides[0].target,
							this.dragStartPosition
						);
						dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
						var endBound = Math.min(
							-this.getLastSlide().target,
							this.dragStartPosition
						);
						dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
					}

					this.dragX = dragX;

					this.dragMoveTime = new Date();
					this.dispatchEvent("dragMove", event, [pointer, moveVector]);
				};

				proto.dragEnd = function (event, pointer) {
					if (!this.isDraggable) {
						return;
					}
					if (this.options.freeScroll) {
						this.isFreeScrolling = true;
					}
					// set selectedIndex based on where flick will end up
					var index = this.dragEndRestingSelect();

					if (this.options.freeScroll && !this.options.wrapAround) {
						// if free-scroll & not wrap around
						// do not free-scroll if going outside of bounding slides
						// so bounding slides can attract slider, and keep it in bounds
						var restingX = this.getRestingPosition();
						this.isFreeScrolling =
							-restingX > this.slides[0].target &&
							-restingX < this.getLastSlide().target;
					} else if (!this.options.freeScroll && index == this.selectedIndex) {
						// boost selection if selected index has not changed
						index += this.dragEndBoostSelect();
					}
					delete this.previousDragX;
					// apply selection
					// TODO refactor this, selecting here feels weird
					// HACK, set flag so dragging stays in correct direction
					this.isDragSelect = this.options.wrapAround;
					this.select(index);
					delete this.isDragSelect;
					this.dispatchEvent("dragEnd", event, [pointer]);
				};

				proto.dragEndRestingSelect = function () {
					var restingX = this.getRestingPosition();
					// how far away from selected slide
					var distance = Math.abs(
						this.getSlideDistance(-restingX, this.selectedIndex)
					);
					// get closet resting going up and going down
					var positiveResting = this._getClosestResting(restingX, distance, 1);
					var negativeResting = this._getClosestResting(restingX, distance, -1);
					// use closer resting for wrap-around
					var index =
						positiveResting.distance < negativeResting.distance
							? positiveResting.index
							: negativeResting.index;
					return index;
				};

				/**
				 * given resting X and distance to selected cell
				 * get the distance and index of the closest cell
				 * @param {Number} restingX - estimated post-flick resting position
				 * @param {Number} distance - distance to selected cell
				 * @param {Integer} increment - +1 or -1, going up or down
				 * @returns {Object} - { distance: {Number}, index: {Integer} }
				 */
				proto._getClosestResting = function (restingX, distance, increment) {
					var index = this.selectedIndex;
					var minDistance = Infinity;
					var condition =
						this.options.contain && !this.options.wrapAround
							? // if contain, keep going if distance is equal to minDistance
							  function (d, md) {
									return d <= md;
							  }
							: function (d, md) {
									return d < md;
							  };
					while (condition(distance, minDistance)) {
						// measure distance to next cell
						index += increment;
						minDistance = distance;
						distance = this.getSlideDistance(-restingX, index);
						if (distance === null) {
							break;
						}
						distance = Math.abs(distance);
					}
					return {
						distance: minDistance,
						// selected was previous index
						index: index - increment,
					};
				};

				/**
				 * measure distance between x and a slide target
				 * @param {Number} x
				 * @param {Integer} index - slide index
				 */
				proto.getSlideDistance = function (x, index) {
					var len = this.slides.length;
					// wrap around if at least 2 slides
					var isWrapAround = this.options.wrapAround && len > 1;
					var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
					var slide = this.slides[slideIndex];
					if (!slide) {
						return null;
					}
					// add distance for wrap-around slides
					var wrap = isWrapAround
						? this.slideableWidth * Math.floor(index / len)
						: 0;
					return x - (slide.target + wrap);
				};

				proto.dragEndBoostSelect = function () {
					// do not boost if no previousDragX or dragMoveTime
					if (
						this.previousDragX === undefined ||
						!this.dragMoveTime ||
						// or if drag was held for 100 ms
						new Date() - this.dragMoveTime > 100
					) {
						return 0;
					}

					var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
					var delta = this.previousDragX - this.dragX;
					if (distance > 0 && delta > 0) {
						// boost to next if moving towards the right, and positive velocity
						return 1;
					} else if (distance < 0 && delta < 0) {
						// boost to previous if moving towards the left, and negative velocity
						return -1;
					}
					return 0;
				};

				// ----- staticClick ----- //

				proto.staticClick = function (event, pointer) {
					// get clickedCell, if cell was clicked
					var clickedCell = this.getParentCell(event.target);
					var cellElem = clickedCell && clickedCell.element;
					var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
					this.dispatchEvent("staticClick", event, [
						pointer,
						cellElem,
						cellIndex,
					]);
				};

				// ----- scroll ----- //

				proto.onscroll = function () {
					var scroll = getScrollPosition();
					var scrollMoveX = this.pointerDownScroll.x - scroll.x;
					var scrollMoveY = this.pointerDownScroll.y - scroll.y;
					// cancel click/tap if scroll is too much
					if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
						this._pointerDone();
					}
				};

				// ----- utils ----- //

				function getScrollPosition() {
					return {
						x: window.pageXOffset,
						y: window.pageYOffset,
					};
				}

				// -----  ----- //

				return Flickity;
			});

			/***/
		},

		/***/ 217: /***/ (module, exports, __webpack_require__) => {
			var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // Flickity main
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (true) {
					// AMD
					!((__WEBPACK_AMD_DEFINE_ARRAY__ = [
						__webpack_require__(158),
						__webpack_require__(131),
						__webpack_require__(47),
						__webpack_require__(229),
						__webpack_require__(714),
						__webpack_require__(880),
					]),
					(__WEBPACK_AMD_DEFINE_RESULT__ = function (
						EvEmitter,
						getSize,
						utils,
						Cell,
						Slide,
						animatePrototype
					) {
						return factory(
							window,
							EvEmitter,
							getSize,
							utils,
							Cell,
							Slide,
							animatePrototype
						);
					}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
					var _Flickity;
				}
			})(
				window,
				function factory(
					window,
					EvEmitter,
					getSize,
					utils,
					Cell,
					Slide,
					animatePrototype
				) {
					"use strict";

					// vars
					var jQuery = window.jQuery;
					var getComputedStyle = window.getComputedStyle;
					var console = window.console;

					function moveElements(elems, toElem) {
						elems = utils.makeArray(elems);
						while (elems.length) {
							toElem.appendChild(elems.shift());
						}
					}

					// -------------------------- Flickity -------------------------- //

					// globally unique identifiers
					var GUID = 0;
					// internal store of all Flickity intances
					var instances = {};

					function Flickity(element, options) {
						var queryElement = utils.getQueryElement(element);
						if (!queryElement) {
							if (console) {
								console.error(
									"Bad element for Flickity: " + (queryElement || element)
								);
							}
							return;
						}
						this.element = queryElement;
						// do not initialize twice on same element
						if (this.element.flickityGUID) {
							var instance = instances[this.element.flickityGUID];
							instance.option(options);
							return instance;
						}

						// add jQuery
						if (jQuery) {
							this.$element = jQuery(this.element);
						}
						// options
						this.options = utils.extend({}, this.constructor.defaults);
						this.option(options);

						// kick things off
						this._create();
					}

					Flickity.defaults = {
						accessibility: true,
						// adaptiveHeight: false,
						cellAlign: "center",
						// cellSelector: undefined,
						// contain: false,
						freeScrollFriction: 0.075, // friction when free-scrolling
						friction: 0.28, // friction when selecting
						namespaceJQueryEvents: true,
						// initialIndex: 0,
						percentPosition: true,
						resize: true,
						selectedAttraction: 0.025,
						setGallerySize: true,
						// watchCSS: false,
						// wrapAround: false
					};

					// hash of methods triggered on _create()
					Flickity.createMethods = [];

					var proto = Flickity.prototype;
					// inherit EventEmitter
					utils.extend(proto, EvEmitter.prototype);

					proto._create = function () {
						// add id for Flickity.data
						var id = (this.guid = ++GUID);
						this.element.flickityGUID = id; // expando
						instances[id] = this; // associate via id
						// initial properties
						this.selectedIndex = 0;
						// how many frames slider has been in same position
						this.restingFrames = 0;
						// initial physics properties
						this.x = 0;
						this.velocity = 0;
						this.originSide = this.options.rightToLeft ? "right" : "left";
						// create viewport & slider
						this.viewport = document.createElement("div");
						this.viewport.className = "flickity-viewport";
						this._createSlider();

						if (this.options.resize || this.options.watchCSS) {
							window.addEventListener("resize", this);
						}

						// add listeners from on option
						for (var eventName in this.options.on) {
							var listener = this.options.on[eventName];
							this.on(eventName, listener);
						}

						Flickity.createMethods.forEach(function (method) {
							this[method]();
						}, this);

						if (this.options.watchCSS) {
							this.watchCSS();
						} else {
							this.activate();
						}
					};

					/**
					 * set options
					 * @param {Object} opts
					 */
					proto.option = function (opts) {
						utils.extend(this.options, opts);
					};

					proto.activate = function () {
						if (this.isActive) {
							return;
						}
						this.isActive = true;
						this.element.classList.add("flickity-enabled");
						if (this.options.rightToLeft) {
							this.element.classList.add("flickity-rtl");
						}

						this.getSize();
						// move initial cell elements so they can be loaded as cells
						var cellElems = this._filterFindCellElements(this.element.children);
						moveElements(cellElems, this.slider);
						this.viewport.appendChild(this.slider);
						this.element.appendChild(this.viewport);
						// get cells from children
						this.reloadCells();

						if (this.options.accessibility) {
							// allow element to focusable
							this.element.tabIndex = 0;
							// listen for key presses
							this.element.addEventListener("keydown", this);
						}

						this.emitEvent("activate");
						this.selectInitialIndex();
						// flag for initial activation, for using initialIndex
						this.isInitActivated = true;
						// ready event. #493
						this.dispatchEvent("ready");
					};

					// slider positions the cells
					proto._createSlider = function () {
						// slider element does all the positioning
						var slider = document.createElement("div");
						slider.className = "flickity-slider";
						slider.style[this.originSide] = 0;
						this.slider = slider;
					};

					proto._filterFindCellElements = function (elems) {
						return utils.filterFindElements(elems, this.options.cellSelector);
					};

					// goes through all children
					proto.reloadCells = function () {
						// collection of item elements
						this.cells = this._makeCells(this.slider.children);
						this.positionCells();
						this._getWrapShiftCells();
						this.setGallerySize();
					};

					/**
					 * turn elements into Flickity.Cells
					 * @param {Array or NodeList or HTMLElement} elems
					 * @returns {Array} items - collection of new Flickity Cells
					 */
					proto._makeCells = function (elems) {
						var cellElems = this._filterFindCellElements(elems);

						// create new Flickity for collection
						var cells = cellElems.map(function (cellElem) {
							return new Cell(cellElem, this);
						}, this);

						return cells;
					};

					proto.getLastCell = function () {
						return this.cells[this.cells.length - 1];
					};

					proto.getLastSlide = function () {
						return this.slides[this.slides.length - 1];
					};

					// positions all cells
					proto.positionCells = function () {
						// size all cells
						this._sizeCells(this.cells);
						// position all cells
						this._positionCells(0);
					};

					/**
					 * position certain cells
					 * @param {Integer} index - which cell to start with
					 */
					proto._positionCells = function (index) {
						index = index || 0;
						// also measure maxCellHeight
						// start 0 if positioning all cells
						this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
						var cellX = 0;
						// get cellX
						if (index > 0) {
							var startCell = this.cells[index - 1];
							cellX = startCell.x + startCell.size.outerWidth;
						}
						var len = this.cells.length;
						for (var i = index; i < len; i++) {
							var cell = this.cells[i];
							cell.setPosition(cellX);
							cellX += cell.size.outerWidth;
							this.maxCellHeight = Math.max(
								cell.size.outerHeight,
								this.maxCellHeight
							);
						}
						// keep track of cellX for wrap-around
						this.slideableWidth = cellX;
						// slides
						this.updateSlides();
						// contain slides target
						this._containSlides();
						// update slidesWidth
						this.slidesWidth = len
							? this.getLastSlide().target - this.slides[0].target
							: 0;
					};

					/**
					 * cell.getSize() on multiple cells
					 * @param {Array} cells
					 */
					proto._sizeCells = function (cells) {
						cells.forEach(function (cell) {
							cell.getSize();
						});
					};

					// --------------------------  -------------------------- //

					proto.updateSlides = function () {
						this.slides = [];
						if (!this.cells.length) {
							return;
						}

						var slide = new Slide(this);
						this.slides.push(slide);
						var isOriginLeft = this.originSide == "left";
						var nextMargin = isOriginLeft ? "marginRight" : "marginLeft";

						var canCellFit = this._getCanCellFit();

						this.cells.forEach(function (cell, i) {
							// just add cell if first cell in slide
							if (!slide.cells.length) {
								slide.addCell(cell);
								return;
							}

							var slideWidth =
								slide.outerWidth -
								slide.firstMargin +
								(cell.size.outerWidth - cell.size[nextMargin]);

							if (canCellFit.call(this, i, slideWidth)) {
								slide.addCell(cell);
							} else {
								// doesn't fit, new slide
								slide.updateTarget();

								slide = new Slide(this);
								this.slides.push(slide);
								slide.addCell(cell);
							}
						}, this);
						// last slide
						slide.updateTarget();
						// update .selectedSlide
						this.updateSelectedSlide();
					};

					proto._getCanCellFit = function () {
						var groupCells = this.options.groupCells;
						if (!groupCells) {
							return function () {
								return false;
							};
						} else if (typeof groupCells == "number") {
							// group by number. 3 -> [0,1,2], [3,4,5], ...
							var number = parseInt(groupCells, 10);
							return function (i) {
								return i % number !== 0;
							};
						}
						// default, group by width of slide
						// parse '75%
						var percentMatch =
							typeof groupCells == "string" && groupCells.match(/^(\d+)%$/);
						var percent = percentMatch
							? parseInt(percentMatch[1], 10) / 100
							: 1;
						return function (i, slideWidth) {
							return slideWidth <= (this.size.innerWidth + 1) * percent;
						};
					};

					// alias _init for jQuery plugin .flickity()
					proto._init = proto.reposition = function () {
						this.positionCells();
						this.positionSliderAtSelected();
					};

					proto.getSize = function () {
						this.size = getSize(this.element);
						this.setCellAlign();
						this.cursorPosition = this.size.innerWidth * this.cellAlign;
					};

					var cellAlignShorthands = {
						// cell align, then based on origin side
						center: {
							left: 0.5,
							right: 0.5,
						},
						left: {
							left: 0,
							right: 1,
						},
						right: {
							right: 0,
							left: 1,
						},
					};

					proto.setCellAlign = function () {
						var shorthand = cellAlignShorthands[this.options.cellAlign];
						this.cellAlign = shorthand
							? shorthand[this.originSide]
							: this.options.cellAlign;
					};

					proto.setGallerySize = function () {
						if (this.options.setGallerySize) {
							var height =
								this.options.adaptiveHeight && this.selectedSlide
									? this.selectedSlide.height
									: this.maxCellHeight;
							this.viewport.style.height = height + "px";
						}
					};

					proto._getWrapShiftCells = function () {
						// only for wrap-around
						if (!this.options.wrapAround) {
							return;
						}
						// unshift previous cells
						this._unshiftCells(this.beforeShiftCells);
						this._unshiftCells(this.afterShiftCells);
						// get before cells
						// initial gap
						var gapX = this.cursorPosition;
						var cellIndex = this.cells.length - 1;
						this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
						// get after cells
						// ending gap between last cell and end of gallery viewport
						gapX = this.size.innerWidth - this.cursorPosition;
						// start cloning at first cell, working forwards
						this.afterShiftCells = this._getGapCells(gapX, 0, 1);
					};

					proto._getGapCells = function (gapX, cellIndex, increment) {
						// keep adding cells until the cover the initial gap
						var cells = [];
						while (gapX > 0) {
							var cell = this.cells[cellIndex];
							if (!cell) {
								break;
							}
							cells.push(cell);
							cellIndex += increment;
							gapX -= cell.size.outerWidth;
						}
						return cells;
					};

					// ----- contain ----- //

					// contain cell targets so no excess sliding
					proto._containSlides = function () {
						if (
							!this.options.contain ||
							this.options.wrapAround ||
							!this.cells.length
						) {
							return;
						}
						var isRightToLeft = this.options.rightToLeft;
						var beginMargin = isRightToLeft ? "marginRight" : "marginLeft";
						var endMargin = isRightToLeft ? "marginLeft" : "marginRight";
						var contentWidth =
							this.slideableWidth - this.getLastCell().size[endMargin];
						// content is less than gallery size
						var isContentSmaller = contentWidth < this.size.innerWidth;
						// bounds
						var beginBound =
							this.cursorPosition + this.cells[0].size[beginMargin];
						var endBound =
							contentWidth - this.size.innerWidth * (1 - this.cellAlign);
						// contain each cell target
						this.slides.forEach(function (slide) {
							if (isContentSmaller) {
								// all cells fit inside gallery
								slide.target = contentWidth * this.cellAlign;
							} else {
								// contain to bounds
								slide.target = Math.max(slide.target, beginBound);
								slide.target = Math.min(slide.target, endBound);
							}
						}, this);
					};

					// -----  ----- //

					/**
					 * emits events via eventEmitter and jQuery events
					 * @param {String} type - name of event
					 * @param {Event} event - original event
					 * @param {Array} args - extra arguments
					 */
					proto.dispatchEvent = function (type, event, args) {
						var emitArgs = event ? [event].concat(args) : args;
						this.emitEvent(type, emitArgs);

						if (jQuery && this.$element) {
							// default trigger with type if no event
							type += this.options.namespaceJQueryEvents ? ".flickity" : "";
							var $event = type;
							if (event) {
								// create jQuery event
								var jQEvent = jQuery.Event(event);
								jQEvent.type = type;
								$event = jQEvent;
							}
							this.$element.trigger($event, args);
						}
					};

					// -------------------------- select -------------------------- //

					/**
					 * @param {Integer} index - index of the slide
					 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
					 * @param {Boolean} isInstant - will immediately set position at selected cell
					 */
					proto.select = function (index, isWrap, isInstant) {
						if (!this.isActive) {
							return;
						}
						index = parseInt(index, 10);
						this._wrapSelect(index);

						if (this.options.wrapAround || isWrap) {
							index = utils.modulo(index, this.slides.length);
						}
						// bail if invalid index
						if (!this.slides[index]) {
							return;
						}
						var prevIndex = this.selectedIndex;
						this.selectedIndex = index;
						this.updateSelectedSlide();
						if (isInstant) {
							this.positionSliderAtSelected();
						} else {
							this.startAnimation();
						}
						if (this.options.adaptiveHeight) {
							this.setGallerySize();
						}
						// events
						this.dispatchEvent("select", null, [index]);
						// change event if new index
						if (index != prevIndex) {
							this.dispatchEvent("change", null, [index]);
						}
						// old v1 event name, remove in v3
						this.dispatchEvent("cellSelect");
					};

					// wraps position for wrapAround, to move to closest slide. #113
					proto._wrapSelect = function (index) {
						var len = this.slides.length;
						var isWrapping = this.options.wrapAround && len > 1;
						if (!isWrapping) {
							return index;
						}
						var wrapIndex = utils.modulo(index, len);
						// go to shortest
						var delta = Math.abs(wrapIndex - this.selectedIndex);
						var backWrapDelta = Math.abs(wrapIndex + len - this.selectedIndex);
						var forewardWrapDelta = Math.abs(
							wrapIndex - len - this.selectedIndex
						);
						if (!this.isDragSelect && backWrapDelta < delta) {
							index += len;
						} else if (!this.isDragSelect && forewardWrapDelta < delta) {
							index -= len;
						}
						// wrap position so slider is within normal area
						if (index < 0) {
							this.x -= this.slideableWidth;
						} else if (index >= len) {
							this.x += this.slideableWidth;
						}
					};

					proto.previous = function (isWrap, isInstant) {
						this.select(this.selectedIndex - 1, isWrap, isInstant);
					};

					proto.next = function (isWrap, isInstant) {
						this.select(this.selectedIndex + 1, isWrap, isInstant);
					};

					proto.updateSelectedSlide = function () {
						var slide = this.slides[this.selectedIndex];
						// selectedIndex could be outside of slides, if triggered before resize()
						if (!slide) {
							return;
						}
						// unselect previous selected slide
						this.unselectSelectedSlide();
						// update new selected slide
						this.selectedSlide = slide;
						slide.select();
						this.selectedCells = slide.cells;
						this.selectedElements = slide.getCellElements();
						// HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
						// Remove in v3?
						this.selectedCell = slide.cells[0];
						this.selectedElement = this.selectedElements[0];
					};

					proto.unselectSelectedSlide = function () {
						if (this.selectedSlide) {
							this.selectedSlide.unselect();
						}
					};

					proto.selectInitialIndex = function () {
						var initialIndex = this.options.initialIndex;
						// already activated, select previous selectedIndex
						if (this.isInitActivated) {
							this.select(this.selectedIndex, false, true);
							return;
						}
						// select with selector string
						if (initialIndex && typeof initialIndex == "string") {
							var cell = this.queryCell(initialIndex);
							if (cell) {
								this.selectCell(initialIndex, false, true);
								return;
							}
						}

						var index = 0;
						// select with number
						if (initialIndex && this.slides[initialIndex]) {
							index = initialIndex;
						}
						// select instantly
						this.select(index, false, true);
					};

					/**
					 * select slide from number or cell element
					 * @param {Element or Number} elem
					 */
					proto.selectCell = function (value, isWrap, isInstant) {
						// get cell
						var cell = this.queryCell(value);
						if (!cell) {
							return;
						}

						var index = this.getCellSlideIndex(cell);
						this.select(index, isWrap, isInstant);
					};

					proto.getCellSlideIndex = function (cell) {
						// get index of slides that has cell
						for (var i = 0; i < this.slides.length; i++) {
							var slide = this.slides[i];
							var index = slide.cells.indexOf(cell);
							if (index != -1) {
								return i;
							}
						}
					};

					// -------------------------- get cells -------------------------- //

					/**
					 * get Flickity.Cell, given an Element
					 * @param {Element} elem
					 * @returns {Flickity.Cell} item
					 */
					proto.getCell = function (elem) {
						// loop through cells to get the one that matches
						for (var i = 0; i < this.cells.length; i++) {
							var cell = this.cells[i];
							if (cell.element == elem) {
								return cell;
							}
						}
					};

					/**
					 * get collection of Flickity.Cells, given Elements
					 * @param {Element, Array, NodeList} elems
					 * @returns {Array} cells - Flickity.Cells
					 */
					proto.getCells = function (elems) {
						elems = utils.makeArray(elems);
						var cells = [];
						elems.forEach(function (elem) {
							var cell = this.getCell(elem);
							if (cell) {
								cells.push(cell);
							}
						}, this);
						return cells;
					};

					/**
					 * get cell elements
					 * @returns {Array} cellElems
					 */
					proto.getCellElements = function () {
						return this.cells.map(function (cell) {
							return cell.element;
						});
					};

					/**
					 * get parent cell from an element
					 * @param {Element} elem
					 * @returns {Flickit.Cell} cell
					 */
					proto.getParentCell = function (elem) {
						// first check if elem is cell
						var cell = this.getCell(elem);
						if (cell) {
							return cell;
						}
						// try to get parent cell elem
						elem = utils.getParent(elem, ".flickity-slider > *");
						return this.getCell(elem);
					};

					/**
					 * get cells adjacent to a slide
					 * @param {Integer} adjCount - number of adjacent slides
					 * @param {Integer} index - index of slide to start
					 * @returns {Array} cells - array of Flickity.Cells
					 */
					proto.getAdjacentCellElements = function (adjCount, index) {
						if (!adjCount) {
							return this.selectedSlide.getCellElements();
						}
						index = index === undefined ? this.selectedIndex : index;

						var len = this.slides.length;
						if (1 + adjCount * 2 >= len) {
							return this.getCellElements();
						}

						var cellElems = [];
						for (var i = index - adjCount; i <= index + adjCount; i++) {
							var slideIndex = this.options.wrapAround
								? utils.modulo(i, len)
								: i;
							var slide = this.slides[slideIndex];
							if (slide) {
								cellElems = cellElems.concat(slide.getCellElements());
							}
						}
						return cellElems;
					};

					/**
					 * select slide from number or cell element
					 * @param {Element, Selector String, or Number} selector
					 */
					proto.queryCell = function (selector) {
						if (typeof selector == "number") {
							// use number as index
							return this.cells[selector];
						}
						if (typeof selector == "string") {
							// do not select invalid selectors from hash: #123, #/. #791
							if (selector.match(/^[#\.]?[\d\/]/)) {
								return;
							}
							// use string as selector, get element
							selector = this.element.querySelector(selector);
						}
						// get cell from element
						return this.getCell(selector);
					};

					// -------------------------- events -------------------------- //

					proto.uiChange = function () {
						this.emitEvent("uiChange");
					};

					// keep focus on element when child UI elements are clicked
					proto.childUIPointerDown = function (event) {
						// HACK iOS does not allow touch events to bubble up?!
						if (event.type != "touchstart") {
							event.preventDefault();
						}
						this.focus();
					};

					// ----- resize ----- //

					proto.onresize = function () {
						this.watchCSS();
						this.resize();
					};

					utils.debounceMethod(Flickity, "onresize", 150);

					proto.resize = function () {
						if (!this.isActive) {
							return;
						}
						this.getSize();
						// wrap values
						if (this.options.wrapAround) {
							this.x = utils.modulo(this.x, this.slideableWidth);
						}
						this.positionCells();
						this._getWrapShiftCells();
						this.setGallerySize();
						this.emitEvent("resize");
						// update selected index for group slides, instant
						// TODO: position can be lost between groups of various numbers
						var selectedElement =
							this.selectedElements && this.selectedElements[0];
						this.selectCell(selectedElement, false, true);
					};

					// watches the :after property, activates/deactivates
					proto.watchCSS = function () {
						var watchOption = this.options.watchCSS;
						if (!watchOption) {
							return;
						}

						var afterContent = getComputedStyle(this.element, ":after").content;
						// activate if :after { content: 'flickity' }
						if (afterContent.indexOf("flickity") != -1) {
							this.activate();
						} else {
							this.deactivate();
						}
					};

					// ----- keydown ----- //

					// go previous/next if left/right keys pressed
					proto.onkeydown = function (event) {
						// only work if element is in focus
						var isNotFocused =
							document.activeElement && document.activeElement != this.element;
						if (!this.options.accessibility || isNotFocused) {
							return;
						}

						var handler = Flickity.keyboardHandlers[event.keyCode];
						if (handler) {
							handler.call(this);
						}
					};

					Flickity.keyboardHandlers = {
						// left arrow
						37: function () {
							var leftMethod = this.options.rightToLeft ? "next" : "previous";
							this.uiChange();
							this[leftMethod]();
						},
						// right arrow
						39: function () {
							var rightMethod = this.options.rightToLeft ? "previous" : "next";
							this.uiChange();
							this[rightMethod]();
						},
					};

					// ----- focus ----- //

					proto.focus = function () {
						// TODO remove scrollTo once focus options gets more support
						// https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Browser_compatibility
						var prevScrollY = window.pageYOffset;
						this.element.focus({ preventScroll: true });
						// hack to fix scroll jump after focus, #76
						if (window.pageYOffset != prevScrollY) {
							window.scrollTo(window.pageXOffset, prevScrollY);
						}
					};

					// -------------------------- destroy -------------------------- //

					// deactivate all Flickity functionality, but keep stuff available
					proto.deactivate = function () {
						if (!this.isActive) {
							return;
						}
						this.element.classList.remove("flickity-enabled");
						this.element.classList.remove("flickity-rtl");
						this.unselectSelectedSlide();
						// destroy cells
						this.cells.forEach(function (cell) {
							cell.destroy();
						});
						this.element.removeChild(this.viewport);
						// move child elements back into element
						moveElements(this.slider.children, this.element);
						if (this.options.accessibility) {
							this.element.removeAttribute("tabIndex");
							this.element.removeEventListener("keydown", this);
						}
						// set flags
						this.isActive = false;
						this.emitEvent("deactivate");
					};

					proto.destroy = function () {
						this.deactivate();
						window.removeEventListener("resize", this);
						this.allOff();
						this.emitEvent("destroy");
						if (jQuery && this.$element) {
							jQuery.removeData(this.element, "flickity");
						}
						delete this.element.flickityGUID;
						delete instances[this.guid];
					};

					// -------------------------- prototype -------------------------- //

					utils.extend(proto, animatePrototype);

					// -------------------------- extras -------------------------- //

					/**
					 * get Flickity instance from element
					 * @param {Element} elem
					 * @returns {Flickity}
					 */
					Flickity.data = function (elem) {
						elem = utils.getQueryElement(elem);
						var id = elem && elem.flickityGUID;
						return id && instances[id];
					};

					utils.htmlInit(Flickity, "flickity");

					if (jQuery && jQuery.bridget) {
						jQuery.bridget("flickity", Flickity);
					}

					// set internal jQuery, for Webpack + jQuery v3, #478
					Flickity.setJQuery = function (jq) {
						jQuery = jq;
					};

					Flickity.Cell = Cell;
					Flickity.Slide = Slide;

					return Flickity;
				}
			);

			/***/
		},

		/***/ 442: /***/ (module, exports, __webpack_require__) => {
			var __WEBPACK_AMD_DEFINE_FACTORY__,
				__WEBPACK_AMD_DEFINE_ARRAY__,
				__WEBPACK_AMD_DEFINE_RESULT__;
			/*!
			 * Flickity v2.2.0
			 * Touch, responsive, flickable carousels
			 *
			 * Licensed GPLv3 for open source use
			 * or Flickity Commercial License for commercial use
			 *
			 * https://flickity.metafizzy.co
			 * Copyright 2015-2018 Metafizzy
			 */

			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (true) {
					// AMD
					!((__WEBPACK_AMD_DEFINE_ARRAY__ = [
						__webpack_require__(217),
						__webpack_require__(690),
						__webpack_require__(410),
						__webpack_require__(573),
						__webpack_require__(516),
						__webpack_require__(597),
						__webpack_require__(227),
					]),
					(__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
					(__WEBPACK_AMD_DEFINE_RESULT__ =
						typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
							? __WEBPACK_AMD_DEFINE_FACTORY__.apply(
									exports,
									__WEBPACK_AMD_DEFINE_ARRAY__
							  )
							: __WEBPACK_AMD_DEFINE_FACTORY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(window, function factory(Flickity) {
				/*jshint strict: false*/
				return Flickity;
			});

			/***/
		},

		/***/ 227: /***/ (module, exports, __webpack_require__) => {
			var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // lazyload
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (true) {
					// AMD
					!((__WEBPACK_AMD_DEFINE_ARRAY__ = [
						__webpack_require__(217),
						__webpack_require__(47),
					]),
					(__WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, utils) {
						return factory(window, Flickity, utils);
					}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(window, function factory(window, Flickity, utils) {
				"use strict";

				Flickity.createMethods.push("_createLazyload");
				var proto = Flickity.prototype;

				proto._createLazyload = function () {
					this.on("select", this.lazyLoad);
				};

				proto.lazyLoad = function () {
					var lazyLoad = this.options.lazyLoad;
					if (!lazyLoad) {
						return;
					}
					// get adjacent cells, use lazyLoad option for adjacent count
					var adjCount = typeof lazyLoad == "number" ? lazyLoad : 0;
					var cellElems = this.getAdjacentCellElements(adjCount);
					// get lazy images in those cells
					var lazyImages = [];
					cellElems.forEach(function (cellElem) {
						var lazyCellImages = getCellLazyImages(cellElem);
						lazyImages = lazyImages.concat(lazyCellImages);
					});
					// load lazy images
					lazyImages.forEach(function (img) {
						new LazyLoader(img, this);
					}, this);
				};

				function getCellLazyImages(cellElem) {
					// check if cell element is lazy image
					if (cellElem.nodeName == "IMG") {
						var lazyloadAttr = cellElem.getAttribute("data-flickity-lazyload");
						var srcAttr = cellElem.getAttribute("data-flickity-lazyload-src");
						var srcsetAttr = cellElem.getAttribute(
							"data-flickity-lazyload-srcset"
						);
						if (lazyloadAttr || srcAttr || srcsetAttr) {
							return [cellElem];
						}
					}
					// select lazy images in cell
					var lazySelector =
						"img[data-flickity-lazyload], " +
						"img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]";
					var imgs = cellElem.querySelectorAll(lazySelector);
					return utils.makeArray(imgs);
				}

				// -------------------------- LazyLoader -------------------------- //

				/**
				 * class to handle loading images
				 */
				function LazyLoader(img, flickity) {
					this.img = img;
					this.flickity = flickity;
					this.load();
				}

				LazyLoader.prototype.handleEvent = utils.handleEvent;

				LazyLoader.prototype.load = function () {
					this.img.addEventListener("load", this);
					this.img.addEventListener("error", this);
					// get src & srcset
					var src =
						this.img.getAttribute("data-flickity-lazyload") ||
						this.img.getAttribute("data-flickity-lazyload-src");
					var srcset = this.img.getAttribute("data-flickity-lazyload-srcset");
					// set src & serset
					this.img.src = src;
					if (srcset) {
						this.img.setAttribute("srcset", srcset);
					}
					// remove attr
					this.img.removeAttribute("data-flickity-lazyload");
					this.img.removeAttribute("data-flickity-lazyload-src");
					this.img.removeAttribute("data-flickity-lazyload-srcset");
				};

				LazyLoader.prototype.onload = function (event) {
					this.complete(event, "flickity-lazyloaded");
				};

				LazyLoader.prototype.onerror = function (event) {
					this.complete(event, "flickity-lazyerror");
				};

				LazyLoader.prototype.complete = function (event, className) {
					// unbind events
					this.img.removeEventListener("load", this);
					this.img.removeEventListener("error", this);

					var cell = this.flickity.getParentCell(this.img);
					var cellElem = cell && cell.element;
					this.flickity.cellSizeChange(cellElem);

					this.img.classList.add(className);
					this.flickity.dispatchEvent("lazyLoad", event, cellElem);
				};

				// -----  ----- //

				Flickity.LazyLoader = LazyLoader;

				return Flickity;
			});

			/***/
		},

		/***/ 573: /***/ (module, exports, __webpack_require__) => {
			var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // page dots
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (true) {
					// AMD
					!((__WEBPACK_AMD_DEFINE_ARRAY__ = [
						__webpack_require__(217),
						__webpack_require__(704),
						__webpack_require__(47),
					]),
					(__WEBPACK_AMD_DEFINE_RESULT__ = function (
						Flickity,
						Unipointer,
						utils
					) {
						return factory(window, Flickity, Unipointer, utils);
					}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(window, function factory(window, Flickity, Unipointer, utils) {
				// -------------------------- PageDots -------------------------- //

				"use strict";

				function PageDots(parent) {
					this.parent = parent;
					this._create();
				}

				PageDots.prototype = Object.create(Unipointer.prototype);

				PageDots.prototype._create = function () {
					// create holder element
					this.holder = document.createElement("ol");
					this.holder.className = "flickity-page-dots";
					// create dots, array of elements
					this.dots = [];
					// events
					this.handleClick = this.onClick.bind(this);
					this.on(
						"pointerDown",
						this.parent.childUIPointerDown.bind(this.parent)
					);
				};

				PageDots.prototype.activate = function () {
					this.setDots();
					this.holder.addEventListener("click", this.handleClick);
					this.bindStartEvent(this.holder);
					// add to DOM
					this.parent.element.appendChild(this.holder);
				};

				PageDots.prototype.deactivate = function () {
					this.holder.removeEventListener("click", this.handleClick);
					this.unbindStartEvent(this.holder);
					// remove from DOM
					this.parent.element.removeChild(this.holder);
				};

				PageDots.prototype.setDots = function () {
					// get difference between number of slides and number of dots
					var delta = this.parent.slides.length - this.dots.length;
					if (delta > 0) {
						this.addDots(delta);
					} else if (delta < 0) {
						this.removeDots(-delta);
					}
				};

				PageDots.prototype.addDots = function (count) {
					var fragment = document.createDocumentFragment();
					var newDots = [];
					var length = this.dots.length;
					var max = length + count;

					for (var i = length; i < max; i++) {
						var dot = document.createElement("li");
						dot.className = "dot";
						dot.setAttribute("aria-label", "Page dot " + (i + 1));
						fragment.appendChild(dot);
						newDots.push(dot);
					}

					this.holder.appendChild(fragment);
					this.dots = this.dots.concat(newDots);
				};

				PageDots.prototype.removeDots = function (count) {
					// remove from this.dots collection
					var removeDots = this.dots.splice(this.dots.length - count, count);
					// remove from DOM
					removeDots.forEach(function (dot) {
						this.holder.removeChild(dot);
					}, this);
				};

				PageDots.prototype.updateSelected = function () {
					// remove selected class on previous
					if (this.selectedDot) {
						this.selectedDot.className = "dot";
						this.selectedDot.removeAttribute("aria-current");
					}
					// don't proceed if no dots
					if (!this.dots.length) {
						return;
					}
					this.selectedDot = this.dots[this.parent.selectedIndex];
					this.selectedDot.className = "dot is-selected";
					this.selectedDot.setAttribute("aria-current", "step");
				};

				PageDots.prototype.onTap = // old method name, backwards-compatible
					PageDots.prototype.onClick = function (event) {
						var target = event.target;
						// only care about dot clicks
						if (target.nodeName != "LI") {
							return;
						}

						this.parent.uiChange();
						var index = this.dots.indexOf(target);
						this.parent.select(index);
					};

				PageDots.prototype.destroy = function () {
					this.deactivate();
					this.allOff();
				};

				Flickity.PageDots = PageDots;

				// -------------------------- Flickity -------------------------- //

				utils.extend(Flickity.defaults, {
					pageDots: true,
				});

				Flickity.createMethods.push("_createPageDots");

				var proto = Flickity.prototype;

				proto._createPageDots = function () {
					if (!this.options.pageDots) {
						return;
					}
					this.pageDots = new PageDots(this);
					// events
					this.on("activate", this.activatePageDots);
					this.on("select", this.updateSelectedPageDots);
					this.on("cellChange", this.updatePageDots);
					this.on("resize", this.updatePageDots);
					this.on("deactivate", this.deactivatePageDots);
				};

				proto.activatePageDots = function () {
					this.pageDots.activate();
				};

				proto.updateSelectedPageDots = function () {
					this.pageDots.updateSelected();
				};

				proto.updatePageDots = function () {
					this.pageDots.setDots();
				};

				proto.deactivatePageDots = function () {
					this.pageDots.deactivate();
				};

				// -----  ----- //

				Flickity.PageDots = PageDots;

				return Flickity;
			});

			/***/
		},

		/***/ 516: /***/ (module, exports, __webpack_require__) => {
			var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // player & autoPlay
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (true) {
					// AMD
					!((__WEBPACK_AMD_DEFINE_ARRAY__ = [
						__webpack_require__(158),
						__webpack_require__(47),
						__webpack_require__(217),
					]),
					(__WEBPACK_AMD_DEFINE_RESULT__ = function (
						EvEmitter,
						utils,
						Flickity
					) {
						return factory(EvEmitter, utils, Flickity);
					}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(window, function factory(EvEmitter, utils, Flickity) {
				"use strict";

				// -------------------------- Player -------------------------- //

				function Player(parent) {
					this.parent = parent;
					this.state = "stopped";
					// visibility change event handler
					this.onVisibilityChange = this.visibilityChange.bind(this);
					this.onVisibilityPlay = this.visibilityPlay.bind(this);
				}

				Player.prototype = Object.create(EvEmitter.prototype);

				// start play
				Player.prototype.play = function () {
					if (this.state == "playing") {
						return;
					}
					// do not play if page is hidden, start playing when page is visible
					var isPageHidden = document.hidden;
					if (isPageHidden) {
						document.addEventListener(
							"visibilitychange",
							this.onVisibilityPlay
						);
						return;
					}

					this.state = "playing";
					// listen to visibility change
					document.addEventListener(
						"visibilitychange",
						this.onVisibilityChange
					);
					// start ticking
					this.tick();
				};

				Player.prototype.tick = function () {
					// do not tick if not playing
					if (this.state != "playing") {
						return;
					}

					var time = this.parent.options.autoPlay;
					// default to 3 seconds
					time = typeof time == "number" ? time : 3000;
					var _this = this;
					// HACK: reset ticks if stopped and started within interval
					this.clear();
					this.timeout = setTimeout(function () {
						_this.parent.next(true);
						_this.tick();
					}, time);
				};

				Player.prototype.stop = function () {
					this.state = "stopped";
					this.clear();
					// remove visibility change event
					document.removeEventListener(
						"visibilitychange",
						this.onVisibilityChange
					);
				};

				Player.prototype.clear = function () {
					clearTimeout(this.timeout);
				};

				Player.prototype.pause = function () {
					if (this.state == "playing") {
						this.state = "paused";
						this.clear();
					}
				};

				Player.prototype.unpause = function () {
					// re-start play if paused
					if (this.state == "paused") {
						this.play();
					}
				};

				// pause if page visibility is hidden, unpause if visible
				Player.prototype.visibilityChange = function () {
					var isPageHidden = document.hidden;
					this[isPageHidden ? "pause" : "unpause"]();
				};

				Player.prototype.visibilityPlay = function () {
					this.play();
					document.removeEventListener(
						"visibilitychange",
						this.onVisibilityPlay
					);
				};

				// -------------------------- Flickity -------------------------- //

				utils.extend(Flickity.defaults, {
					pauseAutoPlayOnHover: true,
				});

				Flickity.createMethods.push("_createPlayer");
				var proto = Flickity.prototype;

				proto._createPlayer = function () {
					this.player = new Player(this);

					this.on("activate", this.activatePlayer);
					this.on("uiChange", this.stopPlayer);
					this.on("pointerDown", this.stopPlayer);
					this.on("deactivate", this.deactivatePlayer);
				};

				proto.activatePlayer = function () {
					if (!this.options.autoPlay) {
						return;
					}
					this.player.play();
					this.element.addEventListener("mouseenter", this);
				};

				// Player API, don't hate the ... thanks I know where the door is

				proto.playPlayer = function () {
					this.player.play();
				};

				proto.stopPlayer = function () {
					this.player.stop();
				};

				proto.pausePlayer = function () {
					this.player.pause();
				};

				proto.unpausePlayer = function () {
					this.player.unpause();
				};

				proto.deactivatePlayer = function () {
					this.player.stop();
					this.element.removeEventListener("mouseenter", this);
				};

				// ----- mouseenter/leave ----- //

				// pause auto-play on hover
				proto.onmouseenter = function () {
					if (!this.options.pauseAutoPlayOnHover) {
						return;
					}
					this.player.pause();
					this.element.addEventListener("mouseleave", this);
				};

				// resume auto-play on hover off
				proto.onmouseleave = function () {
					this.player.unpause();
					this.element.removeEventListener("mouseleave", this);
				};

				// -----  ----- //

				Flickity.Player = Player;

				return Flickity;
			});

			/***/
		},

		/***/ 410: /***/ (module, exports, __webpack_require__) => {
			var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // prev/next buttons
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (true) {
					// AMD
					!((__WEBPACK_AMD_DEFINE_ARRAY__ = [
						__webpack_require__(217),
						__webpack_require__(704),
						__webpack_require__(47),
					]),
					(__WEBPACK_AMD_DEFINE_RESULT__ = function (
						Flickity,
						Unipointer,
						utils
					) {
						return factory(window, Flickity, Unipointer, utils);
					}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(window, function factory(window, Flickity, Unipointer, utils) {
				"use strict";

				var svgURI = "http://www.w3.org/2000/svg";

				// -------------------------- PrevNextButton -------------------------- //

				function PrevNextButton(direction, parent) {
					this.direction = direction;
					this.parent = parent;
					this._create();
				}

				PrevNextButton.prototype = Object.create(Unipointer.prototype);

				PrevNextButton.prototype._create = function () {
					// properties
					this.isEnabled = true;
					this.isPrevious = this.direction == -1;
					var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
					this.isLeft = this.direction == leftDirection;

					var element = (this.element = document.createElement("button"));
					element.className = "flickity-button flickity-prev-next-button";
					element.className += this.isPrevious ? " previous" : " next";
					// prevent button from submitting form http://stackoverflow.com/a/10836076/182183
					element.setAttribute("type", "button");
					// init as disabled
					this.disable();

					element.setAttribute(
						"aria-label",
						this.isPrevious ? "Previous" : "Next"
					);

					// create arrow
					var svg = this.createSVG();
					element.appendChild(svg);
					// events
					this.parent.on("select", this.update.bind(this));
					this.on(
						"pointerDown",
						this.parent.childUIPointerDown.bind(this.parent)
					);
				};

				PrevNextButton.prototype.activate = function () {
					this.bindStartEvent(this.element);
					this.element.addEventListener("click", this);
					// add to DOM
					this.parent.element.appendChild(this.element);
				};

				PrevNextButton.prototype.deactivate = function () {
					// remove from DOM
					this.parent.element.removeChild(this.element);
					// click events
					this.unbindStartEvent(this.element);
					this.element.removeEventListener("click", this);
				};

				PrevNextButton.prototype.createSVG = function () {
					var svg = document.createElementNS(svgURI, "svg");
					svg.setAttribute("class", "flickity-button-icon");
					svg.setAttribute("viewBox", "0 0 100 100");
					var path = document.createElementNS(svgURI, "path");
					var pathMovements = getArrowMovements(this.parent.options.arrowShape);
					path.setAttribute("d", pathMovements);
					path.setAttribute("class", "arrow");
					// rotate arrow
					if (!this.isLeft) {
						path.setAttribute("transform", "translate(100, 100) rotate(180) ");
					}
					svg.appendChild(path);
					return svg;
				};

				// get SVG path movmement
				function getArrowMovements(shape) {
					// use shape as movement if string
					if (typeof shape == "string") {
						return shape;
					}
					// create movement string
					return (
						"M " +
						shape.x0 +
						",50" +
						" L " +
						shape.x1 +
						"," +
						(shape.y1 + 50) +
						" L " +
						shape.x2 +
						"," +
						(shape.y2 + 50) +
						" L " +
						shape.x3 +
						",50 " +
						" L " +
						shape.x2 +
						"," +
						(50 - shape.y2) +
						" L " +
						shape.x1 +
						"," +
						(50 - shape.y1) +
						" Z"
					);
				}

				PrevNextButton.prototype.handleEvent = utils.handleEvent;

				PrevNextButton.prototype.onclick = function () {
					if (!this.isEnabled) {
						return;
					}
					this.parent.uiChange();
					var method = this.isPrevious ? "previous" : "next";
					this.parent[method]();
				};

				// -----  ----- //

				PrevNextButton.prototype.enable = function () {
					if (this.isEnabled) {
						return;
					}
					this.element.disabled = false;
					this.isEnabled = true;
				};

				PrevNextButton.prototype.disable = function () {
					if (!this.isEnabled) {
						return;
					}
					this.element.disabled = true;
					this.isEnabled = false;
				};

				PrevNextButton.prototype.update = function () {
					// index of first or last slide, if previous or next
					var slides = this.parent.slides;
					// enable is wrapAround and at least 2 slides
					if (this.parent.options.wrapAround && slides.length > 1) {
						this.enable();
						return;
					}
					var lastIndex = slides.length ? slides.length - 1 : 0;
					var boundIndex = this.isPrevious ? 0 : lastIndex;
					var method =
						this.parent.selectedIndex == boundIndex ? "disable" : "enable";
					this[method]();
				};

				PrevNextButton.prototype.destroy = function () {
					this.deactivate();
					this.allOff();
				};

				// -------------------------- Flickity prototype -------------------------- //

				utils.extend(Flickity.defaults, {
					prevNextButtons: true,
					arrowShape: {
						x0: 10,
						x1: 60,
						y1: 50,
						x2: 70,
						y2: 40,
						x3: 30,
					},
				});

				Flickity.createMethods.push("_createPrevNextButtons");
				var proto = Flickity.prototype;

				proto._createPrevNextButtons = function () {
					if (!this.options.prevNextButtons) {
						return;
					}

					this.prevButton = new PrevNextButton(-1, this);
					this.nextButton = new PrevNextButton(1, this);

					this.on("activate", this.activatePrevNextButtons);
				};

				proto.activatePrevNextButtons = function () {
					this.prevButton.activate();
					this.nextButton.activate();
					this.on("deactivate", this.deactivatePrevNextButtons);
				};

				proto.deactivatePrevNextButtons = function () {
					this.prevButton.deactivate();
					this.nextButton.deactivate();
					this.off("deactivate", this.deactivatePrevNextButtons);
				};

				// --------------------------  -------------------------- //

				Flickity.PrevNextButton = PrevNextButton;

				return Flickity;
			});

			/***/
		},

		/***/ 714: /***/ (module, exports, __webpack_require__) => {
			var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__; // slide
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (true) {
					// AMD
					!((__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
					(__WEBPACK_AMD_DEFINE_RESULT__ =
						typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
							? __WEBPACK_AMD_DEFINE_FACTORY__.call(
									exports,
									__webpack_require__,
									exports,
									module
							  )
							: __WEBPACK_AMD_DEFINE_FACTORY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(window, function factory() {
				"use strict";

				function Slide(parent) {
					this.parent = parent;
					this.isOriginLeft = parent.originSide == "left";
					this.cells = [];
					this.outerWidth = 0;
					this.height = 0;
				}

				var proto = Slide.prototype;

				proto.addCell = function (cell) {
					this.cells.push(cell);
					this.outerWidth += cell.size.outerWidth;
					this.height = Math.max(cell.size.outerHeight, this.height);
					// first cell stuff
					if (this.cells.length == 1) {
						this.x = cell.x; // x comes from first cell
						var beginMargin = this.isOriginLeft ? "marginLeft" : "marginRight";
						this.firstMargin = cell.size[beginMargin];
					}
				};

				proto.updateTarget = function () {
					var endMargin = this.isOriginLeft ? "marginRight" : "marginLeft";
					var lastCell = this.getLastCell();
					var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
					var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
					this.target =
						this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
				};

				proto.getLastCell = function () {
					return this.cells[this.cells.length - 1];
				};

				proto.select = function () {
					this.cells.forEach(function (cell) {
						cell.select();
					});
				};

				proto.unselect = function () {
					this.cells.forEach(function (cell) {
						cell.unselect();
					});
				};

				proto.getCellElements = function () {
					return this.cells.map(function (cell) {
						return cell.element;
					});
				};

				return Slide;
			});

			/***/
		},

		/***/ 131: /***/ (module, exports, __webpack_require__) => {
			var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
			/*!
			 * getSize v2.0.3
			 * measure size of elements
			 * MIT license
			 */

			/* jshint browser: true, strict: true, undef: true, unused: true */
			/* globals console: false */

			(function (window, factory) {
				/* jshint strict: false */ /* globals define, module */
				if (true) {
					// AMD
					!((__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
					(__WEBPACK_AMD_DEFINE_RESULT__ =
						typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
							? __WEBPACK_AMD_DEFINE_FACTORY__.call(
									exports,
									__webpack_require__,
									exports,
									module
							  )
							: __WEBPACK_AMD_DEFINE_FACTORY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(window, function factory() {
				"use strict";

				// -------------------------- helpers -------------------------- //

				// get a number from a string, not a percentage
				function getStyleSize(value) {
					var num = parseFloat(value);
					// not a percent like '100%', and a number
					var isValid = value.indexOf("%") == -1 && !isNaN(num);
					return isValid && num;
				}

				function noop() {}

				var logError =
					typeof console == "undefined"
						? noop
						: function (message) {
								console.error(message);
						  };

				// -------------------------- measurements -------------------------- //

				var measurements = [
					"paddingLeft",
					"paddingRight",
					"paddingTop",
					"paddingBottom",
					"marginLeft",
					"marginRight",
					"marginTop",
					"marginBottom",
					"borderLeftWidth",
					"borderRightWidth",
					"borderTopWidth",
					"borderBottomWidth",
				];

				var measurementsLength = measurements.length;

				function getZeroSize() {
					var size = {
						width: 0,
						height: 0,
						innerWidth: 0,
						innerHeight: 0,
						outerWidth: 0,
						outerHeight: 0,
					};
					for (var i = 0; i < measurementsLength; i++) {
						var measurement = measurements[i];
						size[measurement] = 0;
					}
					return size;
				}

				// -------------------------- getStyle -------------------------- //

				/**
				 * getStyle, get style of element, check for Firefox bug
				 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
				 */
				function getStyle(elem) {
					var style = getComputedStyle(elem);
					if (!style) {
						logError(
							"Style returned " +
								style +
								". Are you running this code in a hidden iframe on Firefox? " +
								"See https://bit.ly/getsizebug1"
						);
					}
					return style;
				}

				// -------------------------- setup -------------------------- //

				var isSetup = false;

				var isBoxSizeOuter;

				/**
				 * setup
				 * check isBoxSizerOuter
				 * do on first getSize() rather than on page load for Firefox bug
				 */
				function setup() {
					// setup once
					if (isSetup) {
						return;
					}
					isSetup = true;

					// -------------------------- box sizing -------------------------- //

					/**
					 * Chrome & Safari measure the outer-width on style.width on border-box elems
					 * IE11 & Firefox<29 measures the inner-width
					 */
					var div = document.createElement("div");
					div.style.width = "200px";
					div.style.padding = "1px 2px 3px 4px";
					div.style.borderStyle = "solid";
					div.style.borderWidth = "1px 2px 3px 4px";
					div.style.boxSizing = "border-box";

					var body = document.body || document.documentElement;
					body.appendChild(div);
					var style = getStyle(div);
					// round value for browser zoom. desandro/masonry#928
					isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
					getSize.isBoxSizeOuter = isBoxSizeOuter;

					body.removeChild(div);
				}

				// -------------------------- getSize -------------------------- //

				function getSize(elem) {
					setup();

					// use querySeletor if elem is string
					if (typeof elem == "string") {
						elem = document.querySelector(elem);
					}

					// do not proceed on non-objects
					if (!elem || typeof elem != "object" || !elem.nodeType) {
						return;
					}

					var style = getStyle(elem);

					// if hidden, everything is 0
					if (style.display == "none") {
						return getZeroSize();
					}

					var size = {};
					size.width = elem.offsetWidth;
					size.height = elem.offsetHeight;

					var isBorderBox = (size.isBorderBox =
						style.boxSizing == "border-box");

					// get all measurements
					for (var i = 0; i < measurementsLength; i++) {
						var measurement = measurements[i];
						var value = style[measurement];
						var num = parseFloat(value);
						// any 'auto', 'medium' value will be 0
						size[measurement] = !isNaN(num) ? num : 0;
					}

					var paddingWidth = size.paddingLeft + size.paddingRight;
					var paddingHeight = size.paddingTop + size.paddingBottom;
					var marginWidth = size.marginLeft + size.marginRight;
					var marginHeight = size.marginTop + size.marginBottom;
					var borderWidth = size.borderLeftWidth + size.borderRightWidth;
					var borderHeight = size.borderTopWidth + size.borderBottomWidth;

					var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

					// overwrite width and height if we can get it from style
					var styleWidth = getStyleSize(style.width);
					if (styleWidth !== false) {
						size.width =
							styleWidth +
							// add padding and border unless it's already including it
							(isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
					}

					var styleHeight = getStyleSize(style.height);
					if (styleHeight !== false) {
						size.height =
							styleHeight +
							// add padding and border unless it's already including it
							(isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
					}

					size.innerWidth = size.width - (paddingWidth + borderWidth);
					size.innerHeight = size.height - (paddingHeight + borderHeight);

					size.outerWidth = size.width + marginWidth;
					size.outerHeight = size.height + marginHeight;

					return size;
				}

				return getSize;
			});

			/***/
		},

		/***/ 414: /***/ (module) => {
			"use strict";

			// forEach method, could be shipped as part of an Object Literal/Module
			function forEach(array, callback, scope) {
				var index = 0;

				for (index = 0; index < array.length; index += 1) {
					callback.call(scope, array[index], index); // passes back stuff we need
				}
			}

			function hasClass(el, className) {
				var regex = new RegExp("^" + className + "| +" + className, "g");

				return el.className.match(regex);
			}

			function addClass(el, className) {
				// Return if it already has the className
				if (hasClass(el, className)) return;

				el.className += " " + className;
			}

			function removeClass(el, className) {
				// Return if it doesn't already have the className
				if (!hasClass(el, className)) return;

				var regex = new RegExp("^" + className + "| +" + className, "g");

				el.className = el.className.replace(regex, "");
			}

			function toggleClass(el, className) {
				if (hasClass(el, className)) {
					removeClass(el, className);
				} else {
					addClass(el, className);
				}
			}

			function findPairingFromPairingTrigger(pairings, pairingTrigger) {
				var foundPairing = null;

				forEach(pairings, function (pairing) {
					if (pairing.trigger === pairingTrigger) {
						foundPairing = pairing;
					}
				});

				return foundPairing;
			}

			/**
			 * See {@link https://stackoverflow.com/revisions/2117523/11 Stack Overflow}
			 * An RFC4122 v4 compliant uuid solution
			 */
			function uuidv4() {
				return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
					/[xy]/g,
					function (c) {
						var r = (Math.random() * 16) | 0;
						var v = c === "x" ? r : (r & 0x3) | 0x8;

						return v.toString(16);
					}
				);
			}

			function init(groupedContent) {
				var triggers = groupedContent.triggers;
				var pairings = groupedContent.pairings;

				triggers.setAttribute("role", "tablist");

				forEach(pairings, function (pairing, index) {
					pairing.trigger.setAttribute("role", "tab");
					pairing.trigger.setAttribute(
						"aria-controls",
						groupedContent.namespace +
							"-" +
							groupedContent.id +
							"-" +
							index +
							"-content"
					);

					if (pairing.trigger.children.length > 0) {
						forEach(pairing.trigger.children, function (child) {
							child.setAttribute("tabIndex", "-1");
						});
					}

					if (hasClass(pairing.trigger, "active")) {
						pairing.trigger.setAttribute("aria-selected", "true");
						pairing.trigger.setAttribute("tabIndex", "0");
					} else {
						pairing.trigger.setAttribute("tabIndex", "-1");
					}

					pairing.content.id =
						groupedContent.namespace +
						"-" +
						groupedContent.id +
						"-" +
						index +
						"-content";
					pairing.content.setAttribute("role", "tabpanel");

					if (!hasClass(pairing.content, "active")) {
						pairing.content.setAttribute("aria-hidden", "true");
					}
				});
			}

			function update(groupedContent) {
				var pairings = groupedContent.pairings;

				forEach(pairings, function (pairing) {
					pairing.trigger.removeAttribute("aria-selected");
					pairing.content.removeAttribute("aria-hidden");

					if (hasClass(pairing.trigger, "active")) {
						pairing.trigger.setAttribute("aria-selected", "true");
						pairing.trigger.setAttribute("tabIndex", "0");
					} else {
						pairing.trigger.setAttribute("tabIndex", "-1");
					}

					if (!hasClass(pairing.content, "active")) {
						pairing.content.setAttribute("aria-hidden", "true");
					}
				});
			}

			var a11y = {
				init: init,
				update: update,
			};

			var asyncGenerator = (function () {
				function AwaitValue(value) {
					this.value = value;
				}

				function AsyncGenerator(gen) {
					var front, back;

					function send(key, arg) {
						return new Promise(function (resolve, reject) {
							var request = {
								key: key,
								arg: arg,
								resolve: resolve,
								reject: reject,
								next: null,
							};

							if (back) {
								back = back.next = request;
							} else {
								front = back = request;
								resume(key, arg);
							}
						});
					}

					function resume(key, arg) {
						try {
							var result = gen[key](arg);
							var value = result.value;

							if (value instanceof AwaitValue) {
								Promise.resolve(value.value).then(
									function (arg) {
										resume("next", arg);
									},
									function (arg) {
										resume("throw", arg);
									}
								);
							} else {
								settle(result.done ? "return" : "normal", result.value);
							}
						} catch (err) {
							settle("throw", err);
						}
					}

					function settle(type, value) {
						switch (type) {
							case "return":
								front.resolve({
									value: value,
									done: true,
								});
								break;

							case "throw":
								front.reject(value);
								break;

							default:
								front.resolve({
									value: value,
									done: false,
								});
								break;
						}

						front = front.next;

						if (front) {
							resume(front.key, front.arg);
						} else {
							back = null;
						}
					}

					this._invoke = send;

					if (typeof gen.return !== "function") {
						this.return = undefined;
					}
				}

				if (typeof Symbol === "function" && Symbol.asyncIterator) {
					AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
						return this;
					};
				}

				AsyncGenerator.prototype.next = function (arg) {
					return this._invoke("next", arg);
				};

				AsyncGenerator.prototype.throw = function (arg) {
					return this._invoke("throw", arg);
				};

				AsyncGenerator.prototype.return = function (arg) {
					return this._invoke("return", arg);
				};

				return {
					wrap: function (fn) {
						return function () {
							return new AsyncGenerator(fn.apply(this, arguments));
						};
					},
					await: function (value) {
						return new AwaitValue(value);
					},
				};
			})();

			var classCallCheck = function (instance, Constructor) {
				if (!(instance instanceof Constructor)) {
					throw new TypeError("Cannot call a class as a function");
				}
			};

			var createClass = (function () {
				function defineProperties(target, props) {
					for (var i = 0; i < props.length; i++) {
						var descriptor = props[i];
						descriptor.enumerable = descriptor.enumerable || false;
						descriptor.configurable = true;
						if ("value" in descriptor) descriptor.writable = true;
						Object.defineProperty(target, descriptor.key, descriptor);
					}
				}

				return function (Constructor, protoProps, staticProps) {
					if (protoProps) defineProperties(Constructor.prototype, protoProps);
					if (staticProps) defineProperties(Constructor, staticProps);
					return Constructor;
				};
			})();

			/** A class for creating, managing, and destroying groupable content as tabs. */

			var TabsLayout = (function () {
				function TabsLayout(groupedContent) {
					classCallCheck(this, TabsLayout);

					this.groupedContent = groupedContent;
					this.pairings = groupedContent.pairings;
					this.events = [];

					this._handleKeydown = this._handleKeydown.bind(this);
					this._handleClick = this._handleClick.bind(this);

					this._init();
					a11y.init(this.groupedContent);
				}

				createClass(TabsLayout, [
					{
						key: "unload",
						value: function unload() {
							forEach(this.events, function (event) {
								event.trigger.removeEventListener(event.type, event.fn);
							});
						},
					},
					{
						key: "_init",
						value: function _init() {
							var _this = this;

							var existingActive = false;

							forEach(this.pairings, function (pairing) {
								var trigger = pairing.trigger;

								if (hasClass(trigger, "active")) {
									existingActive = true;
								}

								trigger.addEventListener("keydown", _this._handleKeydown);
								trigger.addEventListener("click", _this._handleClick);

								_this.events.push({
									trigger: trigger,
									type: "keydown",
									fn: _this._handleKeydown,
								});

								_this.events.push({
									trigger: trigger,
									type: "click",
									fn: _this._handleClick,
								});
							});

							if (!existingActive) {
								addClass(this.pairings[0].trigger, "active");
								addClass(this.pairings[0].content, "active");
							}
						},
					},
					{
						key: "_handleKeydown",
						value: function _handleKeydown(event) {
							var trigger = event.currentTarget;
							var pairing = findPairingFromPairingTrigger(
								this.pairings,
								trigger
							);
							var pairingIndex = this.pairings.indexOf(pairing);
							var prevIndex =
								pairingIndex - 1 < 0
									? this.pairings.length - 1
									: pairingIndex - 1;
							var nextIndex =
								pairingIndex + 1 >= this.pairings.length ? 0 : pairingIndex + 1;

							var nextPairing = null;

							switch (event.key) {
								case "ArrowLeft":
									nextPairing = this.pairings[prevIndex];
									break;
								case "ArrowRight":
									nextPairing = this.pairings[nextIndex];
									break;
								default:
									nextPairing = null;
									break;
							}

							// Fast exit if we can't find the tab or tabs
							if (nextPairing === null) return;

							event.preventDefault();

							forEach(this.pairings, function (inactivePairing) {
								removeClass(inactivePairing.trigger, "active");
								removeClass(inactivePairing.content, "active");
							});

							addClass(nextPairing.trigger, "active");
							addClass(nextPairing.content, "active");

							nextPairing.trigger.focus();

							a11y.update(this.groupedContent);
						},
					},
					{
						key: "_handleClick",
						value: function _handleClick(event) {
							var trigger = event.currentTarget;
							var pairing = findPairingFromPairingTrigger(
								this.pairings,
								trigger
							);

							// Fast exit if we can't find the tab or tabs
							if (pairing === null) return;

							event.preventDefault();

							forEach(this.pairings, function (inactivePairing) {
								removeClass(inactivePairing.trigger, "active");
								removeClass(inactivePairing.content, "active");
							});

							addClass(pairing.trigger, "active");
							addClass(pairing.content, "active");

							a11y.update(this.groupedContent);
						},
					},
				]);
				return TabsLayout;
			})();

			function init$1(groupedContent) {
				var pairings = groupedContent.pairings;

				forEach(pairings, function (pairing, index) {
					pairing.trigger.setAttribute("role", "button");
					pairing.trigger.setAttribute(
						"aria-controls",
						groupedContent.namespace +
							"-" +
							groupedContent.id +
							"-" +
							index +
							"-content"
					);
					pairing.trigger.setAttribute("tabIndex", "0");

					if (pairing.trigger.children.length > 0) {
						forEach(pairing.trigger.children, function (child) {
							child.setAttribute("tabIndex", "-1");
						});
					}

					if (hasClass(pairing.trigger, "active")) {
						pairing.trigger.setAttribute("aria-expanded", "true");
					} else {
						pairing.trigger.setAttribute("aria-expanded", "false");
					}

					pairing.content.id =
						groupedContent.namespace +
						"-" +
						groupedContent.id +
						"-" +
						index +
						"-content";

					if (!hasClass(pairing.content, "active")) {
						pairing.content.setAttribute("aria-hidden", "true");
					}
				});
			}

			function update$1(groupedContent) {
				var pairings = groupedContent.pairings;

				forEach(pairings, function (pairing) {
					pairing.content.removeAttribute("aria-hidden");

					if (hasClass(pairing.trigger, "active")) {
						pairing.trigger.setAttribute("aria-expanded", "true");
					} else {
						pairing.trigger.setAttribute("aria-expanded", "false");
					}

					if (!hasClass(pairing.content, "active")) {
						pairing.content.setAttribute("aria-hidden", "true");
					}
				});
			}

			var a11y$1 = {
				init: init$1,
				update: update$1,
			};

			/** A class for creating, managing, and destroying groupable content as an accordion. */

			var AccordionLayout = (function () {
				function AccordionLayout(groupedContent) {
					classCallCheck(this, AccordionLayout);

					this.groupedContent = groupedContent;
					this.pairings = groupedContent.pairings;
					this.events = [];

					this._handleKeydown = this._handleKeydown.bind(this);
					this._handleClick = this._handleClick.bind(this);

					this._init(this.pairings);
					a11y$1.init(this.groupedContent);
				}

				createClass(AccordionLayout, [
					{
						key: "unload",
						value: function unload() {
							forEach(this.events, function (event) {
								event.trigger.removeEventListener(event.type, event.fn);
							});
						},
					},
					{
						key: "_init",
						value: function _init() {
							var _this = this;

							forEach(this.pairings, function (pairing) {
								var trigger = pairing.trigger;
								var content = pairing.content;

								trigger.parentNode.insertBefore(content, trigger.nextSibling);

								trigger.addEventListener("keydown", _this._handleKeydown);
								trigger.addEventListener("click", _this._handleClick);

								_this.events.push({
									trigger: trigger,
									type: "keydown",
									fn: _this._handleKeydown,
								});

								_this.events.push({
									trigger: trigger,
									type: "click",
									fn: _this._handleClick,
								});
							});

							this.groupedContent.contents.remove();
						},
					},
					{
						key: "_handleKeydown",
						value: function _handleKeydown(event) {
							var trigger = event.currentTarget;
							var pairing = findPairingFromPairingTrigger(
								this.pairings,
								trigger
							);

							// Fast exit if enter isn't pressed or we can't find the group
							if (event.key !== "Enter" || pairing === null) return;

							event.preventDefault();

							toggleClass(pairing.trigger, "active");
							toggleClass(pairing.content, "active");
							a11y$1.update(this.groupedContent);
						},
					},
					{
						key: "_handleClick",
						value: function _handleClick(event) {
							var trigger = event.currentTarget;
							var pairing = findPairingFromPairingTrigger(
								this.pairings,
								trigger
							);

							// Fast exit if we can't find the group
							if (pairing === null) return;

							event.preventDefault();

							toggleClass(pairing.trigger, "active");
							toggleClass(pairing.content, "active");
							a11y$1.update(this.groupedContent);
						},
					},
				]);
				return AccordionLayout;
			})();

			/**
			 * Returns an array of nodes related to the heading node.
			 * @param {node} heading - The heading node to search for content from.
			 * @returns {node[]}
			 */
			function getHeadingContent(heading) {
				var headingTagNames = ["H1", "H2", "H3", "H4", "H5", "H6"];
				var tagNameIndex = headingTagNames.indexOf(heading.tagName);
				var content = [];

				var sibling = heading.nextElementSibling;

				while (
					sibling !== null &&
					(headingTagNames.indexOf(sibling.tagName) === -1 ||
						headingTagNames.indexOf(sibling.tagName) > tagNameIndex)
				) {
					content.push(sibling);

					sibling = sibling.nextElementSibling;
				}

				return content;
			}

			/**
			 * Returns an object array representing the heading tree from a given node.
			 * Root nodes are evaluated differently, and requires the evaluatingRoot flag
			 * to be true.
			 * @param {node} el - The node being evaluated.
			 * @param {node[]} children - The children of the evaluated node.
			 * @param {boolean} [evaluatingRoot] - Whether to evaluate as root node.
			 * @returns {Object[]}
			 */
			function getHeadingTree(el, children) {
				var evaluatingRoot =
					arguments.length > 2 && arguments[2] !== undefined
						? arguments[2]
						: false;

				var headingTagNames = ["H1", "H2", "H3", "H4", "H5", "H6"];
				var tagNameIndex = headingTagNames.indexOf(el.tagName);
				var headings = [];

				var currentLowestTagNameIndex = 5;

				for (var i = 0; i < children.length; i += 1) {
					var child = children[i];
					var childTagNameIndex = headingTagNames.indexOf(child.tagName);

					if (
						childTagNameIndex !== -1 &&
						childTagNameIndex < currentLowestTagNameIndex
					) {
						currentLowestTagNameIndex = childTagNameIndex;
					}

					if (
						(evaluatingRoot &&
							childTagNameIndex !== -1 &&
							childTagNameIndex <= currentLowestTagNameIndex) ||
						(!evaluatingRoot &&
							childTagNameIndex !== -1 &&
							childTagNameIndex === tagNameIndex + 1)
					) {
						var siblings = getHeadingContent(child);

						var childNode = {
							el: child,
							content: siblings,
							children: getHeadingTree(child, siblings),
						};

						headings.push(childNode);
					}
				}

				return headings;
			}

			/**
			 * Returns groupings of headings that meet the minimum sequence value
			 * and don't contain any invalid headings.
			 * @param {Object[]} headings - An array of heading objects.
			 * @param {int[]} invalidHeadings - An array of invalid heading integers,
			 *                                  representing indexes of headings.
			 * @param {*} minInSequence - Minimum headings in sequence before being considered
			 *                            as a grouping.
			 * @returns {Object[][]}
			 */
			function getHeadingGroupsInSequence(
				headings,
				invalidHeadings,
				minInSequence
			) {
				var headingGroupsInSequence = [];
				var currentHeadingGroupInSequence = [];
				var currentSequence = 0;

				for (var i = 0; i < headings.length; i += 1) {
					if (invalidHeadings.indexOf(i) === -1) {
						currentHeadingGroupInSequence.push(headings[i]);
						currentSequence += 1;

						if (
							i !== headings.length - 1 &&
							headings[i].el.tagName !== headings[i + 1].el.tagName &&
							invalidHeadings.indexOf(i + 1)
						) {
							currentHeadingGroupInSequence = [];
							currentSequence = 0;
						} else if (
							i !== 0 &&
							headings[i].el.tagName !== headings[i - 1].el.tagName
						) {
							currentHeadingGroupInSequence.pop();
							currentSequence -= 1;

							if (currentSequence >= minInSequence) {
								headingGroupsInSequence.push(currentHeadingGroupInSequence);
							}

							currentHeadingGroupInSequence = [headings[i]];
							currentSequence = 1;
						}
					}
				}

				if (currentSequence >= minInSequence) {
					headingGroupsInSequence.push(currentHeadingGroupInSequence);
				}

				return headingGroupsInSequence;
			}

			/**
			 * Generates necessary DOM elements to group related content.
			 * Returns a object array representing the grouped content.
			 * @param {Object[]} children - An array of objects.
			 * @returns {Object[]}
			 */
			function createGroupedContent(children) {
				var pairings = [];

				var firstChild = children[0].el;
				var triggers = document.createElement("div");
				var contents = document.createElement("div");

				contents = firstChild.parentNode.insertBefore(
					contents,
					firstChild.nextSibling
				);
				triggers = firstChild.parentNode.insertBefore(
					triggers,
					firstChild.nextSibling
				);

				for (var i = 0; i < children.length; i += 1) {
					var child = children[i];
					var trigger = child.el;
					var content = document.createElement("div");

					trigger = triggers.appendChild(trigger);
					content = contents.appendChild(content);

					for (var j = 0; j < child.content.length; j += 1) {
						content.appendChild(child.content[j]);
					}

					pairings.push({
						trigger: trigger,
						content: content,
					});
				}

				return {
					triggers: triggers,
					contents: contents,
					pairings: pairings,
				};
			}

			/**
			 * Returns all groupable content within the supplied node.
			 * @param {node} node - A node to traverse for groupable content.
			 * @returns {Object[][]}
			 */
			/*
			 * Recursive function:
			 *  Returns all groups of headings that
			 *  are elegible to become grouped content.
			 */
			function getGroupedContentSet(node) {
				var children = node.children;
				var childrenWithGroupableContent = [];
				var groupedContentSet = [];

				if (children.length === 0) {
					return [];
				}

				for (var i = 0; i < children.length; i += 1) {
					var childGroupableContent = getGroupedContentSet(children[i]);

					if (childGroupableContent.length > 0) {
						childrenWithGroupableContent.push(i);
						groupedContentSet = groupedContentSet.concat(childGroupableContent);
					}
				}

				var headingGroupsInSequence = getHeadingGroupsInSequence(
					children,
					childrenWithGroupableContent,
					3
				);

				for (var _i = 0; _i < headingGroupsInSequence.length; _i += 1) {
					groupedContentSet.push(
						createGroupedContent(headingGroupsInSequence[_i])
					);
				}

				return groupedContentSet;
			}

			/**
			 * When static parsing isn't enough, there's intelliparse™!
			 * Searches through dom content to find heading groupings that
			 * are elegible to become tab groups.
			 * Assumes that content is in a flattened hierarchy in the dom
			 * and interprets increasing heading values as a deeper level of nesting.
			 * Returns all groupable content as an array of object arrays.
			 * @param {node} el - The node who's content will be searched for groupable content.
			 * @returns {Object[][]}
			 */
			function intelliParse(el) {
				var children = el.children;
				var heading = el.querySelector("h1, h2, h3, h4, h5, h6");

				// Fast return if there's no headings
				if (children.length === 0) return [];

				var rootNode = {
					el: el,
					content: null,
					children: getHeadingTree(heading, children, true),
				};

				return getGroupedContentSet(rootNode);
			}

			/**
			 * Parses content from a given node based on a static structure.
			 * The structure is as follows:
			 * <ul class="tabs">
			 *   <li class="active">Tab 1</li>
			 *   <li>Tab 2</li>
			 *   <li>Tab 3</li>
			 * </ul>
			 *
			 * <ul class="tabs-content">
			 *   <li class="active">
			 *     <p>Tab 1 content goes here.</p>
			 *   </li>
			 *   <li>
			 *     <p>Tab 2 content goes here.</p>
			 *   </li>
			 *   <li>
			 *     <p>Tab 3 content goes here.</p>
			 *   </li>
			 * </ul>
			 * Returns all groupable content as an array of object arrays.
			 * @param {node} el - The node who's content will be searched for groupable content.
			 * @returns {Object[][]}
			 */
			function staticParse(el) {
				var groupedContentSet = [];

				var tabs = el.querySelectorAll(".tabs");

				for (var i = 0; i < tabs.length; i += 1) {
					var triggers = tabs[i].children;
					var contents = tabs[i].nextElementSibling.children;

					// Only add a tab group if equal triggers to contents
					if (triggers.length === contents.length) {
						var length = groupedContentSet.push({
							triggers: tabs[i],
							contents: tabs[i].nextElementSibling,
							pairings: [],
						});
						var index = length - 1;

						for (var j = 0; j < triggers.length; j += 1) {
							var trigger = triggers[j];
							var content = contents[j];

							var pairing = {
								trigger: trigger,
								content: content,
							};

							groupedContentSet[index].pairings.push(pairing);
						}
					}
				}

				return groupedContentSet;
			}

			/**
			 * Returns all groupable content as an array of object arrays.
			 * @param {node} content - The node to parse for groupable content.
			 * @param {boolean} intelliparse - Whether to use intelligent parsing.
			 * @returns {Object[][]}
			 */
			function parse(content) {
				var intelliparse =
					arguments.length > 1 && arguments[1] !== undefined
						? arguments[1]
						: false;

				var groupedContentSet = intelliparse
					? intelliParse(content)
					: staticParse(content);

				return groupedContentSet;
			}

			/** A class for creating, managing, and destroying groupable content. */

			var GroupedContent = (function () {
				/**
				 * Create grouped content
				 * @param {node} el - The element to search for groupable content in.
				 * @param {Object}  [options] - Additional options
				 * @param {string}  [options.layout] - The layout to display groupable content in.
				 * @param {boolean} [options.intelliparse] - The parsing algorithm used to find content with.
				 */
				function GroupedContent(el) {
					var _this = this;

					var options =
						arguments.length > 1 && arguments[1] !== undefined
							? arguments[1]
							: {};
					classCallCheck(this, GroupedContent);

					this.namespace = "grouped-content";
					this.el = el;
					this.groupedContentInstances = [];

					var layout = options.layout || "tabs";
					var intelliparse = !!options.intelliparse;

					forEach(parse(el, intelliparse), function (groupedContent) {
						var id = uuidv4();
						var instance = null;
						var groupedContentWrapper = document.createElement("div");

						groupedContentWrapper =
							groupedContent.triggers.parentNode.insertBefore(
								groupedContentWrapper,
								groupedContent.triggers.nextSibling
							);

						addClass(groupedContentWrapper, _this.namespace);
						addClass(
							groupedContentWrapper,
							_this.namespace + "-layout-" + layout
						);

						groupedContentWrapper.appendChild(groupedContent.triggers);
						groupedContentWrapper.appendChild(groupedContent.contents);

						groupedContent.namespace = _this.namespace;
						groupedContent.id = id;
						groupedContent.triggers.id =
							_this.namespace + "-" + id + "-triggers";
						groupedContent.contents.id =
							_this.namespace + "-" + id + "-contents";

						addClass(groupedContent.triggers, _this.namespace + "-triggers");
						addClass(groupedContent.contents, _this.namespace + "-contents");

						forEach(groupedContent.pairings, function (pairing) {
							addClass(pairing.trigger, _this.namespace + "-trigger");
							addClass(pairing.content, _this.namespace + "-content");
						});

						switch (layout) {
							case "accordion":
								instance = new AccordionLayout(groupedContent);
								break;
							case "tabs":
							default:
								instance = new TabsLayout(groupedContent);
								break;
						}

						_this.groupedContentInstances.push({
							groupedContent: groupedContent,
							instance: instance,
						});
					});
				}

				/** Unload all grouped content instances */

				createClass(GroupedContent, [
					{
						key: "unload",
						value: function unload() {
							forEach(
								this.groupedContentInstances,
								function (groupedContentInstance) {
									groupedContentInstance.instance.unload();
								}
							);
						},
					},
				]);
				return GroupedContent;
			})();

			module.exports = GroupedContent;

			/***/
		},

		/***/ 458: /***/ (module) => {
			function _classCallCheck(instance, Constructor) {
				if (!(instance instanceof Constructor)) {
					throw new TypeError("Cannot call a class as a function");
				}
			}
			function _defineProperties(target, props) {
				for (var i = 0; i < props.length; i++) {
					var descriptor = props[i];
					descriptor.enumerable = descriptor.enumerable || false;
					descriptor.configurable = true;
					if ("value" in descriptor) descriptor.writable = true;
					Object.defineProperty(target, descriptor.key, descriptor);
				}
			}
			function _createClass(Constructor, protoProps, staticProps) {
				if (protoProps) _defineProperties(Constructor.prototype, protoProps);
				if (staticProps) _defineProperties(Constructor, staticProps);
				Object.defineProperty(Constructor, "prototype", {
					writable: false,
				});
				return Constructor;
			}
			function _defineProperty(obj, key, value) {
				if (key in obj) {
					Object.defineProperty(obj, key, {
						value: value,
						enumerable: true,
						configurable: true,
						writable: true,
					});
				} else {
					obj[key] = value;
				}
				return obj;
			}
			function _slicedToArray(arr, i) {
				return (
					_arrayWithHoles(arr) ||
					_iterableToArrayLimit(arr, i) ||
					_unsupportedIterableToArray(arr, i) ||
					_nonIterableRest()
				);
			}
			function _arrayWithHoles(arr) {
				if (Array.isArray(arr)) return arr;
			}
			function _iterableToArrayLimit(arr, i) {
				var _i =
					arr == null
						? null
						: (typeof Symbol !== "undefined" && arr[Symbol.iterator]) ||
						  arr["@@iterator"];
				if (_i == null) return;
				var _arr = [];
				var _n = true;
				var _d = false;
				var _s, _e;
				try {
					for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
						_arr.push(_s.value);
						if (i && _arr.length === i) break;
					}
				} catch (err) {
					_d = true;
					_e = err;
				} finally {
					try {
						if (!_n && _i["return"] != null) _i["return"]();
					} finally {
						if (_d) throw _e;
					}
				}
				return _arr;
			}
			function _unsupportedIterableToArray(o, minLen) {
				if (!o) return;
				if (typeof o === "string") return _arrayLikeToArray(o, minLen);
				var n = Object.prototype.toString.call(o).slice(8, -1);
				if (n === "Object" && o.constructor) n = o.constructor.name;
				if (n === "Map" || n === "Set") return Array.from(o);
				if (
					n === "Arguments" ||
					/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
				)
					return _arrayLikeToArray(o, minLen);
			}
			function _arrayLikeToArray(arr, len) {
				if (len == null || len > arr.length) len = arr.length;
				for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
				return arr2;
			}
			function _nonIterableRest() {
				throw new TypeError(
					"Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
				);
			}
			function _classPrivateFieldGet(receiver, privateMap) {
				var descriptor = _classExtractFieldDescriptor(
					receiver,
					privateMap,
					"get"
				);
				return _classApplyDescriptorGet(receiver, descriptor);
			}
			function _classPrivateFieldSet(receiver, privateMap, value) {
				var descriptor = _classExtractFieldDescriptor(
					receiver,
					privateMap,
					"set"
				);
				_classApplyDescriptorSet(receiver, descriptor, value);
				return value;
			}
			function _classExtractFieldDescriptor(receiver, privateMap, action) {
				if (!privateMap.has(receiver)) {
					throw new TypeError(
						"attempted to " + action + " private field on non-instance"
					);
				}
				return privateMap.get(receiver);
			}
			function _classApplyDescriptorGet(receiver, descriptor) {
				if (descriptor.get) {
					return descriptor.get.call(receiver);
				}
				return descriptor.value;
			}
			function _classApplyDescriptorSet(receiver, descriptor, value) {
				if (descriptor.set) {
					descriptor.set.call(receiver, value);
				} else {
					if (!descriptor.writable) {
						throw new TypeError("attempted to set read only private field");
					}
					descriptor.value = value;
				}
			}
			function _classPrivateMethodGet(receiver, privateSet, fn) {
				if (!privateSet.has(receiver)) {
					throw new TypeError("attempted to get private field on non-instance");
				}
				return fn;
			}
			function _checkPrivateRedeclaration(obj, privateCollection) {
				if (privateCollection.has(obj)) {
					throw new TypeError(
						"Cannot initialize the same private elements twice on an object"
					);
				}
			}
			function _classPrivateFieldInitSpec(obj, privateMap, value) {
				_checkPrivateRedeclaration(obj, privateMap);
				privateMap.set(obj, value);
			}
			function _classPrivateMethodInitSpec(obj, privateSet) {
				_checkPrivateRedeclaration(obj, privateSet);
				privateSet.add(obj);
			}

			var list = [
				" daum[ /]",
				" deusu/",
				"(?:^| )site",
				"@[a-z]",
				"\\(at\\)[a-z]",
				"\\(github\\.com/",
				"\\[at\\][a-z]",
				"^12345",
				"^<",
				"^[\\w \\.\\-\\(\\)]+(/v?\\d+(\\.\\d+)?(\\.\\d{1,10})?)?$",
				"^[^ ]{50,}$",
				"^active",
				"^ad muncher",
				"^anglesharp/",
				"^anonymous",
				"^avsdevicesdk/",
				"^axios/",
				"^bidtellect/",
				"^biglotron",
				"^castro",
				"^clamav[ /]",
				"^cobweb/",
				"^coccoc",
				"^custom",
				"^ddg[_-]android",
				"^discourse",
				"^dispatch/\\d",
				"^downcast/",
				"^duckduckgo",
				"^facebook",
				"^fdm[ /]\\d",
				"^getright/",
				"^gozilla/",
				"^hatena",
				"^hobbit",
				"^hotzonu",
				"^hwcdn/",
				"^jeode/",
				"^jetty/",
				"^jigsaw",
				"^linkdex",
				"^lwp[-: ]",
				"^metauri",
				"^microsoft bits",
				"^movabletype",
				"^mozilla/\\d\\.\\d \\(compatible;?\\)$",
				"^mozilla/\\d\\.\\d \\w*$",
				"^navermailapp",
				"^netsurf",
				"^offline explorer",
				"^phantom",
				"^php",
				"^postman",
				"^postrank",
				"^python",
				"^read",
				"^reed",
				"^restsharp/",
				"^snapchat",
				"^space bison",
				"^svn",
				"^swcd ",
				"^taringa",
				"^test certificate info",
				"^thumbor/",
				"^tumblr/",
				"^user-agent:mozilla",
				"^valid",
				"^venus/fedoraplanet",
				"^w3c",
				"^webbandit/",
				"^webcopier",
				"^wget",
				"^whatsapp",
				"^xenu link sleuth",
				"^yahoo",
				"^yandex",
				"^zdm/\\d",
				"^zoom marketplace/",
				"^$",
				"adbeat\\.com",
				"appinsights",
				"archive",
				"ask jeeves/teoma",
				"bit\\.ly/",
				"bluecoat drtr",
				"bot",
				"browsex",
				"burpcollaborator",
				"capture",
				"catch",
				"check",
				"chrome-lighthouse",
				"chromeframe",
				"client",
				"cloud",
				"crawl",
				"dareboost",
				"datanyze",
				"dataprovider",
				"dejaclick",
				"dmbrowser",
				"download",
				"evc-batch/",
				"feed",
				"firephp",
				"freesafeip",
				"ghost",
				"gomezagent",
				"google",
				"headlesschrome/",
				"http",
				"httrack",
				"hubspot marketing grader",
				"hydra",
				"ibisbrowser",
				"images",
				"iplabel",
				"ips-agent",
				"java",
				"library",
				"mail\\.ru/",
				"manager",
				"monitor",
				"morningscore/",
				"neustar wpm",
				"news",
				"nutch",
				"offbyone",
				"optimize",
				"pageburst",
				"pagespeed",
				"perl",
				"pingdom",
				"powermarks",
				"preview",
				"proxy",
				"ptst[ /]\\d",
				"reader",
				"rexx;",
				"rigor",
				"rss",
				"scan",
				"scrape",
				"search",
				"serp ?reputation ?management",
				"server",
				"sogou",
				"sparkler/",
				"spider",
				"statuscake",
				"stumbleupon\\.com",
				"supercleaner",
				"synapse",
				"synthetic",
				"taginspector/",
				"torrent",
				"tracemyfile",
				"transcoder",
				"trendsmapresolver",
				"twingly recon",
				"url",
				"virtuoso",
				"wappalyzer",
				"webglance",
				"webkit2png",
				"websitemetadataretriever",
				"whatcms/",
				"wordpress",
				"zgrab",
			];

			/**
			 * Mutate given list of patter strings
			 * @param {string[]} list
			 * @returns {string[]}
			 */
			function amend(list) {
				try {
					// Risk: Uses lookbehind assertion, avoid breakage in parsing by using RegExp constructor
					new RegExp("(?<! cu)bot").test("dangerbot"); // eslint-disable-line prefer-regex-literals
				} catch (error) {
					// Skip regex fixes
					return list;
				}
				[
					// Addresses: Cubot device
					["bot", "(?<! cu)bot"],
					// Addresses: Android webview
					[
						"google",
						"(?<! (?:channel/|google/))google(?!(app|/google| pixel))",
					],
					// Addresses: libhttp browser
					["http", "(?<!(?:lib))http"],
					// Addresses: java based browsers
					["java", "java(?!;)"],
					// Addresses: Yandex Search App
					["search", "(?<! ya(?:yandex)?)search"],
				].forEach(function (_ref) {
					var _ref2 = _slicedToArray(_ref, 2),
						search = _ref2[0],
						replace = _ref2[1];
					var index = list.lastIndexOf(search);
					if (~index) {
						list.splice(index, 1, replace);
					}
				});
				return list;
			}

			amend(list);
			var flags = "i";

			/**
			 * Test user agents for matching patterns
			 */
			var _list = /*#__PURE__*/ new WeakMap();
			var _pattern = /*#__PURE__*/ new WeakMap();
			var _update = /*#__PURE__*/ new WeakSet();
			var _index = /*#__PURE__*/ new WeakSet();
			var Isbot = /*#__PURE__*/ (function () {
				/**
				 * @type {string[]}
				 */

				/**
				 * @type {RegExp}
				 */

				function Isbot(patterns) {
					var _this = this;
					_classCallCheck(this, Isbot);
					_classPrivateMethodInitSpec(this, _index);
					_classPrivateMethodInitSpec(this, _update);
					_classPrivateFieldInitSpec(this, _list, {
						writable: true,
						value: void 0,
					});
					_classPrivateFieldInitSpec(this, _pattern, {
						writable: true,
						value: void 0,
					});
					_classPrivateFieldSet(this, _list, patterns || list.slice());
					_classPrivateMethodGet(this, _update, _update2).call(this);
					var isbot = function isbot(ua) {
						return _this.test(ua);
					};
					return Object.defineProperties(
						isbot,
						Object.entries(
							Object.getOwnPropertyDescriptors(Isbot.prototype)
						).reduce(function (accumulator, _ref) {
							var _ref2 = _slicedToArray(_ref, 2),
								prop = _ref2[0],
								descriptor = _ref2[1];
							if (typeof descriptor.value === "function") {
								Object.assign(
									accumulator,
									_defineProperty({}, prop, {
										value: _this[prop].bind(_this),
									})
								);
							}
							if (typeof descriptor.get === "function") {
								Object.assign(
									accumulator,
									_defineProperty({}, prop, {
										get: function get() {
											return _this[prop];
										},
									})
								);
							}
							return accumulator;
						}, {})
					);
				}

				/**
				 * Recreate the pattern from rules list
				 */
				_createClass(Isbot, [
					{
						key: "pattern",
						get:
							/**
							 * Get a clone of the pattern
							 * @type RegExp
							 */
							function get() {
								return new RegExp(_classPrivateFieldGet(this, _pattern));
							},

						/**
						 * Match given string against out pattern
						 * @param  {string} ua User Agent string
						 * @returns {boolean}
						 */
					},
					{
						key: "test",
						value: function test(ua) {
							return (
								Boolean(ua) && _classPrivateFieldGet(this, _pattern).test(ua)
							);
						},

						/**
						 * Get the match for strings' known crawler pattern
						 * @param  {string} ua User Agent string
						 * @returns {string|null}
						 */
					},
					{
						key: "find",
						value: function find() {
							var ua =
								arguments.length > 0 && arguments[0] !== undefined
									? arguments[0]
									: "";
							var match = ua.match(_classPrivateFieldGet(this, _pattern));
							return match && match[0];
						},

						/**
						 * Get the patterns that match user agent string if any
						 * @param  {string} ua User Agent string
						 * @returns {string[]}
						 */
					},
					{
						key: "matches",
						value: function matches() {
							var ua =
								arguments.length > 0 && arguments[0] !== undefined
									? arguments[0]
									: "";
							return _classPrivateFieldGet(this, _list).filter(function (
								entry
							) {
								return new RegExp(entry, flags).test(ua);
							});
						},

						/**
						 * Clear all patterns that match user agent
						 * @param  {string} ua User Agent string
						 * @returns {void}
						 */
					},
					{
						key: "clear",
						value: function clear() {
							var ua =
								arguments.length > 0 && arguments[0] !== undefined
									? arguments[0]
									: "";
							this.exclude(this.matches(ua));
						},

						/**
						 * Extent patterns for known crawlers
						 * @param  {string[]} filters
						 * @returns {void}
						 */
					},
					{
						key: "extend",
						value: function extend() {
							var _this2 = this;
							var filters =
								arguments.length > 0 && arguments[0] !== undefined
									? arguments[0]
									: [];
							[].push.apply(
								_classPrivateFieldGet(this, _list),
								filters
									.filter(function (rule) {
										return (
											_classPrivateMethodGet(_this2, _index, _index2).call(
												_this2,
												rule
											) === -1
										);
									})
									.map(function (filter) {
										return filter.toLowerCase();
									})
							);
							_classPrivateMethodGet(this, _update, _update2).call(this);
						},

						/**
						 * Exclude patterns from bot pattern rule
						 * @param  {string[]} filters
						 * @returns {void}
						 */
					},
					{
						key: "exclude",
						value: function exclude() {
							var filters =
								arguments.length > 0 && arguments[0] !== undefined
									? arguments[0]
									: [];
							var length = filters.length;
							while (length--) {
								var index = _classPrivateMethodGet(this, _index, _index2).call(
									this,
									filters[length]
								);
								if (index > -1) {
									_classPrivateFieldGet(this, _list).splice(index, 1);
								}
							}
							_classPrivateMethodGet(this, _update, _update2).call(this);
						},

						/**
						 * Create a new Isbot instance using given list or self's list
						 * @param  {string[]} [list]
						 * @returns {Isbot}
						 */
					},
					{
						key: "spawn",
						value: function spawn(list) {
							return new Isbot(list || _classPrivateFieldGet(this, _list));
						},
					},
				]);
				return Isbot;
			})();
			function _update2() {
				_classPrivateFieldSet(
					this,
					_pattern,
					new RegExp(_classPrivateFieldGet(this, _list).join("|"), flags)
				);
			}
			function _index2(rule) {
				return _classPrivateFieldGet(this, _list).indexOf(rule.toLowerCase());
			}

			var isbot = new Isbot();

			module.exports = isbot;
			//# sourceMappingURL=index.js.map

			/***/
		},

		/***/ 220: /***/ () => {
			/*!
			 * Revealer 3.0.0
			 *
			 * Copyright 2021, Pixel Union - http://pixelunion.net
			 * Released under the MIT license
			 */
			(function ($) {
				// check for trend event (make sure jquery.trend is included)
				if (typeof $.event.special.trend !== "object") {
					console.warn(
						"Please make sure jquery.trend is included! Otherwise revealer won't work."
					);
				}

				// Simple requestAnimationFrame polyfill
				var raf =
					window.requestAnimationFrame ||
					window.mozRequestAnimationFrame ||
					window.webkitRequestAnimationFrame ||
					function (fn) {
						window.setTimeout(fn, 1000 / 60);
					};

				// Public API
				var methods = {
					isVisible: function (el) {
						return !!el.data("revealer-visible");
					},

					show: function (el, force) {
						// Check state
						if (methods.isVisible(el)) {
							el.removeClass("animating animating-in");
							el.off("revealer-animating revealer-show");
							return;
						}

						// Remove previous event listeners
						el.data("revealer-visible", true);
						el.off("trend");

						if (force) {
							el.addClass("visible");
							raf(function () {
								el.trigger("revealer-animating");
								el.trigger("revealer-show");
							});
							return;
						}

						raf(function () {
							// Start animation state transition
							el.addClass("animating animating-in");
							el.trigger("revealer-animating");

							raf(function () {
								el.addClass("visible");

								el.one("trend", function () {
									el.removeClass("animating animating-in");
									el.trigger("revealer-show");
								});
							});
						});
					},

					hide: function (el, force) {
						// Check state
						if (!methods.isVisible(el)) {
							el.removeClass("animating animating-out visible");
							el.off("revealer-animating revealer-hide");
							return;
						}

						// Remove previous event listeners
						el.data("revealer-visible", false);
						el.off("trend");

						if (force) {
							el.removeClass("visible");
							raf(function () {
								el.trigger("revealer-animating");
								el.trigger("revealer-hide");
							});
							return;
						}

						raf(function () {
							el.addClass("animating animating-out");
							el.trigger("revealer-animating");

							raf(function () {
								el.removeClass("visible");

								el.one("trend", function () {
									el.removeClass("animating animating-in animating-out");
									el.trigger("revealer-hide");
								});
							});
						});
					},

					toggle: function (el, force) {
						if (methods.isVisible(el)) {
							methods.hide(el, force);
						} else {
							methods.show(el, force);
						}
					},
				};

				// jQuery plugin
				$.fn.revealer = function (method, force) {
					// Get action
					var action = methods[method || "toggle"];
					if (!action) return this;

					// Run action
					if (method === "isVisible") {
						return action(this);
					}

					return this.each(function () {
						action($(this), force);
					});
				};
			})(jQuery);

			/***/
		},

		/***/ 72: /***/ () => {
			/*!
			 * Trend 1.0.0
			 *
			 * Fail-safe TransitionEnd event for jQuery.
			 *
			 * Adds a new "trend" event that can be used in browsers that don't
			 * support "transitionend".
			 *
			 * NOTE: Only supports being bound with "jQuery.one".
			 *
			 * Copyright 2021, Pixel Union - http://pixelunion.net
			 * Released under the MIT license
			 */
			(function ($) {
				// Prefixed transitionend event names
				var transitionEndEvents =
					"webkitTransitionEnd " +
					"otransitionend " +
					"oTransitionEnd " +
					"msTransitionEnd " +
					"transitionend";

				// Prefixed transition duration property names
				var transitionDurationProperties = [
					"transition-duration",
					"-moz-transition-duration",
					"-webkit-transition-duration",
					"-ms-transition-duration",
					"-o-transition-duration",
					"-khtml-transition-duration",
				];

				// Prefixed transition delay property names
				var transitionDelayProperties = [
					"transition-delay",
					"-moz-transition-delay",
					"-webkit-transition-delay",
					"-ms-transition-delay",
					"-o-transition-delay",
					"-khtml-transition-delay",
				];

				// Parses a CSS time value into milliseconds.
				var parseTime = function (s) {
					s = s.replace(/\s/, "");
					var v = window.parseFloat(s);

					return s.match(/[^m]s$/i) ? v * 1000 : v;
				};

				// Parses the longest time unit found in a series of CSS properties.
				// Returns a value in milliseconds.
				var parseProperties = function (el, properties) {
					var duration = 0;

					for (var i = 0; i < properties.length; i++) {
						// Get raw CSS value
						var value = el.css(properties[i]);
						if (!value) continue;

						// Multiple transitions--pick the longest
						if (value.indexOf(",") !== -1) {
							var values = value.split(",");
							var durations = (function () {
								var results = [];
								for (var i = 0; i < values.length; i++) {
									var duration = parseTime(values[i]);
									results.push(duration);
								}
								return results;
							})();

							duration = Math.max.apply(Math, durations);
						}

						// Single transition
						else {
							duration = parseTime(value);
						}

						// Accept first vaue
						break;
					}

					return duration;
				};

				$.event.special.trend = {
					// Triggers an event handler when an element is done transitioning.
					//
					// Handles browsers that don't support transitionend by adding a
					// timeout with the transition duration.
					add: function (handleObj) {
						var el = $(this);
						var fired = false;

						// Mark element as being in transition
						el.data("trend", true);

						// Calculate a fallback duration. + 20 because some browsers fire
						// timeouts faster than transitionend.
						var time =
							parseProperties(el, transitionDurationProperties) +
							parseProperties(el, transitionDelayProperties) +
							20;

						var cb = function (e) {
							// transitionend events can be sent for each property. Let's just
							// skip all but the first. Also handles the timeout callback.
							if (fired) return;

							// Child elements that also have transitions can be fired before we
							// complete. This will catch and ignore those. Unfortunately, we'll
							// have to rely on the timeout in these cases.
							if (e && e.srcElement !== el[0]) return;

							// Mark element has not being in transition
							el.data("trend", false);

							// Callback
							fired = true;
							if (handleObj.handler) handleObj.handler();
						};

						el.one(transitionEndEvents, cb);
						el.data("trend-timeout", window.setTimeout(cb, time));
					},

					remove: function (handleObj) {
						var el = $(this);
						el.off(transitionEndEvents);
						window.clearTimeout(el.data("trend-timeout"));
					},
				};
			})(jQuery);

			/***/
		},

		/***/ 755: /***/ function (module, exports) {
			var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
			/*!
			 * jQuery JavaScript Library v3.5.1
			 * https://jquery.com/
			 *
			 * Includes Sizzle.js
			 * https://sizzlejs.com/
			 *
			 * Copyright JS Foundation and other contributors
			 * Released under the MIT license
			 * https://jquery.org/license
			 *
			 * Date: 2020-05-04T22:49Z
			 */
			(function (global, factory) {
				"use strict";

				if (true && typeof module.exports === "object") {
					// For CommonJS and CommonJS-like environments where a proper `window`
					// is present, execute the factory and get jQuery.
					// For environments that do not have a `window` with a `document`
					// (such as Node.js), expose a factory as module.exports.
					// This accentuates the need for the creation of a real `window`.
					// e.g. var jQuery = require("jquery")(window);
					// See ticket #14549 for more info.
					module.exports = global.document
						? factory(global, true)
						: function (w) {
								if (!w.document) {
									throw new Error("jQuery requires a window with a document");
								}
								return factory(w);
						  };
				} else {
					factory(global);
				}

				// Pass this if window is not defined yet
			})(
				typeof window !== "undefined" ? window : this,
				function (window, noGlobal) {
					// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
					// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
					// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
					// enough that all such attempts are guarded in a try block.
					"use strict";

					var arr = [];

					var getProto = Object.getPrototypeOf;

					var slice = arr.slice;

					var flat = arr.flat
						? function (array) {
								return arr.flat.call(array);
						  }
						: function (array) {
								return arr.concat.apply([], array);
						  };

					var push = arr.push;

					var indexOf = arr.indexOf;

					var class2type = {};

					var toString = class2type.toString;

					var hasOwn = class2type.hasOwnProperty;

					var fnToString = hasOwn.toString;

					var ObjectFunctionString = fnToString.call(Object);

					var support = {};

					var isFunction = function isFunction(obj) {
						// Support: Chrome <=57, Firefox <=52
						// In some browsers, typeof returns "function" for HTML <object> elements
						// (i.e., `typeof document.createElement( "object" ) === "function"`).
						// We don't want to classify *any* DOM node as a function.
						return (
							typeof obj === "function" && typeof obj.nodeType !== "number"
						);
					};

					var isWindow = function isWindow(obj) {
						return obj != null && obj === obj.window;
					};

					var document = window.document;

					var preservedScriptAttributes = {
						type: true,
						src: true,
						nonce: true,
						noModule: true,
					};

					function DOMEval(code, node, doc) {
						doc = doc || document;

						var i,
							val,
							script = doc.createElement("script");

						script.text = code;
						if (node) {
							for (i in preservedScriptAttributes) {
								// Support: Firefox 64+, Edge 18+
								// Some browsers don't support the "nonce" property on scripts.
								// On the other hand, just using `getAttribute` is not enough as
								// the `nonce` attribute is reset to an empty string whenever it
								// becomes browsing-context connected.
								// See https://github.com/whatwg/html/issues/2369
								// See https://html.spec.whatwg.org/#nonce-attributes
								// The `node.getAttribute` check was added for the sake of
								// `jQuery.globalEval` so that it can fake a nonce-containing node
								// via an object.
								val = node[i] || (node.getAttribute && node.getAttribute(i));
								if (val) {
									script.setAttribute(i, val);
								}
							}
						}
						doc.head.appendChild(script).parentNode.removeChild(script);
					}

					function toType(obj) {
						if (obj == null) {
							return obj + "";
						}

						// Support: Android <=2.3 only (functionish RegExp)
						return typeof obj === "object" || typeof obj === "function"
							? class2type[toString.call(obj)] || "object"
							: typeof obj;
					}
					/* global Symbol */
					// Defining this global in .eslintrc.json would create a danger of using the global
					// unguarded in another place, it seems safer to define global only for this module

					var version = "3.5.1",
						// Define a local copy of jQuery
						jQuery = function (selector, context) {
							// The jQuery object is actually just the init constructor 'enhanced'
							// Need init if jQuery is called (just allow error to be thrown if not included)
							return new jQuery.fn.init(selector, context);
						};

					jQuery.fn = jQuery.prototype = {
						// The current version of jQuery being used
						jquery: version,

						constructor: jQuery,

						// The default length of a jQuery object is 0
						length: 0,

						toArray: function () {
							return slice.call(this);
						},

						// Get the Nth element in the matched element set OR
						// Get the whole matched element set as a clean array
						get: function (num) {
							// Return all the elements in a clean array
							if (num == null) {
								return slice.call(this);
							}

							// Return just the one element from the set
							return num < 0 ? this[num + this.length] : this[num];
						},

						// Take an array of elements and push it onto the stack
						// (returning the new matched element set)
						pushStack: function (elems) {
							// Build a new jQuery matched element set
							var ret = jQuery.merge(this.constructor(), elems);

							// Add the old object onto the stack (as a reference)
							ret.prevObject = this;

							// Return the newly-formed element set
							return ret;
						},

						// Execute a callback for every element in the matched set.
						each: function (callback) {
							return jQuery.each(this, callback);
						},

						map: function (callback) {
							return this.pushStack(
								jQuery.map(this, function (elem, i) {
									return callback.call(elem, i, elem);
								})
							);
						},

						slice: function () {
							return this.pushStack(slice.apply(this, arguments));
						},

						first: function () {
							return this.eq(0);
						},

						last: function () {
							return this.eq(-1);
						},

						even: function () {
							return this.pushStack(
								jQuery.grep(this, function (_elem, i) {
									return (i + 1) % 2;
								})
							);
						},

						odd: function () {
							return this.pushStack(
								jQuery.grep(this, function (_elem, i) {
									return i % 2;
								})
							);
						},

						eq: function (i) {
							var len = this.length,
								j = +i + (i < 0 ? len : 0);
							return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
						},

						end: function () {
							return this.prevObject || this.constructor();
						},

						// For internal use only.
						// Behaves like an Array's method, not like a jQuery method.
						push: push,
						sort: arr.sort,
						splice: arr.splice,
					};

					jQuery.extend = jQuery.fn.extend = function () {
						var options,
							name,
							src,
							copy,
							copyIsArray,
							clone,
							target = arguments[0] || {},
							i = 1,
							length = arguments.length,
							deep = false;

						// Handle a deep copy situation
						if (typeof target === "boolean") {
							deep = target;

							// Skip the boolean and the target
							target = arguments[i] || {};
							i++;
						}

						// Handle case when target is a string or something (possible in deep copy)
						if (typeof target !== "object" && !isFunction(target)) {
							target = {};
						}

						// Extend jQuery itself if only one argument is passed
						if (i === length) {
							target = this;
							i--;
						}

						for (; i < length; i++) {
							// Only deal with non-null/undefined values
							if ((options = arguments[i]) != null) {
								// Extend the base object
								for (name in options) {
									copy = options[name];

									// Prevent Object.prototype pollution
									// Prevent never-ending loop
									if (name === "__proto__" || target === copy) {
										continue;
									}

									// Recurse if we're merging plain objects or arrays
									if (
										deep &&
										copy &&
										(jQuery.isPlainObject(copy) ||
											(copyIsArray = Array.isArray(copy)))
									) {
										src = target[name];

										// Ensure proper type for the source value
										if (copyIsArray && !Array.isArray(src)) {
											clone = [];
										} else if (!copyIsArray && !jQuery.isPlainObject(src)) {
											clone = {};
										} else {
											clone = src;
										}
										copyIsArray = false;

										// Never move original objects, clone them
										target[name] = jQuery.extend(deep, clone, copy);

										// Don't bring in undefined values
									} else if (copy !== undefined) {
										target[name] = copy;
									}
								}
							}
						}

						// Return the modified object
						return target;
					};

					jQuery.extend({
						// Unique for each copy of jQuery on the page
						expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),

						// Assume jQuery is ready without the ready module
						isReady: true,

						error: function (msg) {
							throw new Error(msg);
						},

						noop: function () {},

						isPlainObject: function (obj) {
							var proto, Ctor;

							// Detect obvious negatives
							// Use toString instead of jQuery.type to catch host objects
							if (!obj || toString.call(obj) !== "[object Object]") {
								return false;
							}

							proto = getProto(obj);

							// Objects with no prototype (e.g., `Object.create( null )`) are plain
							if (!proto) {
								return true;
							}

							// Objects with prototype are plain iff they were constructed by a global Object function
							Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
							return (
								typeof Ctor === "function" &&
								fnToString.call(Ctor) === ObjectFunctionString
							);
						},

						isEmptyObject: function (obj) {
							var name;

							for (name in obj) {
								return false;
							}
							return true;
						},

						// Evaluates a script in a provided context; falls back to the global one
						// if not specified.
						globalEval: function (code, options, doc) {
							DOMEval(code, { nonce: options && options.nonce }, doc);
						},

						each: function (obj, callback) {
							var length,
								i = 0;

							if (isArrayLike(obj)) {
								length = obj.length;
								for (; i < length; i++) {
									if (callback.call(obj[i], i, obj[i]) === false) {
										break;
									}
								}
							} else {
								for (i in obj) {
									if (callback.call(obj[i], i, obj[i]) === false) {
										break;
									}
								}
							}

							return obj;
						},

						// results is for internal usage only
						makeArray: function (arr, results) {
							var ret = results || [];

							if (arr != null) {
								if (isArrayLike(Object(arr))) {
									jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
								} else {
									push.call(ret, arr);
								}
							}

							return ret;
						},

						inArray: function (elem, arr, i) {
							return arr == null ? -1 : indexOf.call(arr, elem, i);
						},

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						merge: function (first, second) {
							var len = +second.length,
								j = 0,
								i = first.length;

							for (; j < len; j++) {
								first[i++] = second[j];
							}

							first.length = i;

							return first;
						},

						grep: function (elems, callback, invert) {
							var callbackInverse,
								matches = [],
								i = 0,
								length = elems.length,
								callbackExpect = !invert;

							// Go through the array, only saving the items
							// that pass the validator function
							for (; i < length; i++) {
								callbackInverse = !callback(elems[i], i);
								if (callbackInverse !== callbackExpect) {
									matches.push(elems[i]);
								}
							}

							return matches;
						},

						// arg is for internal usage only
						map: function (elems, callback, arg) {
							var length,
								value,
								i = 0,
								ret = [];

							// Go through the array, translating each of the items to their new values
							if (isArrayLike(elems)) {
								length = elems.length;
								for (; i < length; i++) {
									value = callback(elems[i], i, arg);

									if (value != null) {
										ret.push(value);
									}
								}

								// Go through every key on the object,
							} else {
								for (i in elems) {
									value = callback(elems[i], i, arg);

									if (value != null) {
										ret.push(value);
									}
								}
							}

							// Flatten any nested arrays
							return flat(ret);
						},

						// A global GUID counter for objects
						guid: 1,

						// jQuery.support is not used in Core but other projects attach their
						// properties to it so it needs to exist.
						support: support,
					});

					if (typeof Symbol === "function") {
						jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
					}

					// Populate the class2type map
					jQuery.each(
						"Boolean Number String Function Array Date RegExp Object Error Symbol".split(
							" "
						),
						function (_i, name) {
							class2type["[object " + name + "]"] = name.toLowerCase();
						}
					);

					function isArrayLike(obj) {
						// Support: real iOS 8.2 only (not reproducible in simulator)
						// `in` check used to prevent JIT error (gh-2145)
						// hasOwn isn't used here due to false negatives
						// regarding Nodelist length in IE
						var length = !!obj && "length" in obj && obj.length,
							type = toType(obj);

						if (isFunction(obj) || isWindow(obj)) {
							return false;
						}

						return (
							type === "array" ||
							length === 0 ||
							(typeof length === "number" && length > 0 && length - 1 in obj)
						);
					}
					var Sizzle =
						/*!
						 * Sizzle CSS Selector Engine v2.3.5
						 * https://sizzlejs.com/
						 *
						 * Copyright JS Foundation and other contributors
						 * Released under the MIT license
						 * https://js.foundation/
						 *
						 * Date: 2020-03-14
						 */
						(function (window) {
							var i,
								support,
								Expr,
								getText,
								isXML,
								tokenize,
								compile,
								select,
								outermostContext,
								sortInput,
								hasDuplicate,
								// Local document vars
								setDocument,
								document,
								docElem,
								documentIsHTML,
								rbuggyQSA,
								rbuggyMatches,
								matches,
								contains,
								// Instance-specific data
								expando = "sizzle" + 1 * new Date(),
								preferredDoc = window.document,
								dirruns = 0,
								done = 0,
								classCache = createCache(),
								tokenCache = createCache(),
								compilerCache = createCache(),
								nonnativeSelectorCache = createCache(),
								sortOrder = function (a, b) {
									if (a === b) {
										hasDuplicate = true;
									}
									return 0;
								},
								// Instance methods
								hasOwn = {}.hasOwnProperty,
								arr = [],
								pop = arr.pop,
								pushNative = arr.push,
								push = arr.push,
								slice = arr.slice,
								// Use a stripped-down indexOf as it's faster than native
								// https://jsperf.com/thor-indexof-vs-for/5
								indexOf = function (list, elem) {
									var i = 0,
										len = list.length;
									for (; i < len; i++) {
										if (list[i] === elem) {
											return i;
										}
									}
									return -1;
								},
								booleans =
									"checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
									"ismap|loop|multiple|open|readonly|required|scoped",
								// Regular expressions

								// http://www.w3.org/TR/css3-selectors/#whitespace
								whitespace = "[\\x20\\t\\r\\n\\f]",
								// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
								identifier =
									"(?:\\\\[\\da-fA-F]{1,6}" +
									whitespace +
									"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
								// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
								attributes =
									"\\[" +
									whitespace +
									"*(" +
									identifier +
									")(?:" +
									whitespace +
									// Operator (capture 2)
									"*([*^$|!~]?=)" +
									whitespace +
									// "Attribute values must be CSS identifiers [capture 5]
									// or strings [capture 3 or capture 4]"
									"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
									identifier +
									"))|)" +
									whitespace +
									"*\\]",
								pseudos =
									":(" +
									identifier +
									")(?:\\((" +
									// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
									// 1. quoted (capture 3; capture 4 or capture 5)
									"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
									// 2. simple (capture 6)
									"((?:\\\\.|[^\\\\()[\\]]|" +
									attributes +
									")*)|" +
									// 3. anything else (capture 2)
									".*" +
									")\\)|)",
								// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
								rwhitespace = new RegExp(whitespace + "+", "g"),
								rtrim = new RegExp(
									"^" +
										whitespace +
										"+|((?:^|[^\\\\])(?:\\\\.)*)" +
										whitespace +
										"+$",
									"g"
								),
								rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
								rcombinators = new RegExp(
									"^" +
										whitespace +
										"*([>+~]|" +
										whitespace +
										")" +
										whitespace +
										"*"
								),
								rdescend = new RegExp(whitespace + "|>"),
								rpseudo = new RegExp(pseudos),
								ridentifier = new RegExp("^" + identifier + "$"),
								matchExpr = {
									ID: new RegExp("^#(" + identifier + ")"),
									CLASS: new RegExp("^\\.(" + identifier + ")"),
									TAG: new RegExp("^(" + identifier + "|[*])"),
									ATTR: new RegExp("^" + attributes),
									PSEUDO: new RegExp("^" + pseudos),
									CHILD: new RegExp(
										"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
											whitespace +
											"*(even|odd|(([+-]|)(\\d*)n|)" +
											whitespace +
											"*(?:([+-]|)" +
											whitespace +
											"*(\\d+)|))" +
											whitespace +
											"*\\)|)",
										"i"
									),
									bool: new RegExp("^(?:" + booleans + ")$", "i"),

									// For use in libraries implementing .is()
									// We use this for POS matching in `select`
									needsContext: new RegExp(
										"^" +
											whitespace +
											"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
											whitespace +
											"*((?:-\\d)?\\d*)" +
											whitespace +
											"*\\)|)(?=[^-]|$)",
										"i"
									),
								},
								rhtml = /HTML$/i,
								rinputs = /^(?:input|select|textarea|button)$/i,
								rheader = /^h\d$/i,
								rnative = /^[^{]+\{\s*\[native \w/,
								// Easily-parseable/retrievable ID or TAG or CLASS selectors
								rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
								rsibling = /[+~]/,
								// CSS escapes
								// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
								runescape = new RegExp(
									"\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])",
									"g"
								),
								funescape = function (escape, nonHex) {
									var high = "0x" + escape.slice(1) - 0x10000;

									return nonHex
										? // Strip the backslash prefix from a non-hex escape sequence
										  nonHex
										: // Replace a hexadecimal escape sequence with the encoded Unicode code point
										// Support: IE <=11+
										// For values outside the Basic Multilingual Plane (BMP), manually construct a
										// surrogate pair
										high < 0
										? String.fromCharCode(high + 0x10000)
										: String.fromCharCode(
												(high >> 10) | 0xd800,
												(high & 0x3ff) | 0xdc00
										  );
								},
								// CSS string/identifier serialization
								// https://drafts.csswg.org/cssom/#common-serializing-idioms
								rcssescape =
									/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
								fcssescape = function (ch, asCodePoint) {
									if (asCodePoint) {
										// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
										if (ch === "\0") {
											return "\uFFFD";
										}

										// Control characters and (dependent upon position) numbers get escaped as code points
										return (
											ch.slice(0, -1) +
											"\\" +
											ch.charCodeAt(ch.length - 1).toString(16) +
											" "
										);
									}

									// Other potentially-special ASCII characters get backslash-escaped
									return "\\" + ch;
								},
								// Used for iframes
								// See setDocument()
								// Removing the function wrapper causes a "Permission Denied"
								// error in IE
								unloadHandler = function () {
									setDocument();
								},
								inDisabledFieldset = addCombinator(
									function (elem) {
										return (
											elem.disabled === true &&
											elem.nodeName.toLowerCase() === "fieldset"
										);
									},
									{ dir: "parentNode", next: "legend" }
								);

							// Optimize for push.apply( _, NodeList )
							try {
								push.apply(
									(arr = slice.call(preferredDoc.childNodes)),
									preferredDoc.childNodes
								);

								// Support: Android<4.0
								// Detect silently failing push.apply
								// eslint-disable-next-line no-unused-expressions
								arr[preferredDoc.childNodes.length].nodeType;
							} catch (e) {
								push = {
									apply: arr.length
										? // Leverage slice if possible
										  function (target, els) {
												pushNative.apply(target, slice.call(els));
										  }
										: // Support: IE<9
										  // Otherwise append directly
										  function (target, els) {
												var j = target.length,
													i = 0;

												// Can't trust NodeList.length
												while ((target[j++] = els[i++])) {}
												target.length = j - 1;
										  },
								};
							}

							function Sizzle(selector, context, results, seed) {
								var m,
									i,
									elem,
									nid,
									match,
									groups,
									newSelector,
									newContext = context && context.ownerDocument,
									// nodeType defaults to 9, since context defaults to document
									nodeType = context ? context.nodeType : 9;

								results = results || [];

								// Return early from calls with invalid selector or context
								if (
									typeof selector !== "string" ||
									!selector ||
									(nodeType !== 1 && nodeType !== 9 && nodeType !== 11)
								) {
									return results;
								}

								// Try to shortcut find operations (as opposed to filters) in HTML documents
								if (!seed) {
									setDocument(context);
									context = context || document;

									if (documentIsHTML) {
										// If the selector is sufficiently simple, try using a "get*By*" DOM method
										// (excepting DocumentFragment context, where the methods don't exist)
										if (
											nodeType !== 11 &&
											(match = rquickExpr.exec(selector))
										) {
											// ID selector
											if ((m = match[1])) {
												// Document context
												if (nodeType === 9) {
													if ((elem = context.getElementById(m))) {
														// Support: IE, Opera, Webkit
														// TODO: identify versions
														// getElementById can match elements by name instead of ID
														if (elem.id === m) {
															results.push(elem);
															return results;
														}
													} else {
														return results;
													}

													// Element context
												} else {
													// Support: IE, Opera, Webkit
													// TODO: identify versions
													// getElementById can match elements by name instead of ID
													if (
														newContext &&
														(elem = newContext.getElementById(m)) &&
														contains(context, elem) &&
														elem.id === m
													) {
														results.push(elem);
														return results;
													}
												}

												// Type selector
											} else if (match[2]) {
												push.apply(
													results,
													context.getElementsByTagName(selector)
												);
												return results;

												// Class selector
											} else if (
												(m = match[3]) &&
												support.getElementsByClassName &&
												context.getElementsByClassName
											) {
												push.apply(results, context.getElementsByClassName(m));
												return results;
											}
										}

										// Take advantage of querySelectorAll
										if (
											support.qsa &&
											!nonnativeSelectorCache[selector + " "] &&
											(!rbuggyQSA || !rbuggyQSA.test(selector)) &&
											// Support: IE 8 only
											// Exclude object elements
											(nodeType !== 1 ||
												context.nodeName.toLowerCase() !== "object")
										) {
											newSelector = selector;
											newContext = context;

											// qSA considers elements outside a scoping root when evaluating child or
											// descendant combinators, which is not what we want.
											// In such cases, we work around the behavior by prefixing every selector in the
											// list with an ID selector referencing the scope context.
											// The technique has to be used as well when a leading combinator is used
											// as such selectors are not recognized by querySelectorAll.
											// Thanks to Andrew Dupont for this technique.
											if (
												nodeType === 1 &&
												(rdescend.test(selector) || rcombinators.test(selector))
											) {
												// Expand context for sibling selectors
												newContext =
													(rsibling.test(selector) &&
														testContext(context.parentNode)) ||
													context;

												// We can use :scope instead of the ID hack if the browser
												// supports it & if we're not changing the context.
												if (newContext !== context || !support.scope) {
													// Capture the context ID, setting it first if necessary
													if ((nid = context.getAttribute("id"))) {
														nid = nid.replace(rcssescape, fcssescape);
													} else {
														context.setAttribute("id", (nid = expando));
													}
												}

												// Prefix every selector in the list
												groups = tokenize(selector);
												i = groups.length;
												while (i--) {
													groups[i] =
														(nid ? "#" + nid : ":scope") +
														" " +
														toSelector(groups[i]);
												}
												newSelector = groups.join(",");
											}

											try {
												push.apply(
													results,
													newContext.querySelectorAll(newSelector)
												);
												return results;
											} catch (qsaError) {
												nonnativeSelectorCache(selector, true);
											} finally {
												if (nid === expando) {
													context.removeAttribute("id");
												}
											}
										}
									}
								}

								// All others
								return select(
									selector.replace(rtrim, "$1"),
									context,
									results,
									seed
								);
							}

							/**
							 * Create key-value caches of limited size
							 * @returns {function(string, object)} Returns the Object data after storing it on itself with
							 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
							 *	deleting the oldest entry
							 */
							function createCache() {
								var keys = [];

								function cache(key, value) {
									// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
									if (keys.push(key + " ") > Expr.cacheLength) {
										// Only keep the most recent entries
										delete cache[keys.shift()];
									}
									return (cache[key + " "] = value);
								}
								return cache;
							}

							/**
							 * Mark a function for special use by Sizzle
							 * @param {Function} fn The function to mark
							 */
							function markFunction(fn) {
								fn[expando] = true;
								return fn;
							}

							/**
							 * Support testing using an element
							 * @param {Function} fn Passed the created element and returns a boolean result
							 */
							function assert(fn) {
								var el = document.createElement("fieldset");

								try {
									return !!fn(el);
								} catch (e) {
									return false;
								} finally {
									// Remove from its parent by default
									if (el.parentNode) {
										el.parentNode.removeChild(el);
									}

									// release memory in IE
									el = null;
								}
							}

							/**
							 * Adds the same handler for all of the specified attrs
							 * @param {String} attrs Pipe-separated list of attributes
							 * @param {Function} handler The method that will be applied
							 */
							function addHandle(attrs, handler) {
								var arr = attrs.split("|"),
									i = arr.length;

								while (i--) {
									Expr.attrHandle[arr[i]] = handler;
								}
							}

							/**
							 * Checks document order of two siblings
							 * @param {Element} a
							 * @param {Element} b
							 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
							 */
							function siblingCheck(a, b) {
								var cur = b && a,
									diff =
										cur &&
										a.nodeType === 1 &&
										b.nodeType === 1 &&
										a.sourceIndex - b.sourceIndex;

								// Use IE sourceIndex if available on both nodes
								if (diff) {
									return diff;
								}

								// Check if b follows a
								if (cur) {
									while ((cur = cur.nextSibling)) {
										if (cur === b) {
											return -1;
										}
									}
								}

								return a ? 1 : -1;
							}

							/**
							 * Returns a function to use in pseudos for input types
							 * @param {String} type
							 */
							function createInputPseudo(type) {
								return function (elem) {
									var name = elem.nodeName.toLowerCase();
									return name === "input" && elem.type === type;
								};
							}

							/**
							 * Returns a function to use in pseudos for buttons
							 * @param {String} type
							 */
							function createButtonPseudo(type) {
								return function (elem) {
									var name = elem.nodeName.toLowerCase();
									return (
										(name === "input" || name === "button") &&
										elem.type === type
									);
								};
							}

							/**
							 * Returns a function to use in pseudos for :enabled/:disabled
							 * @param {Boolean} disabled true for :disabled; false for :enabled
							 */
							function createDisabledPseudo(disabled) {
								// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
								return function (elem) {
									// Only certain elements can match :enabled or :disabled
									// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
									// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
									if ("form" in elem) {
										// Check for inherited disabledness on relevant non-disabled elements:
										// * listed form-associated elements in a disabled fieldset
										//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
										//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
										// * option elements in a disabled optgroup
										//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
										// All such elements have a "form" property.
										if (elem.parentNode && elem.disabled === false) {
											// Option elements defer to a parent optgroup if present
											if ("label" in elem) {
												if ("label" in elem.parentNode) {
													return elem.parentNode.disabled === disabled;
												} else {
													return elem.disabled === disabled;
												}
											}

											// Support: IE 6 - 11
											// Use the isDisabled shortcut property to check for disabled fieldset ancestors
											return (
												elem.isDisabled === disabled ||
												// Where there is no isDisabled, check manually
												/* jshint -W018 */
												(elem.isDisabled !== !disabled &&
													inDisabledFieldset(elem) === disabled)
											);
										}

										return elem.disabled === disabled;

										// Try to winnow out elements that can't be disabled before trusting the disabled property.
										// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
										// even exist on them, let alone have a boolean value.
									} else if ("label" in elem) {
										return elem.disabled === disabled;
									}

									// Remaining elements are neither :enabled nor :disabled
									return false;
								};
							}

							/**
							 * Returns a function to use in pseudos for positionals
							 * @param {Function} fn
							 */
							function createPositionalPseudo(fn) {
								return markFunction(function (argument) {
									argument = +argument;
									return markFunction(function (seed, matches) {
										var j,
											matchIndexes = fn([], seed.length, argument),
											i = matchIndexes.length;

										// Match elements found at the specified indexes
										while (i--) {
											if (seed[(j = matchIndexes[i])]) {
												seed[j] = !(matches[j] = seed[j]);
											}
										}
									});
								});
							}

							/**
							 * Checks a node for validity as a Sizzle context
							 * @param {Element|Object=} context
							 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
							 */
							function testContext(context) {
								return (
									context &&
									typeof context.getElementsByTagName !== "undefined" &&
									context
								);
							}

							// Expose support vars for convenience
							support = Sizzle.support = {};

							/**
							 * Detects XML nodes
							 * @param {Element|Object} elem An element or a document
							 * @returns {Boolean} True iff elem is a non-HTML XML node
							 */
							isXML = Sizzle.isXML = function (elem) {
								var namespace = elem.namespaceURI,
									docElem = (elem.ownerDocument || elem).documentElement;

								// Support: IE <=8
								// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
								// https://bugs.jquery.com/ticket/4833
								return !rhtml.test(
									namespace || (docElem && docElem.nodeName) || "HTML"
								);
							};

							/**
							 * Sets document-related variables once based on the current document
							 * @param {Element|Object} [doc] An element or document object to use to set the document
							 * @returns {Object} Returns the current document
							 */
							setDocument = Sizzle.setDocument = function (node) {
								var hasCompare,
									subWindow,
									doc = node ? node.ownerDocument || node : preferredDoc;

								// Return early if doc is invalid or already selected
								// Support: IE 11+, Edge 17 - 18+
								// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
								// two documents; shallow comparisons work.
								// eslint-disable-next-line eqeqeq
								if (
									doc == document ||
									doc.nodeType !== 9 ||
									!doc.documentElement
								) {
									return document;
								}

								// Update global variables
								document = doc;
								docElem = document.documentElement;
								documentIsHTML = !isXML(document);

								// Support: IE 9 - 11+, Edge 12 - 18+
								// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
								// Support: IE 11+, Edge 17 - 18+
								// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
								// two documents; shallow comparisons work.
								// eslint-disable-next-line eqeqeq
								if (
									preferredDoc != document &&
									(subWindow = document.defaultView) &&
									subWindow.top !== subWindow
								) {
									// Support: IE 11, Edge
									if (subWindow.addEventListener) {
										subWindow.addEventListener("unload", unloadHandler, false);

										// Support: IE 9 - 10 only
									} else if (subWindow.attachEvent) {
										subWindow.attachEvent("onunload", unloadHandler);
									}
								}

								// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
								// Safari 4 - 5 only, Opera <=11.6 - 12.x only
								// IE/Edge & older browsers don't support the :scope pseudo-class.
								// Support: Safari 6.0 only
								// Safari 6.0 supports :scope but it's an alias of :root there.
								support.scope = assert(function (el) {
									docElem
										.appendChild(el)
										.appendChild(document.createElement("div"));
									return (
										typeof el.querySelectorAll !== "undefined" &&
										!el.querySelectorAll(":scope fieldset div").length
									);
								});

								/* Attributes
                ---------------------------------------------------------------------- */

								// Support: IE<8
								// Verify that getAttribute really returns attributes and not properties
								// (excepting IE8 booleans)
								support.attributes = assert(function (el) {
									el.className = "i";
									return !el.getAttribute("className");
								});

								/* getElement(s)By*
                ---------------------------------------------------------------------- */

								// Check if getElementsByTagName("*") returns only elements
								support.getElementsByTagName = assert(function (el) {
									el.appendChild(document.createComment(""));
									return !el.getElementsByTagName("*").length;
								});

								// Support: IE<9
								support.getElementsByClassName = rnative.test(
									document.getElementsByClassName
								);

								// Support: IE<10
								// Check if getElementById returns elements by name
								// The broken getElementById methods don't pick up programmatically-set names,
								// so use a roundabout getElementsByName test
								support.getById = assert(function (el) {
									docElem.appendChild(el).id = expando;
									return (
										!document.getElementsByName ||
										!document.getElementsByName(expando).length
									);
								});

								// ID filter and find
								if (support.getById) {
									Expr.filter["ID"] = function (id) {
										var attrId = id.replace(runescape, funescape);
										return function (elem) {
											return elem.getAttribute("id") === attrId;
										};
									};
									Expr.find["ID"] = function (id, context) {
										if (
											typeof context.getElementById !== "undefined" &&
											documentIsHTML
										) {
											var elem = context.getElementById(id);
											return elem ? [elem] : [];
										}
									};
								} else {
									Expr.filter["ID"] = function (id) {
										var attrId = id.replace(runescape, funescape);
										return function (elem) {
											var node =
												typeof elem.getAttributeNode !== "undefined" &&
												elem.getAttributeNode("id");
											return node && node.value === attrId;
										};
									};

									// Support: IE 6 - 7 only
									// getElementById is not reliable as a find shortcut
									Expr.find["ID"] = function (id, context) {
										if (
											typeof context.getElementById !== "undefined" &&
											documentIsHTML
										) {
											var node,
												i,
												elems,
												elem = context.getElementById(id);

											if (elem) {
												// Verify the id attribute
												node = elem.getAttributeNode("id");
												if (node && node.value === id) {
													return [elem];
												}

												// Fall back on getElementsByName
												elems = context.getElementsByName(id);
												i = 0;
												while ((elem = elems[i++])) {
													node = elem.getAttributeNode("id");
													if (node && node.value === id) {
														return [elem];
													}
												}
											}

											return [];
										}
									};
								}

								// Tag
								Expr.find["TAG"] = support.getElementsByTagName
									? function (tag, context) {
											if (typeof context.getElementsByTagName !== "undefined") {
												return context.getElementsByTagName(tag);

												// DocumentFragment nodes don't have gEBTN
											} else if (support.qsa) {
												return context.querySelectorAll(tag);
											}
									  }
									: function (tag, context) {
											var elem,
												tmp = [],
												i = 0,
												// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
												results = context.getElementsByTagName(tag);

											// Filter out possible comments
											if (tag === "*") {
												while ((elem = results[i++])) {
													if (elem.nodeType === 1) {
														tmp.push(elem);
													}
												}

												return tmp;
											}
											return results;
									  };

								// Class
								Expr.find["CLASS"] =
									support.getElementsByClassName &&
									function (className, context) {
										if (
											typeof context.getElementsByClassName !== "undefined" &&
											documentIsHTML
										) {
											return context.getElementsByClassName(className);
										}
									};

								/* QSA/matchesSelector
                ---------------------------------------------------------------------- */

								// QSA and matchesSelector support

								// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
								rbuggyMatches = [];

								// qSa(:focus) reports false when true (Chrome 21)
								// We allow this because of a bug in IE8/9 that throws an error
								// whenever `document.activeElement` is accessed on an iframe
								// So, we allow :focus to pass through QSA all the time to avoid the IE error
								// See https://bugs.jquery.com/ticket/13378
								rbuggyQSA = [];

								if ((support.qsa = rnative.test(document.querySelectorAll))) {
									// Build QSA regex
									// Regex strategy adopted from Diego Perini
									assert(function (el) {
										var input;

										// Select is set to empty string on purpose
										// This is to test IE's treatment of not explicitly
										// setting a boolean content attribute,
										// since its presence should be enough
										// https://bugs.jquery.com/ticket/12359
										docElem.appendChild(el).innerHTML =
											"<a id='" +
											expando +
											"'></a>" +
											"<select id='" +
											expando +
											"-\r\\' msallowcapture=''>" +
											"<option selected=''></option></select>";

										// Support: IE8, Opera 11-12.16
										// Nothing should be selected when empty strings follow ^= or $= or *=
										// The test attribute must be unknown in Opera but "safe" for WinRT
										// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
										if (el.querySelectorAll("[msallowcapture^='']").length) {
											rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
										}

										// Support: IE8
										// Boolean attributes and "value" are not treated correctly
										if (!el.querySelectorAll("[selected]").length) {
											rbuggyQSA.push(
												"\\[" + whitespace + "*(?:value|" + booleans + ")"
											);
										}

										// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
										if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
											rbuggyQSA.push("~=");
										}

										// Support: IE 11+, Edge 15 - 18+
										// IE 11/Edge don't find elements on a `[name='']` query in some cases.
										// Adding a temporary attribute to the document before the selection works
										// around the issue.
										// Interestingly, IE 10 & older don't seem to have the issue.
										input = document.createElement("input");
										input.setAttribute("name", "");
										el.appendChild(input);
										if (!el.querySelectorAll("[name='']").length) {
											rbuggyQSA.push(
												"\\[" +
													whitespace +
													"*name" +
													whitespace +
													"*=" +
													whitespace +
													"*(?:''|\"\")"
											);
										}

										// Webkit/Opera - :checked should return selected option elements
										// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
										// IE8 throws error here and will not see later tests
										if (!el.querySelectorAll(":checked").length) {
											rbuggyQSA.push(":checked");
										}

										// Support: Safari 8+, iOS 8+
										// https://bugs.webkit.org/show_bug.cgi?id=136851
										// In-page `selector#id sibling-combinator selector` fails
										if (!el.querySelectorAll("a#" + expando + "+*").length) {
											rbuggyQSA.push(".#.+[+~]");
										}

										// Support: Firefox <=3.6 - 5 only
										// Old Firefox doesn't throw on a badly-escaped identifier.
										el.querySelectorAll("\\\f");
										rbuggyQSA.push("[\\r\\n\\f]");
									});

									assert(function (el) {
										el.innerHTML =
											"<a href='' disabled='disabled'></a>" +
											"<select disabled='disabled'><option/></select>";

										// Support: Windows 8 Native Apps
										// The type and name attributes are restricted during .innerHTML assignment
										var input = document.createElement("input");
										input.setAttribute("type", "hidden");
										el.appendChild(input).setAttribute("name", "D");

										// Support: IE8
										// Enforce case-sensitivity of name attribute
										if (el.querySelectorAll("[name=d]").length) {
											rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
										}

										// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
										// IE8 throws error here and will not see later tests
										if (el.querySelectorAll(":enabled").length !== 2) {
											rbuggyQSA.push(":enabled", ":disabled");
										}

										// Support: IE9-11+
										// IE's :disabled selector does not pick up the children of disabled fieldsets
										docElem.appendChild(el).disabled = true;
										if (el.querySelectorAll(":disabled").length !== 2) {
											rbuggyQSA.push(":enabled", ":disabled");
										}

										// Support: Opera 10 - 11 only
										// Opera 10-11 does not throw on post-comma invalid pseudos
										el.querySelectorAll("*,:x");
										rbuggyQSA.push(",.*:");
									});
								}

								if (
									(support.matchesSelector = rnative.test(
										(matches =
											docElem.matches ||
											docElem.webkitMatchesSelector ||
											docElem.mozMatchesSelector ||
											docElem.oMatchesSelector ||
											docElem.msMatchesSelector)
									))
								) {
									assert(function (el) {
										// Check to see if it's possible to do matchesSelector
										// on a disconnected node (IE 9)
										support.disconnectedMatch = matches.call(el, "*");

										// This should fail with an exception
										// Gecko does not error, returns false instead
										matches.call(el, "[s!='']:x");
										rbuggyMatches.push("!=", pseudos);
									});
								}

								rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
								rbuggyMatches =
									rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));

								/* Contains
                ---------------------------------------------------------------------- */
								hasCompare = rnative.test(docElem.compareDocumentPosition);

								// Element contains another
								// Purposefully self-exclusive
								// As in, an element does not contain itself
								contains =
									hasCompare || rnative.test(docElem.contains)
										? function (a, b) {
												var adown = a.nodeType === 9 ? a.documentElement : a,
													bup = b && b.parentNode;
												return (
													a === bup ||
													!!(
														bup &&
														bup.nodeType === 1 &&
														(adown.contains
															? adown.contains(bup)
															: a.compareDocumentPosition &&
															  a.compareDocumentPosition(bup) & 16)
													)
												);
										  }
										: function (a, b) {
												if (b) {
													while ((b = b.parentNode)) {
														if (b === a) {
															return true;
														}
													}
												}
												return false;
										  };

								/* Sorting
                ---------------------------------------------------------------------- */

								// Document order sorting
								sortOrder = hasCompare
									? function (a, b) {
											// Flag for duplicate removal
											if (a === b) {
												hasDuplicate = true;
												return 0;
											}

											// Sort on method existence if only one input has compareDocumentPosition
											var compare =
												!a.compareDocumentPosition - !b.compareDocumentPosition;
											if (compare) {
												return compare;
											}

											// Calculate position if both inputs belong to the same document
											// Support: IE 11+, Edge 17 - 18+
											// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
											// two documents; shallow comparisons work.
											// eslint-disable-next-line eqeqeq
											compare =
												(a.ownerDocument || a) == (b.ownerDocument || b)
													? a.compareDocumentPosition(b)
													: // Otherwise we know they are disconnected
													  1;

											// Disconnected nodes
											if (
												compare & 1 ||
												(!support.sortDetached &&
													b.compareDocumentPosition(a) === compare)
											) {
												// Choose the first element that is related to our preferred document
												// Support: IE 11+, Edge 17 - 18+
												// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
												// two documents; shallow comparisons work.
												// eslint-disable-next-line eqeqeq
												if (
													a == document ||
													(a.ownerDocument == preferredDoc &&
														contains(preferredDoc, a))
												) {
													return -1;
												}

												// Support: IE 11+, Edge 17 - 18+
												// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
												// two documents; shallow comparisons work.
												// eslint-disable-next-line eqeqeq
												if (
													b == document ||
													(b.ownerDocument == preferredDoc &&
														contains(preferredDoc, b))
												) {
													return 1;
												}

												// Maintain original order
												return sortInput
													? indexOf(sortInput, a) - indexOf(sortInput, b)
													: 0;
											}

											return compare & 4 ? -1 : 1;
									  }
									: function (a, b) {
											// Exit early if the nodes are identical
											if (a === b) {
												hasDuplicate = true;
												return 0;
											}

											var cur,
												i = 0,
												aup = a.parentNode,
												bup = b.parentNode,
												ap = [a],
												bp = [b];

											// Parentless nodes are either documents or disconnected
											if (!aup || !bup) {
												// Support: IE 11+, Edge 17 - 18+
												// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
												// two documents; shallow comparisons work.
												/* eslint-disable eqeqeq */
												return a == document
													? -1
													: b == document
													? 1
													: /* eslint-enable eqeqeq */
													aup
													? -1
													: bup
													? 1
													: sortInput
													? indexOf(sortInput, a) - indexOf(sortInput, b)
													: 0;

												// If the nodes are siblings, we can do a quick check
											} else if (aup === bup) {
												return siblingCheck(a, b);
											}

											// Otherwise we need full lists of their ancestors for comparison
											cur = a;
											while ((cur = cur.parentNode)) {
												ap.unshift(cur);
											}
											cur = b;
											while ((cur = cur.parentNode)) {
												bp.unshift(cur);
											}

											// Walk down the tree looking for a discrepancy
											while (ap[i] === bp[i]) {
												i++;
											}

											return i
												? // Do a sibling check if the nodes have a common ancestor
												  siblingCheck(ap[i], bp[i])
												: // Otherwise nodes in our document sort first
												// Support: IE 11+, Edge 17 - 18+
												// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
												// two documents; shallow comparisons work.
												/* eslint-disable eqeqeq */
												ap[i] == preferredDoc
												? -1
												: bp[i] == preferredDoc
												? 1
												: /* eslint-enable eqeqeq */
												  0;
									  };

								return document;
							};

							Sizzle.matches = function (expr, elements) {
								return Sizzle(expr, null, null, elements);
							};

							Sizzle.matchesSelector = function (elem, expr) {
								setDocument(elem);

								if (
									support.matchesSelector &&
									documentIsHTML &&
									!nonnativeSelectorCache[expr + " "] &&
									(!rbuggyMatches || !rbuggyMatches.test(expr)) &&
									(!rbuggyQSA || !rbuggyQSA.test(expr))
								) {
									try {
										var ret = matches.call(elem, expr);

										// IE 9's matchesSelector returns false on disconnected nodes
										if (
											ret ||
											support.disconnectedMatch ||
											// As well, disconnected nodes are said to be in a document
											// fragment in IE 9
											(elem.document && elem.document.nodeType !== 11)
										) {
											return ret;
										}
									} catch (e) {
										nonnativeSelectorCache(expr, true);
									}
								}

								return Sizzle(expr, document, null, [elem]).length > 0;
							};

							Sizzle.contains = function (context, elem) {
								// Set document vars if needed
								// Support: IE 11+, Edge 17 - 18+
								// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
								// two documents; shallow comparisons work.
								// eslint-disable-next-line eqeqeq
								if ((context.ownerDocument || context) != document) {
									setDocument(context);
								}
								return contains(context, elem);
							};

							Sizzle.attr = function (elem, name) {
								// Set document vars if needed
								// Support: IE 11+, Edge 17 - 18+
								// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
								// two documents; shallow comparisons work.
								// eslint-disable-next-line eqeqeq
								if ((elem.ownerDocument || elem) != document) {
									setDocument(elem);
								}

								var fn = Expr.attrHandle[name.toLowerCase()],
									// Don't get fooled by Object.prototype properties (jQuery #13807)
									val =
										fn && hasOwn.call(Expr.attrHandle, name.toLowerCase())
											? fn(elem, name, !documentIsHTML)
											: undefined;

								return val !== undefined
									? val
									: support.attributes || !documentIsHTML
									? elem.getAttribute(name)
									: (val = elem.getAttributeNode(name)) && val.specified
									? val.value
									: null;
							};

							Sizzle.escape = function (sel) {
								return (sel + "").replace(rcssescape, fcssescape);
							};

							Sizzle.error = function (msg) {
								throw new Error(
									"Syntax error, unrecognized expression: " + msg
								);
							};

							/**
							 * Document sorting and removing duplicates
							 * @param {ArrayLike} results
							 */
							Sizzle.uniqueSort = function (results) {
								var elem,
									duplicates = [],
									j = 0,
									i = 0;

								// Unless we *know* we can detect duplicates, assume their presence
								hasDuplicate = !support.detectDuplicates;
								sortInput = !support.sortStable && results.slice(0);
								results.sort(sortOrder);

								if (hasDuplicate) {
									while ((elem = results[i++])) {
										if (elem === results[i]) {
											j = duplicates.push(i);
										}
									}
									while (j--) {
										results.splice(duplicates[j], 1);
									}
								}

								// Clear input after sorting to release objects
								// See https://github.com/jquery/sizzle/pull/225
								sortInput = null;

								return results;
							};

							/**
							 * Utility function for retrieving the text value of an array of DOM nodes
							 * @param {Array|Element} elem
							 */
							getText = Sizzle.getText = function (elem) {
								var node,
									ret = "",
									i = 0,
									nodeType = elem.nodeType;

								if (!nodeType) {
									// If no nodeType, this is expected to be an array
									while ((node = elem[i++])) {
										// Do not traverse comment nodes
										ret += getText(node);
									}
								} else if (
									nodeType === 1 ||
									nodeType === 9 ||
									nodeType === 11
								) {
									// Use textContent for elements
									// innerText usage removed for consistency of new lines (jQuery #11153)
									if (typeof elem.textContent === "string") {
										return elem.textContent;
									} else {
										// Traverse its children
										for (
											elem = elem.firstChild;
											elem;
											elem = elem.nextSibling
										) {
											ret += getText(elem);
										}
									}
								} else if (nodeType === 3 || nodeType === 4) {
									return elem.nodeValue;
								}

								// Do not include comment or processing instruction nodes

								return ret;
							};

							Expr = Sizzle.selectors = {
								// Can be adjusted by the user
								cacheLength: 50,

								createPseudo: markFunction,

								match: matchExpr,

								attrHandle: {},

								find: {},

								relative: {
									">": { dir: "parentNode", first: true },
									" ": { dir: "parentNode" },
									"+": { dir: "previousSibling", first: true },
									"~": { dir: "previousSibling" },
								},

								preFilter: {
									ATTR: function (match) {
										match[1] = match[1].replace(runescape, funescape);

										// Move the given value to match[3] whether quoted or unquoted
										match[3] = (match[3] || match[4] || match[5] || "").replace(
											runescape,
											funescape
										);

										if (match[2] === "~=") {
											match[3] = " " + match[3] + " ";
										}

										return match.slice(0, 4);
									},

									CHILD: function (match) {
										/* matches from matchExpr["CHILD"]
                      1 type (only|nth|...)
                      2 what (child|of-type)
                      3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
                      4 xn-component of xn+y argument ([+-]?\d*n|)
                      5 sign of xn-component
                      6 x of xn-component
                      7 sign of y-component
                      8 y of y-component
                    */
										match[1] = match[1].toLowerCase();

										if (match[1].slice(0, 3) === "nth") {
											// nth-* requires argument
											if (!match[3]) {
												Sizzle.error(match[0]);
											}

											// numeric x and y parameters for Expr.filter.CHILD
											// remember that false/true cast respectively to 0/1
											match[4] = +(match[4]
												? match[5] + (match[6] || 1)
												: 2 * (match[3] === "even" || match[3] === "odd"));
											match[5] = +(match[7] + match[8] || match[3] === "odd");

											// other types prohibit arguments
										} else if (match[3]) {
											Sizzle.error(match[0]);
										}

										return match;
									},

									PSEUDO: function (match) {
										var excess,
											unquoted = !match[6] && match[2];

										if (matchExpr["CHILD"].test(match[0])) {
											return null;
										}

										// Accept quoted arguments as-is
										if (match[3]) {
											match[2] = match[4] || match[5] || "";

											// Strip excess characters from unquoted arguments
										} else if (
											unquoted &&
											rpseudo.test(unquoted) &&
											// Get excess from tokenize (recursively)
											(excess = tokenize(unquoted, true)) &&
											// advance to the next closing parenthesis
											(excess =
												unquoted.indexOf(")", unquoted.length - excess) -
												unquoted.length)
										) {
											// excess is a negative index
											match[0] = match[0].slice(0, excess);
											match[2] = unquoted.slice(0, excess);
										}

										// Return only captures needed by the pseudo filter method (type and argument)
										return match.slice(0, 3);
									},
								},

								filter: {
									TAG: function (nodeNameSelector) {
										var nodeName = nodeNameSelector
											.replace(runescape, funescape)
											.toLowerCase();
										return nodeNameSelector === "*"
											? function () {
													return true;
											  }
											: function (elem) {
													return (
														elem.nodeName &&
														elem.nodeName.toLowerCase() === nodeName
													);
											  };
									},

									CLASS: function (className) {
										var pattern = classCache[className + " "];

										return (
											pattern ||
											((pattern = new RegExp(
												"(^|" +
													whitespace +
													")" +
													className +
													"(" +
													whitespace +
													"|$)"
											)) &&
												classCache(className, function (elem) {
													return pattern.test(
														(typeof elem.className === "string" &&
															elem.className) ||
															(typeof elem.getAttribute !== "undefined" &&
																elem.getAttribute("class")) ||
															""
													);
												}))
										);
									},

									ATTR: function (name, operator, check) {
										return function (elem) {
											var result = Sizzle.attr(elem, name);

											if (result == null) {
												return operator === "!=";
											}
											if (!operator) {
												return true;
											}

											result += "";

											/* eslint-disable max-len */

											return operator === "="
												? result === check
												: operator === "!="
												? result !== check
												: operator === "^="
												? check && result.indexOf(check) === 0
												: operator === "*="
												? check && result.indexOf(check) > -1
												: operator === "$="
												? check && result.slice(-check.length) === check
												: operator === "~="
												? (
														" " +
														result.replace(rwhitespace, " ") +
														" "
												  ).indexOf(check) > -1
												: operator === "|="
												? result === check ||
												  result.slice(0, check.length + 1) === check + "-"
												: false;
											/* eslint-enable max-len */
										};
									},

									CHILD: function (type, what, _argument, first, last) {
										var simple = type.slice(0, 3) !== "nth",
											forward = type.slice(-4) !== "last",
											ofType = what === "of-type";

										return first === 1 && last === 0
											? // Shortcut for :nth-*(n)
											  function (elem) {
													return !!elem.parentNode;
											  }
											: function (elem, _context, xml) {
													var cache,
														uniqueCache,
														outerCache,
														node,
														nodeIndex,
														start,
														dir =
															simple !== forward
																? "nextSibling"
																: "previousSibling",
														parent = elem.parentNode,
														name = ofType && elem.nodeName.toLowerCase(),
														useCache = !xml && !ofType,
														diff = false;

													if (parent) {
														// :(first|last|only)-(child|of-type)
														if (simple) {
															while (dir) {
																node = elem;
																while ((node = node[dir])) {
																	if (
																		ofType
																			? node.nodeName.toLowerCase() === name
																			: node.nodeType === 1
																	) {
																		return false;
																	}
																}

																// Reverse direction for :only-* (if we haven't yet done so)
																start = dir =
																	type === "only" && !start && "nextSibling";
															}
															return true;
														}

														start = [
															forward ? parent.firstChild : parent.lastChild,
														];

														// non-xml :nth-child(...) stores cache data on `parent`
														if (forward && useCache) {
															// Seek `elem` from a previously-cached index

															// ...in a gzip-friendly way
															node = parent;
															outerCache =
																node[expando] || (node[expando] = {});

															// Support: IE <9 only
															// Defend against cloned attroperties (jQuery gh-1709)
															uniqueCache =
																outerCache[node.uniqueID] ||
																(outerCache[node.uniqueID] = {});

															cache = uniqueCache[type] || [];
															nodeIndex = cache[0] === dirruns && cache[1];
															diff = nodeIndex && cache[2];
															node = nodeIndex && parent.childNodes[nodeIndex];

															while (
																(node =
																	(++nodeIndex && node && node[dir]) ||
																	// Fallback to seeking `elem` from the start
																	(diff = nodeIndex = 0) ||
																	start.pop())
															) {
																// When found, cache indexes on `parent` and break
																if (
																	node.nodeType === 1 &&
																	++diff &&
																	node === elem
																) {
																	uniqueCache[type] = [
																		dirruns,
																		nodeIndex,
																		diff,
																	];
																	break;
																}
															}
														} else {
															// Use previously-cached element index if available
															if (useCache) {
																// ...in a gzip-friendly way
																node = elem;
																outerCache =
																	node[expando] || (node[expando] = {});

																// Support: IE <9 only
																// Defend against cloned attroperties (jQuery gh-1709)
																uniqueCache =
																	outerCache[node.uniqueID] ||
																	(outerCache[node.uniqueID] = {});

																cache = uniqueCache[type] || [];
																nodeIndex = cache[0] === dirruns && cache[1];
																diff = nodeIndex;
															}

															// xml :nth-child(...)
															// or :nth-last-child(...) or :nth(-last)?-of-type(...)
															if (diff === false) {
																// Use the same loop as above to seek `elem` from the start
																while (
																	(node =
																		(++nodeIndex && node && node[dir]) ||
																		(diff = nodeIndex = 0) ||
																		start.pop())
																) {
																	if (
																		(ofType
																			? node.nodeName.toLowerCase() === name
																			: node.nodeType === 1) &&
																		++diff
																	) {
																		// Cache the index of each encountered element
																		if (useCache) {
																			outerCache =
																				node[expando] || (node[expando] = {});

																			// Support: IE <9 only
																			// Defend against cloned attroperties (jQuery gh-1709)
																			uniqueCache =
																				outerCache[node.uniqueID] ||
																				(outerCache[node.uniqueID] = {});

																			uniqueCache[type] = [dirruns, diff];
																		}

																		if (node === elem) {
																			break;
																		}
																	}
																}
															}
														}

														// Incorporate the offset, then check against cycle size
														diff -= last;
														return (
															diff === first ||
															(diff % first === 0 && diff / first >= 0)
														);
													}
											  };
									},

									PSEUDO: function (pseudo, argument) {
										// pseudo-class names are case-insensitive
										// http://www.w3.org/TR/selectors/#pseudo-classes
										// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
										// Remember that setFilters inherits from pseudos
										var args,
											fn =
												Expr.pseudos[pseudo] ||
												Expr.setFilters[pseudo.toLowerCase()] ||
												Sizzle.error("unsupported pseudo: " + pseudo);

										// The user may use createPseudo to indicate that
										// arguments are needed to create the filter function
										// just as Sizzle does
										if (fn[expando]) {
											return fn(argument);
										}

										// But maintain support for old signatures
										if (fn.length > 1) {
											args = [pseudo, pseudo, "", argument];
											return Expr.setFilters.hasOwnProperty(
												pseudo.toLowerCase()
											)
												? markFunction(function (seed, matches) {
														var idx,
															matched = fn(seed, argument),
															i = matched.length;
														while (i--) {
															idx = indexOf(seed, matched[i]);
															seed[idx] = !(matches[idx] = matched[i]);
														}
												  })
												: function (elem) {
														return fn(elem, 0, args);
												  };
										}

										return fn;
									},
								},

								pseudos: {
									// Potentially complex pseudos
									not: markFunction(function (selector) {
										// Trim the selector passed to compile
										// to avoid treating leading and trailing
										// spaces as combinators
										var input = [],
											results = [],
											matcher = compile(selector.replace(rtrim, "$1"));

										return matcher[expando]
											? markFunction(function (seed, matches, _context, xml) {
													var elem,
														unmatched = matcher(seed, null, xml, []),
														i = seed.length;

													// Match elements unmatched by `matcher`
													while (i--) {
														if ((elem = unmatched[i])) {
															seed[i] = !(matches[i] = elem);
														}
													}
											  })
											: function (elem, _context, xml) {
													input[0] = elem;
													matcher(input, null, xml, results);

													// Don't keep the element (issue #299)
													input[0] = null;
													return !results.pop();
											  };
									}),

									has: markFunction(function (selector) {
										return function (elem) {
											return Sizzle(selector, elem).length > 0;
										};
									}),

									contains: markFunction(function (text) {
										text = text.replace(runescape, funescape);
										return function (elem) {
											return (
												(elem.textContent || getText(elem)).indexOf(text) > -1
											);
										};
									}),

									// "Whether an element is represented by a :lang() selector
									// is based solely on the element's language value
									// being equal to the identifier C,
									// or beginning with the identifier C immediately followed by "-".
									// The matching of C against the element's language value is performed case-insensitively.
									// The identifier C does not have to be a valid language name."
									// http://www.w3.org/TR/selectors/#lang-pseudo
									lang: markFunction(function (lang) {
										// lang value must be a valid identifier
										if (!ridentifier.test(lang || "")) {
											Sizzle.error("unsupported lang: " + lang);
										}
										lang = lang.replace(runescape, funescape).toLowerCase();
										return function (elem) {
											var elemLang;
											do {
												if (
													(elemLang = documentIsHTML
														? elem.lang
														: elem.getAttribute("xml:lang") ||
														  elem.getAttribute("lang"))
												) {
													elemLang = elemLang.toLowerCase();
													return (
														elemLang === lang ||
														elemLang.indexOf(lang + "-") === 0
													);
												}
											} while ((elem = elem.parentNode) && elem.nodeType === 1);
											return false;
										};
									}),

									// Miscellaneous
									target: function (elem) {
										var hash = window.location && window.location.hash;
										return hash && hash.slice(1) === elem.id;
									},

									root: function (elem) {
										return elem === docElem;
									},

									focus: function (elem) {
										return (
											elem === document.activeElement &&
											(!document.hasFocus || document.hasFocus()) &&
											!!(elem.type || elem.href || ~elem.tabIndex)
										);
									},

									// Boolean properties
									enabled: createDisabledPseudo(false),
									disabled: createDisabledPseudo(true),

									checked: function (elem) {
										// In CSS3, :checked should return both checked and selected elements
										// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
										var nodeName = elem.nodeName.toLowerCase();
										return (
											(nodeName === "input" && !!elem.checked) ||
											(nodeName === "option" && !!elem.selected)
										);
									},

									selected: function (elem) {
										// Accessing this property makes selected-by-default
										// options in Safari work properly
										if (elem.parentNode) {
											// eslint-disable-next-line no-unused-expressions
											elem.parentNode.selectedIndex;
										}

										return elem.selected === true;
									},

									// Contents
									empty: function (elem) {
										// http://www.w3.org/TR/selectors/#empty-pseudo
										// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
										//   but not by others (comment: 8; processing instruction: 7; etc.)
										// nodeType < 6 works because attributes (2) do not appear as children
										for (
											elem = elem.firstChild;
											elem;
											elem = elem.nextSibling
										) {
											if (elem.nodeType < 6) {
												return false;
											}
										}
										return true;
									},

									parent: function (elem) {
										return !Expr.pseudos["empty"](elem);
									},

									// Element/input types
									header: function (elem) {
										return rheader.test(elem.nodeName);
									},

									input: function (elem) {
										return rinputs.test(elem.nodeName);
									},

									button: function (elem) {
										var name = elem.nodeName.toLowerCase();
										return (
											(name === "input" && elem.type === "button") ||
											name === "button"
										);
									},

									text: function (elem) {
										var attr;
										return (
											elem.nodeName.toLowerCase() === "input" &&
											elem.type === "text" &&
											// Support: IE<8
											// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
											((attr = elem.getAttribute("type")) == null ||
												attr.toLowerCase() === "text")
										);
									},

									// Position-in-collection
									first: createPositionalPseudo(function () {
										return [0];
									}),

									last: createPositionalPseudo(function (
										_matchIndexes,
										length
									) {
										return [length - 1];
									}),

									eq: createPositionalPseudo(function (
										_matchIndexes,
										length,
										argument
									) {
										return [argument < 0 ? argument + length : argument];
									}),

									even: createPositionalPseudo(function (matchIndexes, length) {
										var i = 0;
										for (; i < length; i += 2) {
											matchIndexes.push(i);
										}
										return matchIndexes;
									}),

									odd: createPositionalPseudo(function (matchIndexes, length) {
										var i = 1;
										for (; i < length; i += 2) {
											matchIndexes.push(i);
										}
										return matchIndexes;
									}),

									lt: createPositionalPseudo(function (
										matchIndexes,
										length,
										argument
									) {
										var i =
											argument < 0
												? argument + length
												: argument > length
												? length
												: argument;
										for (; --i >= 0; ) {
											matchIndexes.push(i);
										}
										return matchIndexes;
									}),

									gt: createPositionalPseudo(function (
										matchIndexes,
										length,
										argument
									) {
										var i = argument < 0 ? argument + length : argument;
										for (; ++i < length; ) {
											matchIndexes.push(i);
										}
										return matchIndexes;
									}),
								},
							};

							Expr.pseudos["nth"] = Expr.pseudos["eq"];

							// Add button/input type pseudos
							for (i in {
								radio: true,
								checkbox: true,
								file: true,
								password: true,
								image: true,
							}) {
								Expr.pseudos[i] = createInputPseudo(i);
							}
							for (i in { submit: true, reset: true }) {
								Expr.pseudos[i] = createButtonPseudo(i);
							}

							// Easy API for creating new setFilters
							function setFilters() {}
							setFilters.prototype = Expr.filters = Expr.pseudos;
							Expr.setFilters = new setFilters();

							tokenize = Sizzle.tokenize = function (selector, parseOnly) {
								var matched,
									match,
									tokens,
									type,
									soFar,
									groups,
									preFilters,
									cached = tokenCache[selector + " "];

								if (cached) {
									return parseOnly ? 0 : cached.slice(0);
								}

								soFar = selector;
								groups = [];
								preFilters = Expr.preFilter;

								while (soFar) {
									// Comma and first run
									if (!matched || (match = rcomma.exec(soFar))) {
										if (match) {
											// Don't consume trailing commas as valid
											soFar = soFar.slice(match[0].length) || soFar;
										}
										groups.push((tokens = []));
									}

									matched = false;

									// Combinators
									if ((match = rcombinators.exec(soFar))) {
										matched = match.shift();
										tokens.push({
											value: matched,

											// Cast descendant combinators to space
											type: match[0].replace(rtrim, " "),
										});
										soFar = soFar.slice(matched.length);
									}

									// Filters
									for (type in Expr.filter) {
										if (
											(match = matchExpr[type].exec(soFar)) &&
											(!preFilters[type] || (match = preFilters[type](match)))
										) {
											matched = match.shift();
											tokens.push({
												value: matched,
												type: type,
												matches: match,
											});
											soFar = soFar.slice(matched.length);
										}
									}

									if (!matched) {
										break;
									}
								}

								// Return the length of the invalid excess
								// if we're just parsing
								// Otherwise, throw an error or return tokens
								return parseOnly
									? soFar.length
									: soFar
									? Sizzle.error(selector)
									: // Cache the tokens
									  tokenCache(selector, groups).slice(0);
							};

							function toSelector(tokens) {
								var i = 0,
									len = tokens.length,
									selector = "";
								for (; i < len; i++) {
									selector += tokens[i].value;
								}
								return selector;
							}

							function addCombinator(matcher, combinator, base) {
								var dir = combinator.dir,
									skip = combinator.next,
									key = skip || dir,
									checkNonElements = base && key === "parentNode",
									doneName = done++;

								return combinator.first
									? // Check against closest ancestor/preceding element
									  function (elem, context, xml) {
											while ((elem = elem[dir])) {
												if (elem.nodeType === 1 || checkNonElements) {
													return matcher(elem, context, xml);
												}
											}
											return false;
									  }
									: // Check against all ancestor/preceding elements
									  function (elem, context, xml) {
											var oldCache,
												uniqueCache,
												outerCache,
												newCache = [dirruns, doneName];

											// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
											if (xml) {
												while ((elem = elem[dir])) {
													if (elem.nodeType === 1 || checkNonElements) {
														if (matcher(elem, context, xml)) {
															return true;
														}
													}
												}
											} else {
												while ((elem = elem[dir])) {
													if (elem.nodeType === 1 || checkNonElements) {
														outerCache = elem[expando] || (elem[expando] = {});

														// Support: IE <9 only
														// Defend against cloned attroperties (jQuery gh-1709)
														uniqueCache =
															outerCache[elem.uniqueID] ||
															(outerCache[elem.uniqueID] = {});

														if (skip && skip === elem.nodeName.toLowerCase()) {
															elem = elem[dir] || elem;
														} else if (
															(oldCache = uniqueCache[key]) &&
															oldCache[0] === dirruns &&
															oldCache[1] === doneName
														) {
															// Assign to newCache so results back-propagate to previous elements
															return (newCache[2] = oldCache[2]);
														} else {
															// Reuse newcache so results back-propagate to previous elements
															uniqueCache[key] = newCache;

															// A match means we're done; a fail means we have to keep checking
															if ((newCache[2] = matcher(elem, context, xml))) {
																return true;
															}
														}
													}
												}
											}
											return false;
									  };
							}

							function elementMatcher(matchers) {
								return matchers.length > 1
									? function (elem, context, xml) {
											var i = matchers.length;
											while (i--) {
												if (!matchers[i](elem, context, xml)) {
													return false;
												}
											}
											return true;
									  }
									: matchers[0];
							}

							function multipleContexts(selector, contexts, results) {
								var i = 0,
									len = contexts.length;
								for (; i < len; i++) {
									Sizzle(selector, contexts[i], results);
								}
								return results;
							}

							function condense(unmatched, map, filter, context, xml) {
								var elem,
									newUnmatched = [],
									i = 0,
									len = unmatched.length,
									mapped = map != null;

								for (; i < len; i++) {
									if ((elem = unmatched[i])) {
										if (!filter || filter(elem, context, xml)) {
											newUnmatched.push(elem);
											if (mapped) {
												map.push(i);
											}
										}
									}
								}

								return newUnmatched;
							}

							function setMatcher(
								preFilter,
								selector,
								matcher,
								postFilter,
								postFinder,
								postSelector
							) {
								if (postFilter && !postFilter[expando]) {
									postFilter = setMatcher(postFilter);
								}
								if (postFinder && !postFinder[expando]) {
									postFinder = setMatcher(postFinder, postSelector);
								}
								return markFunction(function (seed, results, context, xml) {
									var temp,
										i,
										elem,
										preMap = [],
										postMap = [],
										preexisting = results.length,
										// Get initial elements from seed or context
										elems =
											seed ||
											multipleContexts(
												selector || "*",
												context.nodeType ? [context] : context,
												[]
											),
										// Prefilter to get matcher input, preserving a map for seed-results synchronization
										matcherIn =
											preFilter && (seed || !selector)
												? condense(elems, preMap, preFilter, context, xml)
												: elems,
										matcherOut = matcher
											? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
											  postFinder ||
											  (seed ? preFilter : preexisting || postFilter)
												? // ...intermediate processing is necessary
												  []
												: // ...otherwise use results directly
												  results
											: matcherIn;

									// Find primary matches
									if (matcher) {
										matcher(matcherIn, matcherOut, context, xml);
									}

									// Apply postFilter
									if (postFilter) {
										temp = condense(matcherOut, postMap);
										postFilter(temp, [], context, xml);

										// Un-match failing elements by moving them back to matcherIn
										i = temp.length;
										while (i--) {
											if ((elem = temp[i])) {
												matcherOut[postMap[i]] = !(matcherIn[postMap[i]] =
													elem);
											}
										}
									}

									if (seed) {
										if (postFinder || preFilter) {
											if (postFinder) {
												// Get the final matcherOut by condensing this intermediate into postFinder contexts
												temp = [];
												i = matcherOut.length;
												while (i--) {
													if ((elem = matcherOut[i])) {
														// Restore matcherIn since elem is not yet a final match
														temp.push((matcherIn[i] = elem));
													}
												}
												postFinder(null, (matcherOut = []), temp, xml);
											}

											// Move matched elements from seed to results to keep them synchronized
											i = matcherOut.length;
											while (i--) {
												if (
													(elem = matcherOut[i]) &&
													(temp = postFinder
														? indexOf(seed, elem)
														: preMap[i]) > -1
												) {
													seed[temp] = !(results[temp] = elem);
												}
											}
										}

										// Add elements to results, through postFinder if defined
									} else {
										matcherOut = condense(
											matcherOut === results
												? matcherOut.splice(preexisting, matcherOut.length)
												: matcherOut
										);
										if (postFinder) {
											postFinder(null, results, matcherOut, xml);
										} else {
											push.apply(results, matcherOut);
										}
									}
								});
							}

							function matcherFromTokens(tokens) {
								var checkContext,
									matcher,
									j,
									len = tokens.length,
									leadingRelative = Expr.relative[tokens[0].type],
									implicitRelative = leadingRelative || Expr.relative[" "],
									i = leadingRelative ? 1 : 0,
									// The foundational matcher ensures that elements are reachable from top-level context(s)
									matchContext = addCombinator(
										function (elem) {
											return elem === checkContext;
										},
										implicitRelative,
										true
									),
									matchAnyContext = addCombinator(
										function (elem) {
											return indexOf(checkContext, elem) > -1;
										},
										implicitRelative,
										true
									),
									matchers = [
										function (elem, context, xml) {
											var ret =
												(!leadingRelative &&
													(xml || context !== outermostContext)) ||
												((checkContext = context).nodeType
													? matchContext(elem, context, xml)
													: matchAnyContext(elem, context, xml));

											// Avoid hanging onto element (issue #299)
											checkContext = null;
											return ret;
										},
									];

								for (; i < len; i++) {
									if ((matcher = Expr.relative[tokens[i].type])) {
										matchers = [
											addCombinator(elementMatcher(matchers), matcher),
										];
									} else {
										matcher = Expr.filter[tokens[i].type].apply(
											null,
											tokens[i].matches
										);

										// Return special upon seeing a positional matcher
										if (matcher[expando]) {
											// Find the next relative operator (if any) for proper handling
											j = ++i;
											for (; j < len; j++) {
												if (Expr.relative[tokens[j].type]) {
													break;
												}
											}
											return setMatcher(
												i > 1 && elementMatcher(matchers),
												i > 1 &&
													toSelector(
														// If the preceding token was a descendant combinator, insert an implicit any-element `*`
														tokens.slice(0, i - 1).concat({
															value: tokens[i - 2].type === " " ? "*" : "",
														})
													).replace(rtrim, "$1"),
												matcher,
												i < j && matcherFromTokens(tokens.slice(i, j)),
												j < len &&
													matcherFromTokens((tokens = tokens.slice(j))),
												j < len && toSelector(tokens)
											);
										}
										matchers.push(matcher);
									}
								}

								return elementMatcher(matchers);
							}

							function matcherFromGroupMatchers(elementMatchers, setMatchers) {
								var bySet = setMatchers.length > 0,
									byElement = elementMatchers.length > 0,
									superMatcher = function (
										seed,
										context,
										xml,
										results,
										outermost
									) {
										var elem,
											j,
											matcher,
											matchedCount = 0,
											i = "0",
											unmatched = seed && [],
											setMatched = [],
											contextBackup = outermostContext,
											// We must always have either seed elements or outermost context
											elems =
												seed || (byElement && Expr.find["TAG"]("*", outermost)),
											// Use integer dirruns iff this is the outermost matcher
											dirrunsUnique = (dirruns +=
												contextBackup == null ? 1 : Math.random() || 0.1),
											len = elems.length;

										if (outermost) {
											// Support: IE 11+, Edge 17 - 18+
											// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
											// two documents; shallow comparisons work.
											// eslint-disable-next-line eqeqeq
											outermostContext =
												context == document || context || outermost;
										}

										// Add elements passing elementMatchers directly to results
										// Support: IE<9, Safari
										// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
										for (; i !== len && (elem = elems[i]) != null; i++) {
											if (byElement && elem) {
												j = 0;

												// Support: IE 11+, Edge 17 - 18+
												// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
												// two documents; shallow comparisons work.
												// eslint-disable-next-line eqeqeq
												if (!context && elem.ownerDocument != document) {
													setDocument(elem);
													xml = !documentIsHTML;
												}
												while ((matcher = elementMatchers[j++])) {
													if (matcher(elem, context || document, xml)) {
														results.push(elem);
														break;
													}
												}
												if (outermost) {
													dirruns = dirrunsUnique;
												}
											}

											// Track unmatched elements for set filters
											if (bySet) {
												// They will have gone through all possible matchers
												if ((elem = !matcher && elem)) {
													matchedCount--;
												}

												// Lengthen the array for every element, matched or not
												if (seed) {
													unmatched.push(elem);
												}
											}
										}

										// `i` is now the count of elements visited above, and adding it to `matchedCount`
										// makes the latter nonnegative.
										matchedCount += i;

										// Apply set filters to unmatched elements
										// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
										// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
										// no element matchers and no seed.
										// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
										// case, which will result in a "00" `matchedCount` that differs from `i` but is also
										// numerically zero.
										if (bySet && i !== matchedCount) {
											j = 0;
											while ((matcher = setMatchers[j++])) {
												matcher(unmatched, setMatched, context, xml);
											}

											if (seed) {
												// Reintegrate element matches to eliminate the need for sorting
												if (matchedCount > 0) {
													while (i--) {
														if (!(unmatched[i] || setMatched[i])) {
															setMatched[i] = pop.call(results);
														}
													}
												}

												// Discard index placeholder values to get only actual matches
												setMatched = condense(setMatched);
											}

											// Add matches to results
											push.apply(results, setMatched);

											// Seedless set matches succeeding multiple successful matchers stipulate sorting
											if (
												outermost &&
												!seed &&
												setMatched.length > 0 &&
												matchedCount + setMatchers.length > 1
											) {
												Sizzle.uniqueSort(results);
											}
										}

										// Override manipulation of globals by nested matchers
										if (outermost) {
											dirruns = dirrunsUnique;
											outermostContext = contextBackup;
										}

										return unmatched;
									};

								return bySet ? markFunction(superMatcher) : superMatcher;
							}

							compile = Sizzle.compile = function (
								selector,
								match /* Internal Use Only */
							) {
								var i,
									setMatchers = [],
									elementMatchers = [],
									cached = compilerCache[selector + " "];

								if (!cached) {
									// Generate a function of recursive functions that can be used to check each element
									if (!match) {
										match = tokenize(selector);
									}
									i = match.length;
									while (i--) {
										cached = matcherFromTokens(match[i]);
										if (cached[expando]) {
											setMatchers.push(cached);
										} else {
											elementMatchers.push(cached);
										}
									}

									// Cache the compiled function
									cached = compilerCache(
										selector,
										matcherFromGroupMatchers(elementMatchers, setMatchers)
									);

									// Save selector and tokenization
									cached.selector = selector;
								}
								return cached;
							};

							/**
							 * A low-level selection function that works with Sizzle's compiled
							 *  selector functions
							 * @param {String|Function} selector A selector or a pre-compiled
							 *  selector function built with Sizzle.compile
							 * @param {Element} context
							 * @param {Array} [results]
							 * @param {Array} [seed] A set of elements to match against
							 */
							select = Sizzle.select = function (
								selector,
								context,
								results,
								seed
							) {
								var i,
									tokens,
									token,
									type,
									find,
									compiled = typeof selector === "function" && selector,
									match =
										!seed &&
										tokenize((selector = compiled.selector || selector));

								results = results || [];

								// Try to minimize operations if there is only one selector in the list and no seed
								// (the latter of which guarantees us context)
								if (match.length === 1) {
									// Reduce context if the leading compound selector is an ID
									tokens = match[0] = match[0].slice(0);
									if (
										tokens.length > 2 &&
										(token = tokens[0]).type === "ID" &&
										context.nodeType === 9 &&
										documentIsHTML &&
										Expr.relative[tokens[1].type]
									) {
										context = (Expr.find["ID"](
											token.matches[0].replace(runescape, funescape),
											context
										) || [])[0];
										if (!context) {
											return results;

											// Precompiled matchers will still verify ancestry, so step up a level
										} else if (compiled) {
											context = context.parentNode;
										}

										selector = selector.slice(tokens.shift().value.length);
									}

									// Fetch a seed set for right-to-left matching
									i = matchExpr["needsContext"].test(selector)
										? 0
										: tokens.length;
									while (i--) {
										token = tokens[i];

										// Abort if we hit a combinator
										if (Expr.relative[(type = token.type)]) {
											break;
										}
										if ((find = Expr.find[type])) {
											// Search, expanding context for leading sibling combinators
											if (
												(seed = find(
													token.matches[0].replace(runescape, funescape),
													(rsibling.test(tokens[0].type) &&
														testContext(context.parentNode)) ||
														context
												))
											) {
												// If seed is empty or no tokens remain, we can return early
												tokens.splice(i, 1);
												selector = seed.length && toSelector(tokens);
												if (!selector) {
													push.apply(results, seed);
													return results;
												}

												break;
											}
										}
									}
								}

								// Compile and execute a filtering function if one is not provided
								// Provide `match` to avoid retokenization if we modified the selector above
								(compiled || compile(selector, match))(
									seed,
									context,
									!documentIsHTML,
									results,
									!context ||
										(rsibling.test(selector) &&
											testContext(context.parentNode)) ||
										context
								);
								return results;
							};

							// One-time assignments

							// Sort stability
							support.sortStable =
								expando.split("").sort(sortOrder).join("") === expando;

							// Support: Chrome 14-35+
							// Always assume duplicates if they aren't passed to the comparison function
							support.detectDuplicates = !!hasDuplicate;

							// Initialize against the default document
							setDocument();

							// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
							// Detached nodes confoundingly follow *each other*
							support.sortDetached = assert(function (el) {
								// Should return 1, but returns 4 (following)
								return (
									el.compareDocumentPosition(
										document.createElement("fieldset")
									) & 1
								);
							});

							// Support: IE<8
							// Prevent attribute/property "interpolation"
							// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
							if (
								!assert(function (el) {
									el.innerHTML = "<a href='#'></a>";
									return el.firstChild.getAttribute("href") === "#";
								})
							) {
								addHandle(
									"type|href|height|width",
									function (elem, name, isXML) {
										if (!isXML) {
											return elem.getAttribute(
												name,
												name.toLowerCase() === "type" ? 1 : 2
											);
										}
									}
								);
							}

							// Support: IE<9
							// Use defaultValue in place of getAttribute("value")
							if (
								!support.attributes ||
								!assert(function (el) {
									el.innerHTML = "<input/>";
									el.firstChild.setAttribute("value", "");
									return el.firstChild.getAttribute("value") === "";
								})
							) {
								addHandle("value", function (elem, _name, isXML) {
									if (!isXML && elem.nodeName.toLowerCase() === "input") {
										return elem.defaultValue;
									}
								});
							}

							// Support: IE<9
							// Use getAttributeNode to fetch booleans when getAttribute lies
							if (
								!assert(function (el) {
									return el.getAttribute("disabled") == null;
								})
							) {
								addHandle(booleans, function (elem, name, isXML) {
									var val;
									if (!isXML) {
										return elem[name] === true
											? name.toLowerCase()
											: (val = elem.getAttributeNode(name)) && val.specified
											? val.value
											: null;
									}
								});
							}

							return Sizzle;
						})(window);

					jQuery.find = Sizzle;
					jQuery.expr = Sizzle.selectors;

					// Deprecated
					jQuery.expr[":"] = jQuery.expr.pseudos;
					jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
					jQuery.text = Sizzle.getText;
					jQuery.isXMLDoc = Sizzle.isXML;
					jQuery.contains = Sizzle.contains;
					jQuery.escapeSelector = Sizzle.escape;

					var dir = function (elem, dir, until) {
						var matched = [],
							truncate = until !== undefined;

						while ((elem = elem[dir]) && elem.nodeType !== 9) {
							if (elem.nodeType === 1) {
								if (truncate && jQuery(elem).is(until)) {
									break;
								}
								matched.push(elem);
							}
						}
						return matched;
					};

					var siblings = function (n, elem) {
						var matched = [];

						for (; n; n = n.nextSibling) {
							if (n.nodeType === 1 && n !== elem) {
								matched.push(n);
							}
						}

						return matched;
					};

					var rneedsContext = jQuery.expr.match.needsContext;

					function nodeName(elem, name) {
						return (
							elem.nodeName &&
							elem.nodeName.toLowerCase() === name.toLowerCase()
						);
					}
					var rsingleTag =
						/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

					// Implement the identical functionality for filter and not
					function winnow(elements, qualifier, not) {
						if (isFunction(qualifier)) {
							return jQuery.grep(elements, function (elem, i) {
								return !!qualifier.call(elem, i, elem) !== not;
							});
						}

						// Single element
						if (qualifier.nodeType) {
							return jQuery.grep(elements, function (elem) {
								return (elem === qualifier) !== not;
							});
						}

						// Arraylike of elements (jQuery, arguments, Array)
						if (typeof qualifier !== "string") {
							return jQuery.grep(elements, function (elem) {
								return indexOf.call(qualifier, elem) > -1 !== not;
							});
						}

						// Filtered directly for both simple and complex selectors
						return jQuery.filter(qualifier, elements, not);
					}

					jQuery.filter = function (expr, elems, not) {
						var elem = elems[0];

						if (not) {
							expr = ":not(" + expr + ")";
						}

						if (elems.length === 1 && elem.nodeType === 1) {
							return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
						}

						return jQuery.find.matches(
							expr,
							jQuery.grep(elems, function (elem) {
								return elem.nodeType === 1;
							})
						);
					};

					jQuery.fn.extend({
						find: function (selector) {
							var i,
								ret,
								len = this.length,
								self = this;

							if (typeof selector !== "string") {
								return this.pushStack(
									jQuery(selector).filter(function () {
										for (i = 0; i < len; i++) {
											if (jQuery.contains(self[i], this)) {
												return true;
											}
										}
									})
								);
							}

							ret = this.pushStack([]);

							for (i = 0; i < len; i++) {
								jQuery.find(selector, self[i], ret);
							}

							return len > 1 ? jQuery.uniqueSort(ret) : ret;
						},
						filter: function (selector) {
							return this.pushStack(winnow(this, selector || [], false));
						},
						not: function (selector) {
							return this.pushStack(winnow(this, selector || [], true));
						},
						is: function (selector) {
							return !!winnow(
								this,

								// If this is a positional/relative selector, check membership in the returned set
								// so $("p:first").is("p:last") won't return true for a doc with two "p".
								typeof selector === "string" && rneedsContext.test(selector)
									? jQuery(selector)
									: selector || [],
								false
							).length;
						},
					});

					// Initialize a jQuery object

					// A central reference to the root jQuery(document)
					var rootjQuery,
						// A simple way to check for HTML strings
						// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
						// Strict HTML recognition (#11290: must start with <)
						// Shortcut simple #id case for speed
						rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
						init = (jQuery.fn.init = function (selector, context, root) {
							var match, elem;

							// HANDLE: $(""), $(null), $(undefined), $(false)
							if (!selector) {
								return this;
							}

							// Method init() accepts an alternate rootjQuery
							// so migrate can support jQuery.sub (gh-2101)
							root = root || rootjQuery;

							// Handle HTML strings
							if (typeof selector === "string") {
								if (
									selector[0] === "<" &&
									selector[selector.length - 1] === ">" &&
									selector.length >= 3
								) {
									// Assume that strings that start and end with <> are HTML and skip the regex check
									match = [null, selector, null];
								} else {
									match = rquickExpr.exec(selector);
								}

								// Match html or make sure no context is specified for #id
								if (match && (match[1] || !context)) {
									// HANDLE: $(html) -> $(array)
									if (match[1]) {
										context = context instanceof jQuery ? context[0] : context;

										// Option to run scripts is true for back-compat
										// Intentionally let the error be thrown if parseHTML is not present
										jQuery.merge(
											this,
											jQuery.parseHTML(
												match[1],
												context && context.nodeType
													? context.ownerDocument || context
													: document,
												true
											)
										);

										// HANDLE: $(html, props)
										if (
											rsingleTag.test(match[1]) &&
											jQuery.isPlainObject(context)
										) {
											for (match in context) {
												// Properties of context are called as methods if possible
												if (isFunction(this[match])) {
													this[match](context[match]);

													// ...and otherwise set as attributes
												} else {
													this.attr(match, context[match]);
												}
											}
										}

										return this;

										// HANDLE: $(#id)
									} else {
										elem = document.getElementById(match[2]);

										if (elem) {
											// Inject the element directly into the jQuery object
											this[0] = elem;
											this.length = 1;
										}
										return this;
									}

									// HANDLE: $(expr, $(...))
								} else if (!context || context.jquery) {
									return (context || root).find(selector);

									// HANDLE: $(expr, context)
									// (which is just equivalent to: $(context).find(expr)
								} else {
									return this.constructor(context).find(selector);
								}

								// HANDLE: $(DOMElement)
							} else if (selector.nodeType) {
								this[0] = selector;
								this.length = 1;
								return this;

								// HANDLE: $(function)
								// Shortcut for document ready
							} else if (isFunction(selector)) {
								return root.ready !== undefined
									? root.ready(selector)
									: // Execute immediately if ready is not present
									  selector(jQuery);
							}

							return jQuery.makeArray(selector, this);
						});

					// Give the init function the jQuery prototype for later instantiation
					init.prototype = jQuery.fn;

					// Initialize central reference
					rootjQuery = jQuery(document);

					var rparentsprev = /^(?:parents|prev(?:Until|All))/,
						// Methods guaranteed to produce a unique set when starting from a unique set
						guaranteedUnique = {
							children: true,
							contents: true,
							next: true,
							prev: true,
						};

					jQuery.fn.extend({
						has: function (target) {
							var targets = jQuery(target, this),
								l = targets.length;

							return this.filter(function () {
								var i = 0;
								for (; i < l; i++) {
									if (jQuery.contains(this, targets[i])) {
										return true;
									}
								}
							});
						},

						closest: function (selectors, context) {
							var cur,
								i = 0,
								l = this.length,
								matched = [],
								targets = typeof selectors !== "string" && jQuery(selectors);

							// Positional selectors never match, since there's no _selection_ context
							if (!rneedsContext.test(selectors)) {
								for (; i < l; i++) {
									for (
										cur = this[i];
										cur && cur !== context;
										cur = cur.parentNode
									) {
										// Always skip document fragments
										if (
											cur.nodeType < 11 &&
											(targets
												? targets.index(cur) > -1
												: // Don't pass non-elements to Sizzle
												  cur.nodeType === 1 &&
												  jQuery.find.matchesSelector(cur, selectors))
										) {
											matched.push(cur);
											break;
										}
									}
								}
							}

							return this.pushStack(
								matched.length > 1 ? jQuery.uniqueSort(matched) : matched
							);
						},

						// Determine the position of an element within the set
						index: function (elem) {
							// No argument, return index in parent
							if (!elem) {
								return this[0] && this[0].parentNode
									? this.first().prevAll().length
									: -1;
							}

							// Index in selector
							if (typeof elem === "string") {
								return indexOf.call(jQuery(elem), this[0]);
							}

							// Locate the position of the desired element
							return indexOf.call(
								this,

								// If it receives a jQuery object, the first element is used
								elem.jquery ? elem[0] : elem
							);
						},

						add: function (selector, context) {
							return this.pushStack(
								jQuery.uniqueSort(
									jQuery.merge(this.get(), jQuery(selector, context))
								)
							);
						},

						addBack: function (selector) {
							return this.add(
								selector == null
									? this.prevObject
									: this.prevObject.filter(selector)
							);
						},
					});

					function sibling(cur, dir) {
						while ((cur = cur[dir]) && cur.nodeType !== 1) {}
						return cur;
					}

					jQuery.each(
						{
							parent: function (elem) {
								var parent = elem.parentNode;
								return parent && parent.nodeType !== 11 ? parent : null;
							},
							parents: function (elem) {
								return dir(elem, "parentNode");
							},
							parentsUntil: function (elem, _i, until) {
								return dir(elem, "parentNode", until);
							},
							next: function (elem) {
								return sibling(elem, "nextSibling");
							},
							prev: function (elem) {
								return sibling(elem, "previousSibling");
							},
							nextAll: function (elem) {
								return dir(elem, "nextSibling");
							},
							prevAll: function (elem) {
								return dir(elem, "previousSibling");
							},
							nextUntil: function (elem, _i, until) {
								return dir(elem, "nextSibling", until);
							},
							prevUntil: function (elem, _i, until) {
								return dir(elem, "previousSibling", until);
							},
							siblings: function (elem) {
								return siblings((elem.parentNode || {}).firstChild, elem);
							},
							children: function (elem) {
								return siblings(elem.firstChild);
							},
							contents: function (elem) {
								if (
									elem.contentDocument != null &&
									// Support: IE 11+
									// <object> elements with no `data` attribute has an object
									// `contentDocument` with a `null` prototype.
									getProto(elem.contentDocument)
								) {
									return elem.contentDocument;
								}

								// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
								// Treat the template element as a regular one in browsers that
								// don't support it.
								if (nodeName(elem, "template")) {
									elem = elem.content || elem;
								}

								return jQuery.merge([], elem.childNodes);
							},
						},
						function (name, fn) {
							jQuery.fn[name] = function (until, selector) {
								var matched = jQuery.map(this, fn, until);

								if (name.slice(-5) !== "Until") {
									selector = until;
								}

								if (selector && typeof selector === "string") {
									matched = jQuery.filter(selector, matched);
								}

								if (this.length > 1) {
									// Remove duplicates
									if (!guaranteedUnique[name]) {
										jQuery.uniqueSort(matched);
									}

									// Reverse order for parents* and prev-derivatives
									if (rparentsprev.test(name)) {
										matched.reverse();
									}
								}

								return this.pushStack(matched);
							};
						}
					);
					var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;

					// Convert String-formatted options into Object-formatted ones
					function createOptions(options) {
						var object = {};
						jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
							object[flag] = true;
						});
						return object;
					}

					/*
					 * Create a callback list using the following parameters:
					 *
					 *	options: an optional list of space-separated options that will change how
					 *			the callback list behaves or a more traditional option object
					 *
					 * By default a callback list will act like an event callback list and can be
					 * "fired" multiple times.
					 *
					 * Possible options:
					 *
					 *	once:			will ensure the callback list can only be fired once (like a Deferred)
					 *
					 *	memory:			will keep track of previous values and will call any callback added
					 *					after the list has been fired right away with the latest "memorized"
					 *					values (like a Deferred)
					 *
					 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
					 *
					 *	stopOnFalse:	interrupt callings when a callback returns false
					 *
					 */
					jQuery.Callbacks = function (options) {
						// Convert options from String-formatted to Object-formatted if needed
						// (we check in cache first)
						options =
							typeof options === "string"
								? createOptions(options)
								: jQuery.extend({}, options);

						var // Flag to know if list is currently firing
							firing,
							// Last fire value for non-forgettable lists
							memory,
							// Flag to know if list was already fired
							fired,
							// Flag to prevent firing
							locked,
							// Actual callback list
							list = [],
							// Queue of execution data for repeatable lists
							queue = [],
							// Index of currently firing callback (modified by add/remove as needed)
							firingIndex = -1,
							// Fire callbacks
							fire = function () {
								// Enforce single-firing
								locked = locked || options.once;

								// Execute callbacks for all pending executions,
								// respecting firingIndex overrides and runtime changes
								fired = firing = true;
								for (; queue.length; firingIndex = -1) {
									memory = queue.shift();
									while (++firingIndex < list.length) {
										// Run callback and check for early termination
										if (
											list[firingIndex].apply(memory[0], memory[1]) === false &&
											options.stopOnFalse
										) {
											// Jump to end and forget the data so .add doesn't re-fire
											firingIndex = list.length;
											memory = false;
										}
									}
								}

								// Forget the data if we're done with it
								if (!options.memory) {
									memory = false;
								}

								firing = false;

								// Clean up if we're done firing for good
								if (locked) {
									// Keep an empty list if we have data for future add calls
									if (memory) {
										list = [];

										// Otherwise, this object is spent
									} else {
										list = "";
									}
								}
							},
							// Actual Callbacks object
							self = {
								// Add a callback or a collection of callbacks to the list
								add: function () {
									if (list) {
										// If we have memory from a past run, we should fire after adding
										if (memory && !firing) {
											firingIndex = list.length - 1;
											queue.push(memory);
										}

										(function add(args) {
											jQuery.each(args, function (_, arg) {
												if (isFunction(arg)) {
													if (!options.unique || !self.has(arg)) {
														list.push(arg);
													}
												} else if (
													arg &&
													arg.length &&
													toType(arg) !== "string"
												) {
													// Inspect recursively
													add(arg);
												}
											});
										})(arguments);

										if (memory && !firing) {
											fire();
										}
									}
									return this;
								},

								// Remove a callback from the list
								remove: function () {
									jQuery.each(arguments, function (_, arg) {
										var index;
										while ((index = jQuery.inArray(arg, list, index)) > -1) {
											list.splice(index, 1);

											// Handle firing indexes
											if (index <= firingIndex) {
												firingIndex--;
											}
										}
									});
									return this;
								},

								// Check if a given callback is in the list.
								// If no argument is given, return whether or not list has callbacks attached.
								has: function (fn) {
									return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
								},

								// Remove all callbacks from the list
								empty: function () {
									if (list) {
										list = [];
									}
									return this;
								},

								// Disable .fire and .add
								// Abort any current/pending executions
								// Clear all callbacks and values
								disable: function () {
									locked = queue = [];
									list = memory = "";
									return this;
								},
								disabled: function () {
									return !list;
								},

								// Disable .fire
								// Also disable .add unless we have memory (since it would have no effect)
								// Abort any pending executions
								lock: function () {
									locked = queue = [];
									if (!memory && !firing) {
										list = memory = "";
									}
									return this;
								},
								locked: function () {
									return !!locked;
								},

								// Call all callbacks with the given context and arguments
								fireWith: function (context, args) {
									if (!locked) {
										args = args || [];
										args = [context, args.slice ? args.slice() : args];
										queue.push(args);
										if (!firing) {
											fire();
										}
									}
									return this;
								},

								// Call all the callbacks with the given arguments
								fire: function () {
									self.fireWith(this, arguments);
									return this;
								},

								// To know if the callbacks have already been called at least once
								fired: function () {
									return !!fired;
								},
							};

						return self;
					};

					function Identity(v) {
						return v;
					}
					function Thrower(ex) {
						throw ex;
					}

					function adoptValue(value, resolve, reject, noValue) {
						var method;

						try {
							// Check for promise aspect first to privilege synchronous behavior
							if (value && isFunction((method = value.promise))) {
								method.call(value).done(resolve).fail(reject);

								// Other thenables
							} else if (value && isFunction((method = value.then))) {
								method.call(value, resolve, reject);

								// Other non-thenables
							} else {
								// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
								// * false: [ value ].slice( 0 ) => resolve( value )
								// * true: [ value ].slice( 1 ) => resolve()
								resolve.apply(undefined, [value].slice(noValue));
							}

							// For Promises/A+, convert exceptions into rejections
							// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
							// Deferred#then to conditionally suppress rejection.
						} catch (value) {
							// Support: Android 4.0 only
							// Strict mode functions invoked without .call/.apply get global-object context
							reject.apply(undefined, [value]);
						}
					}

					jQuery.extend({
						Deferred: function (func) {
							var tuples = [
									// action, add listener, callbacks,
									// ... .then handlers, argument index, [final state]
									[
										"notify",
										"progress",
										jQuery.Callbacks("memory"),
										jQuery.Callbacks("memory"),
										2,
									],
									[
										"resolve",
										"done",
										jQuery.Callbacks("once memory"),
										jQuery.Callbacks("once memory"),
										0,
										"resolved",
									],
									[
										"reject",
										"fail",
										jQuery.Callbacks("once memory"),
										jQuery.Callbacks("once memory"),
										1,
										"rejected",
									],
								],
								state = "pending",
								promise = {
									state: function () {
										return state;
									},
									always: function () {
										deferred.done(arguments).fail(arguments);
										return this;
									},
									catch: function (fn) {
										return promise.then(null, fn);
									},

									// Keep pipe for back-compat
									pipe: function (/* fnDone, fnFail, fnProgress */) {
										var fns = arguments;

										return jQuery
											.Deferred(function (newDefer) {
												jQuery.each(tuples, function (_i, tuple) {
													// Map tuples (progress, done, fail) to arguments (done, fail, progress)
													var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];

													// deferred.progress(function() { bind to newDefer or newDefer.notify })
													// deferred.done(function() { bind to newDefer or newDefer.resolve })
													// deferred.fail(function() { bind to newDefer or newDefer.reject })
													deferred[tuple[1]](function () {
														var returned = fn && fn.apply(this, arguments);
														if (returned && isFunction(returned.promise)) {
															returned
																.promise()
																.progress(newDefer.notify)
																.done(newDefer.resolve)
																.fail(newDefer.reject);
														} else {
															newDefer[tuple[0] + "With"](
																this,
																fn ? [returned] : arguments
															);
														}
													});
												});
												fns = null;
											})
											.promise();
									},
									then: function (onFulfilled, onRejected, onProgress) {
										var maxDepth = 0;
										function resolve(depth, deferred, handler, special) {
											return function () {
												var that = this,
													args = arguments,
													mightThrow = function () {
														var returned, then;

														// Support: Promises/A+ section 2.3.3.3.3
														// https://promisesaplus.com/#point-59
														// Ignore double-resolution attempts
														if (depth < maxDepth) {
															return;
														}

														returned = handler.apply(that, args);

														// Support: Promises/A+ section 2.3.1
														// https://promisesaplus.com/#point-48
														if (returned === deferred.promise()) {
															throw new TypeError("Thenable self-resolution");
														}

														// Support: Promises/A+ sections 2.3.3.1, 3.5
														// https://promisesaplus.com/#point-54
														// https://promisesaplus.com/#point-75
														// Retrieve `then` only once
														then =
															returned &&
															// Support: Promises/A+ section 2.3.4
															// https://promisesaplus.com/#point-64
															// Only check objects and functions for thenability
															(typeof returned === "object" ||
																typeof returned === "function") &&
															returned.then;

														// Handle a returned thenable
														if (isFunction(then)) {
															// Special processors (notify) just wait for resolution
															if (special) {
																then.call(
																	returned,
																	resolve(
																		maxDepth,
																		deferred,
																		Identity,
																		special
																	),
																	resolve(maxDepth, deferred, Thrower, special)
																);

																// Normal processors (resolve) also hook into progress
															} else {
																// ...and disregard older resolution values
																maxDepth++;

																then.call(
																	returned,
																	resolve(
																		maxDepth,
																		deferred,
																		Identity,
																		special
																	),
																	resolve(maxDepth, deferred, Thrower, special),
																	resolve(
																		maxDepth,
																		deferred,
																		Identity,
																		deferred.notifyWith
																	)
																);
															}

															// Handle all other returned values
														} else {
															// Only substitute handlers pass on context
															// and multiple values (non-spec behavior)
															if (handler !== Identity) {
																that = undefined;
																args = [returned];
															}

															// Process the value(s)
															// Default process is resolve
															(special || deferred.resolveWith)(that, args);
														}
													},
													// Only normal processors (resolve) catch and reject exceptions
													process = special
														? mightThrow
														: function () {
																try {
																	mightThrow();
																} catch (e) {
																	if (jQuery.Deferred.exceptionHook) {
																		jQuery.Deferred.exceptionHook(
																			e,
																			process.stackTrace
																		);
																	}

																	// Support: Promises/A+ section 2.3.3.3.4.1
																	// https://promisesaplus.com/#point-61
																	// Ignore post-resolution exceptions
																	if (depth + 1 >= maxDepth) {
																		// Only substitute handlers pass on context
																		// and multiple values (non-spec behavior)
																		if (handler !== Thrower) {
																			that = undefined;
																			args = [e];
																		}

																		deferred.rejectWith(that, args);
																	}
																}
														  };

												// Support: Promises/A+ section 2.3.3.3.1
												// https://promisesaplus.com/#point-57
												// Re-resolve promises immediately to dodge false rejection from
												// subsequent errors
												if (depth) {
													process();
												} else {
													// Call an optional hook to record the stack, in case of exception
													// since it's otherwise lost when execution goes async
													if (jQuery.Deferred.getStackHook) {
														process.stackTrace = jQuery.Deferred.getStackHook();
													}
													window.setTimeout(process);
												}
											};
										}

										return jQuery
											.Deferred(function (newDefer) {
												// progress_handlers.add( ... )
												tuples[0][3].add(
													resolve(
														0,
														newDefer,
														isFunction(onProgress) ? onProgress : Identity,
														newDefer.notifyWith
													)
												);

												// fulfilled_handlers.add( ... )
												tuples[1][3].add(
													resolve(
														0,
														newDefer,
														isFunction(onFulfilled) ? onFulfilled : Identity
													)
												);

												// rejected_handlers.add( ... )
												tuples[2][3].add(
													resolve(
														0,
														newDefer,
														isFunction(onRejected) ? onRejected : Thrower
													)
												);
											})
											.promise();
									},

									// Get a promise for this deferred
									// If obj is provided, the promise aspect is added to the object
									promise: function (obj) {
										return obj != null ? jQuery.extend(obj, promise) : promise;
									},
								},
								deferred = {};

							// Add list-specific methods
							jQuery.each(tuples, function (i, tuple) {
								var list = tuple[2],
									stateString = tuple[5];

								// promise.progress = list.add
								// promise.done = list.add
								// promise.fail = list.add
								promise[tuple[1]] = list.add;

								// Handle state
								if (stateString) {
									list.add(
										function () {
											// state = "resolved" (i.e., fulfilled)
											// state = "rejected"
											state = stateString;
										},

										// rejected_callbacks.disable
										// fulfilled_callbacks.disable
										tuples[3 - i][2].disable,

										// rejected_handlers.disable
										// fulfilled_handlers.disable
										tuples[3 - i][3].disable,

										// progress_callbacks.lock
										tuples[0][2].lock,

										// progress_handlers.lock
										tuples[0][3].lock
									);
								}

								// progress_handlers.fire
								// fulfilled_handlers.fire
								// rejected_handlers.fire
								list.add(tuple[3].fire);

								// deferred.notify = function() { deferred.notifyWith(...) }
								// deferred.resolve = function() { deferred.resolveWith(...) }
								// deferred.reject = function() { deferred.rejectWith(...) }
								deferred[tuple[0]] = function () {
									deferred[tuple[0] + "With"](
										this === deferred ? undefined : this,
										arguments
									);
									return this;
								};

								// deferred.notifyWith = list.fireWith
								// deferred.resolveWith = list.fireWith
								// deferred.rejectWith = list.fireWith
								deferred[tuple[0] + "With"] = list.fireWith;
							});

							// Make the deferred a promise
							promise.promise(deferred);

							// Call given func if any
							if (func) {
								func.call(deferred, deferred);
							}

							// All done!
							return deferred;
						},

						// Deferred helper
						when: function (singleValue) {
							var // count of uncompleted subordinates
								remaining = arguments.length,
								// count of unprocessed arguments
								i = remaining,
								// subordinate fulfillment data
								resolveContexts = Array(i),
								resolveValues = slice.call(arguments),
								// the master Deferred
								master = jQuery.Deferred(),
								// subordinate callback factory
								updateFunc = function (i) {
									return function (value) {
										resolveContexts[i] = this;
										resolveValues[i] =
											arguments.length > 1 ? slice.call(arguments) : value;
										if (!--remaining) {
											master.resolveWith(resolveContexts, resolveValues);
										}
									};
								};

							// Single- and empty arguments are adopted like Promise.resolve
							if (remaining <= 1) {
								adoptValue(
									singleValue,
									master.done(updateFunc(i)).resolve,
									master.reject,
									!remaining
								);

								// Use .then() to unwrap secondary thenables (cf. gh-3000)
								if (
									master.state() === "pending" ||
									isFunction(resolveValues[i] && resolveValues[i].then)
								) {
									return master.then();
								}
							}

							// Multiple arguments are aggregated like Promise.all array elements
							while (i--) {
								adoptValue(resolveValues[i], updateFunc(i), master.reject);
							}

							return master.promise();
						},
					});

					// These usually indicate a programmer mistake during development,
					// warn about them ASAP rather than swallowing them by default.
					var rerrorNames =
						/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

					jQuery.Deferred.exceptionHook = function (error, stack) {
						// Support: IE 8 - 9 only
						// Console exists when dev tools are open, which can happen at any time
						if (
							window.console &&
							window.console.warn &&
							error &&
							rerrorNames.test(error.name)
						) {
							window.console.warn(
								"jQuery.Deferred exception: " + error.message,
								error.stack,
								stack
							);
						}
					};

					jQuery.readyException = function (error) {
						window.setTimeout(function () {
							throw error;
						});
					};

					// The deferred used on DOM ready
					var readyList = jQuery.Deferred();

					jQuery.fn.ready = function (fn) {
						readyList
							.then(fn)

							// Wrap jQuery.readyException in a function so that the lookup
							// happens at the time of error handling instead of callback
							// registration.
							.catch(function (error) {
								jQuery.readyException(error);
							});

						return this;
					};

					jQuery.extend({
						// Is the DOM ready to be used? Set to true once it occurs.
						isReady: false,

						// A counter to track how many items to wait for before
						// the ready event fires. See #6781
						readyWait: 1,

						// Handle when the DOM is ready
						ready: function (wait) {
							// Abort if there are pending holds or we're already ready
							if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
								return;
							}

							// Remember that the DOM is ready
							jQuery.isReady = true;

							// If a normal DOM Ready event fired, decrement, and wait if need be
							if (wait !== true && --jQuery.readyWait > 0) {
								return;
							}

							// If there are functions bound, to execute
							readyList.resolveWith(document, [jQuery]);
						},
					});

					jQuery.ready.then = readyList.then;

					// The ready event handler and self cleanup method
					function completed() {
						document.removeEventListener("DOMContentLoaded", completed);
						window.removeEventListener("load", completed);
						jQuery.ready();
					}

					// Catch cases where $(document).ready() is called
					// after the browser event has already occurred.
					// Support: IE <=9 - 10 only
					// Older IE sometimes signals "interactive" too soon
					if (
						document.readyState === "complete" ||
						(document.readyState !== "loading" &&
							!document.documentElement.doScroll)
					) {
						// Handle it asynchronously to allow scripts the opportunity to delay ready
						window.setTimeout(jQuery.ready);
					} else {
						// Use the handy event callback
						document.addEventListener("DOMContentLoaded", completed);

						// A fallback to window.onload, that will always work
						window.addEventListener("load", completed);
					}

					// Multifunctional method to get and set values of a collection
					// The value/s can optionally be executed if it's a function
					var access = function (
						elems,
						fn,
						key,
						value,
						chainable,
						emptyGet,
						raw
					) {
						var i = 0,
							len = elems.length,
							bulk = key == null;

						// Sets many values
						if (toType(key) === "object") {
							chainable = true;
							for (i in key) {
								access(elems, fn, i, key[i], true, emptyGet, raw);
							}

							// Sets one value
						} else if (value !== undefined) {
							chainable = true;

							if (!isFunction(value)) {
								raw = true;
							}

							if (bulk) {
								// Bulk operations run against the entire set
								if (raw) {
									fn.call(elems, value);
									fn = null;

									// ...except when executing function values
								} else {
									bulk = fn;
									fn = function (elem, _key, value) {
										return bulk.call(jQuery(elem), value);
									};
								}
							}

							if (fn) {
								for (; i < len; i++) {
									fn(
										elems[i],
										key,
										raw ? value : value.call(elems[i], i, fn(elems[i], key))
									);
								}
							}
						}

						if (chainable) {
							return elems;
						}

						// Gets
						if (bulk) {
							return fn.call(elems);
						}

						return len ? fn(elems[0], key) : emptyGet;
					};

					// Matches dashed string for camelizing
					var rmsPrefix = /^-ms-/,
						rdashAlpha = /-([a-z])/g;

					// Used by camelCase as callback to replace()
					function fcamelCase(_all, letter) {
						return letter.toUpperCase();
					}

					// Convert dashed to camelCase; used by the css and data modules
					// Support: IE <=9 - 11, Edge 12 - 15
					// Microsoft forgot to hump their vendor prefix (#9572)
					function camelCase(string) {
						return string
							.replace(rmsPrefix, "ms-")
							.replace(rdashAlpha, fcamelCase);
					}
					var acceptData = function (owner) {
						// Accepts only:
						//  - Node
						//    - Node.ELEMENT_NODE
						//    - Node.DOCUMENT_NODE
						//  - Object
						//    - Any
						return (
							owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType
						);
					};

					function Data() {
						this.expando = jQuery.expando + Data.uid++;
					}

					Data.uid = 1;

					Data.prototype = {
						cache: function (owner) {
							// Check if the owner object already has a cache
							var value = owner[this.expando];

							// If not, create one
							if (!value) {
								value = {};

								// We can accept data for non-element nodes in modern browsers,
								// but we should not, see #8335.
								// Always return an empty object.
								if (acceptData(owner)) {
									// If it is a node unlikely to be stringify-ed or looped over
									// use plain assignment
									if (owner.nodeType) {
										owner[this.expando] = value;

										// Otherwise secure it in a non-enumerable property
										// configurable must be true to allow the property to be
										// deleted when data is removed
									} else {
										Object.defineProperty(owner, this.expando, {
											value: value,
											configurable: true,
										});
									}
								}
							}

							return value;
						},
						set: function (owner, data, value) {
							var prop,
								cache = this.cache(owner);

							// Handle: [ owner, key, value ] args
							// Always use camelCase key (gh-2257)
							if (typeof data === "string") {
								cache[camelCase(data)] = value;

								// Handle: [ owner, { properties } ] args
							} else {
								// Copy the properties one-by-one to the cache object
								for (prop in data) {
									cache[camelCase(prop)] = data[prop];
								}
							}
							return cache;
						},
						get: function (owner, key) {
							return key === undefined
								? this.cache(owner)
								: // Always use camelCase key (gh-2257)
								  owner[this.expando] && owner[this.expando][camelCase(key)];
						},
						access: function (owner, key, value) {
							// In cases where either:
							//
							//   1. No key was specified
							//   2. A string key was specified, but no value provided
							//
							// Take the "read" path and allow the get method to determine
							// which value to return, respectively either:
							//
							//   1. The entire cache object
							//   2. The data stored at the key
							//
							if (
								key === undefined ||
								(key && typeof key === "string" && value === undefined)
							) {
								return this.get(owner, key);
							}

							// When the key is not a string, or both a key and value
							// are specified, set or extend (existing objects) with either:
							//
							//   1. An object of properties
							//   2. A key and value
							//
							this.set(owner, key, value);

							// Since the "set" path can have two possible entry points
							// return the expected data based on which path was taken[*]
							return value !== undefined ? value : key;
						},
						remove: function (owner, key) {
							var i,
								cache = owner[this.expando];

							if (cache === undefined) {
								return;
							}

							if (key !== undefined) {
								// Support array or space separated string of keys
								if (Array.isArray(key)) {
									// If key is an array of keys...
									// We always set camelCase keys, so remove that.
									key = key.map(camelCase);
								} else {
									key = camelCase(key);

									// If a key with the spaces exists, use it.
									// Otherwise, create an array by matching non-whitespace
									key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
								}

								i = key.length;

								while (i--) {
									delete cache[key[i]];
								}
							}

							// Remove the expando if there's no more data
							if (key === undefined || jQuery.isEmptyObject(cache)) {
								// Support: Chrome <=35 - 45
								// Webkit & Blink performance suffers when deleting properties
								// from DOM nodes, so set to undefined instead
								// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
								if (owner.nodeType) {
									owner[this.expando] = undefined;
								} else {
									delete owner[this.expando];
								}
							}
						},
						hasData: function (owner) {
							var cache = owner[this.expando];
							return cache !== undefined && !jQuery.isEmptyObject(cache);
						},
					};
					var dataPriv = new Data();

					var dataUser = new Data();

					//	Implementation Summary
					//
					//	1. Enforce API surface and semantic compatibility with 1.9.x branch
					//	2. Improve the module's maintainability by reducing the storage
					//		paths to a single mechanism.
					//	3. Use the same single mechanism to support "private" and "user" data.
					//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
					//	5. Avoid exposing implementation details on user objects (eg. expando properties)
					//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

					var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
						rmultiDash = /[A-Z]/g;

					function getData(data) {
						if (data === "true") {
							return true;
						}

						if (data === "false") {
							return false;
						}

						if (data === "null") {
							return null;
						}

						// Only convert to a number if it doesn't change the string
						if (data === +data + "") {
							return +data;
						}

						if (rbrace.test(data)) {
							return JSON.parse(data);
						}

						return data;
					}

					function dataAttr(elem, key, data) {
						var name;

						// If nothing was found internally, try to fetch any
						// data from the HTML5 data-* attribute
						if (data === undefined && elem.nodeType === 1) {
							name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
							data = elem.getAttribute(name);

							if (typeof data === "string") {
								try {
									data = getData(data);
								} catch (e) {}

								// Make sure we set the data so it isn't changed later
								dataUser.set(elem, key, data);
							} else {
								data = undefined;
							}
						}
						return data;
					}

					jQuery.extend({
						hasData: function (elem) {
							return dataUser.hasData(elem) || dataPriv.hasData(elem);
						},

						data: function (elem, name, data) {
							return dataUser.access(elem, name, data);
						},

						removeData: function (elem, name) {
							dataUser.remove(elem, name);
						},

						// TODO: Now that all calls to _data and _removeData have been replaced
						// with direct calls to dataPriv methods, these can be deprecated.
						_data: function (elem, name, data) {
							return dataPriv.access(elem, name, data);
						},

						_removeData: function (elem, name) {
							dataPriv.remove(elem, name);
						},
					});

					jQuery.fn.extend({
						data: function (key, value) {
							var i,
								name,
								data,
								elem = this[0],
								attrs = elem && elem.attributes;

							// Gets all values
							if (key === undefined) {
								if (this.length) {
									data = dataUser.get(elem);

									if (
										elem.nodeType === 1 &&
										!dataPriv.get(elem, "hasDataAttrs")
									) {
										i = attrs.length;
										while (i--) {
											// Support: IE 11 only
											// The attrs elements can be null (#14894)
											if (attrs[i]) {
												name = attrs[i].name;
												if (name.indexOf("data-") === 0) {
													name = camelCase(name.slice(5));
													dataAttr(elem, name, data[name]);
												}
											}
										}
										dataPriv.set(elem, "hasDataAttrs", true);
									}
								}

								return data;
							}

							// Sets multiple values
							if (typeof key === "object") {
								return this.each(function () {
									dataUser.set(this, key);
								});
							}

							return access(
								this,
								function (value) {
									var data;

									// The calling jQuery object (element matches) is not empty
									// (and therefore has an element appears at this[ 0 ]) and the
									// `value` parameter was not undefined. An empty jQuery object
									// will result in `undefined` for elem = this[ 0 ] which will
									// throw an exception if an attempt to read a data cache is made.
									if (elem && value === undefined) {
										// Attempt to get data from the cache
										// The key will always be camelCased in Data
										data = dataUser.get(elem, key);
										if (data !== undefined) {
											return data;
										}

										// Attempt to "discover" the data in
										// HTML5 custom data-* attrs
										data = dataAttr(elem, key);
										if (data !== undefined) {
											return data;
										}

										// We tried really hard, but the data doesn't exist.
										return;
									}

									// Set the data...
									this.each(function () {
										// We always store the camelCased key
										dataUser.set(this, key, value);
									});
								},
								null,
								value,
								arguments.length > 1,
								null,
								true
							);
						},

						removeData: function (key) {
							return this.each(function () {
								dataUser.remove(this, key);
							});
						},
					});

					jQuery.extend({
						queue: function (elem, type, data) {
							var queue;

							if (elem) {
								type = (type || "fx") + "queue";
								queue = dataPriv.get(elem, type);

								// Speed up dequeue by getting out quickly if this is just a lookup
								if (data) {
									if (!queue || Array.isArray(data)) {
										queue = dataPriv.access(elem, type, jQuery.makeArray(data));
									} else {
										queue.push(data);
									}
								}
								return queue || [];
							}
						},

						dequeue: function (elem, type) {
							type = type || "fx";

							var queue = jQuery.queue(elem, type),
								startLength = queue.length,
								fn = queue.shift(),
								hooks = jQuery._queueHooks(elem, type),
								next = function () {
									jQuery.dequeue(elem, type);
								};

							// If the fx queue is dequeued, always remove the progress sentinel
							if (fn === "inprogress") {
								fn = queue.shift();
								startLength--;
							}

							if (fn) {
								// Add a progress sentinel to prevent the fx queue from being
								// automatically dequeued
								if (type === "fx") {
									queue.unshift("inprogress");
								}

								// Clear up the last queue stop function
								delete hooks.stop;
								fn.call(elem, next, hooks);
							}

							if (!startLength && hooks) {
								hooks.empty.fire();
							}
						},

						// Not public - generate a queueHooks object, or return the current one
						_queueHooks: function (elem, type) {
							var key = type + "queueHooks";
							return (
								dataPriv.get(elem, key) ||
								dataPriv.access(elem, key, {
									empty: jQuery.Callbacks("once memory").add(function () {
										dataPriv.remove(elem, [type + "queue", key]);
									}),
								})
							);
						},
					});

					jQuery.fn.extend({
						queue: function (type, data) {
							var setter = 2;

							if (typeof type !== "string") {
								data = type;
								type = "fx";
								setter--;
							}

							if (arguments.length < setter) {
								return jQuery.queue(this[0], type);
							}

							return data === undefined
								? this
								: this.each(function () {
										var queue = jQuery.queue(this, type, data);

										// Ensure a hooks for this queue
										jQuery._queueHooks(this, type);

										if (type === "fx" && queue[0] !== "inprogress") {
											jQuery.dequeue(this, type);
										}
								  });
						},
						dequeue: function (type) {
							return this.each(function () {
								jQuery.dequeue(this, type);
							});
						},
						clearQueue: function (type) {
							return this.queue(type || "fx", []);
						},

						// Get a promise resolved when queues of a certain type
						// are emptied (fx is the type by default)
						promise: function (type, obj) {
							var tmp,
								count = 1,
								defer = jQuery.Deferred(),
								elements = this,
								i = this.length,
								resolve = function () {
									if (!--count) {
										defer.resolveWith(elements, [elements]);
									}
								};

							if (typeof type !== "string") {
								obj = type;
								type = undefined;
							}
							type = type || "fx";

							while (i--) {
								tmp = dataPriv.get(elements[i], type + "queueHooks");
								if (tmp && tmp.empty) {
									count++;
									tmp.empty.add(resolve);
								}
							}
							resolve();
							return defer.promise(obj);
						},
					});
					var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;

					var rcssNum = new RegExp(
						"^(?:([+-])=|)(" + pnum + ")([a-z%]*)$",
						"i"
					);

					var cssExpand = ["Top", "Right", "Bottom", "Left"];

					var documentElement = document.documentElement;

					var isAttached = function (elem) {
							return jQuery.contains(elem.ownerDocument, elem);
						},
						composed = { composed: true };

					// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
					// Check attachment across shadow DOM boundaries when possible (gh-3504)
					// Support: iOS 10.0-10.2 only
					// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
					// leading to errors. We need to check for `getRootNode`.
					if (documentElement.getRootNode) {
						isAttached = function (elem) {
							return (
								jQuery.contains(elem.ownerDocument, elem) ||
								elem.getRootNode(composed) === elem.ownerDocument
							);
						};
					}
					var isHiddenWithinTree = function (elem, el) {
						// isHiddenWithinTree might be called from jQuery#filter function;
						// in that case, element will be second argument
						elem = el || elem;

						// Inline style trumps all
						return (
							elem.style.display === "none" ||
							(elem.style.display === "" &&
								// Otherwise, check computed style
								// Support: Firefox <=43 - 45
								// Disconnected elements can have computed display: none, so first confirm that elem is
								// in the document.
								isAttached(elem) &&
								jQuery.css(elem, "display") === "none")
						);
					};

					function adjustCSS(elem, prop, valueParts, tween) {
						var adjusted,
							scale,
							maxIterations = 20,
							currentValue = tween
								? function () {
										return tween.cur();
								  }
								: function () {
										return jQuery.css(elem, prop, "");
								  },
							initial = currentValue(),
							unit =
								(valueParts && valueParts[3]) ||
								(jQuery.cssNumber[prop] ? "" : "px"),
							// Starting value computation is required for potential unit mismatches
							initialInUnit =
								elem.nodeType &&
								(jQuery.cssNumber[prop] || (unit !== "px" && +initial)) &&
								rcssNum.exec(jQuery.css(elem, prop));

						if (initialInUnit && initialInUnit[3] !== unit) {
							// Support: Firefox <=54
							// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
							initial = initial / 2;

							// Trust units reported by jQuery.css
							unit = unit || initialInUnit[3];

							// Iteratively approximate from a nonzero starting point
							initialInUnit = +initial || 1;

							while (maxIterations--) {
								// Evaluate and update our best guess (doubling guesses that zero out).
								// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
								jQuery.style(elem, prop, initialInUnit + unit);
								if (
									(1 - scale) *
										(1 - (scale = currentValue() / initial || 0.5)) <=
									0
								) {
									maxIterations = 0;
								}
								initialInUnit = initialInUnit / scale;
							}

							initialInUnit = initialInUnit * 2;
							jQuery.style(elem, prop, initialInUnit + unit);

							// Make sure we update the tween properties later on
							valueParts = valueParts || [];
						}

						if (valueParts) {
							initialInUnit = +initialInUnit || +initial || 0;

							// Apply relative offset (+=/-=) if specified
							adjusted = valueParts[1]
								? initialInUnit + (valueParts[1] + 1) * valueParts[2]
								: +valueParts[2];
							if (tween) {
								tween.unit = unit;
								tween.start = initialInUnit;
								tween.end = adjusted;
							}
						}
						return adjusted;
					}

					var defaultDisplayMap = {};

					function getDefaultDisplay(elem) {
						var temp,
							doc = elem.ownerDocument,
							nodeName = elem.nodeName,
							display = defaultDisplayMap[nodeName];

						if (display) {
							return display;
						}

						temp = doc.body.appendChild(doc.createElement(nodeName));
						display = jQuery.css(temp, "display");

						temp.parentNode.removeChild(temp);

						if (display === "none") {
							display = "block";
						}
						defaultDisplayMap[nodeName] = display;

						return display;
					}

					function showHide(elements, show) {
						var display,
							elem,
							values = [],
							index = 0,
							length = elements.length;

						// Determine new display value for elements that need to change
						for (; index < length; index++) {
							elem = elements[index];
							if (!elem.style) {
								continue;
							}

							display = elem.style.display;
							if (show) {
								// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
								// check is required in this first loop unless we have a nonempty display value (either
								// inline or about-to-be-restored)
								if (display === "none") {
									values[index] = dataPriv.get(elem, "display") || null;
									if (!values[index]) {
										elem.style.display = "";
									}
								}
								if (elem.style.display === "" && isHiddenWithinTree(elem)) {
									values[index] = getDefaultDisplay(elem);
								}
							} else {
								if (display !== "none") {
									values[index] = "none";

									// Remember what we're overwriting
									dataPriv.set(elem, "display", display);
								}
							}
						}

						// Set the display of the elements in a second loop to avoid constant reflow
						for (index = 0; index < length; index++) {
							if (values[index] != null) {
								elements[index].style.display = values[index];
							}
						}

						return elements;
					}

					jQuery.fn.extend({
						show: function () {
							return showHide(this, true);
						},
						hide: function () {
							return showHide(this);
						},
						toggle: function (state) {
							if (typeof state === "boolean") {
								return state ? this.show() : this.hide();
							}

							return this.each(function () {
								if (isHiddenWithinTree(this)) {
									jQuery(this).show();
								} else {
									jQuery(this).hide();
								}
							});
						},
					});
					var rcheckableType = /^(?:checkbox|radio)$/i;

					var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;

					var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;

					(function () {
						var fragment = document.createDocumentFragment(),
							div = fragment.appendChild(document.createElement("div")),
							input = document.createElement("input");

						// Support: Android 4.0 - 4.3 only
						// Check state lost if the name is set (#11217)
						// Support: Windows Web Apps (WWA)
						// `name` and `type` must use .setAttribute for WWA (#14901)
						input.setAttribute("type", "radio");
						input.setAttribute("checked", "checked");
						input.setAttribute("name", "t");

						div.appendChild(input);

						// Support: Android <=4.1 only
						// Older WebKit doesn't clone checked state correctly in fragments
						support.checkClone = div
							.cloneNode(true)
							.cloneNode(true).lastChild.checked;

						// Support: IE <=11 only
						// Make sure textarea (and checkbox) defaultValue is properly cloned
						div.innerHTML = "<textarea>x</textarea>";
						support.noCloneChecked =
							!!div.cloneNode(true).lastChild.defaultValue;

						// Support: IE <=9 only
						// IE <=9 replaces <option> tags with their contents when inserted outside of
						// the select element.
						div.innerHTML = "<option></option>";
						support.option = !!div.lastChild;
					})();

					// We have to close these tags to support XHTML (#13200)
					var wrapMap = {
						// XHTML parsers do not magically insert elements in the
						// same way that tag soup parsers do. So we cannot shorten
						// this by omitting <tbody> or other required elements.
						thead: [1, "<table>", "</table>"],
						col: [2, "<table><colgroup>", "</colgroup></table>"],
						tr: [2, "<table><tbody>", "</tbody></table>"],
						td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],

						_default: [0, "", ""],
					};

					wrapMap.tbody =
						wrapMap.tfoot =
						wrapMap.colgroup =
						wrapMap.caption =
							wrapMap.thead;
					wrapMap.th = wrapMap.td;

					// Support: IE <=9 only
					if (!support.option) {
						wrapMap.optgroup = wrapMap.option = [
							1,
							"<select multiple='multiple'>",
							"</select>",
						];
					}

					function getAll(context, tag) {
						// Support: IE <=9 - 11 only
						// Use typeof to avoid zero-argument method invocation on host objects (#15151)
						var ret;

						if (typeof context.getElementsByTagName !== "undefined") {
							ret = context.getElementsByTagName(tag || "*");
						} else if (typeof context.querySelectorAll !== "undefined") {
							ret = context.querySelectorAll(tag || "*");
						} else {
							ret = [];
						}

						if (tag === undefined || (tag && nodeName(context, tag))) {
							return jQuery.merge([context], ret);
						}

						return ret;
					}

					// Mark scripts as having already been evaluated
					function setGlobalEval(elems, refElements) {
						var i = 0,
							l = elems.length;

						for (; i < l; i++) {
							dataPriv.set(
								elems[i],
								"globalEval",
								!refElements || dataPriv.get(refElements[i], "globalEval")
							);
						}
					}

					var rhtml = /<|&#?\w+;/;

					function buildFragment(elems, context, scripts, selection, ignored) {
						var elem,
							tmp,
							tag,
							wrap,
							attached,
							j,
							fragment = context.createDocumentFragment(),
							nodes = [],
							i = 0,
							l = elems.length;

						for (; i < l; i++) {
							elem = elems[i];

							if (elem || elem === 0) {
								// Add nodes directly
								if (toType(elem) === "object") {
									// Support: Android <=4.0 only, PhantomJS 1 only
									// push.apply(_, arraylike) throws on ancient WebKit
									jQuery.merge(nodes, elem.nodeType ? [elem] : elem);

									// Convert non-html into a text node
								} else if (!rhtml.test(elem)) {
									nodes.push(context.createTextNode(elem));

									// Convert html into DOM nodes
								} else {
									tmp =
										tmp || fragment.appendChild(context.createElement("div"));

									// Deserialize a standard representation
									tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
									wrap = wrapMap[tag] || wrapMap._default;
									tmp.innerHTML =
										wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];

									// Descend through wrappers to the right content
									j = wrap[0];
									while (j--) {
										tmp = tmp.lastChild;
									}

									// Support: Android <=4.0 only, PhantomJS 1 only
									// push.apply(_, arraylike) throws on ancient WebKit
									jQuery.merge(nodes, tmp.childNodes);

									// Remember the top-level container
									tmp = fragment.firstChild;

									// Ensure the created nodes are orphaned (#12392)
									tmp.textContent = "";
								}
							}
						}

						// Remove wrapper from fragment
						fragment.textContent = "";

						i = 0;
						while ((elem = nodes[i++])) {
							// Skip elements already in the context collection (trac-4087)
							if (selection && jQuery.inArray(elem, selection) > -1) {
								if (ignored) {
									ignored.push(elem);
								}
								continue;
							}

							attached = isAttached(elem);

							// Append to fragment
							tmp = getAll(fragment.appendChild(elem), "script");

							// Preserve script evaluation history
							if (attached) {
								setGlobalEval(tmp);
							}

							// Capture executables
							if (scripts) {
								j = 0;
								while ((elem = tmp[j++])) {
									if (rscriptType.test(elem.type || "")) {
										scripts.push(elem);
									}
								}
							}
						}

						return fragment;
					}

					var rkeyEvent = /^key/,
						rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
						rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

					function returnTrue() {
						return true;
					}

					function returnFalse() {
						return false;
					}

					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous, except when they are no-op.
					// So expect focus to be synchronous when the element is already active,
					// and blur to be synchronous when the element is not already active.
					// (focus and blur are always synchronous in other supported browsers,
					// this just defines when we can count on it).
					function expectSync(elem, type) {
						return (elem === safeActiveElement()) === (type === "focus");
					}

					// Support: IE <=9 only
					// Accessing document.activeElement can throw unexpectedly
					// https://bugs.jquery.com/ticket/13393
					function safeActiveElement() {
						try {
							return document.activeElement;
						} catch (err) {}
					}

					function on(elem, types, selector, data, fn, one) {
						var origFn, type;

						// Types can be a map of types/handlers
						if (typeof types === "object") {
							// ( types-Object, selector, data )
							if (typeof selector !== "string") {
								// ( types-Object, data )
								data = data || selector;
								selector = undefined;
							}
							for (type in types) {
								on(elem, type, selector, data, types[type], one);
							}
							return elem;
						}

						if (data == null && fn == null) {
							// ( types, fn )
							fn = selector;
							data = selector = undefined;
						} else if (fn == null) {
							if (typeof selector === "string") {
								// ( types, selector, fn )
								fn = data;
								data = undefined;
							} else {
								// ( types, data, fn )
								fn = data;
								data = selector;
								selector = undefined;
							}
						}
						if (fn === false) {
							fn = returnFalse;
						} else if (!fn) {
							return elem;
						}

						if (one === 1) {
							origFn = fn;
							fn = function (event) {
								// Can use an empty set, since event contains the info
								jQuery().off(event);
								return origFn.apply(this, arguments);
							};

							// Use same guid so caller can remove using origFn
							fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
						}
						return elem.each(function () {
							jQuery.event.add(this, types, fn, data, selector);
						});
					}

					/*
					 * Helper functions for managing events -- not part of the public interface.
					 * Props to Dean Edwards' addEvent library for many of the ideas.
					 */
					jQuery.event = {
						global: {},

						add: function (elem, types, handler, data, selector) {
							var handleObjIn,
								eventHandle,
								tmp,
								events,
								t,
								handleObj,
								special,
								handlers,
								type,
								namespaces,
								origType,
								elemData = dataPriv.get(elem);

							// Only attach events to objects that accept data
							if (!acceptData(elem)) {
								return;
							}

							// Caller can pass in an object of custom data in lieu of the handler
							if (handler.handler) {
								handleObjIn = handler;
								handler = handleObjIn.handler;
								selector = handleObjIn.selector;
							}

							// Ensure that invalid selectors throw exceptions at attach time
							// Evaluate against documentElement in case elem is a non-element node (e.g., document)
							if (selector) {
								jQuery.find.matchesSelector(documentElement, selector);
							}

							// Make sure that the handler has a unique ID, used to find/remove it later
							if (!handler.guid) {
								handler.guid = jQuery.guid++;
							}

							// Init the element's event structure and main handler, if this is the first
							if (!(events = elemData.events)) {
								events = elemData.events = Object.create(null);
							}
							if (!(eventHandle = elemData.handle)) {
								eventHandle = elemData.handle = function (e) {
									// Discard the second event of a jQuery.event.trigger() and
									// when an event is called after a page has unloaded
									return typeof jQuery !== "undefined" &&
										jQuery.event.triggered !== e.type
										? jQuery.event.dispatch.apply(elem, arguments)
										: undefined;
								};
							}

							// Handle multiple events separated by a space
							types = (types || "").match(rnothtmlwhite) || [""];
							t = types.length;
							while (t--) {
								tmp = rtypenamespace.exec(types[t]) || [];
								type = origType = tmp[1];
								namespaces = (tmp[2] || "").split(".").sort();

								// There *must* be a type, no attaching namespace-only handlers
								if (!type) {
									continue;
								}

								// If event changes its type, use the special event handlers for the changed type
								special = jQuery.event.special[type] || {};

								// If selector defined, determine special event api type, otherwise given type
								type =
									(selector ? special.delegateType : special.bindType) || type;

								// Update special based on newly reset type
								special = jQuery.event.special[type] || {};

								// handleObj is passed to all event handlers
								handleObj = jQuery.extend(
									{
										type: type,
										origType: origType,
										data: data,
										handler: handler,
										guid: handler.guid,
										selector: selector,
										needsContext:
											selector && jQuery.expr.match.needsContext.test(selector),
										namespace: namespaces.join("."),
									},
									handleObjIn
								);

								// Init the event handler queue if we're the first
								if (!(handlers = events[type])) {
									handlers = events[type] = [];
									handlers.delegateCount = 0;

									// Only use addEventListener if the special events handler returns false
									if (
										!special.setup ||
										special.setup.call(elem, data, namespaces, eventHandle) ===
											false
									) {
										if (elem.addEventListener) {
											elem.addEventListener(type, eventHandle);
										}
									}
								}

								if (special.add) {
									special.add.call(elem, handleObj);

									if (!handleObj.handler.guid) {
										handleObj.handler.guid = handler.guid;
									}
								}

								// Add to the element's handler list, delegates in front
								if (selector) {
									handlers.splice(handlers.delegateCount++, 0, handleObj);
								} else {
									handlers.push(handleObj);
								}

								// Keep track of which events have ever been used, for event optimization
								jQuery.event.global[type] = true;
							}
						},

						// Detach an event or set of events from an element
						remove: function (elem, types, handler, selector, mappedTypes) {
							var j,
								origCount,
								tmp,
								events,
								t,
								handleObj,
								special,
								handlers,
								type,
								namespaces,
								origType,
								elemData = dataPriv.hasData(elem) && dataPriv.get(elem);

							if (!elemData || !(events = elemData.events)) {
								return;
							}

							// Once for each type.namespace in types; type may be omitted
							types = (types || "").match(rnothtmlwhite) || [""];
							t = types.length;
							while (t--) {
								tmp = rtypenamespace.exec(types[t]) || [];
								type = origType = tmp[1];
								namespaces = (tmp[2] || "").split(".").sort();

								// Unbind all events (on this namespace, if provided) for the element
								if (!type) {
									for (type in events) {
										jQuery.event.remove(
											elem,
											type + types[t],
											handler,
											selector,
											true
										);
									}
									continue;
								}

								special = jQuery.event.special[type] || {};
								type =
									(selector ? special.delegateType : special.bindType) || type;
								handlers = events[type] || [];
								tmp =
									tmp[2] &&
									new RegExp(
										"(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)"
									);

								// Remove matching events
								origCount = j = handlers.length;
								while (j--) {
									handleObj = handlers[j];

									if (
										(mappedTypes || origType === handleObj.origType) &&
										(!handler || handler.guid === handleObj.guid) &&
										(!tmp || tmp.test(handleObj.namespace)) &&
										(!selector ||
											selector === handleObj.selector ||
											(selector === "**" && handleObj.selector))
									) {
										handlers.splice(j, 1);

										if (handleObj.selector) {
											handlers.delegateCount--;
										}
										if (special.remove) {
											special.remove.call(elem, handleObj);
										}
									}
								}

								// Remove generic event handler if we removed something and no more handlers exist
								// (avoids potential for endless recursion during removal of special event handlers)
								if (origCount && !handlers.length) {
									if (
										!special.teardown ||
										special.teardown.call(elem, namespaces, elemData.handle) ===
											false
									) {
										jQuery.removeEvent(elem, type, elemData.handle);
									}

									delete events[type];
								}
							}

							// Remove data and the expando if it's no longer used
							if (jQuery.isEmptyObject(events)) {
								dataPriv.remove(elem, "handle events");
							}
						},

						dispatch: function (nativeEvent) {
							var i,
								j,
								ret,
								matched,
								handleObj,
								handlerQueue,
								args = new Array(arguments.length),
								// Make a writable jQuery.Event from the native event object
								event = jQuery.event.fix(nativeEvent),
								handlers =
									(dataPriv.get(this, "events") || Object.create(null))[
										event.type
									] || [],
								special = jQuery.event.special[event.type] || {};

							// Use the fix-ed jQuery.Event rather than the (read-only) native event
							args[0] = event;

							for (i = 1; i < arguments.length; i++) {
								args[i] = arguments[i];
							}

							event.delegateTarget = this;

							// Call the preDispatch hook for the mapped type, and let it bail if desired
							if (
								special.preDispatch &&
								special.preDispatch.call(this, event) === false
							) {
								return;
							}

							// Determine handlers
							handlerQueue = jQuery.event.handlers.call(this, event, handlers);

							// Run delegates first; they may want to stop propagation beneath us
							i = 0;
							while (
								(matched = handlerQueue[i++]) &&
								!event.isPropagationStopped()
							) {
								event.currentTarget = matched.elem;

								j = 0;
								while (
									(handleObj = matched.handlers[j++]) &&
									!event.isImmediatePropagationStopped()
								) {
									// If the event is namespaced, then each handler is only invoked if it is
									// specially universal or its namespaces are a superset of the event's.
									if (
										!event.rnamespace ||
										handleObj.namespace === false ||
										event.rnamespace.test(handleObj.namespace)
									) {
										event.handleObj = handleObj;
										event.data = handleObj.data;

										ret = (
											(jQuery.event.special[handleObj.origType] || {}).handle ||
											handleObj.handler
										).apply(matched.elem, args);

										if (ret !== undefined) {
											if ((event.result = ret) === false) {
												event.preventDefault();
												event.stopPropagation();
											}
										}
									}
								}
							}

							// Call the postDispatch hook for the mapped type
							if (special.postDispatch) {
								special.postDispatch.call(this, event);
							}

							return event.result;
						},

						handlers: function (event, handlers) {
							var i,
								handleObj,
								sel,
								matchedHandlers,
								matchedSelectors,
								handlerQueue = [],
								delegateCount = handlers.delegateCount,
								cur = event.target;

							// Find delegate handlers
							if (
								delegateCount &&
								// Support: IE <=9
								// Black-hole SVG <use> instance trees (trac-13180)
								cur.nodeType &&
								// Support: Firefox <=42
								// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
								// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
								// Support: IE 11 only
								// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
								!(event.type === "click" && event.button >= 1)
							) {
								for (; cur !== this; cur = cur.parentNode || this) {
									// Don't check non-elements (#13208)
									// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
									if (
										cur.nodeType === 1 &&
										!(event.type === "click" && cur.disabled === true)
									) {
										matchedHandlers = [];
										matchedSelectors = {};
										for (i = 0; i < delegateCount; i++) {
											handleObj = handlers[i];

											// Don't conflict with Object.prototype properties (#13203)
											sel = handleObj.selector + " ";

											if (matchedSelectors[sel] === undefined) {
												matchedSelectors[sel] = handleObj.needsContext
													? jQuery(sel, this).index(cur) > -1
													: jQuery.find(sel, this, null, [cur]).length;
											}
											if (matchedSelectors[sel]) {
												matchedHandlers.push(handleObj);
											}
										}
										if (matchedHandlers.length) {
											handlerQueue.push({
												elem: cur,
												handlers: matchedHandlers,
											});
										}
									}
								}
							}

							// Add the remaining (directly-bound) handlers
							cur = this;
							if (delegateCount < handlers.length) {
								handlerQueue.push({
									elem: cur,
									handlers: handlers.slice(delegateCount),
								});
							}

							return handlerQueue;
						},

						addProp: function (name, hook) {
							Object.defineProperty(jQuery.Event.prototype, name, {
								enumerable: true,
								configurable: true,

								get: isFunction(hook)
									? function () {
											if (this.originalEvent) {
												return hook(this.originalEvent);
											}
									  }
									: function () {
											if (this.originalEvent) {
												return this.originalEvent[name];
											}
									  },

								set: function (value) {
									Object.defineProperty(this, name, {
										enumerable: true,
										configurable: true,
										writable: true,
										value: value,
									});
								},
							});
						},

						fix: function (originalEvent) {
							return originalEvent[jQuery.expando]
								? originalEvent
								: new jQuery.Event(originalEvent);
						},

						special: {
							load: {
								// Prevent triggered image.load events from bubbling to window.load
								noBubble: true,
							},
							click: {
								// Utilize native event to ensure correct state for checkable inputs
								setup: function (data) {
									// For mutual compressibility with _default, replace `this` access with a local var.
									// `|| data` is dead code meant only to preserve the variable through minification.
									var el = this || data;

									// Claim the first handler
									if (
										rcheckableType.test(el.type) &&
										el.click &&
										nodeName(el, "input")
									) {
										// dataPriv.set( el, "click", ... )
										leverageNative(el, "click", returnTrue);
									}

									// Return false to allow normal processing in the caller
									return false;
								},
								trigger: function (data) {
									// For mutual compressibility with _default, replace `this` access with a local var.
									// `|| data` is dead code meant only to preserve the variable through minification.
									var el = this || data;

									// Force setup before triggering a click
									if (
										rcheckableType.test(el.type) &&
										el.click &&
										nodeName(el, "input")
									) {
										leverageNative(el, "click");
									}

									// Return non-false to allow normal event-path propagation
									return true;
								},

								// For cross-browser consistency, suppress native .click() on links
								// Also prevent it if we're currently inside a leveraged native-event stack
								_default: function (event) {
									var target = event.target;
									return (
										(rcheckableType.test(target.type) &&
											target.click &&
											nodeName(target, "input") &&
											dataPriv.get(target, "click")) ||
										nodeName(target, "a")
									);
								},
							},

							beforeunload: {
								postDispatch: function (event) {
									// Support: Firefox 20+
									// Firefox doesn't alert if the returnValue field is not set.
									if (event.result !== undefined && event.originalEvent) {
										event.originalEvent.returnValue = event.result;
									}
								},
							},
						},
					};

					// Ensure the presence of an event listener that handles manually-triggered
					// synthetic events by interrupting progress until reinvoked in response to
					// *native* events that it fires directly, ensuring that state changes have
					// already occurred before other listeners are invoked.
					function leverageNative(el, type, expectSync) {
						// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
						if (!expectSync) {
							if (dataPriv.get(el, type) === undefined) {
								jQuery.event.add(el, type, returnTrue);
							}
							return;
						}

						// Register the controller as a special universal handler for all event namespaces
						dataPriv.set(el, type, false);
						jQuery.event.add(el, type, {
							namespace: false,
							handler: function (event) {
								var notAsync,
									result,
									saved = dataPriv.get(this, type);

								if (event.isTrigger & 1 && this[type]) {
									// Interrupt processing of the outer synthetic .trigger()ed event
									// Saved data should be false in such cases, but might be a leftover capture object
									// from an async native handler (gh-4350)
									if (!saved.length) {
										// Store arguments for use when handling the inner native event
										// There will always be at least one argument (an event object), so this array
										// will not be confused with a leftover capture object.
										saved = slice.call(arguments);
										dataPriv.set(this, type, saved);

										// Trigger the native event and capture its result
										// Support: IE <=9 - 11+
										// focus() and blur() are asynchronous
										notAsync = expectSync(this, type);
										this[type]();
										result = dataPriv.get(this, type);
										if (saved !== result || notAsync) {
											dataPriv.set(this, type, false);
										} else {
											result = {};
										}
										if (saved !== result) {
											// Cancel the outer synthetic event
											event.stopImmediatePropagation();
											event.preventDefault();
											return result.value;
										}

										// If this is an inner synthetic event for an event with a bubbling surrogate
										// (focus or blur), assume that the surrogate already propagated from triggering the
										// native event and prevent that from happening again here.
										// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
										// bubbling surrogate propagates *after* the non-bubbling base), but that seems
										// less bad than duplication.
									} else if ((jQuery.event.special[type] || {}).delegateType) {
										event.stopPropagation();
									}

									// If this is a native event triggered above, everything is now in order
									// Fire an inner synthetic event with the original arguments
								} else if (saved.length) {
									// ...and capture the result
									dataPriv.set(this, type, {
										value: jQuery.event.trigger(
											// Support: IE <=9 - 11+
											// Extend with the prototype to reset the above stopImmediatePropagation()
											jQuery.extend(saved[0], jQuery.Event.prototype),
											saved.slice(1),
											this
										),
									});

									// Abort handling of the native event
									event.stopImmediatePropagation();
								}
							},
						});
					}

					jQuery.removeEvent = function (elem, type, handle) {
						// This "if" is needed for plain objects
						if (elem.removeEventListener) {
							elem.removeEventListener(type, handle);
						}
					};

					jQuery.Event = function (src, props) {
						// Allow instantiation without the 'new' keyword
						if (!(this instanceof jQuery.Event)) {
							return new jQuery.Event(src, props);
						}

						// Event object
						if (src && src.type) {
							this.originalEvent = src;
							this.type = src.type;

							// Events bubbling up the document may have been marked as prevented
							// by a handler lower down the tree; reflect the correct value.
							this.isDefaultPrevented =
								src.defaultPrevented ||
								(src.defaultPrevented === undefined &&
									// Support: Android <=2.3 only
									src.returnValue === false)
									? returnTrue
									: returnFalse;

							// Create target properties
							// Support: Safari <=6 - 7 only
							// Target should not be a text node (#504, #13143)
							this.target =
								src.target && src.target.nodeType === 3
									? src.target.parentNode
									: src.target;

							this.currentTarget = src.currentTarget;
							this.relatedTarget = src.relatedTarget;

							// Event type
						} else {
							this.type = src;
						}

						// Put explicitly provided properties onto the event object
						if (props) {
							jQuery.extend(this, props);
						}

						// Create a timestamp if incoming event doesn't have one
						this.timeStamp = (src && src.timeStamp) || Date.now();

						// Mark it as fixed
						this[jQuery.expando] = true;
					};

					// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
					// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
					jQuery.Event.prototype = {
						constructor: jQuery.Event,
						isDefaultPrevented: returnFalse,
						isPropagationStopped: returnFalse,
						isImmediatePropagationStopped: returnFalse,
						isSimulated: false,

						preventDefault: function () {
							var e = this.originalEvent;

							this.isDefaultPrevented = returnTrue;

							if (e && !this.isSimulated) {
								e.preventDefault();
							}
						},
						stopPropagation: function () {
							var e = this.originalEvent;

							this.isPropagationStopped = returnTrue;

							if (e && !this.isSimulated) {
								e.stopPropagation();
							}
						},
						stopImmediatePropagation: function () {
							var e = this.originalEvent;

							this.isImmediatePropagationStopped = returnTrue;

							if (e && !this.isSimulated) {
								e.stopImmediatePropagation();
							}

							this.stopPropagation();
						},
					};

					// Includes all common event props including KeyEvent and MouseEvent specific props
					jQuery.each(
						{
							altKey: true,
							bubbles: true,
							cancelable: true,
							changedTouches: true,
							ctrlKey: true,
							detail: true,
							eventPhase: true,
							metaKey: true,
							pageX: true,
							pageY: true,
							shiftKey: true,
							view: true,
							char: true,
							code: true,
							charCode: true,
							key: true,
							keyCode: true,
							button: true,
							buttons: true,
							clientX: true,
							clientY: true,
							offsetX: true,
							offsetY: true,
							pointerId: true,
							pointerType: true,
							screenX: true,
							screenY: true,
							targetTouches: true,
							toElement: true,
							touches: true,

							which: function (event) {
								var button = event.button;

								// Add which for key events
								if (event.which == null && rkeyEvent.test(event.type)) {
									return event.charCode != null
										? event.charCode
										: event.keyCode;
								}

								// Add which for click: 1 === left; 2 === middle; 3 === right
								if (
									!event.which &&
									button !== undefined &&
									rmouseEvent.test(event.type)
								) {
									if (button & 1) {
										return 1;
									}

									if (button & 2) {
										return 3;
									}

									if (button & 4) {
										return 2;
									}

									return 0;
								}

								return event.which;
							},
						},
						jQuery.event.addProp
					);

					jQuery.each(
						{ focus: "focusin", blur: "focusout" },
						function (type, delegateType) {
							jQuery.event.special[type] = {
								// Utilize native event if possible so blur/focus sequence is correct
								setup: function () {
									// Claim the first handler
									// dataPriv.set( this, "focus", ... )
									// dataPriv.set( this, "blur", ... )
									leverageNative(this, type, expectSync);

									// Return false to allow normal processing in the caller
									return false;
								},
								trigger: function () {
									// Force setup before trigger
									leverageNative(this, type);

									// Return non-false to allow normal event-path propagation
									return true;
								},

								delegateType: delegateType,
							};
						}
					);

					// Create mouseenter/leave events using mouseover/out and event-time checks
					// so that event delegation works in jQuery.
					// Do the same for pointerenter/pointerleave and pointerover/pointerout
					//
					// Support: Safari 7 only
					// Safari sends mouseenter too often; see:
					// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
					// for the description of the bug (it existed in older Chrome versions as well).
					jQuery.each(
						{
							mouseenter: "mouseover",
							mouseleave: "mouseout",
							pointerenter: "pointerover",
							pointerleave: "pointerout",
						},
						function (orig, fix) {
							jQuery.event.special[orig] = {
								delegateType: fix,
								bindType: fix,

								handle: function (event) {
									var ret,
										target = this,
										related = event.relatedTarget,
										handleObj = event.handleObj;

									// For mouseenter/leave call the handler if related is outside the target.
									// NB: No relatedTarget if the mouse left/entered the browser window
									if (
										!related ||
										(related !== target && !jQuery.contains(target, related))
									) {
										event.type = handleObj.origType;
										ret = handleObj.handler.apply(this, arguments);
										event.type = fix;
									}
									return ret;
								},
							};
						}
					);

					jQuery.fn.extend({
						on: function (types, selector, data, fn) {
							return on(this, types, selector, data, fn);
						},
						one: function (types, selector, data, fn) {
							return on(this, types, selector, data, fn, 1);
						},
						off: function (types, selector, fn) {
							var handleObj, type;
							if (types && types.preventDefault && types.handleObj) {
								// ( event )  dispatched jQuery.Event
								handleObj = types.handleObj;
								jQuery(types.delegateTarget).off(
									handleObj.namespace
										? handleObj.origType + "." + handleObj.namespace
										: handleObj.origType,
									handleObj.selector,
									handleObj.handler
								);
								return this;
							}
							if (typeof types === "object") {
								// ( types-object [, selector] )
								for (type in types) {
									this.off(type, selector, types[type]);
								}
								return this;
							}
							if (selector === false || typeof selector === "function") {
								// ( types [, fn] )
								fn = selector;
								selector = undefined;
							}
							if (fn === false) {
								fn = returnFalse;
							}
							return this.each(function () {
								jQuery.event.remove(this, types, fn, selector);
							});
						},
					});

					var // Support: IE <=10 - 11, Edge 12 - 13 only
						// In IE/Edge using regex groups here causes severe slowdowns.
						// See https://connect.microsoft.com/IE/feedback/details/1736512/
						rnoInnerhtml = /<script|<style|<link/i,
						// checked="checked" or checked
						rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
						rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

					// Prefer a tbody over its parent table for containing new rows
					function manipulationTarget(elem, content) {
						if (
							nodeName(elem, "table") &&
							nodeName(
								content.nodeType !== 11 ? content : content.firstChild,
								"tr"
							)
						) {
							return jQuery(elem).children("tbody")[0] || elem;
						}

						return elem;
					}

					// Replace/restore the type attribute of script elements for safe DOM manipulation
					function disableScript(elem) {
						elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
						return elem;
					}
					function restoreScript(elem) {
						if ((elem.type || "").slice(0, 5) === "true/") {
							elem.type = elem.type.slice(5);
						} else {
							elem.removeAttribute("type");
						}

						return elem;
					}

					function cloneCopyEvent(src, dest) {
						var i, l, type, pdataOld, udataOld, udataCur, events;

						if (dest.nodeType !== 1) {
							return;
						}

						// 1. Copy private data: events, handlers, etc.
						if (dataPriv.hasData(src)) {
							pdataOld = dataPriv.get(src);
							events = pdataOld.events;

							if (events) {
								dataPriv.remove(dest, "handle events");

								for (type in events) {
									for (i = 0, l = events[type].length; i < l; i++) {
										jQuery.event.add(dest, type, events[type][i]);
									}
								}
							}
						}

						// 2. Copy user data
						if (dataUser.hasData(src)) {
							udataOld = dataUser.access(src);
							udataCur = jQuery.extend({}, udataOld);

							dataUser.set(dest, udataCur);
						}
					}

					// Fix IE bugs, see support tests
					function fixInput(src, dest) {
						var nodeName = dest.nodeName.toLowerCase();

						// Fails to persist the checked state of a cloned checkbox or radio button.
						if (nodeName === "input" && rcheckableType.test(src.type)) {
							dest.checked = src.checked;

							// Fails to return the selected option to the default selected state when cloning options
						} else if (nodeName === "input" || nodeName === "textarea") {
							dest.defaultValue = src.defaultValue;
						}
					}

					function domManip(collection, args, callback, ignored) {
						// Flatten any nested arrays
						args = flat(args);

						var fragment,
							first,
							scripts,
							hasScripts,
							node,
							doc,
							i = 0,
							l = collection.length,
							iNoClone = l - 1,
							value = args[0],
							valueIsFunction = isFunction(value);

						// We can't cloneNode fragments that contain checked, in WebKit
						if (
							valueIsFunction ||
							(l > 1 &&
								typeof value === "string" &&
								!support.checkClone &&
								rchecked.test(value))
						) {
							return collection.each(function (index) {
								var self = collection.eq(index);
								if (valueIsFunction) {
									args[0] = value.call(this, index, self.html());
								}
								domManip(self, args, callback, ignored);
							});
						}

						if (l) {
							fragment = buildFragment(
								args,
								collection[0].ownerDocument,
								false,
								collection,
								ignored
							);
							first = fragment.firstChild;

							if (fragment.childNodes.length === 1) {
								fragment = first;
							}

							// Require either new content or an interest in ignored elements to invoke the callback
							if (first || ignored) {
								scripts = jQuery.map(getAll(fragment, "script"), disableScript);
								hasScripts = scripts.length;

								// Use the original fragment for the last item
								// instead of the first because it can end up
								// being emptied incorrectly in certain situations (#8070).
								for (; i < l; i++) {
									node = fragment;

									if (i !== iNoClone) {
										node = jQuery.clone(node, true, true);

										// Keep references to cloned scripts for later restoration
										if (hasScripts) {
											// Support: Android <=4.0 only, PhantomJS 1 only
											// push.apply(_, arraylike) throws on ancient WebKit
											jQuery.merge(scripts, getAll(node, "script"));
										}
									}

									callback.call(collection[i], node, i);
								}

								if (hasScripts) {
									doc = scripts[scripts.length - 1].ownerDocument;

									// Reenable scripts
									jQuery.map(scripts, restoreScript);

									// Evaluate executable scripts on first document insertion
									for (i = 0; i < hasScripts; i++) {
										node = scripts[i];
										if (
											rscriptType.test(node.type || "") &&
											!dataPriv.access(node, "globalEval") &&
											jQuery.contains(doc, node)
										) {
											if (
												node.src &&
												(node.type || "").toLowerCase() !== "module"
											) {
												// Optional AJAX dependency, but won't run scripts if not present
												if (jQuery._evalUrl && !node.noModule) {
													jQuery._evalUrl(
														node.src,
														{
															nonce: node.nonce || node.getAttribute("nonce"),
														},
														doc
													);
												}
											} else {
												DOMEval(
													node.textContent.replace(rcleanScript, ""),
													node,
													doc
												);
											}
										}
									}
								}
							}
						}

						return collection;
					}

					function remove(elem, selector, keepData) {
						var node,
							nodes = selector ? jQuery.filter(selector, elem) : elem,
							i = 0;

						for (; (node = nodes[i]) != null; i++) {
							if (!keepData && node.nodeType === 1) {
								jQuery.cleanData(getAll(node));
							}

							if (node.parentNode) {
								if (keepData && isAttached(node)) {
									setGlobalEval(getAll(node, "script"));
								}
								node.parentNode.removeChild(node);
							}
						}

						return elem;
					}

					jQuery.extend({
						htmlPrefilter: function (html) {
							return html;
						},

						clone: function (elem, dataAndEvents, deepDataAndEvents) {
							var i,
								l,
								srcElements,
								destElements,
								clone = elem.cloneNode(true),
								inPage = isAttached(elem);

							// Fix IE cloning issues
							if (
								!support.noCloneChecked &&
								(elem.nodeType === 1 || elem.nodeType === 11) &&
								!jQuery.isXMLDoc(elem)
							) {
								// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
								destElements = getAll(clone);
								srcElements = getAll(elem);

								for (i = 0, l = srcElements.length; i < l; i++) {
									fixInput(srcElements[i], destElements[i]);
								}
							}

							// Copy the events from the original to the clone
							if (dataAndEvents) {
								if (deepDataAndEvents) {
									srcElements = srcElements || getAll(elem);
									destElements = destElements || getAll(clone);

									for (i = 0, l = srcElements.length; i < l; i++) {
										cloneCopyEvent(srcElements[i], destElements[i]);
									}
								} else {
									cloneCopyEvent(elem, clone);
								}
							}

							// Preserve script evaluation history
							destElements = getAll(clone, "script");
							if (destElements.length > 0) {
								setGlobalEval(destElements, !inPage && getAll(elem, "script"));
							}

							// Return the cloned set
							return clone;
						},

						cleanData: function (elems) {
							var data,
								elem,
								type,
								special = jQuery.event.special,
								i = 0;

							for (; (elem = elems[i]) !== undefined; i++) {
								if (acceptData(elem)) {
									if ((data = elem[dataPriv.expando])) {
										if (data.events) {
											for (type in data.events) {
												if (special[type]) {
													jQuery.event.remove(elem, type);

													// This is a shortcut to avoid jQuery.event.remove's overhead
												} else {
													jQuery.removeEvent(elem, type, data.handle);
												}
											}
										}

										// Support: Chrome <=35 - 45+
										// Assign undefined instead of using delete, see Data#remove
										elem[dataPriv.expando] = undefined;
									}
									if (elem[dataUser.expando]) {
										// Support: Chrome <=35 - 45+
										// Assign undefined instead of using delete, see Data#remove
										elem[dataUser.expando] = undefined;
									}
								}
							}
						},
					});

					jQuery.fn.extend({
						detach: function (selector) {
							return remove(this, selector, true);
						},

						remove: function (selector) {
							return remove(this, selector);
						},

						text: function (value) {
							return access(
								this,
								function (value) {
									return value === undefined
										? jQuery.text(this)
										: this.empty().each(function () {
												if (
													this.nodeType === 1 ||
													this.nodeType === 11 ||
													this.nodeType === 9
												) {
													this.textContent = value;
												}
										  });
								},
								null,
								value,
								arguments.length
							);
						},

						append: function () {
							return domManip(this, arguments, function (elem) {
								if (
									this.nodeType === 1 ||
									this.nodeType === 11 ||
									this.nodeType === 9
								) {
									var target = manipulationTarget(this, elem);
									target.appendChild(elem);
								}
							});
						},

						prepend: function () {
							return domManip(this, arguments, function (elem) {
								if (
									this.nodeType === 1 ||
									this.nodeType === 11 ||
									this.nodeType === 9
								) {
									var target = manipulationTarget(this, elem);
									target.insertBefore(elem, target.firstChild);
								}
							});
						},

						before: function () {
							return domManip(this, arguments, function (elem) {
								if (this.parentNode) {
									this.parentNode.insertBefore(elem, this);
								}
							});
						},

						after: function () {
							return domManip(this, arguments, function (elem) {
								if (this.parentNode) {
									this.parentNode.insertBefore(elem, this.nextSibling);
								}
							});
						},

						empty: function () {
							var elem,
								i = 0;

							for (; (elem = this[i]) != null; i++) {
								if (elem.nodeType === 1) {
									// Prevent memory leaks
									jQuery.cleanData(getAll(elem, false));

									// Remove any remaining nodes
									elem.textContent = "";
								}
							}

							return this;
						},

						clone: function (dataAndEvents, deepDataAndEvents) {
							dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
							deepDataAndEvents =
								deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

							return this.map(function () {
								return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
							});
						},

						html: function (value) {
							return access(
								this,
								function (value) {
									var elem = this[0] || {},
										i = 0,
										l = this.length;

									if (value === undefined && elem.nodeType === 1) {
										return elem.innerHTML;
									}

									// See if we can take a shortcut and just use innerHTML
									if (
										typeof value === "string" &&
										!rnoInnerhtml.test(value) &&
										!wrapMap[
											(rtagName.exec(value) || ["", ""])[1].toLowerCase()
										]
									) {
										value = jQuery.htmlPrefilter(value);

										try {
											for (; i < l; i++) {
												elem = this[i] || {};

												// Remove element nodes and prevent memory leaks
												if (elem.nodeType === 1) {
													jQuery.cleanData(getAll(elem, false));
													elem.innerHTML = value;
												}
											}

											elem = 0;

											// If using innerHTML throws an exception, use the fallback method
										} catch (e) {}
									}

									if (elem) {
										this.empty().append(value);
									}
								},
								null,
								value,
								arguments.length
							);
						},

						replaceWith: function () {
							var ignored = [];

							// Make the changes, replacing each non-ignored context element with the new content
							return domManip(
								this,
								arguments,
								function (elem) {
									var parent = this.parentNode;

									if (jQuery.inArray(this, ignored) < 0) {
										jQuery.cleanData(getAll(this));
										if (parent) {
											parent.replaceChild(elem, this);
										}
									}

									// Force callback invocation
								},
								ignored
							);
						},
					});

					jQuery.each(
						{
							appendTo: "append",
							prependTo: "prepend",
							insertBefore: "before",
							insertAfter: "after",
							replaceAll: "replaceWith",
						},
						function (name, original) {
							jQuery.fn[name] = function (selector) {
								var elems,
									ret = [],
									insert = jQuery(selector),
									last = insert.length - 1,
									i = 0;

								for (; i <= last; i++) {
									elems = i === last ? this : this.clone(true);
									jQuery(insert[i])[original](elems);

									// Support: Android <=4.0 only, PhantomJS 1 only
									// .get() because push.apply(_, arraylike) throws on ancient WebKit
									push.apply(ret, elems.get());
								}

								return this.pushStack(ret);
							};
						}
					);
					var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");

					var getStyles = function (elem) {
						// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
						// IE throws on elements created in popups
						// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
						var view = elem.ownerDocument.defaultView;

						if (!view || !view.opener) {
							view = window;
						}

						return view.getComputedStyle(elem);
					};

					var swap = function (elem, options, callback) {
						var ret,
							name,
							old = {};

						// Remember the old values, and insert the new ones
						for (name in options) {
							old[name] = elem.style[name];
							elem.style[name] = options[name];
						}

						ret = callback.call(elem);

						// Revert the old values
						for (name in options) {
							elem.style[name] = old[name];
						}

						return ret;
					};

					var rboxStyle = new RegExp(cssExpand.join("|"), "i");

					(function () {
						// Executing both pixelPosition & boxSizingReliable tests require only one layout
						// so they're executed at the same time to save the second computation.
						function computeStyleTests() {
							// This is a singleton, we need to execute it only once
							if (!div) {
								return;
							}

							container.style.cssText =
								"position:absolute;left:-11111px;width:60px;" +
								"margin-top:1px;padding:0;border:0";
							div.style.cssText =
								"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
								"margin:auto;border:1px;padding:1px;" +
								"width:60%;top:1%";
							documentElement.appendChild(container).appendChild(div);

							var divStyle = window.getComputedStyle(div);
							pixelPositionVal = divStyle.top !== "1%";

							// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
							reliableMarginLeftVal =
								roundPixelMeasures(divStyle.marginLeft) === 12;

							// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
							// Some styles come back with percentage values, even though they shouldn't
							div.style.right = "60%";
							pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;

							// Support: IE 9 - 11 only
							// Detect misreporting of content dimensions for box-sizing:border-box elements
							boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;

							// Support: IE 9 only
							// Detect overflow:scroll screwiness (gh-3699)
							// Support: Chrome <=64
							// Don't get tricked when zoom affects offsetWidth (gh-4029)
							div.style.position = "absolute";
							scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;

							documentElement.removeChild(container);

							// Nullify the div so it wouldn't be stored in the memory and
							// it will also be a sign that checks already performed
							div = null;
						}

						function roundPixelMeasures(measure) {
							return Math.round(parseFloat(measure));
						}

						var pixelPositionVal,
							boxSizingReliableVal,
							scrollboxSizeVal,
							pixelBoxStylesVal,
							reliableTrDimensionsVal,
							reliableMarginLeftVal,
							container = document.createElement("div"),
							div = document.createElement("div");

						// Finish early in limited (non-browser) environments
						if (!div.style) {
							return;
						}

						// Support: IE <=9 - 11 only
						// Style of cloned element affects source element cloned (#8908)
						div.style.backgroundClip = "content-box";
						div.cloneNode(true).style.backgroundClip = "";
						support.clearCloneStyle =
							div.style.backgroundClip === "content-box";

						jQuery.extend(support, {
							boxSizingReliable: function () {
								computeStyleTests();
								return boxSizingReliableVal;
							},
							pixelBoxStyles: function () {
								computeStyleTests();
								return pixelBoxStylesVal;
							},
							pixelPosition: function () {
								computeStyleTests();
								return pixelPositionVal;
							},
							reliableMarginLeft: function () {
								computeStyleTests();
								return reliableMarginLeftVal;
							},
							scrollboxSize: function () {
								computeStyleTests();
								return scrollboxSizeVal;
							},

							// Support: IE 9 - 11+, Edge 15 - 18+
							// IE/Edge misreport `getComputedStyle` of table rows with width/height
							// set in CSS while `offset*` properties report correct values.
							// Behavior in IE 9 is more subtle than in newer versions & it passes
							// some versions of this test; make sure not to make it pass there!
							reliableTrDimensions: function () {
								var table, tr, trChild, trStyle;
								if (reliableTrDimensionsVal == null) {
									table = document.createElement("table");
									tr = document.createElement("tr");
									trChild = document.createElement("div");

									table.style.cssText = "position:absolute;left:-11111px";
									tr.style.height = "1px";
									trChild.style.height = "9px";

									documentElement
										.appendChild(table)
										.appendChild(tr)
										.appendChild(trChild);

									trStyle = window.getComputedStyle(tr);
									reliableTrDimensionsVal = parseInt(trStyle.height) > 3;

									documentElement.removeChild(table);
								}
								return reliableTrDimensionsVal;
							},
						});
					})();

					function curCSS(elem, name, computed) {
						var width,
							minWidth,
							maxWidth,
							ret,
							// Support: Firefox 51+
							// Retrieving style before computed somehow
							// fixes an issue with getting wrong values
							// on detached elements
							style = elem.style;

						computed = computed || getStyles(elem);

						// getPropertyValue is needed for:
						//   .css('filter') (IE 9 only, #12537)
						//   .css('--customProperty) (#3144)
						if (computed) {
							ret = computed.getPropertyValue(name) || computed[name];

							if (ret === "" && !isAttached(elem)) {
								ret = jQuery.style(elem, name);
							}

							// A tribute to the "awesome hack by Dean Edwards"
							// Android Browser returns percentage for some values,
							// but width seems to be reliably pixels.
							// This is against the CSSOM draft spec:
							// https://drafts.csswg.org/cssom/#resolved-values
							if (
								!support.pixelBoxStyles() &&
								rnumnonpx.test(ret) &&
								rboxStyle.test(name)
							) {
								// Remember the original values
								width = style.width;
								minWidth = style.minWidth;
								maxWidth = style.maxWidth;

								// Put in the new values to get a computed value out
								style.minWidth = style.maxWidth = style.width = ret;
								ret = computed.width;

								// Revert the changed values
								style.width = width;
								style.minWidth = minWidth;
								style.maxWidth = maxWidth;
							}
						}

						return ret !== undefined
							? // Support: IE <=9 - 11 only
							  // IE returns zIndex value as an integer.
							  ret + ""
							: ret;
					}

					function addGetHookIf(conditionFn, hookFn) {
						// Define the hook, we'll check on the first run if it's really needed.
						return {
							get: function () {
								if (conditionFn()) {
									// Hook not needed (or it's not possible to use it due
									// to missing dependency), remove it.
									delete this.get;
									return;
								}

								// Hook needed; redefine it so that the support test is not executed again.
								return (this.get = hookFn).apply(this, arguments);
							},
						};
					}

					var cssPrefixes = ["Webkit", "Moz", "ms"],
						emptyStyle = document.createElement("div").style,
						vendorProps = {};

					// Return a vendor-prefixed property or undefined
					function vendorPropName(name) {
						// Check for vendor prefixed names
						var capName = name[0].toUpperCase() + name.slice(1),
							i = cssPrefixes.length;

						while (i--) {
							name = cssPrefixes[i] + capName;
							if (name in emptyStyle) {
								return name;
							}
						}
					}

					// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
					function finalPropName(name) {
						var final = jQuery.cssProps[name] || vendorProps[name];

						if (final) {
							return final;
						}
						if (name in emptyStyle) {
							return name;
						}
						return (vendorProps[name] = vendorPropName(name) || name);
					}

					var // Swappable if display is none or starts with table
						// except "table", "table-cell", or "table-caption"
						// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
						rdisplayswap = /^(none|table(?!-c[ea]).+)/,
						rcustomProp = /^--/,
						cssShow = {
							position: "absolute",
							visibility: "hidden",
							display: "block",
						},
						cssNormalTransform = {
							letterSpacing: "0",
							fontWeight: "400",
						};

					function setPositiveNumber(_elem, value, subtract) {
						// Any relative (+/-) values have already been
						// normalized at this point
						var matches = rcssNum.exec(value);
						return matches
							? // Guard against undefined "subtract", e.g., when used as in cssHooks
							  Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px")
							: value;
					}

					function boxModelAdjustment(
						elem,
						dimension,
						box,
						isBorderBox,
						styles,
						computedVal
					) {
						var i = dimension === "width" ? 1 : 0,
							extra = 0,
							delta = 0;

						// Adjustment may not be necessary
						if (box === (isBorderBox ? "border" : "content")) {
							return 0;
						}

						for (; i < 4; i += 2) {
							// Both box models exclude margin
							if (box === "margin") {
								delta += jQuery.css(elem, box + cssExpand[i], true, styles);
							}

							// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
							if (!isBorderBox) {
								// Add padding
								delta += jQuery.css(
									elem,
									"padding" + cssExpand[i],
									true,
									styles
								);

								// For "border" or "margin", add border
								if (box !== "padding") {
									delta += jQuery.css(
										elem,
										"border" + cssExpand[i] + "Width",
										true,
										styles
									);

									// But still keep track of it otherwise
								} else {
									extra += jQuery.css(
										elem,
										"border" + cssExpand[i] + "Width",
										true,
										styles
									);
								}

								// If we get here with a border-box (content + padding + border), we're seeking "content" or
								// "padding" or "margin"
							} else {
								// For "content", subtract padding
								if (box === "content") {
									delta -= jQuery.css(
										elem,
										"padding" + cssExpand[i],
										true,
										styles
									);
								}

								// For "content" or "padding", subtract border
								if (box !== "margin") {
									delta -= jQuery.css(
										elem,
										"border" + cssExpand[i] + "Width",
										true,
										styles
									);
								}
							}
						}

						// Account for positive content-box scroll gutter when requested by providing computedVal
						if (!isBorderBox && computedVal >= 0) {
							// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
							// Assuming integer scroll gutter, subtract the rest and round down
							delta +=
								Math.max(
									0,
									Math.ceil(
										elem[
											"offset" + dimension[0].toUpperCase() + dimension.slice(1)
										] -
											computedVal -
											delta -
											extra -
											0.5

										// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
										// Use an explicit zero to avoid NaN (gh-3964)
									)
								) || 0;
						}

						return delta;
					}

					function getWidthOrHeight(elem, dimension, extra) {
						// Start with computed style
						var styles = getStyles(elem),
							// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
							// Fake content-box until we know it's needed to know the true value.
							boxSizingNeeded = !support.boxSizingReliable() || extra,
							isBorderBox =
								boxSizingNeeded &&
								jQuery.css(elem, "boxSizing", false, styles) === "border-box",
							valueIsBorderBox = isBorderBox,
							val = curCSS(elem, dimension, styles),
							offsetProp =
								"offset" + dimension[0].toUpperCase() + dimension.slice(1);

						// Support: Firefox <=54
						// Return a confounding non-pixel value or feign ignorance, as appropriate.
						if (rnumnonpx.test(val)) {
							if (!extra) {
								return val;
							}
							val = "auto";
						}

						// Support: IE 9 - 11 only
						// Use offsetWidth/offsetHeight for when box sizing is unreliable.
						// In those cases, the computed value can be trusted to be border-box.
						if (
							((!support.boxSizingReliable() && isBorderBox) ||
								// Support: IE 10 - 11+, Edge 15 - 18+
								// IE/Edge misreport `getComputedStyle` of table rows with width/height
								// set in CSS while `offset*` properties report correct values.
								// Interestingly, in some cases IE 9 doesn't suffer from this issue.
								(!support.reliableTrDimensions() && nodeName(elem, "tr")) ||
								// Fall back to offsetWidth/offsetHeight when value is "auto"
								// This happens for inline elements with no explicit setting (gh-3571)
								val === "auto" ||
								// Support: Android <=4.1 - 4.3 only
								// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
								(!parseFloat(val) &&
									jQuery.css(elem, "display", false, styles) === "inline")) &&
							// Make sure the element is visible & connected
							elem.getClientRects().length
						) {
							isBorderBox =
								jQuery.css(elem, "boxSizing", false, styles) === "border-box";

							// Where available, offsetWidth/offsetHeight approximate border box dimensions.
							// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
							// retrieved value as a content box dimension.
							valueIsBorderBox = offsetProp in elem;
							if (valueIsBorderBox) {
								val = elem[offsetProp];
							}
						}

						// Normalize "" and auto
						val = parseFloat(val) || 0;

						// Adjust for the element's box model
						return (
							val +
							boxModelAdjustment(
								elem,
								dimension,
								extra || (isBorderBox ? "border" : "content"),
								valueIsBorderBox,
								styles,

								// Provide the current computed size to request scroll gutter calculation (gh-3589)
								val
							) +
							"px"
						);
					}

					jQuery.extend({
						// Add in style property hooks for overriding the default
						// behavior of getting and setting a style property
						cssHooks: {
							opacity: {
								get: function (elem, computed) {
									if (computed) {
										// We should always get a number back from opacity
										var ret = curCSS(elem, "opacity");
										return ret === "" ? "1" : ret;
									}
								},
							},
						},

						// Don't automatically add "px" to these possibly-unitless properties
						cssNumber: {
							animationIterationCount: true,
							columnCount: true,
							fillOpacity: true,
							flexGrow: true,
							flexShrink: true,
							fontWeight: true,
							gridArea: true,
							gridColumn: true,
							gridColumnEnd: true,
							gridColumnStart: true,
							gridRow: true,
							gridRowEnd: true,
							gridRowStart: true,
							lineHeight: true,
							opacity: true,
							order: true,
							orphans: true,
							widows: true,
							zIndex: true,
							zoom: true,
						},

						// Add in properties whose names you wish to fix before
						// setting or getting the value
						cssProps: {},

						// Get and set the style property on a DOM Node
						style: function (elem, name, value, extra) {
							// Don't set styles on text and comment nodes
							if (
								!elem ||
								elem.nodeType === 3 ||
								elem.nodeType === 8 ||
								!elem.style
							) {
								return;
							}

							// Make sure that we're working with the right name
							var ret,
								type,
								hooks,
								origName = camelCase(name),
								isCustomProp = rcustomProp.test(name),
								style = elem.style;

							// Make sure that we're working with the right name. We don't
							// want to query the value if it is a CSS custom property
							// since they are user-defined.
							if (!isCustomProp) {
								name = finalPropName(origName);
							}

							// Gets hook for the prefixed version, then unprefixed version
							hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

							// Check if we're setting a value
							if (value !== undefined) {
								type = typeof value;

								// Convert "+=" or "-=" to relative numbers (#7345)
								if (
									type === "string" &&
									(ret = rcssNum.exec(value)) &&
									ret[1]
								) {
									value = adjustCSS(elem, name, ret);

									// Fixes bug #9237
									type = "number";
								}

								// Make sure that null and NaN values aren't set (#7116)
								if (value == null || value !== value) {
									return;
								}

								// If a number was passed in, add the unit (except for certain CSS properties)
								// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
								// "px" to a few hardcoded values.
								if (type === "number" && !isCustomProp) {
									value +=
										(ret && ret[3]) || (jQuery.cssNumber[origName] ? "" : "px");
								}

								// background-* props affect original clone's values
								if (
									!support.clearCloneStyle &&
									value === "" &&
									name.indexOf("background") === 0
								) {
									style[name] = "inherit";
								}

								// If a hook was provided, use that value, otherwise just set the specified value
								if (
									!hooks ||
									!("set" in hooks) ||
									(value = hooks.set(elem, value, extra)) !== undefined
								) {
									if (isCustomProp) {
										style.setProperty(name, value);
									} else {
										style[name] = value;
									}
								}
							} else {
								// If a hook was provided get the non-computed value from there
								if (
									hooks &&
									"get" in hooks &&
									(ret = hooks.get(elem, false, extra)) !== undefined
								) {
									return ret;
								}

								// Otherwise just get the value from the style object
								return style[name];
							}
						},

						css: function (elem, name, extra, styles) {
							var val,
								num,
								hooks,
								origName = camelCase(name),
								isCustomProp = rcustomProp.test(name);

							// Make sure that we're working with the right name. We don't
							// want to modify the value if it is a CSS custom property
							// since they are user-defined.
							if (!isCustomProp) {
								name = finalPropName(origName);
							}

							// Try prefixed name followed by the unprefixed name
							hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

							// If a hook was provided get the computed value from there
							if (hooks && "get" in hooks) {
								val = hooks.get(elem, true, extra);
							}

							// Otherwise, if a way to get the computed value exists, use that
							if (val === undefined) {
								val = curCSS(elem, name, styles);
							}

							// Convert "normal" to computed value
							if (val === "normal" && name in cssNormalTransform) {
								val = cssNormalTransform[name];
							}

							// Make numeric if forced or a qualifier was provided and val looks numeric
							if (extra === "" || extra) {
								num = parseFloat(val);
								return extra === true || isFinite(num) ? num || 0 : val;
							}

							return val;
						},
					});

					jQuery.each(["height", "width"], function (_i, dimension) {
						jQuery.cssHooks[dimension] = {
							get: function (elem, computed, extra) {
								if (computed) {
									// Certain elements can have dimension info if we invisibly show them
									// but it must have a current display style that would benefit
									return rdisplayswap.test(jQuery.css(elem, "display")) &&
										// Support: Safari 8+
										// Table columns in Safari have non-zero offsetWidth & zero
										// getBoundingClientRect().width unless display is changed.
										// Support: IE <=11 only
										// Running getBoundingClientRect on a disconnected node
										// in IE throws an error.
										(!elem.getClientRects().length ||
											!elem.getBoundingClientRect().width)
										? swap(elem, cssShow, function () {
												return getWidthOrHeight(elem, dimension, extra);
										  })
										: getWidthOrHeight(elem, dimension, extra);
								}
							},

							set: function (elem, value, extra) {
								var matches,
									styles = getStyles(elem),
									// Only read styles.position if the test has a chance to fail
									// to avoid forcing a reflow.
									scrollboxSizeBuggy =
										!support.scrollboxSize() && styles.position === "absolute",
									// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
									boxSizingNeeded = scrollboxSizeBuggy || extra,
									isBorderBox =
										boxSizingNeeded &&
										jQuery.css(elem, "boxSizing", false, styles) ===
											"border-box",
									subtract = extra
										? boxModelAdjustment(
												elem,
												dimension,
												extra,
												isBorderBox,
												styles
										  )
										: 0;

								// Account for unreliable border-box dimensions by comparing offset* to computed and
								// faking a content-box to get border and padding (gh-3699)
								if (isBorderBox && scrollboxSizeBuggy) {
									subtract -= Math.ceil(
										elem[
											"offset" + dimension[0].toUpperCase() + dimension.slice(1)
										] -
											parseFloat(styles[dimension]) -
											boxModelAdjustment(
												elem,
												dimension,
												"border",
												false,
												styles
											) -
											0.5
									);
								}

								// Convert to pixels if value adjustment is needed
								if (
									subtract &&
									(matches = rcssNum.exec(value)) &&
									(matches[3] || "px") !== "px"
								) {
									elem.style[dimension] = value;
									value = jQuery.css(elem, dimension);
								}

								return setPositiveNumber(elem, value, subtract);
							},
						};
					});

					jQuery.cssHooks.marginLeft = addGetHookIf(
						support.reliableMarginLeft,
						function (elem, computed) {
							if (computed) {
								return (
									(parseFloat(curCSS(elem, "marginLeft")) ||
										elem.getBoundingClientRect().left -
											swap(elem, { marginLeft: 0 }, function () {
												return elem.getBoundingClientRect().left;
											})) + "px"
								);
							}
						}
					);

					// These hooks are used by animate to expand properties
					jQuery.each(
						{
							margin: "",
							padding: "",
							border: "Width",
						},
						function (prefix, suffix) {
							jQuery.cssHooks[prefix + suffix] = {
								expand: function (value) {
									var i = 0,
										expanded = {},
										// Assumes a single number if not a string
										parts =
											typeof value === "string" ? value.split(" ") : [value];

									for (; i < 4; i++) {
										expanded[prefix + cssExpand[i] + suffix] =
											parts[i] || parts[i - 2] || parts[0];
									}

									return expanded;
								},
							};

							if (prefix !== "margin") {
								jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
							}
						}
					);

					jQuery.fn.extend({
						css: function (name, value) {
							return access(
								this,
								function (elem, name, value) {
									var styles,
										len,
										map = {},
										i = 0;

									if (Array.isArray(name)) {
										styles = getStyles(elem);
										len = name.length;

										for (; i < len; i++) {
											map[name[i]] = jQuery.css(elem, name[i], false, styles);
										}

										return map;
									}

									return value !== undefined
										? jQuery.style(elem, name, value)
										: jQuery.css(elem, name);
								},
								name,
								value,
								arguments.length > 1
							);
						},
					});

					function Tween(elem, options, prop, end, easing) {
						return new Tween.prototype.init(elem, options, prop, end, easing);
					}
					jQuery.Tween = Tween;

					Tween.prototype = {
						constructor: Tween,
						init: function (elem, options, prop, end, easing, unit) {
							this.elem = elem;
							this.prop = prop;
							this.easing = easing || jQuery.easing._default;
							this.options = options;
							this.start = this.now = this.cur();
							this.end = end;
							this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
						},
						cur: function () {
							var hooks = Tween.propHooks[this.prop];

							return hooks && hooks.get
								? hooks.get(this)
								: Tween.propHooks._default.get(this);
						},
						run: function (percent) {
							var eased,
								hooks = Tween.propHooks[this.prop];

							if (this.options.duration) {
								this.pos = eased = jQuery.easing[this.easing](
									percent,
									this.options.duration * percent,
									0,
									1,
									this.options.duration
								);
							} else {
								this.pos = eased = percent;
							}
							this.now = (this.end - this.start) * eased + this.start;

							if (this.options.step) {
								this.options.step.call(this.elem, this.now, this);
							}

							if (hooks && hooks.set) {
								hooks.set(this);
							} else {
								Tween.propHooks._default.set(this);
							}
							return this;
						},
					};

					Tween.prototype.init.prototype = Tween.prototype;

					Tween.propHooks = {
						_default: {
							get: function (tween) {
								var result;

								// Use a property on the element directly when it is not a DOM element,
								// or when there is no matching style property that exists.
								if (
									tween.elem.nodeType !== 1 ||
									(tween.elem[tween.prop] != null &&
										tween.elem.style[tween.prop] == null)
								) {
									return tween.elem[tween.prop];
								}

								// Passing an empty string as a 3rd parameter to .css will automatically
								// attempt a parseFloat and fallback to a string if the parse fails.
								// Simple values such as "10px" are parsed to Float;
								// complex values such as "rotate(1rad)" are returned as-is.
								result = jQuery.css(tween.elem, tween.prop, "");

								// Empty strings, null, undefined and "auto" are converted to 0.
								return !result || result === "auto" ? 0 : result;
							},
							set: function (tween) {
								// Use step hook for back compat.
								// Use cssHook if its there.
								// Use .style if available and use plain properties where available.
								if (jQuery.fx.step[tween.prop]) {
									jQuery.fx.step[tween.prop](tween);
								} else if (
									tween.elem.nodeType === 1 &&
									(jQuery.cssHooks[tween.prop] ||
										tween.elem.style[finalPropName(tween.prop)] != null)
								) {
									jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
								} else {
									tween.elem[tween.prop] = tween.now;
								}
							},
						},
					};

					// Support: IE <=9 only
					// Panic based approach to setting things on disconnected nodes
					Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
						set: function (tween) {
							if (tween.elem.nodeType && tween.elem.parentNode) {
								tween.elem[tween.prop] = tween.now;
							}
						},
					};

					jQuery.easing = {
						linear: function (p) {
							return p;
						},
						swing: function (p) {
							return 0.5 - Math.cos(p * Math.PI) / 2;
						},
						_default: "swing",
					};

					jQuery.fx = Tween.prototype.init;

					// Back compat <1.8 extension point
					jQuery.fx.step = {};

					var fxNow,
						inProgress,
						rfxtypes = /^(?:toggle|show|hide)$/,
						rrun = /queueHooks$/;

					function schedule() {
						if (inProgress) {
							if (document.hidden === false && window.requestAnimationFrame) {
								window.requestAnimationFrame(schedule);
							} else {
								window.setTimeout(schedule, jQuery.fx.interval);
							}

							jQuery.fx.tick();
						}
					}

					// Animations created synchronously will run synchronously
					function createFxNow() {
						window.setTimeout(function () {
							fxNow = undefined;
						});
						return (fxNow = Date.now());
					}

					// Generate parameters to create a standard animation
					function genFx(type, includeWidth) {
						var which,
							i = 0,
							attrs = { height: type };

						// If we include width, step value is 1 to do all cssExpand values,
						// otherwise step value is 2 to skip over Left and Right
						includeWidth = includeWidth ? 1 : 0;
						for (; i < 4; i += 2 - includeWidth) {
							which = cssExpand[i];
							attrs["margin" + which] = attrs["padding" + which] = type;
						}

						if (includeWidth) {
							attrs.opacity = attrs.width = type;
						}

						return attrs;
					}

					function createTween(value, prop, animation) {
						var tween,
							collection = (Animation.tweeners[prop] || []).concat(
								Animation.tweeners["*"]
							),
							index = 0,
							length = collection.length;
						for (; index < length; index++) {
							if ((tween = collection[index].call(animation, prop, value))) {
								// We're done with this property
								return tween;
							}
						}
					}

					function defaultPrefilter(elem, props, opts) {
						var prop,
							value,
							toggle,
							hooks,
							oldfire,
							propTween,
							restoreDisplay,
							display,
							isBox = "width" in props || "height" in props,
							anim = this,
							orig = {},
							style = elem.style,
							hidden = elem.nodeType && isHiddenWithinTree(elem),
							dataShow = dataPriv.get(elem, "fxshow");

						// Queue-skipping animations hijack the fx hooks
						if (!opts.queue) {
							hooks = jQuery._queueHooks(elem, "fx");
							if (hooks.unqueued == null) {
								hooks.unqueued = 0;
								oldfire = hooks.empty.fire;
								hooks.empty.fire = function () {
									if (!hooks.unqueued) {
										oldfire();
									}
								};
							}
							hooks.unqueued++;

							anim.always(function () {
								// Ensure the complete handler is called before this completes
								anim.always(function () {
									hooks.unqueued--;
									if (!jQuery.queue(elem, "fx").length) {
										hooks.empty.fire();
									}
								});
							});
						}

						// Detect show/hide animations
						for (prop in props) {
							value = props[prop];
							if (rfxtypes.test(value)) {
								delete props[prop];
								toggle = toggle || value === "toggle";
								if (value === (hidden ? "hide" : "show")) {
									// Pretend to be hidden if this is a "show" and
									// there is still data from a stopped show/hide
									if (
										value === "show" &&
										dataShow &&
										dataShow[prop] !== undefined
									) {
										hidden = true;

										// Ignore all other no-op show/hide data
									} else {
										continue;
									}
								}
								orig[prop] =
									(dataShow && dataShow[prop]) || jQuery.style(elem, prop);
							}
						}

						// Bail out if this is a no-op like .hide().hide()
						propTween = !jQuery.isEmptyObject(props);
						if (!propTween && jQuery.isEmptyObject(orig)) {
							return;
						}

						// Restrict "overflow" and "display" styles during box animations
						if (isBox && elem.nodeType === 1) {
							// Support: IE <=9 - 11, Edge 12 - 15
							// Record all 3 overflow attributes because IE does not infer the shorthand
							// from identically-valued overflowX and overflowY and Edge just mirrors
							// the overflowX value there.
							opts.overflow = [
								style.overflow,
								style.overflowX,
								style.overflowY,
							];

							// Identify a display type, preferring old show/hide data over the CSS cascade
							restoreDisplay = dataShow && dataShow.display;
							if (restoreDisplay == null) {
								restoreDisplay = dataPriv.get(elem, "display");
							}
							display = jQuery.css(elem, "display");
							if (display === "none") {
								if (restoreDisplay) {
									display = restoreDisplay;
								} else {
									// Get nonempty value(s) by temporarily forcing visibility
									showHide([elem], true);
									restoreDisplay = elem.style.display || restoreDisplay;
									display = jQuery.css(elem, "display");
									showHide([elem]);
								}
							}

							// Animate inline elements as inline-block
							if (
								display === "inline" ||
								(display === "inline-block" && restoreDisplay != null)
							) {
								if (jQuery.css(elem, "float") === "none") {
									// Restore the original display value at the end of pure show/hide animations
									if (!propTween) {
										anim.done(function () {
											style.display = restoreDisplay;
										});
										if (restoreDisplay == null) {
											display = style.display;
											restoreDisplay = display === "none" ? "" : display;
										}
									}
									style.display = "inline-block";
								}
							}
						}

						if (opts.overflow) {
							style.overflow = "hidden";
							anim.always(function () {
								style.overflow = opts.overflow[0];
								style.overflowX = opts.overflow[1];
								style.overflowY = opts.overflow[2];
							});
						}

						// Implement show/hide animations
						propTween = false;
						for (prop in orig) {
							// General show/hide setup for this element animation
							if (!propTween) {
								if (dataShow) {
									if ("hidden" in dataShow) {
										hidden = dataShow.hidden;
									}
								} else {
									dataShow = dataPriv.access(elem, "fxshow", {
										display: restoreDisplay,
									});
								}

								// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
								if (toggle) {
									dataShow.hidden = !hidden;
								}

								// Show elements before animating them
								if (hidden) {
									showHide([elem], true);
								}

								/* eslint-disable no-loop-func */

								anim.done(function () {
									/* eslint-enable no-loop-func */

									// The final step of a "hide" animation is actually hiding the element
									if (!hidden) {
										showHide([elem]);
									}
									dataPriv.remove(elem, "fxshow");
									for (prop in orig) {
										jQuery.style(elem, prop, orig[prop]);
									}
								});
							}

							// Per-property setup
							propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
							if (!(prop in dataShow)) {
								dataShow[prop] = propTween.start;
								if (hidden) {
									propTween.end = propTween.start;
									propTween.start = 0;
								}
							}
						}
					}

					function propFilter(props, specialEasing) {
						var index, name, easing, value, hooks;

						// camelCase, specialEasing and expand cssHook pass
						for (index in props) {
							name = camelCase(index);
							easing = specialEasing[name];
							value = props[index];
							if (Array.isArray(value)) {
								easing = value[1];
								value = props[index] = value[0];
							}

							if (index !== name) {
								props[name] = value;
								delete props[index];
							}

							hooks = jQuery.cssHooks[name];
							if (hooks && "expand" in hooks) {
								value = hooks.expand(value);
								delete props[name];

								// Not quite $.extend, this won't overwrite existing keys.
								// Reusing 'index' because we have the correct "name"
								for (index in value) {
									if (!(index in props)) {
										props[index] = value[index];
										specialEasing[index] = easing;
									}
								}
							} else {
								specialEasing[name] = easing;
							}
						}
					}

					function Animation(elem, properties, options) {
						var result,
							stopped,
							index = 0,
							length = Animation.prefilters.length,
							deferred = jQuery.Deferred().always(function () {
								// Don't match elem in the :animated selector
								delete tick.elem;
							}),
							tick = function () {
								if (stopped) {
									return false;
								}
								var currentTime = fxNow || createFxNow(),
									remaining = Math.max(
										0,
										animation.startTime + animation.duration - currentTime
									),
									// Support: Android 2.3 only
									// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
									temp = remaining / animation.duration || 0,
									percent = 1 - temp,
									index = 0,
									length = animation.tweens.length;

								for (; index < length; index++) {
									animation.tweens[index].run(percent);
								}

								deferred.notifyWith(elem, [animation, percent, remaining]);

								// If there's more to do, yield
								if (percent < 1 && length) {
									return remaining;
								}

								// If this was an empty animation, synthesize a final progress notification
								if (!length) {
									deferred.notifyWith(elem, [animation, 1, 0]);
								}

								// Resolve the animation and report its conclusion
								deferred.resolveWith(elem, [animation]);
								return false;
							},
							animation = deferred.promise({
								elem: elem,
								props: jQuery.extend({}, properties),
								opts: jQuery.extend(
									true,
									{
										specialEasing: {},
										easing: jQuery.easing._default,
									},
									options
								),
								originalProperties: properties,
								originalOptions: options,
								startTime: fxNow || createFxNow(),
								duration: options.duration,
								tweens: [],
								createTween: function (prop, end) {
									var tween = jQuery.Tween(
										elem,
										animation.opts,
										prop,
										end,
										animation.opts.specialEasing[prop] || animation.opts.easing
									);
									animation.tweens.push(tween);
									return tween;
								},
								stop: function (gotoEnd) {
									var index = 0,
										// If we are going to the end, we want to run all the tweens
										// otherwise we skip this part
										length = gotoEnd ? animation.tweens.length : 0;
									if (stopped) {
										return this;
									}
									stopped = true;
									for (; index < length; index++) {
										animation.tweens[index].run(1);
									}

									// Resolve when we played the last frame; otherwise, reject
									if (gotoEnd) {
										deferred.notifyWith(elem, [animation, 1, 0]);
										deferred.resolveWith(elem, [animation, gotoEnd]);
									} else {
										deferred.rejectWith(elem, [animation, gotoEnd]);
									}
									return this;
								},
							}),
							props = animation.props;

						propFilter(props, animation.opts.specialEasing);

						for (; index < length; index++) {
							result = Animation.prefilters[index].call(
								animation,
								elem,
								props,
								animation.opts
							);
							if (result) {
								if (isFunction(result.stop)) {
									jQuery._queueHooks(
										animation.elem,
										animation.opts.queue
									).stop = result.stop.bind(result);
								}
								return result;
							}
						}

						jQuery.map(props, createTween, animation);

						if (isFunction(animation.opts.start)) {
							animation.opts.start.call(elem, animation);
						}

						// Attach callbacks from options
						animation
							.progress(animation.opts.progress)
							.done(animation.opts.done, animation.opts.complete)
							.fail(animation.opts.fail)
							.always(animation.opts.always);

						jQuery.fx.timer(
							jQuery.extend(tick, {
								elem: elem,
								anim: animation,
								queue: animation.opts.queue,
							})
						);

						return animation;
					}

					jQuery.Animation = jQuery.extend(Animation, {
						tweeners: {
							"*": [
								function (prop, value) {
									var tween = this.createTween(prop, value);
									adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
									return tween;
								},
							],
						},

						tweener: function (props, callback) {
							if (isFunction(props)) {
								callback = props;
								props = ["*"];
							} else {
								props = props.match(rnothtmlwhite);
							}

							var prop,
								index = 0,
								length = props.length;

							for (; index < length; index++) {
								prop = props[index];
								Animation.tweeners[prop] = Animation.tweeners[prop] || [];
								Animation.tweeners[prop].unshift(callback);
							}
						},

						prefilters: [defaultPrefilter],

						prefilter: function (callback, prepend) {
							if (prepend) {
								Animation.prefilters.unshift(callback);
							} else {
								Animation.prefilters.push(callback);
							}
						},
					});

					jQuery.speed = function (speed, easing, fn) {
						var opt =
							speed && typeof speed === "object"
								? jQuery.extend({}, speed)
								: {
										complete:
											fn || (!fn && easing) || (isFunction(speed) && speed),
										duration: speed,
										easing:
											(fn && easing) ||
											(easing && !isFunction(easing) && easing),
								  };

						// Go to the end state if fx are off
						if (jQuery.fx.off) {
							opt.duration = 0;
						} else {
							if (typeof opt.duration !== "number") {
								if (opt.duration in jQuery.fx.speeds) {
									opt.duration = jQuery.fx.speeds[opt.duration];
								} else {
									opt.duration = jQuery.fx.speeds._default;
								}
							}
						}

						// Normalize opt.queue - true/undefined/null -> "fx"
						if (opt.queue == null || opt.queue === true) {
							opt.queue = "fx";
						}

						// Queueing
						opt.old = opt.complete;

						opt.complete = function () {
							if (isFunction(opt.old)) {
								opt.old.call(this);
							}

							if (opt.queue) {
								jQuery.dequeue(this, opt.queue);
							}
						};

						return opt;
					};

					jQuery.fn.extend({
						fadeTo: function (speed, to, easing, callback) {
							// Show any hidden elements after setting opacity to 0
							return (
								this.filter(isHiddenWithinTree)
									.css("opacity", 0)
									.show()

									// Animate to the value specified
									.end()
									.animate({ opacity: to }, speed, easing, callback)
							);
						},
						animate: function (prop, speed, easing, callback) {
							var empty = jQuery.isEmptyObject(prop),
								optall = jQuery.speed(speed, easing, callback),
								doAnimation = function () {
									// Operate on a copy of prop so per-property easing won't be lost
									var anim = Animation(this, jQuery.extend({}, prop), optall);

									// Empty animations, or finishing resolves immediately
									if (empty || dataPriv.get(this, "finish")) {
										anim.stop(true);
									}
								};
							doAnimation.finish = doAnimation;

							return empty || optall.queue === false
								? this.each(doAnimation)
								: this.queue(optall.queue, doAnimation);
						},
						stop: function (type, clearQueue, gotoEnd) {
							var stopQueue = function (hooks) {
								var stop = hooks.stop;
								delete hooks.stop;
								stop(gotoEnd);
							};

							if (typeof type !== "string") {
								gotoEnd = clearQueue;
								clearQueue = type;
								type = undefined;
							}
							if (clearQueue) {
								this.queue(type || "fx", []);
							}

							return this.each(function () {
								var dequeue = true,
									index = type != null && type + "queueHooks",
									timers = jQuery.timers,
									data = dataPriv.get(this);

								if (index) {
									if (data[index] && data[index].stop) {
										stopQueue(data[index]);
									}
								} else {
									for (index in data) {
										if (data[index] && data[index].stop && rrun.test(index)) {
											stopQueue(data[index]);
										}
									}
								}

								for (index = timers.length; index--; ) {
									if (
										timers[index].elem === this &&
										(type == null || timers[index].queue === type)
									) {
										timers[index].anim.stop(gotoEnd);
										dequeue = false;
										timers.splice(index, 1);
									}
								}

								// Start the next in the queue if the last step wasn't forced.
								// Timers currently will call their complete callbacks, which
								// will dequeue but only if they were gotoEnd.
								if (dequeue || !gotoEnd) {
									jQuery.dequeue(this, type);
								}
							});
						},
						finish: function (type) {
							if (type !== false) {
								type = type || "fx";
							}
							return this.each(function () {
								var index,
									data = dataPriv.get(this),
									queue = data[type + "queue"],
									hooks = data[type + "queueHooks"],
									timers = jQuery.timers,
									length = queue ? queue.length : 0;

								// Enable finishing flag on private data
								data.finish = true;

								// Empty the queue first
								jQuery.queue(this, type, []);

								if (hooks && hooks.stop) {
									hooks.stop.call(this, true);
								}

								// Look for any active animations, and finish them
								for (index = timers.length; index--; ) {
									if (
										timers[index].elem === this &&
										timers[index].queue === type
									) {
										timers[index].anim.stop(true);
										timers.splice(index, 1);
									}
								}

								// Look for any animations in the old queue and finish them
								for (index = 0; index < length; index++) {
									if (queue[index] && queue[index].finish) {
										queue[index].finish.call(this);
									}
								}

								// Turn off finishing flag
								delete data.finish;
							});
						},
					});

					jQuery.each(["toggle", "show", "hide"], function (_i, name) {
						var cssFn = jQuery.fn[name];
						jQuery.fn[name] = function (speed, easing, callback) {
							return speed == null || typeof speed === "boolean"
								? cssFn.apply(this, arguments)
								: this.animate(genFx(name, true), speed, easing, callback);
						};
					});

					// Generate shortcuts for custom animations
					jQuery.each(
						{
							slideDown: genFx("show"),
							slideUp: genFx("hide"),
							slideToggle: genFx("toggle"),
							fadeIn: { opacity: "show" },
							fadeOut: { opacity: "hide" },
							fadeToggle: { opacity: "toggle" },
						},
						function (name, props) {
							jQuery.fn[name] = function (speed, easing, callback) {
								return this.animate(props, speed, easing, callback);
							};
						}
					);

					jQuery.timers = [];
					jQuery.fx.tick = function () {
						var timer,
							i = 0,
							timers = jQuery.timers;

						fxNow = Date.now();

						for (; i < timers.length; i++) {
							timer = timers[i];

							// Run the timer and safely remove it when done (allowing for external removal)
							if (!timer() && timers[i] === timer) {
								timers.splice(i--, 1);
							}
						}

						if (!timers.length) {
							jQuery.fx.stop();
						}
						fxNow = undefined;
					};

					jQuery.fx.timer = function (timer) {
						jQuery.timers.push(timer);
						jQuery.fx.start();
					};

					jQuery.fx.interval = 13;
					jQuery.fx.start = function () {
						if (inProgress) {
							return;
						}

						inProgress = true;
						schedule();
					};

					jQuery.fx.stop = function () {
						inProgress = null;
					};

					jQuery.fx.speeds = {
						slow: 600,
						fast: 200,

						// Default speed
						_default: 400,
					};

					// Based off of the plugin by Clint Helfers, with permission.
					// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
					jQuery.fn.delay = function (time, type) {
						time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
						type = type || "fx";

						return this.queue(type, function (next, hooks) {
							var timeout = window.setTimeout(next, time);
							hooks.stop = function () {
								window.clearTimeout(timeout);
							};
						});
					};

					(function () {
						var input = document.createElement("input"),
							select = document.createElement("select"),
							opt = select.appendChild(document.createElement("option"));

						input.type = "checkbox";

						// Support: Android <=4.3 only
						// Default value for a checkbox should be "on"
						support.checkOn = input.value !== "";

						// Support: IE <=11 only
						// Must access selectedIndex to make default options select
						support.optSelected = opt.selected;

						// Support: IE <=11 only
						// An input loses its value after becoming a radio
						input = document.createElement("input");
						input.value = "t";
						input.type = "radio";
						support.radioValue = input.value === "t";
					})();

					var boolHook,
						attrHandle = jQuery.expr.attrHandle;

					jQuery.fn.extend({
						attr: function (name, value) {
							return access(
								this,
								jQuery.attr,
								name,
								value,
								arguments.length > 1
							);
						},

						removeAttr: function (name) {
							return this.each(function () {
								jQuery.removeAttr(this, name);
							});
						},
					});

					jQuery.extend({
						attr: function (elem, name, value) {
							var ret,
								hooks,
								nType = elem.nodeType;

							// Don't get/set attributes on text, comment and attribute nodes
							if (nType === 3 || nType === 8 || nType === 2) {
								return;
							}

							// Fallback to prop when attributes are not supported
							if (typeof elem.getAttribute === "undefined") {
								return jQuery.prop(elem, name, value);
							}

							// Attribute hooks are determined by the lowercase version
							// Grab necessary hook if one is defined
							if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
								hooks =
									jQuery.attrHooks[name.toLowerCase()] ||
									(jQuery.expr.match.bool.test(name) ? boolHook : undefined);
							}

							if (value !== undefined) {
								if (value === null) {
									jQuery.removeAttr(elem, name);
									return;
								}

								if (
									hooks &&
									"set" in hooks &&
									(ret = hooks.set(elem, value, name)) !== undefined
								) {
									return ret;
								}

								elem.setAttribute(name, value + "");
								return value;
							}

							if (
								hooks &&
								"get" in hooks &&
								(ret = hooks.get(elem, name)) !== null
							) {
								return ret;
							}

							ret = jQuery.find.attr(elem, name);

							// Non-existent attributes return null, we normalize to undefined
							return ret == null ? undefined : ret;
						},

						attrHooks: {
							type: {
								set: function (elem, value) {
									if (
										!support.radioValue &&
										value === "radio" &&
										nodeName(elem, "input")
									) {
										var val = elem.value;
										elem.setAttribute("type", value);
										if (val) {
											elem.value = val;
										}
										return value;
									}
								},
							},
						},

						removeAttr: function (elem, value) {
							var name,
								i = 0,
								// Attribute names can contain non-HTML whitespace characters
								// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
								attrNames = value && value.match(rnothtmlwhite);

							if (attrNames && elem.nodeType === 1) {
								while ((name = attrNames[i++])) {
									elem.removeAttribute(name);
								}
							}
						},
					});

					// Hooks for boolean attributes
					boolHook = {
						set: function (elem, value, name) {
							if (value === false) {
								// Remove boolean attributes when set to false
								jQuery.removeAttr(elem, name);
							} else {
								elem.setAttribute(name, name);
							}
							return name;
						},
					};

					jQuery.each(
						jQuery.expr.match.bool.source.match(/\w+/g),
						function (_i, name) {
							var getter = attrHandle[name] || jQuery.find.attr;

							attrHandle[name] = function (elem, name, isXML) {
								var ret,
									handle,
									lowercaseName = name.toLowerCase();

								if (!isXML) {
									// Avoid an infinite loop by temporarily removing this function from the getter
									handle = attrHandle[lowercaseName];
									attrHandle[lowercaseName] = ret;
									ret =
										getter(elem, name, isXML) != null ? lowercaseName : null;
									attrHandle[lowercaseName] = handle;
								}
								return ret;
							};
						}
					);

					var rfocusable = /^(?:input|select|textarea|button)$/i,
						rclickable = /^(?:a|area)$/i;

					jQuery.fn.extend({
						prop: function (name, value) {
							return access(
								this,
								jQuery.prop,
								name,
								value,
								arguments.length > 1
							);
						},

						removeProp: function (name) {
							return this.each(function () {
								delete this[jQuery.propFix[name] || name];
							});
						},
					});

					jQuery.extend({
						prop: function (elem, name, value) {
							var ret,
								hooks,
								nType = elem.nodeType;

							// Don't get/set properties on text, comment and attribute nodes
							if (nType === 3 || nType === 8 || nType === 2) {
								return;
							}

							if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
								// Fix name and attach hooks
								name = jQuery.propFix[name] || name;
								hooks = jQuery.propHooks[name];
							}

							if (value !== undefined) {
								if (
									hooks &&
									"set" in hooks &&
									(ret = hooks.set(elem, value, name)) !== undefined
								) {
									return ret;
								}

								return (elem[name] = value);
							}

							if (
								hooks &&
								"get" in hooks &&
								(ret = hooks.get(elem, name)) !== null
							) {
								return ret;
							}

							return elem[name];
						},

						propHooks: {
							tabIndex: {
								get: function (elem) {
									// Support: IE <=9 - 11 only
									// elem.tabIndex doesn't always return the
									// correct value when it hasn't been explicitly set
									// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
									// Use proper attribute retrieval(#12072)
									var tabindex = jQuery.find.attr(elem, "tabindex");

									if (tabindex) {
										return parseInt(tabindex, 10);
									}

									if (
										rfocusable.test(elem.nodeName) ||
										(rclickable.test(elem.nodeName) && elem.href)
									) {
										return 0;
									}

									return -1;
								},
							},
						},

						propFix: {
							for: "htmlFor",
							class: "className",
						},
					});

					// Support: IE <=11 only
					// Accessing the selectedIndex property
					// forces the browser to respect setting selected
					// on the option
					// The getter ensures a default option is selected
					// when in an optgroup
					// eslint rule "no-unused-expressions" is disabled for this code
					// since it considers such accessions noop
					if (!support.optSelected) {
						jQuery.propHooks.selected = {
							get: function (elem) {
								/* eslint no-unused-expressions: "off" */

								var parent = elem.parentNode;
								if (parent && parent.parentNode) {
									parent.parentNode.selectedIndex;
								}
								return null;
							},
							set: function (elem) {
								/* eslint no-unused-expressions: "off" */

								var parent = elem.parentNode;
								if (parent) {
									parent.selectedIndex;

									if (parent.parentNode) {
										parent.parentNode.selectedIndex;
									}
								}
							},
						};
					}

					jQuery.each(
						[
							"tabIndex",
							"readOnly",
							"maxLength",
							"cellSpacing",
							"cellPadding",
							"rowSpan",
							"colSpan",
							"useMap",
							"frameBorder",
							"contentEditable",
						],
						function () {
							jQuery.propFix[this.toLowerCase()] = this;
						}
					);

					// Strip and collapse whitespace according to HTML spec
					// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
					function stripAndCollapse(value) {
						var tokens = value.match(rnothtmlwhite) || [];
						return tokens.join(" ");
					}

					function getClass(elem) {
						return (elem.getAttribute && elem.getAttribute("class")) || "";
					}

					function classesToArray(value) {
						if (Array.isArray(value)) {
							return value;
						}
						if (typeof value === "string") {
							return value.match(rnothtmlwhite) || [];
						}
						return [];
					}

					jQuery.fn.extend({
						addClass: function (value) {
							var classes,
								elem,
								cur,
								curValue,
								clazz,
								j,
								finalValue,
								i = 0;

							if (isFunction(value)) {
								return this.each(function (j) {
									jQuery(this).addClass(value.call(this, j, getClass(this)));
								});
							}

							classes = classesToArray(value);

							if (classes.length) {
								while ((elem = this[i++])) {
									curValue = getClass(elem);
									cur =
										elem.nodeType === 1 &&
										" " + stripAndCollapse(curValue) + " ";

									if (cur) {
										j = 0;
										while ((clazz = classes[j++])) {
											if (cur.indexOf(" " + clazz + " ") < 0) {
												cur += clazz + " ";
											}
										}

										// Only assign if different to avoid unneeded rendering.
										finalValue = stripAndCollapse(cur);
										if (curValue !== finalValue) {
											elem.setAttribute("class", finalValue);
										}
									}
								}
							}

							return this;
						},

						removeClass: function (value) {
							var classes,
								elem,
								cur,
								curValue,
								clazz,
								j,
								finalValue,
								i = 0;

							if (isFunction(value)) {
								return this.each(function (j) {
									jQuery(this).removeClass(value.call(this, j, getClass(this)));
								});
							}

							if (!arguments.length) {
								return this.attr("class", "");
							}

							classes = classesToArray(value);

							if (classes.length) {
								while ((elem = this[i++])) {
									curValue = getClass(elem);

									// This expression is here for better compressibility (see addClass)
									cur =
										elem.nodeType === 1 &&
										" " + stripAndCollapse(curValue) + " ";

									if (cur) {
										j = 0;
										while ((clazz = classes[j++])) {
											// Remove *all* instances
											while (cur.indexOf(" " + clazz + " ") > -1) {
												cur = cur.replace(" " + clazz + " ", " ");
											}
										}

										// Only assign if different to avoid unneeded rendering.
										finalValue = stripAndCollapse(cur);
										if (curValue !== finalValue) {
											elem.setAttribute("class", finalValue);
										}
									}
								}
							}

							return this;
						},

						toggleClass: function (value, stateVal) {
							var type = typeof value,
								isValidValue = type === "string" || Array.isArray(value);

							if (typeof stateVal === "boolean" && isValidValue) {
								return stateVal
									? this.addClass(value)
									: this.removeClass(value);
							}

							if (isFunction(value)) {
								return this.each(function (i) {
									jQuery(this).toggleClass(
										value.call(this, i, getClass(this), stateVal),
										stateVal
									);
								});
							}

							return this.each(function () {
								var className, i, self, classNames;

								if (isValidValue) {
									// Toggle individual class names
									i = 0;
									self = jQuery(this);
									classNames = classesToArray(value);

									while ((className = classNames[i++])) {
										// Check each className given, space separated list
										if (self.hasClass(className)) {
											self.removeClass(className);
										} else {
											self.addClass(className);
										}
									}

									// Toggle whole class name
								} else if (value === undefined || type === "boolean") {
									className = getClass(this);
									if (className) {
										// Store className if set
										dataPriv.set(this, "__className__", className);
									}

									// If the element has a class name or if we're passed `false`,
									// then remove the whole classname (if there was one, the above saved it).
									// Otherwise bring back whatever was previously saved (if anything),
									// falling back to the empty string if nothing was stored.
									if (this.setAttribute) {
										this.setAttribute(
											"class",
											className || value === false
												? ""
												: dataPriv.get(this, "__className__") || ""
										);
									}
								}
							});
						},

						hasClass: function (selector) {
							var className,
								elem,
								i = 0;

							className = " " + selector + " ";
							while ((elem = this[i++])) {
								if (
									elem.nodeType === 1 &&
									(" " + stripAndCollapse(getClass(elem)) + " ").indexOf(
										className
									) > -1
								) {
									return true;
								}
							}

							return false;
						},
					});

					var rreturn = /\r/g;

					jQuery.fn.extend({
						val: function (value) {
							var hooks,
								ret,
								valueIsFunction,
								elem = this[0];

							if (!arguments.length) {
								if (elem) {
									hooks =
										jQuery.valHooks[elem.type] ||
										jQuery.valHooks[elem.nodeName.toLowerCase()];

									if (
										hooks &&
										"get" in hooks &&
										(ret = hooks.get(elem, "value")) !== undefined
									) {
										return ret;
									}

									ret = elem.value;

									// Handle most common string cases
									if (typeof ret === "string") {
										return ret.replace(rreturn, "");
									}

									// Handle cases where value is null/undef or number
									return ret == null ? "" : ret;
								}

								return;
							}

							valueIsFunction = isFunction(value);

							return this.each(function (i) {
								var val;

								if (this.nodeType !== 1) {
									return;
								}

								if (valueIsFunction) {
									val = value.call(this, i, jQuery(this).val());
								} else {
									val = value;
								}

								// Treat null/undefined as ""; convert numbers to string
								if (val == null) {
									val = "";
								} else if (typeof val === "number") {
									val += "";
								} else if (Array.isArray(val)) {
									val = jQuery.map(val, function (value) {
										return value == null ? "" : value + "";
									});
								}

								hooks =
									jQuery.valHooks[this.type] ||
									jQuery.valHooks[this.nodeName.toLowerCase()];

								// If set returns undefined, fall back to normal setting
								if (
									!hooks ||
									!("set" in hooks) ||
									hooks.set(this, val, "value") === undefined
								) {
									this.value = val;
								}
							});
						},
					});

					jQuery.extend({
						valHooks: {
							option: {
								get: function (elem) {
									var val = jQuery.find.attr(elem, "value");
									return val != null
										? val
										: // Support: IE <=10 - 11 only
										  // option.text throws exceptions (#14686, #14858)
										  // Strip and collapse whitespace
										  // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
										  stripAndCollapse(jQuery.text(elem));
								},
							},
							select: {
								get: function (elem) {
									var value,
										option,
										i,
										options = elem.options,
										index = elem.selectedIndex,
										one = elem.type === "select-one",
										values = one ? null : [],
										max = one ? index + 1 : options.length;

									if (index < 0) {
										i = max;
									} else {
										i = one ? index : 0;
									}

									// Loop through all the selected options
									for (; i < max; i++) {
										option = options[i];

										// Support: IE <=9 only
										// IE8-9 doesn't update selected after form reset (#2551)
										if (
											(option.selected || i === index) &&
											// Don't return options that are disabled or in a disabled optgroup
											!option.disabled &&
											(!option.parentNode.disabled ||
												!nodeName(option.parentNode, "optgroup"))
										) {
											// Get the specific value for the option
											value = jQuery(option).val();

											// We don't need an array for one selects
											if (one) {
												return value;
											}

											// Multi-Selects return an array
											values.push(value);
										}
									}

									return values;
								},

								set: function (elem, value) {
									var optionSet,
										option,
										options = elem.options,
										values = jQuery.makeArray(value),
										i = options.length;

									while (i--) {
										option = options[i];

										/* eslint-disable no-cond-assign */

										if (
											(option.selected =
												jQuery.inArray(
													jQuery.valHooks.option.get(option),
													values
												) > -1)
										) {
											optionSet = true;
										}

										/* eslint-enable no-cond-assign */
									}

									// Force browsers to behave consistently when non-matching value is set
									if (!optionSet) {
										elem.selectedIndex = -1;
									}
									return values;
								},
							},
						},
					});

					// Radios and checkboxes getter/setter
					jQuery.each(["radio", "checkbox"], function () {
						jQuery.valHooks[this] = {
							set: function (elem, value) {
								if (Array.isArray(value)) {
									return (elem.checked =
										jQuery.inArray(jQuery(elem).val(), value) > -1);
								}
							},
						};
						if (!support.checkOn) {
							jQuery.valHooks[this].get = function (elem) {
								return elem.getAttribute("value") === null ? "on" : elem.value;
							};
						}
					});

					// Return jQuery for attributes-only inclusion

					support.focusin = "onfocusin" in window;

					var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
						stopPropagationCallback = function (e) {
							e.stopPropagation();
						};

					jQuery.extend(jQuery.event, {
						trigger: function (event, data, elem, onlyHandlers) {
							var i,
								cur,
								tmp,
								bubbleType,
								ontype,
								handle,
								special,
								lastElement,
								eventPath = [elem || document],
								type = hasOwn.call(event, "type") ? event.type : event,
								namespaces = hasOwn.call(event, "namespace")
									? event.namespace.split(".")
									: [];

							cur = lastElement = tmp = elem = elem || document;

							// Don't do events on text and comment nodes
							if (elem.nodeType === 3 || elem.nodeType === 8) {
								return;
							}

							// focus/blur morphs to focusin/out; ensure we're not firing them right now
							if (rfocusMorph.test(type + jQuery.event.triggered)) {
								return;
							}

							if (type.indexOf(".") > -1) {
								// Namespaced trigger; create a regexp to match event type in handle()
								namespaces = type.split(".");
								type = namespaces.shift();
								namespaces.sort();
							}
							ontype = type.indexOf(":") < 0 && "on" + type;

							// Caller can pass in a jQuery.Event object, Object, or just an event type string
							event = event[jQuery.expando]
								? event
								: new jQuery.Event(type, typeof event === "object" && event);

							// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
							event.isTrigger = onlyHandlers ? 2 : 3;
							event.namespace = namespaces.join(".");
							event.rnamespace = event.namespace
								? new RegExp(
										"(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)"
								  )
								: null;

							// Clean up the event in case it is being reused
							event.result = undefined;
							if (!event.target) {
								event.target = elem;
							}

							// Clone any incoming data and prepend the event, creating the handler arg list
							data = data == null ? [event] : jQuery.makeArray(data, [event]);

							// Allow special events to draw outside the lines
							special = jQuery.event.special[type] || {};
							if (
								!onlyHandlers &&
								special.trigger &&
								special.trigger.apply(elem, data) === false
							) {
								return;
							}

							// Determine event propagation path in advance, per W3C events spec (#9951)
							// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
							if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
								bubbleType = special.delegateType || type;
								if (!rfocusMorph.test(bubbleType + type)) {
									cur = cur.parentNode;
								}
								for (; cur; cur = cur.parentNode) {
									eventPath.push(cur);
									tmp = cur;
								}

								// Only add window if we got to document (e.g., not plain obj or detached DOM)
								if (tmp === (elem.ownerDocument || document)) {
									eventPath.push(tmp.defaultView || tmp.parentWindow || window);
								}
							}

							// Fire handlers on the event path
							i = 0;
							while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
								lastElement = cur;
								event.type = i > 1 ? bubbleType : special.bindType || type;

								// jQuery handler
								handle =
									(dataPriv.get(cur, "events") || Object.create(null))[
										event.type
									] && dataPriv.get(cur, "handle");
								if (handle) {
									handle.apply(cur, data);
								}

								// Native handler
								handle = ontype && cur[ontype];
								if (handle && handle.apply && acceptData(cur)) {
									event.result = handle.apply(cur, data);
									if (event.result === false) {
										event.preventDefault();
									}
								}
							}
							event.type = type;

							// If nobody prevented the default action, do it now
							if (!onlyHandlers && !event.isDefaultPrevented()) {
								if (
									(!special._default ||
										special._default.apply(eventPath.pop(), data) === false) &&
									acceptData(elem)
								) {
									// Call a native DOM method on the target with the same name as the event.
									// Don't do default actions on window, that's where global variables be (#6170)
									if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
										// Don't re-trigger an onFOO event when we call its FOO() method
										tmp = elem[ontype];

										if (tmp) {
											elem[ontype] = null;
										}

										// Prevent re-triggering of the same event, since we already bubbled it above
										jQuery.event.triggered = type;

										if (event.isPropagationStopped()) {
											lastElement.addEventListener(
												type,
												stopPropagationCallback
											);
										}

										elem[type]();

										if (event.isPropagationStopped()) {
											lastElement.removeEventListener(
												type,
												stopPropagationCallback
											);
										}

										jQuery.event.triggered = undefined;

										if (tmp) {
											elem[ontype] = tmp;
										}
									}
								}
							}

							return event.result;
						},

						// Piggyback on a donor event to simulate a different one
						// Used only for `focus(in | out)` events
						simulate: function (type, elem, event) {
							var e = jQuery.extend(new jQuery.Event(), event, {
								type: type,
								isSimulated: true,
							});

							jQuery.event.trigger(e, null, elem);
						},
					});

					jQuery.fn.extend({
						trigger: function (type, data) {
							return this.each(function () {
								jQuery.event.trigger(type, data, this);
							});
						},
						triggerHandler: function (type, data) {
							var elem = this[0];
							if (elem) {
								return jQuery.event.trigger(type, data, elem, true);
							}
						},
					});

					// Support: Firefox <=44
					// Firefox doesn't have focus(in | out) events
					// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
					//
					// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
					// focus(in | out) events fire after focus & blur events,
					// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
					// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
					if (!support.focusin) {
						jQuery.each(
							{ focus: "focusin", blur: "focusout" },
							function (orig, fix) {
								// Attach a single capturing handler on the document while someone wants focusin/focusout
								var handler = function (event) {
									jQuery.event.simulate(
										fix,
										event.target,
										jQuery.event.fix(event)
									);
								};

								jQuery.event.special[fix] = {
									setup: function () {
										// Handle: regular nodes (via `this.ownerDocument`), window
										// (via `this.document`) & document (via `this`).
										var doc = this.ownerDocument || this.document || this,
											attaches = dataPriv.access(doc, fix);

										if (!attaches) {
											doc.addEventListener(orig, handler, true);
										}
										dataPriv.access(doc, fix, (attaches || 0) + 1);
									},
									teardown: function () {
										var doc = this.ownerDocument || this.document || this,
											attaches = dataPriv.access(doc, fix) - 1;

										if (!attaches) {
											doc.removeEventListener(orig, handler, true);
											dataPriv.remove(doc, fix);
										} else {
											dataPriv.access(doc, fix, attaches);
										}
									},
								};
							}
						);
					}
					var location = window.location;

					var nonce = { guid: Date.now() };

					var rquery = /\?/;

					// Cross-browser xml parsing
					jQuery.parseXML = function (data) {
						var xml;
						if (!data || typeof data !== "string") {
							return null;
						}

						// Support: IE 9 - 11 only
						// IE throws on parseFromString with invalid input.
						try {
							xml = new window.DOMParser().parseFromString(data, "text/xml");
						} catch (e) {
							xml = undefined;
						}

						if (!xml || xml.getElementsByTagName("parsererror").length) {
							jQuery.error("Invalid XML: " + data);
						}
						return xml;
					};

					var rbracket = /\[\]$/,
						rCRLF = /\r?\n/g,
						rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
						rsubmittable = /^(?:input|select|textarea|keygen)/i;

					function buildParams(prefix, obj, traditional, add) {
						var name;

						if (Array.isArray(obj)) {
							// Serialize array item.
							jQuery.each(obj, function (i, v) {
								if (traditional || rbracket.test(prefix)) {
									// Treat each array item as a scalar.
									add(prefix, v);
								} else {
									// Item is non-scalar (array or object), encode its numeric index.
									buildParams(
										prefix +
											"[" +
											(typeof v === "object" && v != null ? i : "") +
											"]",
										v,
										traditional,
										add
									);
								}
							});
						} else if (!traditional && toType(obj) === "object") {
							// Serialize object item.
							for (name in obj) {
								buildParams(
									prefix + "[" + name + "]",
									obj[name],
									traditional,
									add
								);
							}
						} else {
							// Serialize scalar item.
							add(prefix, obj);
						}
					}

					// Serialize an array of form elements or a set of
					// key/values into a query string
					jQuery.param = function (a, traditional) {
						var prefix,
							s = [],
							add = function (key, valueOrFunction) {
								// If value is a function, invoke it and use its return value
								var value = isFunction(valueOrFunction)
									? valueOrFunction()
									: valueOrFunction;

								s[s.length] =
									encodeURIComponent(key) +
									"=" +
									encodeURIComponent(value == null ? "" : value);
							};

						if (a == null) {
							return "";
						}

						// If an array was passed in, assume that it is an array of form elements.
						if (Array.isArray(a) || (a.jquery && !jQuery.isPlainObject(a))) {
							// Serialize the form elements
							jQuery.each(a, function () {
								add(this.name, this.value);
							});
						} else {
							// If traditional, encode the "old" way (the way 1.3.2 or older
							// did it), otherwise encode params recursively.
							for (prefix in a) {
								buildParams(prefix, a[prefix], traditional, add);
							}
						}

						// Return the resulting serialization
						return s.join("&");
					};

					jQuery.fn.extend({
						serialize: function () {
							return jQuery.param(this.serializeArray());
						},
						serializeArray: function () {
							return this.map(function () {
								// Can add propHook for "elements" to filter or add form elements
								var elements = jQuery.prop(this, "elements");
								return elements ? jQuery.makeArray(elements) : this;
							})
								.filter(function () {
									var type = this.type;

									// Use .is( ":disabled" ) so that fieldset[disabled] works
									return (
										this.name &&
										!jQuery(this).is(":disabled") &&
										rsubmittable.test(this.nodeName) &&
										!rsubmitterTypes.test(type) &&
										(this.checked || !rcheckableType.test(type))
									);
								})
								.map(function (_i, elem) {
									var val = jQuery(this).val();

									if (val == null) {
										return null;
									}

									if (Array.isArray(val)) {
										return jQuery.map(val, function (val) {
											return {
												name: elem.name,
												value: val.replace(rCRLF, "\r\n"),
											};
										});
									}

									return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
								})
								.get();
						},
					});

					var r20 = /%20/g,
						rhash = /#.*$/,
						rantiCache = /([?&])_=[^&]*/,
						rheaders = /^(.*?):[ \t]*([^\r\n]*)$/gm,
						// #7653, #8125, #8152: local protocol detection
						rlocalProtocol =
							/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
						rnoContent = /^(?:GET|HEAD)$/,
						rprotocol = /^\/\//,
						/* Prefilters
						 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
						 * 2) These are called:
						 *    - BEFORE asking for a transport
						 *    - AFTER param serialization (s.data is a string if s.processData is true)
						 * 3) key is the dataType
						 * 4) the catchall symbol "*" can be used
						 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
						 */
						prefilters = {},
						/* Transports bindings
						 * 1) key is the dataType
						 * 2) the catchall symbol "*" can be used
						 * 3) selection will start with transport dataType and THEN go to "*" if needed
						 */
						transports = {},
						// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
						allTypes = "*/".concat("*"),
						// Anchor tag for parsing the document origin
						originAnchor = document.createElement("a");
					originAnchor.href = location.href;

					// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
					function addToPrefiltersOrTransports(structure) {
						// dataTypeExpression is optional and defaults to "*"
						return function (dataTypeExpression, func) {
							if (typeof dataTypeExpression !== "string") {
								func = dataTypeExpression;
								dataTypeExpression = "*";
							}

							var dataType,
								i = 0,
								dataTypes =
									dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];

							if (isFunction(func)) {
								// For each dataType in the dataTypeExpression
								while ((dataType = dataTypes[i++])) {
									// Prepend if requested
									if (dataType[0] === "+") {
										dataType = dataType.slice(1) || "*";
										(structure[dataType] = structure[dataType] || []).unshift(
											func
										);

										// Otherwise append
									} else {
										(structure[dataType] = structure[dataType] || []).push(
											func
										);
									}
								}
							}
						};
					}

					// Base inspection function for prefilters and transports
					function inspectPrefiltersOrTransports(
						structure,
						options,
						originalOptions,
						jqXHR
					) {
						var inspected = {},
							seekingTransport = structure === transports;

						function inspect(dataType) {
							var selected;
							inspected[dataType] = true;
							jQuery.each(
								structure[dataType] || [],
								function (_, prefilterOrFactory) {
									var dataTypeOrTransport = prefilterOrFactory(
										options,
										originalOptions,
										jqXHR
									);
									if (
										typeof dataTypeOrTransport === "string" &&
										!seekingTransport &&
										!inspected[dataTypeOrTransport]
									) {
										options.dataTypes.unshift(dataTypeOrTransport);
										inspect(dataTypeOrTransport);
										return false;
									} else if (seekingTransport) {
										return !(selected = dataTypeOrTransport);
									}
								}
							);
							return selected;
						}

						return (
							inspect(options.dataTypes[0]) || (!inspected["*"] && inspect("*"))
						);
					}

					// A special extend for ajax options
					// that takes "flat" options (not to be deep extended)
					// Fixes #9887
					function ajaxExtend(target, src) {
						var key,
							deep,
							flatOptions = jQuery.ajaxSettings.flatOptions || {};

						for (key in src) {
							if (src[key] !== undefined) {
								(flatOptions[key] ? target : deep || (deep = {}))[key] =
									src[key];
							}
						}
						if (deep) {
							jQuery.extend(true, target, deep);
						}

						return target;
					}

					/* Handles responses to an ajax request:
					 * - finds the right dataType (mediates between content-type and expected dataType)
					 * - returns the corresponding response
					 */
					function ajaxHandleResponses(s, jqXHR, responses) {
						var ct,
							type,
							finalDataType,
							firstDataType,
							contents = s.contents,
							dataTypes = s.dataTypes;

						// Remove auto dataType and get content-type in the process
						while (dataTypes[0] === "*") {
							dataTypes.shift();
							if (ct === undefined) {
								ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
							}
						}

						// Check if we're dealing with a known content-type
						if (ct) {
							for (type in contents) {
								if (contents[type] && contents[type].test(ct)) {
									dataTypes.unshift(type);
									break;
								}
							}
						}

						// Check to see if we have a response for the expected dataType
						if (dataTypes[0] in responses) {
							finalDataType = dataTypes[0];
						} else {
							// Try convertible dataTypes
							for (type in responses) {
								if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
									finalDataType = type;
									break;
								}
								if (!firstDataType) {
									firstDataType = type;
								}
							}

							// Or just use first one
							finalDataType = finalDataType || firstDataType;
						}

						// If we found a dataType
						// We add the dataType to the list if needed
						// and return the corresponding response
						if (finalDataType) {
							if (finalDataType !== dataTypes[0]) {
								dataTypes.unshift(finalDataType);
							}
							return responses[finalDataType];
						}
					}

					/* Chain conversions given the request and the original response
					 * Also sets the responseXXX fields on the jqXHR instance
					 */
					function ajaxConvert(s, response, jqXHR, isSuccess) {
						var conv2,
							current,
							conv,
							tmp,
							prev,
							converters = {},
							// Work with a copy of dataTypes in case we need to modify it for conversion
							dataTypes = s.dataTypes.slice();

						// Create converters map with lowercased keys
						if (dataTypes[1]) {
							for (conv in s.converters) {
								converters[conv.toLowerCase()] = s.converters[conv];
							}
						}

						current = dataTypes.shift();

						// Convert to each sequential dataType
						while (current) {
							if (s.responseFields[current]) {
								jqXHR[s.responseFields[current]] = response;
							}

							// Apply the dataFilter if provided
							if (!prev && isSuccess && s.dataFilter) {
								response = s.dataFilter(response, s.dataType);
							}

							prev = current;
							current = dataTypes.shift();

							if (current) {
								// There's only work to do if current dataType is non-auto
								if (current === "*") {
									current = prev;

									// Convert response if prev dataType is non-auto and differs from current
								} else if (prev !== "*" && prev !== current) {
									// Seek a direct converter
									conv =
										converters[prev + " " + current] ||
										converters["* " + current];

									// If none found, seek a pair
									if (!conv) {
										for (conv2 in converters) {
											// If conv2 outputs current
											tmp = conv2.split(" ");
											if (tmp[1] === current) {
												// If prev can be converted to accepted input
												conv =
													converters[prev + " " + tmp[0]] ||
													converters["* " + tmp[0]];
												if (conv) {
													// Condense equivalence converters
													if (conv === true) {
														conv = converters[conv2];

														// Otherwise, insert the intermediate dataType
													} else if (converters[conv2] !== true) {
														current = tmp[0];
														dataTypes.unshift(tmp[1]);
													}
													break;
												}
											}
										}
									}

									// Apply converter (if not an equivalence)
									if (conv !== true) {
										// Unless errors are allowed to bubble, catch and return them
										if (conv && s.throws) {
											response = conv(response);
										} else {
											try {
												response = conv(response);
											} catch (e) {
												return {
													state: "parsererror",
													error: conv
														? e
														: "No conversion from " + prev + " to " + current,
												};
											}
										}
									}
								}
							}
						}

						return { state: "success", data: response };
					}

					jQuery.extend({
						// Counter for holding the number of active queries
						active: 0,

						// Last-Modified header cache for next request
						lastModified: {},
						etag: {},

						ajaxSettings: {
							url: location.href,
							type: "GET",
							isLocal: rlocalProtocol.test(location.protocol),
							global: true,
							processData: true,
							async: true,
							contentType: "application/x-www-form-urlencoded; charset=UTF-8",

							/*
              timeout: 0,
              data: null,
              dataType: null,
              username: null,
              password: null,
              cache: null,
              throws: false,
              traditional: false,
              headers: {},
              */

							accepts: {
								"*": allTypes,
								text: "text/plain",
								html: "text/html",
								xml: "application/xml, text/xml",
								json: "application/json, text/javascript",
							},

							contents: {
								xml: /\bxml\b/,
								html: /\bhtml/,
								json: /\bjson\b/,
							},

							responseFields: {
								xml: "responseXML",
								text: "responseText",
								json: "responseJSON",
							},

							// Data converters
							// Keys separate source (or catchall "*") and destination types with a single space
							converters: {
								// Convert anything to text
								"* text": String,

								// Text to html (true = no transformation)
								"text html": true,

								// Evaluate text as a json expression
								"text json": JSON.parse,

								// Parse text as xml
								"text xml": jQuery.parseXML,
							},

							// For options that shouldn't be deep extended:
							// you can add your own custom options here if
							// and when you create one that shouldn't be
							// deep extended (see ajaxExtend)
							flatOptions: {
								url: true,
								context: true,
							},
						},

						// Creates a full fledged settings object into target
						// with both ajaxSettings and settings fields.
						// If target is omitted, writes into ajaxSettings.
						ajaxSetup: function (target, settings) {
							return settings
								? // Building a settings object
								  ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings)
								: // Extending ajaxSettings
								  ajaxExtend(jQuery.ajaxSettings, target);
						},

						ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
						ajaxTransport: addToPrefiltersOrTransports(transports),

						// Main method
						ajax: function (url, options) {
							// If url is an object, simulate pre-1.5 signature
							if (typeof url === "object") {
								options = url;
								url = undefined;
							}

							// Force options to be an object
							options = options || {};

							var transport,
								// URL without anti-cache param
								cacheURL,
								// Response headers
								responseHeadersString,
								responseHeaders,
								// timeout handle
								timeoutTimer,
								// Url cleanup var
								urlAnchor,
								// Request state (becomes false upon send and true upon completion)
								completed,
								// To know if global events are to be dispatched
								fireGlobals,
								// Loop variable
								i,
								// uncached part of the url
								uncached,
								// Create the final options object
								s = jQuery.ajaxSetup({}, options),
								// Callbacks context
								callbackContext = s.context || s,
								// Context for global events is callbackContext if it is a DOM node or jQuery collection
								globalEventContext =
									s.context &&
									(callbackContext.nodeType || callbackContext.jquery)
										? jQuery(callbackContext)
										: jQuery.event,
								// Deferreds
								deferred = jQuery.Deferred(),
								completeDeferred = jQuery.Callbacks("once memory"),
								// Status-dependent callbacks
								statusCode = s.statusCode || {},
								// Headers (they are sent all at once)
								requestHeaders = {},
								requestHeadersNames = {},
								// Default abort message
								strAbort = "canceled",
								// Fake xhr
								jqXHR = {
									readyState: 0,

									// Builds headers hashtable if needed
									getResponseHeader: function (key) {
										var match;
										if (completed) {
											if (!responseHeaders) {
												responseHeaders = {};
												while ((match = rheaders.exec(responseHeadersString))) {
													responseHeaders[match[1].toLowerCase() + " "] = (
														responseHeaders[match[1].toLowerCase() + " "] || []
													).concat(match[2]);
												}
											}
											match = responseHeaders[key.toLowerCase() + " "];
										}
										return match == null ? null : match.join(", ");
									},

									// Raw string
									getAllResponseHeaders: function () {
										return completed ? responseHeadersString : null;
									},

									// Caches the header
									setRequestHeader: function (name, value) {
										if (completed == null) {
											name = requestHeadersNames[name.toLowerCase()] =
												requestHeadersNames[name.toLowerCase()] || name;
											requestHeaders[name] = value;
										}
										return this;
									},

									// Overrides response content-type header
									overrideMimeType: function (type) {
										if (completed == null) {
											s.mimeType = type;
										}
										return this;
									},

									// Status-dependent callbacks
									statusCode: function (map) {
										var code;
										if (map) {
											if (completed) {
												// Execute the appropriate callbacks
												jqXHR.always(map[jqXHR.status]);
											} else {
												// Lazy-add the new callbacks in a way that preserves old ones
												for (code in map) {
													statusCode[code] = [statusCode[code], map[code]];
												}
											}
										}
										return this;
									},

									// Cancel the request
									abort: function (statusText) {
										var finalText = statusText || strAbort;
										if (transport) {
											transport.abort(finalText);
										}
										done(0, finalText);
										return this;
									},
								};

							// Attach deferreds
							deferred.promise(jqXHR);

							// Add protocol if not provided (prefilters might expect it)
							// Handle falsy url in the settings object (#10093: consistency with old signature)
							// We also use the url parameter if available
							s.url = ((url || s.url || location.href) + "").replace(
								rprotocol,
								location.protocol + "//"
							);

							// Alias method option to type as per ticket #12004
							s.type = options.method || options.type || s.method || s.type;

							// Extract dataTypes list
							s.dataTypes = (s.dataType || "*")
								.toLowerCase()
								.match(rnothtmlwhite) || [""];

							// A cross-domain request is in order when the origin doesn't match the current origin.
							if (s.crossDomain == null) {
								urlAnchor = document.createElement("a");

								// Support: IE <=8 - 11, Edge 12 - 15
								// IE throws exception on accessing the href property if url is malformed,
								// e.g. http://example.com:80x/
								try {
									urlAnchor.href = s.url;

									// Support: IE <=8 - 11 only
									// Anchor's host property isn't correctly set when s.url is relative
									urlAnchor.href = urlAnchor.href;
									s.crossDomain =
										originAnchor.protocol + "//" + originAnchor.host !==
										urlAnchor.protocol + "//" + urlAnchor.host;
								} catch (e) {
									// If there is an error parsing the URL, assume it is crossDomain,
									// it can be rejected by the transport if it is invalid
									s.crossDomain = true;
								}
							}

							// Convert data if not already a string
							if (s.data && s.processData && typeof s.data !== "string") {
								s.data = jQuery.param(s.data, s.traditional);
							}

							// Apply prefilters
							inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);

							// If request was aborted inside a prefilter, stop there
							if (completed) {
								return jqXHR;
							}

							// We can fire global events as of now if asked to
							// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
							fireGlobals = jQuery.event && s.global;

							// Watch for a new set of requests
							if (fireGlobals && jQuery.active++ === 0) {
								jQuery.event.trigger("ajaxStart");
							}

							// Uppercase the type
							s.type = s.type.toUpperCase();

							// Determine if request has content
							s.hasContent = !rnoContent.test(s.type);

							// Save the URL in case we're toying with the If-Modified-Since
							// and/or If-None-Match header later on
							// Remove hash to simplify url manipulation
							cacheURL = s.url.replace(rhash, "");

							// More options handling for requests with no content
							if (!s.hasContent) {
								// Remember the hash so we can put it back
								uncached = s.url.slice(cacheURL.length);

								// If data is available and should be processed, append data to url
								if (s.data && (s.processData || typeof s.data === "string")) {
									cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;

									// #9682: remove data so that it's not used in an eventual retry
									delete s.data;
								}

								// Add or update anti-cache param if needed
								if (s.cache === false) {
									cacheURL = cacheURL.replace(rantiCache, "$1");
									uncached =
										(rquery.test(cacheURL) ? "&" : "?") +
										"_=" +
										nonce.guid++ +
										uncached;
								}

								// Put hash and anti-cache on the URL that will be requested (gh-1732)
								s.url = cacheURL + uncached;

								// Change '%20' to '+' if this is encoded form body content (gh-2658)
							} else if (
								s.data &&
								s.processData &&
								(s.contentType || "").indexOf(
									"application/x-www-form-urlencoded"
								) === 0
							) {
								s.data = s.data.replace(r20, "+");
							}

							// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
							if (s.ifModified) {
								if (jQuery.lastModified[cacheURL]) {
									jqXHR.setRequestHeader(
										"If-Modified-Since",
										jQuery.lastModified[cacheURL]
									);
								}
								if (jQuery.etag[cacheURL]) {
									jqXHR.setRequestHeader(
										"If-None-Match",
										jQuery.etag[cacheURL]
									);
								}
							}

							// Set the correct header, if data is being sent
							if (
								(s.data && s.hasContent && s.contentType !== false) ||
								options.contentType
							) {
								jqXHR.setRequestHeader("Content-Type", s.contentType);
							}

							// Set the Accepts header for the server, depending on the dataType
							jqXHR.setRequestHeader(
								"Accept",
								s.dataTypes[0] && s.accepts[s.dataTypes[0]]
									? s.accepts[s.dataTypes[0]] +
											(s.dataTypes[0] !== "*"
												? ", " + allTypes + "; q=0.01"
												: "")
									: s.accepts["*"]
							);

							// Check for headers option
							for (i in s.headers) {
								jqXHR.setRequestHeader(i, s.headers[i]);
							}

							// Allow custom headers/mimetypes and early abort
							if (
								s.beforeSend &&
								(s.beforeSend.call(callbackContext, jqXHR, s) === false ||
									completed)
							) {
								// Abort if not done already and return
								return jqXHR.abort();
							}

							// Aborting is no longer a cancellation
							strAbort = "abort";

							// Install callbacks on deferreds
							completeDeferred.add(s.complete);
							jqXHR.done(s.success);
							jqXHR.fail(s.error);

							// Get transport
							transport = inspectPrefiltersOrTransports(
								transports,
								s,
								options,
								jqXHR
							);

							// If no transport, we auto-abort
							if (!transport) {
								done(-1, "No Transport");
							} else {
								jqXHR.readyState = 1;

								// Send global event
								if (fireGlobals) {
									globalEventContext.trigger("ajaxSend", [jqXHR, s]);
								}

								// If request was aborted inside ajaxSend, stop there
								if (completed) {
									return jqXHR;
								}

								// Timeout
								if (s.async && s.timeout > 0) {
									timeoutTimer = window.setTimeout(function () {
										jqXHR.abort("timeout");
									}, s.timeout);
								}

								try {
									completed = false;
									transport.send(requestHeaders, done);
								} catch (e) {
									// Rethrow post-completion exceptions
									if (completed) {
										throw e;
									}

									// Propagate others as results
									done(-1, e);
								}
							}

							// Callback for when everything is done
							function done(status, nativeStatusText, responses, headers) {
								var isSuccess,
									success,
									error,
									response,
									modified,
									statusText = nativeStatusText;

								// Ignore repeat invocations
								if (completed) {
									return;
								}

								completed = true;

								// Clear timeout if it exists
								if (timeoutTimer) {
									window.clearTimeout(timeoutTimer);
								}

								// Dereference transport for early garbage collection
								// (no matter how long the jqXHR object will be used)
								transport = undefined;

								// Cache response headers
								responseHeadersString = headers || "";

								// Set readyState
								jqXHR.readyState = status > 0 ? 4 : 0;

								// Determine if successful
								isSuccess = (status >= 200 && status < 300) || status === 304;

								// Get response data
								if (responses) {
									response = ajaxHandleResponses(s, jqXHR, responses);
								}

								// Use a noop converter for missing script
								if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1) {
									s.converters["text script"] = function () {};
								}

								// Convert no matter what (that way responseXXX fields are always set)
								response = ajaxConvert(s, response, jqXHR, isSuccess);

								// If successful, handle type chaining
								if (isSuccess) {
									// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
									if (s.ifModified) {
										modified = jqXHR.getResponseHeader("Last-Modified");
										if (modified) {
											jQuery.lastModified[cacheURL] = modified;
										}
										modified = jqXHR.getResponseHeader("etag");
										if (modified) {
											jQuery.etag[cacheURL] = modified;
										}
									}

									// if no content
									if (status === 204 || s.type === "HEAD") {
										statusText = "nocontent";

										// if not modified
									} else if (status === 304) {
										statusText = "notmodified";

										// If we have data, let's convert it
									} else {
										statusText = response.state;
										success = response.data;
										error = response.error;
										isSuccess = !error;
									}
								} else {
									// Extract error from statusText and normalize for non-aborts
									error = statusText;
									if (status || !statusText) {
										statusText = "error";
										if (status < 0) {
											status = 0;
										}
									}
								}

								// Set data for the fake xhr object
								jqXHR.status = status;
								jqXHR.statusText = (nativeStatusText || statusText) + "";

								// Success/Error
								if (isSuccess) {
									deferred.resolveWith(callbackContext, [
										success,
										statusText,
										jqXHR,
									]);
								} else {
									deferred.rejectWith(callbackContext, [
										jqXHR,
										statusText,
										error,
									]);
								}

								// Status-dependent callbacks
								jqXHR.statusCode(statusCode);
								statusCode = undefined;

								if (fireGlobals) {
									globalEventContext.trigger(
										isSuccess ? "ajaxSuccess" : "ajaxError",
										[jqXHR, s, isSuccess ? success : error]
									);
								}

								// Complete
								completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);

								if (fireGlobals) {
									globalEventContext.trigger("ajaxComplete", [jqXHR, s]);

									// Handle the global AJAX counter
									if (!--jQuery.active) {
										jQuery.event.trigger("ajaxStop");
									}
								}
							}

							return jqXHR;
						},

						getJSON: function (url, data, callback) {
							return jQuery.get(url, data, callback, "json");
						},

						getScript: function (url, callback) {
							return jQuery.get(url, undefined, callback, "script");
						},
					});

					jQuery.each(["get", "post"], function (_i, method) {
						jQuery[method] = function (url, data, callback, type) {
							// Shift arguments if data argument was omitted
							if (isFunction(data)) {
								type = type || callback;
								callback = data;
								data = undefined;
							}

							// The url can be an options object (which then must have .url)
							return jQuery.ajax(
								jQuery.extend(
									{
										url: url,
										type: method,
										dataType: type,
										data: data,
										success: callback,
									},
									jQuery.isPlainObject(url) && url
								)
							);
						};
					});

					jQuery.ajaxPrefilter(function (s) {
						var i;
						for (i in s.headers) {
							if (i.toLowerCase() === "content-type") {
								s.contentType = s.headers[i] || "";
							}
						}
					});

					jQuery._evalUrl = function (url, options, doc) {
						return jQuery.ajax({
							url: url,

							// Make this explicit, since user can override this through ajaxSetup (#11264)
							type: "GET",
							dataType: "script",
							cache: true,
							async: false,
							global: false,

							// Only evaluate the response if it is successful (gh-4126)
							// dataFilter is not invoked for failure responses, so using it instead
							// of the default converter is kludgy but it works.
							converters: {
								"text script": function () {},
							},
							dataFilter: function (response) {
								jQuery.globalEval(response, options, doc);
							},
						});
					};

					jQuery.fn.extend({
						wrapAll: function (html) {
							var wrap;

							if (this[0]) {
								if (isFunction(html)) {
									html = html.call(this[0]);
								}

								// The elements to wrap the target around
								wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);

								if (this[0].parentNode) {
									wrap.insertBefore(this[0]);
								}

								wrap
									.map(function () {
										var elem = this;

										while (elem.firstElementChild) {
											elem = elem.firstElementChild;
										}

										return elem;
									})
									.append(this);
							}

							return this;
						},

						wrapInner: function (html) {
							if (isFunction(html)) {
								return this.each(function (i) {
									jQuery(this).wrapInner(html.call(this, i));
								});
							}

							return this.each(function () {
								var self = jQuery(this),
									contents = self.contents();

								if (contents.length) {
									contents.wrapAll(html);
								} else {
									self.append(html);
								}
							});
						},

						wrap: function (html) {
							var htmlIsFunction = isFunction(html);

							return this.each(function (i) {
								jQuery(this).wrapAll(
									htmlIsFunction ? html.call(this, i) : html
								);
							});
						},

						unwrap: function (selector) {
							this.parent(selector)
								.not("body")
								.each(function () {
									jQuery(this).replaceWith(this.childNodes);
								});
							return this;
						},
					});

					jQuery.expr.pseudos.hidden = function (elem) {
						return !jQuery.expr.pseudos.visible(elem);
					};
					jQuery.expr.pseudos.visible = function (elem) {
						return !!(
							elem.offsetWidth ||
							elem.offsetHeight ||
							elem.getClientRects().length
						);
					};

					jQuery.ajaxSettings.xhr = function () {
						try {
							return new window.XMLHttpRequest();
						} catch (e) {}
					};

					var xhrSuccessStatus = {
							// File protocol always yields status code 0, assume 200
							0: 200,

							// Support: IE <=9 only
							// #1450: sometimes IE returns 1223 when it should be 204
							1223: 204,
						},
						xhrSupported = jQuery.ajaxSettings.xhr();

					support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
					support.ajax = xhrSupported = !!xhrSupported;

					jQuery.ajaxTransport(function (options) {
						var callback, errorCallback;

						// Cross domain only allowed if supported through XMLHttpRequest
						if (support.cors || (xhrSupported && !options.crossDomain)) {
							return {
								send: function (headers, complete) {
									var i,
										xhr = options.xhr();

									xhr.open(
										options.type,
										options.url,
										options.async,
										options.username,
										options.password
									);

									// Apply custom fields if provided
									if (options.xhrFields) {
										for (i in options.xhrFields) {
											xhr[i] = options.xhrFields[i];
										}
									}

									// Override mime type if needed
									if (options.mimeType && xhr.overrideMimeType) {
										xhr.overrideMimeType(options.mimeType);
									}

									// X-Requested-With header
									// For cross-domain requests, seeing as conditions for a preflight are
									// akin to a jigsaw puzzle, we simply never set it to be sure.
									// (it can always be set on a per-request basis or even using ajaxSetup)
									// For same-domain requests, won't change header if already provided.
									if (!options.crossDomain && !headers["X-Requested-With"]) {
										headers["X-Requested-With"] = "XMLHttpRequest";
									}

									// Set headers
									for (i in headers) {
										xhr.setRequestHeader(i, headers[i]);
									}

									// Callback
									callback = function (type) {
										return function () {
											if (callback) {
												callback =
													errorCallback =
													xhr.onload =
													xhr.onerror =
													xhr.onabort =
													xhr.ontimeout =
													xhr.onreadystatechange =
														null;

												if (type === "abort") {
													xhr.abort();
												} else if (type === "error") {
													// Support: IE <=9 only
													// On a manual native abort, IE9 throws
													// errors on any property access that is not readyState
													if (typeof xhr.status !== "number") {
														complete(0, "error");
													} else {
														complete(
															// File: protocol always yields status 0; see #8605, #14207
															xhr.status,
															xhr.statusText
														);
													}
												} else {
													complete(
														xhrSuccessStatus[xhr.status] || xhr.status,
														xhr.statusText,

														// Support: IE <=9 only
														// IE9 has no XHR2 but throws on binary (trac-11426)
														// For XHR2 non-text, let the caller handle it (gh-2498)
														(xhr.responseType || "text") !== "text" ||
															typeof xhr.responseText !== "string"
															? { binary: xhr.response }
															: { text: xhr.responseText },
														xhr.getAllResponseHeaders()
													);
												}
											}
										};
									};

									// Listen to events
									xhr.onload = callback();
									errorCallback =
										xhr.onerror =
										xhr.ontimeout =
											callback("error");

									// Support: IE 9 only
									// Use onreadystatechange to replace onabort
									// to handle uncaught aborts
									if (xhr.onabort !== undefined) {
										xhr.onabort = errorCallback;
									} else {
										xhr.onreadystatechange = function () {
											// Check readyState before timeout as it changes
											if (xhr.readyState === 4) {
												// Allow onerror to be called first,
												// but that will not handle a native abort
												// Also, save errorCallback to a variable
												// as xhr.onerror cannot be accessed
												window.setTimeout(function () {
													if (callback) {
														errorCallback();
													}
												});
											}
										};
									}

									// Create the abort callback
									callback = callback("abort");

									try {
										// Do send the request (this may raise an exception)
										xhr.send((options.hasContent && options.data) || null);
									} catch (e) {
										// #14683: Only rethrow if this hasn't been notified as an error yet
										if (callback) {
											throw e;
										}
									}
								},

								abort: function () {
									if (callback) {
										callback();
									}
								},
							};
						}
					});

					// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
					jQuery.ajaxPrefilter(function (s) {
						if (s.crossDomain) {
							s.contents.script = false;
						}
					});

					// Install script dataType
					jQuery.ajaxSetup({
						accepts: {
							script:
								"text/javascript, application/javascript, " +
								"application/ecmascript, application/x-ecmascript",
						},
						contents: {
							script: /\b(?:java|ecma)script\b/,
						},
						converters: {
							"text script": function (text) {
								jQuery.globalEval(text);
								return text;
							},
						},
					});

					// Handle cache's special case and crossDomain
					jQuery.ajaxPrefilter("script", function (s) {
						if (s.cache === undefined) {
							s.cache = false;
						}
						if (s.crossDomain) {
							s.type = "GET";
						}
					});

					// Bind script tag hack transport
					jQuery.ajaxTransport("script", function (s) {
						// This transport only deals with cross domain or forced-by-attrs requests
						if (s.crossDomain || s.scriptAttrs) {
							var script, callback;
							return {
								send: function (_, complete) {
									script = jQuery("<script>")
										.attr(s.scriptAttrs || {})
										.prop({ charset: s.scriptCharset, src: s.url })
										.on(
											"load error",
											(callback = function (evt) {
												script.remove();
												callback = null;
												if (evt) {
													complete(evt.type === "error" ? 404 : 200, evt.type);
												}
											})
										);

									// Use native DOM manipulation to avoid our domManip AJAX trickery
									document.head.appendChild(script[0]);
								},
								abort: function () {
									if (callback) {
										callback();
									}
								},
							};
						}
					});

					var oldCallbacks = [],
						rjsonp = /(=)\?(?=&|$)|\?\?/;

					// Default jsonp settings
					jQuery.ajaxSetup({
						jsonp: "callback",
						jsonpCallback: function () {
							var callback =
								oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
							this[callback] = true;
							return callback;
						},
					});

					// Detect, normalize options and install callbacks for jsonp requests
					jQuery.ajaxPrefilter(
						"json jsonp",
						function (s, originalSettings, jqXHR) {
							var callbackName,
								overwritten,
								responseContainer,
								jsonProp =
									s.jsonp !== false &&
									(rjsonp.test(s.url)
										? "url"
										: typeof s.data === "string" &&
										  (s.contentType || "").indexOf(
												"application/x-www-form-urlencoded"
										  ) === 0 &&
										  rjsonp.test(s.data) &&
										  "data");

							// Handle iff the expected data type is "jsonp" or we have a parameter to set
							if (jsonProp || s.dataTypes[0] === "jsonp") {
								// Get callback name, remembering preexisting value associated with it
								callbackName = s.jsonpCallback = isFunction(s.jsonpCallback)
									? s.jsonpCallback()
									: s.jsonpCallback;

								// Insert callback into url or form data
								if (jsonProp) {
									s[jsonProp] = s[jsonProp].replace(
										rjsonp,
										"$1" + callbackName
									);
								} else if (s.jsonp !== false) {
									s.url +=
										(rquery.test(s.url) ? "&" : "?") +
										s.jsonp +
										"=" +
										callbackName;
								}

								// Use data converter to retrieve json after script execution
								s.converters["script json"] = function () {
									if (!responseContainer) {
										jQuery.error(callbackName + " was not called");
									}
									return responseContainer[0];
								};

								// Force json dataType
								s.dataTypes[0] = "json";

								// Install callback
								overwritten = window[callbackName];
								window[callbackName] = function () {
									responseContainer = arguments;
								};

								// Clean-up function (fires after converters)
								jqXHR.always(function () {
									// If previous value didn't exist - remove it
									if (overwritten === undefined) {
										jQuery(window).removeProp(callbackName);

										// Otherwise restore preexisting value
									} else {
										window[callbackName] = overwritten;
									}

									// Save back as free
									if (s[callbackName]) {
										// Make sure that re-using the options doesn't screw things around
										s.jsonpCallback = originalSettings.jsonpCallback;

										// Save the callback name for future use
										oldCallbacks.push(callbackName);
									}

									// Call if it was a function and we have a response
									if (responseContainer && isFunction(overwritten)) {
										overwritten(responseContainer[0]);
									}

									responseContainer = overwritten = undefined;
								});

								// Delegate to script
								return "script";
							}
						}
					);

					// Support: Safari 8 only
					// In Safari 8 documents created via document.implementation.createHTMLDocument
					// collapse sibling forms: the second one becomes a child of the first one.
					// Because of that, this security measure has to be disabled in Safari 8.
					// https://bugs.webkit.org/show_bug.cgi?id=137337
					support.createHTMLDocument = (function () {
						var body = document.implementation.createHTMLDocument("").body;
						body.innerHTML = "<form></form><form></form>";
						return body.childNodes.length === 2;
					})();

					// Argument "data" should be string of html
					// context (optional): If specified, the fragment will be created in this context,
					// defaults to document
					// keepScripts (optional): If true, will include scripts passed in the html string
					jQuery.parseHTML = function (data, context, keepScripts) {
						if (typeof data !== "string") {
							return [];
						}
						if (typeof context === "boolean") {
							keepScripts = context;
							context = false;
						}

						var base, parsed, scripts;

						if (!context) {
							// Stop scripts or inline event handlers from being executed immediately
							// by using document.implementation
							if (support.createHTMLDocument) {
								context = document.implementation.createHTMLDocument("");

								// Set the base href for the created document
								// so any parsed elements with URLs
								// are based on the document's URL (gh-2965)
								base = context.createElement("base");
								base.href = document.location.href;
								context.head.appendChild(base);
							} else {
								context = document;
							}
						}

						parsed = rsingleTag.exec(data);
						scripts = !keepScripts && [];

						// Single tag
						if (parsed) {
							return [context.createElement(parsed[1])];
						}

						parsed = buildFragment([data], context, scripts);

						if (scripts && scripts.length) {
							jQuery(scripts).remove();
						}

						return jQuery.merge([], parsed.childNodes);
					};

					/**
					 * Load a url into a page
					 */
					jQuery.fn.load = function (url, params, callback) {
						var selector,
							type,
							response,
							self = this,
							off = url.indexOf(" ");

						if (off > -1) {
							selector = stripAndCollapse(url.slice(off));
							url = url.slice(0, off);
						}

						// If it's a function
						if (isFunction(params)) {
							// We assume that it's the callback
							callback = params;
							params = undefined;

							// Otherwise, build a param string
						} else if (params && typeof params === "object") {
							type = "POST";
						}

						// If we have elements to modify, make the request
						if (self.length > 0) {
							jQuery
								.ajax({
									url: url,

									// If "type" variable is undefined, then "GET" method will be used.
									// Make value of this field explicit since
									// user can override it through ajaxSetup method
									type: type || "GET",
									dataType: "html",
									data: params,
								})
								.done(function (responseText) {
									// Save response for use in complete callback
									response = arguments;

									self.html(
										selector
											? // If a selector was specified, locate the right elements in a dummy div
											  // Exclude scripts to avoid IE 'Permission Denied' errors
											  jQuery("<div>")
													.append(jQuery.parseHTML(responseText))
													.find(selector)
											: // Otherwise use the full result
											  responseText
									);

									// If the request succeeds, this function gets "data", "status", "jqXHR"
									// but they are ignored because response was set above.
									// If it fails, this function gets "jqXHR", "status", "error"
								})
								.always(
									callback &&
										function (jqXHR, status) {
											self.each(function () {
												callback.apply(
													this,
													response || [jqXHR.responseText, status, jqXHR]
												);
											});
										}
								);
						}

						return this;
					};

					jQuery.expr.pseudos.animated = function (elem) {
						return jQuery.grep(jQuery.timers, function (fn) {
							return elem === fn.elem;
						}).length;
					};

					jQuery.offset = {
						setOffset: function (elem, options, i) {
							var curPosition,
								curLeft,
								curCSSTop,
								curTop,
								curOffset,
								curCSSLeft,
								calculatePosition,
								position = jQuery.css(elem, "position"),
								curElem = jQuery(elem),
								props = {};

							// Set position first, in-case top/left are set even on static elem
							if (position === "static") {
								elem.style.position = "relative";
							}

							curOffset = curElem.offset();
							curCSSTop = jQuery.css(elem, "top");
							curCSSLeft = jQuery.css(elem, "left");
							calculatePosition =
								(position === "absolute" || position === "fixed") &&
								(curCSSTop + curCSSLeft).indexOf("auto") > -1;

							// Need to be able to calculate position if either
							// top or left is auto and position is either absolute or fixed
							if (calculatePosition) {
								curPosition = curElem.position();
								curTop = curPosition.top;
								curLeft = curPosition.left;
							} else {
								curTop = parseFloat(curCSSTop) || 0;
								curLeft = parseFloat(curCSSLeft) || 0;
							}

							if (isFunction(options)) {
								// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
								options = options.call(elem, i, jQuery.extend({}, curOffset));
							}

							if (options.top != null) {
								props.top = options.top - curOffset.top + curTop;
							}
							if (options.left != null) {
								props.left = options.left - curOffset.left + curLeft;
							}

							if ("using" in options) {
								options.using.call(elem, props);
							} else {
								if (typeof props.top === "number") {
									props.top += "px";
								}
								if (typeof props.left === "number") {
									props.left += "px";
								}
								curElem.css(props);
							}
						},
					};

					jQuery.fn.extend({
						// offset() relates an element's border box to the document origin
						offset: function (options) {
							// Preserve chaining for setter
							if (arguments.length) {
								return options === undefined
									? this
									: this.each(function (i) {
											jQuery.offset.setOffset(this, options, i);
									  });
							}

							var rect,
								win,
								elem = this[0];

							if (!elem) {
								return;
							}

							// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
							// Support: IE <=11 only
							// Running getBoundingClientRect on a
							// disconnected node in IE throws an error
							if (!elem.getClientRects().length) {
								return { top: 0, left: 0 };
							}

							// Get document-relative position by adding viewport scroll to viewport-relative gBCR
							rect = elem.getBoundingClientRect();
							win = elem.ownerDocument.defaultView;
							return {
								top: rect.top + win.pageYOffset,
								left: rect.left + win.pageXOffset,
							};
						},

						// position() relates an element's margin box to its offset parent's padding box
						// This corresponds to the behavior of CSS absolute positioning
						position: function () {
							if (!this[0]) {
								return;
							}

							var offsetParent,
								offset,
								doc,
								elem = this[0],
								parentOffset = { top: 0, left: 0 };

							// position:fixed elements are offset from the viewport, which itself always has zero offset
							if (jQuery.css(elem, "position") === "fixed") {
								// Assume position:fixed implies availability of getBoundingClientRect
								offset = elem.getBoundingClientRect();
							} else {
								offset = this.offset();

								// Account for the *real* offset parent, which can be the document or its root element
								// when a statically positioned element is identified
								doc = elem.ownerDocument;
								offsetParent = elem.offsetParent || doc.documentElement;
								while (
									offsetParent &&
									(offsetParent === doc.body ||
										offsetParent === doc.documentElement) &&
									jQuery.css(offsetParent, "position") === "static"
								) {
									offsetParent = offsetParent.parentNode;
								}
								if (
									offsetParent &&
									offsetParent !== elem &&
									offsetParent.nodeType === 1
								) {
									// Incorporate borders into its offset, since they are outside its content origin
									parentOffset = jQuery(offsetParent).offset();
									parentOffset.top += jQuery.css(
										offsetParent,
										"borderTopWidth",
										true
									);
									parentOffset.left += jQuery.css(
										offsetParent,
										"borderLeftWidth",
										true
									);
								}
							}

							// Subtract parent offsets and element margins
							return {
								top:
									offset.top -
									parentOffset.top -
									jQuery.css(elem, "marginTop", true),
								left:
									offset.left -
									parentOffset.left -
									jQuery.css(elem, "marginLeft", true),
							};
						},

						// This method will return documentElement in the following cases:
						// 1) For the element inside the iframe without offsetParent, this method will return
						//    documentElement of the parent window
						// 2) For the hidden or detached element
						// 3) For body or html element, i.e. in case of the html node - it will return itself
						//
						// but those exceptions were never presented as a real life use-cases
						// and might be considered as more preferable results.
						//
						// This logic, however, is not guaranteed and can change at any point in the future
						offsetParent: function () {
							return this.map(function () {
								var offsetParent = this.offsetParent;

								while (
									offsetParent &&
									jQuery.css(offsetParent, "position") === "static"
								) {
									offsetParent = offsetParent.offsetParent;
								}

								return offsetParent || documentElement;
							});
						},
					});

					// Create scrollLeft and scrollTop methods
					jQuery.each(
						{ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
						function (method, prop) {
							var top = "pageYOffset" === prop;

							jQuery.fn[method] = function (val) {
								return access(
									this,
									function (elem, method, val) {
										// Coalesce documents and windows
										var win;
										if (isWindow(elem)) {
											win = elem;
										} else if (elem.nodeType === 9) {
											win = elem.defaultView;
										}

										if (val === undefined) {
											return win ? win[prop] : elem[method];
										}

										if (win) {
											win.scrollTo(
												!top ? val : win.pageXOffset,
												top ? val : win.pageYOffset
											);
										} else {
											elem[method] = val;
										}
									},
									method,
									val,
									arguments.length
								);
							};
						}
					);

					// Support: Safari <=7 - 9.1, Chrome <=37 - 49
					// Add the top/left cssHooks using jQuery.fn.position
					// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
					// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
					// getComputedStyle returns percent when specified for top/left/bottom/right;
					// rather than make the css module depend on the offset module, just check for it here
					jQuery.each(["top", "left"], function (_i, prop) {
						jQuery.cssHooks[prop] = addGetHookIf(
							support.pixelPosition,
							function (elem, computed) {
								if (computed) {
									computed = curCSS(elem, prop);

									// If curCSS returns percentage, fallback to offset
									return rnumnonpx.test(computed)
										? jQuery(elem).position()[prop] + "px"
										: computed;
								}
							}
						);
					});

					// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
					jQuery.each(
						{ Height: "height", Width: "width" },
						function (name, type) {
							jQuery.each(
								{ padding: "inner" + name, content: type, "": "outer" + name },
								function (defaultExtra, funcName) {
									// Margin is only for outerHeight, outerWidth
									jQuery.fn[funcName] = function (margin, value) {
										var chainable =
												arguments.length &&
												(defaultExtra || typeof margin !== "boolean"),
											extra =
												defaultExtra ||
												(margin === true || value === true
													? "margin"
													: "border");

										return access(
											this,
											function (elem, type, value) {
												var doc;

												if (isWindow(elem)) {
													// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
													return funcName.indexOf("outer") === 0
														? elem["inner" + name]
														: elem.document.documentElement["client" + name];
												}

												// Get document width or height
												if (elem.nodeType === 9) {
													doc = elem.documentElement;

													// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
													// whichever is greatest
													return Math.max(
														elem.body["scroll" + name],
														doc["scroll" + name],
														elem.body["offset" + name],
														doc["offset" + name],
														doc["client" + name]
													);
												}

												return value === undefined
													? // Get width or height on the element, requesting but not forcing parseFloat
													  jQuery.css(elem, type, extra)
													: // Set width or height on the element
													  jQuery.style(elem, type, value, extra);
											},
											type,
											chainable ? margin : undefined,
											chainable
										);
									};
								}
							);
						}
					);

					jQuery.each(
						[
							"ajaxStart",
							"ajaxStop",
							"ajaxComplete",
							"ajaxError",
							"ajaxSuccess",
							"ajaxSend",
						],
						function (_i, type) {
							jQuery.fn[type] = function (fn) {
								return this.on(type, fn);
							};
						}
					);

					jQuery.fn.extend({
						bind: function (types, data, fn) {
							return this.on(types, null, data, fn);
						},
						unbind: function (types, fn) {
							return this.off(types, null, fn);
						},

						delegate: function (selector, types, data, fn) {
							return this.on(types, selector, data, fn);
						},
						undelegate: function (selector, types, fn) {
							// ( namespace ) or ( selector, types [, fn] )
							return arguments.length === 1
								? this.off(selector, "**")
								: this.off(types, selector || "**", fn);
						},

						hover: function (fnOver, fnOut) {
							return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
						},
					});

					jQuery.each(
						(
							"blur focus focusin focusout resize scroll click dblclick " +
							"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
							"change select submit keydown keypress keyup contextmenu"
						).split(" "),
						function (_i, name) {
							// Handle event binding
							jQuery.fn[name] = function (data, fn) {
								return arguments.length > 0
									? this.on(name, null, data, fn)
									: this.trigger(name);
							};
						}
					);

					// Support: Android <=4.0 only
					// Make sure we trim BOM and NBSP
					var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

					// Bind a function to a context, optionally partially applying any
					// arguments.
					// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
					// However, it is not slated for removal any time soon
					jQuery.proxy = function (fn, context) {
						var tmp, args, proxy;

						if (typeof context === "string") {
							tmp = fn[context];
							context = fn;
							fn = tmp;
						}

						// Quick check to determine if target is callable, in the spec
						// this throws a TypeError, but we will just return undefined.
						if (!isFunction(fn)) {
							return undefined;
						}

						// Simulated bind
						args = slice.call(arguments, 2);
						proxy = function () {
							return fn.apply(
								context || this,
								args.concat(slice.call(arguments))
							);
						};

						// Set the guid of unique handler to the same of original handler, so it can be removed
						proxy.guid = fn.guid = fn.guid || jQuery.guid++;

						return proxy;
					};

					jQuery.holdReady = function (hold) {
						if (hold) {
							jQuery.readyWait++;
						} else {
							jQuery.ready(true);
						}
					};
					jQuery.isArray = Array.isArray;
					jQuery.parseJSON = JSON.parse;
					jQuery.nodeName = nodeName;
					jQuery.isFunction = isFunction;
					jQuery.isWindow = isWindow;
					jQuery.camelCase = camelCase;
					jQuery.type = toType;

					jQuery.now = Date.now;

					jQuery.isNumeric = function (obj) {
						// As of jQuery 3.0, isNumeric is limited to
						// strings and numbers (primitives or objects)
						// that can be coerced to finite numbers (gh-2662)
						var type = jQuery.type(obj);
						return (
							(type === "number" || type === "string") &&
							// parseFloat NaNs numeric-cast false positives ("")
							// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
							// subtraction forces infinities to NaN
							!isNaN(obj - parseFloat(obj))
						);
					};

					jQuery.trim = function (text) {
						return text == null ? "" : (text + "").replace(rtrim, "");
					};

					// Register as a named AMD module, since jQuery can be concatenated with other
					// files that may use define, but not via a proper concatenation script that
					// understands anonymous AMD modules. A named AMD is safest and most robust
					// way to register. Lowercase jquery is used because AMD module names are
					// derived from file names, and jQuery is normally delivered in a lowercase
					// file name. Do this after creating the global so that if an AMD module wants
					// to call noConflict to hide this version of jQuery, it will work.

					// Note that for maximum portability, libraries that are not jQuery should
					// declare themselves as anonymous modules, and avoid setting a global if an
					// AMD loader is present. jQuery is a special case. For more information, see
					// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

					if (true) {
						!((__WEBPACK_AMD_DEFINE_ARRAY__ = []),
						(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
							return jQuery;
						}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
						__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
							(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
					}

					var // Map over jQuery in case of overwrite
						_jQuery = window.jQuery,
						// Map over the $ in case of overwrite
						_$ = window.$;

					jQuery.noConflict = function (deep) {
						if (window.$ === jQuery) {
							window.$ = _$;
						}

						if (deep && window.jQuery === jQuery) {
							window.jQuery = _jQuery;
						}

						return jQuery;
					};

					// Expose jQuery and $ identifiers, even in AMD
					// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
					// and CommonJS for browser emulators (#13566)
					if (typeof noGlobal === "undefined") {
						window.jQuery = window.$ = jQuery;
					}

					return jQuery;
				}
			);

			/***/
		},

		/***/ 405: /***/ (module) => {
			module.exports = debounce;

			function debounce(fn, delay, at_start, guarantee) {
				var timeout;
				var args;
				var self;

				return function debounced() {
					self = this;
					args = Array.prototype.slice.call(arguments);

					if (timeout && (at_start || guarantee)) {
						return;
					} else if (!at_start) {
						clear();

						timeout = setTimeout(run, delay);
						return timeout;
					}

					timeout = setTimeout(clear, delay);
					fn.apply(self, args);

					function run() {
						clear();
						fn.apply(self, args);
					}

					function clear() {
						clearTimeout(timeout);
						timeout = null;
					}
				};
			}

			/***/
		},

		/***/ 411: /***/ function (module, exports, __webpack_require__) {
			var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
			/*! PhotoSwipe Default UI - 4.1.3 - 2019-01-08
			 * http://photoswipe.com
			 * Copyright (c) 2019 Dmitry Semenov; */
			/**
			 *
			 * UI on top of main sliding area (caption, arrows, close button, etc.).
			 * Built just using public methods/properties of PhotoSwipe.
			 *
			 */
			(function (root, factory) {
				if (true) {
					!((__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
					(__WEBPACK_AMD_DEFINE_RESULT__ =
						typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
							? __WEBPACK_AMD_DEFINE_FACTORY__.call(
									exports,
									__webpack_require__,
									exports,
									module
							  )
							: __WEBPACK_AMD_DEFINE_FACTORY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(this, function () {
				"use strict";

				var PhotoSwipeUI_Default = function (pswp, framework) {
					var ui = this;
					var _overlayUIUpdated = false,
						_controlsVisible = true,
						_fullscrenAPI,
						_controls,
						_captionContainer,
						_fakeCaptionContainer,
						_indexIndicator,
						_shareButton,
						_shareModal,
						_shareModalHidden = true,
						_initalCloseOnScrollValue,
						_isIdle,
						_listen,
						_loadingIndicator,
						_loadingIndicatorHidden,
						_loadingIndicatorTimeout,
						_galleryHasOneSlide,
						_options,
						_defaultUIOptions = {
							barsSize: { top: 44, bottom: "auto" },
							closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
							timeToIdle: 4000,
							timeToIdleOutside: 1000,
							loadingIndicatorDelay: 1000, // 2s

							addCaptionHTMLFn: function (item, captionEl /*, isFake */) {
								if (!item.title) {
									captionEl.children[0].innerHTML = "";
									return false;
								}
								captionEl.children[0].innerHTML = item.title;
								return true;
							},

							closeEl: true,
							captionEl: true,
							fullscreenEl: true,
							zoomEl: true,
							shareEl: true,
							counterEl: true,
							arrowEl: true,
							preloaderEl: true,

							tapToClose: false,
							tapToToggleControls: true,

							clickToCloseNonZoomable: true,

							shareButtons: [
								{
									id: "facebook",
									label: "Share on Facebook",
									url: "https://www.facebook.com/sharer/sharer.php?u=",
								},
								{
									id: "twitter",
									label: "Tweet",
									url: "https://twitter.com/intent/tweet?text=&url=",
								},
								{
									id: "pinterest",
									label: "Pin it",
									url:
										"http://www.pinterest.com/pin/create/button/" +
										"?url=&media=&description=",
								},
								{
									id: "download",
									label: "Download image",
									url: "",
									download: true,
								},
							],
							getImageURLForShare: function (/* shareButtonData */) {
								return pswp.currItem.src || "";
							},
							getPageURLForShare: function (/* shareButtonData */) {
								return window.location.href;
							},
							getTextForShare: function (/* shareButtonData */) {
								return pswp.currItem.title || "";
							},

							indexIndicatorSep: " / ",
							fitControlsWidth: 1200,
						},
						_blockControlsTap,
						_blockControlsTapTimeout;

					var _onControlsTap = function (e) {
							if (_blockControlsTap) {
								return true;
							}

							e = e || window.event;

							if (_options.timeToIdle && _options.mouseUsed && !_isIdle) {
								// reset idle timer
								_onIdleMouseMove();
							}

							var target = e.target || e.srcElement,
								uiElement,
								clickedClass = target.getAttribute("class") || "",
								found;

							for (var i = 0; i < _uiElements.length; i++) {
								uiElement = _uiElements[i];
								if (
									uiElement.onTap &&
									clickedClass.indexOf("pswp__" + uiElement.name) > -1
								) {
									uiElement.onTap();
									found = true;
								}
							}

							if (found) {
								if (e.stopPropagation) {
									e.stopPropagation();
								}
								_blockControlsTap = true;

								// Some versions of Android don't prevent ghost click event
								// when preventDefault() was called on touchstart and/or touchend.
								//
								// This happens on v4.3, 4.2, 4.1,
								// older versions strangely work correctly,
								// but just in case we add delay on all of them)
								var tapDelay = framework.features.isOldAndroid ? 600 : 30;
								_blockControlsTapTimeout = setTimeout(function () {
									_blockControlsTap = false;
								}, tapDelay);
							}
						},
						_fitControlsInViewport = function () {
							return (
								!pswp.likelyTouchDevice ||
								_options.mouseUsed ||
								screen.width > _options.fitControlsWidth
							);
						},
						_togglePswpClass = function (el, cName, add) {
							framework[(add ? "add" : "remove") + "Class"](
								el,
								"pswp__" + cName
							);
						},
						// add class when there is just one item in the gallery
						// (by default it hides left/right arrows and 1ofX counter)
						_countNumItems = function () {
							var hasOneSlide = _options.getNumItemsFn() === 1;

							if (hasOneSlide !== _galleryHasOneSlide) {
								_togglePswpClass(_controls, "ui--one-slide", hasOneSlide);
								_galleryHasOneSlide = hasOneSlide;
							}
						},
						_toggleShareModalClass = function () {
							_togglePswpClass(
								_shareModal,
								"share-modal--hidden",
								_shareModalHidden
							);
						},
						_toggleShareModal = function () {
							_shareModalHidden = !_shareModalHidden;

							if (!_shareModalHidden) {
								_toggleShareModalClass();
								setTimeout(function () {
									if (!_shareModalHidden) {
										framework.addClass(
											_shareModal,
											"pswp__share-modal--fade-in"
										);
									}
								}, 30);
							} else {
								framework.removeClass(
									_shareModal,
									"pswp__share-modal--fade-in"
								);
								setTimeout(function () {
									if (_shareModalHidden) {
										_toggleShareModalClass();
									}
								}, 300);
							}

							if (!_shareModalHidden) {
								_updateShareURLs();
							}
							return false;
						},
						_openWindowPopup = function (e) {
							e = e || window.event;
							var target = e.target || e.srcElement;

							pswp.shout("shareLinkClick", e, target);

							if (!target.href) {
								return false;
							}

							if (target.hasAttribute("download")) {
								return true;
							}

							window.open(
								target.href,
								"pswp_share",
								"scrollbars=yes,resizable=yes,toolbar=no," +
									"location=yes,width=550,height=420,top=100,left=" +
									(window.screen ? Math.round(screen.width / 2 - 275) : 100)
							);

							if (!_shareModalHidden) {
								_toggleShareModal();
							}

							return false;
						},
						_updateShareURLs = function () {
							var shareButtonOut = "",
								shareButtonData,
								shareURL,
								image_url,
								page_url,
								share_text;

							for (var i = 0; i < _options.shareButtons.length; i++) {
								shareButtonData = _options.shareButtons[i];

								image_url = _options.getImageURLForShare(shareButtonData);
								page_url = _options.getPageURLForShare(shareButtonData);
								share_text = _options.getTextForShare(shareButtonData);

								shareURL = shareButtonData.url
									.replace("", encodeURIComponent(page_url))
									.replace("", encodeURIComponent(image_url))
									.replace("", image_url)
									.replace("", encodeURIComponent(share_text));

								shareButtonOut +=
									'<a href="' +
									shareURL +
									'" target="_blank" ' +
									'class="pswp__share--' +
									shareButtonData.id +
									'"' +
									(shareButtonData.download ? "download" : "") +
									">" +
									shareButtonData.label +
									"</a>";

								if (_options.parseShareButtonOut) {
									shareButtonOut = _options.parseShareButtonOut(
										shareButtonData,
										shareButtonOut
									);
								}
							}
							_shareModal.children[0].innerHTML = shareButtonOut;
							_shareModal.children[0].onclick = _openWindowPopup;
						},
						_hasCloseClass = function (target) {
							for (var i = 0; i < _options.closeElClasses.length; i++) {
								if (
									framework.hasClass(
										target,
										"pswp__" + _options.closeElClasses[i]
									)
								) {
									return true;
								}
							}
						},
						_idleInterval,
						_idleTimer,
						_idleIncrement = 0,
						_onIdleMouseMove = function () {
							clearTimeout(_idleTimer);
							_idleIncrement = 0;
							if (_isIdle) {
								ui.setIdle(false);
							}
						},
						_onMouseLeaveWindow = function (e) {
							e = e ? e : window.event;
							var from = e.relatedTarget || e.toElement;
							if (!from || from.nodeName === "HTML") {
								clearTimeout(_idleTimer);
								_idleTimer = setTimeout(function () {
									ui.setIdle(true);
								}, _options.timeToIdleOutside);
							}
						},
						_setupFullscreenAPI = function () {
							if (_options.fullscreenEl && !framework.features.isOldAndroid) {
								if (!_fullscrenAPI) {
									_fullscrenAPI = ui.getFullscreenAPI();
								}
								if (_fullscrenAPI) {
									framework.bind(
										document,
										_fullscrenAPI.eventK,
										ui.updateFullscreen
									);
									ui.updateFullscreen();
									framework.addClass(pswp.template, "pswp--supports-fs");
								} else {
									framework.removeClass(pswp.template, "pswp--supports-fs");
								}
							}
						},
						_setupLoadingIndicator = function () {
							// Setup loading indicator
							if (_options.preloaderEl) {
								_toggleLoadingIndicator(true);

								_listen("beforeChange", function () {
									clearTimeout(_loadingIndicatorTimeout);

									// display loading indicator with delay
									_loadingIndicatorTimeout = setTimeout(function () {
										if (pswp.currItem && pswp.currItem.loading) {
											if (
												!pswp.allowProgressiveImg() ||
												(pswp.currItem.img && !pswp.currItem.img.naturalWidth)
											) {
												// show preloader if progressive loading is not enabled,
												// or image width is not defined yet (because of slow connection)
												_toggleLoadingIndicator(false);
												// items-controller.js function allowProgressiveImg
											}
										} else {
											_toggleLoadingIndicator(true); // hide preloader
										}
									}, _options.loadingIndicatorDelay);
								});
								_listen("imageLoadComplete", function (index, item) {
									if (pswp.currItem === item) {
										_toggleLoadingIndicator(true);
									}
								});
							}
						},
						_toggleLoadingIndicator = function (hide) {
							if (_loadingIndicatorHidden !== hide) {
								_togglePswpClass(_loadingIndicator, "preloader--active", !hide);
								_loadingIndicatorHidden = hide;
							}
						},
						_applyNavBarGaps = function (item) {
							var gap = item.vGap;

							if (_fitControlsInViewport()) {
								var bars = _options.barsSize;
								if (_options.captionEl && bars.bottom === "auto") {
									if (!_fakeCaptionContainer) {
										_fakeCaptionContainer = framework.createEl(
											"pswp__caption pswp__caption--fake"
										);
										_fakeCaptionContainer.appendChild(
											framework.createEl("pswp__caption__center")
										);
										_controls.insertBefore(
											_fakeCaptionContainer,
											_captionContainer
										);
										framework.addClass(_controls, "pswp__ui--fit");
									}
									if (
										_options.addCaptionHTMLFn(item, _fakeCaptionContainer, true)
									) {
										var captionSize = _fakeCaptionContainer.clientHeight;
										gap.bottom = parseInt(captionSize, 10) || 44;
									} else {
										gap.bottom = bars.top; // if no caption, set size of bottom gap to size of top
									}
								} else {
									gap.bottom = bars.bottom === "auto" ? 0 : bars.bottom;
								}

								// height of top bar is static, no need to calculate it
								gap.top = bars.top;
							} else {
								gap.top = gap.bottom = 0;
							}
						},
						_setupIdle = function () {
							// Hide controls when mouse is used
							if (_options.timeToIdle) {
								_listen("mouseUsed", function () {
									framework.bind(document, "mousemove", _onIdleMouseMove);
									framework.bind(document, "mouseout", _onMouseLeaveWindow);

									_idleInterval = setInterval(function () {
										_idleIncrement++;
										if (_idleIncrement === 2) {
											ui.setIdle(true);
										}
									}, _options.timeToIdle / 2);
								});
							}
						},
						_setupHidingControlsDuringGestures = function () {
							// Hide controls on vertical drag
							_listen("onVerticalDrag", function (now) {
								if (_controlsVisible && now < 0.95) {
									ui.hideControls();
								} else if (!_controlsVisible && now >= 0.95) {
									ui.showControls();
								}
							});

							// Hide controls when pinching to close
							var pinchControlsHidden;
							_listen("onPinchClose", function (now) {
								if (_controlsVisible && now < 0.9) {
									ui.hideControls();
									pinchControlsHidden = true;
								} else if (
									pinchControlsHidden &&
									!_controlsVisible &&
									now > 0.9
								) {
									ui.showControls();
								}
							});

							_listen("zoomGestureEnded", function () {
								pinchControlsHidden = false;
								if (pinchControlsHidden && !_controlsVisible) {
									ui.showControls();
								}
							});
						};

					var _uiElements = [
						{
							name: "caption",
							option: "captionEl",
							onInit: function (el) {
								_captionContainer = el;
							},
						},
						{
							name: "share-modal",
							option: "shareEl",
							onInit: function (el) {
								_shareModal = el;
							},
							onTap: function () {
								_toggleShareModal();
							},
						},
						{
							name: "button--share",
							option: "shareEl",
							onInit: function (el) {
								_shareButton = el;
							},
							onTap: function () {
								_toggleShareModal();
							},
						},
						{
							name: "button--zoom",
							option: "zoomEl",
							onTap: pswp.toggleDesktopZoom,
						},
						{
							name: "counter",
							option: "counterEl",
							onInit: function (el) {
								_indexIndicator = el;
							},
						},
						{
							name: "button--close",
							option: "closeEl",
							onTap: pswp.close,
						},
						{
							name: "button--arrow--left",
							option: "arrowEl",
							onTap: pswp.prev,
						},
						{
							name: "button--arrow--right",
							option: "arrowEl",
							onTap: pswp.next,
						},
						{
							name: "button--fs",
							option: "fullscreenEl",
							onTap: function () {
								if (_fullscrenAPI.isFullscreen()) {
									_fullscrenAPI.exit();
								} else {
									_fullscrenAPI.enter();
								}
							},
						},
						{
							name: "preloader",
							option: "preloaderEl",
							onInit: function (el) {
								_loadingIndicator = el;
							},
						},
					];

					var _setupUIElements = function () {
						var item, classAttr, uiElement;

						var loopThroughChildElements = function (sChildren) {
							if (!sChildren) {
								return;
							}

							var l = sChildren.length;
							for (var i = 0; i < l; i++) {
								item = sChildren[i];
								classAttr = item.className;

								for (var a = 0; a < _uiElements.length; a++) {
									uiElement = _uiElements[a];

									if (classAttr.indexOf("pswp__" + uiElement.name) > -1) {
										if (_options[uiElement.option]) {
											// if element is not disabled from options

											framework.removeClass(item, "pswp__element--disabled");
											if (uiElement.onInit) {
												uiElement.onInit(item);
											}

											//item.style.display = 'block';
										} else {
											framework.addClass(item, "pswp__element--disabled");
											//item.style.display = 'none';
										}
									}
								}
							}
						};
						loopThroughChildElements(_controls.children);

						var topBar = framework.getChildByClass(_controls, "pswp__top-bar");
						if (topBar) {
							loopThroughChildElements(topBar.children);
						}
					};

					ui.init = function () {
						// extend options
						framework.extend(pswp.options, _defaultUIOptions, true);

						// create local link for fast access
						_options = pswp.options;

						// find pswp__ui element
						_controls = framework.getChildByClass(pswp.scrollWrap, "pswp__ui");

						// create local link
						_listen = pswp.listen;

						_setupHidingControlsDuringGestures();

						// update controls when slides change
						_listen("beforeChange", ui.update);

						// toggle zoom on double-tap
						_listen("doubleTap", function (point) {
							var initialZoomLevel = pswp.currItem.initialZoomLevel;
							if (pswp.getZoomLevel() !== initialZoomLevel) {
								pswp.zoomTo(initialZoomLevel, point, 333);
							} else {
								pswp.zoomTo(
									_options.getDoubleTapZoom(false, pswp.currItem),
									point,
									333
								);
							}
						});

						// Allow text selection in caption
						_listen("preventDragEvent", function (e, isDown, preventObj) {
							var t = e.target || e.srcElement;
							if (
								t &&
								t.getAttribute("class") &&
								e.type.indexOf("mouse") > -1 &&
								(t.getAttribute("class").indexOf("__caption") > 0 ||
									/(SMALL|STRONG|EM)/i.test(t.tagName))
							) {
								preventObj.prevent = false;
							}
						});

						// bind events for UI
						_listen("bindEvents", function () {
							framework.bind(_controls, "pswpTap click", _onControlsTap);
							framework.bind(pswp.scrollWrap, "pswpTap", ui.onGlobalTap);

							if (!pswp.likelyTouchDevice) {
								framework.bind(pswp.scrollWrap, "mouseover", ui.onMouseOver);
							}
						});

						// unbind events for UI
						_listen("unbindEvents", function () {
							if (!_shareModalHidden) {
								_toggleShareModal();
							}

							if (_idleInterval) {
								clearInterval(_idleInterval);
							}
							framework.unbind(document, "mouseout", _onMouseLeaveWindow);
							framework.unbind(document, "mousemove", _onIdleMouseMove);
							framework.unbind(_controls, "pswpTap click", _onControlsTap);
							framework.unbind(pswp.scrollWrap, "pswpTap", ui.onGlobalTap);
							framework.unbind(pswp.scrollWrap, "mouseover", ui.onMouseOver);

							if (_fullscrenAPI) {
								framework.unbind(
									document,
									_fullscrenAPI.eventK,
									ui.updateFullscreen
								);
								if (_fullscrenAPI.isFullscreen()) {
									_options.hideAnimationDuration = 0;
									_fullscrenAPI.exit();
								}
								_fullscrenAPI = null;
							}
						});

						// clean up things when gallery is destroyed
						_listen("destroy", function () {
							if (_options.captionEl) {
								if (_fakeCaptionContainer) {
									_controls.removeChild(_fakeCaptionContainer);
								}
								framework.removeClass(
									_captionContainer,
									"pswp__caption--empty"
								);
							}

							if (_shareModal) {
								_shareModal.children[0].onclick = null;
							}
							framework.removeClass(_controls, "pswp__ui--over-close");
							framework.addClass(_controls, "pswp__ui--hidden");
							ui.setIdle(false);
						});

						if (!_options.showAnimationDuration) {
							framework.removeClass(_controls, "pswp__ui--hidden");
						}
						_listen("initialZoomIn", function () {
							if (_options.showAnimationDuration) {
								framework.removeClass(_controls, "pswp__ui--hidden");
							}
						});
						_listen("initialZoomOut", function () {
							framework.addClass(_controls, "pswp__ui--hidden");
						});

						_listen("parseVerticalMargin", _applyNavBarGaps);

						_setupUIElements();

						if (_options.shareEl && _shareButton && _shareModal) {
							_shareModalHidden = true;
						}

						_countNumItems();

						_setupIdle();

						_setupFullscreenAPI();

						_setupLoadingIndicator();
					};

					ui.setIdle = function (isIdle) {
						_isIdle = isIdle;
						_togglePswpClass(_controls, "ui--idle", isIdle);
					};

					ui.update = function () {
						// Don't update UI if it's hidden
						if (_controlsVisible && pswp.currItem) {
							ui.updateIndexIndicator();

							if (_options.captionEl) {
								_options.addCaptionHTMLFn(pswp.currItem, _captionContainer);

								_togglePswpClass(
									_captionContainer,
									"caption--empty",
									!pswp.currItem.title
								);
							}

							_overlayUIUpdated = true;
						} else {
							_overlayUIUpdated = false;
						}

						if (!_shareModalHidden) {
							_toggleShareModal();
						}

						_countNumItems();
					};

					ui.updateFullscreen = function (e) {
						if (e) {
							// some browsers change window scroll position during the fullscreen
							// so PhotoSwipe updates it just in case
							setTimeout(function () {
								pswp.setScrollOffset(0, framework.getScrollY());
							}, 50);
						}

						// toogle pswp--fs class on root element
						framework[
							(_fullscrenAPI.isFullscreen() ? "add" : "remove") + "Class"
						](pswp.template, "pswp--fs");
					};

					ui.updateIndexIndicator = function () {
						if (_options.counterEl) {
							_indexIndicator.innerHTML =
								pswp.getCurrentIndex() +
								1 +
								_options.indexIndicatorSep +
								_options.getNumItemsFn();
						}
					};

					ui.onGlobalTap = function (e) {
						e = e || window.event;
						var target = e.target || e.srcElement;

						if (_blockControlsTap) {
							return;
						}

						if (e.detail && e.detail.pointerType === "mouse") {
							// close gallery if clicked outside of the image
							if (_hasCloseClass(target)) {
								pswp.close();
								return;
							}

							if (framework.hasClass(target, "pswp__img")) {
								if (
									pswp.getZoomLevel() === 1 &&
									pswp.getZoomLevel() <= pswp.currItem.fitRatio
								) {
									if (_options.clickToCloseNonZoomable) {
										pswp.close();
									}
								} else {
									pswp.toggleDesktopZoom(e.detail.releasePoint);
								}
							}
						} else {
							// tap anywhere (except buttons) to toggle visibility of controls
							if (_options.tapToToggleControls) {
								if (_controlsVisible) {
									ui.hideControls();
								} else {
									ui.showControls();
								}
							}

							// tap to close gallery
							if (
								_options.tapToClose &&
								(framework.hasClass(target, "pswp__img") ||
									_hasCloseClass(target))
							) {
								pswp.close();
								return;
							}
						}
					};
					ui.onMouseOver = function (e) {
						e = e || window.event;
						var target = e.target || e.srcElement;

						// add class when mouse is over an element that should close the gallery
						_togglePswpClass(
							_controls,
							"ui--over-close",
							_hasCloseClass(target)
						);
					};

					ui.hideControls = function () {
						framework.addClass(_controls, "pswp__ui--hidden");
						_controlsVisible = false;
					};

					ui.showControls = function () {
						_controlsVisible = true;
						if (!_overlayUIUpdated) {
							ui.update();
						}
						framework.removeClass(_controls, "pswp__ui--hidden");
					};

					ui.supportsFullscreen = function () {
						var d = document;
						return !!(
							d.exitFullscreen ||
							d.mozCancelFullScreen ||
							d.webkitExitFullscreen ||
							d.msExitFullscreen
						);
					};

					ui.getFullscreenAPI = function () {
						var dE = document.documentElement,
							api,
							tF = "fullscreenchange";

						if (dE.requestFullscreen) {
							api = {
								enterK: "requestFullscreen",
								exitK: "exitFullscreen",
								elementK: "fullscreenElement",
								eventK: tF,
							};
						} else if (dE.mozRequestFullScreen) {
							api = {
								enterK: "mozRequestFullScreen",
								exitK: "mozCancelFullScreen",
								elementK: "mozFullScreenElement",
								eventK: "moz" + tF,
							};
						} else if (dE.webkitRequestFullscreen) {
							api = {
								enterK: "webkitRequestFullscreen",
								exitK: "webkitExitFullscreen",
								elementK: "webkitFullscreenElement",
								eventK: "webkit" + tF,
							};
						} else if (dE.msRequestFullscreen) {
							api = {
								enterK: "msRequestFullscreen",
								exitK: "msExitFullscreen",
								elementK: "msFullscreenElement",
								eventK: "MSFullscreenChange",
							};
						}

						if (api) {
							api.enter = function () {
								// disable close-on-scroll in fullscreen
								_initalCloseOnScrollValue = _options.closeOnScroll;
								_options.closeOnScroll = false;

								if (this.enterK === "webkitRequestFullscreen") {
									pswp.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
								} else {
									return pswp.template[this.enterK]();
								}
							};
							api.exit = function () {
								_options.closeOnScroll = _initalCloseOnScrollValue;

								return document[this.exitK]();
							};
							api.isFullscreen = function () {
								return document[this.elementK];
							};
						}

						return api;
					};
				};
				return PhotoSwipeUI_Default;
			});

			/***/
		},

		/***/ 832: /***/ function (module, exports, __webpack_require__) {
			var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
			/*! PhotoSwipe - v4.1.3 - 2019-01-08
			 * http://photoswipe.com
			 * Copyright (c) 2019 Dmitry Semenov; */
			(function (root, factory) {
				if (true) {
					!((__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
					(__WEBPACK_AMD_DEFINE_RESULT__ =
						typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
							? __WEBPACK_AMD_DEFINE_FACTORY__.call(
									exports,
									__webpack_require__,
									exports,
									module
							  )
							: __WEBPACK_AMD_DEFINE_FACTORY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(this, function () {
				"use strict";
				var PhotoSwipe = function (template, UiClass, items, options) {
					/*>>framework-bridge*/
					/**
					 *
					 * Set of generic functions used by gallery.
					 *
					 * You're free to modify anything here as long as functionality is kept.
					 *
					 */
					var framework = {
						features: null,
						bind: function (target, type, listener, unbind) {
							var methodName = (unbind ? "remove" : "add") + "EventListener";
							type = type.split(" ");
							for (var i = 0; i < type.length; i++) {
								if (type[i]) {
									target[methodName](type[i], listener, false);
								}
							}
						},
						isArray: function (obj) {
							return obj instanceof Array;
						},
						createEl: function (classes, tag) {
							var el = document.createElement(tag || "div");
							if (classes) {
								el.className = classes;
							}
							return el;
						},
						getScrollY: function () {
							var yOffset = window.pageYOffset;
							return yOffset !== undefined
								? yOffset
								: document.documentElement.scrollTop;
						},
						unbind: function (target, type, listener) {
							framework.bind(target, type, listener, true);
						},
						removeClass: function (el, className) {
							var reg = new RegExp("(\\s|^)" + className + "(\\s|$)");
							el.className = el.className
								.replace(reg, " ")
								.replace(/^\s\s*/, "")
								.replace(/\s\s*$/, "");
						},
						addClass: function (el, className) {
							if (!framework.hasClass(el, className)) {
								el.className += (el.className ? " " : "") + className;
							}
						},
						hasClass: function (el, className) {
							return (
								el.className &&
								new RegExp("(^|\\s)" + className + "(\\s|$)").test(el.className)
							);
						},
						getChildByClass: function (parentEl, childClassName) {
							var node = parentEl.firstChild;
							while (node) {
								if (framework.hasClass(node, childClassName)) {
									return node;
								}
								node = node.nextSibling;
							}
						},
						arraySearch: function (array, value, key) {
							var i = array.length;
							while (i--) {
								if (array[i][key] === value) {
									return i;
								}
							}
							return -1;
						},
						extend: function (o1, o2, preventOverwrite) {
							for (var prop in o2) {
								if (o2.hasOwnProperty(prop)) {
									if (preventOverwrite && o1.hasOwnProperty(prop)) {
										continue;
									}
									o1[prop] = o2[prop];
								}
							}
						},
						easing: {
							sine: {
								out: function (k) {
									return Math.sin(k * (Math.PI / 2));
								},
								inOut: function (k) {
									return -(Math.cos(Math.PI * k) - 1) / 2;
								},
							},
							cubic: {
								out: function (k) {
									return --k * k * k + 1;
								},
							},
							/*
                  elastic: {
                    out: function ( k ) {
            
                      var s, a = 0.1, p = 0.4;
                      if ( k === 0 ) return 0;
                      if ( k === 1 ) return 1;
                      if ( !a || a < 1 ) { a = 1; s = p / 4; }
                      else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
                      return ( a * Math.pow( 2, - 10 * k) * Math.sin( ( k - s ) * ( 2 * Math.PI ) / p ) + 1 );
            
                    },
                  },
                  back: {
                    out: function ( k ) {
                      var s = 1.70158;
                      return --k * k * ( ( s + 1 ) * k + s ) + 1;
                    }
                  }
                */
						},

						/**
						 *
						 * @return {object}
						 *
						 * {
						 *  raf : request animation frame function
						 *  caf : cancel animation frame function
						 *  transfrom : transform property key (with vendor), or null if not supported
						 *  oldIE : IE8 or below
						 * }
						 *
						 */
						detectFeatures: function () {
							if (framework.features) {
								return framework.features;
							}
							var helperEl = framework.createEl(),
								helperStyle = helperEl.style,
								vendor = "",
								features = {};

							// IE8 and below
							features.oldIE = document.all && !document.addEventListener;

							features.touch = "ontouchstart" in window;

							if (window.requestAnimationFrame) {
								features.raf = window.requestAnimationFrame;
								features.caf = window.cancelAnimationFrame;
							}

							features.pointerEvent =
								!!window.PointerEvent || navigator.msPointerEnabled;

							// fix false-positive detection of old Android in new IE
							// (IE11 ua string contains "Android 4.0")

							if (!features.pointerEvent) {
								var ua = navigator.userAgent;

								// Detect if device is iPhone or iPod and if it's older than iOS 8
								// http://stackoverflow.com/a/14223920
								//
								// This detection is made because of buggy top/bottom toolbars
								// that don't trigger window.resize event.
								// For more info refer to _isFixedPosition variable in core.js

								if (/iP(hone|od)/.test(navigator.platform)) {
									var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
									if (v && v.length > 0) {
										v = parseInt(v[1], 10);
										if (v >= 1 && v < 8) {
											features.isOldIOSPhone = true;
										}
									}
								}

								// Detect old Android (before KitKat)
								// due to bugs related to position:fixed
								// http://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript

								var match = ua.match(/Android\s([0-9\.]*)/);
								var androidversion = match ? match[1] : 0;
								androidversion = parseFloat(androidversion);
								if (androidversion >= 1) {
									if (androidversion < 4.4) {
										features.isOldAndroid = true; // for fixed position bug & performance
									}
									features.androidVersion = androidversion; // for touchend bug
								}
								features.isMobileOpera = /opera mini|opera mobi/i.test(ua);

								// p.s. yes, yes, UA sniffing is bad, propose your solution for above bugs.
							}

							var styleChecks = ["transform", "perspective", "animationName"],
								vendors = ["", "webkit", "Moz", "ms", "O"],
								styleCheckItem,
								styleName;

							for (var i = 0; i < 4; i++) {
								vendor = vendors[i];

								for (var a = 0; a < 3; a++) {
									styleCheckItem = styleChecks[a];

									// uppercase first letter of property name, if vendor is present
									styleName =
										vendor +
										(vendor
											? styleCheckItem.charAt(0).toUpperCase() +
											  styleCheckItem.slice(1)
											: styleCheckItem);

									if (!features[styleCheckItem] && styleName in helperStyle) {
										features[styleCheckItem] = styleName;
									}
								}

								if (vendor && !features.raf) {
									vendor = vendor.toLowerCase();
									features.raf = window[vendor + "RequestAnimationFrame"];
									if (features.raf) {
										features.caf =
											window[vendor + "CancelAnimationFrame"] ||
											window[vendor + "CancelRequestAnimationFrame"];
									}
								}
							}

							if (!features.raf) {
								var lastTime = 0;
								features.raf = function (fn) {
									var currTime = new Date().getTime();
									var timeToCall = Math.max(0, 16 - (currTime - lastTime));
									var id = window.setTimeout(function () {
										fn(currTime + timeToCall);
									}, timeToCall);
									lastTime = currTime + timeToCall;
									return id;
								};
								features.caf = function (id) {
									clearTimeout(id);
								};
							}

							// Detect SVG support
							features.svg =
								!!document.createElementNS &&
								!!document.createElementNS("http://www.w3.org/2000/svg", "svg")
									.createSVGRect;

							framework.features = features;

							return features;
						},
					};

					framework.detectFeatures();

					// Override addEventListener for old versions of IE
					if (framework.features.oldIE) {
						framework.bind = function (target, type, listener, unbind) {
							type = type.split(" ");

							var methodName = (unbind ? "detach" : "attach") + "Event",
								evName,
								_handleEv = function () {
									listener.handleEvent.call(listener);
								};

							for (var i = 0; i < type.length; i++) {
								evName = type[i];
								if (evName) {
									if (typeof listener === "object" && listener.handleEvent) {
										if (!unbind) {
											listener["oldIE" + evName] = _handleEv;
										} else {
											if (!listener["oldIE" + evName]) {
												return false;
											}
										}

										target[methodName](
											"on" + evName,
											listener["oldIE" + evName]
										);
									} else {
										target[methodName]("on" + evName, listener);
									}
								}
							}
						};
					}

					/*>>framework-bridge*/

					/*>>core*/
					//function(template, UiClass, items, options)

					var self = this;

					/**
					 * Static vars, don't change unless you know what you're doing.
					 */
					var DOUBLE_TAP_RADIUS = 25,
						NUM_HOLDERS = 3;

					/**
					 * Options
					 */
					var _options = {
						allowPanToNext: true,
						spacing: 0.12,
						bgOpacity: 1,
						mouseUsed: false,
						loop: true,
						pinchToClose: true,
						closeOnScroll: true,
						closeOnVerticalDrag: true,
						verticalDragRange: 0.75,
						hideAnimationDuration: 333,
						showAnimationDuration: 333,
						showHideOpacity: false,
						focus: true,
						escKey: true,
						arrowKeys: true,
						mainScrollEndFriction: 0.35,
						panEndFriction: 0.35,
						isClickableElement: function (el) {
							return el.tagName === "A";
						},
						getDoubleTapZoom: function (isMouseClick, item) {
							if (isMouseClick) {
								return 1;
							} else {
								return item.initialZoomLevel < 0.7 ? 1 : 1.33;
							}
						},
						maxSpreadZoom: 1.33,
						modal: true,

						// not fully implemented yet
						scaleMode: "fit", // TODO
					};
					framework.extend(_options, options);

					/**
					 * Private helper variables & functions
					 */

					var _getEmptyPoint = function () {
						return { x: 0, y: 0 };
					};

					var _isOpen,
						_isDestroying,
						_closedByScroll,
						_currentItemIndex,
						_containerStyle,
						_containerShiftIndex,
						_currPanDist = _getEmptyPoint(),
						_startPanOffset = _getEmptyPoint(),
						_panOffset = _getEmptyPoint(),
						_upMoveEvents, // drag move, drag end & drag cancel events array
						_downEvents, // drag start events array
						_globalEventHandlers,
						_viewportSize = {},
						_currZoomLevel,
						_startZoomLevel,
						_translatePrefix,
						_translateSufix,
						_updateSizeInterval,
						_itemsNeedUpdate,
						_currPositionIndex = 0,
						_offset = {},
						_slideSize = _getEmptyPoint(), // size of slide area, including spacing
						_itemHolders,
						_prevItemIndex,
						_indexDiff = 0, // difference of indexes since last content update
						_dragStartEvent,
						_dragMoveEvent,
						_dragEndEvent,
						_dragCancelEvent,
						_transformKey,
						_pointerEventEnabled,
						_isFixedPosition = true,
						_likelyTouchDevice,
						_modules = [],
						_requestAF,
						_cancelAF,
						_initalClassName,
						_initalWindowScrollY,
						_oldIE,
						_currentWindowScrollY,
						_features,
						_windowVisibleSize = {},
						_renderMaxResolution = false,
						_orientationChangeTimeout,
						// Registers PhotoSWipe module (History, Controller ...)
						_registerModule = function (name, module) {
							framework.extend(self, module.publicMethods);
							_modules.push(name);
						},
						_getLoopedId = function (index) {
							var numSlides = _getNumItems();
							if (index > numSlides - 1) {
								return index - numSlides;
							} else if (index < 0) {
								return numSlides + index;
							}
							return index;
						},
						// Micro bind/trigger
						_listeners = {},
						_listen = function (name, fn) {
							if (!_listeners[name]) {
								_listeners[name] = [];
							}
							return _listeners[name].push(fn);
						},
						_shout = function (name) {
							var listeners = _listeners[name];

							if (listeners) {
								var args = Array.prototype.slice.call(arguments);
								args.shift();

								for (var i = 0; i < listeners.length; i++) {
									listeners[i].apply(self, args);
								}
							}
						},
						_getCurrentTime = function () {
							return new Date().getTime();
						},
						_applyBgOpacity = function (opacity) {
							_bgOpacity = opacity;
							self.bg.style.opacity = opacity * _options.bgOpacity;
						},
						_applyZoomTransform = function (styleObj, x, y, zoom, item) {
							if (!_renderMaxResolution || (item && item !== self.currItem)) {
								zoom = zoom / (item ? item.fitRatio : self.currItem.fitRatio);
							}

							styleObj[_transformKey] =
								_translatePrefix +
								x +
								"px, " +
								y +
								"px" +
								_translateSufix +
								" scale(" +
								zoom +
								")";
						},
						_applyCurrentZoomPan = function (allowRenderResolution) {
							if (_currZoomElementStyle) {
								if (allowRenderResolution) {
									if (_currZoomLevel > self.currItem.fitRatio) {
										if (!_renderMaxResolution) {
											_setImageSize(self.currItem, false, true);
											_renderMaxResolution = true;
										}
									} else {
										if (_renderMaxResolution) {
											_setImageSize(self.currItem);
											_renderMaxResolution = false;
										}
									}
								}

								_applyZoomTransform(
									_currZoomElementStyle,
									_panOffset.x,
									_panOffset.y,
									_currZoomLevel
								);
							}
						},
						_applyZoomPanToItem = function (item) {
							if (item.container) {
								_applyZoomTransform(
									item.container.style,
									item.initialPosition.x,
									item.initialPosition.y,
									item.initialZoomLevel,
									item
								);
							}
						},
						_setTranslateX = function (x, elStyle) {
							elStyle[_transformKey] =
								_translatePrefix + x + "px, 0px" + _translateSufix;
						},
						_moveMainScroll = function (x, dragging) {
							if (!_options.loop && dragging) {
								var newSlideIndexOffset =
										_currentItemIndex +
										(_slideSize.x * _currPositionIndex - x) / _slideSize.x,
									delta = Math.round(x - _mainScrollPos.x);

								if (
									(newSlideIndexOffset < 0 && delta > 0) ||
									(newSlideIndexOffset >= _getNumItems() - 1 && delta < 0)
								) {
									x = _mainScrollPos.x + delta * _options.mainScrollEndFriction;
								}
							}

							_mainScrollPos.x = x;
							_setTranslateX(x, _containerStyle);
						},
						_calculatePanOffset = function (axis, zoomLevel) {
							var m = _midZoomPoint[axis] - _offset[axis];
							return (
								_startPanOffset[axis] +
								_currPanDist[axis] +
								m -
								m * (zoomLevel / _startZoomLevel)
							);
						},
						_equalizePoints = function (p1, p2) {
							p1.x = p2.x;
							p1.y = p2.y;
							if (p2.id) {
								p1.id = p2.id;
							}
						},
						_roundPoint = function (p) {
							p.x = Math.round(p.x);
							p.y = Math.round(p.y);
						},
						_mouseMoveTimeout = null,
						_onFirstMouseMove = function () {
							// Wait until mouse move event is fired at least twice during 100ms
							// We do this, because some mobile browsers trigger it on touchstart
							if (_mouseMoveTimeout) {
								framework.unbind(document, "mousemove", _onFirstMouseMove);
								framework.addClass(template, "pswp--has_mouse");
								_options.mouseUsed = true;
								_shout("mouseUsed");
							}
							_mouseMoveTimeout = setTimeout(function () {
								_mouseMoveTimeout = null;
							}, 100);
						},
						_bindEvents = function () {
							framework.bind(document, "keydown", self);

							if (_features.transform) {
								// don't bind click event in browsers that don't support transform (mostly IE8)
								framework.bind(self.scrollWrap, "click", self);
							}

							if (!_options.mouseUsed) {
								framework.bind(document, "mousemove", _onFirstMouseMove);
							}

							framework.bind(window, "resize scroll orientationchange", self);

							_shout("bindEvents");
						},
						_unbindEvents = function () {
							framework.unbind(window, "resize scroll orientationchange", self);
							framework.unbind(window, "scroll", _globalEventHandlers.scroll);
							framework.unbind(document, "keydown", self);
							framework.unbind(document, "mousemove", _onFirstMouseMove);

							if (_features.transform) {
								framework.unbind(self.scrollWrap, "click", self);
							}

							if (_isDragging) {
								framework.unbind(window, _upMoveEvents, self);
							}

							clearTimeout(_orientationChangeTimeout);

							_shout("unbindEvents");
						},
						_calculatePanBounds = function (zoomLevel, update) {
							var bounds = _calculateItemSize(
								self.currItem,
								_viewportSize,
								zoomLevel
							);
							if (update) {
								_currPanBounds = bounds;
							}
							return bounds;
						},
						_getMinZoomLevel = function (item) {
							if (!item) {
								item = self.currItem;
							}
							return item.initialZoomLevel;
						},
						_getMaxZoomLevel = function (item) {
							if (!item) {
								item = self.currItem;
							}
							return item.w > 0 ? _options.maxSpreadZoom : 1;
						},
						// Return true if offset is out of the bounds
						_modifyDestPanOffset = function (
							axis,
							destPanBounds,
							destPanOffset,
							destZoomLevel
						) {
							if (destZoomLevel === self.currItem.initialZoomLevel) {
								destPanOffset[axis] = self.currItem.initialPosition[axis];
								return true;
							} else {
								destPanOffset[axis] = _calculatePanOffset(axis, destZoomLevel);

								if (destPanOffset[axis] > destPanBounds.min[axis]) {
									destPanOffset[axis] = destPanBounds.min[axis];
									return true;
								} else if (destPanOffset[axis] < destPanBounds.max[axis]) {
									destPanOffset[axis] = destPanBounds.max[axis];
									return true;
								}
							}
							return false;
						},
						_setupTransforms = function () {
							if (_transformKey) {
								// setup 3d transforms
								var allow3dTransform =
									_features.perspective && !_likelyTouchDevice;
								_translatePrefix =
									"translate" + (allow3dTransform ? "3d(" : "(");
								_translateSufix = _features.perspective ? ", 0px)" : ")";
								return;
							}

							// Override zoom/pan/move functions in case old browser is used (most likely IE)
							// (so they use left/top/width/height, instead of CSS transform)

							_transformKey = "left";
							framework.addClass(template, "pswp--ie");

							_setTranslateX = function (x, elStyle) {
								elStyle.left = x + "px";
							};
							_applyZoomPanToItem = function (item) {
								var zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
									s = item.container.style,
									w = zoomRatio * item.w,
									h = zoomRatio * item.h;

								s.width = w + "px";
								s.height = h + "px";
								s.left = item.initialPosition.x + "px";
								s.top = item.initialPosition.y + "px";
							};
							_applyCurrentZoomPan = function () {
								if (_currZoomElementStyle) {
									var s = _currZoomElementStyle,
										item = self.currItem,
										zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
										w = zoomRatio * item.w,
										h = zoomRatio * item.h;

									s.width = w + "px";
									s.height = h + "px";

									s.left = _panOffset.x + "px";
									s.top = _panOffset.y + "px";
								}
							};
						},
						_onKeyDown = function (e) {
							var keydownAction = "";
							if (_options.escKey && e.keyCode === 27) {
								keydownAction = "close";
							} else if (_options.arrowKeys) {
								if (e.keyCode === 37) {
									keydownAction = "prev";
								} else if (e.keyCode === 39) {
									keydownAction = "next";
								}
							}

							if (keydownAction) {
								// don't do anything if special key pressed to prevent from overriding default browser actions
								// e.g. in Chrome on Mac cmd+arrow-left returns to previous page
								if (!e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey) {
									if (e.preventDefault) {
										e.preventDefault();
									} else {
										e.returnValue = false;
									}
									self[keydownAction]();
								}
							}
						},
						_onGlobalClick = function (e) {
							if (!e) {
								return;
							}

							// don't allow click event to pass through when triggering after drag or some other gesture
							if (
								_moved ||
								_zoomStarted ||
								_mainScrollAnimating ||
								_verticalDragInitiated
							) {
								e.preventDefault();
								e.stopPropagation();
							}
						},
						_updatePageScrollOffset = function () {
							self.setScrollOffset(0, framework.getScrollY());
						};

					// Micro animation engine
					var _animations = {},
						_numAnimations = 0,
						_stopAnimation = function (name) {
							if (_animations[name]) {
								if (_animations[name].raf) {
									_cancelAF(_animations[name].raf);
								}
								_numAnimations--;
								delete _animations[name];
							}
						},
						_registerStartAnimation = function (name) {
							if (_animations[name]) {
								_stopAnimation(name);
							}
							if (!_animations[name]) {
								_numAnimations++;
								_animations[name] = {};
							}
						},
						_stopAllAnimations = function () {
							for (var prop in _animations) {
								if (_animations.hasOwnProperty(prop)) {
									_stopAnimation(prop);
								}
							}
						},
						_animateProp = function (
							name,
							b,
							endProp,
							d,
							easingFn,
							onUpdate,
							onComplete
						) {
							var startAnimTime = _getCurrentTime(),
								t;
							_registerStartAnimation(name);

							var animloop = function () {
								if (_animations[name]) {
									t = _getCurrentTime() - startAnimTime; // time diff
									//b - beginning (start prop)
									//d - anim duration

									if (t >= d) {
										_stopAnimation(name);
										onUpdate(endProp);
										if (onComplete) {
											onComplete();
										}
										return;
									}
									onUpdate((endProp - b) * easingFn(t / d) + b);

									_animations[name].raf = _requestAF(animloop);
								}
							};
							animloop();
						};

					var publicMethods = {
						// make a few local variables and functions public
						shout: _shout,
						listen: _listen,
						viewportSize: _viewportSize,
						options: _options,

						isMainScrollAnimating: function () {
							return _mainScrollAnimating;
						},
						getZoomLevel: function () {
							return _currZoomLevel;
						},
						getCurrentIndex: function () {
							return _currentItemIndex;
						},
						isDragging: function () {
							return _isDragging;
						},
						isZooming: function () {
							return _isZooming;
						},
						setScrollOffset: function (x, y) {
							_offset.x = x;
							_currentWindowScrollY = _offset.y = y;
							_shout("updateScrollOffset", _offset);
						},
						applyZoomPan: function (
							zoomLevel,
							panX,
							panY,
							allowRenderResolution
						) {
							_panOffset.x = panX;
							_panOffset.y = panY;
							_currZoomLevel = zoomLevel;
							_applyCurrentZoomPan(allowRenderResolution);
						},

						init: function () {
							if (_isOpen || _isDestroying) {
								return;
							}

							var i;

							self.framework = framework; // basic functionality
							self.template = template; // root DOM element of PhotoSwipe
							self.bg = framework.getChildByClass(template, "pswp__bg");

							_initalClassName = template.className;
							_isOpen = true;

							_features = framework.detectFeatures();
							_requestAF = _features.raf;
							_cancelAF = _features.caf;
							_transformKey = _features.transform;
							_oldIE = _features.oldIE;

							self.scrollWrap = framework.getChildByClass(
								template,
								"pswp__scroll-wrap"
							);
							self.container = framework.getChildByClass(
								self.scrollWrap,
								"pswp__container"
							);

							_containerStyle = self.container.style; // for fast access

							// Objects that hold slides (there are only 3 in DOM)
							self.itemHolders = _itemHolders = [
								{ el: self.container.children[0], wrap: 0, index: -1 },
								{ el: self.container.children[1], wrap: 0, index: -1 },
								{ el: self.container.children[2], wrap: 0, index: -1 },
							];

							// hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)
							_itemHolders[0].el.style.display =
								_itemHolders[2].el.style.display = "none";

							_setupTransforms();

							// Setup global events
							_globalEventHandlers = {
								resize: self.updateSize,

								// Fixes: iOS 10.3 resize event
								// does not update scrollWrap.clientWidth instantly after resize
								// https://github.com/dimsemenov/PhotoSwipe/issues/1315
								orientationchange: function () {
									clearTimeout(_orientationChangeTimeout);
									_orientationChangeTimeout = setTimeout(function () {
										if (_viewportSize.x !== self.scrollWrap.clientWidth) {
											self.updateSize();
										}
									}, 500);
								},
								scroll: _updatePageScrollOffset,
								keydown: _onKeyDown,
								click: _onGlobalClick,
							};

							// disable show/hide effects on old browsers that don't support CSS animations or transforms,
							// old IOS, Android and Opera mobile. Blackberry seems to work fine, even older models.
							var oldPhone =
								_features.isOldIOSPhone ||
								_features.isOldAndroid ||
								_features.isMobileOpera;
							if (
								!_features.animationName ||
								!_features.transform ||
								oldPhone
							) {
								_options.showAnimationDuration =
									_options.hideAnimationDuration = 0;
							}

							// init modules
							for (i = 0; i < _modules.length; i++) {
								self["init" + _modules[i]]();
							}

							// init
							if (UiClass) {
								var ui = (self.ui = new UiClass(self, framework));
								ui.init();
							}

							_shout("firstUpdate");
							_currentItemIndex = _currentItemIndex || _options.index || 0;
							// validate index
							if (
								isNaN(_currentItemIndex) ||
								_currentItemIndex < 0 ||
								_currentItemIndex >= _getNumItems()
							) {
								_currentItemIndex = 0;
							}
							self.currItem = _getItemAt(_currentItemIndex);

							if (_features.isOldIOSPhone || _features.isOldAndroid) {
								_isFixedPosition = false;
							}

							template.setAttribute("aria-hidden", "false");
							if (_options.modal) {
								if (!_isFixedPosition) {
									template.style.position = "absolute";
									template.style.top = framework.getScrollY() + "px";
								} else {
									template.style.position = "fixed";
								}
							}

							if (_currentWindowScrollY === undefined) {
								_shout("initialLayout");
								_currentWindowScrollY = _initalWindowScrollY =
									framework.getScrollY();
							}

							// add classes to root element of PhotoSwipe
							var rootClasses = "pswp--open ";
							if (_options.mainClass) {
								rootClasses += _options.mainClass + " ";
							}
							if (_options.showHideOpacity) {
								rootClasses += "pswp--animate_opacity ";
							}
							rootClasses += _likelyTouchDevice
								? "pswp--touch"
								: "pswp--notouch";
							rootClasses += _features.animationName
								? " pswp--css_animation"
								: "";
							rootClasses += _features.svg ? " pswp--svg" : "";
							framework.addClass(template, rootClasses);

							self.updateSize();

							// initial update
							_containerShiftIndex = -1;
							_indexDiff = null;
							for (i = 0; i < NUM_HOLDERS; i++) {
								_setTranslateX(
									(i + _containerShiftIndex) * _slideSize.x,
									_itemHolders[i].el.style
								);
							}

							if (!_oldIE) {
								framework.bind(self.scrollWrap, _downEvents, self); // no dragging for old IE
							}

							_listen("initialZoomInEnd", function () {
								self.setContent(_itemHolders[0], _currentItemIndex - 1);
								self.setContent(_itemHolders[2], _currentItemIndex + 1);

								_itemHolders[0].el.style.display =
									_itemHolders[2].el.style.display = "block";

								if (_options.focus) {
									// focus causes layout,
									// which causes lag during the animation,
									// that's why we delay it untill the initial zoom transition ends
									template.focus();
								}

								_bindEvents();
							});

							// set content for center slide (first time)
							self.setContent(_itemHolders[1], _currentItemIndex);

							self.updateCurrItem();

							_shout("afterInit");

							if (!_isFixedPosition) {
								// On all versions of iOS lower than 8.0, we check size of viewport every second.
								//
								// This is done to detect when Safari top & bottom bars appear,
								// as this action doesn't trigger any events (like resize).
								//
								// On iOS8 they fixed this.
								//
								// 10 Nov 2014: iOS 7 usage ~40%. iOS 8 usage 56%.

								_updateSizeInterval = setInterval(function () {
									if (
										!_numAnimations &&
										!_isDragging &&
										!_isZooming &&
										_currZoomLevel === self.currItem.initialZoomLevel
									) {
										self.updateSize();
									}
								}, 1000);
							}

							framework.addClass(template, "pswp--visible");
						},

						// Close the gallery, then destroy it
						close: function () {
							if (!_isOpen) {
								return;
							}

							_isOpen = false;
							_isDestroying = true;
							_shout("close");
							_unbindEvents();

							_showOrHide(self.currItem, null, true, self.destroy);
						},

						// destroys the gallery (unbinds events, cleans up intervals and timeouts to avoid memory leaks)
						destroy: function () {
							_shout("destroy");

							if (_showOrHideTimeout) {
								clearTimeout(_showOrHideTimeout);
							}

							template.setAttribute("aria-hidden", "true");
							template.className = _initalClassName;

							if (_updateSizeInterval) {
								clearInterval(_updateSizeInterval);
							}

							framework.unbind(self.scrollWrap, _downEvents, self);

							// we unbind scroll event at the end, as closing animation may depend on it
							framework.unbind(window, "scroll", self);

							_stopDragUpdateLoop();

							_stopAllAnimations();

							_listeners = null;
						},

						/**
						 * Pan image to position
						 * @param {Number} x
						 * @param {Number} y
						 * @param {Boolean} force Will ignore bounds if set to true.
						 */
						panTo: function (x, y, force) {
							if (!force) {
								if (x > _currPanBounds.min.x) {
									x = _currPanBounds.min.x;
								} else if (x < _currPanBounds.max.x) {
									x = _currPanBounds.max.x;
								}

								if (y > _currPanBounds.min.y) {
									y = _currPanBounds.min.y;
								} else if (y < _currPanBounds.max.y) {
									y = _currPanBounds.max.y;
								}
							}

							_panOffset.x = x;
							_panOffset.y = y;
							_applyCurrentZoomPan();
						},

						handleEvent: function (e) {
							e = e || window.event;
							if (_globalEventHandlers[e.type]) {
								_globalEventHandlers[e.type](e);
							}
						},

						goTo: function (index) {
							index = _getLoopedId(index);

							var diff = index - _currentItemIndex;
							_indexDiff = diff;

							_currentItemIndex = index;
							self.currItem = _getItemAt(_currentItemIndex);
							_currPositionIndex -= diff;

							_moveMainScroll(_slideSize.x * _currPositionIndex);

							_stopAllAnimations();
							_mainScrollAnimating = false;

							self.updateCurrItem();
						},
						next: function () {
							self.goTo(_currentItemIndex + 1);
						},
						prev: function () {
							self.goTo(_currentItemIndex - 1);
						},

						// update current zoom/pan objects
						updateCurrZoomItem: function (emulateSetContent) {
							if (emulateSetContent) {
								_shout("beforeChange", 0);
							}

							// itemHolder[1] is middle (current) item
							if (_itemHolders[1].el.children.length) {
								var zoomElement = _itemHolders[1].el.children[0];
								if (framework.hasClass(zoomElement, "pswp__zoom-wrap")) {
									_currZoomElementStyle = zoomElement.style;
								} else {
									_currZoomElementStyle = null;
								}
							} else {
								_currZoomElementStyle = null;
							}

							_currPanBounds = self.currItem.bounds;
							_startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;

							_panOffset.x = _currPanBounds.center.x;
							_panOffset.y = _currPanBounds.center.y;

							if (emulateSetContent) {
								_shout("afterChange");
							}
						},

						invalidateCurrItems: function () {
							_itemsNeedUpdate = true;
							for (var i = 0; i < NUM_HOLDERS; i++) {
								if (_itemHolders[i].item) {
									_itemHolders[i].item.needsUpdate = true;
								}
							}
						},

						updateCurrItem: function (beforeAnimation) {
							if (_indexDiff === 0) {
								return;
							}

							var diffAbs = Math.abs(_indexDiff),
								tempHolder;

							if (beforeAnimation && diffAbs < 2) {
								return;
							}

							self.currItem = _getItemAt(_currentItemIndex);
							_renderMaxResolution = false;

							_shout("beforeChange", _indexDiff);

							if (diffAbs >= NUM_HOLDERS) {
								_containerShiftIndex +=
									_indexDiff + (_indexDiff > 0 ? -NUM_HOLDERS : NUM_HOLDERS);
								diffAbs = NUM_HOLDERS;
							}
							for (var i = 0; i < diffAbs; i++) {
								if (_indexDiff > 0) {
									tempHolder = _itemHolders.shift();
									_itemHolders[NUM_HOLDERS - 1] = tempHolder; // move first to last

									_containerShiftIndex++;
									_setTranslateX(
										(_containerShiftIndex + 2) * _slideSize.x,
										tempHolder.el.style
									);
									self.setContent(
										tempHolder,
										_currentItemIndex - diffAbs + i + 1 + 1
									);
								} else {
									tempHolder = _itemHolders.pop();
									_itemHolders.unshift(tempHolder); // move last to first

									_containerShiftIndex--;
									_setTranslateX(
										_containerShiftIndex * _slideSize.x,
										tempHolder.el.style
									);
									self.setContent(
										tempHolder,
										_currentItemIndex + diffAbs - i - 1 - 1
									);
								}
							}

							// reset zoom/pan on previous item
							if (_currZoomElementStyle && Math.abs(_indexDiff) === 1) {
								var prevItem = _getItemAt(_prevItemIndex);
								if (prevItem.initialZoomLevel !== _currZoomLevel) {
									_calculateItemSize(prevItem, _viewportSize);
									_setImageSize(prevItem);
									_applyZoomPanToItem(prevItem);
								}
							}

							// reset diff after update
							_indexDiff = 0;

							self.updateCurrZoomItem();

							_prevItemIndex = _currentItemIndex;

							_shout("afterChange");
						},

						updateSize: function (force) {
							if (!_isFixedPosition && _options.modal) {
								var windowScrollY = framework.getScrollY();
								if (_currentWindowScrollY !== windowScrollY) {
									template.style.top = windowScrollY + "px";
									_currentWindowScrollY = windowScrollY;
								}
								if (
									!force &&
									_windowVisibleSize.x === window.innerWidth &&
									_windowVisibleSize.y === window.innerHeight
								) {
									return;
								}
								_windowVisibleSize.x = window.innerWidth;
								_windowVisibleSize.y = window.innerHeight;

								//template.style.width = _windowVisibleSize.x + 'px';
								template.style.height = _windowVisibleSize.y + "px";
							}

							_viewportSize.x = self.scrollWrap.clientWidth;
							_viewportSize.y = self.scrollWrap.clientHeight;

							_updatePageScrollOffset();

							_slideSize.x =
								_viewportSize.x +
								Math.round(_viewportSize.x * _options.spacing);
							_slideSize.y = _viewportSize.y;

							_moveMainScroll(_slideSize.x * _currPositionIndex);

							_shout("beforeResize"); // even may be used for example to switch image sources

							// don't re-calculate size on inital size update
							if (_containerShiftIndex !== undefined) {
								var holder, item, hIndex;

								for (var i = 0; i < NUM_HOLDERS; i++) {
									holder = _itemHolders[i];
									_setTranslateX(
										(i + _containerShiftIndex) * _slideSize.x,
										holder.el.style
									);

									hIndex = _currentItemIndex + i - 1;

									if (_options.loop && _getNumItems() > 2) {
										hIndex = _getLoopedId(hIndex);
									}

									// update zoom level on items and refresh source (if needsUpdate)
									item = _getItemAt(hIndex);

									// re-render gallery item if `needsUpdate`,
									// or doesn't have `bounds` (entirely new slide object)
									if (
										item &&
										(_itemsNeedUpdate || item.needsUpdate || !item.bounds)
									) {
										self.cleanSlide(item);

										self.setContent(holder, hIndex);

										// if "center" slide
										if (i === 1) {
											self.currItem = item;
											self.updateCurrZoomItem(true);
										}

										item.needsUpdate = false;
									} else if (holder.index === -1 && hIndex >= 0) {
										// add content first time
										self.setContent(holder, hIndex);
									}
									if (item && item.container) {
										_calculateItemSize(item, _viewportSize);
										_setImageSize(item);
										_applyZoomPanToItem(item);
									}
								}
								_itemsNeedUpdate = false;
							}

							_startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
							_currPanBounds = self.currItem.bounds;

							if (_currPanBounds) {
								_panOffset.x = _currPanBounds.center.x;
								_panOffset.y = _currPanBounds.center.y;
								_applyCurrentZoomPan(true);
							}

							_shout("resize");
						},

						// Zoom current item to
						zoomTo: function (
							destZoomLevel,
							centerPoint,
							speed,
							easingFn,
							updateFn
						) {
							/*
                  if(destZoomLevel === 'fit') {
                    destZoomLevel = self.currItem.fitRatio;
                  } else if(destZoomLevel === 'fill') {
                    destZoomLevel = self.currItem.fillRatio;
                  }
                */

							if (centerPoint) {
								_startZoomLevel = _currZoomLevel;
								_midZoomPoint.x = Math.abs(centerPoint.x) - _panOffset.x;
								_midZoomPoint.y = Math.abs(centerPoint.y) - _panOffset.y;
								_equalizePoints(_startPanOffset, _panOffset);
							}

							var destPanBounds = _calculatePanBounds(destZoomLevel, false),
								destPanOffset = {};

							_modifyDestPanOffset(
								"x",
								destPanBounds,
								destPanOffset,
								destZoomLevel
							);
							_modifyDestPanOffset(
								"y",
								destPanBounds,
								destPanOffset,
								destZoomLevel
							);

							var initialZoomLevel = _currZoomLevel;
							var initialPanOffset = {
								x: _panOffset.x,
								y: _panOffset.y,
							};

							_roundPoint(destPanOffset);

							var onUpdate = function (now) {
								if (now === 1) {
									_currZoomLevel = destZoomLevel;
									_panOffset.x = destPanOffset.x;
									_panOffset.y = destPanOffset.y;
								} else {
									_currZoomLevel =
										(destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
									_panOffset.x =
										(destPanOffset.x - initialPanOffset.x) * now +
										initialPanOffset.x;
									_panOffset.y =
										(destPanOffset.y - initialPanOffset.y) * now +
										initialPanOffset.y;
								}

								if (updateFn) {
									updateFn(now);
								}

								_applyCurrentZoomPan(now === 1);
							};

							if (speed) {
								_animateProp(
									"customZoomTo",
									0,
									1,
									speed,
									easingFn || framework.easing.sine.inOut,
									onUpdate
								);
							} else {
								onUpdate(1);
							}
						},
					};

					/*>>core*/

					/*>>gestures*/
					/**
					 * Mouse/touch/pointer event handlers.
					 *
					 * separated from @core.js for readability
					 */

					var MIN_SWIPE_DISTANCE = 30,
						DIRECTION_CHECK_OFFSET = 10; // amount of pixels to drag to determine direction of swipe

					var _gestureStartTime,
						_gestureCheckSpeedTime,
						// pool of objects that are used during dragging of zooming
						p = {}, // first point
						p2 = {}, // second point (for zoom gesture)
						delta = {},
						_currPoint = {},
						_startPoint = {},
						_currPointers = [],
						_startMainScrollPos = {},
						_releaseAnimData,
						_posPoints = [], // array of points during dragging, used to determine type of gesture
						_tempPoint = {},
						_isZoomingIn,
						_verticalDragInitiated,
						_oldAndroidTouchEndTimeout,
						_currZoomedItemIndex = 0,
						_centerPoint = _getEmptyPoint(),
						_lastReleaseTime = 0,
						_isDragging, // at least one pointer is down
						_isMultitouch, // at least two _pointers are down
						_zoomStarted, // zoom level changed during zoom gesture
						_moved,
						_dragAnimFrame,
						_mainScrollShifted,
						_currentPoints, // array of current touch points
						_isZooming,
						_currPointsDistance,
						_startPointsDistance,
						_currPanBounds,
						_mainScrollPos = _getEmptyPoint(),
						_currZoomElementStyle,
						_mainScrollAnimating, // true, if animation after swipe gesture is running
						_midZoomPoint = _getEmptyPoint(),
						_currCenterPoint = _getEmptyPoint(),
						_direction,
						_isFirstMove,
						_opacityChanged,
						_bgOpacity,
						_wasOverInitialZoom,
						_isEqualPoints = function (p1, p2) {
							return p1.x === p2.x && p1.y === p2.y;
						},
						_isNearbyPoints = function (touch0, touch1) {
							return (
								Math.abs(touch0.x - touch1.x) < DOUBLE_TAP_RADIUS &&
								Math.abs(touch0.y - touch1.y) < DOUBLE_TAP_RADIUS
							);
						},
						_calculatePointsDistance = function (p1, p2) {
							_tempPoint.x = Math.abs(p1.x - p2.x);
							_tempPoint.y = Math.abs(p1.y - p2.y);
							return Math.sqrt(
								_tempPoint.x * _tempPoint.x + _tempPoint.y * _tempPoint.y
							);
						},
						_stopDragUpdateLoop = function () {
							if (_dragAnimFrame) {
								_cancelAF(_dragAnimFrame);
								_dragAnimFrame = null;
							}
						},
						_dragUpdateLoop = function () {
							if (_isDragging) {
								_dragAnimFrame = _requestAF(_dragUpdateLoop);
								_renderMovement();
							}
						},
						_canPan = function () {
							return !(
								_options.scaleMode === "fit" &&
								_currZoomLevel === self.currItem.initialZoomLevel
							);
						},
						// find the closest parent DOM element
						_closestElement = function (el, fn) {
							if (!el || el === document) {
								return false;
							}

							// don't search elements above pswp__scroll-wrap
							if (
								el.getAttribute("class") &&
								el.getAttribute("class").indexOf("pswp__scroll-wrap") > -1
							) {
								return false;
							}

							if (fn(el)) {
								return el;
							}

							return _closestElement(el.parentNode, fn);
						},
						_preventObj = {},
						_preventDefaultEventBehaviour = function (e, isDown) {
							_preventObj.prevent = !_closestElement(
								e.target,
								_options.isClickableElement
							);

							_shout("preventDragEvent", e, isDown, _preventObj);
							return _preventObj.prevent;
						},
						_convertTouchToPoint = function (touch, p) {
							p.x = touch.pageX;
							p.y = touch.pageY;
							p.id = touch.identifier;
							return p;
						},
						_findCenterOfPoints = function (p1, p2, pCenter) {
							pCenter.x = (p1.x + p2.x) * 0.5;
							pCenter.y = (p1.y + p2.y) * 0.5;
						},
						_pushPosPoint = function (time, x, y) {
							if (time - _gestureCheckSpeedTime > 50) {
								var o = _posPoints.length > 2 ? _posPoints.shift() : {};
								o.x = x;
								o.y = y;
								_posPoints.push(o);
								_gestureCheckSpeedTime = time;
							}
						},
						_calculateVerticalDragOpacityRatio = function () {
							var yOffset = _panOffset.y - self.currItem.initialPosition.y; // difference between initial and current position
							return 1 - Math.abs(yOffset / (_viewportSize.y / 2));
						},
						// points pool, reused during touch events
						_ePoint1 = {},
						_ePoint2 = {},
						_tempPointsArr = [],
						_tempCounter,
						_getTouchPoints = function (e) {
							// clean up previous points, without recreating array
							while (_tempPointsArr.length > 0) {
								_tempPointsArr.pop();
							}

							if (!_pointerEventEnabled) {
								if (e.type.indexOf("touch") > -1) {
									if (e.touches && e.touches.length > 0) {
										_tempPointsArr[0] = _convertTouchToPoint(
											e.touches[0],
											_ePoint1
										);
										if (e.touches.length > 1) {
											_tempPointsArr[1] = _convertTouchToPoint(
												e.touches[1],
												_ePoint2
											);
										}
									}
								} else {
									_ePoint1.x = e.pageX;
									_ePoint1.y = e.pageY;
									_ePoint1.id = "";
									_tempPointsArr[0] = _ePoint1; //_ePoint1;
								}
							} else {
								_tempCounter = 0;
								// we can use forEach, as pointer events are supported only in modern browsers
								_currPointers.forEach(function (p) {
									if (_tempCounter === 0) {
										_tempPointsArr[0] = p;
									} else if (_tempCounter === 1) {
										_tempPointsArr[1] = p;
									}
									_tempCounter++;
								});
							}
							return _tempPointsArr;
						},
						_panOrMoveMainScroll = function (axis, delta) {
							var panFriction,
								overDiff = 0,
								newOffset = _panOffset[axis] + delta[axis],
								startOverDiff,
								dir = delta[axis] > 0,
								newMainScrollPosition = _mainScrollPos.x + delta.x,
								mainScrollDiff = _mainScrollPos.x - _startMainScrollPos.x,
								newPanPos,
								newMainScrollPos;

							// calculate fdistance over the bounds and friction
							if (
								newOffset > _currPanBounds.min[axis] ||
								newOffset < _currPanBounds.max[axis]
							) {
								panFriction = _options.panEndFriction;
								// Linear increasing of friction, so at 1/4 of viewport it's at max value.
								// Looks not as nice as was expected. Left for history.
								// panFriction = (1 - (_panOffset[axis] + delta[axis] + panBounds.min[axis]) / (_viewportSize[axis] / 4) );
							} else {
								panFriction = 1;
							}

							newOffset = _panOffset[axis] + delta[axis] * panFriction;

							// move main scroll or start panning
							if (
								_options.allowPanToNext ||
								_currZoomLevel === self.currItem.initialZoomLevel
							) {
								if (!_currZoomElementStyle) {
									newMainScrollPos = newMainScrollPosition;
								} else if (
									_direction === "h" &&
									axis === "x" &&
									!_zoomStarted
								) {
									if (dir) {
										if (newOffset > _currPanBounds.min[axis]) {
											panFriction = _options.panEndFriction;
											overDiff = _currPanBounds.min[axis] - newOffset;
											startOverDiff =
												_currPanBounds.min[axis] - _startPanOffset[axis];
										}

										// drag right
										if (
											(startOverDiff <= 0 || mainScrollDiff < 0) &&
											_getNumItems() > 1
										) {
											newMainScrollPos = newMainScrollPosition;
											if (
												mainScrollDiff < 0 &&
												newMainScrollPosition > _startMainScrollPos.x
											) {
												newMainScrollPos = _startMainScrollPos.x;
											}
										} else {
											if (_currPanBounds.min.x !== _currPanBounds.max.x) {
												newPanPos = newOffset;
											}
										}
									} else {
										if (newOffset < _currPanBounds.max[axis]) {
											panFriction = _options.panEndFriction;
											overDiff = newOffset - _currPanBounds.max[axis];
											startOverDiff =
												_startPanOffset[axis] - _currPanBounds.max[axis];
										}

										if (
											(startOverDiff <= 0 || mainScrollDiff > 0) &&
											_getNumItems() > 1
										) {
											newMainScrollPos = newMainScrollPosition;

											if (
												mainScrollDiff > 0 &&
												newMainScrollPosition < _startMainScrollPos.x
											) {
												newMainScrollPos = _startMainScrollPos.x;
											}
										} else {
											if (_currPanBounds.min.x !== _currPanBounds.max.x) {
												newPanPos = newOffset;
											}
										}
									}

									//
								}

								if (axis === "x") {
									if (newMainScrollPos !== undefined) {
										_moveMainScroll(newMainScrollPos, true);
										if (newMainScrollPos === _startMainScrollPos.x) {
											_mainScrollShifted = false;
										} else {
											_mainScrollShifted = true;
										}
									}

									if (_currPanBounds.min.x !== _currPanBounds.max.x) {
										if (newPanPos !== undefined) {
											_panOffset.x = newPanPos;
										} else if (!_mainScrollShifted) {
											_panOffset.x += delta.x * panFriction;
										}
									}

									return newMainScrollPos !== undefined;
								}
							}

							if (!_mainScrollAnimating) {
								if (!_mainScrollShifted) {
									if (_currZoomLevel > self.currItem.fitRatio) {
										_panOffset[axis] += delta[axis] * panFriction;
									}
								}
							}
						},
						// Pointerdown/touchstart/mousedown handler
						_onDragStart = function (e) {
							// Allow dragging only via left mouse button.
							// As this handler is not added in IE8 - we ignore e.which
							//
							// http://www.quirksmode.org/js/events_properties.html
							// https://developer.mozilla.org/en-US/docs/Web/API/event.button
							if (e.type === "mousedown" && e.button > 0) {
								return;
							}

							if (_initialZoomRunning) {
								e.preventDefault();
								return;
							}

							if (_oldAndroidTouchEndTimeout && e.type === "mousedown") {
								return;
							}

							if (_preventDefaultEventBehaviour(e, true)) {
								e.preventDefault();
							}

							_shout("pointerDown");

							if (_pointerEventEnabled) {
								var pointerIndex = framework.arraySearch(
									_currPointers,
									e.pointerId,
									"id"
								);
								if (pointerIndex < 0) {
									pointerIndex = _currPointers.length;
								}
								_currPointers[pointerIndex] = {
									x: e.pageX,
									y: e.pageY,
									id: e.pointerId,
								};
							}

							var startPointsList = _getTouchPoints(e),
								numPoints = startPointsList.length;

							_currentPoints = null;

							_stopAllAnimations();

							// init drag
							if (!_isDragging || numPoints === 1) {
								_isDragging = _isFirstMove = true;
								framework.bind(window, _upMoveEvents, self);

								_isZoomingIn =
									_wasOverInitialZoom =
									_opacityChanged =
									_verticalDragInitiated =
									_mainScrollShifted =
									_moved =
									_isMultitouch =
									_zoomStarted =
										false;

								_direction = null;

								_shout("firstTouchStart", startPointsList);

								_equalizePoints(_startPanOffset, _panOffset);

								_currPanDist.x = _currPanDist.y = 0;
								_equalizePoints(_currPoint, startPointsList[0]);
								_equalizePoints(_startPoint, _currPoint);

								//_equalizePoints(_startMainScrollPos, _mainScrollPos);
								_startMainScrollPos.x = _slideSize.x * _currPositionIndex;

								_posPoints = [
									{
										x: _currPoint.x,
										y: _currPoint.y,
									},
								];

								_gestureCheckSpeedTime = _gestureStartTime = _getCurrentTime();

								//_mainScrollAnimationEnd(true);
								_calculatePanBounds(_currZoomLevel, true);

								// Start rendering
								_stopDragUpdateLoop();
								_dragUpdateLoop();
							}

							// init zoom
							if (
								!_isZooming &&
								numPoints > 1 &&
								!_mainScrollAnimating &&
								!_mainScrollShifted
							) {
								_startZoomLevel = _currZoomLevel;
								_zoomStarted = false; // true if zoom changed at least once

								_isZooming = _isMultitouch = true;
								_currPanDist.y = _currPanDist.x = 0;

								_equalizePoints(_startPanOffset, _panOffset);

								_equalizePoints(p, startPointsList[0]);
								_equalizePoints(p2, startPointsList[1]);

								_findCenterOfPoints(p, p2, _currCenterPoint);

								_midZoomPoint.x = Math.abs(_currCenterPoint.x) - _panOffset.x;
								_midZoomPoint.y = Math.abs(_currCenterPoint.y) - _panOffset.y;
								_currPointsDistance = _startPointsDistance =
									_calculatePointsDistance(p, p2);
							}
						},
						// Pointermove/touchmove/mousemove handler
						_onDragMove = function (e) {
							e.preventDefault();

							if (_pointerEventEnabled) {
								var pointerIndex = framework.arraySearch(
									_currPointers,
									e.pointerId,
									"id"
								);
								if (pointerIndex > -1) {
									var p = _currPointers[pointerIndex];
									p.x = e.pageX;
									p.y = e.pageY;
								}
							}

							if (_isDragging) {
								var touchesList = _getTouchPoints(e);
								if (!_direction && !_moved && !_isZooming) {
									if (_mainScrollPos.x !== _slideSize.x * _currPositionIndex) {
										// if main scroll position is shifted – direction is always horizontal
										_direction = "h";
									} else {
										var diff =
											Math.abs(touchesList[0].x - _currPoint.x) -
											Math.abs(touchesList[0].y - _currPoint.y);
										// check the direction of movement
										if (Math.abs(diff) >= DIRECTION_CHECK_OFFSET) {
											_direction = diff > 0 ? "h" : "v";
											_currentPoints = touchesList;
										}
									}
								} else {
									_currentPoints = touchesList;
								}
							}
						},
						//
						_renderMovement = function () {
							if (!_currentPoints) {
								return;
							}

							var numPoints = _currentPoints.length;

							if (numPoints === 0) {
								return;
							}

							_equalizePoints(p, _currentPoints[0]);

							delta.x = p.x - _currPoint.x;
							delta.y = p.y - _currPoint.y;

							if (_isZooming && numPoints > 1) {
								// Handle behaviour for more than 1 point

								_currPoint.x = p.x;
								_currPoint.y = p.y;

								// check if one of two points changed
								if (
									!delta.x &&
									!delta.y &&
									_isEqualPoints(_currentPoints[1], p2)
								) {
									return;
								}

								_equalizePoints(p2, _currentPoints[1]);

								if (!_zoomStarted) {
									_zoomStarted = true;
									_shout("zoomGestureStarted");
								}

								// Distance between two points
								var pointsDistance = _calculatePointsDistance(p, p2);

								var zoomLevel = _calculateZoomLevel(pointsDistance);

								// slightly over the of initial zoom level
								if (
									zoomLevel >
									self.currItem.initialZoomLevel +
										self.currItem.initialZoomLevel / 15
								) {
									_wasOverInitialZoom = true;
								}

								// Apply the friction if zoom level is out of the bounds
								var zoomFriction = 1,
									minZoomLevel = _getMinZoomLevel(),
									maxZoomLevel = _getMaxZoomLevel();

								if (zoomLevel < minZoomLevel) {
									if (
										_options.pinchToClose &&
										!_wasOverInitialZoom &&
										_startZoomLevel <= self.currItem.initialZoomLevel
									) {
										// fade out background if zooming out
										var minusDiff = minZoomLevel - zoomLevel;
										var percent = 1 - minusDiff / (minZoomLevel / 1.2);

										_applyBgOpacity(percent);
										_shout("onPinchClose", percent);
										_opacityChanged = true;
									} else {
										zoomFriction = (minZoomLevel - zoomLevel) / minZoomLevel;
										if (zoomFriction > 1) {
											zoomFriction = 1;
										}
										zoomLevel =
											minZoomLevel - zoomFriction * (minZoomLevel / 3);
									}
								} else if (zoomLevel > maxZoomLevel) {
									// 1.5 - extra zoom level above the max. E.g. if max is x6, real max 6 + 1.5 = 7.5
									zoomFriction =
										(zoomLevel - maxZoomLevel) / (minZoomLevel * 6);
									if (zoomFriction > 1) {
										zoomFriction = 1;
									}
									zoomLevel = maxZoomLevel + zoomFriction * minZoomLevel;
								}

								if (zoomFriction < 0) {
									zoomFriction = 0;
								}

								// distance between touch points after friction is applied
								_currPointsDistance = pointsDistance;

								// _centerPoint - The point in the middle of two pointers
								_findCenterOfPoints(p, p2, _centerPoint);

								// paning with two pointers pressed
								_currPanDist.x += _centerPoint.x - _currCenterPoint.x;
								_currPanDist.y += _centerPoint.y - _currCenterPoint.y;
								_equalizePoints(_currCenterPoint, _centerPoint);

								_panOffset.x = _calculatePanOffset("x", zoomLevel);
								_panOffset.y = _calculatePanOffset("y", zoomLevel);

								_isZoomingIn = zoomLevel > _currZoomLevel;
								_currZoomLevel = zoomLevel;
								_applyCurrentZoomPan();
							} else {
								// handle behaviour for one point (dragging or panning)

								if (!_direction) {
									return;
								}

								if (_isFirstMove) {
									_isFirstMove = false;

									// subtract drag distance that was used during the detection direction

									if (Math.abs(delta.x) >= DIRECTION_CHECK_OFFSET) {
										delta.x -= _currentPoints[0].x - _startPoint.x;
									}

									if (Math.abs(delta.y) >= DIRECTION_CHECK_OFFSET) {
										delta.y -= _currentPoints[0].y - _startPoint.y;
									}
								}

								_currPoint.x = p.x;
								_currPoint.y = p.y;

								// do nothing if pointers position hasn't changed
								if (delta.x === 0 && delta.y === 0) {
									return;
								}

								if (_direction === "v" && _options.closeOnVerticalDrag) {
									if (!_canPan()) {
										_currPanDist.y += delta.y;
										_panOffset.y += delta.y;

										var opacityRatio = _calculateVerticalDragOpacityRatio();

										_verticalDragInitiated = true;
										_shout("onVerticalDrag", opacityRatio);

										_applyBgOpacity(opacityRatio);
										_applyCurrentZoomPan();
										return;
									}
								}

								_pushPosPoint(_getCurrentTime(), p.x, p.y);

								_moved = true;
								_currPanBounds = self.currItem.bounds;

								var mainScrollChanged = _panOrMoveMainScroll("x", delta);
								if (!mainScrollChanged) {
									_panOrMoveMainScroll("y", delta);

									_roundPoint(_panOffset);
									_applyCurrentZoomPan();
								}
							}
						},
						// Pointerup/pointercancel/touchend/touchcancel/mouseup event handler
						_onDragRelease = function (e) {
							if (_features.isOldAndroid) {
								if (_oldAndroidTouchEndTimeout && e.type === "mouseup") {
									return;
								}

								// on Android (v4.1, 4.2, 4.3 & possibly older)
								// ghost mousedown/up event isn't preventable via e.preventDefault,
								// which causes fake mousedown event
								// so we block mousedown/up for 600ms
								if (e.type.indexOf("touch") > -1) {
									clearTimeout(_oldAndroidTouchEndTimeout);
									_oldAndroidTouchEndTimeout = setTimeout(function () {
										_oldAndroidTouchEndTimeout = 0;
									}, 600);
								}
							}

							_shout("pointerUp");

							if (_preventDefaultEventBehaviour(e, false)) {
								e.preventDefault();
							}

							var releasePoint;

							if (_pointerEventEnabled) {
								var pointerIndex = framework.arraySearch(
									_currPointers,
									e.pointerId,
									"id"
								);

								if (pointerIndex > -1) {
									releasePoint = _currPointers.splice(pointerIndex, 1)[0];

									if (navigator.msPointerEnabled) {
										var MSPOINTER_TYPES = {
											4: "mouse", // event.MSPOINTER_TYPE_MOUSE
											2: "touch", // event.MSPOINTER_TYPE_TOUCH
											3: "pen", // event.MSPOINTER_TYPE_PEN
										};
										releasePoint.type = MSPOINTER_TYPES[e.pointerType];

										if (!releasePoint.type) {
											releasePoint.type = e.pointerType || "mouse";
										}
									} else {
										releasePoint.type = e.pointerType || "mouse";
									}
								}
							}

							var touchList = _getTouchPoints(e),
								gestureType,
								numPoints = touchList.length;

							if (e.type === "mouseup") {
								numPoints = 0;
							}

							// Do nothing if there were 3 touch points or more
							if (numPoints === 2) {
								_currentPoints = null;
								return true;
							}

							// if second pointer released
							if (numPoints === 1) {
								_equalizePoints(_startPoint, touchList[0]);
							}

							// pointer hasn't moved, send "tap release" point
							if (numPoints === 0 && !_direction && !_mainScrollAnimating) {
								if (!releasePoint) {
									if (e.type === "mouseup") {
										releasePoint = { x: e.pageX, y: e.pageY, type: "mouse" };
									} else if (e.changedTouches && e.changedTouches[0]) {
										releasePoint = {
											x: e.changedTouches[0].pageX,
											y: e.changedTouches[0].pageY,
											type: "touch",
										};
									}
								}

								_shout("touchRelease", e, releasePoint);
							}

							// Difference in time between releasing of two last touch points (zoom gesture)
							var releaseTimeDiff = -1;

							// Gesture completed, no pointers left
							if (numPoints === 0) {
								_isDragging = false;
								framework.unbind(window, _upMoveEvents, self);

								_stopDragUpdateLoop();

								if (_isZooming) {
									// Two points released at the same time
									releaseTimeDiff = 0;
								} else if (_lastReleaseTime !== -1) {
									releaseTimeDiff = _getCurrentTime() - _lastReleaseTime;
								}
							}
							_lastReleaseTime = numPoints === 1 ? _getCurrentTime() : -1;

							if (releaseTimeDiff !== -1 && releaseTimeDiff < 150) {
								gestureType = "zoom";
							} else {
								gestureType = "swipe";
							}

							if (_isZooming && numPoints < 2) {
								_isZooming = false;

								// Only second point released
								if (numPoints === 1) {
									gestureType = "zoomPointerUp";
								}
								_shout("zoomGestureEnded");
							}

							_currentPoints = null;
							if (
								!_moved &&
								!_zoomStarted &&
								!_mainScrollAnimating &&
								!_verticalDragInitiated
							) {
								// nothing to animate
								return;
							}

							_stopAllAnimations();

							if (!_releaseAnimData) {
								_releaseAnimData = _initDragReleaseAnimationData();
							}

							_releaseAnimData.calculateSwipeSpeed("x");

							if (_verticalDragInitiated) {
								var opacityRatio = _calculateVerticalDragOpacityRatio();

								if (opacityRatio < _options.verticalDragRange) {
									self.close();
								} else {
									var initalPanY = _panOffset.y,
										initialBgOpacity = _bgOpacity;

									_animateProp(
										"verticalDrag",
										0,
										1,
										300,
										framework.easing.cubic.out,
										function (now) {
											_panOffset.y =
												(self.currItem.initialPosition.y - initalPanY) * now +
												initalPanY;

											_applyBgOpacity(
												(1 - initialBgOpacity) * now + initialBgOpacity
											);
											_applyCurrentZoomPan();
										}
									);

									_shout("onVerticalDrag", 1);
								}

								return;
							}

							// main scroll
							if (
								(_mainScrollShifted || _mainScrollAnimating) &&
								numPoints === 0
							) {
								var itemChanged = _finishSwipeMainScrollGesture(
									gestureType,
									_releaseAnimData
								);
								if (itemChanged) {
									return;
								}
								gestureType = "zoomPointerUp";
							}

							// prevent zoom/pan animation when main scroll animation runs
							if (_mainScrollAnimating) {
								return;
							}

							// Complete simple zoom gesture (reset zoom level if it's out of the bounds)
							if (gestureType !== "swipe") {
								_completeZoomGesture();
								return;
							}

							// Complete pan gesture if main scroll is not shifted, and it's possible to pan current image
							if (
								!_mainScrollShifted &&
								_currZoomLevel > self.currItem.fitRatio
							) {
								_completePanGesture(_releaseAnimData);
							}
						},
						// Returns object with data about gesture
						// It's created only once and then reused
						_initDragReleaseAnimationData = function () {
							// temp local vars
							var lastFlickDuration, tempReleasePos;

							// s = this
							var s = {
								lastFlickOffset: {},
								lastFlickDist: {},
								lastFlickSpeed: {},
								slowDownRatio: {},
								slowDownRatioReverse: {},
								speedDecelerationRatio: {},
								speedDecelerationRatioAbs: {},
								distanceOffset: {},
								backAnimDestination: {},
								backAnimStarted: {},
								calculateSwipeSpeed: function (axis) {
									if (_posPoints.length > 1) {
										lastFlickDuration =
											_getCurrentTime() - _gestureCheckSpeedTime + 50;
										tempReleasePos = _posPoints[_posPoints.length - 2][axis];
									} else {
										lastFlickDuration = _getCurrentTime() - _gestureStartTime; // total gesture duration
										tempReleasePos = _startPoint[axis];
									}
									s.lastFlickOffset[axis] = _currPoint[axis] - tempReleasePos;
									s.lastFlickDist[axis] = Math.abs(s.lastFlickOffset[axis]);
									if (s.lastFlickDist[axis] > 20) {
										s.lastFlickSpeed[axis] =
											s.lastFlickOffset[axis] / lastFlickDuration;
									} else {
										s.lastFlickSpeed[axis] = 0;
									}
									if (Math.abs(s.lastFlickSpeed[axis]) < 0.1) {
										s.lastFlickSpeed[axis] = 0;
									}

									s.slowDownRatio[axis] = 0.95;
									s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
									s.speedDecelerationRatio[axis] = 1;
								},

								calculateOverBoundsAnimOffset: function (axis, speed) {
									if (!s.backAnimStarted[axis]) {
										if (_panOffset[axis] > _currPanBounds.min[axis]) {
											s.backAnimDestination[axis] = _currPanBounds.min[axis];
										} else if (_panOffset[axis] < _currPanBounds.max[axis]) {
											s.backAnimDestination[axis] = _currPanBounds.max[axis];
										}

										if (s.backAnimDestination[axis] !== undefined) {
											s.slowDownRatio[axis] = 0.7;
											s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
											if (s.speedDecelerationRatioAbs[axis] < 0.05) {
												s.lastFlickSpeed[axis] = 0;
												s.backAnimStarted[axis] = true;

												_animateProp(
													"bounceZoomPan" + axis,
													_panOffset[axis],
													s.backAnimDestination[axis],
													speed || 300,
													framework.easing.sine.out,
													function (pos) {
														_panOffset[axis] = pos;
														_applyCurrentZoomPan();
													}
												);
											}
										}
									}
								},

								// Reduces the speed by slowDownRatio (per 10ms)
								calculateAnimOffset: function (axis) {
									if (!s.backAnimStarted[axis]) {
										s.speedDecelerationRatio[axis] =
											s.speedDecelerationRatio[axis] *
											(s.slowDownRatio[axis] +
												s.slowDownRatioReverse[axis] -
												(s.slowDownRatioReverse[axis] * s.timeDiff) / 10);

										s.speedDecelerationRatioAbs[axis] = Math.abs(
											s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis]
										);
										s.distanceOffset[axis] =
											s.lastFlickSpeed[axis] *
											s.speedDecelerationRatio[axis] *
											s.timeDiff;
										_panOffset[axis] += s.distanceOffset[axis];
									}
								},

								panAnimLoop: function () {
									if (_animations.zoomPan) {
										_animations.zoomPan.raf = _requestAF(s.panAnimLoop);

										s.now = _getCurrentTime();
										s.timeDiff = s.now - s.lastNow;
										s.lastNow = s.now;

										s.calculateAnimOffset("x");
										s.calculateAnimOffset("y");

										_applyCurrentZoomPan();

										s.calculateOverBoundsAnimOffset("x");
										s.calculateOverBoundsAnimOffset("y");

										if (
											s.speedDecelerationRatioAbs.x < 0.05 &&
											s.speedDecelerationRatioAbs.y < 0.05
										) {
											// round pan position
											_panOffset.x = Math.round(_panOffset.x);
											_panOffset.y = Math.round(_panOffset.y);
											_applyCurrentZoomPan();

											_stopAnimation("zoomPan");
											return;
										}
									}
								},
							};
							return s;
						},
						_completePanGesture = function (animData) {
							// calculate swipe speed for Y axis (paanning)
							animData.calculateSwipeSpeed("y");

							_currPanBounds = self.currItem.bounds;

							animData.backAnimDestination = {};
							animData.backAnimStarted = {};

							// Avoid acceleration animation if speed is too low
							if (
								Math.abs(animData.lastFlickSpeed.x) <= 0.05 &&
								Math.abs(animData.lastFlickSpeed.y) <= 0.05
							) {
								animData.speedDecelerationRatioAbs.x =
									animData.speedDecelerationRatioAbs.y = 0;

								// Run pan drag release animation. E.g. if you drag image and release finger without momentum.
								animData.calculateOverBoundsAnimOffset("x");
								animData.calculateOverBoundsAnimOffset("y");
								return true;
							}

							// Animation loop that controls the acceleration after pan gesture ends
							_registerStartAnimation("zoomPan");
							animData.lastNow = _getCurrentTime();
							animData.panAnimLoop();
						},
						_finishSwipeMainScrollGesture = function (
							gestureType,
							_releaseAnimData
						) {
							var itemChanged;
							if (!_mainScrollAnimating) {
								_currZoomedItemIndex = _currentItemIndex;
							}

							var itemsDiff;

							if (gestureType === "swipe") {
								var totalShiftDist = _currPoint.x - _startPoint.x,
									isFastLastFlick = _releaseAnimData.lastFlickDist.x < 10;

								// if container is shifted for more than MIN_SWIPE_DISTANCE,
								// and last flick gesture was in right direction
								if (
									totalShiftDist > MIN_SWIPE_DISTANCE &&
									(isFastLastFlick || _releaseAnimData.lastFlickOffset.x > 20)
								) {
									// go to prev item
									itemsDiff = -1;
								} else if (
									totalShiftDist < -MIN_SWIPE_DISTANCE &&
									(isFastLastFlick || _releaseAnimData.lastFlickOffset.x < -20)
								) {
									// go to next item
									itemsDiff = 1;
								}
							}

							var nextCircle;

							if (itemsDiff) {
								_currentItemIndex += itemsDiff;

								if (_currentItemIndex < 0) {
									_currentItemIndex = _options.loop ? _getNumItems() - 1 : 0;
									nextCircle = true;
								} else if (_currentItemIndex >= _getNumItems()) {
									_currentItemIndex = _options.loop ? 0 : _getNumItems() - 1;
									nextCircle = true;
								}

								if (!nextCircle || _options.loop) {
									_indexDiff += itemsDiff;
									_currPositionIndex -= itemsDiff;
									itemChanged = true;
								}
							}

							var animateToX = _slideSize.x * _currPositionIndex;
							var animateToDist = Math.abs(animateToX - _mainScrollPos.x);
							var finishAnimDuration;

							if (
								!itemChanged &&
								animateToX > _mainScrollPos.x !==
									_releaseAnimData.lastFlickSpeed.x > 0
							) {
								// "return to current" duration, e.g. when dragging from slide 0 to -1
								finishAnimDuration = 333;
							} else {
								finishAnimDuration =
									Math.abs(_releaseAnimData.lastFlickSpeed.x) > 0
										? animateToDist /
										  Math.abs(_releaseAnimData.lastFlickSpeed.x)
										: 333;

								finishAnimDuration = Math.min(finishAnimDuration, 400);
								finishAnimDuration = Math.max(finishAnimDuration, 250);
							}

							if (_currZoomedItemIndex === _currentItemIndex) {
								itemChanged = false;
							}

							_mainScrollAnimating = true;

							_shout("mainScrollAnimStart");

							_animateProp(
								"mainScroll",
								_mainScrollPos.x,
								animateToX,
								finishAnimDuration,
								framework.easing.cubic.out,
								_moveMainScroll,
								function () {
									_stopAllAnimations();
									_mainScrollAnimating = false;
									_currZoomedItemIndex = -1;

									if (
										itemChanged ||
										_currZoomedItemIndex !== _currentItemIndex
									) {
										self.updateCurrItem();
									}

									_shout("mainScrollAnimComplete");
								}
							);

							if (itemChanged) {
								self.updateCurrItem(true);
							}

							return itemChanged;
						},
						_calculateZoomLevel = function (touchesDistance) {
							return (
								(1 / _startPointsDistance) * touchesDistance * _startZoomLevel
							);
						},
						// Resets zoom if it's out of bounds
						_completeZoomGesture = function () {
							var destZoomLevel = _currZoomLevel,
								minZoomLevel = _getMinZoomLevel(),
								maxZoomLevel = _getMaxZoomLevel();

							if (_currZoomLevel < minZoomLevel) {
								destZoomLevel = minZoomLevel;
							} else if (_currZoomLevel > maxZoomLevel) {
								destZoomLevel = maxZoomLevel;
							}

							var destOpacity = 1,
								onUpdate,
								initialOpacity = _bgOpacity;

							if (
								_opacityChanged &&
								!_isZoomingIn &&
								!_wasOverInitialZoom &&
								_currZoomLevel < minZoomLevel
							) {
								//_closedByScroll = true;
								self.close();
								return true;
							}

							if (_opacityChanged) {
								onUpdate = function (now) {
									_applyBgOpacity(
										(destOpacity - initialOpacity) * now + initialOpacity
									);
								};
							}

							self.zoomTo(
								destZoomLevel,
								0,
								200,
								framework.easing.cubic.out,
								onUpdate
							);
							return true;
						};

					_registerModule("Gestures", {
						publicMethods: {
							initGestures: function () {
								// helper function that builds touch/pointer/mouse events
								var addEventNames = function (pref, down, move, up, cancel) {
									_dragStartEvent = pref + down;
									_dragMoveEvent = pref + move;
									_dragEndEvent = pref + up;
									if (cancel) {
										_dragCancelEvent = pref + cancel;
									} else {
										_dragCancelEvent = "";
									}
								};

								_pointerEventEnabled = _features.pointerEvent;
								if (_pointerEventEnabled && _features.touch) {
									// we don't need touch events, if browser supports pointer events
									_features.touch = false;
								}

								if (_pointerEventEnabled) {
									if (navigator.msPointerEnabled) {
										// IE10 pointer events are case-sensitive
										addEventNames("MSPointer", "Down", "Move", "Up", "Cancel");
									} else {
										addEventNames("pointer", "down", "move", "up", "cancel");
									}
								} else if (_features.touch) {
									addEventNames("touch", "start", "move", "end", "cancel");
									_likelyTouchDevice = true;
								} else {
									addEventNames("mouse", "down", "move", "up");
								}

								_upMoveEvents =
									_dragMoveEvent + " " + _dragEndEvent + " " + _dragCancelEvent;
								_downEvents = _dragStartEvent;

								if (_pointerEventEnabled && !_likelyTouchDevice) {
									_likelyTouchDevice =
										navigator.maxTouchPoints > 1 ||
										navigator.msMaxTouchPoints > 1;
								}
								// make variable public
								self.likelyTouchDevice = _likelyTouchDevice;

								_globalEventHandlers[_dragStartEvent] = _onDragStart;
								_globalEventHandlers[_dragMoveEvent] = _onDragMove;
								_globalEventHandlers[_dragEndEvent] = _onDragRelease; // the Kraken

								if (_dragCancelEvent) {
									_globalEventHandlers[_dragCancelEvent] =
										_globalEventHandlers[_dragEndEvent];
								}

								// Bind mouse events on device with detected hardware touch support, in case it supports multiple types of input.
								if (_features.touch) {
									_downEvents += " mousedown";
									_upMoveEvents += " mousemove mouseup";
									_globalEventHandlers.mousedown =
										_globalEventHandlers[_dragStartEvent];
									_globalEventHandlers.mousemove =
										_globalEventHandlers[_dragMoveEvent];
									_globalEventHandlers.mouseup =
										_globalEventHandlers[_dragEndEvent];
								}

								if (!_likelyTouchDevice) {
									// don't allow pan to next slide from zoomed state on Desktop
									_options.allowPanToNext = false;
								}
							},
						},
					});

					/*>>gestures*/

					/*>>show-hide-transition*/
					/**
					 * show-hide-transition.js:
					 *
					 * Manages initial opening or closing transition.
					 *
					 * If you're not planning to use transition for gallery at all,
					 * you may set options hideAnimationDuration and showAnimationDuration to 0,
					 * and just delete startAnimation function.
					 *
					 */

					var _showOrHideTimeout,
						_showOrHide = function (item, img, out, completeFn) {
							if (_showOrHideTimeout) {
								clearTimeout(_showOrHideTimeout);
							}

							_initialZoomRunning = true;
							_initialContentSet = true;

							// dimensions of small thumbnail {x:,y:,w:}.
							// Height is optional, as calculated based on large image.
							var thumbBounds;
							if (item.initialLayout) {
								thumbBounds = item.initialLayout;
								item.initialLayout = null;
							} else {
								thumbBounds =
									_options.getThumbBoundsFn &&
									_options.getThumbBoundsFn(_currentItemIndex);
							}

							var duration = out
								? _options.hideAnimationDuration
								: _options.showAnimationDuration;

							var onComplete = function () {
								_stopAnimation("initialZoom");
								if (!out) {
									_applyBgOpacity(1);
									if (img) {
										img.style.display = "block";
									}
									framework.addClass(template, "pswp--animated-in");
									_shout("initialZoom" + (out ? "OutEnd" : "InEnd"));
								} else {
									self.template.removeAttribute("style");
									self.bg.removeAttribute("style");
								}

								if (completeFn) {
									completeFn();
								}
								_initialZoomRunning = false;
							};

							// if bounds aren't provided, just open gallery without animation
							if (!duration || !thumbBounds || thumbBounds.x === undefined) {
								_shout("initialZoom" + (out ? "Out" : "In"));

								_currZoomLevel = item.initialZoomLevel;
								_equalizePoints(_panOffset, item.initialPosition);
								_applyCurrentZoomPan();

								template.style.opacity = out ? 0 : 1;
								_applyBgOpacity(1);

								if (duration) {
									setTimeout(function () {
										onComplete();
									}, duration);
								} else {
									onComplete();
								}

								return;
							}

							var startAnimation = function () {
								var closeWithRaf = _closedByScroll,
									fadeEverything =
										!self.currItem.src ||
										self.currItem.loadError ||
										_options.showHideOpacity;

								// apply hw-acceleration to image
								if (item.miniImg) {
									item.miniImg.style.webkitBackfaceVisibility = "hidden";
								}

								if (!out) {
									_currZoomLevel = thumbBounds.w / item.w;
									_panOffset.x = thumbBounds.x;
									_panOffset.y = thumbBounds.y - _initalWindowScrollY;

									self[
										fadeEverything ? "template" : "bg"
									].style.opacity = 0.001;
									_applyCurrentZoomPan();
								}

								_registerStartAnimation("initialZoom");

								if (out && !closeWithRaf) {
									framework.removeClass(template, "pswp--animated-in");
								}

								if (fadeEverything) {
									if (out) {
										framework[(closeWithRaf ? "remove" : "add") + "Class"](
											template,
											"pswp--animate_opacity"
										);
									} else {
										setTimeout(function () {
											framework.addClass(template, "pswp--animate_opacity");
										}, 30);
									}
								}

								_showOrHideTimeout = setTimeout(
									function () {
										_shout("initialZoom" + (out ? "Out" : "In"));

										if (!out) {
											// "in" animation always uses CSS transitions (instead of rAF).
											// CSS transition work faster here,
											// as developer may also want to animate other things,
											// like ui on top of sliding area, which can be animated just via CSS

											_currZoomLevel = item.initialZoomLevel;
											_equalizePoints(_panOffset, item.initialPosition);
											_applyCurrentZoomPan();
											_applyBgOpacity(1);

											if (fadeEverything) {
												template.style.opacity = 1;
											} else {
												_applyBgOpacity(1);
											}

											_showOrHideTimeout = setTimeout(
												onComplete,
												duration + 20
											);
										} else {
											// "out" animation uses rAF only when PhotoSwipe is closed by browser scroll, to recalculate position
											var destZoomLevel = thumbBounds.w / item.w,
												initialPanOffset = {
													x: _panOffset.x,
													y: _panOffset.y,
												},
												initialZoomLevel = _currZoomLevel,
												initalBgOpacity = _bgOpacity,
												onUpdate = function (now) {
													if (now === 1) {
														_currZoomLevel = destZoomLevel;
														_panOffset.x = thumbBounds.x;
														_panOffset.y =
															thumbBounds.y - _currentWindowScrollY;
													} else {
														_currZoomLevel =
															(destZoomLevel - initialZoomLevel) * now +
															initialZoomLevel;
														_panOffset.x =
															(thumbBounds.x - initialPanOffset.x) * now +
															initialPanOffset.x;
														_panOffset.y =
															(thumbBounds.y -
																_currentWindowScrollY -
																initialPanOffset.y) *
																now +
															initialPanOffset.y;
													}

													_applyCurrentZoomPan();
													if (fadeEverything) {
														template.style.opacity = 1 - now;
													} else {
														_applyBgOpacity(
															initalBgOpacity - now * initalBgOpacity
														);
													}
												};

											if (closeWithRaf) {
												_animateProp(
													"initialZoom",
													0,
													1,
													duration,
													framework.easing.cubic.out,
													onUpdate,
													onComplete
												);
											} else {
												onUpdate(1);
												_showOrHideTimeout = setTimeout(
													onComplete,
													duration + 20
												);
											}
										}
									},
									out ? 25 : 90
								); // Main purpose of this delay is to give browser time to paint and
								// create composite layers of PhotoSwipe UI parts (background, controls, caption, arrows).
								// Which avoids lag at the beginning of scale transition.
							};
							startAnimation();
						};

					/*>>show-hide-transition*/

					/*>>items-controller*/
					/**
					 *
					 * Controller manages gallery items, their dimensions, and their content.
					 *
					 */

					var _items,
						_tempPanAreaSize = {},
						_imagesToAppendPool = [],
						_initialContentSet,
						_initialZoomRunning,
						_controllerDefaultOptions = {
							index: 0,
							errorMsg:
								'<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
							forceProgressiveLoading: false, // TODO
							preload: [1, 1],
							getNumItemsFn: function () {
								return _items.length;
							},
						};

					var _getItemAt,
						_getNumItems,
						_initialIsLoop,
						_getZeroBounds = function () {
							return {
								center: { x: 0, y: 0 },
								max: { x: 0, y: 0 },
								min: { x: 0, y: 0 },
							};
						},
						_calculateSingleItemPanBounds = function (
							item,
							realPanElementW,
							realPanElementH
						) {
							var bounds = item.bounds;

							// position of element when it's centered
							bounds.center.x = Math.round(
								(_tempPanAreaSize.x - realPanElementW) / 2
							);
							bounds.center.y =
								Math.round((_tempPanAreaSize.y - realPanElementH) / 2) +
								item.vGap.top;

							// maximum pan position
							bounds.max.x =
								realPanElementW > _tempPanAreaSize.x
									? Math.round(_tempPanAreaSize.x - realPanElementW)
									: bounds.center.x;

							bounds.max.y =
								realPanElementH > _tempPanAreaSize.y
									? Math.round(_tempPanAreaSize.y - realPanElementH) +
									  item.vGap.top
									: bounds.center.y;

							// minimum pan position
							bounds.min.x =
								realPanElementW > _tempPanAreaSize.x ? 0 : bounds.center.x;
							bounds.min.y =
								realPanElementH > _tempPanAreaSize.y
									? item.vGap.top
									: bounds.center.y;
						},
						_calculateItemSize = function (item, viewportSize, zoomLevel) {
							if (item.src && !item.loadError) {
								var isInitial = !zoomLevel;

								if (isInitial) {
									if (!item.vGap) {
										item.vGap = { top: 0, bottom: 0 };
									}
									// allows overriding vertical margin for individual items
									_shout("parseVerticalMargin", item);
								}

								_tempPanAreaSize.x = viewportSize.x;
								_tempPanAreaSize.y =
									viewportSize.y - item.vGap.top - item.vGap.bottom;

								if (isInitial) {
									var hRatio = _tempPanAreaSize.x / item.w;
									var vRatio = _tempPanAreaSize.y / item.h;

									item.fitRatio = hRatio < vRatio ? hRatio : vRatio;
									//item.fillRatio = hRatio > vRatio ? hRatio : vRatio;

									var scaleMode = _options.scaleMode;

									if (scaleMode === "orig") {
										zoomLevel = 1;
									} else if (scaleMode === "fit") {
										zoomLevel = item.fitRatio;
									}

									if (zoomLevel > 1) {
										zoomLevel = 1;
									}

									item.initialZoomLevel = zoomLevel;

									if (!item.bounds) {
										// reuse bounds object
										item.bounds = _getZeroBounds();
									}
								}

								if (!zoomLevel) {
									return;
								}

								_calculateSingleItemPanBounds(
									item,
									item.w * zoomLevel,
									item.h * zoomLevel
								);

								if (isInitial && zoomLevel === item.initialZoomLevel) {
									item.initialPosition = item.bounds.center;
								}

								return item.bounds;
							} else {
								item.w = item.h = 0;
								item.initialZoomLevel = item.fitRatio = 1;
								item.bounds = _getZeroBounds();
								item.initialPosition = item.bounds.center;

								// if it's not image, we return zero bounds (content is not zoomable)
								return item.bounds;
							}
						},
						_appendImage = function (
							index,
							item,
							baseDiv,
							img,
							preventAnimation,
							keepPlaceholder
						) {
							if (item.loadError) {
								return;
							}

							if (img) {
								item.imageAppended = true;
								_setImageSize(
									item,
									img,
									item === self.currItem && _renderMaxResolution
								);

								baseDiv.appendChild(img);

								if (keepPlaceholder) {
									setTimeout(function () {
										if (item && item.loaded && item.placeholder) {
											item.placeholder.style.display = "none";
											item.placeholder = null;
										}
									}, 500);
								}
							}
						},
						_preloadImage = function (item) {
							item.loading = true;
							item.loaded = false;
							var img = (item.img = framework.createEl("pswp__img", "img"));
							var onComplete = function () {
								item.loading = false;
								item.loaded = true;

								if (item.loadComplete) {
									item.loadComplete(item);
								} else {
									item.img = null; // no need to store image object
								}
								img.onload = img.onerror = null;
								img = null;
							};
							img.onload = onComplete;
							img.onerror = function () {
								item.loadError = true;
								onComplete();
							};

							img.src = item.src; // + '?a=' + Math.random();

							return img;
						},
						_checkForError = function (item, cleanUp) {
							if (item.src && item.loadError && item.container) {
								if (cleanUp) {
									item.container.innerHTML = "";
								}

								item.container.innerHTML = _options.errorMsg.replace(
									"%url%",
									item.src
								);
								return true;
							}
						},
						_setImageSize = function (item, img, maxRes) {
							if (!item.src) {
								return;
							}

							if (!img) {
								img = item.container.lastChild;
							}

							var w = maxRes ? item.w : Math.round(item.w * item.fitRatio),
								h = maxRes ? item.h : Math.round(item.h * item.fitRatio);

							if (item.placeholder && !item.loaded) {
								item.placeholder.style.width = w + "px";
								item.placeholder.style.height = h + "px";
							}

							img.style.width = w + "px";
							img.style.height = h + "px";
						},
						_appendImagesPool = function () {
							if (_imagesToAppendPool.length) {
								var poolItem;

								for (var i = 0; i < _imagesToAppendPool.length; i++) {
									poolItem = _imagesToAppendPool[i];
									if (poolItem.holder.index === poolItem.index) {
										_appendImage(
											poolItem.index,
											poolItem.item,
											poolItem.baseDiv,
											poolItem.img,
											false,
											poolItem.clearPlaceholder
										);
									}
								}
								_imagesToAppendPool = [];
							}
						};

					_registerModule("Controller", {
						publicMethods: {
							lazyLoadItem: function (index) {
								index = _getLoopedId(index);
								var item = _getItemAt(index);

								if (
									!item ||
									((item.loaded || item.loading) && !_itemsNeedUpdate)
								) {
									return;
								}

								_shout("gettingData", index, item);

								if (!item.src) {
									return;
								}

								_preloadImage(item);
							},
							initController: function () {
								framework.extend(_options, _controllerDefaultOptions, true);
								self.items = _items = items;
								_getItemAt = self.getItemAt;
								_getNumItems = _options.getNumItemsFn; //self.getNumItems;

								_initialIsLoop = _options.loop;
								if (_getNumItems() < 3) {
									_options.loop = false; // disable loop if less then 3 items
								}

								_listen("beforeChange", function (diff) {
									var p = _options.preload,
										isNext = diff === null ? true : diff >= 0,
										preloadBefore = Math.min(p[0], _getNumItems()),
										preloadAfter = Math.min(p[1], _getNumItems()),
										i;

									for (
										i = 1;
										i <= (isNext ? preloadAfter : preloadBefore);
										i++
									) {
										self.lazyLoadItem(_currentItemIndex + i);
									}
									for (
										i = 1;
										i <= (isNext ? preloadBefore : preloadAfter);
										i++
									) {
										self.lazyLoadItem(_currentItemIndex - i);
									}
								});

								_listen("initialLayout", function () {
									self.currItem.initialLayout =
										_options.getThumbBoundsFn &&
										_options.getThumbBoundsFn(_currentItemIndex);
								});

								_listen("mainScrollAnimComplete", _appendImagesPool);
								_listen("initialZoomInEnd", _appendImagesPool);

								_listen("destroy", function () {
									var item;
									for (var i = 0; i < _items.length; i++) {
										item = _items[i];
										// remove reference to DOM elements, for GC
										if (item.container) {
											item.container = null;
										}
										if (item.placeholder) {
											item.placeholder = null;
										}
										if (item.img) {
											item.img = null;
										}
										if (item.preloader) {
											item.preloader = null;
										}
										if (item.loadError) {
											item.loaded = item.loadError = false;
										}
									}
									_imagesToAppendPool = null;
								});
							},

							getItemAt: function (index) {
								if (index >= 0) {
									return _items[index] !== undefined ? _items[index] : false;
								}
								return false;
							},

							allowProgressiveImg: function () {
								// 1. Progressive image loading isn't working on webkit/blink
								//    when hw-acceleration (e.g. translateZ) is applied to IMG element.
								//    That's why in PhotoSwipe parent element gets zoom transform, not image itself.
								//
								// 2. Progressive image loading sometimes blinks in webkit/blink when applying animation to parent element.
								//    That's why it's disabled on touch devices (mainly because of swipe transition)
								//
								// 3. Progressive image loading sometimes doesn't work in IE (up to 11).

								// Don't allow progressive loading on non-large touch devices
								return (
									_options.forceProgressiveLoading ||
									!_likelyTouchDevice ||
									_options.mouseUsed ||
									screen.width > 1200
								);
								// 1200 - to eliminate touch devices with large screen (like Chromebook Pixel)
							},

							setContent: function (holder, index) {
								if (_options.loop) {
									index = _getLoopedId(index);
								}

								var prevItem = self.getItemAt(holder.index);
								if (prevItem) {
									prevItem.container = null;
								}

								var item = self.getItemAt(index),
									img;

								if (!item) {
									holder.el.innerHTML = "";
									return;
								}

								// allow to override data
								_shout("gettingData", index, item);

								holder.index = index;
								holder.item = item;

								// base container DIV is created only once for each of 3 holders
								var baseDiv = (item.container =
									framework.createEl("pswp__zoom-wrap"));

								if (!item.src && item.html) {
									if (item.html.tagName) {
										baseDiv.appendChild(item.html);
									} else {
										baseDiv.innerHTML = item.html;
									}
								}

								_checkForError(item);

								_calculateItemSize(item, _viewportSize);

								if (item.src && !item.loadError && !item.loaded) {
									item.loadComplete = function (item) {
										// gallery closed before image finished loading
										if (!_isOpen) {
											return;
										}

										// check if holder hasn't changed while image was loading
										if (holder && holder.index === index) {
											if (_checkForError(item, true)) {
												item.loadComplete = item.img = null;
												_calculateItemSize(item, _viewportSize);
												_applyZoomPanToItem(item);

												if (holder.index === _currentItemIndex) {
													// recalculate dimensions
													self.updateCurrZoomItem();
												}
												return;
											}
											if (!item.imageAppended) {
												if (
													_features.transform &&
													(_mainScrollAnimating || _initialZoomRunning)
												) {
													_imagesToAppendPool.push({
														item: item,
														baseDiv: baseDiv,
														img: item.img,
														index: index,
														holder: holder,
														clearPlaceholder: true,
													});
												} else {
													_appendImage(
														index,
														item,
														baseDiv,
														item.img,
														_mainScrollAnimating || _initialZoomRunning,
														true
													);
												}
											} else {
												// remove preloader & mini-img
												if (!_initialZoomRunning && item.placeholder) {
													item.placeholder.style.display = "none";
													item.placeholder = null;
												}
											}
										}

										item.loadComplete = null;
										item.img = null; // no need to store image element after it's added

										_shout("imageLoadComplete", index, item);
									};

									if (framework.features.transform) {
										var placeholderClassName =
											"pswp__img pswp__img--placeholder";
										placeholderClassName += item.msrc
											? ""
											: " pswp__img--placeholder--blank";

										var placeholder = framework.createEl(
											placeholderClassName,
											item.msrc ? "img" : ""
										);
										if (item.msrc) {
											placeholder.src = item.msrc;
										}

										_setImageSize(item, placeholder);

										baseDiv.appendChild(placeholder);
										item.placeholder = placeholder;
									}

									if (!item.loading) {
										_preloadImage(item);
									}

									if (self.allowProgressiveImg()) {
										// just append image
										if (!_initialContentSet && _features.transform) {
											_imagesToAppendPool.push({
												item: item,
												baseDiv: baseDiv,
												img: item.img,
												index: index,
												holder: holder,
											});
										} else {
											_appendImage(index, item, baseDiv, item.img, true, true);
										}
									}
								} else if (item.src && !item.loadError) {
									// image object is created every time, due to bugs of image loading & delay when switching images
									img = framework.createEl("pswp__img", "img");
									img.style.opacity = 1;
									img.src = item.src;
									_setImageSize(item, img);
									_appendImage(index, item, baseDiv, img, true);
								}

								if (!_initialContentSet && index === _currentItemIndex) {
									_currZoomElementStyle = baseDiv.style;
									_showOrHide(item, img || item.img);
								} else {
									_applyZoomPanToItem(item);
								}

								holder.el.innerHTML = "";
								holder.el.appendChild(baseDiv);
							},

							cleanSlide: function (item) {
								if (item.img) {
									item.img.onload = item.img.onerror = null;
								}
								item.loaded =
									item.loading =
									item.img =
									item.imageAppended =
										false;
							},
						},
					});

					/*>>items-controller*/

					/*>>tap*/
					/**
					 * tap.js:
					 *
					 * Displatches tap and double-tap events.
					 *
					 */

					var tapTimer,
						tapReleasePoint = {},
						_dispatchTapEvent = function (
							origEvent,
							releasePoint,
							pointerType
						) {
							var e = document.createEvent("CustomEvent"),
								eDetail = {
									origEvent: origEvent,
									target: origEvent.target,
									releasePoint: releasePoint,
									pointerType: pointerType || "touch",
								};

							e.initCustomEvent("pswpTap", true, true, eDetail);
							origEvent.target.dispatchEvent(e);
						};

					_registerModule("Tap", {
						publicMethods: {
							initTap: function () {
								_listen("firstTouchStart", self.onTapStart);
								_listen("touchRelease", self.onTapRelease);
								_listen("destroy", function () {
									tapReleasePoint = {};
									tapTimer = null;
								});
							},
							onTapStart: function (touchList) {
								if (touchList.length > 1) {
									clearTimeout(tapTimer);
									tapTimer = null;
								}
							},
							onTapRelease: function (e, releasePoint) {
								if (!releasePoint) {
									return;
								}

								if (!_moved && !_isMultitouch && !_numAnimations) {
									var p0 = releasePoint;
									if (tapTimer) {
										clearTimeout(tapTimer);
										tapTimer = null;

										// Check if taped on the same place
										if (_isNearbyPoints(p0, tapReleasePoint)) {
											_shout("doubleTap", p0);
											return;
										}
									}

									if (releasePoint.type === "mouse") {
										_dispatchTapEvent(e, releasePoint, "mouse");
										return;
									}

									var clickedTagName = e.target.tagName.toUpperCase();
									// avoid double tap delay on buttons and elements that have class pswp__single-tap
									if (
										clickedTagName === "BUTTON" ||
										framework.hasClass(e.target, "pswp__single-tap")
									) {
										_dispatchTapEvent(e, releasePoint);
										return;
									}

									_equalizePoints(tapReleasePoint, p0);

									tapTimer = setTimeout(function () {
										_dispatchTapEvent(e, releasePoint);
										tapTimer = null;
									}, 300);
								}
							},
						},
					});

					/*>>tap*/

					/*>>desktop-zoom*/
					/**
					 *
					 * desktop-zoom.js:
					 *
					 * - Binds mousewheel event for paning zoomed image.
					 * - Manages "dragging", "zoomed-in", "zoom-out" classes.
					 *   (which are used for cursors and zoom icon)
					 * - Adds toggleDesktopZoom function.
					 *
					 */

					var _wheelDelta;

					_registerModule("DesktopZoom", {
						publicMethods: {
							initDesktopZoom: function () {
								if (_oldIE) {
									// no zoom for old IE (<=8)
									return;
								}

								if (_likelyTouchDevice) {
									// if detected hardware touch support, we wait until mouse is used,
									// and only then apply desktop-zoom features
									_listen("mouseUsed", function () {
										self.setupDesktopZoom();
									});
								} else {
									self.setupDesktopZoom(true);
								}
							},

							setupDesktopZoom: function (onInit) {
								_wheelDelta = {};

								var events = "wheel mousewheel DOMMouseScroll";

								_listen("bindEvents", function () {
									framework.bind(template, events, self.handleMouseWheel);
								});

								_listen("unbindEvents", function () {
									if (_wheelDelta) {
										framework.unbind(template, events, self.handleMouseWheel);
									}
								});

								self.mouseZoomedIn = false;

								var hasDraggingClass,
									updateZoomable = function () {
										if (self.mouseZoomedIn) {
											framework.removeClass(template, "pswp--zoomed-in");
											self.mouseZoomedIn = false;
										}
										if (_currZoomLevel < 1) {
											framework.addClass(template, "pswp--zoom-allowed");
										} else {
											framework.removeClass(template, "pswp--zoom-allowed");
										}
										removeDraggingClass();
									},
									removeDraggingClass = function () {
										if (hasDraggingClass) {
											framework.removeClass(template, "pswp--dragging");
											hasDraggingClass = false;
										}
									};

								_listen("resize", updateZoomable);
								_listen("afterChange", updateZoomable);
								_listen("pointerDown", function () {
									if (self.mouseZoomedIn) {
										hasDraggingClass = true;
										framework.addClass(template, "pswp--dragging");
									}
								});
								_listen("pointerUp", removeDraggingClass);

								if (!onInit) {
									updateZoomable();
								}
							},

							handleMouseWheel: function (e) {
								if (_currZoomLevel <= self.currItem.fitRatio) {
									if (_options.modal) {
										if (
											!_options.closeOnScroll ||
											_numAnimations ||
											_isDragging
										) {
											e.preventDefault();
										} else if (_transformKey && Math.abs(e.deltaY) > 2) {
											// close PhotoSwipe
											// if browser supports transforms & scroll changed enough
											_closedByScroll = true;
											self.close();
										}
									}
									return true;
								}

								// allow just one event to fire
								e.stopPropagation();

								// https://developer.mozilla.org/en-US/docs/Web/Events/wheel
								_wheelDelta.x = 0;

								if ("deltaX" in e) {
									if (e.deltaMode === 1 /* DOM_DELTA_LINE */) {
										// 18 - average line height
										_wheelDelta.x = e.deltaX * 18;
										_wheelDelta.y = e.deltaY * 18;
									} else {
										_wheelDelta.x = e.deltaX;
										_wheelDelta.y = e.deltaY;
									}
								} else if ("wheelDelta" in e) {
									if (e.wheelDeltaX) {
										_wheelDelta.x = -0.16 * e.wheelDeltaX;
									}
									if (e.wheelDeltaY) {
										_wheelDelta.y = -0.16 * e.wheelDeltaY;
									} else {
										_wheelDelta.y = -0.16 * e.wheelDelta;
									}
								} else if ("detail" in e) {
									_wheelDelta.y = e.detail;
								} else {
									return;
								}

								_calculatePanBounds(_currZoomLevel, true);

								var newPanX = _panOffset.x - _wheelDelta.x,
									newPanY = _panOffset.y - _wheelDelta.y;

								// only prevent scrolling in nonmodal mode when not at edges
								if (
									_options.modal ||
									(newPanX <= _currPanBounds.min.x &&
										newPanX >= _currPanBounds.max.x &&
										newPanY <= _currPanBounds.min.y &&
										newPanY >= _currPanBounds.max.y)
								) {
									e.preventDefault();
								}

								// TODO: use rAF instead of mousewheel?
								self.panTo(newPanX, newPanY);
							},

							toggleDesktopZoom: function (centerPoint) {
								centerPoint = centerPoint || {
									x: _viewportSize.x / 2 + _offset.x,
									y: _viewportSize.y / 2 + _offset.y,
								};

								var doubleTapZoomLevel = _options.getDoubleTapZoom(
									true,
									self.currItem
								);
								var zoomOut = _currZoomLevel === doubleTapZoomLevel;

								self.mouseZoomedIn = !zoomOut;

								self.zoomTo(
									zoomOut ? self.currItem.initialZoomLevel : doubleTapZoomLevel,
									centerPoint,
									333
								);
								framework[(!zoomOut ? "add" : "remove") + "Class"](
									template,
									"pswp--zoomed-in"
								);
							},
						},
					});

					/*>>desktop-zoom*/

					/*>>history*/
					/**
					 *
					 * history.js:
					 *
					 * - Back button to close gallery.
					 *
					 * - Unique URL for each slide: example.com/&pid=1&gid=3
					 *   (where PID is picture index, and GID and gallery index)
					 *
					 * - Switch URL when slides change.
					 *
					 */

					var _historyDefaultOptions = {
						history: true,
						galleryUID: 1,
					};

					var _historyUpdateTimeout,
						_hashChangeTimeout,
						_hashAnimCheckTimeout,
						_hashChangedByScript,
						_hashChangedByHistory,
						_hashReseted,
						_initialHash,
						_historyChanged,
						_closedFromURL,
						_urlChangedOnce,
						_windowLoc,
						_supportsPushState,
						_getHash = function () {
							return _windowLoc.hash.substring(1);
						},
						_cleanHistoryTimeouts = function () {
							if (_historyUpdateTimeout) {
								clearTimeout(_historyUpdateTimeout);
							}

							if (_hashAnimCheckTimeout) {
								clearTimeout(_hashAnimCheckTimeout);
							}
						},
						// pid - Picture index
						// gid - Gallery index
						_parseItemIndexFromURL = function () {
							var hash = _getHash(),
								params = {};

							if (hash.length < 5) {
								// pid=1
								return params;
							}

							var i,
								vars = hash.split("&");
							for (i = 0; i < vars.length; i++) {
								if (!vars[i]) {
									continue;
								}
								var pair = vars[i].split("=");
								if (pair.length < 2) {
									continue;
								}
								params[pair[0]] = pair[1];
							}
							if (_options.galleryPIDs) {
								// detect custom pid in hash and search for it among the items collection
								var searchfor = params.pid;
								params.pid = 0; // if custom pid cannot be found, fallback to the first item
								for (i = 0; i < _items.length; i++) {
									if (_items[i].pid === searchfor) {
										params.pid = i;
										break;
									}
								}
							} else {
								params.pid = parseInt(params.pid, 10) - 1;
							}
							if (params.pid < 0) {
								params.pid = 0;
							}
							return params;
						},
						_updateHash = function () {
							if (_hashAnimCheckTimeout) {
								clearTimeout(_hashAnimCheckTimeout);
							}

							if (_numAnimations || _isDragging) {
								// changing browser URL forces layout/paint in some browsers, which causes noticable lag during animation
								// that's why we update hash only when no animations running
								_hashAnimCheckTimeout = setTimeout(_updateHash, 500);
								return;
							}

							if (_hashChangedByScript) {
								clearTimeout(_hashChangeTimeout);
							} else {
								_hashChangedByScript = true;
							}

							var pid = _currentItemIndex + 1;
							var item = _getItemAt(_currentItemIndex);
							if (item.hasOwnProperty("pid")) {
								// carry forward any custom pid assigned to the item
								pid = item.pid;
							}
							var newHash =
								_initialHash +
								"&" +
								"gid=" +
								_options.galleryUID +
								"&" +
								"pid=" +
								pid;

							if (!_historyChanged) {
								if (_windowLoc.hash.indexOf(newHash) === -1) {
									_urlChangedOnce = true;
								}
								// first time - add new hisory record, then just replace
							}

							var newURL = _windowLoc.href.split("#")[0] + "#" + newHash;

							if (_supportsPushState) {
								if ("#" + newHash !== window.location.hash) {
									history[_historyChanged ? "replaceState" : "pushState"](
										"",
										document.title,
										newURL
									);
								}
							} else {
								if (_historyChanged) {
									_windowLoc.replace(newURL);
								} else {
									_windowLoc.hash = newHash;
								}
							}

							_historyChanged = true;
							_hashChangeTimeout = setTimeout(function () {
								_hashChangedByScript = false;
							}, 60);
						};

					_registerModule("History", {
						publicMethods: {
							initHistory: function () {
								framework.extend(_options, _historyDefaultOptions, true);

								if (!_options.history) {
									return;
								}

								_windowLoc = window.location;
								_urlChangedOnce = false;
								_closedFromURL = false;
								_historyChanged = false;
								_initialHash = _getHash();
								_supportsPushState = "pushState" in history;

								if (_initialHash.indexOf("gid=") > -1) {
									_initialHash = _initialHash.split("&gid=")[0];
									_initialHash = _initialHash.split("?gid=")[0];
								}

								_listen("afterChange", self.updateURL);
								_listen("unbindEvents", function () {
									framework.unbind(window, "hashchange", self.onHashChange);
								});

								var returnToOriginal = function () {
									_hashReseted = true;
									if (!_closedFromURL) {
										if (_urlChangedOnce) {
											history.back();
										} else {
											if (_initialHash) {
												_windowLoc.hash = _initialHash;
											} else {
												if (_supportsPushState) {
													// remove hash from url without refreshing it or scrolling to top
													history.pushState(
														"",
														document.title,
														_windowLoc.pathname + _windowLoc.search
													);
												} else {
													_windowLoc.hash = "";
												}
											}
										}
									}

									_cleanHistoryTimeouts();
								};

								_listen("unbindEvents", function () {
									if (_closedByScroll) {
										// if PhotoSwipe is closed by scroll, we go "back" before the closing animation starts
										// this is done to keep the scroll position
										returnToOriginal();
									}
								});
								_listen("destroy", function () {
									if (!_hashReseted) {
										returnToOriginal();
									}
								});
								_listen("firstUpdate", function () {
									_currentItemIndex = _parseItemIndexFromURL().pid;
								});

								var index = _initialHash.indexOf("pid=");
								if (index > -1) {
									_initialHash = _initialHash.substring(0, index);
									if (_initialHash.slice(-1) === "&") {
										_initialHash = _initialHash.slice(0, -1);
									}
								}

								setTimeout(function () {
									if (_isOpen) {
										// hasn't destroyed yet
										framework.bind(window, "hashchange", self.onHashChange);
									}
								}, 40);
							},
							onHashChange: function () {
								if (_getHash() === _initialHash) {
									_closedFromURL = true;
									self.close();
									return;
								}
								if (!_hashChangedByScript) {
									_hashChangedByHistory = true;
									self.goTo(_parseItemIndexFromURL().pid);
									_hashChangedByHistory = false;
								}
							},
							updateURL: function () {
								// Delay the update of URL, to avoid lag during transition,
								// and to not to trigger actions like "refresh page sound" or "blinking favicon" to often

								_cleanHistoryTimeouts();

								if (_hashChangedByHistory) {
									return;
								}

								if (!_historyChanged) {
									_updateHash(); // first time
								} else {
									_historyUpdateTimeout = setTimeout(_updateHash, 800);
								}
							},
						},
					});

					/*>>history*/
					framework.extend(self, publicMethods);
				};
				return PhotoSwipe;
			});

			/***/
		},

		/***/ 277: /***/ (module, exports, __webpack_require__) => {
			var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
			/*!
			 * $script.js JS loader & dependency manager
			 * https://github.com/ded/script.js
			 * (c) Dustin Diaz 2014 | License MIT
			 */

			(function (name, definition) {
				if (true && module.exports) module.exports = definition();
				else if (true)
					!((__WEBPACK_AMD_DEFINE_FACTORY__ = definition),
					(__WEBPACK_AMD_DEFINE_RESULT__ =
						typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
							? __WEBPACK_AMD_DEFINE_FACTORY__.call(
									exports,
									__webpack_require__,
									exports,
									module
							  )
							: __WEBPACK_AMD_DEFINE_FACTORY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				else {
				}
			})("$script", function () {
				var doc = document,
					head = doc.getElementsByTagName("head")[0],
					s = "string",
					f = false,
					push = "push",
					readyState = "readyState",
					onreadystatechange = "onreadystatechange",
					list = {},
					ids = {},
					delay = {},
					scripts = {},
					scriptpath,
					urlArgs;

				function every(ar, fn) {
					for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f;
					return 1;
				}
				function each(ar, fn) {
					every(ar, function (el) {
						fn(el);
						return 1;
					});
				}

				function $script(paths, idOrDone, optDone) {
					paths = paths[push] ? paths : [paths];
					var idOrDoneIsDone = idOrDone && idOrDone.call,
						done = idOrDoneIsDone ? idOrDone : optDone,
						id = idOrDoneIsDone ? paths.join("") : idOrDone,
						queue = paths.length;
					function loopFn(item) {
						return item.call ? item() : list[item];
					}
					function callback() {
						if (!--queue) {
							list[id] = 1;
							done && done();
							for (var dset in delay) {
								every(dset.split("|"), loopFn) &&
									!each(delay[dset], loopFn) &&
									(delay[dset] = []);
							}
						}
					}
					setTimeout(function () {
						each(paths, function loading(path, force) {
							if (path === null) return callback();

							if (!force && !/^https?:\/\//.test(path) && scriptpath) {
								path =
									path.indexOf(".js") === -1
										? scriptpath + path + ".js"
										: scriptpath + path;
							}

							if (scripts[path]) {
								if (id) ids[id] = 1;
								return scripts[path] == 2
									? callback()
									: setTimeout(function () {
											loading(path, true);
									  }, 0);
							}

							scripts[path] = 1;
							if (id) ids[id] = 1;
							create(path, callback);
						});
					}, 0);
					return $script;
				}

				function create(path, fn) {
					var el = doc.createElement("script"),
						loaded;
					el.onload =
						el.onerror =
						el[onreadystatechange] =
							function () {
								if (
									(el[readyState] && !/^c|loade/.test(el[readyState])) ||
									loaded
								)
									return;
								el.onload = el[onreadystatechange] = null;
								loaded = 1;
								scripts[path] = 2;
								fn();
							};
					el.async = 1;
					el.src = urlArgs
						? path + (path.indexOf("?") === -1 ? "?" : "&") + urlArgs
						: path;
					head.insertBefore(el, head.lastChild);
				}

				$script.get = create;

				$script.order = function (scripts, id, done) {
					(function callback(s) {
						s = scripts.shift();
						!scripts.length ? $script(s, id, done) : $script(s, callback);
					})();
				};

				$script.path = function (p) {
					scriptpath = p;
				};
				$script.urlArgs = function (str) {
					urlArgs = str;
				};
				$script.ready = function (deps, ready, req) {
					deps = deps[push] ? deps : [deps];
					var missing = [];
					!each(deps, function (dep) {
						list[dep] || missing[push](dep);
					}) &&
					every(deps, function (dep) {
						return list[dep];
					})
						? ready()
						: !(function (key) {
								delay[key] = delay[key] || [];
								delay[key][push](ready);
								req && req(missing);
						  })(deps.join("|"));
					return $script;
				};

				$script.done = function (idOrDone) {
					$script([null], idOrDone);
				};

				return $script;
			});

			/***/
		},

		/***/ 265: /***/ function (module) {
			(function webpackUniversalModuleDefinition(root, factory) {
				if (true) module.exports = factory();
				else {
				}
			})(this, function () {
				return /******/ (function (modules) {
					// webpackBootstrap
					/******/ // The module cache
					/******/ var installedModules = {};
					/******/
					/******/ // The require function
					/******/ function __nested_webpack_require_543__(moduleId) {
						/******/
						/******/ // Check if module is in cache
						/******/ if (installedModules[moduleId]) {
							/******/ return installedModules[moduleId].exports;
							/******/
						}
						/******/ // Create a new module (and put it into the cache)
						/******/ var module = (installedModules[moduleId] = {
							/******/ i: moduleId,
							/******/ l: false,
							/******/ exports: {},
							/******/
						});
						/******/
						/******/ // Execute the module function
						/******/ modules[moduleId].call(
							module.exports,
							module,
							module.exports,
							__nested_webpack_require_543__
						);
						/******/
						/******/ // Flag the module as loaded
						/******/ module.l = true;
						/******/
						/******/ // Return the exports of the module
						/******/ return module.exports;
						/******/
					}
					/******/
					/******/
					/******/ // expose the modules object (__webpack_modules__)
					/******/ __nested_webpack_require_543__.m = modules;
					/******/
					/******/ // expose the module cache
					/******/ __nested_webpack_require_543__.c = installedModules;
					/******/
					/******/ // define getter function for harmony exports
					/******/ __nested_webpack_require_543__.d = function (
						exports,
						name,
						getter
					) {
						/******/ if (!__nested_webpack_require_543__.o(exports, name)) {
							/******/ Object.defineProperty(exports, name, {
								enumerable: true,
								get: getter,
							});
							/******/
						}
						/******/
					};
					/******/
					/******/ // define __esModule on exports
					/******/ __nested_webpack_require_543__.r = function (exports) {
						/******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
							/******/ Object.defineProperty(exports, Symbol.toStringTag, {
								value: "Module",
							});
							/******/
						}
						/******/ Object.defineProperty(exports, "__esModule", {
							value: true,
						});
						/******/
					};
					/******/
					/******/ // create a fake namespace object
					/******/ // mode & 1: value is a module id, require it
					/******/ // mode & 2: merge all properties of value into the ns
					/******/ // mode & 4: return value when already ns object
					/******/ // mode & 8|1: behave like require
					/******/ __nested_webpack_require_543__.t = function (value, mode) {
						/******/ if (mode & 1)
							value = __nested_webpack_require_543__(value);
						/******/ if (mode & 8) return value;
						/******/ if (
							mode & 4 &&
							typeof value === "object" &&
							value &&
							value.__esModule
						)
							return value;
						/******/ var ns = Object.create(null);
						/******/ __nested_webpack_require_543__.r(ns);
						/******/ Object.defineProperty(ns, "default", {
							enumerable: true,
							value: value,
						});
						/******/ if (mode & 2 && typeof value != "string")
							for (var key in value)
								__nested_webpack_require_543__.d(
									ns,
									key,
									function (key) {
										return value[key];
									}.bind(null, key)
								);
						/******/ return ns;
						/******/
					};
					/******/
					/******/ // getDefaultExport function for compatibility with non-harmony modules
					/******/ __nested_webpack_require_543__.n = function (module) {
						/******/ var getter =
							module && module.__esModule
								? /******/ function getDefault() {
										return module["default"];
								  }
								: /******/ function getModuleExports() {
										return module;
								  };
						/******/ __nested_webpack_require_543__.d(getter, "a", getter);
						/******/ return getter;
						/******/
					};
					/******/
					/******/ // Object.prototype.hasOwnProperty.call
					/******/ __nested_webpack_require_543__.o = function (
						object,
						property
					) {
						return Object.prototype.hasOwnProperty.call(object, property);
					};
					/******/
					/******/ // __webpack_public_path__
					/******/ __nested_webpack_require_543__.p = "";
					/******/
					/******/
					/******/ // Load entry module and return exports
					/******/ return __nested_webpack_require_543__(
						(__nested_webpack_require_543__.s = 0)
					);
					/******/
				})(
					/************************************************************************/
					/******/ [
						/* 0 */
						/***/ function (
							module,
							__webpack_exports__,
							__nested_webpack_require_4019__
						) {
							"use strict";
							__nested_webpack_require_4019__.r(__webpack_exports__);

							// CONCATENATED MODULE: ./src/tools.js
							var argumentAsArray = function argumentAsArray(argument) {
								return Array.isArray(argument) ? argument : [argument];
							};
							var isElement = function isElement(target) {
								return target instanceof Node;
							};
							var isElementList = function isElementList(nodeList) {
								return nodeList instanceof NodeList;
							};
							var eachNode = function eachNode(nodeList, callback) {
								if (nodeList && callback) {
									nodeList = isElementList(nodeList) ? nodeList : [nodeList];

									for (var i = 0; i < nodeList.length; i++) {
										if (callback(nodeList[i], i, nodeList.length) === true) {
											break;
										}
									}
								}
							};
							var throwError = function throwError(message) {
								return console.error("[scroll-lock] ".concat(message));
							};
							var arrayAsSelector = function arrayAsSelector(array) {
								if (Array.isArray(array)) {
									var selector = array.join(", ");
									return selector;
								}
							};
							var nodeListAsArray = function nodeListAsArray(nodeList) {
								var nodes = [];
								eachNode(nodeList, function (node) {
									return nodes.push(node);
								});
								return nodes;
							};
							var findParentBySelector = function findParentBySelector(
								$el,
								selector
							) {
								var self =
									arguments.length > 2 && arguments[2] !== undefined
										? arguments[2]
										: true;
								var $root =
									arguments.length > 3 && arguments[3] !== undefined
										? arguments[3]
										: document;

								if (
									self &&
									nodeListAsArray($root.querySelectorAll(selector)).indexOf(
										$el
									) !== -1
								) {
									return $el;
								}

								while (
									($el = $el.parentElement) &&
									nodeListAsArray($root.querySelectorAll(selector)).indexOf(
										$el
									) === -1
								) {}

								return $el;
							};
							var elementHasSelector = function elementHasSelector(
								$el,
								selector
							) {
								var $root =
									arguments.length > 2 && arguments[2] !== undefined
										? arguments[2]
										: document;
								var has =
									nodeListAsArray($root.querySelectorAll(selector)).indexOf(
										$el
									) !== -1;
								return has;
							};
							var elementHasOverflowHidden = function elementHasOverflowHidden(
								$el
							) {
								if ($el) {
									var computedStyle = getComputedStyle($el);
									var overflowIsHidden = computedStyle.overflow === "hidden";
									return overflowIsHidden;
								}
							};
							var elementScrollTopOnStart = function elementScrollTopOnStart(
								$el
							) {
								if ($el) {
									if (elementHasOverflowHidden($el)) {
										return true;
									}

									var scrollTop = $el.scrollTop;
									return scrollTop <= 0;
								}
							};
							var elementScrollTopOnEnd = function elementScrollTopOnEnd($el) {
								if ($el) {
									if (elementHasOverflowHidden($el)) {
										return true;
									}

									var scrollTop = $el.scrollTop;
									var scrollHeight = $el.scrollHeight;
									var scrollTopWithHeight = scrollTop + $el.offsetHeight;
									return scrollTopWithHeight >= scrollHeight;
								}
							};
							var elementScrollLeftOnStart = function elementScrollLeftOnStart(
								$el
							) {
								if ($el) {
									if (elementHasOverflowHidden($el)) {
										return true;
									}

									var scrollLeft = $el.scrollLeft;
									return scrollLeft <= 0;
								}
							};
							var elementScrollLeftOnEnd = function elementScrollLeftOnEnd(
								$el
							) {
								if ($el) {
									if (elementHasOverflowHidden($el)) {
										return true;
									}

									var scrollLeft = $el.scrollLeft;
									var scrollWidth = $el.scrollWidth;
									var scrollLeftWithWidth = scrollLeft + $el.offsetWidth;
									return scrollLeftWithWidth >= scrollWidth;
								}
							};
							var elementIsScrollableField = function elementIsScrollableField(
								$el
							) {
								var selector = 'textarea, [contenteditable="true"]';
								return elementHasSelector($el, selector);
							};
							var elementIsInputRange = function elementIsInputRange($el) {
								var selector = 'input[type="range"]';
								return elementHasSelector($el, selector);
							};
							// CONCATENATED MODULE: ./src/scroll-lock.js
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"disablePageScroll",
								function () {
									return disablePageScroll;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"enablePageScroll",
								function () {
									return enablePageScroll;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"getScrollState",
								function () {
									return getScrollState;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"clearQueueScrollLocks",
								function () {
									return clearQueueScrollLocks;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"getTargetScrollBarWidth",
								function () {
									return scroll_lock_getTargetScrollBarWidth;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"getCurrentTargetScrollBarWidth",
								function () {
									return scroll_lock_getCurrentTargetScrollBarWidth;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"getPageScrollBarWidth",
								function () {
									return getPageScrollBarWidth;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"getCurrentPageScrollBarWidth",
								function () {
									return getCurrentPageScrollBarWidth;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"addScrollableTarget",
								function () {
									return scroll_lock_addScrollableTarget;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"removeScrollableTarget",
								function () {
									return scroll_lock_removeScrollableTarget;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"addScrollableSelector",
								function () {
									return scroll_lock_addScrollableSelector;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"removeScrollableSelector",
								function () {
									return scroll_lock_removeScrollableSelector;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"addLockableTarget",
								function () {
									return scroll_lock_addLockableTarget;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"addLockableSelector",
								function () {
									return scroll_lock_addLockableSelector;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"setFillGapMethod",
								function () {
									return scroll_lock_setFillGapMethod;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"addFillGapTarget",
								function () {
									return scroll_lock_addFillGapTarget;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"removeFillGapTarget",
								function () {
									return scroll_lock_removeFillGapTarget;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"addFillGapSelector",
								function () {
									return scroll_lock_addFillGapSelector;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"removeFillGapSelector",
								function () {
									return scroll_lock_removeFillGapSelector;
								}
							);
							/* harmony export (binding) */ __nested_webpack_require_4019__.d(
								__webpack_exports__,
								"refillGaps",
								function () {
									return refillGaps;
								}
							);
							function _objectSpread(target) {
								for (var i = 1; i < arguments.length; i++) {
									var source = arguments[i] != null ? arguments[i] : {};
									var ownKeys = Object.keys(source);
									if (typeof Object.getOwnPropertySymbols === "function") {
										ownKeys = ownKeys.concat(
											Object.getOwnPropertySymbols(source).filter(function (
												sym
											) {
												return Object.getOwnPropertyDescriptor(source, sym)
													.enumerable;
											})
										);
									}
									ownKeys.forEach(function (key) {
										_defineProperty(target, key, source[key]);
									});
								}
								return target;
							}

							function _defineProperty(obj, key, value) {
								if (key in obj) {
									Object.defineProperty(obj, key, {
										value: value,
										enumerable: true,
										configurable: true,
										writable: true,
									});
								} else {
									obj[key] = value;
								}
								return obj;
							}

							var FILL_GAP_AVAILABLE_METHODS = [
								"padding",
								"margin",
								"width",
								"max-width",
								"none",
							];
							var TOUCH_DIRECTION_DETECT_OFFSET = 3;
							var state = {
								scroll: true,
								queue: 0,
								scrollableSelectors: ["[data-scroll-lock-scrollable]"],
								lockableSelectors: ["body", "[data-scroll-lock-lockable]"],
								fillGapSelectors: [
									"body",
									"[data-scroll-lock-fill-gap]",
									"[data-scroll-lock-lockable]",
								],
								fillGapMethod: FILL_GAP_AVAILABLE_METHODS[0],
								//
								startTouchY: 0,
								startTouchX: 0,
							};
							var disablePageScroll = function disablePageScroll(target) {
								if (state.queue <= 0) {
									state.scroll = false;
									scroll_lock_hideLockableOverflow();
									fillGaps();
								}

								scroll_lock_addScrollableTarget(target);
								state.queue++;
							};
							var enablePageScroll = function enablePageScroll(target) {
								state.queue > 0 && state.queue--;

								if (state.queue <= 0) {
									state.scroll = true;
									scroll_lock_showLockableOverflow();
									unfillGaps();
								}

								scroll_lock_removeScrollableTarget(target);
							};
							var getScrollState = function getScrollState() {
								return state.scroll;
							};
							var clearQueueScrollLocks = function clearQueueScrollLocks() {
								state.queue = 0;
							};
							var scroll_lock_getTargetScrollBarWidth =
								function getTargetScrollBarWidth($target) {
									var onlyExists =
										arguments.length > 1 && arguments[1] !== undefined
											? arguments[1]
											: false;

									if (isElement($target)) {
										var currentOverflowYProperty = $target.style.overflowY;

										if (onlyExists) {
											if (!getScrollState()) {
												$target.style.overflowY = $target.getAttribute(
													"data-scroll-lock-saved-overflow-y-property"
												);
											}
										} else {
											$target.style.overflowY = "scroll";
										}

										var width =
											scroll_lock_getCurrentTargetScrollBarWidth($target);
										$target.style.overflowY = currentOverflowYProperty;
										return width;
									} else {
										return 0;
									}
								};
							var scroll_lock_getCurrentTargetScrollBarWidth =
								function getCurrentTargetScrollBarWidth($target) {
									if (isElement($target)) {
										if ($target === document.body) {
											var documentWidth = document.documentElement.clientWidth;
											var windowWidth = window.innerWidth;
											var currentWidth = windowWidth - documentWidth;
											return currentWidth;
										} else {
											var borderLeftWidthCurrentProperty =
												$target.style.borderLeftWidth;
											var borderRightWidthCurrentProperty =
												$target.style.borderRightWidth;
											$target.style.borderLeftWidth = "0px";
											$target.style.borderRightWidth = "0px";

											var _currentWidth =
												$target.offsetWidth - $target.clientWidth;

											$target.style.borderLeftWidth =
												borderLeftWidthCurrentProperty;
											$target.style.borderRightWidth =
												borderRightWidthCurrentProperty;
											return _currentWidth;
										}
									} else {
										return 0;
									}
								};
							var getPageScrollBarWidth = function getPageScrollBarWidth() {
								var onlyExists =
									arguments.length > 0 && arguments[0] !== undefined
										? arguments[0]
										: false;
								return scroll_lock_getTargetScrollBarWidth(
									document.body,
									onlyExists
								);
							};
							var getCurrentPageScrollBarWidth =
								function getCurrentPageScrollBarWidth() {
									return scroll_lock_getCurrentTargetScrollBarWidth(
										document.body
									);
								};
							var scroll_lock_addScrollableTarget =
								function addScrollableTarget(target) {
									if (target) {
										var targets = argumentAsArray(target);
										targets.map(function ($targets) {
											eachNode($targets, function ($target) {
												if (isElement($target)) {
													$target.setAttribute(
														"data-scroll-lock-scrollable",
														""
													);
												} else {
													throwError(
														'"'.concat($target, '" is not a Element.')
													);
												}
											});
										});
									}
								};
							var scroll_lock_removeScrollableTarget =
								function removeScrollableTarget(target) {
									if (target) {
										var targets = argumentAsArray(target);
										targets.map(function ($targets) {
											eachNode($targets, function ($target) {
												if (isElement($target)) {
													$target.removeAttribute(
														"data-scroll-lock-scrollable"
													);
												} else {
													throwError(
														'"'.concat($target, '" is not a Element.')
													);
												}
											});
										});
									}
								};
							var scroll_lock_addScrollableSelector =
								function addScrollableSelector(selector) {
									if (selector) {
										var selectors = argumentAsArray(selector);
										selectors.map(function (selector) {
											state.scrollableSelectors.push(selector);
										});
									}
								};
							var scroll_lock_removeScrollableSelector =
								function removeScrollableSelector(selector) {
									if (selector) {
										var selectors = argumentAsArray(selector);
										selectors.map(function (selector) {
											state.scrollableSelectors =
												state.scrollableSelectors.filter(function (sSelector) {
													return sSelector !== selector;
												});
										});
									}
								};
							var scroll_lock_addLockableTarget = function addLockableTarget(
								target
							) {
								if (target) {
									var targets = argumentAsArray(target);
									targets.map(function ($targets) {
										eachNode($targets, function ($target) {
											if (isElement($target)) {
												$target.setAttribute("data-scroll-lock-lockable", "");
											} else {
												throwError('"'.concat($target, '" is not a Element.'));
											}
										});
									});

									if (!getScrollState()) {
										scroll_lock_hideLockableOverflow();
									}
								}
							};
							var scroll_lock_addLockableSelector =
								function addLockableSelector(selector) {
									if (selector) {
										var selectors = argumentAsArray(selector);
										selectors.map(function (selector) {
											state.lockableSelectors.push(selector);
										});

										if (!getScrollState()) {
											scroll_lock_hideLockableOverflow();
										}

										scroll_lock_addFillGapSelector(selector);
									}
								};
							var scroll_lock_setFillGapMethod = function setFillGapMethod(
								method
							) {
								if (method) {
									if (FILL_GAP_AVAILABLE_METHODS.indexOf(method) !== -1) {
										state.fillGapMethod = method;
										refillGaps();
									} else {
										var methods = FILL_GAP_AVAILABLE_METHODS.join(", ");
										throwError(
											'"'
												.concat(
													method,
													'" method is not available!\nAvailable fill gap methods: '
												)
												.concat(methods, ".")
										);
									}
								}
							};
							var scroll_lock_addFillGapTarget = function addFillGapTarget(
								target
							) {
								if (target) {
									var targets = argumentAsArray(target);
									targets.map(function ($targets) {
										eachNode($targets, function ($target) {
											if (isElement($target)) {
												$target.setAttribute("data-scroll-lock-fill-gap", "");

												if (!state.scroll) {
													scroll_lock_fillGapTarget($target);
												}
											} else {
												throwError('"'.concat($target, '" is not a Element.'));
											}
										});
									});
								}
							};
							var scroll_lock_removeFillGapTarget =
								function removeFillGapTarget(target) {
									if (target) {
										var targets = argumentAsArray(target);
										targets.map(function ($targets) {
											eachNode($targets, function ($target) {
												if (isElement($target)) {
													$target.removeAttribute("data-scroll-lock-fill-gap");

													if (!state.scroll) {
														scroll_lock_unfillGapTarget($target);
													}
												} else {
													throwError(
														'"'.concat($target, '" is not a Element.')
													);
												}
											});
										});
									}
								};
							var scroll_lock_addFillGapSelector = function addFillGapSelector(
								selector
							) {
								if (selector) {
									var selectors = argumentAsArray(selector);
									selectors.map(function (selector) {
										if (state.fillGapSelectors.indexOf(selector) === -1) {
											state.fillGapSelectors.push(selector);

											if (!state.scroll) {
												scroll_lock_fillGapSelector(selector);
											}
										}
									});
								}
							};
							var scroll_lock_removeFillGapSelector =
								function removeFillGapSelector(selector) {
									if (selector) {
										var selectors = argumentAsArray(selector);
										selectors.map(function (selector) {
											state.fillGapSelectors = state.fillGapSelectors.filter(
												function (fSelector) {
													return fSelector !== selector;
												}
											);

											if (!state.scroll) {
												scroll_lock_unfillGapSelector(selector);
											}
										});
									}
								};
							var refillGaps = function refillGaps() {
								if (!state.scroll) {
									fillGaps();
								}
							};

							var scroll_lock_hideLockableOverflow =
								function hideLockableOverflow() {
									var selector = arrayAsSelector(state.lockableSelectors);
									scroll_lock_hideLockableOverflowSelector(selector);
								};

							var scroll_lock_showLockableOverflow =
								function showLockableOverflow() {
									var selector = arrayAsSelector(state.lockableSelectors);
									scroll_lock_showLockableOverflowSelector(selector);
								};

							var scroll_lock_hideLockableOverflowSelector =
								function hideLockableOverflowSelector(selector) {
									var $targets = document.querySelectorAll(selector);
									eachNode($targets, function ($target) {
										scroll_lock_hideLockableOverflowTarget($target);
									});
								};

							var scroll_lock_showLockableOverflowSelector =
								function showLockableOverflowSelector(selector) {
									var $targets = document.querySelectorAll(selector);
									eachNode($targets, function ($target) {
										scroll_lock_showLockableOverflowTarget($target);
									});
								};

							var scroll_lock_hideLockableOverflowTarget =
								function hideLockableOverflowTarget($target) {
									if (
										isElement($target) &&
										$target.getAttribute("data-scroll-lock-locked") !== "true"
									) {
										var computedStyle = window.getComputedStyle($target);
										$target.setAttribute(
											"data-scroll-lock-saved-overflow-y-property",
											computedStyle.overflowY
										);
										$target.setAttribute(
											"data-scroll-lock-saved-inline-overflow-property",
											$target.style.overflow
										);
										$target.setAttribute(
											"data-scroll-lock-saved-inline-overflow-y-property",
											$target.style.overflowY
										);
										$target.style.overflow = "hidden";
										$target.setAttribute("data-scroll-lock-locked", "true");
									}
								};

							var scroll_lock_showLockableOverflowTarget =
								function showLockableOverflowTarget($target) {
									if (
										isElement($target) &&
										$target.getAttribute("data-scroll-lock-locked") === "true"
									) {
										$target.style.overflow = $target.getAttribute(
											"data-scroll-lock-saved-inline-overflow-property"
										);
										$target.style.overflowY = $target.getAttribute(
											"data-scroll-lock-saved-inline-overflow-y-property"
										);
										$target.removeAttribute(
											"data-scroll-lock-saved-overflow-property"
										);
										$target.removeAttribute(
											"data-scroll-lock-saved-inline-overflow-property"
										);
										$target.removeAttribute(
											"data-scroll-lock-saved-inline-overflow-y-property"
										);
										$target.removeAttribute("data-scroll-lock-locked");
									}
								};

							var fillGaps = function fillGaps() {
								state.fillGapSelectors.map(function (selector) {
									scroll_lock_fillGapSelector(selector);
								});
							};

							var unfillGaps = function unfillGaps() {
								state.fillGapSelectors.map(function (selector) {
									scroll_lock_unfillGapSelector(selector);
								});
							};

							var scroll_lock_fillGapSelector = function fillGapSelector(
								selector
							) {
								var $targets = document.querySelectorAll(selector);
								var isLockable =
									state.lockableSelectors.indexOf(selector) !== -1;
								eachNode($targets, function ($target) {
									scroll_lock_fillGapTarget($target, isLockable);
								});
							};

							var scroll_lock_fillGapTarget = function fillGapTarget($target) {
								var isLockable =
									arguments.length > 1 && arguments[1] !== undefined
										? arguments[1]
										: false;

								if (isElement($target)) {
									var scrollBarWidth;

									if (
										$target.getAttribute("data-scroll-lock-lockable") === "" ||
										isLockable
									) {
										scrollBarWidth = scroll_lock_getTargetScrollBarWidth(
											$target,
											true
										);
									} else {
										var $lockableParent = findParentBySelector(
											$target,
											arrayAsSelector(state.lockableSelectors)
										);
										scrollBarWidth = scroll_lock_getTargetScrollBarWidth(
											$lockableParent,
											true
										);
									}

									if (
										$target.getAttribute("data-scroll-lock-filled-gap") ===
										"true"
									) {
										scroll_lock_unfillGapTarget($target);
									}

									var computedStyle = window.getComputedStyle($target);
									$target.setAttribute("data-scroll-lock-filled-gap", "true");
									$target.setAttribute(
										"data-scroll-lock-current-fill-gap-method",
										state.fillGapMethod
									);

									if (state.fillGapMethod === "margin") {
										var currentMargin = parseFloat(computedStyle.marginRight);
										$target.style.marginRight = "".concat(
											currentMargin + scrollBarWidth,
											"px"
										);
									} else if (state.fillGapMethod === "width") {
										$target.style.width = "calc(100% - ".concat(
											scrollBarWidth,
											"px)"
										);
									} else if (state.fillGapMethod === "max-width") {
										$target.style.maxWidth = "calc(100% - ".concat(
											scrollBarWidth,
											"px)"
										);
									} else if (state.fillGapMethod === "padding") {
										var currentPadding = parseFloat(computedStyle.paddingRight);
										$target.style.paddingRight = "".concat(
											currentPadding + scrollBarWidth,
											"px"
										);
									}
								}
							};

							var scroll_lock_unfillGapSelector = function unfillGapSelector(
								selector
							) {
								var $targets = document.querySelectorAll(selector);
								eachNode($targets, function ($target) {
									scroll_lock_unfillGapTarget($target);
								});
							};

							var scroll_lock_unfillGapTarget = function unfillGapTarget(
								$target
							) {
								if (isElement($target)) {
									if (
										$target.getAttribute("data-scroll-lock-filled-gap") ===
										"true"
									) {
										var currentFillGapMethod = $target.getAttribute(
											"data-scroll-lock-current-fill-gap-method"
										);
										$target.removeAttribute("data-scroll-lock-filled-gap");
										$target.removeAttribute(
											"data-scroll-lock-current-fill-gap-method"
										);

										if (currentFillGapMethod === "margin") {
											$target.style.marginRight = "";
										} else if (currentFillGapMethod === "width") {
											$target.style.width = "";
										} else if (currentFillGapMethod === "max-width") {
											$target.style.maxWidth = "";
										} else if (currentFillGapMethod === "padding") {
											$target.style.paddingRight = "";
										}
									}
								}
							};

							var onResize = function onResize(e) {
								refillGaps();
							};

							var onTouchStart = function onTouchStart(e) {
								if (!state.scroll) {
									state.startTouchY = e.touches[0].clientY;
									state.startTouchX = e.touches[0].clientX;
								}
							};

							var scroll_lock_onTouchMove = function onTouchMove(e) {
								if (!state.scroll) {
									var startTouchY = state.startTouchY,
										startTouchX = state.startTouchX;
									var currentClientY = e.touches[0].clientY;
									var currentClientX = e.touches[0].clientX;

									if (e.touches.length < 2) {
										var selector = arrayAsSelector(state.scrollableSelectors);
										var direction = {
											up: startTouchY < currentClientY,
											down: startTouchY > currentClientY,
											left: startTouchX < currentClientX,
											right: startTouchX > currentClientX,
										};
										var directionWithOffset = {
											up:
												startTouchY + TOUCH_DIRECTION_DETECT_OFFSET <
												currentClientY,
											down:
												startTouchY - TOUCH_DIRECTION_DETECT_OFFSET >
												currentClientY,
											left:
												startTouchX + TOUCH_DIRECTION_DETECT_OFFSET <
												currentClientX,
											right:
												startTouchX - TOUCH_DIRECTION_DETECT_OFFSET >
												currentClientX,
										};

										var handle = function handle($el) {
											var skip =
												arguments.length > 1 && arguments[1] !== undefined
													? arguments[1]
													: false;

											if ($el) {
												var parentScrollableEl = findParentBySelector(
													$el,
													selector,
													false
												);

												if (elementIsInputRange($el)) {
													return false;
												}

												if (
													skip ||
													(elementIsScrollableField($el) &&
														findParentBySelector($el, selector)) ||
													elementHasSelector($el, selector)
												) {
													var prevent = false;

													if (
														elementScrollLeftOnStart($el) &&
														elementScrollLeftOnEnd($el)
													) {
														if (
															(direction.up && elementScrollTopOnStart($el)) ||
															(direction.down && elementScrollTopOnEnd($el))
														) {
															prevent = true;
														}
													} else if (
														elementScrollTopOnStart($el) &&
														elementScrollTopOnEnd($el)
													) {
														if (
															(direction.left &&
																elementScrollLeftOnStart($el)) ||
															(direction.right && elementScrollLeftOnEnd($el))
														) {
															prevent = true;
														}
													} else if (
														(directionWithOffset.up &&
															elementScrollTopOnStart($el)) ||
														(directionWithOffset.down &&
															elementScrollTopOnEnd($el)) ||
														(directionWithOffset.left &&
															elementScrollLeftOnStart($el)) ||
														(directionWithOffset.right &&
															elementScrollLeftOnEnd($el))
													) {
														prevent = true;
													}

													if (prevent) {
														if (parentScrollableEl) {
															handle(parentScrollableEl, true);
														} else {
															if (e.cancelable) {
																e.preventDefault();
															}
														}
													}
												} else {
													handle(parentScrollableEl);
												}
											} else {
												if (e.cancelable) {
													e.preventDefault();
												}
											}
										};

										handle(e.target);
									}
								}
							};

							var onTouchEnd = function onTouchEnd(e) {
								if (!state.scroll) {
									state.startTouchY = 0;
									state.startTouchX = 0;
								}
							};

							if (typeof window !== "undefined") {
								window.addEventListener("resize", onResize);
							}

							if (typeof document !== "undefined") {
								document.addEventListener("touchstart", onTouchStart);
								document.addEventListener(
									"touchmove",
									scroll_lock_onTouchMove,
									{
										passive: false,
									}
								);
								document.addEventListener("touchend", onTouchEnd);
							}

							var deprecatedMethods = {
								hide: function hide(target) {
									throwError(
										'"hide" is deprecated! Use "disablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#disablepagescrollscrollabletarget'
									);
									disablePageScroll(target);
								},
								show: function show(target) {
									throwError(
										'"show" is deprecated! Use "enablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#enablepagescrollscrollabletarget'
									);
									enablePageScroll(target);
								},
								toggle: function toggle(target) {
									throwError('"toggle" is deprecated! Do not use it.');

									if (getScrollState()) {
										disablePageScroll();
									} else {
										enablePageScroll(target);
									}
								},
								getState: function getState() {
									throwError(
										'"getState" is deprecated! Use "getScrollState" instead. \n https://github.com/FL3NKEY/scroll-lock#getscrollstate'
									);
									return getScrollState();
								},
								getWidth: function getWidth() {
									throwError(
										'"getWidth" is deprecated! Use "getPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getpagescrollbarwidth'
									);
									return getPageScrollBarWidth();
								},
								getCurrentWidth: function getCurrentWidth() {
									throwError(
										'"getCurrentWidth" is deprecated! Use "getCurrentPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getcurrentpagescrollbarwidth'
									);
									return getCurrentPageScrollBarWidth();
								},
								setScrollableTargets: function setScrollableTargets(target) {
									throwError(
										'"setScrollableTargets" is deprecated! Use "addScrollableTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addscrollabletargetscrollabletarget'
									);
									scroll_lock_addScrollableTarget(target);
								},
								setFillGapSelectors: function setFillGapSelectors(selector) {
									throwError(
										'"setFillGapSelectors" is deprecated! Use "addFillGapSelector" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgapselectorfillgapselector'
									);
									scroll_lock_addFillGapSelector(selector);
								},
								setFillGapTargets: function setFillGapTargets(target) {
									throwError(
										'"setFillGapTargets" is deprecated! Use "addFillGapTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgaptargetfillgaptarget'
									);
									scroll_lock_addFillGapTarget(target);
								},
								clearQueue: function clearQueue() {
									throwError(
										'"clearQueue" is deprecated! Use "clearQueueScrollLocks" instead. \n https://github.com/FL3NKEY/scroll-lock#clearqueuescrolllocks'
									);
									clearQueueScrollLocks();
								},
							};

							var scrollLock = _objectSpread(
								{
									disablePageScroll: disablePageScroll,
									enablePageScroll: enablePageScroll,
									getScrollState: getScrollState,
									clearQueueScrollLocks: clearQueueScrollLocks,
									getTargetScrollBarWidth: scroll_lock_getTargetScrollBarWidth,
									getCurrentTargetScrollBarWidth:
										scroll_lock_getCurrentTargetScrollBarWidth,
									getPageScrollBarWidth: getPageScrollBarWidth,
									getCurrentPageScrollBarWidth: getCurrentPageScrollBarWidth,
									addScrollableSelector: scroll_lock_addScrollableSelector,
									removeScrollableSelector:
										scroll_lock_removeScrollableSelector,
									addScrollableTarget: scroll_lock_addScrollableTarget,
									removeScrollableTarget: scroll_lock_removeScrollableTarget,
									addLockableSelector: scroll_lock_addLockableSelector,
									addLockableTarget: scroll_lock_addLockableTarget,
									addFillGapSelector: scroll_lock_addFillGapSelector,
									removeFillGapSelector: scroll_lock_removeFillGapSelector,
									addFillGapTarget: scroll_lock_addFillGapTarget,
									removeFillGapTarget: scroll_lock_removeFillGapTarget,
									setFillGapMethod: scroll_lock_setFillGapMethod,
									refillGaps: refillGaps,
									_state: state,
								},
								deprecatedMethods
							);

							/* harmony default export */ var scroll_lock =
								(__webpack_exports__["default"] = scrollLock);

							/***/
						},
						/******/
					]
				)["default"];
			});

			/***/
		},

		/***/ 637: /***/ (module, exports) => {
			var __WEBPACK_AMD_DEFINE_FACTORY__,
				__WEBPACK_AMD_DEFINE_ARRAY__,
				__WEBPACK_AMD_DEFINE_RESULT__;
			/*********************************************************************
			 *  #### Twitter Post Fetcher v17.0.3 ####
			 *  Coded by Jason Mayes 2015. A present to all the developers out there.
			 *  www.jasonmayes.com
			 *  Please keep this disclaimer with my code if you use it. Thanks. :-)
			 *  Got feedback or questions, ask here:
			 *  http://www.jasonmayes.com/projects/twitterApi/
			 *  Github: https://github.com/jasonmayes/Twitter-Post-Fetcher
			 *  Updates will be posted to this site.
			 *********************************************************************/
			!(function (e, t) {
				true
					? !((__WEBPACK_AMD_DEFINE_ARRAY__ = []),
					  (__WEBPACK_AMD_DEFINE_FACTORY__ = t),
					  (__WEBPACK_AMD_DEFINE_RESULT__ =
							typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
								? __WEBPACK_AMD_DEFINE_FACTORY__.apply(
										exports,
										__WEBPACK_AMD_DEFINE_ARRAY__
								  )
								: __WEBPACK_AMD_DEFINE_FACTORY__),
					  __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
							(module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
					: 0;
			})(0, function () {
				var e = "",
					t = 20,
					a = !0,
					i = [],
					n = !1,
					s = !0,
					l = !0,
					r = null,
					o = !0,
					c = !0,
					d = null,
					m = !0,
					u = !1,
					p = !1,
					g = !0,
					h = "en",
					w = !0,
					f = !1,
					v = null;
				function b(e) {
					return e
						.replace(/<b[^>]*>(.*?)<\/b>/gi, function (e, t) {
							return t;
						})
						.replace(
							/class="(?!(tco-hidden|tco-display|tco-ellipsis))+.*?"|data-query-source=".*?"|dir=".*?"|rel=".*?"/gi,
							""
						);
				}
				function _(e) {
					for (
						var t = e.getElementsByTagName("a"), a = t.length - 1;
						a >= 0;
						a--
					)
						t[a].setAttribute("target", "_blank");
				}
				function y(e, t) {
					for (
						var a = [],
							i = new RegExp("(^| )" + t + "( |$)"),
							n = e.getElementsByTagName("*"),
							s = 0,
							l = n.length;
						s < l;
						s++
					)
						i.test(n[s].className) && a.push(n[s]);
					return a;
				}
				function T(e) {
					if (void 0 !== e && e.innerHTML.indexOf("data-image") >= 0) {
						var t = e.innerHTML.split('data-image="')[1].split('"')[0];
						return decodeURIComponent(t) + ".jpg";
					}
				}
				var k = {
					fetch: function (o) {
						if (
							(void 0 === o.maxTweets && (o.maxTweets = 20),
							void 0 === o.enableLinks && (o.enableLinks = !0),
							void 0 === o.showUser && (o.showUser = !0),
							void 0 === o.showTime && (o.showTime = !0),
							void 0 === o.dateFunction && (o.dateFunction = "default"),
							void 0 === o.showRetweet && (o.showRetweet = !0),
							void 0 === o.customCallback && (o.customCallback = null),
							void 0 === o.showInteraction && (o.showInteraction = !0),
							void 0 === o.showImages && (o.showImages = !1),
							void 0 === o.useEmoji && (o.useEmoji = !1),
							void 0 === o.linksInNewWindow && (o.linksInNewWindow = !0),
							void 0 === o.showPermalinks && (o.showPermalinks = !0),
							void 0 === o.dataOnly && (o.dataOnly = !1),
							n)
						)
							i.push(o);
						else {
							(n = !0),
								(e = o.domId),
								(t = o.maxTweets),
								(a = o.enableLinks),
								(l = o.showUser),
								(s = o.showTime),
								(c = o.showRetweet),
								(r = o.dateFunction),
								(d = o.customCallback),
								(m = o.showInteraction),
								(u = o.showImages),
								(p = o.useEmoji),
								(g = o.linksInNewWindow),
								(w = o.showPermalinks),
								(f = o.dataOnly);
							var b = document.getElementsByTagName("head")[0];
							null !== v && b.removeChild(v),
								((v = document.createElement("script")).type =
									"text/javascript"),
								void 0 !== o.list
									? (v.src =
											"https://syndication.twitter.com/timeline/list?callback=__twttrf.callback&dnt=false&list_slug=" +
											o.list.listSlug +
											"&screen_name=" +
											o.list.screenName +
											"&suppress_response_codes=true&lang=" +
											(o.lang || h) +
											"&rnd=" +
											Math.random())
									: void 0 !== o.profile
									? (v.src =
											"https://syndication.twitter.com/timeline/profile?callback=__twttrf.callback&dnt=false&screen_name=" +
											o.profile.screenName +
											"&suppress_response_codes=true&lang=" +
											(o.lang || h) +
											"&rnd=" +
											Math.random())
									: void 0 !== o.likes
									? (v.src =
											"https://syndication.twitter.com/timeline/likes?callback=__twttrf.callback&dnt=false&screen_name=" +
											o.likes.screenName +
											"&suppress_response_codes=true&lang=" +
											(o.lang || h) +
											"&rnd=" +
											Math.random())
									: (v.src =
											"https://cdn.syndication.twimg.com/widgets/timelines/" +
											o.id +
											"?&lang=" +
											(o.lang || h) +
											"&callback=__twttrf.callback&suppress_response_codes=true&rnd=" +
											Math.random()),
								b.appendChild(v);
						}
					},
					callback: function (h) {
						if (void 0 === h || void 0 === h.body)
							return (
								(n = !1), void (i.length > 0 && (k.fetch(i[0]), i.splice(0, 1)))
							);
						p ||
							(h.body = h.body.replace(
								/(<img[^c]*class="Emoji[^>]*>)|(<img[^c]*class="u-block[^>]*>)/g,
								""
							)),
							u ||
								(h.body = h.body.replace(
									/(<img[^c]*class="NaturalImage-image[^>]*>|(<img[^c]*class="CroppedImage-image[^>]*>))/g,
									""
								)),
							l ||
								(h.body = h.body.replace(
									/(<img[^c]*class="Avatar"[^>]*>)/g,
									""
								));
						var v = document.createElement("div");
						function C(e) {
							var t = e.getElementsByTagName("img")[0];
							return (
								t && t.length && (t.src = t.getAttribute("data-src-2x")), e
							);
						}
						(v.innerHTML = h.body),
							void 0 === v.getElementsByClassName && (o = !1);
						var x = [],
							E = [],
							N = [],
							A = [],
							I = [],
							B = [],
							L = [],
							M = 0;
						if (o)
							for (
								var H = v.getElementsByClassName("timeline-Tweet");
								M < H.length;

							)
								H[M].getElementsByClassName("timeline-Tweet-retweetCredit")
									.length > 0
									? I.push(!0)
									: I.push(!1),
									(!I[M] || (I[M] && c)) &&
										(x.push(
											H[M].getElementsByClassName("timeline-Tweet-text")[0]
										),
										B.push(H[M].getAttribute("data-tweet-id")),
										l &&
											E.push(
												C(
													H[M].getElementsByClassName(
														"timeline-Tweet-author"
													)[0]
												)
											),
										N.push(H[M].getElementsByClassName("dt-updated")[0]),
										L.push(
											H[M].getElementsByClassName("timeline-Tweet-timestamp")[0]
										),
										void 0 !==
										H[M].getElementsByClassName("timeline-Tweet-media")[0]
											? A.push(
													H[M].getElementsByClassName("timeline-Tweet-media")[0]
											  )
											: A.push(void 0)),
									M++;
						else
							for (H = y(v, "timeline-Tweet"); M < H.length; )
								y(H[M], "timeline-Tweet-retweetCredit").length > 0
									? I.push(!0)
									: I.push(!1),
									(!I[M] || (I[M] && c)) &&
										(x.push(y(H[M], "timeline-Tweet-text")[0]),
										B.push(H[M].getAttribute("data-tweet-id")),
										l && E.push(C(y(H[M], "timeline-Tweet-author")[0])),
										N.push(y(H[M], "dt-updated")[0]),
										L.push(y(H[M], "timeline-Tweet-timestamp")[0]),
										void 0 !== y(H[M], "timeline-Tweet-media")[0]
											? A.push(y(H[M], "timeline-Tweet-media")[0])
											: A.push(void 0)),
									M++;
						x.length > t &&
							(x.splice(t, x.length - t),
							E.splice(t, E.length - t),
							N.splice(t, N.length - t),
							I.splice(t, I.length - t),
							A.splice(t, A.length - t),
							L.splice(t, L.length - t));
						var R = [],
							j = ((M = x.length), 0);
						if (f)
							for (; j < M; )
								R.push({
									tweet: x[j].innerHTML,
									author: E[j] ? E[j].innerHTML : "Unknown Author",
									author_data: {
										profile_url: E[j]
											? E[j].querySelector('[data-scribe="element:user_link"]')
													.href
											: null,
										profile_image: E[j]
											? E[j]
													.querySelector('[data-scribe="element:avatar"]')
													.getAttribute("data-src-1x")
											: null,
										profile_image_2x: E[j]
											? E[j]
													.querySelector('[data-scribe="element:avatar"]')
													.getAttribute("data-src-2x")
											: null,
										screen_name: E[j]
											? E[j].querySelector(
													'[data-scribe="element:screen_name"]'
											  ).title
											: null,
										name: E[j]
											? E[j].querySelector('[data-scribe="element:name"]').title
											: null,
									},
									time: N[j].textContent,
									timestamp: N[j]
										.getAttribute("datetime")
										.replace("+0000", "Z")
										.replace(/([\+\-])(\d\d)(\d\d)/, "$1$2:$3"),
									image: T(A[j]),
									rt: I[j],
									tid: B[j],
									permalinkURL: void 0 === L[j] ? "" : L[j].href,
								}),
									j++;
						else
							for (; j < M; ) {
								if ("string" != typeof r) {
									var q = N[j].getAttribute("datetime"),
										P = new Date(
											N[j]
												.getAttribute("datetime")
												.replace(/-/g, "/")
												.replace("T", " ")
												.split("+")[0]
										),
										S = r(P, q);
									if ((N[j].setAttribute("aria-label", S), x[j].textContent))
										if (o) N[j].textContent = S;
										else {
											var U = document.createElement("p"),
												F = document.createTextNode(S);
											U.appendChild(F),
												U.setAttribute("aria-label", S),
												(N[j] = U);
										}
									else N[j].textContent = S;
								}
								var O = "";
								a
									? (g && (_(x[j]), l && _(E[j])),
									  l &&
											(O +=
												'<div class="user">' + b(E[j].innerHTML) + "</div>"),
									  (O += '<p class="tweet">' + b(x[j].innerHTML) + "</p>"),
									  s &&
											(O += w
												? '<p class="timePosted"><a href="' +
												  L[j] +
												  '">' +
												  N[j].getAttribute("aria-label") +
												  "</a></p>"
												: '<p class="timePosted">' +
												  N[j].getAttribute("aria-label") +
												  "</p>"))
									: (x[j].textContent,
									  l && (O += '<p class="user">' + E[j].textContent + "</p>"),
									  (O += '<p class="tweet">' + x[j].textContent + "</p>"),
									  s &&
											(O +=
												'<p class="timePosted">' + N[j].textContent + "</p>")),
									m &&
										(O +=
											'<p class="interact"><a href="https://twitter.com/intent/tweet?in_reply_to=' +
											B[j] +
											'" class="twitter_reply_icon"' +
											(g ? ' target="_blank">' : ">") +
											'Reply</a><a href="https://twitter.com/intent/retweet?tweet_id=' +
											B[j] +
											'" class="twitter_retweet_icon"' +
											(g ? ' target="_blank">' : ">") +
											'Retweet</a><a href="https://twitter.com/intent/favorite?tweet_id=' +
											B[j] +
											'" class="twitter_fav_icon"' +
											(g ? ' target="_blank">' : ">") +
											"Favorite</a></p>"),
									u &&
										void 0 !== A[j] &&
										void 0 !== T(A[j]) &&
										(O +=
											'<div class="media"><img src="' +
											T(A[j]) +
											'" alt="Image from tweet" /></div>'),
									u ? R.push(O) : !u && x[j].textContent.length && R.push(O),
									j++;
							}
						!(function (t) {
							if (null === d) {
								for (
									var a = t.length,
										i = 0,
										n = document.getElementById(e),
										s = "<ul>";
									i < a;

								)
									(s += "<li>" + t[i] + "</li>"), i++;
								(s += "</ul>"), (n.innerHTML = s);
							} else d(t);
						})(R),
							(n = !1),
							i.length > 0 && (k.fetch(i[0]), i.splice(0, 1));
					},
				};
				return (window.__twttrf = k), (window.twitterFetcher = k), k;
			});

			/***/
		},

		/***/ 842: /***/ (module, exports, __webpack_require__) => {
			var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
			/*!
			 * Unidragger v2.3.0
			 * Draggable base class
			 * MIT license
			 */

			/*jshint browser: true, unused: true, undef: true, strict: true */

			(function (window, factory) {
				// universal module definition
				/*jshint strict: false */ /*globals define, module, require */

				if (true) {
					// AMD
					!((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(704)]),
					(__WEBPACK_AMD_DEFINE_RESULT__ = function (Unipointer) {
						return factory(window, Unipointer);
					}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(window, function factory(window, Unipointer) {
				"use strict";

				// -------------------------- Unidragger -------------------------- //

				function Unidragger() {}

				// inherit Unipointer & EvEmitter
				var proto = (Unidragger.prototype = Object.create(
					Unipointer.prototype
				));

				// ----- bind start ----- //

				proto.bindHandles = function () {
					this._bindHandles(true);
				};

				proto.unbindHandles = function () {
					this._bindHandles(false);
				};

				/**
				 * Add or remove start event
				 * @param {Boolean} isAdd
				 */
				proto._bindHandles = function (isAdd) {
					// munge isAdd, default to true
					isAdd = isAdd === undefined ? true : isAdd;
					// bind each handle
					var bindMethod = isAdd ? "addEventListener" : "removeEventListener";
					var touchAction = isAdd ? this._touchActionValue : "";
					for (var i = 0; i < this.handles.length; i++) {
						var handle = this.handles[i];
						this._bindStartEvent(handle, isAdd);
						handle[bindMethod]("click", this);
						// touch-action: none to override browser touch gestures. metafizzy/flickity#540
						if (window.PointerEvent) {
							handle.style.touchAction = touchAction;
						}
					}
				};

				// prototype so it can be overwriteable by Flickity
				proto._touchActionValue = "none";

				// ----- start event ----- //

				/**
				 * pointer start
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 */
				proto.pointerDown = function (event, pointer) {
					var isOkay = this.okayPointerDown(event);
					if (!isOkay) {
						return;
					}
					// track start event position
					this.pointerDownPointer = pointer;

					event.preventDefault();
					this.pointerDownBlur();
					// bind move and end events
					this._bindPostStartEvents(event);
					this.emitEvent("pointerDown", [event, pointer]);
				};

				// nodes that have text fields
				var cursorNodes = {
					TEXTAREA: true,
					INPUT: true,
					SELECT: true,
					OPTION: true,
				};

				// input types that do not have text fields
				var clickTypes = {
					radio: true,
					checkbox: true,
					button: true,
					submit: true,
					image: true,
					file: true,
				};

				// dismiss inputs with text fields. flickity#403, flickity#404
				proto.okayPointerDown = function (event) {
					var isCursorNode = cursorNodes[event.target.nodeName];
					var isClickType = clickTypes[event.target.type];
					var isOkay = !isCursorNode || isClickType;
					if (!isOkay) {
						this._pointerReset();
					}
					return isOkay;
				};

				// kludge to blur previously focused input
				proto.pointerDownBlur = function () {
					var focused = document.activeElement;
					// do not blur body for IE10, metafizzy/flickity#117
					var canBlur = focused && focused.blur && focused != document.body;
					if (canBlur) {
						focused.blur();
					}
				};

				// ----- move event ----- //

				/**
				 * drag move
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 */
				proto.pointerMove = function (event, pointer) {
					var moveVector = this._dragPointerMove(event, pointer);
					this.emitEvent("pointerMove", [event, pointer, moveVector]);
					this._dragMove(event, pointer, moveVector);
				};

				// base pointer move logic
				proto._dragPointerMove = function (event, pointer) {
					var moveVector = {
						x: pointer.pageX - this.pointerDownPointer.pageX,
						y: pointer.pageY - this.pointerDownPointer.pageY,
					};
					// start drag if pointer has moved far enough to start drag
					if (!this.isDragging && this.hasDragStarted(moveVector)) {
						this._dragStart(event, pointer);
					}
					return moveVector;
				};

				// condition if pointer has moved far enough to start drag
				proto.hasDragStarted = function (moveVector) {
					return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
				};

				// ----- end event ----- //

				/**
				 * pointer up
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 */
				proto.pointerUp = function (event, pointer) {
					this.emitEvent("pointerUp", [event, pointer]);
					this._dragPointerUp(event, pointer);
				};

				proto._dragPointerUp = function (event, pointer) {
					if (this.isDragging) {
						this._dragEnd(event, pointer);
					} else {
						// pointer didn't move enough for drag to start
						this._staticClick(event, pointer);
					}
				};

				// -------------------------- drag -------------------------- //

				// dragStart
				proto._dragStart = function (event, pointer) {
					this.isDragging = true;
					// prevent clicks
					this.isPreventingClicks = true;
					this.dragStart(event, pointer);
				};

				proto.dragStart = function (event, pointer) {
					this.emitEvent("dragStart", [event, pointer]);
				};

				// dragMove
				proto._dragMove = function (event, pointer, moveVector) {
					// do not drag if not dragging yet
					if (!this.isDragging) {
						return;
					}

					this.dragMove(event, pointer, moveVector);
				};

				proto.dragMove = function (event, pointer, moveVector) {
					event.preventDefault();
					this.emitEvent("dragMove", [event, pointer, moveVector]);
				};

				// dragEnd
				proto._dragEnd = function (event, pointer) {
					// set flags
					this.isDragging = false;
					// re-enable clicking async
					setTimeout(
						function () {
							delete this.isPreventingClicks;
						}.bind(this)
					);

					this.dragEnd(event, pointer);
				};

				proto.dragEnd = function (event, pointer) {
					this.emitEvent("dragEnd", [event, pointer]);
				};

				// ----- onclick ----- //

				// handle all clicks and prevent clicks when dragging
				proto.onclick = function (event) {
					if (this.isPreventingClicks) {
						event.preventDefault();
					}
				};

				// ----- staticClick ----- //

				// triggered after pointer down & up with no/tiny movement
				proto._staticClick = function (event, pointer) {
					// ignore emulated mouse up clicks
					if (this.isIgnoringMouseUp && event.type == "mouseup") {
						return;
					}

					this.staticClick(event, pointer);

					// set flag for emulated clicks 300ms after touchend
					if (event.type != "mouseup") {
						this.isIgnoringMouseUp = true;
						// reset flag after 300ms
						setTimeout(
							function () {
								delete this.isIgnoringMouseUp;
							}.bind(this),
							400
						);
					}
				};

				proto.staticClick = function (event, pointer) {
					this.emitEvent("staticClick", [event, pointer]);
				};

				// ----- utils ----- //

				Unidragger.getPointerPoint = Unipointer.getPointerPoint;

				// -----  ----- //

				return Unidragger;
			});

			/***/
		},

		/***/ 704: /***/ (module, exports, __webpack_require__) => {
			var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
			/*!
			 * Unipointer v2.3.0
			 * base class for doing one thing with pointer event
			 * MIT license
			 */

			/*jshint browser: true, undef: true, unused: true, strict: true */

			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */ /*global define, module, require */
				if (true) {
					// AMD
					!((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(158)]),
					(__WEBPACK_AMD_DEFINE_RESULT__ = function (EvEmitter) {
						return factory(window, EvEmitter);
					}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
				}
			})(window, function factory(window, EvEmitter) {
				"use strict";

				function noop() {}

				function Unipointer() {}

				// inherit EvEmitter
				var proto = (Unipointer.prototype = Object.create(EvEmitter.prototype));

				proto.bindStartEvent = function (elem) {
					this._bindStartEvent(elem, true);
				};

				proto.unbindStartEvent = function (elem) {
					this._bindStartEvent(elem, false);
				};

				/**
				 * Add or remove start event
				 * @param {Boolean} isAdd - remove if falsey
				 */
				proto._bindStartEvent = function (elem, isAdd) {
					// munge isAdd, default to true
					isAdd = isAdd === undefined ? true : isAdd;
					var bindMethod = isAdd ? "addEventListener" : "removeEventListener";

					// default to mouse events
					var startEvent = "mousedown";
					if (window.PointerEvent) {
						// Pointer Events
						startEvent = "pointerdown";
					} else if ("ontouchstart" in window) {
						// Touch Events. iOS Safari
						startEvent = "touchstart";
					}
					elem[bindMethod](startEvent, this);
				};

				// trigger handler methods for events
				proto.handleEvent = function (event) {
					var method = "on" + event.type;
					if (this[method]) {
						this[method](event);
					}
				};

				// returns the touch that we're keeping track of
				proto.getTouch = function (touches) {
					for (var i = 0; i < touches.length; i++) {
						var touch = touches[i];
						if (touch.identifier == this.pointerIdentifier) {
							return touch;
						}
					}
				};

				// ----- start event ----- //

				proto.onmousedown = function (event) {
					// dismiss clicks from right or middle buttons
					var button = event.button;
					if (button && button !== 0 && button !== 1) {
						return;
					}
					this._pointerDown(event, event);
				};

				proto.ontouchstart = function (event) {
					this._pointerDown(event, event.changedTouches[0]);
				};

				proto.onpointerdown = function (event) {
					this._pointerDown(event, event);
				};

				/**
				 * pointer start
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 */
				proto._pointerDown = function (event, pointer) {
					// dismiss right click and other pointers
					// button = 0 is okay, 1-4 not
					if (event.button || this.isPointerDown) {
						return;
					}

					this.isPointerDown = true;
					// save pointer identifier to match up touch events
					this.pointerIdentifier =
						pointer.pointerId !== undefined
							? // pointerId for pointer events, touch.indentifier for touch events
							  pointer.pointerId
							: pointer.identifier;

					this.pointerDown(event, pointer);
				};

				proto.pointerDown = function (event, pointer) {
					this._bindPostStartEvents(event);
					this.emitEvent("pointerDown", [event, pointer]);
				};

				// hash of events to be bound after start event
				var postStartEvents = {
					mousedown: ["mousemove", "mouseup"],
					touchstart: ["touchmove", "touchend", "touchcancel"],
					pointerdown: ["pointermove", "pointerup", "pointercancel"],
				};

				proto._bindPostStartEvents = function (event) {
					if (!event) {
						return;
					}
					// get proper events to match start event
					var events = postStartEvents[event.type];
					// bind events to node
					events.forEach(function (eventName) {
						window.addEventListener(eventName, this);
					}, this);
					// save these arguments
					this._boundPointerEvents = events;
				};

				proto._unbindPostStartEvents = function () {
					// check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
					if (!this._boundPointerEvents) {
						return;
					}
					this._boundPointerEvents.forEach(function (eventName) {
						window.removeEventListener(eventName, this);
					}, this);

					delete this._boundPointerEvents;
				};

				// ----- move event ----- //

				proto.onmousemove = function (event) {
					this._pointerMove(event, event);
				};

				proto.onpointermove = function (event) {
					if (event.pointerId == this.pointerIdentifier) {
						this._pointerMove(event, event);
					}
				};

				proto.ontouchmove = function (event) {
					var touch = this.getTouch(event.changedTouches);
					if (touch) {
						this._pointerMove(event, touch);
					}
				};

				/**
				 * pointer move
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 * @private
				 */
				proto._pointerMove = function (event, pointer) {
					this.pointerMove(event, pointer);
				};

				// public
				proto.pointerMove = function (event, pointer) {
					this.emitEvent("pointerMove", [event, pointer]);
				};

				// ----- end event ----- //

				proto.onmouseup = function (event) {
					this._pointerUp(event, event);
				};

				proto.onpointerup = function (event) {
					if (event.pointerId == this.pointerIdentifier) {
						this._pointerUp(event, event);
					}
				};

				proto.ontouchend = function (event) {
					var touch = this.getTouch(event.changedTouches);
					if (touch) {
						this._pointerUp(event, touch);
					}
				};

				/**
				 * pointer up
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 * @private
				 */
				proto._pointerUp = function (event, pointer) {
					this._pointerDone();
					this.pointerUp(event, pointer);
				};

				// public
				proto.pointerUp = function (event, pointer) {
					this.emitEvent("pointerUp", [event, pointer]);
				};

				// ----- pointer done ----- //

				// triggered on pointer up & pointer cancel
				proto._pointerDone = function () {
					this._pointerReset();
					this._unbindPostStartEvents();
					this.pointerDone();
				};

				proto._pointerReset = function () {
					// reset properties
					this.isPointerDown = false;
					delete this.pointerIdentifier;
				};

				proto.pointerDone = noop;

				// ----- pointer cancel ----- //

				proto.onpointercancel = function (event) {
					if (event.pointerId == this.pointerIdentifier) {
						this._pointerCancel(event, event);
					}
				};

				proto.ontouchcancel = function (event) {
					var touch = this.getTouch(event.changedTouches);
					if (touch) {
						this._pointerCancel(event, touch);
					}
				};

				/**
				 * pointer cancel
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 * @private
				 */
				proto._pointerCancel = function (event, pointer) {
					this._pointerDone();
					this.pointerCancel(event, pointer);
				};

				// public
				proto.pointerCancel = function (event, pointer) {
					this.emitEvent("pointerCancel", [event, pointer]);
				};

				// -----  ----- //

				// utility function for getting x/y coords from event
				Unipointer.getPointerPoint = function (pointer) {
					return {
						x: pointer.pageX,
						y: pointer.pageY,
					};
				};

				// -----  ----- //

				return Unipointer;
			});

			/***/
		},

		/***/ 529: /***/ function (module, exports) {
			var __WEBPACK_AMD_DEFINE_FACTORY__,
				__WEBPACK_AMD_DEFINE_ARRAY__,
				__WEBPACK_AMD_DEFINE_RESULT__;
			(function (global, factory) {
				if (true) {
					!((__WEBPACK_AMD_DEFINE_ARRAY__ = [exports]),
					(__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
					(__WEBPACK_AMD_DEFINE_RESULT__ =
						typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
							? __WEBPACK_AMD_DEFINE_FACTORY__.apply(
									exports,
									__WEBPACK_AMD_DEFINE_ARRAY__
							  )
							: __WEBPACK_AMD_DEFINE_FACTORY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
						(module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
				} else {
					var mod;
				}
			})(this, function (exports) {
				"use strict";

				Object.defineProperty(exports, "__esModule", {
					value: true,
				});

				function _classCallCheck(instance, Constructor) {
					if (!(instance instanceof Constructor)) {
						throw new TypeError("Cannot call a class as a function");
					}
				}

				var _createClass = (function () {
					function defineProperties(target, props) {
						for (var i = 0; i < props.length; i++) {
							var descriptor = props[i];
							descriptor.enumerable = descriptor.enumerable || false;
							descriptor.configurable = true;
							if ("value" in descriptor) descriptor.writable = true;
							Object.defineProperty(target, descriptor.key, descriptor);
						}
					}

					return function (Constructor, protoProps, staticProps) {
						if (protoProps) defineProperties(Constructor.prototype, protoProps);
						if (staticProps) defineProperties(Constructor, staticProps);
						return Constructor;
					};
				})();

				var _extends =
					Object.assign ||
					function (target) {
						for (var i = 1; i < arguments.length; i++) {
							var source = arguments[i];

							for (var key in source) {
								if (Object.prototype.hasOwnProperty.call(source, key)) {
									target[key] = source[key];
								}
							}
						}

						return target;
					};

				var defaults = {
					modal: ".modal",
					modalInner: ".modal-inner",
					modalContent: ".modal-content",
					open: "[data-modal-open]",
					close: "[data-modal-close]",
					page: "body",
					class: "modal-visible",
					loadClass: "vanilla-modal",
					clickOutside: true,
					closeKeys: [27],
					transitions: true,
					transitionEnd: null,
					onBeforeOpen: null,
					onBeforeClose: null,
					onOpen: null,
					onClose: null,
				};

				function throwError(message) {
					// eslint-disable-next-line no-console
					console.error("VanillaModal: " + message);
				}

				function find(arr, callback) {
					return function (key) {
						var filteredArray = arr.filter(callback);
						return filteredArray[0] ? filteredArray[0][key] : undefined;
					};
				}

				function transitionEndVendorSniff() {
					var el = document.createElement("div");
					var transitions = [
						{ key: "transition", value: "transitionend" },
						{ key: "OTransition", value: "otransitionend" },
						{ key: "MozTransition", value: "transitionend" },
						{ key: "WebkitTransition", value: "webkitTransitionEnd" },
					];
					return find(transitions, function (_ref) {
						var key = _ref.key;
						return typeof el.style[key] !== "undefined";
					})("value");
				}

				function isPopulatedArray(arr) {
					return (
						Object.prototype.toString.call(arr) === "[object Array]" &&
						arr.length
					);
				}

				function getNode(selector, parent) {
					var targetNode = parent || document;
					var node = targetNode.querySelector(selector);
					if (!node) {
						throwError(selector + " not found in document.");
					}
					return node;
				}

				function addClass(el, className) {
					if (!(el instanceof HTMLElement)) {
						throwError("Not a valid HTML element.");
					}
					el.setAttribute(
						"class",
						el.className
							.split(" ")
							.filter(function (cn) {
								return cn !== className;
							})
							.concat(className)
							.join(" ")
					);
				}

				function removeClass(el, className) {
					if (!(el instanceof HTMLElement)) {
						throwError("Not a valid HTML element.");
					}
					el.setAttribute(
						"class",
						el.className
							.split(" ")
							.filter(function (cn) {
								return cn !== className;
							})
							.join(" ")
					);
				}

				function getElementContext(e) {
					if (e && typeof e.hash === "string") {
						return document.querySelector(e.hash);
					} else if (typeof e === "string") {
						return document.querySelector(e);
					}
					throwError("No selector supplied to open()");
					return null;
				}

				function applyUserSettings(settings) {
					return _extends({}, defaults, settings, {
						transitionEnd: transitionEndVendorSniff(),
					});
				}

				function matches(e, selector) {
					var allMatches = (
						e.target.document || e.target.ownerDocument
					).querySelectorAll(selector);
					for (var i = 0; i < allMatches.length; i += 1) {
						var node = e.target;
						while (node && node !== document.body) {
							if (node === allMatches[i]) {
								return node;
							}
							node = node.parentNode;
						}
					}
					return null;
				}

				var VanillaModal = (function () {
					function VanillaModal(settings) {
						_classCallCheck(this, VanillaModal);

						this.isOpen = false;
						this.current = null;
						this.isListening = false;

						this.settings = applyUserSettings(settings);
						this.dom = this.getDomNodes();

						this.open = this.open.bind(this);
						this.close = this.close.bind(this);
						this.closeKeyHandler = this.closeKeyHandler.bind(this);
						this.outsideClickHandler = this.outsideClickHandler.bind(this);
						this.delegateOpen = this.delegateOpen.bind(this);
						this.delegateClose = this.delegateClose.bind(this);
						this.listen = this.listen.bind(this);
						this.destroy = this.destroy.bind(this);

						this.addLoadedCssClass();
						this.listen();
					}

					_createClass(VanillaModal, [
						{
							key: "getDomNodes",
							value: function getDomNodes() {
								var _settings = this.settings,
									modal = _settings.modal,
									page = _settings.page,
									modalInner = _settings.modalInner,
									modalContent = _settings.modalContent;

								return {
									modal: getNode(modal),
									page: getNode(page),
									modalInner: getNode(modalInner, getNode(modal)),
									modalContent: getNode(modalContent, getNode(modal)),
								};
							},
						},
						{
							key: "addLoadedCssClass",
							value: function addLoadedCssClass() {
								addClass(this.dom.page, this.settings.loadClass);
							},
						},
						{
							key: "setOpenId",
							value: function setOpenId(id) {
								var page = this.dom.page;

								page.setAttribute("data-current-modal", id || "anonymous");
							},
						},
						{
							key: "removeOpenId",
							value: function removeOpenId() {
								var page = this.dom.page;

								page.removeAttribute("data-current-modal");
							},
						},
						{
							key: "open",
							value: function open(allMatches, e) {
								var page = this.dom.page;
								var _settings2 = this.settings,
									onBeforeOpen = _settings2.onBeforeOpen,
									onOpen = _settings2.onOpen;

								if (!(this.current instanceof HTMLElement === false)) {
									throwError("VanillaModal target must exist on page.");
									return;
								}
								this.releaseNode(this.current);
								this.current = getElementContext(allMatches);
								if (typeof onBeforeOpen === "function") {
									onBeforeOpen.call(this, e);
								}
								this.captureNode(this.current);
								addClass(page, this.settings.class);
								this.setOpenId(this.current.id);
								this.isOpen = true;
								if (typeof onOpen === "function") {
									onOpen.call(this, e);
								}
							},
						},
						{
							key: "detectTransition",
							value: function detectTransition() {
								var modal = this.dom.modal;

								var css = window.getComputedStyle(modal, null);
								return Boolean(
									[
										"transitionDuration",
										"oTransitionDuration",
										"MozTransitionDuration",
										"webkitTransitionDuration",
									].filter(function (i) {
										return typeof css[i] === "string" && parseFloat(css[i]) > 0;
									}).length
								);
							},
						},
						{
							key: "close",
							value: function close(e) {
								var _settings3 = this.settings,
									transitions = _settings3.transitions,
									transitionEnd = _settings3.transitionEnd,
									onBeforeClose = _settings3.onBeforeClose;

								var hasTransition = this.detectTransition();
								if (this.isOpen) {
									this.isOpen = false;
									if (typeof onBeforeClose === "function") {
										onBeforeClose.call(this, e);
									}
									removeClass(this.dom.page, this.settings.class);
									if (transitions && transitionEnd && hasTransition) {
										this.closeModalWithTransition(e);
									} else {
										this.closeModal(e);
									}
								}
							},
						},
						{
							key: "closeModal",
							value: function closeModal(e) {
								var onClose = this.settings.onClose;

								this.removeOpenId(this.dom.page);
								this.releaseNode(this.current);
								this.isOpen = false;
								this.current = null;
								if (typeof onClose === "function") {
									onClose.call(this, e);
								}
							},
						},
						{
							key: "closeModalWithTransition",
							value: function closeModalWithTransition(e) {
								var _this = this;

								var modal = this.dom.modal;
								var transitionEnd = this.settings.transitionEnd;

								var closeTransitionHandler = function closeTransitionHandler() {
									modal.removeEventListener(
										transitionEnd,
										closeTransitionHandler
									);
									_this.closeModal(e);
								};
								modal.addEventListener(transitionEnd, closeTransitionHandler);
							},
						},
						{
							key: "captureNode",
							value: function captureNode(node) {
								var modalContent = this.dom.modalContent;

								while (node.childNodes.length) {
									modalContent.appendChild(node.childNodes[0]);
								}
							},
						},
						{
							key: "releaseNode",
							value: function releaseNode(node) {
								var modalContent = this.dom.modalContent;

								while (modalContent.childNodes.length) {
									node.appendChild(modalContent.childNodes[0]);
								}
							},
						},
						{
							key: "closeKeyHandler",
							value: function closeKeyHandler(e) {
								var closeKeys = this.settings.closeKeys;

								if (
									isPopulatedArray(closeKeys) &&
									closeKeys.indexOf(e.which) > -1 &&
									this.isOpen === true
								) {
									e.preventDefault();
									this.close(e);
								}
							},
						},
						{
							key: "outsideClickHandler",
							value: function outsideClickHandler(e) {
								var clickOutside = this.settings.clickOutside;
								var modalInner = this.dom.modalInner;

								if (clickOutside) {
									var node = e.target;
									while (node && node !== document.body) {
										if (node === modalInner) {
											return;
										}
										node = node.parentNode;
									}
									this.close(e);
								}
							},
						},
						{
							key: "delegateOpen",
							value: function delegateOpen(e) {
								var open = this.settings.open;

								var matchedNode = matches(e, open);
								if (matchedNode) {
									e.preventDefault();
									this.open(matchedNode, e);
								}
							},
						},
						{
							key: "delegateClose",
							value: function delegateClose(e) {
								var close = this.settings.close;

								if (matches(e, close)) {
									e.preventDefault();
									this.close(e);
								}
							},
						},
						{
							key: "listen",
							value: function listen() {
								var modal = this.dom.modal;

								if (!this.isListening) {
									modal.addEventListener(
										"click",
										this.outsideClickHandler,
										false
									);
									document.addEventListener(
										"keydown",
										this.closeKeyHandler,
										false
									);
									document.addEventListener("click", this.delegateOpen, false);
									document.addEventListener("click", this.delegateClose, false);
									this.isListening = true;
								} else {
									throwError("Event listeners already applied.");
								}
							},
						},
						{
							key: "destroy",
							value: function destroy() {
								var modal = this.dom.modal;

								if (this.isListening) {
									this.close();
									modal.removeEventListener("click", this.outsideClickHandler);
									document.removeEventListener("keydown", this.closeKeyHandler);
									document.removeEventListener("click", this.delegateOpen);
									document.removeEventListener("click", this.delegateClose);
									this.isListening = false;
								} else {
									throwError("Event listeners already removed.");
								}
							},
						},
					]);

					return VanillaModal;
				})();

				exports.default = VanillaModal;
			});

			/***/
		},

		/******/
	};
	/************************************************************************/
	/******/ // The module cache
	/******/ var __webpack_module_cache__ = {};
	/******/
	/******/ // The require function
	/******/ function __webpack_require__(moduleId) {
		/******/ // Check if module is in cache
		/******/ if (__webpack_module_cache__[moduleId]) {
			/******/ return __webpack_module_cache__[moduleId].exports;
			/******/
		}
		/******/ // Create a new module (and put it into the cache)
		/******/ var module = (__webpack_module_cache__[moduleId] = {
			/******/ // no module.id needed
			/******/ // no module.loaded needed
			/******/ exports: {},
			/******/
		});
		/******/
		/******/ // Execute the module function
		/******/ __webpack_modules__[moduleId].call(
			module.exports,
			module,
			module.exports,
			__webpack_require__
		);
		/******/
		/******/ // Return the exports of the module
		/******/ return module.exports;
		/******/
	}
	/******/
	/************************************************************************/
	/******/ /* webpack/runtime/compat get default export */
	/******/ (() => {
		/******/ // getDefaultExport function for compatibility with non-harmony modules
		/******/ __webpack_require__.n = (module) => {
			/******/ var getter =
				module && module.__esModule
					? /******/ () => module["default"]
					: /******/ () => module;
			/******/ __webpack_require__.d(getter, { a: getter });
			/******/ return getter;
			/******/
		};
		/******/
	})();
	/******/
	/******/ /* webpack/runtime/define property getters */
	/******/ (() => {
		/******/ // define getter functions for harmony exports
		/******/ __webpack_require__.d = (exports, definition) => {
			/******/ for (var key in definition) {
				/******/ if (
					__webpack_require__.o(definition, key) &&
					!__webpack_require__.o(exports, key)
				) {
					/******/ Object.defineProperty(exports, key, {
						enumerable: true,
						get: definition[key],
					});
					/******/
				}
				/******/
			}
			/******/
		};
		/******/
	})();
	/******/
	/******/ /* webpack/runtime/global */
	/******/ (() => {
		/******/ __webpack_require__.g = (function () {
			/******/ if (typeof globalThis === "object") return globalThis;
			/******/ try {
				/******/ return this || new Function("return this")();
				/******/
			} catch (e) {
				/******/ if (typeof window === "object") return window;
				/******/
			}
			/******/
		})();
		/******/
	})();
	/******/
	/******/ /* webpack/runtime/hasOwnProperty shorthand */
	/******/ (() => {
		/******/ __webpack_require__.o = (obj, prop) =>
			Object.prototype.hasOwnProperty.call(obj, prop);
		/******/
	})();
	/******/
	/************************************************************************/
	(() => {
		(function (n, v) {
			// eslint-disable-next-line max-len
			if (
				window.Shopify &&
				window.Shopify.theme &&
				navigator &&
				navigator.sendBeacon &&
				window.Shopify.designMode
			) {
				if (sessionStorage.getItem("oots_beacon")) return;

				navigator.sendBeacon(
					"https://app.outofthesandbox.com/beacon",
					new URLSearchParams({
						shop_domain: window.Shopify.shop,
						shop_id: window.Store.id,
						theme_name: n,
						theme_version: v,
						theme_store_id: window.Shopify.theme.theme_store_id,
						theme_id: window.Shopify.theme.id,
						theme_role: window.Shopify.theme.role,
					})
				);

				sessionStorage.setItem("oots_beacon", "");
			}
		})("empire", "9.1.1");
	})();

	(() => {
		"use strict";

		// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
		var jquery = __webpack_require__(755);
		var jquery_default = /*#__PURE__*/ __webpack_require__.n(jquery); // CONCATENATED MODULE: ./source/scripts/globals/jquery.js
		// jQuery plugins expect to find a global `jQuery` object, so we
		// need to attach it to the window.
		//
		// This is in its own file because we have to attach it before any
		// other imports happen, but with ES6 modules, all `import`s have
		// to be at the top.

		window.jQuery = jquery_default();
		window.$ = jquery_default();
		// EXTERNAL MODULE: ./node_modules/jquery-trend/jquery.trend.js
		var jquery_trend = __webpack_require__(72);
		// EXTERNAL MODULE: ./node_modules/jquery-revealer/jquery.revealer.js
		var jquery_revealer = __webpack_require__(220);
		// EXTERNAL MODULE: ./node_modules/scriptjs/dist/script.js
		var script = __webpack_require__(277);
		var script_default = /*#__PURE__*/ __webpack_require__.n(script); // CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-map/dist/index.es.js
		/*!
		 * @pixelunion/pxs-map v3.1.0
		 * (c) 2023 Pixel Union
		 */

		function _classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function _toConsumableArray(arr) {
			return (
				_arrayWithoutHoles(arr) ||
				_iterableToArray(arr) ||
				_unsupportedIterableToArray(arr) ||
				_nonIterableSpread()
			);
		}

		function _arrayWithoutHoles(arr) {
			if (Array.isArray(arr)) return _arrayLikeToArray(arr);
		}

		function _iterableToArray(iter) {
			if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter))
				return Array.from(iter);
		}

		function _unsupportedIterableToArray(o, minLen) {
			if (!o) return;
			if (typeof o === "string") return _arrayLikeToArray(o, minLen);
			var n = Object.prototype.toString.call(o).slice(8, -1);
			if (n === "Object" && o.constructor) n = o.constructor.name;
			if (n === "Map" || n === "Set") return Array.from(n);
			if (
				n === "Arguments" ||
				/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
			)
				return _arrayLikeToArray(o, minLen);
		}

		function _arrayLikeToArray(arr, len) {
			if (len == null || len > arr.length) len = arr.length;

			for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

			return arr2;
		}

		function _nonIterableSpread() {
			throw new TypeError(
				"Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
			);
		}

		/*
		 * Function to convert any given latitude and longitude format to decimal degrees
		 */
		function getDecimalDegrees() {
			var firstComponent =
				arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
			var secondComponent =
				arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
			var thirdComponent =
				arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
			var fourthComponent =
				arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
			var directions = {
				N: 1,
				E: 1,
				S: -1,
				W: -1,
			};
			var decimalDegrees = 0.0;
			var components = [
				firstComponent,
				secondComponent,
				thirdComponent,
				fourthComponent,
			];

			for (var i = 0; i < components.length; i++) {
				var component = components[i];

				if (component) {
					if (Number.isNaN(parseFloat(component))) {
						decimalDegrees *= directions[component];
					} else {
						decimalDegrees += parseFloat(component) / Math.pow(60, i);
					}
				}
			}

			return decimalDegrees;
		}
		/*
		 * By providing the ability to use a place name, or latitude and longitude coordinates
		 * we give merchants, and our demo stores the option to bypass the Geocoding API.
		 * The Geocoding API (https://developers.google.com/maps/documentation/geocoding/usage-and-billing) allows us
		 * to take a place name and convert it to latitude and longitude expressed in decimal degrees.
		 */

		function getLatitudeLongitude(address) {
			// Degrees, Minutes and Seconds: DDD° MM' SS.S"
			var latLongDegreesMinutesSeconds =
				/^([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2})(?:'[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:"[ ]?| )?(N|E|S|W) ?([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2})(?:'[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:"[ ]?| )?(N|E|S|W)$/g; // Degrees and Decimal Minutes: DDD° MM.MMM'

			var latLongDegreesMinutes =
				/^([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:'[ ]?| )?(N|E|S|W) ?([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:'[ ]?| )?(N|E|S|W)$/g; // Decimal Degrees: DDD.DDDDD°

			var latLongDegrees =
				/^([-|+]?[0-9]{1,3}(?:\.[0-9]+)?)(?:°[ ]?| )?(N|E|S|W)?,? ?([-|+]?[0-9]{1,3}(?:\.[0-9]+)?)(?:°[ ]?| )?(N|E|S|W)?$/g;
			var latLongFormats = [
				latLongDegreesMinutesSeconds,
				latLongDegreesMinutes,
				latLongDegrees,
			];
			var latLongMatches = latLongFormats.map(function (latLongFormat) {
				return address.match(latLongFormat);
			});
			/*
			 * Select the first latitude and longitude format that is matched.
			 * Ordering:
			 *   1. Degrees, minutes, and seconds,
			 *   2. Degrees, and decimal minutes,
			 *   3. Decimal degrees.
			 */

			var latLongMatch = latLongMatches.reduce(function (
				accumulator,
				value,
				index
			) {
				if (!accumulator && value) {
					var latLongResult = latLongFormats[index].exec(address);
					var lat = latLongResult.slice(1, latLongResult.length / 2 + 1);
					var lng = latLongResult.slice(
						latLongResult.length / 2 + 1,
						latLongResult.length
					);
					return {
						lat: lat,
						lng: lng,
					};
				}

				return accumulator;
			},
			null);
			return new Promise(function (resolve, reject) {
				// If we've got a match on latitude and longitude, use that and avoid geocoding
				if (latLongMatch) {
					var latDecimalDegrees = getDecimalDegrees.apply(
						void 0,
						_toConsumableArray(latLongMatch.lat)
					);
					var longDecimalDegrees = getDecimalDegrees.apply(
						void 0,
						_toConsumableArray(latLongMatch.lng)
					);
					resolve({
						lat: latDecimalDegrees,
						lng: longDecimalDegrees,
					});
				} else {
					// Otherwise, geocode the assumed address
					var geocoder = new google.maps.Geocoder();
					geocoder.geocode(
						{
							address: address,
						},
						function (results, status) {
							if (status !== google.maps.GeocoderStatus.OK || !results[0]) {
								reject(status);
							} else {
								resolve(results[0].geometry.location);
							}
						}
					);
				}
			});
		}

		function getMapStyles(colors) {
			if (!colors) {
				return [];
			}

			return [
				{
					elementType: "geometry",
					stylers: [
						{
							color: colors.e,
						},
					],
				},
				{
					elementType: "labels.icon",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					elementType: "labels.text.fill",
					stylers: [
						{
							color: colors.a,
						},
					],
				},
				{
					elementType: "labels.text.stroke",
					stylers: [
						{
							color: colors.e,
						},
					],
				},
				{
					featureType: "administrative",
					elementType: "geometry",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "administrative.country",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "administrative.land_parcel",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "administrative.neighborhood",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "administrative.locality",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "poi",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "road",
					elementType: "geometry.fill",
					stylers: [
						{
							color: colors.d,
						},
					],
				},
				{
					featureType: "road",
					elementType: "labels.icon",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "road.arterial",
					elementType: "geometry",
					stylers: [
						{
							color: colors.c,
						},
					],
				},
				{
					featureType: "road.highway",
					elementType: "geometry",
					stylers: [
						{
							color: colors.b,
						},
					],
				},
				{
					featureType: "road.highway.controlled_access",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "road.local",
					elementType: "labels.text.fill",
					stylers: [
						{
							color: colors.b,
						},
					],
				},
				{
					featureType: "road.local",
					elementType: "labels.text.stroke",
					stylers: [
						{
							color: colors.e,
						},
					],
				},
				{
					featureType: "transit",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "water",
					elementType: "geometry",
					stylers: [
						{
							color: colors.f,
						},
					],
				},
			];
		}

		function createMap(options) {
			var container = options.container,
				address = options.address,
				zoom = options.zoom,
				colors = options.colors;
			return getLatitudeLongitude(address)
				.then(function (latLong) {
					var map = new google.maps.Map(container, {
						center: latLong,
						clickableIcons: false,
						disableDefaultUI: true,
						disableDoubleClickZoom: true,
						gestureHandling: "none",
						keyboardShortcuts: false,
						maxZoom: zoom,
						minZoom: zoom,
						scrollWheel: false,
						styles: getMapStyles(colors),
						zoom: zoom,
						zoomControl: false,
					});
					new google.maps.Marker({
						clickable: false,
						map: map,
						position: map.getCenter(),
					});
					map.panBy(0, 0);
				})
				["catch"](function (status) {
					var usageLimits =
						"https://developers.google.com/maps/faq#usagelimits";
					var errorMessage;

					switch (status) {
						case "ZERO_RESULTS":
							errorMessage = "<p>Unable to find the address:</p> ".concat(
								address
							);
							break;

						case "OVER_QUERY_LIMIT":
							errorMessage =
								'\n            <p>Unable to load Google Maps, you have reached your usage limit.</p>\n            <p>\n              Please visit\n              <a href="'
									.concat(usageLimits, '" target="_blank">')
									.concat(
										usageLimits,
										"</a>\n              for more details.\n            </p>\n          "
									);
							break;

						default:
							errorMessage = "Unable to load Google Maps.";
							break;
					}

					throw errorMessage;
				});
		}

		function displayErrorInThemeEditor(container, errorMessage) {
			var isThemeEditor = window.Shopify && window.Shopify.designMode;

			if (!isThemeEditor) {
				return;
			}

			container.innerHTML = '<div class="map-error-message">'.concat(
				errorMessage,
				"</div>"
			);
		}

		var PxsMap = function PxsMap(section) {
			var _this = this;

			_classCallCheck(this, PxsMap);

			this.map = null;
			var el = section.el.querySelector("[data-map]");
			var container = el.querySelector("[data-map-container]");
			var settings = section.data;
			var address = settings.address,
				colors = settings.colors;
			var apiKey = settings.api_key; // Scale so range is 12 ~ 17, rather than 1 to 6

			var zoom = Number.isNaN(settings.zoom)
				? 13
				: 11 + parseInt(settings.zoom, 10);

			if (apiKey) {
				if (window.googleMaps === undefined) {
					script_default()(
						"https://maps.googleapis.com/maps/api/js?key=".concat(apiKey),
						function () {
							window.googleMaps = true;
							createMap({
								container: container,
								address: address,
								zoom: zoom,
								colors: colors,
							})
								.then(function (map) {
									_this.map = map;
								})
								["catch"](function (error) {
									return displayErrorInThemeEditor(container, error);
								});
						}
					);
				} else {
					createMap({
						container: container,
						address: address,
						zoom: zoom,
						colors: colors,
					})
						.then(function (map) {
							_this.map = map;
						})
						["catch"](function (error) {
							return displayErrorInThemeEditor(container, error);
						});
				}
			}
		};

		/* harmony default export */ const index_es = PxsMap; // CONCATENATED MODULE: ./node_modules/@pixelunion/age-gate/dist/index.es.js

		/*!
		 * @pixelunion/age-gate v1.1.0
		 * (c) 2023 Pixel Union
		 */

		function index_es_classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}
		function _defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}
		function _createClass(Constructor, protoProps, staticProps) {
			if (protoProps) _defineProperties(Constructor.prototype, protoProps);
			if (staticProps) _defineProperties(Constructor, staticProps);
			Object.defineProperty(Constructor, "prototype", {
				writable: false,
			});
			return Constructor;
		}

		var scrollLock = __webpack_require__(265);
		var isbot = __webpack_require__(458);
		function getAge(birthdate) {
			var today = new Date();
			var age = today.getFullYear() - birthdate.getFullYear();
			var m = today.getMonth() - birthdate.getMonth();
			if (m < 0 || (m === 0 && today.getDate() < birthdate.getDate())) {
				age--;
			}
			return age;
		}
		var SiteAgeGate = /*#__PURE__*/ (function () {
			function SiteAgeGate(el) {
				index_es_classCallCheck(this, SiteAgeGate);
				this._el = el;
				this._ageGateForm = el.querySelector("[data-age-gate]");
				this._ageGateErrorEl = this._ageGateForm.querySelector(
					"[data-age-gate-error]"
				);
				this._requiredAge = this._ageGateForm.dataset.requiredAge;
				this._el.addEventListener("age-gate:open", this._open.bind(this));
				this._el.addEventListener("age-gate:close", this._close.bind(this));
				this._ageGateForm.addEventListener(
					"submit",
					this._onFormSubmit.bind(this)
				);
				if (isbot(navigator.userAgent)) {
					this._close();
				} else if (this._el.style.display === "") {
					this._open();
				}
			}
			_createClass(SiteAgeGate, [
				{
					key: "_open",
					value: function _open() {
						scrollLock.disablePageScroll();
						this._el.style.display = "";
					},
				},
				{
					key: "_close",
					value: function _close() {
						scrollLock.enablePageScroll();
						this._el.style.display = "none";
					},
				},
				{
					key: "_onFormSubmit",
					value: function _onFormSubmit(event) {
						event.preventDefault();
						event.stopPropagation();
						var data = new FormData(event.target);
						var day = data.get("day");
						var month = data.get("month");
						var year = data.get("year");
						if (day === "" || month === "" || year === "") return;
						var age = getAge(new Date(year, month, day));
						if (age >= this._requiredAge) {
							this._close();
							sessionStorage.setItem("age-gate", age);
						} else {
							this._ageGateErrorEl.style.display = "";
						}
					},
				},
			]);
			return SiteAgeGate;
		})();

		var PageAgeGate = /*#__PURE__*/ (function () {
			function PageAgeGate() {
				index_es_classCallCheck(this, PageAgeGate);
				this._ageGateEl = document.getElementById("age-gate-page");
			}
			_createClass(PageAgeGate, [
				{
					key: "onSectionLoad",
					value: function onSectionLoad() {
						var openEvent = new CustomEvent("age-gate:open");
						this._ageGateEl.dispatchEvent(openEvent);
					},
				},
				{
					key: "onSectionSelect",
					value: function onSectionSelect() {
						var openEvent = new CustomEvent("age-gate:open");
						this._ageGateEl.dispatchEvent(openEvent);
					},
				},
				{
					key: "onSectionDeselect",
					value: function onSectionDeselect() {
						var closeEvent = new CustomEvent("age-gate:close");
						this._ageGateEl.dispatchEvent(closeEvent);
					},
				},
			]);
			return PageAgeGate;
		})(); // CONCATENATED MODULE: ./node_modules/@pixelunion/rimg-shopify/dist/index.es.js

		/*!
		 * @pixelunion/rimg-shopify v2.7.1
		 * (c) 2023 Pixel Union
		 */
		/*!
		 * @pixelunion/rimg v2.2.2
		 * (c) 2022 Pixel Union
		 */

		/**
		 * The default template render function. Turns a template string into an image
		 * URL.
		 *
		 * @param {String} template
		 * @param {Size} size
		 * @returns {String}
		 */
		function defaultTemplateRender(template, size) {
			return template.replace(
				"{size}",
				"".concat(size.width, "x").concat(size.height)
			);
		}
		/**
		 * @type Settings
		 */

		var defaults = {
			scale: 1,
			template: false,
			templateRender: defaultTemplateRender,
			max: {
				width: Infinity,
				height: Infinity,
			},
			round: 32,
			placeholder: false,
			crop: null,
		};
		/**
		 * Get a data attribute value from an element, with a default fallback and
		 * sanitization step.
		 *
		 * @param {Element} el
		 *
		 * @param {String} name
		 *        The data attribute name.
		 *
		 * @param {Object} options
		 *        An object holding fallback values if the data attribute does not
		 *        exist. If this object doesn't have the property, we further fallback
		 *        to our defaults.
		 *
		 * @param {Function} [sanitize]
		 *        A function to sanitize the data attribute value with.
		 *
		 * @returns {String|*}
		 */

		function getData(el, name, options, sanitize) {
			var attr = "data-rimg-".concat(name);
			if (!el.hasAttribute(attr)) return options[name] || defaults[name];
			var value = el.getAttribute(attr);
			return sanitize ? sanitize(value) : value;
		}
		/**
		 * Sanitize data attributes that represent a size (in the form of `10x10`).
		 *
		 * @param {String} value
		 * @returns {Object} An object with `width` and `height` properties.
		 */

		function parseSize(value) {
			value = value.split("x");
			return {
				width: parseInt(value[0], 10),
				height: parseInt(value[1], 10),
			};
		}
		/**
		 * Sanitize crop values to ensure they are valid, or null
		 *
		 * @param {String} value
		 * @returns {Object} Shopify crop parameter ('top', 'center', 'bottom', 'left', 'right') or null, if an unsupported value is found
		 */

		function processCropValue(value) {
			switch (value) {
				case "top":
				case "center":
				case "bottom":
				case "left":
				case "right":
					return value;

				default:
					return null;
			}
		}
		/**
		 * Loads information about an element.
		 *
		 * Options can be set on the element itself using data attributes, or through
		 * the `options` parameter. Data attributes take priority.
		 *
		 * @param {HTMLElement} el
		 * @param {Settings} options
		 * @returns {Item}
		 */

		function parseItem(el) {
			var options =
				arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var isImage = el.hasAttribute("data-rimg-template");
			/**
			 * @typedef {Settings} Item
			 */

			return {
				el: el,
				// Type of element
				isImage: isImage,
				isBackgroundImage: isImage && el.tagName !== "IMG",
				// Image scale
				scale: parseInt(getData(el, "scale", options)),
				// Device density
				density: window.devicePixelRatio || 1,
				// Image template URL
				template: getData(el, "template", options),
				templateRender: options.templateRender || defaults.templateRender,
				// Maximum image dimensions
				max: getData(el, "max", options, parseSize),
				// Round image dimensions to the nearest multiple
				round: getData(el, "round", options),
				// Placeholder image dimensions
				placeholder: getData(el, "placeholder", options, parseSize),
				// Crop value; null if image is uncropped, otherwise equal to the Shopify crop parameter ('center', 'top', etc.)
				crop: getData(el, "crop", options, processCropValue),
			};
		}
		/**
		 * Round to the nearest multiple.
		 *
		 * This is so we don't tax the image server too much.
		 *
		 * @param {Number} size The size, in pixels.
		 * @param {Number} [multiple] The multiple to round to the nearest.
		 * @param {Number} [maxLimit] Maximum allowed value - value to return if rounded multiple is above this limit
		 * @returns {Number}
		 */

		function roundSize(size) {
			var multiple =
				arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
			var maxLimit =
				arguments.length > 2 && arguments[2] !== undefined
					? arguments[2]
					: Infinity;
			return size === 0
				? multiple
				: Math.min(Math.ceil(size / multiple) * multiple, maxLimit);
		}
		/**
		 * Get the size of an element.
		 *
		 * If it is too small, it's parent element is checked, and so on. This helps
		 * avoid the situation where an element doesn't have a size yet or is positioned
		 * out of the layout.
		 *
		 * @param {HTMLElement} el
		 * @return {Object} size
		 * @return {Number} size.width The width, in pixels.
		 * @return {Number} size.height The height, in pixels.
		 */

		function getElementSize(el) {
			var size = {
				width: 0,
				height: 0,
			};

			while (el) {
				size.width = el.offsetWidth;
				size.height = el.offsetHeight;
				if (size.width > 20 && size.height > 20) break;
				el = el.parentNode;
			}

			return size;
		}
		/**
		 * Return the maximum supported density of the image, given the container.
		 *
		 * @param {Item} item
		 * @param {Size} size
		 */

		function supportedDensity(item, size) {
			return Math.min(
				Math.min(Math.max(item.max.width / size.width, 1), item.density),
				Math.min(Math.max(item.max.height / size.height, 1), item.density)
			).toFixed(2);
		}
		/**
		 * Trigger a custom event.
		 *
		 * Note: this approach is deprecated, but still required to support older
		 * browsers such as IE 10.
		 *
		 * @see https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
		 *
		 * @param {HTMLElement} el
		 *        The element to trigger the event on.
		 *
		 * @param {String} name
		 *        The event name.
		 *
		 * @returns {Boolean}
		 *          True if the event was canceled.
		 */

		function trigger(el, name) {
			var event = document.createEvent("Event");
			event.initEvent(name, true, true);
			return !el.dispatchEvent(event);
		}
		/**
		 * Set the image URL on the element. Supports background images and `srcset`.
		 *
		 * @param {Item} item
		 * @param {Size} size
		 * @param {Boolean} isPlaceholder
		 */

		function setImage(item, size, isPlaceholder, onLoad) {
			var render = item.templateRender;
			var density = isPlaceholder ? 1 : supportedDensity(item, size);
			var round = isPlaceholder ? 1 : item.round; // Calculate the final display size, taking into account the image's
			// maximum dimensions.

			var targetWidth = size.width * density;
			var targetHeight = size.height * density;
			var displaySize;

			if (item.crop) {
				displaySize = {
					width: roundSize(targetWidth, round, item.max.width),
					height: roundSize(targetHeight, round, item.max.height),
				};
			} else {
				// Shopify serves images clamped by the requested dimensions (fitted to the smallest dimension).
				// To get the desired and expected pixel density we need to request cover dimensions (fitted to largest dimension).
				// This isn't a problem with cropped images which are served at the exact dimension requested.
				var containerAspectRatio = size.width / size.height;
				var imageAspectRatio = item.max.width / item.max.height;

				if (containerAspectRatio > imageAspectRatio) {
					// fit width
					displaySize = {
						width: roundSize(targetWidth, round, item.max.width),
						height: roundSize(
							targetWidth / imageAspectRatio,
							round,
							item.max.height
						),
					};
				} else {
					// fit height
					displaySize = {
						width: roundSize(
							targetHeight * imageAspectRatio,
							round,
							item.max.width
						),
						height: roundSize(targetHeight, round, item.max.height),
					};
				}
			}

			var url = render(item.template, displaySize); // On load callback

			var image = new Image();
			image.onload = onLoad;
			image.src = url; // Set image

			if (item.isBackgroundImage) {
				item.el.style.backgroundImage = "url('".concat(url, "')");
			} else {
				item.el.setAttribute(
					"srcset",
					"".concat(url, " ").concat(density, "x")
				);
			}
		}
		/**
		 * Load the image, set loaded status, and trigger the load event.
		 *
		 * @fires rimg:load
		 * @fires rimg:error
		 * @param {Item} item
		 * @param {Size} size
		 */

		function loadFullImage(item, size) {
			var el = item.el;
			setImage(item, size, false, function (event) {
				if (event.type === "load") {
					el.setAttribute("data-rimg", "loaded");
				} else {
					el.setAttribute("data-rimg", "error");
					trigger(el, "rimg:error");
				}

				trigger(el, "rimg:load");
			});
		}
		/**
		 * Load in a responsive image.
		 *
		 * Sets the image's `srcset` attribute to the final image URLs, calculated based
		 * on the actual size the image is being shown at.
		 *
		 * @fires rimg:loading
		 *        The image URLs have been set and we are waiting for them to load.
		 *
		 * @fires rimg:loaded
		 *        The final image has loaded.
		 *
		 * @fires rimg:error
		 *        The final image failed loading.
		 *
		 * @param {Item} item
		 */

		function loadImage(item) {
			var el = item.el; // Already loaded?

			var status = el.getAttribute("data-rimg");
			if (status === "loading" || status === "loaded") return; // Is the SVG loaded?
			// In Firefox, el.complete always returns true [citation needed, may not be the case anymore, Jan/2022]
			// so we also check el.naturalWidth, which equals 0 until the image loads

			if (!item.isBackgroundImage) {
				if (el.naturalWidth === 0 || !el.complete) {
					// Wait for the load event, then call load image
					el.addEventListener("load", function cb() {
						el.removeEventListener("load", cb);
						loadImage(item);
					});
					return;
				}
			} // Trigger loading event, and stop if cancelled

			if (trigger(el, "rimg:loading")) return; // Mark as loading

			el.setAttribute("data-rimg", "loading"); // Get element size. This is used as the ideal display size.

			var size = getElementSize(item.el);
			size.width *= item.scale;
			size.height *= item.scale;

			if (item.placeholder) {
				// Load a placeholder image first, followed by the full image. Force the
				// element to keep its dimensions while it loads. If the image is smaller
				// than the element size, use the image's size. Density is taken into account
				// for HiDPI devices to avoid blurry images.
				if (!item.isBackgroundImage) {
					el.setAttribute(
						"width",
						Math.min(Math.floor(item.max.width / item.density), size.width)
					);
					el.setAttribute(
						"height",
						Math.min(Math.floor(item.max.height / item.density), size.height)
					);
				}

				setImage(item, item.placeholder, true, function () {
					return loadFullImage(item, size);
				});
			} else {
				loadFullImage(item, size);
			}
		}
		/**
		 * Prepare an element to be displayed on the screen.
		 *
		 * Images have special logic applied to them to swap out the different sources.
		 *
		 * @fires rimg:enter
		 *        The element is entering the viewport.
		 *
		 * @param {HTMLElement} el
		 * @param {Settings} options
		 */

		function load(el, options) {
			if (!el) return;
			trigger(el, "rimg:enter");
			var item = parseItem(el, options);

			if (item.isImage) {
				if (!item.isBackgroundImage) {
					el.setAttribute("data-rimg-template-svg", el.getAttribute("srcset"));
				}

				loadImage(item);
			}
		}
		/**
		 * Reset an element's state so that its image can be recalculated.
		 *
		 * @fires rimg:update
		 *        The element is being updated.
		 *
		 * @param {HTMLElement} el
		 * @param {Settings} options
		 */

		function update(el, options) {
			if (!el) return;
			trigger(el, "rimg:update");
			var item = parseItem(el, options);

			if (item.isImage) {
				if (!item.isBackgroundImage) {
					el.setAttribute("data-rimg", "lazy");
					el.setAttribute("srcset", el.getAttribute("data-rimg-template-svg"));
				}

				loadImage(item);
			}
		}
		/**
		 * Returns true if the element is within the viewport.
		 * @param {HTMLElement} el
		 * @returns {Boolean}
		 */

		function inViewport(el) {
			if (!el.offsetWidth || !el.offsetHeight || !el.getClientRects().length) {
				return false;
			}

			var root = document.documentElement;
			var width = Math.min(root.clientWidth, window.innerWidth);
			var height = Math.min(root.clientHeight, window.innerHeight);
			var rect = el.getBoundingClientRect();
			return (
				rect.bottom >= 0 &&
				rect.right >= 0 &&
				rect.top <= height &&
				rect.left <= width
			);
		}
		/**
		 * @typedef {Object} Size
		 * @property {Number} width
		 * @property {Number} height
		 */

		/**
		 * A function to turn a template string into a URL.
		 *
		 * @callback TemplateRenderer
		 * @param {String} template
		 * @param {Size} size
		 * @returns {String}
		 */

		/**
		 * @typedef {Object} Settings
		 *
		 * @property {String} [template]
		 *           A template string used to generate URLs for an image. This allows us to
		 *           dynamically load images with sizes to match the container's size.
		 *
		 * @property {TemplateRenderer} [templateRender]
		 *           A function to turn a template string into a URL.
		 *
		 * @property {Size} [max]
		 *           The maximum available size for the image. This ensures we don't
		 *           try to load an image larger than is possible.
		 *
		 * @property {Number} [scale]
		 *           A number to scale the final image dimensions by.
		 *           Only applies to lazy-loaded images. Defaults to 1.
		 *
		 * @property {Number} [round]
		 *           Round image dimensions to the nearest multiple. This is intended to
		 *           tax the image server less by lowering the number of possible image
		 *           sizes requested.
		 *
		 * @property {Size} [placeholder]
		 *           The size of the lo-fi image to load before the full image.
		 *
		 * @property {String} [crop]
		 *           Crop value; null if image is uncropped, otherwise equal
		 *           to the Shopify crop parameter ('center', 'top', etc.).
		 */

		/**
		 * Initialize the responsive image handler.
		 *
		 * @param {String|HTMLElement|NodeList} selector
		 *        The CSS selector, element, or elements to track for lazy-loading.
		 *
		 * @param {Settings} options
		 *
		 * @returns {PublicApi}
		 */

		function rimg() {
			var selector =
				arguments.length > 0 && arguments[0] !== undefined
					? arguments[0]
					: '[data-rimg="lazy"]';
			var options =
				arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}; // Intersections

			var io = new IntersectionObserver(
				function (entries) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting || entry.intersectionRatio > 0) {
							io.unobserve(entry.target);
							load(entry.target, options);
						}
					});
				},
				{
					// Watch the viewport, with 20% vertical margins
					rootMargin: "20% 0px",
				}
			);
			/**
			 * @typedef {Object} PublicApi
			 */

			var api = {
				/**
				 * Track a new selector, element, or nodelist for lazy-loading.
				 * @type Function
				 * @param {String|HTMLElement|NodeList} selector
				 */
				track: function track() {
					var selector =
						arguments.length > 0 && arguments[0] !== undefined
							? arguments[0]
							: '[data-rimg="lazy"]';
					var els = querySelector(selector);

					for (var i = 0; i < els.length; i++) {
						// If an element is already in the viewport, load it right away. This
						// fixes a race-condition with dynamically added elements.
						if (inViewport(els[i])) {
							load(els[i], options);
						} else {
							io.observe(els[i]);
						}
					}
				},

				/**
				 * Update element(s) that have already been loaded to force their images
				 * to be recalculated.
				 * @type Function
				 * @param {String|HTMLElement|NodeList} selector
				 */
				update: function update$1() {
					var selector =
						arguments.length > 0 && arguments[0] !== undefined
							? arguments[0]
							: '[data-rimg="loaded"]';
					var els = querySelector(selector);

					for (var i = 0; i < els.length; i++) {
						update(els[i], options);
					}
				},

				/**
				 * Stop tracking element(s) for lazy-loading.
				 * @type Function
				 * @param {String|HTMLElement|NodeList} selector
				 */
				untrack: function untrack() {
					var selector =
						arguments.length > 0 && arguments[0] !== undefined
							? arguments[0]
							: "[data-rimg]";
					var els = querySelector(selector);

					for (var i = 0; i < els.length; i++) {
						io.unobserve(els[i]);
					}
				},

				/**
				 * Manually load images.
				 * @type Function
				 * @param {String|HTMLElement|NodeList} selector
				 */
				load: function load$1() {
					var selector =
						arguments.length > 0 && arguments[0] !== undefined
							? arguments[0]
							: "[data-rimg]";
					var els = querySelector(selector);

					for (var i = 0; i < els.length; i++) {
						load(els[i], options);
					}
				},

				/**
				 * Unload all event handlers and observers.
				 * @type Function
				 */
				unload: function unload() {
					io.disconnect();
				},
			}; // Add initial elements

			api.track(selector);
			return api;
		}
		/**
		 * Finds a group of elements on the page.
		 *
		 * @param {String|HTMLElement|NodeList} selector
		 * @returns {Object} An array-like object.
		 */

		function querySelector(selector) {
			if (typeof selector === "string") {
				return document.querySelectorAll(selector);
			}

			if (selector instanceof HTMLElement) {
				return [selector];
			}

			if (selector instanceof NodeList) {
				return selector;
			}

			return [];
		}

		/**
		 * Polyfill for Element.matches().
		 *
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
		 */
		if (!Element.prototype.matches) {
			Element.prototype.matches =
				Element.prototype.matchesSelector ||
				Element.prototype.mozMatchesSelector ||
				Element.prototype.msMatchesSelector ||
				Element.prototype.oMatchesSelector ||
				Element.prototype.webkitMatchesSelector ||
				function (s) {
					var matches = (this.document || this.ownerDocument).querySelectorAll(
							s
						),
						i = matches.length;

					while (--i >= 0 && matches.item(i) !== this) {}

					return i > -1;
				};
		}

		var state = {
			init: init,
			watch: watch,
			unwatch: unwatch,
			load: load$1,
		};

		function init() {
			var selector =
				arguments.length > 0 && arguments[0] !== undefined
					? arguments[0]
					: '[data-rimg="lazy"]';
			var options =
				arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			state.selector = selector;
			state.instance = rimg(selector, options);
			state.loadedWidth = Math.max(
				document.documentElement.clientWidth,
				window.innerWidth || 0
			); // Listen for Shopify theme editor events

			document.addEventListener("shopify:section:load", function (event) {
				return watch(event.target);
			});
			window.addEventListener("resize", function () {
				return _update();
			});
			document.addEventListener("shopify:section:unload", function (event) {
				return unwatch(event.target);
			}); // Listen for custom events to allow themes to hook into rimg

			document.addEventListener("theme:rimg:watch", function (event) {
				return watch(event.target);
			});
			document.addEventListener("theme:rimg:unwatch", function (event) {
				return unwatch(event.target);
			}); // Support custom events triggered through jQuery
			// See: https://github.com/jquery/jquery/issues/3347

			if (window.jQuery) {
				jQuery(document).on({
					"theme:rimg:watch": function themeRimgWatch(event) {
						return watch(event.target);
					},
					"theme:rimg:unwatch": function themeRimgUnwatch(event) {
						return unwatch(event.target);
					},
				});
			}
		}
		/**
		 * Track an element, and its children.
		 *
		 * @param {HTMLElement} el
		 */

		function watch(el) {
			// Track element
			if (typeof el.matches === "function" && el.matches(state.selector)) {
				state.instance.track(el);
			} // Track element's children

			state.instance.track(el.querySelectorAll(state.selector));
		}
		/**
		 * Untrack an element, and its children
		 *
		 * @param {HTMLElement} el
		 * @private
		 */

		function unwatch(el) {
			// Untrack element's children
			state.instance.untrack(el.querySelectorAll(state.selector)); // Untrack element

			if (typeof el.matches === "function" && el.matches(state.selector)) {
				state.instance.untrack(el);
			}
		}
		/**
		 * Manually load an image
		 *
		 * @param {HTMLElement} el
		 */

		function load$1(el) {
			// Load element
			if (typeof el.matches === "function" && el.matches(state.selector)) {
				state.instance.load(el);
			} // Load element's children

			state.instance.load(el.querySelectorAll(state.selector));
		}
		/**
		 * Update an element, and its children.
		 *
		 * @param {HTMLElement} el
		 */

		function _update() {
			var currentWidth = Math.max(
				document.documentElement.clientWidth,
				window.innerWidth || 0
			); // Return if we're not 2x smaller, or larger than the existing loading size

			if (
				currentWidth / state.loadedWidth > 0.5 &&
				currentWidth / state.loadedWidth < 2
			) {
				return;
			}

			state.loadedWidth = currentWidth;
			state.instance.update();
		}

		/* harmony default export */ const dist_index_es = state; // CONCATENATED MODULE: ./source/scripts/Sections.js

		/* eslint-disable max-classes-per-file */

		/**
		 * Allows a callback to be run once, when a target intersects the viewport.
		 * @constructor
		 * @param {Object} [options] options with which to construct the IntersectionObserver
		 * @param {string} [options.rootMargin='30%'] A string which specifies a set of offsets to add to
		 *                                          the root's bounding_box when calculating intersections.
		 * @param {number} [options.threshold=0] Ratio of intersection required to trigger callback
		 */
		class LazyLoader {
			constructor(options) {
				const defaultOptions = {
					rootMargin: "30%",
					threshold: 0,
				};
				this.callbacks = new WeakMap();
				this._observerCallback = this._observerCallback.bind(this);
				this.observer = new IntersectionObserver(this._observerCallback, {
					...defaultOptions,
					...options,
				});
			}
			/**
			 * Add target and callback. Callback is only run once.
			 * @add
			 * @param {HTMLElement} target Target element
			 * @param {function} callback Callback to run when target begins intersecting
			 */

			add(target, callback) {
				this.callbacks.set(target, callback);
				this.observer.observe(target);
			}
			/**
			 * Remove target. Associated callback is also removed.
			 * @remove
			 * @param {HTMLElement} target Target element
			 */

			remove(target) {
				this.observer.unobserve(target);
				this.callbacks.delete(target);
			}
			/**
			 * Disconnects IntersectionObserver if active
			 * @unload
			 */

			unload() {
				this.observer.disconnect();
			}
			/**
			 * Runs associated callbacks for each entry, then removes that entry and callback
			 * @_observerCallback
			 * @param {IntersectionObserverEntry[]} entries Entries to check
			 * @param {InterserctionObserver} observer IntersectionObserver instance
			 */

			_observerCallback(entries, observer) {
				entries.forEach((_ref) => {
					let { isIntersecting, target } = _ref;

					// do nothing unless target moved into state of intersection
					if (isIntersecting === true) {
						// make sure we stop observing before running the callback, so we don't
						// somehow run the callback twice if element intersects twice quickly
						observer.unobserve(target);
						const callback = this.callbacks.get(target);

						if (typeof callback === "function") {
							callback();
						}

						this.callbacks.delete(target);
					}
				});
			}
		}

		class Sections {
			constructor() {
				this.handlers = {};
				this.instances = {};
				this.options = {};
				this.imports = {};
				this.lazyLoader = null;
				this._onSectionEvent = this._onSectionEvent.bind(this);
				document.addEventListener("shopify:section:load", this._onSectionEvent);
				document.addEventListener(
					"shopify:section:unload",
					this._onSectionEvent
				);
				document.addEventListener(
					"shopify:section:select",
					this._onSectionEvent
				);
				document.addEventListener(
					"shopify:section:deselect",
					this._onSectionEvent
				);
				document.addEventListener("shopify:block:select", this._onSectionEvent);
				document.addEventListener(
					"shopify:block:deselect",
					this._onSectionEvent
				);
			}
			/**
			 * Stop listening for section events, and unbind all handlers.
			 */

			unbind() {
				document.removeEventListener(
					"shopify:section:load",
					this._onSectionEvent
				);
				document.removeEventListener(
					"shopify:section:unload",
					this._onSectionEvent
				);
				document.removeEventListener(
					"shopify:section:select",
					this._onSectionEvent
				);
				document.removeEventListener(
					"shopify:section:deselect",
					this._onSectionEvent
				);
				document.removeEventListener(
					"shopify:block:select",
					this._onSectionEvent
				);
				document.removeEventListener(
					"shopify:block:deselect",
					this._onSectionEvent
				); // Unload all instances

				for (let i = 0; i < this.instances.length; i++) {
					this._triggerInstanceEvent(this.instances[i], "onSectionUnload");
				}

				this.handlers = {};
				this.options = {};
				this.lazyLoader.unload();
				this.lazyLoader = null;
				this.instances = {};
			}
			/**
			 * Register a section handler.
			 *
			 * @param {string} type
			 *        The section type to handle. The handler will be called for all
			 *        sections with this type.
			 *
			 * @param {function} handler
			 *        The handler function is passed information about a specific section
			 *        instance. The handler is expected to return an object that will be
			 *        associated with the section instance.
			 *
			 *        Section handlers are passed an object with the following parameters:
			 *          {string} id
			 *          An ID that maps to a specific section instance. Typically the
			 *          section's filename for static sections, or a generated ID for
			 *          dynamic sections.
			 *
			 *          {string} type
			 *          The section type, as supplied when registered.
			 *
			 *          {Element} el
			 *          The root DOM element for the section instance.
			 *
			 *          {Object} data
			 *          Data loaded from the section script element. Defaults to an
			 *          empty object.
			 *
			 *          {Function} postMessage
			 *          A function that can be called to pass messages between sections.
			 *          The function should be called with a message "name", and
			 *          optionally some data.
			 *
			 * @param {object} options
			 *
			 * @param {boolean} options.lazy
			 *     If true, sections will only be initialized after they intersect the viewport + 30% margin
			 */

			register(type, handler) {
				let options =
					arguments.length > 2 && arguments[2] !== undefined
						? arguments[2]
						: {};

				if (this.handlers[type]) {
					console.warn(
						`Sections: section handler already exists of type '${type}'.`
					);
				} // Store the section handler

				this.handlers[type] = handler; // Store options

				this.options[type] = options; // Init sections for this type

				this._initSections(type);
			}
			/**
			 * Initialize sections already on the page.
			 */

			_initSections(type) {
				// Fetch all existing sections of our type on the page
				const dataEls = document.querySelectorAll(
					`[data-section-type="${type}"]`
				);
				if (!dataEls) return; // Create an instance for each section

				for (let i = 0; i < dataEls.length; i++) {
					const dataEl = dataEls[i];
					const el = dataEl.parentNode; // Get instance ID

					const idEl = el.querySelector("[data-section-id]");

					if (!idEl) {
						console.warn(
							`Sections: unable to find section id for '${type}'.`,
							el
						);
						continue; // eslint-disable-line no-continue
					}

					const sectionId = idEl.getAttribute("data-section-id");

					if (!sectionId) {
						console.warn(
							`Sections: unable to find section id for '${type}'.`,
							el
						);
						continue; // eslint-disable-line no-continue
					}

					if (this.options[type] && this.options[type].lazy) {
						if (this.lazyLoader === null) {
							this.lazyLoader = new LazyLoader();
						}

						this.lazyLoader.add(el, () => this._createInstance(sectionId, el));
					} else {
						this._createInstance(sectionId, el);
					}
				}
			}

			_onSectionEvent(event) {
				const el = event.target;
				const { sectionId, blockId } = event.detail;
				let instance = this.instances[sectionId];

				switch (event.type) {
					case "shopify:section:load":
						instance = this._createInstance(sectionId, el);

						this._triggerInstanceEvent(instance, "onSectionLoad", {
							el,
							id: sectionId,
						});

						break;

					case "shopify:section:unload":
						this._triggerInstanceEvent(instance, "onSectionUnload", {
							el,
							id: sectionId,
						});

						if (this.lazyLoader) {
							this.lazyLoader.remove(el);
						}

						delete this.instances[sectionId];
						break;

					case "shopify:section:select":
						this._triggerInstanceEvent(instance, "onSectionSelect", {
							el,
							id: sectionId,
						});

						break;

					case "shopify:section:deselect":
						this._triggerInstanceEvent(instance, "onSectionDeselect", {
							el,
							id: sectionId,
						});

						break;

					case "shopify:block:select":
						this._triggerInstanceEvent(instance, "onSectionBlockSelect", {
							el,
							id: blockId,
						});

						break;

					case "shopify:block:deselect":
						this._triggerInstanceEvent(instance, "onSectionBlockDeselect", {
							el,
							id: blockId,
						});

						break;

					default:
						break;
				}
			}

			_triggerInstanceEvent(instance, eventName) {
				if (instance && instance[eventName]) {
					for (
						var _len = arguments.length,
							args = new Array(_len > 2 ? _len - 2 : 0),
							_key = 2;
						_key < _len;
						_key++
					) {
						args[_key - 2] = arguments[_key];
					}

					instance[eventName](...args);
				}
			}

			_postMessage(name, data) {
				Object.keys(this.instances).forEach((id) => {
					this._triggerInstanceEvent(
						this.instances[id],
						"onSectionMessage",
						name,
						data
					);
				});
			}

			_createInstance(id, el) {
				const typeEl = el.querySelector("[data-section-type]");
				if (!typeEl) return;
				const type = typeEl.getAttribute("data-section-type");
				if (!type) return;
				const handler = this.handlers[type];

				if (!handler) {
					console.warn(
						`Sections: unable to find section handler for type '${type}'.`
					);
					return;
				}

				const data = this._loadData(el);

				const postMessage = this._postMessage.bind(this);

				const handlerParams = {
					id,
					type,
					el,
					data,
					postMessage,
				};

				if (!this.imports[type]) {
					// Try to create the instance
					const handlerReturn = handler(handlerParams);

					if (handlerReturn instanceof Promise) {
						// Handler is a dynamic import so we need to resolve the import before
						// creating the instance
						handlerReturn.then((_ref2) => {
							let { default: Component } = _ref2;

							this.imports[type] = () => new Component(handlerParams);

							this.instances[id] = new Component(handlerParams);
						});
					} else {
						// Handler returned an instance class - we can create directly.
						this.imports[type] = handler;
						this.instances[id] = handlerReturn;
					}
				} else {
					this.instances[id] = this.imports[type](handlerParams);
				}

				return this.instances[id];
			}

			_loadData(el) {
				const dataEl = el.querySelector("[data-section-data]");
				if (!dataEl) return {}; // Load data from attribute, or innerHTML

				const data =
					dataEl.getAttribute("data-section-data") || dataEl.innerHTML;

				try {
					return JSON.parse(data);
				} catch (error) {
					console.warn(
						`Sections: invalid section data found. ${error.message}`
					);
					return {};
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/checkPolyfills.js
		const polyfillUrls = []; // Checks if all IntersectionObserver and IntersectionObserverEntry
		// features are natively supported.

		if (
			!(
				"IntersectionObserver" in window &&
				"IntersectionObserverEntry" in window &&
				"intersectionRatio" in window.IntersectionObserverEntry.prototype
			)
		) {
			polyfillUrls.push(
				document.querySelector("[data-scripts]").dataset.pxuPolyfills
			);
		} // Polyfill NodeList.forEach if required.
		// Polyfill is so small it doesn't need to load any external code.

		if (window.NodeList && !NodeList.prototype.forEach) {
			NodeList.prototype.forEach = Array.prototype.forEach;
		}

		if (!Element.prototype.closest) {
			Element.prototype.closest = function (s) {
				var el = this;

				do {
					if (Element.prototype.matches.call(el, s)) return el;
					el = el.parentElement || el.parentNode;
				} while (el !== null && el.nodeType === 1);

				return null;
			};
		}

		/* harmony default export */ const checkPolyfills = polyfillUrls; // CONCATENATED MODULE: ./source/scripts/sections/StaticAnnouncement.js
		class StaticAnnouncement {
			constructor(section) {
				// Since the announcement bar positioning is actually handled by the
				// StaticSectionHeader and StickyHeader classes, we need to let them know
				// when the announcement element is refreshed within the editor.
				if (window.Shopify && window.Shopify.designMode) {
					section.postMessage("announcement:load");
				}
			}
		}
		// EXTERNAL MODULE: ./node_modules/fitvids/index.js
		var fitvids = __webpack_require__(729);
		var fitvids_default = /*#__PURE__*/ __webpack_require__.n(fitvids);
		// EXTERNAL MODULE: ./node_modules/grouped-content/dist/index.js
		var dist = __webpack_require__(414);
		var dist_default = /*#__PURE__*/ __webpack_require__.n(dist); // CONCATENATED MODULE: ./source/scripts/components/RichText.js
		class RichText {
			constructor($el) {
				this.$el = $($el);

				this._initExternalLinks();

				this.groupedContent = null;

				if (this.$el.length) {
					this.groupedContent = new (dist_default())(this.$el.get(0), {
						layout: "tabs",
						intelliparse: false,
					});
					fitvids_default()(".rte");
				}
			}

			unload() {
				if (this.groupedContent) {
					this.groupedContent.unload();
				}
			}
			/**
			 * Open links within an RTE field in a new window if they point to external domains
			 *
			 * @private
			 */

			_initExternalLinks() {
				const anchors = this.$el
					.find('a[href^="http"]')
					.filter((i, el) => el.href.indexOf(location.hostname) === -1);
				anchors.attr("target", "_blank");
			}
		} // CONCATENATED MODULE: ./source/scripts/Forms.js
		class Forms {
			constructor(el) {
				let selector =
					arguments.length > 1 && arguments[1] !== undefined
						? arguments[1]
						: ".form-field-input";
				this.$el = jquery_default()(el);
				this.filledClass = "form-field-filled";
				this.fieldSelector = selector;
				this._toggleFilled = this._toggleFilled.bind(this);
				this.$el.on("focus.forms", this.fieldSelector, this._toggleFilled);
				this.$el.on("blur.forms", this.fieldSelector, this._toggleFilled);

				this._checkFilled();
			}

			unload() {
				this.$el.off(".forms");
			}

			_checkFilled() {
				this.$el.find(this.fieldSelector).each((i, el) => {
					if (jquery_default()(el).hasClass(this.filledClass)) return;

					this._toggleFilled(null, el);
				});
			}

			_toggleFilled() {
				let event =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: null;
				let el =
					arguments.length > 1 && arguments[1] !== undefined
						? arguments[1]
						: false;
				const target = event ? event.currentTarget : el;
				const $target = jquery_default()(target);
				const { value } = target;
				let isFilled = value.length > 0;

				try {
					isFilled = isFilled || $target.is(":-webkit-autofill");
					$target.toggleClass(this.filledClass, isFilled);
				} catch (e) {
					$target.toggleClass(this.filledClass, isFilled);
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/StaticArticle.js
		class StaticArticle {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				this.$commentForm = this.$el.find("[data-articlecomments-form]");
				this.richText = new RichText(this.$el);

				if (this.$commentForm.length) {
					this.commentForm = new Forms(this.$commentForm);
				}
			}

			onSectionUnload() {
				this.richText.unload();

				if (this.commentForm) {
					this.commentForm.unload();
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/StaticBlog.js
		class StaticBlog {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				this.richText = new RichText(this.$el);
			}

			onSectionUnload() {
				this.richText.unload();
			}
		}
		// EXTERNAL MODULE: ./node_modules/just-debounce/index.js
		var just_debounce = __webpack_require__(405);
		var just_debounce_default =
			/*#__PURE__*/ __webpack_require__.n(just_debounce); // CONCATENATED MODULE: ./node_modules/morphdom/dist/morphdom-esm.js
		var DOCUMENT_FRAGMENT_NODE = 11;

		function morphAttrs(fromNode, toNode) {
			var toNodeAttrs = toNode.attributes;
			var attr;
			var attrName;
			var attrNamespaceURI;
			var attrValue;
			var fromValue;

			// document-fragments dont have attributes so lets not do anything
			if (
				toNode.nodeType === DOCUMENT_FRAGMENT_NODE ||
				fromNode.nodeType === DOCUMENT_FRAGMENT_NODE
			) {
				return;
			}

			// update attributes on original DOM element
			for (var i = toNodeAttrs.length - 1; i >= 0; i--) {
				attr = toNodeAttrs[i];
				attrName = attr.name;
				attrNamespaceURI = attr.namespaceURI;
				attrValue = attr.value;

				if (attrNamespaceURI) {
					attrName = attr.localName || attrName;
					fromValue = fromNode.getAttributeNS(attrNamespaceURI, attrName);

					if (fromValue !== attrValue) {
						if (attr.prefix === "xmlns") {
							attrName = attr.name; // It's not allowed to set an attribute with the XMLNS namespace without specifying the `xmlns` prefix
						}
						fromNode.setAttributeNS(attrNamespaceURI, attrName, attrValue);
					}
				} else {
					fromValue = fromNode.getAttribute(attrName);

					if (fromValue !== attrValue) {
						fromNode.setAttribute(attrName, attrValue);
					}
				}
			}

			// Remove any extra attributes found on the original DOM element that
			// weren't found on the target element.
			var fromNodeAttrs = fromNode.attributes;

			for (var d = fromNodeAttrs.length - 1; d >= 0; d--) {
				attr = fromNodeAttrs[d];
				attrName = attr.name;
				attrNamespaceURI = attr.namespaceURI;

				if (attrNamespaceURI) {
					attrName = attr.localName || attrName;

					if (!toNode.hasAttributeNS(attrNamespaceURI, attrName)) {
						fromNode.removeAttributeNS(attrNamespaceURI, attrName);
					}
				} else {
					if (!toNode.hasAttribute(attrName)) {
						fromNode.removeAttribute(attrName);
					}
				}
			}
		}

		var range; // Create a range object for efficently rendering strings to elements.
		var NS_XHTML = "http://www.w3.org/1999/xhtml";

		var doc = typeof document === "undefined" ? undefined : document;
		var HAS_TEMPLATE_SUPPORT =
			!!doc && "content" in doc.createElement("template");
		var HAS_RANGE_SUPPORT =
			!!doc &&
			doc.createRange &&
			"createContextualFragment" in doc.createRange();

		function createFragmentFromTemplate(str) {
			var template = doc.createElement("template");
			template.innerHTML = str;
			return template.content.childNodes[0];
		}

		function createFragmentFromRange(str) {
			if (!range) {
				range = doc.createRange();
				range.selectNode(doc.body);
			}

			var fragment = range.createContextualFragment(str);
			return fragment.childNodes[0];
		}

		function createFragmentFromWrap(str) {
			var fragment = doc.createElement("body");
			fragment.innerHTML = str;
			return fragment.childNodes[0];
		}

		/**
		 * This is about the same
		 * var html = new DOMParser().parseFromString(str, 'text/html');
		 * return html.body.firstChild;
		 *
		 * @method toElement
		 * @param {String} str
		 */
		function toElement(str) {
			str = str.trim();
			if (HAS_TEMPLATE_SUPPORT) {
				// avoid restrictions on content for things like `<tr><th>Hi</th></tr>` which
				// createContextualFragment doesn't support
				// <template> support not available in IE
				return createFragmentFromTemplate(str);
			} else if (HAS_RANGE_SUPPORT) {
				return createFragmentFromRange(str);
			}

			return createFragmentFromWrap(str);
		}

		/**
		 * Returns true if two node's names are the same.
		 *
		 * NOTE: We don't bother checking `namespaceURI` because you will never find two HTML elements with the same
		 *       nodeName and different namespace URIs.
		 *
		 * @param {Element} a
		 * @param {Element} b The target element
		 * @return {boolean}
		 */
		function compareNodeNames(fromEl, toEl) {
			var fromNodeName = fromEl.nodeName;
			var toNodeName = toEl.nodeName;
			var fromCodeStart, toCodeStart;

			if (fromNodeName === toNodeName) {
				return true;
			}

			fromCodeStart = fromNodeName.charCodeAt(0);
			toCodeStart = toNodeName.charCodeAt(0);

			// If the target element is a virtual DOM node or SVG node then we may
			// need to normalize the tag name before comparing. Normal HTML elements that are
			// in the "http://www.w3.org/1999/xhtml"
			// are converted to upper case
			if (fromCodeStart <= 90 && toCodeStart >= 97) {
				// from is upper and to is lower
				return fromNodeName === toNodeName.toUpperCase();
			} else if (toCodeStart <= 90 && fromCodeStart >= 97) {
				// to is upper and from is lower
				return toNodeName === fromNodeName.toUpperCase();
			} else {
				return false;
			}
		}

		/**
		 * Create an element, optionally with a known namespace URI.
		 *
		 * @param {string} name the element name, e.g. 'div' or 'svg'
		 * @param {string} [namespaceURI] the element's namespace URI, i.e. the value of
		 * its `xmlns` attribute or its inferred namespace.
		 *
		 * @return {Element}
		 */
		function createElementNS(name, namespaceURI) {
			return !namespaceURI || namespaceURI === NS_XHTML
				? doc.createElement(name)
				: doc.createElementNS(namespaceURI, name);
		}

		/**
		 * Copies the children of one DOM element to another DOM element
		 */
		function moveChildren(fromEl, toEl) {
			var curChild = fromEl.firstChild;
			while (curChild) {
				var nextChild = curChild.nextSibling;
				toEl.appendChild(curChild);
				curChild = nextChild;
			}
			return toEl;
		}

		function syncBooleanAttrProp(fromEl, toEl, name) {
			if (fromEl[name] !== toEl[name]) {
				fromEl[name] = toEl[name];
				if (fromEl[name]) {
					fromEl.setAttribute(name, "");
				} else {
					fromEl.removeAttribute(name);
				}
			}
		}

		var specialElHandlers = {
			OPTION: function (fromEl, toEl) {
				var parentNode = fromEl.parentNode;
				if (parentNode) {
					var parentName = parentNode.nodeName.toUpperCase();
					if (parentName === "OPTGROUP") {
						parentNode = parentNode.parentNode;
						parentName = parentNode && parentNode.nodeName.toUpperCase();
					}
					if (parentName === "SELECT" && !parentNode.hasAttribute("multiple")) {
						if (fromEl.hasAttribute("selected") && !toEl.selected) {
							// Workaround for MS Edge bug where the 'selected' attribute can only be
							// removed if set to a non-empty value:
							// https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12087679/
							fromEl.setAttribute("selected", "selected");
							fromEl.removeAttribute("selected");
						}
						// We have to reset select element's selectedIndex to -1, otherwise setting
						// fromEl.selected using the syncBooleanAttrProp below has no effect.
						// The correct selectedIndex will be set in the SELECT special handler below.
						parentNode.selectedIndex = -1;
					}
				}
				syncBooleanAttrProp(fromEl, toEl, "selected");
			},
			/**
			 * The "value" attribute is special for the <input> element since it sets
			 * the initial value. Changing the "value" attribute without changing the
			 * "value" property will have no effect since it is only used to the set the
			 * initial value.  Similar for the "checked" attribute, and "disabled".
			 */
			INPUT: function (fromEl, toEl) {
				syncBooleanAttrProp(fromEl, toEl, "checked");
				syncBooleanAttrProp(fromEl, toEl, "disabled");

				if (fromEl.value !== toEl.value) {
					fromEl.value = toEl.value;
				}

				if (!toEl.hasAttribute("value")) {
					fromEl.removeAttribute("value");
				}
			},

			TEXTAREA: function (fromEl, toEl) {
				var newValue = toEl.value;
				if (fromEl.value !== newValue) {
					fromEl.value = newValue;
				}

				var firstChild = fromEl.firstChild;
				if (firstChild) {
					// Needed for IE. Apparently IE sets the placeholder as the
					// node value and vise versa. This ignores an empty update.
					var oldValue = firstChild.nodeValue;

					if (
						oldValue == newValue ||
						(!newValue && oldValue == fromEl.placeholder)
					) {
						return;
					}

					firstChild.nodeValue = newValue;
				}
			},
			SELECT: function (fromEl, toEl) {
				if (!toEl.hasAttribute("multiple")) {
					var selectedIndex = -1;
					var i = 0;
					// We have to loop through children of fromEl, not toEl since nodes can be moved
					// from toEl to fromEl directly when morphing.
					// At the time this special handler is invoked, all children have already been morphed
					// and appended to / removed from fromEl, so using fromEl here is safe and correct.
					var curChild = fromEl.firstChild;
					var optgroup;
					var nodeName;
					while (curChild) {
						nodeName = curChild.nodeName && curChild.nodeName.toUpperCase();
						if (nodeName === "OPTGROUP") {
							optgroup = curChild;
							curChild = optgroup.firstChild;
						} else {
							if (nodeName === "OPTION") {
								if (curChild.hasAttribute("selected")) {
									selectedIndex = i;
									break;
								}
								i++;
							}
							curChild = curChild.nextSibling;
							if (!curChild && optgroup) {
								curChild = optgroup.nextSibling;
								optgroup = null;
							}
						}
					}

					fromEl.selectedIndex = selectedIndex;
				}
			},
		};

		var ELEMENT_NODE = 1;
		var DOCUMENT_FRAGMENT_NODE$1 = 11;
		var TEXT_NODE = 3;
		var COMMENT_NODE = 8;

		function noop() {}

		function defaultGetNodeKey(node) {
			if (node) {
				return (node.getAttribute && node.getAttribute("id")) || node.id;
			}
		}

		function morphdomFactory(morphAttrs) {
			return function morphdom(fromNode, toNode, options) {
				if (!options) {
					options = {};
				}

				if (typeof toNode === "string") {
					if (
						fromNode.nodeName === "#document" ||
						fromNode.nodeName === "HTML" ||
						fromNode.nodeName === "BODY"
					) {
						var toNodeHtml = toNode;
						toNode = doc.createElement("html");
						toNode.innerHTML = toNodeHtml;
					} else {
						toNode = toElement(toNode);
					}
				}

				var getNodeKey = options.getNodeKey || defaultGetNodeKey;
				var onBeforeNodeAdded = options.onBeforeNodeAdded || noop;
				var onNodeAdded = options.onNodeAdded || noop;
				var onBeforeElUpdated = options.onBeforeElUpdated || noop;
				var onElUpdated = options.onElUpdated || noop;
				var onBeforeNodeDiscarded = options.onBeforeNodeDiscarded || noop;
				var onNodeDiscarded = options.onNodeDiscarded || noop;
				var onBeforeElChildrenUpdated =
					options.onBeforeElChildrenUpdated || noop;
				var childrenOnly = options.childrenOnly === true;

				// This object is used as a lookup to quickly find all keyed elements in the original DOM tree.
				var fromNodesLookup = Object.create(null);
				var keyedRemovalList = [];

				function addKeyedRemoval(key) {
					keyedRemovalList.push(key);
				}

				function walkDiscardedChildNodes(node, skipKeyedNodes) {
					if (node.nodeType === ELEMENT_NODE) {
						var curChild = node.firstChild;
						while (curChild) {
							var key = undefined;

							if (skipKeyedNodes && (key = getNodeKey(curChild))) {
								// If we are skipping keyed nodes then we add the key
								// to a list so that it can be handled at the very end.
								addKeyedRemoval(key);
							} else {
								// Only report the node as discarded if it is not keyed. We do this because
								// at the end we loop through all keyed elements that were unmatched
								// and then discard them in one final pass.
								onNodeDiscarded(curChild);
								if (curChild.firstChild) {
									walkDiscardedChildNodes(curChild, skipKeyedNodes);
								}
							}

							curChild = curChild.nextSibling;
						}
					}
				}

				/**
				 * Removes a DOM node out of the original DOM
				 *
				 * @param  {Node} node The node to remove
				 * @param  {Node} parentNode The nodes parent
				 * @param  {Boolean} skipKeyedNodes If true then elements with keys will be skipped and not discarded.
				 * @return {undefined}
				 */
				function removeNode(node, parentNode, skipKeyedNodes) {
					if (onBeforeNodeDiscarded(node) === false) {
						return;
					}

					if (parentNode) {
						parentNode.removeChild(node);
					}

					onNodeDiscarded(node);
					walkDiscardedChildNodes(node, skipKeyedNodes);
				}

				// // TreeWalker implementation is no faster, but keeping this around in case this changes in the future
				// function indexTree(root) {
				//     var treeWalker = document.createTreeWalker(
				//         root,
				//         NodeFilter.SHOW_ELEMENT);
				//
				//     var el;
				//     while((el = treeWalker.nextNode())) {
				//         var key = getNodeKey(el);
				//         if (key) {
				//             fromNodesLookup[key] = el;
				//         }
				//     }
				// }

				// // NodeIterator implementation is no faster, but keeping this around in case this changes in the future
				//
				// function indexTree(node) {
				//     var nodeIterator = document.createNodeIterator(node, NodeFilter.SHOW_ELEMENT);
				//     var el;
				//     while((el = nodeIterator.nextNode())) {
				//         var key = getNodeKey(el);
				//         if (key) {
				//             fromNodesLookup[key] = el;
				//         }
				//     }
				// }

				function indexTree(node) {
					if (
						node.nodeType === ELEMENT_NODE ||
						node.nodeType === DOCUMENT_FRAGMENT_NODE$1
					) {
						var curChild = node.firstChild;
						while (curChild) {
							var key = getNodeKey(curChild);
							if (key) {
								fromNodesLookup[key] = curChild;
							}

							// Walk recursively
							indexTree(curChild);

							curChild = curChild.nextSibling;
						}
					}
				}

				indexTree(fromNode);

				function handleNodeAdded(el) {
					onNodeAdded(el);

					var curChild = el.firstChild;
					while (curChild) {
						var nextSibling = curChild.nextSibling;

						var key = getNodeKey(curChild);
						if (key) {
							var unmatchedFromEl = fromNodesLookup[key];
							// if we find a duplicate #id node in cache, replace `el` with cache value
							// and morph it to the child node.
							if (
								unmatchedFromEl &&
								compareNodeNames(curChild, unmatchedFromEl)
							) {
								curChild.parentNode.replaceChild(unmatchedFromEl, curChild);
								morphEl(unmatchedFromEl, curChild);
							} else {
								handleNodeAdded(curChild);
							}
						} else {
							// recursively call for curChild and it's children to see if we find something in
							// fromNodesLookup
							handleNodeAdded(curChild);
						}

						curChild = nextSibling;
					}
				}

				function cleanupFromEl(fromEl, curFromNodeChild, curFromNodeKey) {
					// We have processed all of the "to nodes". If curFromNodeChild is
					// non-null then we still have some from nodes left over that need
					// to be removed
					while (curFromNodeChild) {
						var fromNextSibling = curFromNodeChild.nextSibling;
						if ((curFromNodeKey = getNodeKey(curFromNodeChild))) {
							// Since the node is keyed it might be matched up later so we defer
							// the actual removal to later
							addKeyedRemoval(curFromNodeKey);
						} else {
							// NOTE: we skip nested keyed nodes from being removed since there is
							//       still a chance they will be matched up later
							removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
						}
						curFromNodeChild = fromNextSibling;
					}
				}

				function morphEl(fromEl, toEl, childrenOnly) {
					var toElKey = getNodeKey(toEl);

					if (toElKey) {
						// If an element with an ID is being morphed then it will be in the final
						// DOM so clear it out of the saved elements collection
						delete fromNodesLookup[toElKey];
					}

					if (!childrenOnly) {
						// optional
						if (onBeforeElUpdated(fromEl, toEl) === false) {
							return;
						}

						// update attributes on original DOM element first
						morphAttrs(fromEl, toEl);
						// optional
						onElUpdated(fromEl);

						if (onBeforeElChildrenUpdated(fromEl, toEl) === false) {
							return;
						}
					}

					if (fromEl.nodeName !== "TEXTAREA") {
						morphChildren(fromEl, toEl);
					} else {
						specialElHandlers.TEXTAREA(fromEl, toEl);
					}
				}

				function morphChildren(fromEl, toEl) {
					var curToNodeChild = toEl.firstChild;
					var curFromNodeChild = fromEl.firstChild;
					var curToNodeKey;
					var curFromNodeKey;

					var fromNextSibling;
					var toNextSibling;
					var matchingFromEl;

					// walk the children
					outer: while (curToNodeChild) {
						toNextSibling = curToNodeChild.nextSibling;
						curToNodeKey = getNodeKey(curToNodeChild);

						// walk the fromNode children all the way through
						while (curFromNodeChild) {
							fromNextSibling = curFromNodeChild.nextSibling;

							if (
								curToNodeChild.isSameNode &&
								curToNodeChild.isSameNode(curFromNodeChild)
							) {
								curToNodeChild = toNextSibling;
								curFromNodeChild = fromNextSibling;
								continue outer;
							}

							curFromNodeKey = getNodeKey(curFromNodeChild);

							var curFromNodeType = curFromNodeChild.nodeType;

							// this means if the curFromNodeChild doesnt have a match with the curToNodeChild
							var isCompatible = undefined;

							if (curFromNodeType === curToNodeChild.nodeType) {
								if (curFromNodeType === ELEMENT_NODE) {
									// Both nodes being compared are Element nodes

									if (curToNodeKey) {
										// The target node has a key so we want to match it up with the correct element
										// in the original DOM tree
										if (curToNodeKey !== curFromNodeKey) {
											// The current element in the original DOM tree does not have a matching key so
											// let's check our lookup to see if there is a matching element in the original
											// DOM tree
											if ((matchingFromEl = fromNodesLookup[curToNodeKey])) {
												if (fromNextSibling === matchingFromEl) {
													// Special case for single element removals. To avoid removing the original
													// DOM node out of the tree (since that can break CSS transitions, etc.),
													// we will instead discard the current node and wait until the next
													// iteration to properly match up the keyed target element with its matching
													// element in the original tree
													isCompatible = false;
												} else {
													// We found a matching keyed element somewhere in the original DOM tree.
													// Let's move the original DOM node into the current position and morph
													// it.

													// NOTE: We use insertBefore instead of replaceChild because we want to go through
													// the `removeNode()` function for the node that is being discarded so that
													// all lifecycle hooks are correctly invoked
													fromEl.insertBefore(matchingFromEl, curFromNodeChild);

													// fromNextSibling = curFromNodeChild.nextSibling;

													if (curFromNodeKey) {
														// Since the node is keyed it might be matched up later so we defer
														// the actual removal to later
														addKeyedRemoval(curFromNodeKey);
													} else {
														// NOTE: we skip nested keyed nodes from being removed since there is
														//       still a chance they will be matched up later
														removeNode(
															curFromNodeChild,
															fromEl,
															true /* skip keyed nodes */
														);
													}

													curFromNodeChild = matchingFromEl;
												}
											} else {
												// The nodes are not compatible since the "to" node has a key and there
												// is no matching keyed node in the source tree
												isCompatible = false;
											}
										}
									} else if (curFromNodeKey) {
										// The original has a key
										isCompatible = false;
									}

									isCompatible =
										isCompatible !== false &&
										compareNodeNames(curFromNodeChild, curToNodeChild);
									if (isCompatible) {
										// We found compatible DOM elements so transform
										// the current "from" node to match the current
										// target DOM node.
										// MORPH
										morphEl(curFromNodeChild, curToNodeChild);
									}
								} else if (
									curFromNodeType === TEXT_NODE ||
									curFromNodeType == COMMENT_NODE
								) {
									// Both nodes being compared are Text or Comment nodes
									isCompatible = true;
									// Simply update nodeValue on the original node to
									// change the text value
									if (curFromNodeChild.nodeValue !== curToNodeChild.nodeValue) {
										curFromNodeChild.nodeValue = curToNodeChild.nodeValue;
									}
								}
							}

							if (isCompatible) {
								// Advance both the "to" child and the "from" child since we found a match
								// Nothing else to do as we already recursively called morphChildren above
								curToNodeChild = toNextSibling;
								curFromNodeChild = fromNextSibling;
								continue outer;
							}

							// No compatible match so remove the old node from the DOM and continue trying to find a
							// match in the original DOM. However, we only do this if the from node is not keyed
							// since it is possible that a keyed node might match up with a node somewhere else in the
							// target tree and we don't want to discard it just yet since it still might find a
							// home in the final DOM tree. After everything is done we will remove any keyed nodes
							// that didn't find a home
							if (curFromNodeKey) {
								// Since the node is keyed it might be matched up later so we defer
								// the actual removal to later
								addKeyedRemoval(curFromNodeKey);
							} else {
								// NOTE: we skip nested keyed nodes from being removed since there is
								//       still a chance they will be matched up later
								removeNode(
									curFromNodeChild,
									fromEl,
									true /* skip keyed nodes */
								);
							}

							curFromNodeChild = fromNextSibling;
						} // END: while(curFromNodeChild) {}

						// If we got this far then we did not find a candidate match for
						// our "to node" and we exhausted all of the children "from"
						// nodes. Therefore, we will just append the current "to" node
						// to the end
						if (
							curToNodeKey &&
							(matchingFromEl = fromNodesLookup[curToNodeKey]) &&
							compareNodeNames(matchingFromEl, curToNodeChild)
						) {
							fromEl.appendChild(matchingFromEl);
							// MORPH
							morphEl(matchingFromEl, curToNodeChild);
						} else {
							var onBeforeNodeAddedResult = onBeforeNodeAdded(curToNodeChild);
							if (onBeforeNodeAddedResult !== false) {
								if (onBeforeNodeAddedResult) {
									curToNodeChild = onBeforeNodeAddedResult;
								}

								if (curToNodeChild.actualize) {
									curToNodeChild = curToNodeChild.actualize(
										fromEl.ownerDocument || doc
									);
								}
								fromEl.appendChild(curToNodeChild);
								handleNodeAdded(curToNodeChild);
							}
						}

						curToNodeChild = toNextSibling;
						curFromNodeChild = fromNextSibling;
					}

					cleanupFromEl(fromEl, curFromNodeChild, curFromNodeKey);

					var specialElHandler = specialElHandlers[fromEl.nodeName];
					if (specialElHandler) {
						specialElHandler(fromEl, toEl);
					}
				} // END: morphChildren(...)

				var morphedNode = fromNode;
				var morphedNodeType = morphedNode.nodeType;
				var toNodeType = toNode.nodeType;

				if (!childrenOnly) {
					// Handle the case where we are given two DOM nodes that are not
					// compatible (e.g. <div> --> <span> or <div> --> TEXT)
					if (morphedNodeType === ELEMENT_NODE) {
						if (toNodeType === ELEMENT_NODE) {
							if (!compareNodeNames(fromNode, toNode)) {
								onNodeDiscarded(fromNode);
								morphedNode = moveChildren(
									fromNode,
									createElementNS(toNode.nodeName, toNode.namespaceURI)
								);
							}
						} else {
							// Going from an element node to a text node
							morphedNode = toNode;
						}
					} else if (
						morphedNodeType === TEXT_NODE ||
						morphedNodeType === COMMENT_NODE
					) {
						// Text or comment node
						if (toNodeType === morphedNodeType) {
							if (morphedNode.nodeValue !== toNode.nodeValue) {
								morphedNode.nodeValue = toNode.nodeValue;
							}

							return morphedNode;
						} else {
							// Text node to something else
							morphedNode = toNode;
						}
					}
				}

				if (morphedNode === toNode) {
					// The "to node" was not compatible with the "from node" so we had to
					// toss out the "from node" and use the "to node"
					onNodeDiscarded(fromNode);
				} else {
					if (toNode.isSameNode && toNode.isSameNode(morphedNode)) {
						return;
					}

					morphEl(morphedNode, toNode, childrenOnly);

					// We now need to loop over any keyed nodes that might need to be
					// removed. We only do the removal if we know that the keyed node
					// never found a match. When a keyed node is matched up we remove
					// it out of fromNodesLookup and we use fromNodesLookup to determine
					// if a keyed node has been matched up or not
					if (keyedRemovalList) {
						for (var i = 0, len = keyedRemovalList.length; i < len; i++) {
							var elToRemove = fromNodesLookup[keyedRemovalList[i]];
							if (elToRemove) {
								removeNode(elToRemove, elToRemove.parentNode, false);
							}
						}
					}
				}

				if (!childrenOnly && morphedNode !== fromNode && fromNode.parentNode) {
					if (morphedNode.actualize) {
						morphedNode = morphedNode.actualize(fromNode.ownerDocument || doc);
					}
					// If we had to swap out the from node with a new node because the old
					// node was not compatible with the target node then we need to
					// replace the old DOM node in the original DOM tree. This is only
					// possible if the original DOM node was part of a DOM tree which
					// we know is the case if it has a parent node.
					fromNode.parentNode.replaceChild(morphedNode, fromNode);
				}

				return morphedNode;
			};
		}

		var morphdom = morphdomFactory(morphAttrs);

		/* harmony default export */ const morphdom_esm = morphdom; // CONCATENATED MODULE: ./node_modules/@shopify/theme-addresses/theme-addresses.js

		/**
		 * CountryProvinceSelector Constructor
		 * @param {String} countryOptions the country options in html string
		 */
		function CountryProvinceSelector(countryOptions) {
			if (typeof countryOptions !== "string") {
				throw new TypeError(countryOptions + " is not a string.");
			}
			this.countryOptions = countryOptions;
		}

		/**
		 * Builds the country and province selector with the given node element
		 * @param {Node} countryNodeElement The <select> element for country
		 * @param {Node} provinceNodeElement The <select> element for province
		 * @param {Object} options Additional settings available
		 * @param {CountryProvinceSelector~onCountryChange} options.onCountryChange callback after a country `change` event
		 * @param {CountryProvinceSelector~onProvinceChange} options.onProvinceChange callback after a province `change` event
		 */
		CountryProvinceSelector.prototype.build = function (
			countryNodeElement,
			provinceNodeElement,
			options
		) {
			if (typeof countryNodeElement !== "object") {
				throw new TypeError(countryNodeElement + " is not a object.");
			}

			if (typeof provinceNodeElement !== "object") {
				throw new TypeError(provinceNodeElement + " is not a object.");
			}

			var defaultValue = countryNodeElement.getAttribute("data-default");
			options = options || {};

			countryNodeElement.innerHTML = this.countryOptions;
			countryNodeElement.value = defaultValue;

			if (defaultValue && getOption(countryNodeElement, defaultValue)) {
				var provinces = buildProvince(
					countryNodeElement,
					provinceNodeElement,
					defaultValue
				);
				options.onCountryChange &&
					options.onCountryChange(
						provinces,
						provinceNodeElement,
						countryNodeElement
					);
			}

			// Listen for value change on the country select
			countryNodeElement.addEventListener("change", function (event) {
				var target = event.target;
				var selectedValue = target.value;

				var provinces = buildProvince(
					target,
					provinceNodeElement,
					selectedValue
				);
				options.onCountryChange &&
					options.onCountryChange(
						provinces,
						provinceNodeElement,
						countryNodeElement
					);
			});

			options.onProvinceChange &&
				provinceNodeElement.addEventListener(
					"change",
					options.onProvinceChange
				);
		};

		/**
		 * This callback is called after a user interacted with a country `<select>`
		 * @callback CountryProvinceSelector~onCountryChange
		 * @param {array} provinces the parsed provinces
		 * @param {Node} provinceNodeElement province `<select>` element
		 * @param {Node} countryNodeElement country `<select>` element
		 */

		/**
		 * This callback is called after a user interacted with a province `<select>`
		 * @callback CountryProvinceSelector~onProvinceChange
		 * @param {Event} event the province selector `change` event object
		 */

		/**
		 * Returns the <option> with the specified value from the
		 * given node element
		 * A null is returned if no such <option> is found
		 */
		function getOption(nodeElement, value) {
			return nodeElement.querySelector('option[value="' + value + '"]');
		}

		/**
		 * Builds the options for province selector
		 */
		function buildOptions(provinceNodeElement, provinces) {
			var defaultValue = provinceNodeElement.getAttribute("data-default");

			provinces.forEach(function (option) {
				var optionElement = document.createElement("option");
				optionElement.value = option[0];
				optionElement.textContent = option[1];

				provinceNodeElement.appendChild(optionElement);
			});

			if (defaultValue && getOption(provinceNodeElement, defaultValue)) {
				provinceNodeElement.value = defaultValue;
			}
		}

		/**
		 * Builds the province selector
		 */
		function buildProvince(
			countryNodeElement,
			provinceNodeElement,
			selectedValue
		) {
			var selectedOption = getOption(countryNodeElement, selectedValue);
			var provinces = JSON.parse(selectedOption.getAttribute("data-provinces"));

			provinceNodeElement.options.length = 0;

			if (provinces.length) {
				buildOptions(provinceNodeElement, provinces);
			}

			return provinces;
		} // CONCATENATED MODULE: ./node_modules/@pixelunion/shopify-asyncview/dist/index.es.js

		/*!
		 * @pixelunion/shopify-asyncview v3.0.0
		 * (c) 2020 Pixel Union
		 */

		function dist_index_es_classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function index_es_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function index_es_createClass(Constructor, protoProps, staticProps) {
			if (protoProps)
				index_es_defineProperties(Constructor.prototype, protoProps);
			if (staticProps) index_es_defineProperties(Constructor, staticProps);
			return Constructor;
		}

		function _defineProperty(obj, key, value) {
			if (key in obj) {
				Object.defineProperty(obj, key, {
					value: value,
					enumerable: true,
					configurable: true,
					writable: true,
				});
			} else {
				obj[key] = value;
			}

			return obj;
		}

		function ownKeys(object, enumerableOnly) {
			var keys = Object.keys(object);

			if (Object.getOwnPropertySymbols) {
				var symbols = Object.getOwnPropertySymbols(object);
				if (enumerableOnly)
					symbols = symbols.filter(function (sym) {
						return Object.getOwnPropertyDescriptor(object, sym).enumerable;
					});
				keys.push.apply(keys, symbols);
			}

			return keys;
		}

		function _objectSpread2(target) {
			for (var i = 1; i < arguments.length; i++) {
				var source = arguments[i] != null ? arguments[i] : {};

				if (i % 2) {
					ownKeys(Object(source), true).forEach(function (key) {
						_defineProperty(target, key, source[key]);
					});
				} else if (Object.getOwnPropertyDescriptors) {
					Object.defineProperties(
						target,
						Object.getOwnPropertyDescriptors(source)
					);
				} else {
					ownKeys(Object(source)).forEach(function (key) {
						Object.defineProperty(
							target,
							key,
							Object.getOwnPropertyDescriptor(source, key)
						);
					});
				}
			}

			return target;
		}

		function _slicedToArray(arr, i) {
			return (
				_arrayWithHoles(arr) ||
				_iterableToArrayLimit(arr, i) ||
				index_es_unsupportedIterableToArray(arr, i) ||
				_nonIterableRest()
			);
		}

		function _arrayWithHoles(arr) {
			if (Array.isArray(arr)) return arr;
		}

		function _iterableToArrayLimit(arr, i) {
			if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr)))
				return;
			var _arr = [];
			var _n = true;
			var _d = false;
			var _e = undefined;

			try {
				for (
					var _i = arr[Symbol.iterator](), _s;
					!(_n = (_s = _i.next()).done);
					_n = true
				) {
					_arr.push(_s.value);

					if (i && _arr.length === i) break;
				}
			} catch (err) {
				_d = true;
				_e = err;
			} finally {
				try {
					if (!_n && _i["return"] != null) _i["return"]();
				} finally {
					if (_d) throw _e;
				}
			}

			return _arr;
		}

		function index_es_unsupportedIterableToArray(o, minLen) {
			if (!o) return;
			if (typeof o === "string") return index_es_arrayLikeToArray(o, minLen);
			var n = Object.prototype.toString.call(o).slice(8, -1);
			if (n === "Object" && o.constructor) n = o.constructor.name;
			if (n === "Map" || n === "Set") return Array.from(n);
			if (
				n === "Arguments" ||
				/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
			)
				return index_es_arrayLikeToArray(o, minLen);
		}

		function index_es_arrayLikeToArray(arr, len) {
			if (len == null || len > arr.length) len = arr.length;

			for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

			return arr2;
		}

		function _nonIterableRest() {
			throw new TypeError(
				"Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
			);
		}

		var deferred = {};

		var AsyncView = /*#__PURE__*/ (function () {
			function AsyncView() {
				dist_index_es_classCallCheck(this, AsyncView);
			}

			index_es_createClass(AsyncView, null, [
				{
					key: "load",

					/**
					 * Load the template given by the provided URL into the provided
					 * view
					 *
					 * @param {string} url - The url to load
					 * @param {string} sectionId - The ID of the section to load
					 * @param {object} [options] - Configuration options
					 * @param {string} [options.hash] - A hash used to cache content
					 * @param {object} [options.query] - An object containing additional query parameters of the URL
					 */
					value: function load(url, sectionId) {
						var options =
							arguments.length > 2 && arguments[2] !== undefined
								? arguments[2]
								: {};
						var querylessUrl = url.replace(/\?[^#]+/, "");
						var queryParamsString = new RegExp(/.+\?([^#]+)/).exec(url);
						var queryParams = {
							section_id: sectionId,
						};

						if ("query" in options) {
							queryParams = _objectSpread2({}, queryParams, {}, options.query);
						}

						if (queryParamsString && queryParamsString.length >= 2) {
							queryParamsString[1].split("&").forEach(function (param) {
								var _param$split = param.split("="),
									_param$split2 = _slicedToArray(_param$split, 2),
									key = _param$split2[0],
									value = _param$split2[1];

								queryParams[key] = value;
							});
						} // NOTE: We're adding an additional timestamp to the query.
						// This is to prevent certain browsers from returning cached
						// versions of the url we are requesting.
						// See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4

						var cachebustingParams = _objectSpread2({}, queryParams, {
							_: new Date().getTime(),
						});

						var hashUrl = querylessUrl.replace(
							/([^#]+)(.*)/,
							function (match, address, hash) {
								return ""
									.concat(address, "?")
									.concat(
										Object.keys(queryParams)
											.sort()
											.map(function (key) {
												return ""
													.concat(key, "=")
													.concat(encodeURIComponent(queryParams[key]));
											})
											.join("&")
									)
									.concat(hash);
							}
						);
						var requestUrl = querylessUrl.replace(
							/([^#]+)(.*)/,
							function (match, address, hash) {
								return ""
									.concat(address, "?")
									.concat(
										Object.keys(cachebustingParams)
											.sort()
											.map(function (key) {
												return ""
													.concat(key, "=")
													.concat(encodeURIComponent(cachebustingParams[key]));
											})
											.join("&")
									)
									.concat(hash);
							}
						);
						var promise = new Promise(function (resolve, reject) {
							var data;

							if (hashUrl in deferred) {
								resolve(deferred[hashUrl]);
								return;
							}

							deferred[hashUrl] = promise;

							if (options.hash) {
								data = sessionStorage.getItem(hashUrl);

								if (data) {
									var deserialized = JSON.parse(data);

									if (options.hash === deserialized.options.hash) {
										delete deferred[hashUrl];
										resolve(deserialized);
										return;
									}
								}
							}

							var xhr = new XMLHttpRequest();
							xhr.open("GET", requestUrl, true);

							xhr.onload = function () {
								var el = xhr.response;
								var newOptions = {};
								var optionsEl = el.querySelector("[data-options]");

								if (optionsEl && optionsEl.innerHTML) {
									newOptions = JSON.parse(
										el.querySelector("[data-options]").innerHTML
									);
								}

								var htmlEls = el.querySelectorAll("[data-html]");
								var newHtml = {};

								if (
									htmlEls.length === 1 &&
									htmlEls[0].getAttribute("data-html") === ""
								) {
									newHtml = htmlEls[0].innerHTML;
								} else {
									for (var i = 0; i < htmlEls.length; i++) {
										newHtml[htmlEls[i].getAttribute("data-html")] =
											htmlEls[i].innerHTML;
									}
								}

								var dataEls = el.querySelectorAll("[data-data]");
								var newData = {};

								if (
									dataEls.length === 1 &&
									dataEls[0].getAttribute("data-data") === ""
								) {
									newData = JSON.parse(dataEls[0].innerHTML);
								} else {
									for (var _i = 0; _i < dataEls.length; _i++) {
										newData[dataEls[_i].getAttribute("data-data")] = JSON.parse(
											dataEls[_i].innerHTML
										);
									}
								}

								if (options.hash) {
									try {
										sessionStorage.setItem(
											hashUrl,
											JSON.stringify({
												options: newOptions,
												data: newData,
												html: newHtml,
											})
										);
									} catch (error) {
										console.error(error);
									}
								}

								delete deferred[hashUrl];
								resolve({
									data: newData,
									html: newHtml,
								});
							};

							xhr.onerror = function () {
								delete deferred[hashUrl];
								reject();
							};

							xhr.responseType = "document";
							xhr.send();
						});
						return promise;
					},
				},
			]);

			return AsyncView;
		})();

		/* harmony default export */ const shopify_asyncview_dist_index_es =
			AsyncView;

		// EXTERNAL MODULE: ./node_modules/@pixelunion/events/dist/EventHandler.js
		var EventHandler = __webpack_require__(766); // CONCATENATED MODULE: ./source/scripts/helpers/QuantitySelector.js
		class QuantitySelector {
			constructor(_ref) {
				let { quantityField, onChange } = _ref;
				this.events = new EventHandler /* default */.Z();
				this.field = quantityField;
				this.input = this.field.querySelector("[data-quantity-input]");
				this.plus = this.field.querySelector("[data-quantity-plus]");
				this.minus = this.field.querySelector("[data-quantity-minus]");
				this.minusButtonWrapper = this.field.querySelector(
					"[data-button-wrapper-minus]"
				);
				this.incrementValue = parseInt(this.input.dataset.incrementValue, 10);
				this.increaseAmount = this.increaseAmount.bind(this);
				this.decreaseAmount = this.decreaseAmount.bind(this);
				this.onChange = onChange
					? just_debounce_default()(onChange, 50)
					: () => {};
				this.registerEvents();
			}

			registerEvents() {
				this.increaseAmountClickEvent = this.events.register(
					this.plus,
					"click",
					(e) => this.increaseAmount(e)
				);
				this.decreaseAmountClickEvent = this.events.register(
					this.minus,
					"click",
					(e) => this.decreaseAmount(e)
				);
				this.setAmountChangeEvent = this.events.register(
					this.input,
					"change",
					(e) => this.setAmount(e)
				);
				this.quantityKeyUpEvent = this.events.register(
					this.input,
					"keyup",
					(e) => this.quantityKeyUp(e)
				);
				this.quantityKeyDownEvent = this.events.register(
					this.input,
					"keydown",
					(e) => this.quantityKeyDown(e)
				);

				this._updateMinusButton();
			}

			setAmount(e) {
				e.preventDefault();

				const count = this._getCount();

				if (!count) {
					this.input.value = this.incrementValue;
				}

				this._updateMinusButton();

				this.onChange(e.currentTarget);
			}

			_getCount() {
				return this.input.valueAsNumber;
			}

			increaseAmount(e) {
				e.preventDefault();

				const count = this._getCount();

				this.input.value = count + this.incrementValue;

				this._updateMinusButton();

				this.onChange(e.currentTarget);
			}

			decreaseAmount(e) {
				e.preventDefault();

				const count = this._getCount();

				this.input.value = count - this.incrementValue;

				this._updateMinusButton();

				this.onChange(e.currentTarget);
			}

			quantityKeyUp(e) {
				if (e.key === "Backspace") {
					return;
				}

				this._updateMinusButton();

				this.onChange(e.currentTarget);
			}

			quantityKeyDown(e) {
				if (e.key === "Enter") {
					e.preventDefault();
				}
			}

			_updateMinusButton() {
				const count = this._getCount();

				if (count <= this.incrementValue) {
					this.minusButtonWrapper.classList.add(
						"quantity-selector__button-wrapper--disabled"
					);
				} else {
					this.minusButtonWrapper.classList.remove(
						"quantity-selector__button-wrapper--disabled"
					);
				}
			}

			unload() {
				this.events.unregisterAll();
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/StaticCart.js
		class StaticCart {
			constructor(section) {
				this.settings = section.data.settings;
				this.shipping = section.data.shipping;
				this.updateTimeout = null;
				this.$window = jquery_default()(window);
				this.$el = jquery_default()(section.el);
				this.el = section.el;
				this.events = new EventHandler /* default */.Z();
				this.totals = this.el.querySelectorAll("[data-cart-total]");
				this.$shipping = this.$el.find("[data-cartshipping]");
				this.$cartSidebar = this.$el.find("[data-cart-sidebar]"); // Quantity selector

				this.quantitySelectors = [];
				this.inputFields = this.el.querySelectorAll("[data-quantity-input]"); // Product form containers

				this.$titleTotalSmall = this.$el.find(".cart-title-total--small");
				this.$titleTotalLarge = this.$el.find(".cart-title-total--large");
				this.$titleTotalContents = this.$el.find("[data-cart-title-total]"); // Cart list

				this.cartItemList = this.$el[0].querySelector("[data-cart-item-list]");
				this.cartDiscounts = this.$el[0].querySelector("[data-cart-discounts]"); // Shipping calculator elements

				this.$shippingToggle = this.$el.find("[data-cartshipping-toggle]");
				this.$shippingResponse = this.$shipping.find(
					"[data-cartshipping-response]"
				);
				this.$shippingResponseMessage = this.$shippingResponse.find(
					"[data-cartshipping-message]"
				);
				this.$shippingResponseRates = this.$shippingResponse.find(
					"[data-cartshipping-rates]"
				);
				this.$shippingSubmit = this.$shipping.find(
					"[data-cartshipping-submit]"
				);

				this._moveTitleTotal();

				const $scripts = jquery_default()("[data-scripts]");
				this._editItemQuantity = this._editItemQuantity.bind(this);
				this.inputFields.forEach((input) => {
					this.quantitySelectors.push(
						new QuantitySelector({
							quantityField: input.parentNode,
							onChange: this._editItemQuantity,
						})
					);
				});
				script_default()($scripts.data("shopify-api-url"), () => {
					this._bindEvents();

					window.Shopify.onError = this._handleErrors.bind(this);
				});
				this.forms = new Forms(this.$el);

				if (this.settings.shipping && this.$shipping.length) {
					script_default()($scripts.data("shopify-countries"), () => {
						script_default()($scripts.data("shopify-common"), () => {
							this._initShippingCalc();
						});
					});
				}

				if (this.$cartSidebar.length) {
					new RichText(this.$cartSidebar);
				}
			}

			onSectionUnload() {
				this.$el.off(".cart-page");
				this.$window.off(".cart-page");
				this.forms.unload();
			}

			_bindEvents() {
				// this.$el.on('click.cart-page', '[data-cartitem-remove]', event => {
				//   event.preventDefault();
				//   this._editItemQuantity(event.currentTarget, true);
				// });
				this.$window.on(
					"resize.cart-page",
					just_debounce_default()(() => this._moveTitleTotal(), 20)
				);
			}
			/**
			 * Gets the current value of the quantity input box for a given line item key
			 *
			 * @param {string} key
			 */

			_getItemQuantity(key) {
				return parseInt(
					this.el.querySelector(
						`[data-cartitem-key="${key}"] [data-quantity-input]`
					).value,
					10
				);
			}

			_moveTitleTotal() {
				if (!this.$titleTotalContents.length) {
					return;
				}

				if (this.$window.outerWidth() >= 480) {
					if (
						!jquery_default().contains(
							this.$titleTotalLarge[0],
							this.$titleTotalContents[0]
						)
					) {
						const $form = this.$titleTotalContents.detach();
						this.$titleTotalLarge.append($form);
					}
				} else if (
					!jquery_default().contains(
						this.$titleTotalSmall[0],
						this.$titleTotalContents[0]
					)
				) {
					const $form = this.$titleTotalContents.detach();
					this.$titleTotalSmall.append($form);
				}
			}
			/**
			 * Handle an item quantity change
			 *
			 * @param event
			 * @param {Boolean} remove - Set as true to remove cart item
			 * @private
			 */

			_editItemQuantity(target) {
				let remove =
					arguments.length > 1 && arguments[1] !== undefined
						? arguments[1]
						: false;
				const $target = jquery_default()(target);
				const cartItemRow = $target.closest("[data-cartitem-id]")[0];

				if (remove) {
					cartItemRow.classList.add("removing");
				}

				const quantity = remove
					? 0
					: parseInt(
							cartItemRow.querySelector("[data-quantity-input]").value,
							10
					  );
				const key = cartItemRow.getAttribute("data-cartitem-key");

				this._updateCart(key, quantity);
			}
			/**
			 * Update cart with a valid quantity
			 *
			 * @param $cartItem
			 * @param quantity
			 * @private
			 */

			_updateCart(key, quantity) {
				// cancel any pending requests
				if (this.updateTimeout !== null) {
					clearTimeout(this.updateTimeout);
				}

				this.updateTimeout = setTimeout(() => {
					if (quantity > 0 && this._getItemQuantity(key) !== quantity) {
						this.updateTimeout = null;
						return;
					}

					const thisTimeoutId = this.updateTimeout; // Notify Shopify updated item

					window.Shopify.changeItem(key, quantity, (response) => {
						if (this.updateTimeout !== thisTimeoutId) {
							return;
						}

						this._didUpdate(response, thisTimeoutId);
					});
				}, 300);
			}
			/**
			 * Fetches new cart contents and swaps into page
			 *
			 * @param response
			 * @param {integer} thisTimeoutId Id of timeout for this request. If no longer current, update is cancelled.
			 * @returns {*}
			 * @private
			 */

			_didUpdate(response, thisTimeoutId) {
				// Reload page if all items are removed from cart
				if (!response.items.length) {
					window.location = window.Theme.routes.cart_url;
					return;
				} // Reload the cart-item-list and the discounts snippets

				shopify_asyncview_dist_index_es
					.load(window.Theme.routes.cart_url, "cart-ajax", {
						view: "_ajax",
					})
					.then((_ref) => {
						let { html } = _ref;

						// If another request is in progress, discard this update
						if (this.updateTimeout !== thisTimeoutId) {
							return;
						}

						const countEvent = new CustomEvent("cartcount:update", {
							detail: response,
						});
						window.dispatchEvent(countEvent); // Unregister QuantitySelector events

						this.quantitySelectors.forEach((selector) => {
							selector.unload();
						}); // Inject new cart list contents

						const newListContainer = document.createElement("div");
						newListContainer.innerHTML = html.list;
						morphdom_esm(
							this.cartItemList,
							newListContainer.querySelector("ul"),
							{
								onBeforeElUpdated: (fromEl, toEl) => {
									// Skip images if src matches
									// - we don't want to reload lazy loaded images
									if (fromEl.tagName === "IMG" && fromEl.src === toEl.src) {
										return false;
									}

									return true;
								},
							}
						); // Update cart totals

						this.totals.forEach((total) => {
							const newTotal = total;
							newTotal.innerHTML = html.cart_total;
							morphdom_esm(total, newTotal, {
								childrenOnly: true,
							});
						});
						dist_index_es.watch(this.cartItemList);
						this.forms.unload();
						this.forms = new Forms(this.$el);
						this.inputFields.forEach((input) => {
							this.quantitySelectors.push(
								new QuantitySelector({
									quantityField: input.parentNode,
									onChange: this._editItemQuantity,
								})
							);
						});
						this.$el.off("click.cart-page", "[data-cartitem-remove]");
						this.$el.on(
							"click.cart-page",
							"[data-cartitem-remove]",
							(event) => {
								event.preventDefault();

								this._editItemQuantity(event.currentTarget, true);
							}
						); // Inject new cart level discounts

						this.cartDiscounts.innerHTML = html.discounts;
					})
					.catch(() => window.location.reload());
			}
			/**
			 * Handle Errors returned from Shopify
			 *
			 * @param errors
			 * @private
			 */

			_handleErrors() {
				let errors =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: null;

				if (!errors) {
					return;
				}

				const shippingResponse = {
					message: this.shipping.error_general,
				};

				if (errors.zip && errors.zip.length > 0) {
					if (
						errors.zip[0].indexOf("is not valid") !== -1 ||
						errors.zip[0].indexOf("can't be blank") !== -1
					) {
						shippingResponse.message = `${this.shipping.zip} ${errors.zip}`;
					}
				}

				if (errors.error && errors.error.length > 0) {
					if (errors.error[0].indexOf("shipment_too_heavy") !== -1) {
						shippingResponse.message = this.shipping.shipment_too_heavy;
					}
				}

				this._handleShippingResponse(shippingResponse);
			}

			_initShippingCalc() {
				this._bindShippingCalcEvents();

				const countrySelect = document.getElementById("address_country");
				const provinceSelect = document.getElementById("address_province");
				const provinceContainer = document.getElementById(
					"address_province_container"
				);
				this.shippingCountryProvinceSelector = new CountryProvinceSelector(
					countrySelect.innerHTML
				);
				this.shippingCountryProvinceSelector.build(
					countrySelect,
					provinceSelect,
					{
						onCountryChange: (provinces) => {
							if (provinces.length) {
								provinceContainer.style.display = "block";
							} else {
								provinceContainer.style.display = "none";
							} // "Province", "State", "Region", etc. and "Postal Code", "ZIP Code", etc.
							// Even countries without provinces include a label.

							const { label, zip_label: zipLabel } =
								window.Countries[countrySelect.value];
							provinceContainer.querySelector(
								'label[for="address_province"]'
							).innerHTML = label;
							this.el.querySelector(
								'#address_zip ~ label[for="address_zip"]'
							).innerHTML = zipLabel;
						},
					}
				);
			}

			_bindShippingCalcEvents() {
				this.$el.on("click.cart-page", "[data-cartshipping-toggle]", () => {
					this._toggleShippingCalc();
				});
				this.$el.on("click.cart-page", "[data-cartshipping-submit]", () => {
					this._getShippingRates();
				});
				this.$el.on("keypress.cart-page", "#address_zip", (event) => {
					if (event.keyCode === 10 || event.keyCode === 13) {
						event.preventDefault();
						this.$shippingSubmit.trigger("click");
					}
				});
			}

			_toggleShippingCalc() {
				const oldText = this.$shippingToggle.text();
				const newText = this.$shippingToggle.data("cartshipping-toggle");
				this.$shippingToggle.html(newText).data("cartshipping-toggle", oldText);
				this.$shipping.toggleClass("open");
			}

			_getShippingRates() {
				this._disableShippingButton();

				const shippingAddress = {};
				shippingAddress.country =
					jquery_default()("#address_country").val() || "";
				shippingAddress.province =
					jquery_default()("#address_province").val() || "";
				shippingAddress.zip = jquery_default()("#address_zip").val() || "";
				const queryString = Object.keys(shippingAddress)
					.map(
						(key) =>
							`${encodeURIComponent(
								`shipping_address[${key}]`
							)}=${encodeURIComponent(shippingAddress[key])}`
					)
					.join("&");
				jquery_default()
					.ajax(
						`${window.Theme.routes.cart_url}/shipping_rates.json?${queryString}`,
						{
							dataType: "json",
						}
					)
					.fail((error) => this._handleErrors(error.responseJSON || {}))
					.done((response) => {
						const rates = response.shipping_rates;
						const addressBase = [];

						if (shippingAddress.zip.length) {
							addressBase.push(shippingAddress.zip.trim());
						}

						if (shippingAddress.province.length) {
							addressBase.push(shippingAddress.province);
						}

						if (shippingAddress.country.length) {
							addressBase.push(shippingAddress.country);
						}

						const address = addressBase.join(", ");
						let message = "";

						if (rates.length > 1) {
							const firstRate = window.Shopify.formatMoney(
								rates[0].price,
								this.settings.money_format
							);
							message = this.shipping.multiple_rates
								.replace("*address*", address)
								.replace("*number_of_rates*", rates.length)
								.replace("*rate*", `<span class="money">${firstRate}</span>`);
						} else if (rates.length === 1) {
							message = this.shipping.one_rate.replace("*address*", address);
						} else {
							message = this.shipping.no_rates;
						}

						const ratesList = rates.map((rate) => {
							const price = window.Shopify.formatMoney(
								rate.price,
								this.settings.money_format
							);
							const rateValue = this.shipping.rate_value
								.replace("*rate_title*", rate.name)
								.replace("*rate*", `<span class="money">${price}</span>`);
							return `<li>${rateValue}</li>`;
						});

						this._handleShippingResponse({
							message,
							rates: ratesList,
						});
					});
			}

			_enableShippingButton() {
				this.$shippingSubmit
					.html(this.shipping.calculate_shipping)
					.attr("disabled", false);
			}

			_disableShippingButton() {
				this.$shippingSubmit
					.html(this.shipping.calculating)
					.attr("disabled", true);
			}

			_showShippingResponse() {
				this.$shippingResponse.addClass("visible");
			}

			_hideShippingResponse() {
				this.$shippingResponse.removeClass("visible");
			}
			/**
			 * Handle shipping responses
			 *
			 * @param {object} shippingResponse
			 * @property {String} shippingResponse.messages - Error / Success message
			 * @property {Array|String} shippingResponse.rates - Shipping rates
			 * @private
			 */

			_handleShippingResponse() {
				let shippingResponse =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: {};

				// Hide the response so that it can be populated smoothly
				this._hideShippingResponse();

				const message = shippingResponse.message || null;
				const rates = shippingResponse.rates || null; // Empty out contents

				this.$shippingResponseMessage.empty();
				this.$shippingResponseRates.empty();

				if (message) {
					this.$shippingResponseMessage.html(message);
				}

				if (rates) {
					this.$shippingResponseRates.html(rates);
				} // Reset the calculating button so it can be used again

				this._enableShippingButton(); // No error provided

				if (!message && !rates) {
					return;
				} // Show the response

				this._showShippingResponse();
			}
		} // CONCATENATED MODULE: ./node_modules/@pixelunion/animations/dist/animations.es.js
		/*!
		 * @pixelunion/animations v0.1.0
		 * (c) 2019 Pixel Union
		 * Released under the UNLICENSED license.
		 */

		function animations_es_classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function animations_es_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function animations_es_createClass(Constructor, protoProps, staticProps) {
			if (protoProps)
				animations_es_defineProperties(Constructor.prototype, protoProps);
			if (staticProps) animations_es_defineProperties(Constructor, staticProps);
			return Constructor;
		}

		function animations_es_defineProperty(obj, key, value) {
			if (key in obj) {
				Object.defineProperty(obj, key, {
					value: value,
					enumerable: true,
					configurable: true,
					writable: true,
				});
			} else {
				obj[key] = value;
			}

			return obj;
		}

		function animations_es_ownKeys(object, enumerableOnly) {
			var keys = Object.keys(object);

			if (Object.getOwnPropertySymbols) {
				var symbols = Object.getOwnPropertySymbols(object);
				if (enumerableOnly)
					symbols = symbols.filter(function (sym) {
						return Object.getOwnPropertyDescriptor(object, sym).enumerable;
					});
				keys.push.apply(keys, symbols);
			}

			return keys;
		}

		function animations_es_objectSpread2(target) {
			for (var i = 1; i < arguments.length; i++) {
				var source = arguments[i] != null ? arguments[i] : {};

				if (i % 2) {
					animations_es_ownKeys(source, true).forEach(function (key) {
						animations_es_defineProperty(target, key, source[key]);
					});
				} else if (Object.getOwnPropertyDescriptors) {
					Object.defineProperties(
						target,
						Object.getOwnPropertyDescriptors(source)
					);
				} else {
					animations_es_ownKeys(source).forEach(function (key) {
						Object.defineProperty(
							target,
							key,
							Object.getOwnPropertyDescriptor(source, key)
						);
					});
				}
			}

			return target;
		}

		/**
		 * Promisified version of window.requestAnimationFrame.
		 * @returns {Promise} Promise will resolve when requestAnimationFrame callback is run.
		 */
		function raf() {
			return new Promise(function (resolve) {
				window.requestAnimationFrame(resolve);
			});
		}
		/**
		 * Represents an HTML element with associate states
		 */

		var Animation =
			/*#__PURE__*/
			(function () {
				/**
				 * @param {Object} options
				 * @param {HTMLElement}  options.el Target element
				 * @param {String} [options.state=initial] Initial state. This is also the default state.
				 * @param {String} [options.stateAttribute=data-revealer] Attribute name to update with state.
				 * @param {String} [options.stateChangeAttribute=data-revealer-transition] Attribute name to
				 * update with change of state.
				 * @param {String} [options.endEvent=transitionend] Event to listen for at end of state change.
				 * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
				 * next state change.
				 * @param {Function} [options.onStart] Callback to execute immediate after
				 * applying stateChangeAttribute.
				 */
				function Animation(options) {
					animations_es_classCallCheck(this, Animation);

					this._el = options.el;
					this.cancelRunning = null;
					this._state = options.state || "initial";
					this.initialState = this._state;
					this.stateAttribute =
						options.stateAttribute || "data-animation-state";
					this.stateChangeAttribute =
						options.stateChangeAttribute || "data-animation";
					this.endEvent = options.endEvent || "transitionend";
					this.hold = !!options.hold;

					this.onStart =
						options.onStart ||
						function () {
							/* do nothing */
						};

					this.activeEventHandler = null;
				}
				/**
				 * Returns target element
				 *
				 * @return {HTMLElement} Target element
				 */

				animations_es_createClass(Animation, [
					{
						key: "isState",

						/**
						 * Check if a state is active
						 * @param {String} state State to compare
						 *
						 * @return {Boolean}
						 */
						value: function isState(state) {
							return state === this._state;
						},
						/**
						 * Sequences a change to a new state.
						 * @param {String} state Target state
						 *
						 * @param {Boolean} options.force Switch to final state immediately
						 *
						 * @param {Function} options.onStart Callback to execute immediately after
						 * applying stateChangeAttribute for this state change only.
						 *
						 * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
						 * next state change.
						 *
						 * @return {Promise} Resolves when endEvent triggered
						 */
					},
					{
						key: "animateTo",
						value: function animateTo(state) {
							var _this = this;

							var options =
								arguments.length > 1 && arguments[1] !== undefined
									? arguments[1]
									: {};
							var from = this._el.dataset[this.stateAttribute] || this._state;
							var to = state || this.initialState;
							var force = options.force;
							var hold = "hold" in options ? options.hold : this.hold;
							return new Promise(function (resolve) {
								if (_this.cancelRunning) {
									_this.cancelRunning();
								}

								if (from === to) {
									// Removing this here fixes some lingering attributes. But why?
									_this._el.removeAttribute(_this.stateChangeAttribute);

									resolve(from, null);
									return;
								}

								var running = true;

								_this.cancelRunning = function () {
									running = false;
									resolve(null, null);
								};

								_this._el.removeEventListener(
									_this.endEvent,
									_this.activeEventHandler
								);

								_this.activeEventHandler = null;

								if (force) {
									_this._el.setAttribute(
										_this.stateChangeAttribute,
										"".concat(from, "=>").concat(to)
									);

									_this.onStart({
										el: _this._el,
										from: from,
										to: to,
									});

									if (typeof options.onStart === "function") {
										options.onStart({
											el: _this._el,
											from: from,
											to: to,
										});
									}

									_this._el.setAttribute(_this.stateAttribute, to);

									_this._state = to;

									if (!hold) {
										_this._el.removeAttribute(_this.stateChangeAttribute);
									}

									resolve(to, null);
									return;
								}

								raf()
									.then(function () {
										if (!running) throw new Error("cancelled");

										_this._el.setAttribute(
											_this.stateChangeAttribute,
											"".concat(from, "=>").concat(to)
										);

										_this.onStart({
											el: _this._el,
											from: from,
											to: to,
										});

										if (typeof options.onStart === "function") {
											options.onStart({
												el: _this._el,
												from: from,
												to: to,
											});
										}

										return raf();
									})
									.then(function () {
										if (!running) throw new Error("cancelled");

										_this._el.removeEventListener(
											_this.endEvent,
											_this.activeEventHandler
										);

										_this.activeEventHandler = function (e) {
											// Ignore any events bubbling up
											if (e.target !== _this._el || !running) return;

											_this._el.removeEventListener(
												_this.endEvent,
												_this.activeEventHandler
											);

											if (!hold) {
												_this._el.removeAttribute(_this.stateChangeAttribute);
											}

											resolve(to, e);
										};

										_this._el.addEventListener(
											_this.endEvent,
											_this.activeEventHandler
										);

										_this._el.setAttribute(_this.stateAttribute, to);

										_this._state = to;
									})
									["catch"](function (error) {
										// Only catch 'cancelled' errors.
										if (error.message !== "cancelled") throw error;
									});
							});
						},
						/**
						 * Remove any event listeners
						 */
					},
					{
						key: "unload",
						value: function unload() {
							this._el.removeEventListener(
								this.endEvent,
								this.activeEventHandler
							);

							this.activeEventHandler = null;
						},
					},
					{
						key: "el",
						get: function get() {
							return this._el;
						},
						/**
						 * Returns current state
						 *
						 * @return {String} Current state
						 */
					},
					{
						key: "state",
						get: function get() {
							return this._state;
						},
					},
				]);

				return Animation;
			})();

		/**
		 * Manage state changes for a set of elements
		 */

		var AnimationsManager =
			/*#__PURE__*/
			/* unused pure expression or super */ null &&
			(function () {
				function AnimationsManager() {
					animations_es_classCallCheck(this, AnimationsManager);

					this.animations = new Map();
				}
				/**
				 * Add a new element and return an animation for that element. If element already has an associated animation, return that animation.
				 * @param {Object} options
				 * @param {HTMLElement}  options.el Target element
				 * @param {String} [options.state=initial] Initial state. This is also the default state.
				 * @param {String} [options.stateAttribute=data-revealer] Attribute name to update with state.
				 * @param {String} [options.stateChangeAttribute=data-revealer-transition] Attribute name to update with change of state.
				 * @param {String} [options.endEvent=transitionend] Event name to listen for at end of state change.
				 * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the next state change.
				 * @param {Function} [options.onStart] Callback to execute immediate after applying stateChangeAttribute.
				 *
				 * @return {Animation}
				 */

				animations_es_createClass(AnimationsManager, [
					{
						key: "add",
						value: function add(options) {
							if (this.animations.has(options.el))
								return this.animations.get(options.el);
							var animation = new Animation(options);
							this.animations.set(options.el, animation);
							return animation;
						},
						/**
						 * Remove a single animation
						 * @param {Animation} animation Animation to remove. Any event listeners will also be removed.
						 */
					},
					{
						key: "remove",
						value: function remove(animation) {
							this.animations["delete"](animation.el);
							animation.unload();
						},
						/**
						 * Remove all animations, including all event listeners.
						 */
					},
					{
						key: "removeAll",
						value: function removeAll() {
							this.animations.forEach(function (animation) {
								return animation.unload();
							});
						},
					},
				]);

				return AnimationsManager;
			})();

		function animation(options) {
			var setOptions = {
				endEvent: "animationend",
				hold: true,
			};
			return new Animation(
				animations_es_objectSpread2(
					{
						options: options,
					},
					setOptions
				)
			);
		}

		function transition(options) {
			return new Animation(options);
		}

		// EXTERNAL MODULE: ./node_modules/@pixelunion/breakpoint/dist/cjs/index.js
		var cjs = __webpack_require__(646);
		// EXTERNAL MODULE: ./node_modules/flickity/js/index.js
		var js = __webpack_require__(442);
		var js_default = /*#__PURE__*/ __webpack_require__.n(js); // CONCATENATED MODULE: ./source/scripts/Layout.js
		const eventHandlers = [];
		let previousBreakpoint = null;

		function getBreakpoints() {
			return window
				.getComputedStyle(document.documentElement, ":before")
				.getPropertyValue("content")
				.replace(/"/g, "")
				.split(",");
		}

		function getBreakpoint() {
			return window
				.getComputedStyle(document.documentElement, ":after")
				.getPropertyValue("content")
				.replace(/"/g, "");
		}

		jquery_default()(window).on("resize", (event) => {
			const currentBreakpoint = getBreakpoint();

			if (previousBreakpoint !== currentBreakpoint) {
				eventHandlers.forEach((eventHandler) => {
					eventHandler(event, {
						previous: previousBreakpoint,
						current: currentBreakpoint,
					});
				});
			}

			previousBreakpoint = currentBreakpoint;
		});

		function isLessThanBreakpoint(breakpoint) {
			let inclusive =
				arguments.length > 1 && arguments[1] !== undefined
					? arguments[1]
					: false;
			const breakpoints = getBreakpoints();
			const currentBreakpoint = getBreakpoint();
			const comparison =
				breakpoints.indexOf(currentBreakpoint) -
				breakpoints.indexOf(breakpoint);
			return inclusive ? comparison <= 0 : comparison < 0;
		}

		function isGreaterThanBreakpoint(breakpoint) {
			let inclusive =
				arguments.length > 1 && arguments[1] !== undefined
					? arguments[1]
					: false;
			const breakpoints = getBreakpoints();
			const currentBreakpoint = getBreakpoint();
			const comparison =
				breakpoints.indexOf(currentBreakpoint) -
				breakpoints.indexOf(breakpoint);
			return inclusive ? comparison >= 0 : comparison > 0;
		}

		function isBreakpoint() {
			const currentBreakpoint = getBreakpoint();

			for (
				var _len = arguments.length, breakpoints = new Array(_len), _key = 0;
				_key < _len;
				_key++
			) {
				breakpoints[_key] = arguments[_key];
			}

			return breakpoints.some((breakpoint) => breakpoint === currentBreakpoint);
		}

		function onBreakpointChange(eventHandler) {
			if (eventHandlers.indexOf(eventHandler) === -1) {
				eventHandlers.push(eventHandler);
			}
		}

		function offBreakpointChange(eventHandler) {
			const index = eventHandlers.indexOf(eventHandler);

			if (index !== -1) {
				eventHandlers.splice(index, 1);
			}
		}

		/* harmony default export */ const Layout = {
			isLessThanBreakpoint,
			isGreaterThanBreakpoint,
			isBreakpoint,
			onBreakpointChange,
			offBreakpointChange,
		}; // CONCATENATED MODULE: ./source/scripts/helpers/LazyLoader.js
		/**
		 * Allows a callback to be run once, when a target intersects the viewport.
		 * @constructor
		 * @param {HTMLElement} target Element to track
		 * @param {Function} callback Function to execute when target enters viewport (only executed once)
		 * @param {Object} [options] options with which to construct the IntersectionObserver
		 * @param {string} [options.rootMargin='30%'] A string which specifies a set of offsets to add to the root's bounding_box when calculating intersections.
		 * @param {number} [options.threshold=0] Ratio of intersection required to trigger callback
		 */
		class LazyLoader_LazyLoader {
			constructor(target, callback, options) {
				const defaultOptions = {
					rootMargin: "30%",
					threshold: 0,
				};
				this.callback = callback;
				this._runCallback = this._runCallback.bind(this);
				this.observer = new IntersectionObserver(this._runCallback, {
					...defaultOptions,
					...options,
				});
				this.observer.observe(target);
			}
			/**
			 * Runs the callback if first entry becomes intersecting, then unloads the LazyLoader
			 * @_runCallback
			 * @param {IntersectionObserverEntry[]} entries Entry to check - all but the
			 * first element will be ignored.
			 */

			_runCallback(entries) {
				// do nothing unless target moved into state of intersection
				if (entries[0].isIntersecting === true) {
					this.unload();
					this.callback();
				}
			}
			/**
			 * Disconnects IntersectionObserver if active
			 * @unload
			 */

			unload() {
				this.observer.disconnect();
			}
		}
		// EXTERNAL MODULE: ./node_modules/vanilla-modal/dist/index.js
		var vanilla_modal_dist = __webpack_require__(529);
		var vanilla_modal_dist_default =
			/*#__PURE__*/ __webpack_require__.n(vanilla_modal_dist); // CONCATENATED MODULE: ./node_modules/@shopify/theme-a11y/theme-a11y.js
		/**
		 * A11y Helpers
		 * -----------------------------------------------------------------------------
		 * A collection of useful functions that help make your theme more accessible
		 */

		/**
		 * Moves focus to an HTML element
		 * eg for In-page links, after scroll, focus shifts to content area so that
		 * next `tab` is where user expects. Used in bindInPageLinks()
		 * eg move focus to a modal that is opened. Used in trapFocus()
		 *
		 * @param {Element} container - Container DOM element to trap focus inside of
		 * @param {Object} options - Settings unique to your theme
		 * @param {string} options.className - Class name to apply to element on focus.
		 */
		function forceFocus(element, options) {
			options = options || {};

			var savedTabIndex = element.tabIndex;

			element.tabIndex = -1;
			element.dataset.tabIndex = savedTabIndex;
			element.focus();
			if (typeof options.className !== "undefined") {
				element.classList.add(options.className);
			}
			element.addEventListener("blur", callback);

			function callback(event) {
				event.target.removeEventListener(event.type, callback);

				element.tabIndex = savedTabIndex;
				delete element.dataset.tabIndex;
				if (typeof options.className !== "undefined") {
					element.classList.remove(options.className);
				}
			}
		}

		/**
		 * If there's a hash in the url, focus the appropriate element
		 * This compensates for older browsers that do not move keyboard focus to anchor links.
		 * Recommendation: To be called once the page in loaded.
		 *
		 * @param {Object} options - Settings unique to your theme
		 * @param {string} options.className - Class name to apply to element on focus.
		 * @param {string} options.ignore - Selector for elements to not include.
		 */

		function focusHash(options) {
			options = options || {};
			var hash = window.location.hash;
			var element = document.getElementById(hash.slice(1));

			// if we are to ignore this element, early return
			if (element && options.ignore && element.matches(options.ignore)) {
				return false;
			}

			if (hash && element) {
				forceFocus(element, options);
			}
		}

		/**
		 * When an in-page (url w/hash) link is clicked, focus the appropriate element
		 * This compensates for older browsers that do not move keyboard focus to anchor links.
		 * Recommendation: To be called once the page in loaded.
		 *
		 * @param {Object} options - Settings unique to your theme
		 * @param {string} options.className - Class name to apply to element on focus.
		 * @param {string} options.ignore - CSS selector for elements to not include.
		 */

		function bindInPageLinks(options) {
			options = options || {};
			var links = Array.prototype.slice.call(
				document.querySelectorAll('a[href^="#"]')
			);

			return links.filter(function (link) {
				if (link.hash === "#" || link.hash === "") {
					return false;
				}

				if (options.ignore && link.matches(options.ignore)) {
					return false;
				}

				var element = document.querySelector(link.hash);

				if (!element) {
					return false;
				}

				link.addEventListener("click", function () {
					forceFocus(element, options);
				});

				return true;
			});
		}

		function focusable(container) {
			var elements = Array.prototype.slice.call(
				container.querySelectorAll(
					"[tabindex]," +
						"[draggable]," +
						"a[href]," +
						"area," +
						"button:enabled," +
						"input:not([type=hidden]):enabled," +
						"object," +
						"select:enabled," +
						"textarea:enabled"
				)
			);

			// Filter out elements that are not visible.
			// Copied from jQuery https://github.com/jquery/jquery/blob/2d4f53416e5f74fa98e0c1d66b6f3c285a12f0ce/src/css/hiddenVisibleSelectors.js
			return elements.filter(function (element) {
				return !!(
					element.offsetWidth ||
					element.offsetHeight ||
					element.getClientRects().length
				);
			});
		}

		/**
		 * Traps the focus in a particular container
		 *
		 * @param {Element} container - Container DOM element to trap focus inside of
		 * @param {Element} elementToFocus - Element to be focused on first
		 * @param {Object} options - Settings unique to your theme
		 * @param {string} options.className - Class name to apply to element on focus.
		 */

		var trapFocusHandlers = {};

		function trapFocus(container, options) {
			options = options || {};
			var elements = focusable(container);
			var elementToFocus = options.elementToFocus || container;
			var first = elements[0];
			var last = elements[elements.length - 1];

			removeTrapFocus();

			trapFocusHandlers.focusin = function (event) {
				if (container !== event.target && !container.contains(event.target)) {
					first.focus();
				}

				if (
					event.target !== container &&
					event.target !== last &&
					event.target !== first
				)
					return;
				document.addEventListener("keydown", trapFocusHandlers.keydown);
			};

			trapFocusHandlers.focusout = function () {
				document.removeEventListener("keydown", trapFocusHandlers.keydown);
			};

			trapFocusHandlers.keydown = function (event) {
				if (event.keyCode !== 9) return; // If not TAB key

				// On the last focusable element and tab forward, focus the first element.
				if (event.target === last && !event.shiftKey) {
					event.preventDefault();
					first.focus();
				}

				//  On the first focusable element and tab backward, focus the last element.
				if (
					(event.target === container || event.target === first) &&
					event.shiftKey
				) {
					event.preventDefault();
					last.focus();
				}
			};

			document.addEventListener("focusout", trapFocusHandlers.focusout);
			document.addEventListener("focusin", trapFocusHandlers.focusin);

			forceFocus(elementToFocus, options);
		}

		/**
		 * Removes the trap of focus from the page
		 */
		function removeTrapFocus() {
			document.removeEventListener("focusin", trapFocusHandlers.focusin);
			document.removeEventListener("focusout", trapFocusHandlers.focusout);
			document.removeEventListener("keydown", trapFocusHandlers.keydown);
		}

		/**
		 * Add a preventive message to external links and links that open to a new window.
		 * @param {string} elements - Specific elements to be targeted
		 * @param {object} options.messages - Custom messages to overwrite with keys: newWindow, external, newWindowExternal
		 * @param {string} options.messages.newWindow - When the link opens in a new window (e.g. target="_blank")
		 * @param {string} options.messages.external - When the link is to a different host domain.
		 * @param {string} options.messages.newWindowExternal - When the link is to a different host domain and opens in a new window.
		 * @param {object} options.prefix - Prefix to namespace "id" of the messages
		 */
		function accessibleLinks(elements, options) {
			if (typeof elements !== "string") {
				throw new TypeError(elements + " is not a String.");
			}

			elements = document.querySelectorAll(elements);

			if (elements.length === 0) {
				return;
			}

			options = options || {};
			options.messages = options.messages || {};

			var messages = {
				newWindow: options.messages.newWindow || "Opens in a new window.",
				external: options.messages.external || "Opens external website.",
				newWindowExternal:
					options.messages.newWindowExternal ||
					"Opens external website in a new window.",
			};

			var prefix = options.prefix || "a11y";

			var messageSelectors = {
				newWindow: prefix + "-new-window-message",
				external: prefix + "-external-message",
				newWindowExternal: prefix + "-new-window-external-message",
			};

			function generateHTML(messages) {
				var container = document.createElement("ul");
				var htmlMessages = Object.keys(messages).reduce(function (html, key) {
					return (html +=
						"<li id=" + messageSelectors[key] + ">" + messages[key] + "</li>");
				}, "");

				container.setAttribute("hidden", true);
				container.innerHTML = htmlMessages;

				document.body.appendChild(container);
			}

			function externalSite(link) {
				return link.hostname !== window.location.hostname;
			}

			elements.forEach(function (link) {
				var target = link.getAttribute("target");
				var rel = link.getAttribute("rel");
				var isExternal = externalSite(link);
				var isTargetBlank = target === "_blank";
				var isRelNoopenerEmpty = rel === null || rel.indexOf("noopener") === -1;

				if (isTargetBlank && isRelNoopenerEmpty) {
					link.setAttribute("rel", "noopener");
				}

				if (isExternal && isTargetBlank) {
					link.setAttribute(
						"aria-describedby",
						messageSelectors.newWindowExternal
					);
				} else if (isExternal) {
					link.setAttribute("aria-describedby", messageSelectors.external);
				} else if (isTargetBlank) {
					link.setAttribute("aria-describedby", messageSelectors.newWindow);
				}
			});

			generateHTML(messages);
		} // CONCATENATED MODULE: ./source/scripts/helpers/ScrollLock.js
		const { body } = document;
		const html = document.querySelector("html");

		function _blockScroll(event) {
			// Only block events that occur outside the modal
			if (event.target.closest(".allow-scroll-while-locked")) return;
			event.preventDefault();
			event.stopPropagation();
		}

		class ScrollLock {
			/**
			 * Prevents all scrolling of the document
			 * @param {HTMLElement} modal Element within which scrolling is allowed
			 */
			static lock(modal) {
				if (modal) {
					modal.classList.add("allow-scroll-while-locked");
				}

				html.classList.add("scroll-locked");
				body.style.top = -1 * window.pageYOffset;
				body.addEventListener("scroll", _blockScroll, false);
				body.addEventListener("touchmove", _blockScroll, {
					passive: false,
				});
			}
			/**
			 * Removes scroll lock
			 */

			static unlock() {
				document
					.querySelectorAll(".allow-scroll-while-locked")
					.forEach((modal) =>
						modal.classList.remove("allow-scroll-while-locked")
					);
				html.classList.remove("scroll-locked");
				body.style.top = "";
				body.removeEventListener("scroll", _blockScroll, false);
				body.removeEventListener("touchmove", _blockScroll, {
					passive: false,
				});
			}

			static get isLocked() {
				return html.classList.contains("scroll-locked");
			}
		} // CONCATENATED MODULE: ./source/scripts/components/Modal.js
		let openModals = [];

		const unlockScrollLock = () => {
			if (openModals.length === 0) {
				ScrollLock.unlock();
			}
		};

		class Modal {
			constructor() {
				let options =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: {};
				this.$body = jquery_default()(document.body);
				this.$window = jquery_default()(window); // Extend default vanilla-modal callbacks back to instantiator of Modal

				const defaultOptions = {
					onOpen: () => {},
					onClose: () => {},
					onBeforeOpen: () => {},
					onBeforeClose: () => {},
					modalId: null,
				};
				this.options = {
					...defaultOptions,
					...options,
				};
				const modalSelector = this.options.modalId
					? `[data-modal-container-${this.options.modalId}]`
					: "[data-modal-container]";
				const closeSelector = this.options.modalId
					? `[data-modal-${this.options.modalId}-close`
					: "[data-modal-close]";
				this.loadedClass = this.options.modalId
					? `modal-${this.options.modalId}-loaded`
					: "modal-loaded";
				this.visibleClass = this.options.modalId
					? `modal-${this.options.modalId}-visible`
					: "modal-visible";
				this.modal = null;
				this.$modal = jquery_default()(modalSelector);
				this.$modalInner = this.$modal.find("[data-modal-inner]");
				this.finishedLoading = this.finishedLoading.bind(this);
				this._onOpen = this._onOpen.bind(this);
				this._onBeforeOpen = this._onBeforeOpen.bind(this);
				this._onClose = this._onClose.bind(this);
				this._onBeforeClose = this._onBeforeClose.bind(this);
				this._closeEsc = this._closeEsc.bind(this);
				this.position = this.position.bind(this);
				this.modalOptions = {
					modal: modalSelector,
					loadClass: "",
					class: this.loadedClass,
					close: closeSelector,
					onOpen: this._onOpen,
					onClose: this._onClose,
					onBeforeOpen: this._onBeforeOpen,
					onBeforeClose: this._onBeforeClose,
					transitions: false,
					closeKeys: [], // Override default "close on esc" so we have control
				};
			}

			unload() {
				if (!this.modal) return;
				this.modal.destroy();
				openModals = openModals.filter((modal) => modal !== this);
				unlockScrollLock();
			}
			/**
			 * Open a modal with contents from selector
			 *
			 * @param selector
			 * @param handle
			 */

			open(selector) {
				let handle =
					arguments.length > 1 && arguments[1] !== undefined
						? arguments[1]
						: "general";

				this._addModalClass(handle);

				this.modal = new (vanilla_modal_dist_default())(this.modalOptions);
				this.modal.open(selector);
				openModals.push(this);
				window.addEventListener("keydown", this._closeEsc);
			}

			close() {
				this.modal.close();
				window.removeEventListener("keydown", this._closeEsc);
			}

			finishedLoading() {
				trapFocus(this.$modal[0]);
			}

			_closeEsc(e) {
				if (e.key === "Escape" && openModals[openModals.length - 1] === this) {
					this.close();
				}
			}

			isOpen() {
				return this.modal && this.modal.isOpen;
			}
			/**
			 * Update the vertical positioning of modal
			 */

			position() {
				const windowHeight = window.innerHeight;
				const modalHeight = this.$modalInner.outerHeight();
				const modalPadding = parseInt(this.$modal.css("padding-top"), 10) * 2;
				const offset = (windowHeight - modalPadding - modalHeight) / 2;
				const marginTop = offset > 0 ? offset : 0;
				this.$modalInner.css({
					marginTop,
				});
			}
			/**
			 * Add a class to the modal for individual styling
			 * @param handle
			 * @private
			 */

			_addModalClass(handle) {
				this.$modal.addClass(`modal--${handle}`);
			}
			/**
			 * Remove modal class based on the handle
			 * @private
			 */

			_removeModalClass() {
				const modalClass = this.$modal.attr("class").match(/modal--[\w-]*\b/);

				if (!modalClass) {
					return;
				}

				this.$modal.removeClass(modalClass[0]);
			}

			_onClose() {
				this._removeModalClass();

				this.$body.removeClass(this.visibleClass);
				this.$window.off("resize.modal");
				this.$modalInner.css({
					marginTop: "",
				});
				this.options.onClose();
				removeTrapFocus(this.$modal[0]);

				if (this.activeElement) {
					// Ensure focus is properly re-trapped in the case when modal was
					// opened from another modal
					const focusTrap = this.activeElement.closest("[data-trap-focus]");

					if (focusTrap) {
						trapFocus(focusTrap);
					}

					this.activeElement.focus();
				}

				openModals = openModals.filter((modal) => modal !== this);
				unlockScrollLock();
			}

			_onOpen() {
				this.activeElement = document.activeElement;
				this.position();
				ScrollLock.lock(this.$modal[0]);
				this.$body.addClass(this.visibleClass);
				this.$window.on(
					"resize.modal",
					just_debounce_default()(() => this.position(), 16, true, true)
				);
				this.options.onOpen();
				trapFocus(this.$modal[0]);
			}

			_onBeforeClose() {
				this.options.onBeforeClose();
			}

			_onBeforeOpen() {
				this.options.onBeforeOpen();
			}
		}
		// EXTERNAL MODULE: ./node_modules/@pixelunion/shopify-variants-ui/dist/index.es.js
		var shopify_variants_ui_dist_index_es = __webpack_require__(722); // CONCATENATED MODULE: ./node_modules/@pixelunion/shopify-surface-pick-up/dist/index.es.js
		const LOCAL_STORAGE_KEY = "pxu-shopify-surface-pick-up";
		const loadingClass = "surface-pick-up--loading";

		const isNotExpired = (timestamp) =>
			timestamp + 1000 * 60 * 60 >= Date.now();

		const removeTrailingSlash = (s) => s.replace(/(.*)\/$/, "$1"); // Haversine Distance
		// The haversine formula is an equation giving great-circle distances between
		// two points on a sphere from their longitudes and latitudes

		function calculateDistance(
			latitude1,
			longitude1,
			latitude2,
			longitude2,
			unitSystem
		) {
			const dtor = Math.PI / 180;
			const radius = unitSystem === "metric" ? 6378.14 : 3959;
			const rlat1 = latitude1 * dtor;
			const rlong1 = longitude1 * dtor;
			const rlat2 = latitude2 * dtor;
			const rlong2 = longitude2 * dtor;
			const dlon = rlong1 - rlong2;
			const dlat = rlat1 - rlat2;
			const a =
				Math.sin(dlat / 2) ** 2 +
				Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(dlon / 2) ** 2;
			const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
			return radius * c;
		}

		async function getGeoLocation() {
			return new Promise((resolve, reject) => {
				const options = {
					maximumAge: 3600000,
					// 1 hour
					timeout: 5000,
				};

				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(
						({ coords }) => resolve(coords),
						reject,
						options
					);
				} else {
					reject();
				}
			});
		}

		async function setLocation({ latitude, longitude }) {
			const newData = {
				latitude,
				longitude,
				timestamp: Date.now(),
			};
			localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newData));
			return fetch("/localization.json", {
				method: "PUT",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					latitude,
					longitude,
				}),
			}).then(() => ({
				latitude,
				longitude,
			}));
		}

		async function getLocation(requestLocation = false) {
			const cachedLocation = JSON.parse(
				localStorage.getItem(LOCAL_STORAGE_KEY)
			);

			if (cachedLocation && isNotExpired(cachedLocation.timestamp)) {
				return cachedLocation;
			}

			if (requestLocation) {
				return getGeoLocation().then((coords) => {
					setLocation(coords); // We don't need to wait for this

					return coords;
				});
			}

			return null;
		}

		class SurfacePickUp {
			constructor(el, options) {
				this.el = el;
				this.options = {
					root_url:
						(window.Theme &&
							window.Theme.routes &&
							window.Theme.routes.root_url) ||
						"",
					...options,
				};
				this.options.root_url = removeTrailingSlash(this.options.root_url);
				this.callbacks = [];
				this.onBtnPress = null;
				this.latestVariantId = null;
			}

			load(variantId) {
				// If no variant is available, empty element and quick-return
				if (!variantId) {
					this.el.innerHTML = "";
					return Promise.resolve(true);
				} // Because Shopify doesn't expose any `pick_up_enabled` data on the shop object, we
				// don't know if the variant might be, or is definitely not available for pick up.
				// Until we know the shop has > 0 pick up locations, we want to avoid prompting the
				// user for location data (it's annoying, and only makes sense to do if we use it).
				//
				// Instead, we have to make an initial request, check and see if any pick up locations
				// were returned, then ask for the users location, then make another request to get the
				// location-aware pick up locations.
				//
				// As far as I can tell the pick up aware locations differ only in sort order - which
				// we could do on the front end - but we're following this approach to ensure future
				// compatibility with any changes Shopify makes (maybe disabling options based on
				// user location, or whatever else).
				//
				// Shopify has indicated they will look into adding pick_up_enabled data to the shop
				// object, which which case this method can be greatly simplifed into 2 simple cases.

				this.latestVariantId = variantId;
				this.el.classList.add(loadingClass);
				return this._getData(variantId).then((data) => this._injectData(data));
			}

			onModalRequest(callback) {
				if (this.callbacks.indexOf(callback) >= 0) return;
				this.callbacks.push(callback);
			}

			offModalRequest(callback) {
				this.callbacks.splice(this.callbacks.indexOf(callback));
			}

			unload() {
				this.callbacks = [];
				this.el.innerHTML = "";
			}

			_getData(variantId) {
				return new Promise((resolve) => {
					const xhr = new XMLHttpRequest();
					const requestUrl = `${this.options.root_url}/variants/${variantId}/?section_id=surface-pick-up`;
					xhr.open("GET", requestUrl, true);

					xhr.onload = () => {
						const el = xhr.response;
						const embed = el.querySelector(
							'[data-html="surface-pick-up-embed"]'
						);
						const itemsContainer = el.querySelector(
							'[data-html="surface-pick-up-items"]'
						);
						const items = itemsContainer.content.querySelectorAll(
							"[data-surface-pick-up-item]"
						);
						resolve({
							embed,
							itemsContainer,
							items,
							variantId,
						});
					};

					xhr.onerror = () => {
						resolve({
							embed: {
								innerHTML: "",
							},
							itemsContainer: {
								innerHTML: "",
							},
							items: [],
							variantId,
						});
					};

					xhr.responseType = "document";
					xhr.send();
				});
			}

			_injectData({ embed, itemsContainer, items, variantId }) {
				if (variantId !== this.latestVariantId || items.length === 0) {
					this.el.innerHTML = "";
					this.el.classList.remove(loadingClass);
					return;
				}

				this.el.innerHTML = embed.innerHTML;
				this.el.classList.remove(loadingClass);
				let calculatedDistances = false;

				const calculateDistances = () => {
					if (calculatedDistances) return Promise.resolve();
					return getLocation(true)
						.then((coords) => {
							items.forEach((item) => {
								const distanceEl = item.querySelector("[data-distance]");
								const distanceUnitEl = item.querySelector(
									"[data-distance-unit]"
								);
								const unitSystem = distanceUnitEl.dataset.distanceUnit;
								const itemLatitude = parseFloat(distanceEl.dataset.latitude);
								const itemLongitude = parseFloat(distanceEl.dataset.longitude);

								if (
									coords &&
									isFinite(itemLatitude) &&
									isFinite(itemLongitude)
								) {
									const distance = calculateDistance(
										coords.latitude,
										coords.longitude,
										itemLatitude,
										itemLongitude,
										unitSystem
									);
									distanceEl.innerHTML = distance.toFixed(1);
								} else {
									distanceEl.remove();
									distanceUnitEl.remove();
								}
							});
						})
						.catch((e) => {
							console.log(e);
							items.forEach((item) => {
								const distanceEl = item.querySelector("[data-distance]");
								const distanceUnitEl = item.querySelector(
									"[data-distance-unit]"
								);
								distanceEl.remove();
								distanceUnitEl.remove();
							});
						})
						.finally(() => {
							calculatedDistances = true;
						});
				};

				this.el
					.querySelector("[data-surface-pick-up-embed-modal-btn]")
					.addEventListener("click", () => {
						calculateDistances().then(() =>
							this.callbacks.forEach((callback) =>
								callback(itemsContainer.innerHTML)
							)
						);
					});
			}
		}

		/* harmony default export */ const shopify_surface_pick_up_dist_index_es =
			SurfacePickUp; // CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-gift-card-recipient-form/dist/index.es.js

		/*!
		 * @pixelunion/pxs-gift-card-recipient-form v1.0.0
		 * (c) 2023 Pixel Union
		 */

		function unwrapExports(x) {
			return x &&
				x.__esModule &&
				Object.prototype.hasOwnProperty.call(x, "default")
				? x["default"]
				: x;
		}

		function createCommonjsModule(fn, module) {
			return (
				(module = { exports: {} }), fn(module, module.exports), module.exports
			);
		}

		var EventHandler_1 = createCommonjsModule(function (module, exports) {
			exports.__esModule = true;
			var EventHandler = /** @class */ (function () {
				function EventHandler() {
					this.events = [];
				}
				EventHandler.prototype.register = function (el, event, listener) {
					if (!el || !event || !listener) return null;
					this.events.push({ el: el, event: event, listener: listener });
					el.addEventListener(event, listener);
					return { el: el, event: event, listener: listener };
				};
				EventHandler.prototype.unregister = function (_a) {
					var el = _a.el,
						event = _a.event,
						listener = _a.listener;
					if (!el || !event || !listener) return null;
					this.events = this.events.filter(function (e) {
						return el !== e.el || event !== e.event || listener !== e.listener;
					});
					el.removeEventListener(event, listener);
					return { el: el, event: event, listener: listener };
				};
				EventHandler.prototype.unregisterAll = function () {
					this.events.forEach(function (_a) {
						var el = _a.el,
							event = _a.event,
							listener = _a.listener;
						return el.removeEventListener(event, listener);
					});
					this.events = [];
				};
				return EventHandler;
			})();
			exports["default"] = EventHandler;
		});

		var index_es_EventHandler = unwrapExports(EventHandler_1);

		/*!
		 * @pixelunion/animations v0.1.0
		 * (c) 2019 Pixel Union
		 * Released under the UNLICENSED license.
		 */

		function pxs_gift_card_recipient_form_dist_index_es_classCallCheck(
			instance,
			Constructor
		) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function dist_index_es_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function dist_index_es_createClass(Constructor, protoProps, staticProps) {
			if (protoProps)
				dist_index_es_defineProperties(Constructor.prototype, protoProps);
			if (staticProps) dist_index_es_defineProperties(Constructor, staticProps);
			return Constructor;
		}

		/**
		 * Promisified version of window.requestAnimationFrame.
		 * @returns {Promise} Promise will resolve when requestAnimationFrame callback is run.
		 */
		function index_es_raf() {
			return new Promise(function (resolve) {
				window.requestAnimationFrame(resolve);
			});
		}
		/**
		 * Represents an HTML element with associate states
		 */

		var index_es_Animation =
			/*#__PURE__*/
			(function () {
				/**
				 * @param {Object} options
				 * @param {HTMLElement}  options.el Target element
				 * @param {String} [options.state=initial] Initial state. This is also the default state.
				 * @param {String} [options.stateAttribute=data-revealer] Attribute name to update with state.
				 * @param {String} [options.stateChangeAttribute=data-revealer-transition] Attribute name to
				 * update with change of state.
				 * @param {String} [options.endEvent=transitionend] Event to listen for at end of state change.
				 * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
				 * next state change.
				 * @param {Function} [options.onStart] Callback to execute immediate after
				 * applying stateChangeAttribute.
				 */
				function Animation(options) {
					pxs_gift_card_recipient_form_dist_index_es_classCallCheck(
						this,
						Animation
					);

					this._el = options.el;
					this.cancelRunning = null;
					this._state = options.state || "initial";
					this.initialState = this._state;
					this.stateAttribute =
						options.stateAttribute || "data-animation-state";
					this.stateChangeAttribute =
						options.stateChangeAttribute || "data-animation";
					this.endEvent = options.endEvent || "transitionend";
					this.hold = !!options.hold;

					this.onStart =
						options.onStart ||
						function () {
							/* do nothing */
						};

					this.activeEventHandler = null;
				}
				/**
				 * Returns target element
				 *
				 * @return {HTMLElement} Target element
				 */

				dist_index_es_createClass(Animation, [
					{
						key: "isState",

						/**
						 * Check if a state is active
						 * @param {String} state State to compare
						 *
						 * @return {Boolean}
						 */
						value: function isState(state) {
							return state === this._state;
						},
						/**
						 * Sequences a change to a new state.
						 * @param {String} state Target state
						 *
						 * @param {Boolean} options.force Switch to final state immediately
						 *
						 * @param {Function} options.onStart Callback to execute immediately after
						 * applying stateChangeAttribute for this state change only.
						 *
						 * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
						 * next state change.
						 *
						 * @return {Promise} Resolves when endEvent triggered
						 */
					},
					{
						key: "animateTo",
						value: function animateTo(state) {
							var _this = this;

							var options =
								arguments.length > 1 && arguments[1] !== undefined
									? arguments[1]
									: {};
							var from = this._el.dataset[this.stateAttribute] || this._state;
							var to = state || this.initialState;
							var force = options.force;
							var hold = "hold" in options ? options.hold : this.hold;
							return new Promise(function (resolve) {
								if (_this.cancelRunning) {
									_this.cancelRunning();
								}

								if (from === to) {
									// Removing this here fixes some lingering attributes. But why?
									_this._el.removeAttribute(_this.stateChangeAttribute);

									resolve(from, null);
									return;
								}

								var running = true;

								_this.cancelRunning = function () {
									running = false;
									resolve(null, null);
								};

								_this._el.removeEventListener(
									_this.endEvent,
									_this.activeEventHandler
								);

								_this.activeEventHandler = null;

								if (force) {
									_this._el.setAttribute(
										_this.stateChangeAttribute,
										"".concat(from, "=>").concat(to)
									);

									_this.onStart({
										el: _this._el,
										from: from,
										to: to,
									});

									if (typeof options.onStart === "function") {
										options.onStart({
											el: _this._el,
											from: from,
											to: to,
										});
									}

									_this._el.setAttribute(_this.stateAttribute, to);

									_this._state = to;

									if (!hold) {
										_this._el.removeAttribute(_this.stateChangeAttribute);
									}

									resolve(to, null);
									return;
								}

								index_es_raf()
									.then(function () {
										if (!running) throw new Error("cancelled");

										_this._el.setAttribute(
											_this.stateChangeAttribute,
											"".concat(from, "=>").concat(to)
										);

										_this.onStart({
											el: _this._el,
											from: from,
											to: to,
										});

										if (typeof options.onStart === "function") {
											options.onStart({
												el: _this._el,
												from: from,
												to: to,
											});
										}

										return index_es_raf();
									})
									.then(function () {
										if (!running) throw new Error("cancelled");

										_this._el.removeEventListener(
											_this.endEvent,
											_this.activeEventHandler
										);

										_this.activeEventHandler = function (e) {
											// Ignore any events bubbling up
											if (e.target !== _this._el || !running) return;

											_this._el.removeEventListener(
												_this.endEvent,
												_this.activeEventHandler
											);

											if (!hold) {
												_this._el.removeAttribute(_this.stateChangeAttribute);
											}

											resolve(to, e);
										};

										_this._el.addEventListener(
											_this.endEvent,
											_this.activeEventHandler
										);

										_this._el.setAttribute(_this.stateAttribute, to);

										_this._state = to;
									})
									["catch"](function (error) {
										// Only catch 'cancelled' errors.
										if (error.message !== "cancelled") throw error;
									});
							});
						},
						/**
						 * Remove any event listeners
						 */
					},
					{
						key: "unload",
						value: function unload() {
							this._el.removeEventListener(
								this.endEvent,
								this.activeEventHandler
							);

							this.activeEventHandler = null;
						},
					},
					{
						key: "el",
						get: function get() {
							return this._el;
						},
						/**
						 * Returns current state
						 *
						 * @return {String} Current state
						 */
					},
					{
						key: "state",
						get: function get() {
							return this._state;
						},
					},
				]);

				return Animation;
			})();

		function index_es_transition(options) {
			return new index_es_Animation(options);
		}

		class RecipientForm {
			constructor(el) {
				this.el = el;
				this.events = new index_es_EventHandler();
				this.recipientForm = this.el.querySelector("[data-recipient-form]");
				this.recipientFormInputs = this.el.querySelectorAll(
					"[data-recipient-form-input]"
				);
				this.recipientFormEmailInput = this.el.querySelector(
					"[data-recipient-form-email-input]"
				);
				this.disclosure = this.el.querySelector("[data-recipient-disclosure]");
				this.disclosureCheckbox = this.el.querySelector(
					"[data-recipient-disclosure-checkbox]"
				);
				this.checkmark = this.disclosure.querySelector(".checkmark");
				this.checkmarkCheck =
					this.disclosure.querySelector(".checkmark__check");
				this.fillAnimation = index_es_transition({
					el: this.checkmark,
				});
				this.checkAnimation = index_es_transition({
					el: this.checkmarkCheck,
				});
				this.events.register(this.recipientForm, "keydown", (event) =>
					this._onKeydown(event)
				);
				this.events.register(this.disclosure, "toggle", () => this._onToggle());
				this.events.register(this.disclosureCheckbox, "change", () =>
					this._onChange()
				);
			}

			_onChange() {
				this.disclosure.open = this.disclosureCheckbox.checked;
			}

			_onKeydown(event) {
				// Prevent input form submission
				if (
					event.key === "Enter" &&
					event.target.matches("[data-recipient-form-input]")
				) {
					event.preventDefault();
				}
			}

			_onToggle() {
				if (this.disclosure.open) {
					this._showRecipientForm();
				} else {
					this._hideRecipientForm();
				}
			}

			_showRecipientForm() {
				if (this.checkmark && this.checkmarkCheck) {
					this.fillAnimation.animateTo("checked");
					this.checkAnimation.animateTo("checked");
				}

				this.disclosureCheckbox.checked = true;
				this.recipientFormEmailInput.required = true;
			}

			_hideRecipientForm() {
				if (this.checkmark && this.checkmarkCheck) {
					this.fillAnimation.animateTo("unchecked");
					this.checkAnimation.animateTo("unchecked");
				}

				this.disclosureCheckbox.checked = false;
				this.recipientFormEmailInput.required = false;

				this._resetRecipientForm();
			}

			_resetRecipientForm() {
				this.recipientFormInputs.forEach((el) => {
					el.value = "";

					if (el.classList.contains("form-field-filled")) {
						el.classList.remove("form-field-filled");
					}
				});

				if (
					this.recipientForm.classList.contains("recipient-form--has-errors")
				) {
					this.recipientForm.classList.remove("recipient-form--has-errors");
				}
			}
		}

		/* harmony default export */ const pxs_gift_card_recipient_form_dist_index_es =
			RecipientForm; // CONCATENATED MODULE: ./source/scripts/components/MessageBanner.js

		class MessageBanner {
			constructor(message, type) {
				const bannerTemplate = document.querySelector(
					"[data-templates] [data-message-banner]"
				);
				this.banner = bannerTemplate.cloneNode(true);
				const messageElement = this.banner.querySelector(
					"[data-message-banner-content]"
				);
				messageElement.innerHTML = message;
				this.banner.classList.add(`message--${type}`);
				const modal = document.querySelector(".modal-loaded .modal-inner");
				const target = modal || document.querySelector("[data-site-header]");
				target.appendChild(this.banner);
				this.closeButton = this.banner.querySelector(
					"[data-message-banner-close]"
				);
				this.bannerAnimation = transition({
					el: this.banner,
					state: "closed",
				});
				this.bannerAnimation.animateTo("open");
				this.events = new EventHandler /* default */.Z();
				this.events.register(this.closeButton, "click", () => this._close());
				this.events.register(document, "click", (e) =>
					this._handleDocumentClick(e.target)
				);
				this.events.register(document, "touchStart", (e) =>
					this._handleDocumentClick(e.target)
				);
				this.events.register(window, "keydown", (e) => this._closeEsc(e));
			}

			unload() {
				if (this.banner) {
					this._close();
				}
			}

			_closeEsc(e) {
				if (e.key === "Escape") {
					this._close();
				}
			}

			_close() {
				this.bannerAnimation.animateTo("closed").then(() => {
					this.banner?.remove();
					this.banner = null;
					this.events.unregisterAll();
					this.bannerAnimation.unload();
				});
			}

			_handleDocumentClick(target) {
				const $parent = jquery_default()(target).parents(
					"[data-message-banner]"
				);
				if ($parent.length) return;

				this._close();
			}
		} // CONCATENATED MODULE: ./source/scripts/helpers/Images.js
		class Images {
			/**
			 * Preloads an image in memory and uses the browsers cache to store it until needed.
			 *
			 * @param {Array} images - A list of image urls
			 * @param {String} size - A shopify image size attribute
			 */
			preload(images, size) {
				let imageArray = images;

				if (typeof images === "string") {
					imageArray = [images];
				}

				for (let i = 0; i < imageArray.length; i++) {
					this.loadImage(this.getSizedImageUrl(imageArray[i], size));
				}
			}
			/**
			 * Loads and caches an image in the browsers cache.
			 *
			 * @param {string} path - An image url
			 */

			loadImage(path) {
				const image = new Image();
				image.src = path;
				return image;
			}
			/**
			 * Adds a Shopify size attribute to a URL
			 *
			 * @param src
			 * @param size
			 * @returns {*}
			 */

			getSizedImageUrl() {
				let src =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: null;
				let size = arguments.length > 1 ? arguments[1] : undefined;

				if (!size) {
					return null;
				}

				if (size === "master") {
					return this.removeProtocol(src);
				}

				const match = src.match(
					/\.(jpg|jpeg|gif|png|webp|avif|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
				);

				if (match) {
					const prefix = src.split(match[0]);
					const suffix = match[0];
					return this.removeProtocol(`${prefix[0]}_${size}${suffix}`);
				}

				console.warn(`No ${size} found for '${src}`);
				return null;
			}

			removeProtocol(path) {
				return path.replace(/http(s)?:/, "");
			}
		} // CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
		/*! *****************************************************************************
    Copyright (c) Microsoft Corporation.
    
    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.
    
    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
		/* global Reflect, Promise */

		var extendStatics = function (d, b) {
			extendStatics =
				Object.setPrototypeOf ||
				({ __proto__: [] } instanceof Array &&
					function (d, b) {
						d.__proto__ = b;
					}) ||
				function (d, b) {
					for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
				};
			return extendStatics(d, b);
		};

		function __extends(d, b) {
			extendStatics(d, b);
			function __() {
				this.constructor = d;
			}
			d.prototype =
				b === null
					? Object.create(b)
					: ((__.prototype = b.prototype), new __());
		}

		var __assign = function () {
			__assign =
				Object.assign ||
				function __assign(t) {
					for (var s, i = 1, n = arguments.length; i < n; i++) {
						s = arguments[i];
						for (var p in s)
							if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
					}
					return t;
				};
			return __assign.apply(this, arguments);
		};

		function __rest(s, e) {
			var t = {};
			for (var p in s)
				if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
					t[p] = s[p];
			if (s != null && typeof Object.getOwnPropertySymbols === "function")
				for (
					var i = 0, p = Object.getOwnPropertySymbols(s);
					i < p.length;
					i++
				) {
					if (
						e.indexOf(p[i]) < 0 &&
						Object.prototype.propertyIsEnumerable.call(s, p[i])
					)
						t[p[i]] = s[p[i]];
				}
			return t;
		}

		function __decorate(decorators, target, key, desc) {
			var c = arguments.length,
				r =
					c < 3
						? target
						: desc === null
						? (desc = Object.getOwnPropertyDescriptor(target, key))
						: desc,
				d;
			if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
				r = Reflect.decorate(decorators, target, key, desc);
			else
				for (var i = decorators.length - 1; i >= 0; i--)
					if ((d = decorators[i]))
						r =
							(c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
			return c > 3 && r && Object.defineProperty(target, key, r), r;
		}

		function __param(paramIndex, decorator) {
			return function (target, key) {
				decorator(target, key, paramIndex);
			};
		}

		function __metadata(metadataKey, metadataValue) {
			if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
				return Reflect.metadata(metadataKey, metadataValue);
		}

		function __awaiter(thisArg, _arguments, P, generator) {
			function adopt(value) {
				return value instanceof P
					? value
					: new P(function (resolve) {
							resolve(value);
					  });
			}
			return new (P || (P = Promise))(function (resolve, reject) {
				function fulfilled(value) {
					try {
						step(generator.next(value));
					} catch (e) {
						reject(e);
					}
				}
				function rejected(value) {
					try {
						step(generator["throw"](value));
					} catch (e) {
						reject(e);
					}
				}
				function step(result) {
					result.done
						? resolve(result.value)
						: adopt(result.value).then(fulfilled, rejected);
				}
				step((generator = generator.apply(thisArg, _arguments || [])).next());
			});
		}

		function __generator(thisArg, body) {
			var _ = {
					label: 0,
					sent: function () {
						if (t[0] & 1) throw t[1];
						return t[1];
					},
					trys: [],
					ops: [],
				},
				f,
				y,
				t,
				g;
			return (
				(g = { next: verb(0), throw: verb(1), return: verb(2) }),
				typeof Symbol === "function" &&
					(g[Symbol.iterator] = function () {
						return this;
					}),
				g
			);
			function verb(n) {
				return function (v) {
					return step([n, v]);
				};
			}
			function step(op) {
				if (f) throw new TypeError("Generator is already executing.");
				while (_)
					try {
						if (
							((f = 1),
							y &&
								(t =
									op[0] & 2
										? y["return"]
										: op[0]
										? y["throw"] || ((t = y["return"]) && t.call(y), 0)
										: y.next) &&
								!(t = t.call(y, op[1])).done)
						)
							return t;
						if (((y = 0), t)) op = [op[0] & 2, t.value];
						switch (op[0]) {
							case 0:
							case 1:
								t = op;
								break;
							case 4:
								_.label++;
								return { value: op[1], done: false };
							case 5:
								_.label++;
								y = op[1];
								op = [0];
								continue;
							case 7:
								op = _.ops.pop();
								_.trys.pop();
								continue;
							default:
								if (
									!((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
									(op[0] === 6 || op[0] === 2)
								) {
									_ = 0;
									continue;
								}
								if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
									_.label = op[1];
									break;
								}
								if (op[0] === 6 && _.label < t[1]) {
									_.label = t[1];
									t = op;
									break;
								}
								if (t && _.label < t[2]) {
									_.label = t[2];
									_.ops.push(op);
									break;
								}
								if (t[2]) _.ops.pop();
								_.trys.pop();
								continue;
						}
						op = body.call(thisArg, _);
					} catch (e) {
						op = [6, e];
						y = 0;
					} finally {
						f = t = 0;
					}
				if (op[0] & 5) throw op[1];
				return { value: op[0] ? op[1] : void 0, done: true };
			}
		}

		function __createBinding(o, m, k, k2) {
			if (k2 === undefined) k2 = k;
			o[k2] = m[k];
		}

		function __exportStar(m, exports) {
			for (var p in m)
				if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
		}

		function __values(o) {
			var s = typeof Symbol === "function" && Symbol.iterator,
				m = s && o[s],
				i = 0;
			if (m) return m.call(o);
			if (o && typeof o.length === "number")
				return {
					next: function () {
						if (o && i >= o.length) o = void 0;
						return { value: o && o[i++], done: !o };
					},
				};
			throw new TypeError(
				s ? "Object is not iterable." : "Symbol.iterator is not defined."
			);
		}

		function __read(o, n) {
			var m = typeof Symbol === "function" && o[Symbol.iterator];
			if (!m) return o;
			var i = m.call(o),
				r,
				ar = [],
				e;
			try {
				while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
					ar.push(r.value);
			} catch (error) {
				e = { error: error };
			} finally {
				try {
					if (r && !r.done && (m = i["return"])) m.call(i);
				} finally {
					if (e) throw e.error;
				}
			}
			return ar;
		}

		function __spread() {
			for (var ar = [], i = 0; i < arguments.length; i++)
				ar = ar.concat(__read(arguments[i]));
			return ar;
		}

		function __spreadArrays() {
			for (var s = 0, i = 0, il = arguments.length; i < il; i++)
				s += arguments[i].length;
			for (var r = Array(s), k = 0, i = 0; i < il; i++)
				for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
					r[k] = a[j];
			return r;
		}

		function __await(v) {
			return this instanceof __await ? ((this.v = v), this) : new __await(v);
		}

		function __asyncGenerator(thisArg, _arguments, generator) {
			if (!Symbol.asyncIterator)
				throw new TypeError("Symbol.asyncIterator is not defined.");
			var g = generator.apply(thisArg, _arguments || []),
				i,
				q = [];
			return (
				(i = {}),
				verb("next"),
				verb("throw"),
				verb("return"),
				(i[Symbol.asyncIterator] = function () {
					return this;
				}),
				i
			);
			function verb(n) {
				if (g[n])
					i[n] = function (v) {
						return new Promise(function (a, b) {
							q.push([n, v, a, b]) > 1 || resume(n, v);
						});
					};
			}
			function resume(n, v) {
				try {
					step(g[n](v));
				} catch (e) {
					settle(q[0][3], e);
				}
			}
			function step(r) {
				r.value instanceof __await
					? Promise.resolve(r.value.v).then(fulfill, reject)
					: settle(q[0][2], r);
			}
			function fulfill(value) {
				resume("next", value);
			}
			function reject(value) {
				resume("throw", value);
			}
			function settle(f, v) {
				if ((f(v), q.shift(), q.length)) resume(q[0][0], q[0][1]);
			}
		}

		function __asyncDelegator(o) {
			var i, p;
			return (
				(i = {}),
				verb("next"),
				verb("throw", function (e) {
					throw e;
				}),
				verb("return"),
				(i[Symbol.iterator] = function () {
					return this;
				}),
				i
			);
			function verb(n, f) {
				i[n] = o[n]
					? function (v) {
							return (p = !p)
								? { value: __await(o[n](v)), done: n === "return" }
								: f
								? f(v)
								: v;
					  }
					: f;
			}
		}

		function __asyncValues(o) {
			if (!Symbol.asyncIterator)
				throw new TypeError("Symbol.asyncIterator is not defined.");
			var m = o[Symbol.asyncIterator],
				i;
			return m
				? m.call(o)
				: ((o =
						typeof __values === "function"
							? __values(o)
							: o[Symbol.iterator]()),
				  (i = {}),
				  verb("next"),
				  verb("throw"),
				  verb("return"),
				  (i[Symbol.asyncIterator] = function () {
						return this;
				  }),
				  i);
			function verb(n) {
				i[n] =
					o[n] &&
					function (v) {
						return new Promise(function (resolve, reject) {
							(v = o[n](v)), settle(resolve, reject, v.done, v.value);
						});
					};
			}
			function settle(resolve, reject, d, v) {
				Promise.resolve(v).then(function (v) {
					resolve({ value: v, done: d });
				}, reject);
			}
		}

		function __makeTemplateObject(cooked, raw) {
			if (Object.defineProperty) {
				Object.defineProperty(cooked, "raw", { value: raw });
			} else {
				cooked.raw = raw;
			}
			return cooked;
		}

		function __importStar(mod) {
			if (mod && mod.__esModule) return mod;
			var result = {};
			if (mod != null)
				for (var k in mod)
					if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
			result.default = mod;
			return result;
		}

		function __importDefault(mod) {
			return mod && mod.__esModule ? mod : { default: mod };
		}

		function __classPrivateFieldGet(receiver, privateMap) {
			if (!privateMap.has(receiver)) {
				throw new TypeError("attempted to get private field on non-instance");
			}
			return privateMap.get(receiver);
		}

		function __classPrivateFieldSet(receiver, privateMap, value) {
			if (!privateMap.has(receiver)) {
				throw new TypeError("attempted to set private field on non-instance");
			}
			privateMap.set(receiver, value);
			return value;
		} // CONCATENATED MODULE: ./node_modules/@material/base/foundation.js

		/**
		 * @license
		 * Copyright 2016 Google Inc.
		 *
		 * Permission is hereby granted, free of charge, to any person obtaining a copy
		 * of this software and associated documentation files (the "Software"), to deal
		 * in the Software without restriction, including without limitation the rights
		 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		 * copies of the Software, and to permit persons to whom the Software is
		 * furnished to do so, subject to the following conditions:
		 *
		 * The above copyright notice and this permission notice shall be included in
		 * all copies or substantial portions of the Software.
		 *
		 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
		 * THE SOFTWARE.
		 */
		var MDCFoundation = /** @class */ (function () {
			function MDCFoundation(adapter) {
				if (adapter === void 0) {
					adapter = {};
				}
				this.adapter_ = adapter;
			}
			Object.defineProperty(MDCFoundation, "cssClasses", {
				get: function () {
					// Classes extending MDCFoundation should implement this method to return an object which exports every
					// CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
					return {};
				},
				enumerable: true,
				configurable: true,
			});
			Object.defineProperty(MDCFoundation, "strings", {
				get: function () {
					// Classes extending MDCFoundation should implement this method to return an object which exports all
					// semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
					return {};
				},
				enumerable: true,
				configurable: true,
			});
			Object.defineProperty(MDCFoundation, "numbers", {
				get: function () {
					// Classes extending MDCFoundation should implement this method to return an object which exports all
					// of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
					return {};
				},
				enumerable: true,
				configurable: true,
			});
			Object.defineProperty(MDCFoundation, "defaultAdapter", {
				get: function () {
					// Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
					// way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
					// validation.
					return {};
				},
				enumerable: true,
				configurable: true,
			});
			MDCFoundation.prototype.init = function () {
				// Subclasses should override this method to perform initialization routines (registering events, etc.)
			};
			MDCFoundation.prototype.destroy = function () {
				// Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
			};
			return MDCFoundation;
		})();

		// tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
		/* harmony default export */ const foundation =
			/* unused pure expression or super */ null && MDCFoundation; // CONCATENATED MODULE: ./node_modules/@material/base/component.js
		//# sourceMappingURL=foundation.js.map
		/**
		 * @license
		 * Copyright 2016 Google Inc.
		 *
		 * Permission is hereby granted, free of charge, to any person obtaining a copy
		 * of this software and associated documentation files (the "Software"), to deal
		 * in the Software without restriction, including without limitation the rights
		 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		 * copies of the Software, and to permit persons to whom the Software is
		 * furnished to do so, subject to the following conditions:
		 *
		 * The above copyright notice and this permission notice shall be included in
		 * all copies or substantial portions of the Software.
		 *
		 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
		 * THE SOFTWARE.
		 */

		var MDCComponent = /** @class */ (function () {
			function MDCComponent(root, foundation) {
				var args = [];
				for (var _i = 2; _i < arguments.length; _i++) {
					args[_i - 2] = arguments[_i];
				}
				this.root_ = root;
				this.initialize.apply(this, __spread(args));
				// Note that we initialize foundation here and not within the constructor's default param so that
				// this.root_ is defined and can be used within the foundation class.
				this.foundation_ =
					foundation === undefined ? this.getDefaultFoundation() : foundation;
				this.foundation_.init();
				this.initialSyncWithDOM();
			}
			MDCComponent.attachTo = function (root) {
				// Subclasses which extend MDCBase should provide an attachTo() method that takes a root element and
				// returns an instantiated component with its root set to that element. Also note that in the cases of
				// subclasses, an explicit foundation class will not have to be passed in; it will simply be initialized
				// from getDefaultFoundation().
				return new MDCComponent(root, new MDCFoundation({}));
			};
			/* istanbul ignore next: method param only exists for typing purposes; it does not need to be unit tested */
			MDCComponent.prototype.initialize = function () {
				var _args = [];
				for (var _i = 0; _i < arguments.length; _i++) {
					_args[_i] = arguments[_i];
				}
				// Subclasses can override this to do any additional setup work that would be considered part of a
				// "constructor". Essentially, it is a hook into the parent constructor before the foundation is
				// initialized. Any additional arguments besides root and foundation will be passed in here.
			};
			MDCComponent.prototype.getDefaultFoundation = function () {
				// Subclasses must override this method to return a properly configured foundation class for the
				// component.
				throw new Error(
					"Subclasses must override getDefaultFoundation to return a properly configured " +
						"foundation class"
				);
			};
			MDCComponent.prototype.initialSyncWithDOM = function () {
				// Subclasses should override this method if they need to perform work to synchronize with a host DOM
				// object. An example of this would be a form control wrapper that needs to synchronize its internal state
				// to some property or attribute of the host DOM. Please note: this is *not* the place to perform DOM
				// reads/writes that would cause layout / paint, as this is called synchronously from within the constructor.
			};
			MDCComponent.prototype.destroy = function () {
				// Subclasses may implement this method to release any resources / deregister any listeners they have
				// attached. An example of this might be deregistering a resize event from the window object.
				this.foundation_.destroy();
			};
			MDCComponent.prototype.listen = function (evtType, handler, options) {
				this.root_.addEventListener(evtType, handler, options);
			};
			MDCComponent.prototype.unlisten = function (evtType, handler, options) {
				this.root_.removeEventListener(evtType, handler, options);
			};
			/**
			 * Fires a cross-browser-compatible custom event from the component root of the given type, with the given data.
			 */
			MDCComponent.prototype.emit = function (evtType, evtData, shouldBubble) {
				if (shouldBubble === void 0) {
					shouldBubble = false;
				}
				var evt;
				if (typeof CustomEvent === "function") {
					evt = new CustomEvent(evtType, {
						bubbles: shouldBubble,
						detail: evtData,
					});
				} else {
					evt = document.createEvent("CustomEvent");
					evt.initCustomEvent(evtType, shouldBubble, false, evtData);
				}
				this.root_.dispatchEvent(evt);
			};
			return MDCComponent;
		})();

		// tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
		/* harmony default export */ const component =
			/* unused pure expression or super */ null && MDCComponent; // CONCATENATED MODULE: ./node_modules/@material/dom/events.js
		//# sourceMappingURL=component.js.map
		/**
		 * @license
		 * Copyright 2019 Google Inc.
		 *
		 * Permission is hereby granted, free of charge, to any person obtaining a copy
		 * of this software and associated documentation files (the "Software"), to deal
		 * in the Software without restriction, including without limitation the rights
		 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		 * copies of the Software, and to permit persons to whom the Software is
		 * furnished to do so, subject to the following conditions:
		 *
		 * The above copyright notice and this permission notice shall be included in
		 * all copies or substantial portions of the Software.
		 *
		 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
		 * THE SOFTWARE.
		 */
		/**
		 * Determine whether the current browser supports passive event listeners, and
		 * if so, use them.
		 */
		function applyPassive(globalObj) {
			if (globalObj === void 0) {
				globalObj = window;
			}
			return supportsPassiveOption(globalObj) ? { passive: true } : false;
		}
		function supportsPassiveOption(globalObj) {
			if (globalObj === void 0) {
				globalObj = window;
			}
			// See
			// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
			var passiveSupported = false;
			try {
				var options = {
					// This function will be called when the browser
					// attempts to access the passive property.
					get passive() {
						passiveSupported = true;
						return false;
					},
				};
				var handler = function () {};
				globalObj.document.addEventListener("test", handler, options);
				globalObj.document.removeEventListener("test", handler, options);
			} catch (err) {
				passiveSupported = false;
			}
			return passiveSupported;
		} // CONCATENATED MODULE: ./node_modules/@material/dom/ponyfill.js
		//# sourceMappingURL=events.js.map
		/**
		 * @license
		 * Copyright 2018 Google Inc.
		 *
		 * Permission is hereby granted, free of charge, to any person obtaining a copy
		 * of this software and associated documentation files (the "Software"), to deal
		 * in the Software without restriction, including without limitation the rights
		 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		 * copies of the Software, and to permit persons to whom the Software is
		 * furnished to do so, subject to the following conditions:
		 *
		 * The above copyright notice and this permission notice shall be included in
		 * all copies or substantial portions of the Software.
		 *
		 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
		 * THE SOFTWARE.
		 */
		/**
		 * @fileoverview A "ponyfill" is a polyfill that doesn't modify the global prototype chain.
		 * This makes ponyfills safer than traditional polyfills, especially for libraries like MDC.
		 */
		function closest(element, selector) {
			if (element.closest) {
				return element.closest(selector);
			}
			var el = element;
			while (el) {
				if (matches(el, selector)) {
					return el;
				}
				el = el.parentElement;
			}
			return null;
		}
		function matches(element, selector) {
			var nativeMatches =
				element.matches ||
				element.webkitMatchesSelector ||
				element.msMatchesSelector;
			return nativeMatches.call(element, selector);
		}
		/**
		 * Used to compute the estimated scroll width of elements. When an element is
		 * hidden due to display: none; being applied to a parent element, the width is
		 * returned as 0. However, the element will have a true width once no longer
		 * inside a display: none context. This method computes an estimated width when
		 * the element is hidden or returns the true width when the element is visble.
		 * @param {Element} element the element whose width to estimate
		 */
		function estimateScrollWidth(element) {
			// Check the offsetParent. If the element inherits display: none from any
			// parent, the offsetParent property will be null (see
			// https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent).
			// This check ensures we only clone the node when necessary.
			var htmlEl = element;
			if (htmlEl.offsetParent !== null) {
				return htmlEl.scrollWidth;
			}
			var clone = htmlEl.cloneNode(true);
			clone.style.setProperty("position", "absolute");
			clone.style.setProperty("transform", "translate(-9999px, -9999px)");
			document.documentElement.appendChild(clone);
			var scrollWidth = clone.scrollWidth;
			document.documentElement.removeChild(clone);
			return scrollWidth;
		} // CONCATENATED MODULE: ./node_modules/@material/ripple/constants.js
		//# sourceMappingURL=ponyfill.js.map
		/**
		 * @license
		 * Copyright 2016 Google Inc.
		 *
		 * Permission is hereby granted, free of charge, to any person obtaining a copy
		 * of this software and associated documentation files (the "Software"), to deal
		 * in the Software without restriction, including without limitation the rights
		 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		 * copies of the Software, and to permit persons to whom the Software is
		 * furnished to do so, subject to the following conditions:
		 *
		 * The above copyright notice and this permission notice shall be included in
		 * all copies or substantial portions of the Software.
		 *
		 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
		 * THE SOFTWARE.
		 */
		var cssClasses = {
			// Ripple is a special case where the "root" component is really a "mixin" of sorts,
			// given that it's an 'upgrade' to an existing component. That being said it is the root
			// CSS class that all other CSS classes derive from.
			BG_FOCUSED: "mdc-ripple-upgraded--background-focused",
			FG_ACTIVATION: "mdc-ripple-upgraded--foreground-activation",
			FG_DEACTIVATION: "mdc-ripple-upgraded--foreground-deactivation",
			ROOT: "mdc-ripple-upgraded",
			UNBOUNDED: "mdc-ripple-upgraded--unbounded",
		};
		var strings = {
			VAR_FG_SCALE: "--mdc-ripple-fg-scale",
			VAR_FG_SIZE: "--mdc-ripple-fg-size",
			VAR_FG_TRANSLATE_END: "--mdc-ripple-fg-translate-end",
			VAR_FG_TRANSLATE_START: "--mdc-ripple-fg-translate-start",
			VAR_LEFT: "--mdc-ripple-left",
			VAR_TOP: "--mdc-ripple-top",
		};
		var numbers = {
			DEACTIVATION_TIMEOUT_MS: 225,
			FG_DEACTIVATION_MS: 150,
			INITIAL_ORIGIN_SCALE: 0.6,
			PADDING: 10,
			TAP_DELAY_MS: 300,
		}; // CONCATENATED MODULE: ./node_modules/@material/ripple/util.js
		//# sourceMappingURL=constants.js.map
		/**
		 * Stores result from supportsCssVariables to avoid redundant processing to
		 * detect CSS custom variable support.
		 */
		var supportsCssVariables_;
		function supportsCssVariables(windowObj, forceRefresh) {
			if (forceRefresh === void 0) {
				forceRefresh = false;
			}
			var CSS = windowObj.CSS;
			var supportsCssVars = supportsCssVariables_;
			if (typeof supportsCssVariables_ === "boolean" && !forceRefresh) {
				return supportsCssVariables_;
			}
			var supportsFunctionPresent = CSS && typeof CSS.supports === "function";
			if (!supportsFunctionPresent) {
				return false;
			}
			var explicitlySupportsCssVars = CSS.supports("--css-vars", "yes");
			// See: https://bugs.webkit.org/show_bug.cgi?id=154669
			// See: README section on Safari
			var weAreFeatureDetectingSafari10plus =
				CSS.supports("(--css-vars: yes)") && CSS.supports("color", "#00000000");
			supportsCssVars =
				explicitlySupportsCssVars || weAreFeatureDetectingSafari10plus;
			if (!forceRefresh) {
				supportsCssVariables_ = supportsCssVars;
			}
			return supportsCssVars;
		}
		function getNormalizedEventCoords(evt, pageOffset, clientRect) {
			if (!evt) {
				return { x: 0, y: 0 };
			}
			var x = pageOffset.x,
				y = pageOffset.y;
			var documentX = x + clientRect.left;
			var documentY = y + clientRect.top;
			var normalizedX;
			var normalizedY;
			// Determine touch point relative to the ripple container.
			if (evt.type === "touchstart") {
				var touchEvent = evt;
				normalizedX = touchEvent.changedTouches[0].pageX - documentX;
				normalizedY = touchEvent.changedTouches[0].pageY - documentY;
			} else {
				var mouseEvent = evt;
				normalizedX = mouseEvent.pageX - documentX;
				normalizedY = mouseEvent.pageY - documentY;
			}
			return { x: normalizedX, y: normalizedY };
		} // CONCATENATED MODULE: ./node_modules/@material/ripple/foundation.js
		//# sourceMappingURL=util.js.map
		/**
		 * @license
		 * Copyright 2016 Google Inc.
		 *
		 * Permission is hereby granted, free of charge, to any person obtaining a copy
		 * of this software and associated documentation files (the "Software"), to deal
		 * in the Software without restriction, including without limitation the rights
		 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		 * copies of the Software, and to permit persons to whom the Software is
		 * furnished to do so, subject to the following conditions:
		 *
		 * The above copyright notice and this permission notice shall be included in
		 * all copies or substantial portions of the Software.
		 *
		 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
		 * THE SOFTWARE.
		 */

		// Activation events registered on the root element of each instance for activation
		var ACTIVATION_EVENT_TYPES = [
			"touchstart",
			"pointerdown",
			"mousedown",
			"keydown",
		];
		// Deactivation events registered on documentElement when a pointer-related down event occurs
		var POINTER_DEACTIVATION_EVENT_TYPES = [
			"touchend",
			"pointerup",
			"mouseup",
			"contextmenu",
		];
		// simultaneous nested activations
		var activatedTargets = [];
		var MDCRippleFoundation = /** @class */ (function (_super) {
			__extends(MDCRippleFoundation, _super);
			function MDCRippleFoundation(adapter) {
				var _this =
					_super.call(
						this,
						__assign(__assign({}, MDCRippleFoundation.defaultAdapter), adapter)
					) || this;
				_this.activationAnimationHasEnded_ = false;
				_this.activationTimer_ = 0;
				_this.fgDeactivationRemovalTimer_ = 0;
				_this.fgScale_ = "0";
				_this.frame_ = { width: 0, height: 0 };
				_this.initialSize_ = 0;
				_this.layoutFrame_ = 0;
				_this.maxRadius_ = 0;
				_this.unboundedCoords_ = { left: 0, top: 0 };
				_this.activationState_ = _this.defaultActivationState_();
				_this.activationTimerCallback_ = function () {
					_this.activationAnimationHasEnded_ = true;
					_this.runDeactivationUXLogicIfReady_();
				};
				_this.activateHandler_ = function (e) {
					return _this.activate_(e);
				};
				_this.deactivateHandler_ = function () {
					return _this.deactivate_();
				};
				_this.focusHandler_ = function () {
					return _this.handleFocus();
				};
				_this.blurHandler_ = function () {
					return _this.handleBlur();
				};
				_this.resizeHandler_ = function () {
					return _this.layout();
				};
				return _this;
			}
			Object.defineProperty(MDCRippleFoundation, "cssClasses", {
				get: function () {
					return cssClasses;
				},
				enumerable: true,
				configurable: true,
			});
			Object.defineProperty(MDCRippleFoundation, "strings", {
				get: function () {
					return strings;
				},
				enumerable: true,
				configurable: true,
			});
			Object.defineProperty(MDCRippleFoundation, "numbers", {
				get: function () {
					return numbers;
				},
				enumerable: true,
				configurable: true,
			});
			Object.defineProperty(MDCRippleFoundation, "defaultAdapter", {
				get: function () {
					return {
						addClass: function () {
							return undefined;
						},
						browserSupportsCssVars: function () {
							return true;
						},
						computeBoundingRect: function () {
							return {
								top: 0,
								right: 0,
								bottom: 0,
								left: 0,
								width: 0,
								height: 0,
							};
						},
						containsEventTarget: function () {
							return true;
						},
						deregisterDocumentInteractionHandler: function () {
							return undefined;
						},
						deregisterInteractionHandler: function () {
							return undefined;
						},
						deregisterResizeHandler: function () {
							return undefined;
						},
						getWindowPageOffset: function () {
							return { x: 0, y: 0 };
						},
						isSurfaceActive: function () {
							return true;
						},
						isSurfaceDisabled: function () {
							return true;
						},
						isUnbounded: function () {
							return true;
						},
						registerDocumentInteractionHandler: function () {
							return undefined;
						},
						registerInteractionHandler: function () {
							return undefined;
						},
						registerResizeHandler: function () {
							return undefined;
						},
						removeClass: function () {
							return undefined;
						},
						updateCssVariable: function () {
							return undefined;
						},
					};
				},
				enumerable: true,
				configurable: true,
			});
			MDCRippleFoundation.prototype.init = function () {
				var _this = this;
				var supportsPressRipple = this.supportsPressRipple_();
				this.registerRootHandlers_(supportsPressRipple);
				if (supportsPressRipple) {
					var _a = MDCRippleFoundation.cssClasses,
						ROOT_1 = _a.ROOT,
						UNBOUNDED_1 = _a.UNBOUNDED;
					requestAnimationFrame(function () {
						_this.adapter_.addClass(ROOT_1);
						if (_this.adapter_.isUnbounded()) {
							_this.adapter_.addClass(UNBOUNDED_1);
							// Unbounded ripples need layout logic applied immediately to set coordinates for both shade and ripple
							_this.layoutInternal_();
						}
					});
				}
			};
			MDCRippleFoundation.prototype.destroy = function () {
				var _this = this;
				if (this.supportsPressRipple_()) {
					if (this.activationTimer_) {
						clearTimeout(this.activationTimer_);
						this.activationTimer_ = 0;
						this.adapter_.removeClass(
							MDCRippleFoundation.cssClasses.FG_ACTIVATION
						);
					}
					if (this.fgDeactivationRemovalTimer_) {
						clearTimeout(this.fgDeactivationRemovalTimer_);
						this.fgDeactivationRemovalTimer_ = 0;
						this.adapter_.removeClass(
							MDCRippleFoundation.cssClasses.FG_DEACTIVATION
						);
					}
					var _a = MDCRippleFoundation.cssClasses,
						ROOT_2 = _a.ROOT,
						UNBOUNDED_2 = _a.UNBOUNDED;
					requestAnimationFrame(function () {
						_this.adapter_.removeClass(ROOT_2);
						_this.adapter_.removeClass(UNBOUNDED_2);
						_this.removeCssVars_();
					});
				}
				this.deregisterRootHandlers_();
				this.deregisterDeactivationHandlers_();
			};
			/**
			 * @param evt Optional event containing position information.
			 */
			MDCRippleFoundation.prototype.activate = function (evt) {
				this.activate_(evt);
			};
			MDCRippleFoundation.prototype.deactivate = function () {
				this.deactivate_();
			};
			MDCRippleFoundation.prototype.layout = function () {
				var _this = this;
				if (this.layoutFrame_) {
					cancelAnimationFrame(this.layoutFrame_);
				}
				this.layoutFrame_ = requestAnimationFrame(function () {
					_this.layoutInternal_();
					_this.layoutFrame_ = 0;
				});
			};
			MDCRippleFoundation.prototype.setUnbounded = function (unbounded) {
				var UNBOUNDED = MDCRippleFoundation.cssClasses.UNBOUNDED;
				if (unbounded) {
					this.adapter_.addClass(UNBOUNDED);
				} else {
					this.adapter_.removeClass(UNBOUNDED);
				}
			};
			MDCRippleFoundation.prototype.handleFocus = function () {
				var _this = this;
				requestAnimationFrame(function () {
					return _this.adapter_.addClass(
						MDCRippleFoundation.cssClasses.BG_FOCUSED
					);
				});
			};
			MDCRippleFoundation.prototype.handleBlur = function () {
				var _this = this;
				requestAnimationFrame(function () {
					return _this.adapter_.removeClass(
						MDCRippleFoundation.cssClasses.BG_FOCUSED
					);
				});
			};
			/**
			 * We compute this property so that we are not querying information about the client
			 * until the point in time where the foundation requests it. This prevents scenarios where
			 * client-side feature-detection may happen too early, such as when components are rendered on the server
			 * and then initialized at mount time on the client.
			 */
			MDCRippleFoundation.prototype.supportsPressRipple_ = function () {
				return this.adapter_.browserSupportsCssVars();
			};
			MDCRippleFoundation.prototype.defaultActivationState_ = function () {
				return {
					activationEvent: undefined,
					hasDeactivationUXRun: false,
					isActivated: false,
					isProgrammatic: false,
					wasActivatedByPointer: false,
					wasElementMadeActive: false,
				};
			};
			/**
			 * supportsPressRipple Passed from init to save a redundant function call
			 */
			MDCRippleFoundation.prototype.registerRootHandlers_ = function (
				supportsPressRipple
			) {
				var _this = this;
				if (supportsPressRipple) {
					ACTIVATION_EVENT_TYPES.forEach(function (evtType) {
						_this.adapter_.registerInteractionHandler(
							evtType,
							_this.activateHandler_
						);
					});
					if (this.adapter_.isUnbounded()) {
						this.adapter_.registerResizeHandler(this.resizeHandler_);
					}
				}
				this.adapter_.registerInteractionHandler("focus", this.focusHandler_);
				this.adapter_.registerInteractionHandler("blur", this.blurHandler_);
			};
			MDCRippleFoundation.prototype.registerDeactivationHandlers_ = function (
				evt
			) {
				var _this = this;
				if (evt.type === "keydown") {
					this.adapter_.registerInteractionHandler(
						"keyup",
						this.deactivateHandler_
					);
				} else {
					POINTER_DEACTIVATION_EVENT_TYPES.forEach(function (evtType) {
						_this.adapter_.registerDocumentInteractionHandler(
							evtType,
							_this.deactivateHandler_
						);
					});
				}
			};
			MDCRippleFoundation.prototype.deregisterRootHandlers_ = function () {
				var _this = this;
				ACTIVATION_EVENT_TYPES.forEach(function (evtType) {
					_this.adapter_.deregisterInteractionHandler(
						evtType,
						_this.activateHandler_
					);
				});
				this.adapter_.deregisterInteractionHandler("focus", this.focusHandler_);
				this.adapter_.deregisterInteractionHandler("blur", this.blurHandler_);
				if (this.adapter_.isUnbounded()) {
					this.adapter_.deregisterResizeHandler(this.resizeHandler_);
				}
			};
			MDCRippleFoundation.prototype.deregisterDeactivationHandlers_ =
				function () {
					var _this = this;
					this.adapter_.deregisterInteractionHandler(
						"keyup",
						this.deactivateHandler_
					);
					POINTER_DEACTIVATION_EVENT_TYPES.forEach(function (evtType) {
						_this.adapter_.deregisterDocumentInteractionHandler(
							evtType,
							_this.deactivateHandler_
						);
					});
				};
			MDCRippleFoundation.prototype.removeCssVars_ = function () {
				var _this = this;
				var rippleStrings = MDCRippleFoundation.strings;
				var keys = Object.keys(rippleStrings);
				keys.forEach(function (key) {
					if (key.indexOf("VAR_") === 0) {
						_this.adapter_.updateCssVariable(rippleStrings[key], null);
					}
				});
			};
			MDCRippleFoundation.prototype.activate_ = function (evt) {
				var _this = this;
				if (this.adapter_.isSurfaceDisabled()) {
					return;
				}
				var activationState = this.activationState_;
				if (activationState.isActivated) {
					return;
				}
				// Avoid reacting to follow-on events fired by touch device after an already-processed user interaction
				var previousActivationEvent = this.previousActivationEvent_;
				var isSameInteraction =
					previousActivationEvent &&
					evt !== undefined &&
					previousActivationEvent.type !== evt.type;
				if (isSameInteraction) {
					return;
				}
				activationState.isActivated = true;
				activationState.isProgrammatic = evt === undefined;
				activationState.activationEvent = evt;
				activationState.wasActivatedByPointer = activationState.isProgrammatic
					? false
					: evt !== undefined &&
					  (evt.type === "mousedown" ||
							evt.type === "touchstart" ||
							evt.type === "pointerdown");
				var hasActivatedChild =
					evt !== undefined &&
					activatedTargets.length > 0 &&
					activatedTargets.some(function (target) {
						return _this.adapter_.containsEventTarget(target);
					});
				if (hasActivatedChild) {
					// Immediately reset activation state, while preserving logic that prevents touch follow-on events
					this.resetActivationState_();
					return;
				}
				if (evt !== undefined) {
					activatedTargets.push(evt.target);
					this.registerDeactivationHandlers_(evt);
				}
				activationState.wasElementMadeActive =
					this.checkElementMadeActive_(evt);
				if (activationState.wasElementMadeActive) {
					this.animateActivation_();
				}
				requestAnimationFrame(function () {
					// Reset array on next frame after the current event has had a chance to bubble to prevent ancestor ripples
					activatedTargets = [];
					if (
						!activationState.wasElementMadeActive &&
						evt !== undefined &&
						(evt.key === " " || evt.keyCode === 32)
					) {
						// If space was pressed, try again within an rAF call to detect :active, because different UAs report
						// active states inconsistently when they're called within event handling code:
						// - https://bugs.chromium.org/p/chromium/issues/detail?id=635971
						// - https://bugzilla.mozilla.org/show_bug.cgi?id=1293741
						// We try first outside rAF to support Edge, which does not exhibit this problem, but will crash if a CSS
						// variable is set within a rAF callback for a submit button interaction (#2241).
						activationState.wasElementMadeActive =
							_this.checkElementMadeActive_(evt);
						if (activationState.wasElementMadeActive) {
							_this.animateActivation_();
						}
					}
					if (!activationState.wasElementMadeActive) {
						// Reset activation state immediately if element was not made active.
						_this.activationState_ = _this.defaultActivationState_();
					}
				});
			};
			MDCRippleFoundation.prototype.checkElementMadeActive_ = function (evt) {
				return evt !== undefined && evt.type === "keydown"
					? this.adapter_.isSurfaceActive()
					: true;
			};
			MDCRippleFoundation.prototype.animateActivation_ = function () {
				var _this = this;
				var _a = MDCRippleFoundation.strings,
					VAR_FG_TRANSLATE_START = _a.VAR_FG_TRANSLATE_START,
					VAR_FG_TRANSLATE_END = _a.VAR_FG_TRANSLATE_END;
				var _b = MDCRippleFoundation.cssClasses,
					FG_DEACTIVATION = _b.FG_DEACTIVATION,
					FG_ACTIVATION = _b.FG_ACTIVATION;
				var DEACTIVATION_TIMEOUT_MS =
					MDCRippleFoundation.numbers.DEACTIVATION_TIMEOUT_MS;
				this.layoutInternal_();
				var translateStart = "";
				var translateEnd = "";
				if (!this.adapter_.isUnbounded()) {
					var _c = this.getFgTranslationCoordinates_(),
						startPoint = _c.startPoint,
						endPoint = _c.endPoint;
					translateStart = startPoint.x + "px, " + startPoint.y + "px";
					translateEnd = endPoint.x + "px, " + endPoint.y + "px";
				}
				this.adapter_.updateCssVariable(VAR_FG_TRANSLATE_START, translateStart);
				this.adapter_.updateCssVariable(VAR_FG_TRANSLATE_END, translateEnd);
				// Cancel any ongoing activation/deactivation animations
				clearTimeout(this.activationTimer_);
				clearTimeout(this.fgDeactivationRemovalTimer_);
				this.rmBoundedActivationClasses_();
				this.adapter_.removeClass(FG_DEACTIVATION);
				// Force layout in order to re-trigger the animation.
				this.adapter_.computeBoundingRect();
				this.adapter_.addClass(FG_ACTIVATION);
				this.activationTimer_ = setTimeout(function () {
					return _this.activationTimerCallback_();
				}, DEACTIVATION_TIMEOUT_MS);
			};
			MDCRippleFoundation.prototype.getFgTranslationCoordinates_ = function () {
				var _a = this.activationState_,
					activationEvent = _a.activationEvent,
					wasActivatedByPointer = _a.wasActivatedByPointer;
				var startPoint;
				if (wasActivatedByPointer) {
					startPoint = getNormalizedEventCoords(
						activationEvent,
						this.adapter_.getWindowPageOffset(),
						this.adapter_.computeBoundingRect()
					);
				} else {
					startPoint = {
						x: this.frame_.width / 2,
						y: this.frame_.height / 2,
					};
				}
				// Center the element around the start point.
				startPoint = {
					x: startPoint.x - this.initialSize_ / 2,
					y: startPoint.y - this.initialSize_ / 2,
				};
				var endPoint = {
					x: this.frame_.width / 2 - this.initialSize_ / 2,
					y: this.frame_.height / 2 - this.initialSize_ / 2,
				};
				return { startPoint: startPoint, endPoint: endPoint };
			};
			MDCRippleFoundation.prototype.runDeactivationUXLogicIfReady_ =
				function () {
					var _this = this;
					// This method is called both when a pointing device is released, and when the activation animation ends.
					// The deactivation animation should only run after both of those occur.
					var FG_DEACTIVATION = MDCRippleFoundation.cssClasses.FG_DEACTIVATION;
					var _a = this.activationState_,
						hasDeactivationUXRun = _a.hasDeactivationUXRun,
						isActivated = _a.isActivated;
					var activationHasEnded = hasDeactivationUXRun || !isActivated;
					if (activationHasEnded && this.activationAnimationHasEnded_) {
						this.rmBoundedActivationClasses_();
						this.adapter_.addClass(FG_DEACTIVATION);
						this.fgDeactivationRemovalTimer_ = setTimeout(function () {
							_this.adapter_.removeClass(FG_DEACTIVATION);
						}, numbers.FG_DEACTIVATION_MS);
					}
				};
			MDCRippleFoundation.prototype.rmBoundedActivationClasses_ = function () {
				var FG_ACTIVATION = MDCRippleFoundation.cssClasses.FG_ACTIVATION;
				this.adapter_.removeClass(FG_ACTIVATION);
				this.activationAnimationHasEnded_ = false;
				this.adapter_.computeBoundingRect();
			};
			MDCRippleFoundation.prototype.resetActivationState_ = function () {
				var _this = this;
				this.previousActivationEvent_ = this.activationState_.activationEvent;
				this.activationState_ = this.defaultActivationState_();
				// Touch devices may fire additional events for the same interaction within a short time.
				// Store the previous event until it's safe to assume that subsequent events are for new interactions.
				setTimeout(function () {
					return (_this.previousActivationEvent_ = undefined);
				}, MDCRippleFoundation.numbers.TAP_DELAY_MS);
			};
			MDCRippleFoundation.prototype.deactivate_ = function () {
				var _this = this;
				var activationState = this.activationState_;
				// This can happen in scenarios such as when you have a keyup event that blurs the element.
				if (!activationState.isActivated) {
					return;
				}
				var state = __assign({}, activationState);
				if (activationState.isProgrammatic) {
					requestAnimationFrame(function () {
						return _this.animateDeactivation_(state);
					});
					this.resetActivationState_();
				} else {
					this.deregisterDeactivationHandlers_();
					requestAnimationFrame(function () {
						_this.activationState_.hasDeactivationUXRun = true;
						_this.animateDeactivation_(state);
						_this.resetActivationState_();
					});
				}
			};
			MDCRippleFoundation.prototype.animateDeactivation_ = function (_a) {
				var wasActivatedByPointer = _a.wasActivatedByPointer,
					wasElementMadeActive = _a.wasElementMadeActive;
				if (wasActivatedByPointer || wasElementMadeActive) {
					this.runDeactivationUXLogicIfReady_();
				}
			};
			MDCRippleFoundation.prototype.layoutInternal_ = function () {
				var _this = this;
				this.frame_ = this.adapter_.computeBoundingRect();
				var maxDim = Math.max(this.frame_.height, this.frame_.width);
				// Surface diameter is treated differently for unbounded vs. bounded ripples.
				// Unbounded ripple diameter is calculated smaller since the surface is expected to already be padded appropriately
				// to extend the hitbox, and the ripple is expected to meet the edges of the padded hitbox (which is typically
				// square). Bounded ripples, on the other hand, are fully expected to expand beyond the surface's longest diameter
				// (calculated based on the diagonal plus a constant padding), and are clipped at the surface's border via
				// `overflow: hidden`.
				var getBoundedRadius = function () {
					var hypotenuse = Math.sqrt(
						Math.pow(_this.frame_.width, 2) + Math.pow(_this.frame_.height, 2)
					);
					return hypotenuse + MDCRippleFoundation.numbers.PADDING;
				};
				this.maxRadius_ = this.adapter_.isUnbounded()
					? maxDim
					: getBoundedRadius();
				// Ripple is sized as a fraction of the largest dimension of the surface, then scales up using a CSS scale transform
				var initialSize = Math.floor(
					maxDim * MDCRippleFoundation.numbers.INITIAL_ORIGIN_SCALE
				);
				// Unbounded ripple size should always be even number to equally center align.
				if (this.adapter_.isUnbounded() && initialSize % 2 !== 0) {
					this.initialSize_ = initialSize - 1;
				} else {
					this.initialSize_ = initialSize;
				}
				this.fgScale_ = "" + this.maxRadius_ / this.initialSize_;
				this.updateLayoutCssVars_();
			};
			MDCRippleFoundation.prototype.updateLayoutCssVars_ = function () {
				var _a = MDCRippleFoundation.strings,
					VAR_FG_SIZE = _a.VAR_FG_SIZE,
					VAR_LEFT = _a.VAR_LEFT,
					VAR_TOP = _a.VAR_TOP,
					VAR_FG_SCALE = _a.VAR_FG_SCALE;
				this.adapter_.updateCssVariable(VAR_FG_SIZE, this.initialSize_ + "px");
				this.adapter_.updateCssVariable(VAR_FG_SCALE, this.fgScale_);
				if (this.adapter_.isUnbounded()) {
					this.unboundedCoords_ = {
						left: Math.round(this.frame_.width / 2 - this.initialSize_ / 2),
						top: Math.round(this.frame_.height / 2 - this.initialSize_ / 2),
					};
					this.adapter_.updateCssVariable(
						VAR_LEFT,
						this.unboundedCoords_.left + "px"
					);
					this.adapter_.updateCssVariable(
						VAR_TOP,
						this.unboundedCoords_.top + "px"
					);
				}
			};
			return MDCRippleFoundation;
		})(MDCFoundation);

		// tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
		/* harmony default export */ const ripple_foundation =
			/* unused pure expression or super */ null && MDCRippleFoundation; // CONCATENATED MODULE: ./node_modules/@material/ripple/component.js
		//# sourceMappingURL=foundation.js.map
		/**
		 * @license
		 * Copyright 2016 Google Inc.
		 *
		 * Permission is hereby granted, free of charge, to any person obtaining a copy
		 * of this software and associated documentation files (the "Software"), to deal
		 * in the Software without restriction, including without limitation the rights
		 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		 * copies of the Software, and to permit persons to whom the Software is
		 * furnished to do so, subject to the following conditions:
		 *
		 * The above copyright notice and this permission notice shall be included in
		 * all copies or substantial portions of the Software.
		 *
		 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
		 * THE SOFTWARE.
		 */

		var MDCRipple = /** @class */ (function (_super) {
			__extends(MDCRipple, _super);
			function MDCRipple() {
				var _this = (_super !== null && _super.apply(this, arguments)) || this;
				_this.disabled = false;
				return _this;
			}
			MDCRipple.attachTo = function (root, opts) {
				if (opts === void 0) {
					opts = { isUnbounded: undefined };
				}
				var ripple = new MDCRipple(root);
				// Only override unbounded behavior if option is explicitly specified
				if (opts.isUnbounded !== undefined) {
					ripple.unbounded = opts.isUnbounded;
				}
				return ripple;
			};
			MDCRipple.createAdapter = function (instance) {
				return {
					addClass: function (className) {
						return instance.root_.classList.add(className);
					},
					browserSupportsCssVars: function () {
						return supportsCssVariables(window);
					},
					computeBoundingRect: function () {
						return instance.root_.getBoundingClientRect();
					},
					containsEventTarget: function (target) {
						return instance.root_.contains(target);
					},
					deregisterDocumentInteractionHandler: function (evtType, handler) {
						return document.documentElement.removeEventListener(
							evtType,
							handler,
							applyPassive()
						);
					},
					deregisterInteractionHandler: function (evtType, handler) {
						return instance.root_.removeEventListener(
							evtType,
							handler,
							applyPassive()
						);
					},
					deregisterResizeHandler: function (handler) {
						return window.removeEventListener("resize", handler);
					},
					getWindowPageOffset: function () {
						return { x: window.pageXOffset, y: window.pageYOffset };
					},
					isSurfaceActive: function () {
						return matches(instance.root_, ":active");
					},
					isSurfaceDisabled: function () {
						return Boolean(instance.disabled);
					},
					isUnbounded: function () {
						return Boolean(instance.unbounded);
					},
					registerDocumentInteractionHandler: function (evtType, handler) {
						return document.documentElement.addEventListener(
							evtType,
							handler,
							applyPassive()
						);
					},
					registerInteractionHandler: function (evtType, handler) {
						return instance.root_.addEventListener(
							evtType,
							handler,
							applyPassive()
						);
					},
					registerResizeHandler: function (handler) {
						return window.addEventListener("resize", handler);
					},
					removeClass: function (className) {
						return instance.root_.classList.remove(className);
					},
					updateCssVariable: function (varName, value) {
						return instance.root_.style.setProperty(varName, value);
					},
				};
			};
			Object.defineProperty(MDCRipple.prototype, "unbounded", {
				get: function () {
					return Boolean(this.unbounded_);
				},
				set: function (unbounded) {
					this.unbounded_ = Boolean(unbounded);
					this.setUnbounded_();
				},
				enumerable: true,
				configurable: true,
			});
			MDCRipple.prototype.activate = function () {
				this.foundation_.activate();
			};
			MDCRipple.prototype.deactivate = function () {
				this.foundation_.deactivate();
			};
			MDCRipple.prototype.layout = function () {
				this.foundation_.layout();
			};
			MDCRipple.prototype.getDefaultFoundation = function () {
				return new MDCRippleFoundation(MDCRipple.createAdapter(this));
			};
			MDCRipple.prototype.initialSyncWithDOM = function () {
				var root = this.root_;
				this.unbounded = "mdcRippleIsUnbounded" in root.dataset;
			};
			/**
			 * Closure Compiler throws an access control error when directly accessing a
			 * protected or private property inside a getter/setter, like unbounded above.
			 * By accessing the protected property inside a method, we solve that problem.
			 * That's why this function exists.
			 */
			MDCRipple.prototype.setUnbounded_ = function () {
				this.foundation_.setUnbounded(Boolean(this.unbounded_));
			};
			return MDCRipple;
		})(MDCComponent); // CONCATENATED MODULE: ./source/scripts/helpers/Ripple.js

		//# sourceMappingURL=component.js.map
		// This function sets up the ripple effect for the various buttons throughout the
		// theme using CSS selectors.

		const setupRippleEffect = (rootElement) => {
			if ("reduceAnimations" in document.body.dataset) {
				return;
			}

			const rippleElements = [
				".button-primary",
				".button-secondary",
				".slideshow-slide__button",
				".product-form--atc-button",
				".mobile-nav-content .navmenu-link",
				".mobile-nav-content .navmenu-button",
				".mobile-nav-primary-content .navmenu-link",
				".mobile-nav-primary-content .navmenu-button",
				".live-search-button",
				".options-selection__radios .options-selection__option-value-name",
				".countdown-timer__caption-button",
				".order-page__atc-button",
			];
			rootElement.querySelectorAll(rippleElements.join(",")).forEach((el) => {
				if (
					!el.classList.contains("disabled") &&
					!el.hasAttribute("disabled")
				) {
					el.classList.add("mdc-ripple-surface");
					MDCRipple.attachTo(el);
				}
			});
		};
		/* harmony default export */ const Ripple = {
			setupRippleEffect,
		}; // CONCATENATED MODULE: ./source/scripts/components/AddToCartFlyout.js
		class AddToCartFlyout {
			constructor(formData, options) {
				let callbacks =
					arguments.length > 2 && arguments[2] !== undefined
						? arguments[2]
						: {};
				this.formData = formData;
				this.settings = {
					moneyFormat: null,
					cartRedirection: false,
					...options.settings,
				};
				this.atcButton = options.atcButton;
				this.header = document.querySelector("[data-site-header]");
				this.announcementBar = document.querySelector(
					"[data-announcement-bar]"
				);
				this.utilityBar = document.querySelector("[data-utility-bar]");
				this.flyOutSelector = "[data-atc-banner]";
				this.atcTemplate = document.querySelector(
					`[data-templates] ${this.flyOutSelector}`
				);
				this.recipientForm = document.querySelector("[data-recipient-form]");
				this.activeElement = document.activeElement;
				this.itemId = null;
				this.flyOut = null;
				this._onInit = this._onInit.bind(this);
				this._onError = this._onError.bind(this);
				this._onSuccess = this._onSuccess.bind(this);
				this._onCloseAll = this._onCloseAll.bind(this); // Allows ATC Flow to be overridden

				this.callbacks = {
					onInit: this._onInit,
					onError: this._onError,
					onSuccess: this._onSuccess,
					onClose: this._onCloseAll,
					...callbacks,
				};
				this._handleDocumentClick = this._handleDocumentClick.bind(this);
				this._closeFlyOut = this._closeFlyOut.bind(this);
				this._closeEsc = this._closeEsc.bind(this);
				this.events = new EventHandler /* default */.Z();
				this.Images = new Images();
				this.messageBanner = null;
				this.callbacks.onInit();

				this._disableAtcButton();

				this._updateCart();
			}

			unload() {
				if (this.messageBanner) {
					this.messageBanner.unload();
				}

				this._closeFlyOut();
			}

			_updateCart() {
				const flyOut = this.atcTemplate.cloneNode(true);
				const quantityField = this.formData.filter(
					(data) => data.name === "quantity"
				);
				const quantity = quantityField[0].value;
				jquery_default()
					.ajax({
						type: "POST",
						url: `${window.Theme.routes.cart_add_url}.js`,
						data: jquery_default().param(this.formData),
						dataType: "json",
					})
					.done((response) => {
						this.itemId = response.id;

						if (response.image) {
							const imageUrl = this.Images.getSizedImageUrl(
								response.image,
								"200x"
							);
							this.Images.loadImage(imageUrl);
							const productImage = flyOut.querySelector(
								"[data-atc-banner-product-image]"
							);
							productImage.innerHTML = `<img src="${imageUrl}" alt="${response.product_title}">`;
						}

						const productTitle = flyOut.querySelector(
							"[data-atc-banner-product-title]"
						);
						productTitle.innerHTML = response.product_title;
						/*
            TODO: Bring in `variant.options`, iterate through to get option
              name for: <strong>Option name:</strong> Option
          */

						if (
							response.variant_options[0] !== "Title" &&
							response.variant_options[0] !== "Default Title"
						) {
							const productOptions = flyOut.querySelector(
								"[data-atc-banner-product-options]"
							);
							productOptions.innerHTML = response.variant_options.join(", ");
						}

						if (response.selling_plan_allocation) {
							const productSubscriptionTitle = flyOut.querySelector(
								"[data-atc-banner-product-subscription-title]"
							);
							productSubscriptionTitle.innerHTML =
								response.selling_plan_allocation.selling_plan.name;
						}
						/*
            TODO: Bring in variant, and use that to check compare_at_price
              to see if the item is on sale
          */

						const productPriceQuantity = flyOut.querySelector(
							"[data-atc-banner-product-price-quantity]"
						);
						productPriceQuantity.innerHTML = `${quantity} × `;
						jquery_default()
							.ajax({
								type: "GET",
								url: `${window.Theme.routes.cart_url}.js`,
								dataType: "json",
							})
							.done((secondResponse) => {
								if (
									this.settings.cartRedirection ||
									document.body.classList.contains("template-cart")
								) {
									location.href = window.Theme.routes.cart_url;
									return;
								}

								this.callbacks.onSuccess(); // Reset formData in case instance is never cleared

								this.formData = {};
								let lineItem = null;
								secondResponse.items.forEach((item) => {
									if (item.id === this.itemId) {
										if (!lineItem) {
											lineItem = item;
										} else {
											// If there are 2 lineItems with the same id, it means that there is
											// likely a BOGO offer on the product. We need to grab the highest discounted
											// price (BOGO will be 0) while also combining with the different discounts on
											// the product in the discounts array.
											lineItem.line_level_discount_allocations =
												lineItem.line_level_discount_allocations.concat(
													item.line_level_discount_allocations
												);
											lineItem.final_price =
												lineItem.final_price > item.final_price
													? lineItem.final_price
													: item.final_price;
											lineItem.quantity += item.quantity;
										}
									}
								});
								const productPriceValue = flyOut.querySelector(
									"[data-atc-banner-product-price-value]"
								);
								productPriceValue.innerHTML = Shopify.formatMoney(
									lineItem.original_price,
									this.settings.moneyFormat
								);
								const productPriceDiscounted = flyOut.querySelector(
									"[data-atc-banner-product-price-discounted]"
								);

								if (lineItem.final_price < lineItem.original_price) {
									productPriceDiscounted.innerHTML = Shopify.formatMoney(
										lineItem.final_price,
										this.settings.moneyFormat
									);
									productPriceDiscounted.classList.remove("hidden");
									productPriceValue.classList.add("original-price");
								} else {
									productPriceDiscounted.classList.add("hidden");
									productPriceValue.classList.remove("original-price");
								}

								const productDiscounts = flyOut.querySelector(
									"[data-atc-banner-product-discounts]"
								); // Price Per Unit

								const unitPrice = flyOut.querySelector(
									"[data-atc-banner-unit-price]"
								);
								let unitPriceString = unitPrice.innerHTML;

								if (unitPrice && lineItem.unit_price_measurement) {
									unitPriceString = unitPriceString.replace(
										"** total_quantity **",
										`${lineItem.unit_price_measurement.quantity_value}${lineItem.unit_price_measurement.quantity_unit}`
									);
									unitPriceString = unitPriceString.replace(
										"** unit_price **",
										Shopify.formatMoney(
											lineItem.unit_price,
											this.settings.moneyFormat
										)
									);

									if (lineItem.unit_price_measurement.reference_value === 1) {
										unitPriceString = unitPriceString.replace(
											"** unit_measure **",
											lineItem.unit_price_measurement.reference_unit
										);
									} else {
										unitPriceString = unitPriceString.replace(
											"** unit_measure **",
											`${lineItem.unit_price_measurement.reference_value}${lineItem.unit_price_measurement.reference_unit}`
										);
									}

									unitPrice.innerHTML = unitPriceString;
									unitPrice.classList.remove("hidden");
								}

								if (lineItem.line_level_discount_allocations.length > 0) {
									const discountItemTemplate =
										productDiscounts.firstElementChild.cloneNode(true);
									productDiscounts.innerHTML = "";
									lineItem.line_level_discount_allocations.forEach(
										(discount) => {
											const listItem = discountItemTemplate.cloneNode(true);
											const title = listItem.querySelector(".discount-title");
											const amount = listItem.querySelector(".discount-amount");
											title.innerHTML = discount.discount_application.title;
											amount.innerHTML = Shopify.formatMoney(
												discount.amount,
												this.settings.moneyFormat
											);
											productDiscounts.appendChild(listItem);
										}
									);
									productDiscounts.classList.remove("hidden");
								} else {
									productDiscounts.classList.add("hidden");
								}

								const subTotal = flyOut.querySelector(
									"[data-atc-banner-cart-subtotal]"
								);
								subTotal.innerHTML = Shopify.formatMoney(
									secondResponse.total_price,
									this.settings.moneyFormat
								);
								const itemCount = flyOut.querySelector(
									"[data-atc-banner-cart-button] span"
								);
								itemCount.innerHTML = secondResponse.item_count;
								this.header.appendChild(flyOut);
								this.flyOut = flyOut;
								setupRippleEffect(this.flyOut); // Notifiy Header of new cart count

								const countEvent = new CustomEvent("cartcount:update", {
									detail: secondResponse,
								});
								window.dispatchEvent(countEvent);
								/*
            If user has initiated a new ATC Flow before the first has finished,
            the first FlyOut could have opened after the first attempt to close open flyouts so
            we need to send out an event to close any open flyouts.
            */

								document.dispatchEvent(new Event("closeFlyouts"));
								const closeButton = flyOut.querySelector(
									"[data-atc-banner-close]"
								);
								this.events.register(closeButton, "click", (e) =>
									this._closeFlyOut(e)
								);
								this.events.register(document, "click", (e) =>
									this._handleDocumentClick(e)
								);
								this.events.register(document, "touchstart", (e) =>
									this._handleDocumentClick(e)
								);
								this.events.register(document, "closeFlyouts", (e) =>
									this._closeFlyOut(e)
								);
								this.events.register(window, "keydown", (e) =>
									this._closeEsc(e)
								);

								this._enableAtcButton();

								this.atcAnimation = transition({
									el: this.flyOut,
									state: "closed",
								});
								this.atcAnimation.animateTo("open").then(() => {
									trapFocus(this.flyOut);
								});
							});
					})
					.fail((response) => {
						let errorText;

						try {
							const responseText = JSON.parse(response.responseText);
							errorText = responseText.description;
						} catch (error) {
							errorText = `${response.status} ${response.statusText}`;

							if (response.status === 401) {
								errorText = `${errorText}. Try refreshing and logging in.`;
							}
						}

						this._enableAtcButton();

						if (errorText.email) {
							this.recipientForm.classList.add("recipient-form--has-errors");
						} else {
							this.callbacks.onError(errorText);
						}
					});
			}

			_onError(error) {
				this.messageBanner = new MessageBanner(error, "error");
			}

			_onInit() {
				if (this.messageBanner) {
					this.messageBanner.unload();
				}

				if (this.announcementBar) {
					this.announcementBar.style.setProperty(
						"--index-announcement-bar",
						"1100"
					);
				}

				if (this.utilityBar) {
					this.utilityBar.style.setProperty("--index-utility-bar", "1100");
				}
			}

			_onSuccess() {
				/*
          By default, the ATC Flyout doesn't need any additional success callbacks
           The `this.callbacks.onSuccess` is used to allow other views to initiate
          behaviour when a product has been added to the cart
         */
			}

			_onCloseAll() {
				/*
          By default, the ATC Flyout doesn't need any additional close callbacks
           The `this.callbacks.onClose` is used to allow other views to initiate
          behaviour when the atc banner has been closed
         */
			}

			_closeEsc(e) {
				if (e.key === "Escape") {
					this._closeFlyOut(e);
				}
			}
			/**
			 * Close an open FlyOut
			 *
			 * @private
			 */

			_closeFlyOut() {
				if (!this.flyOut) {
					return;
				}

				removeTrapFocus(this.flyOut); // if the user clicked onto the search box, move focus
				// to the search instead of going to the previous active element.

				if (
					this.documentClickEventTarget &&
					"liveSearchInput" in this.documentClickEventTarget.dataset
				) {
					this.documentClickEventTarget.focus();
				} else if (this.activeElement) {
					this.activeElement.focus();
				}

				this.atcAnimation.animateTo("closed").then(() => {
					if (this.announcementBar) {
						this.announcementBar.style.setProperty(
							"--index-announcement-bar",
							""
						);
					}

					if (this.utilityBar) {
						this.utilityBar.style.setProperty("--index-utility-bar", "");
					}

					this.callbacks.onClose();
					this.flyOut.remove();
					this.flyOut = null;
					this.events.unregisterAll();
					this.atcAnimation.unload();
					delete this.Images;
				});
			}

			_disableAtcButton() {
				this.atcButton.classList.add("processing");
				this.atcButton.setAttribute("disabled", "disabled");
			}

			_enableAtcButton() {
				this.atcButton.removeAttribute("disabled");
				this.atcButton.classList.remove("processing");
			}

			_handleDocumentClick(e) {
				const { target } = e;
				const $parent = jquery_default()(target).parents("[data-atc-banner]");

				if ($parent.length) {
					return;
				}

				this.documentClickEventTarget = target;

				this._closeFlyOut(e);
			}
		} // CONCATENATED MODULE: ./node_modules/drift-zoom/es/util/dom.js
		function _typeof(obj) {
			"@babel/helpers - typeof";
			if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
				_typeof = function _typeof(obj) {
					return typeof obj;
				};
			} else {
				_typeof = function _typeof(obj) {
					return obj &&
						typeof Symbol === "function" &&
						obj.constructor === Symbol &&
						obj !== Symbol.prototype
						? "symbol"
						: typeof obj;
				};
			}
			return _typeof(obj);
		}

		// This is not really a perfect check, but works fine.
		// From http://stackoverflow.com/questions/384286
		var HAS_DOM_2 =
			(typeof HTMLElement === "undefined"
				? "undefined"
				: _typeof(HTMLElement)) === "object";
		function isDOMElement(obj) {
			return HAS_DOM_2
				? obj instanceof HTMLElement
				: obj &&
						_typeof(obj) === "object" &&
						obj !== null &&
						obj.nodeType === 1 &&
						typeof obj.nodeName === "string";
		}
		function addClasses(el, classNames) {
			classNames.forEach(function (className) {
				el.classList.add(className);
			});
		}
		function removeClasses(el, classNames) {
			classNames.forEach(function (className) {
				el.classList.remove(className);
			});
		} // CONCATENATED MODULE: ./node_modules/drift-zoom/es/injectBaseStylesheet.js
		//# sourceMappingURL=dom.js.map
		/* UNMINIFIED RULES
    
    const RULES = `
    @keyframes noop {
      0% { zoom: 1; }
    }
    
    @-webkit-keyframes noop {
      0% { zoom: 1; }
    }
    
    .drift-zoom-pane.drift-open {
      display: block;
    }
    
    .drift-zoom-pane.drift-opening, .drift-zoom-pane.drift-closing {
      animation: noop 1ms;
      -webkit-animation: noop 1ms;
    }
    
    .drift-zoom-pane {
      position: absolute;
      overflow: hidden;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      pointer-events: none;
    }
    
    .drift-zoom-pane-loader {
      display: none;
    }
    
    .drift-zoom-pane img {
      position: absolute;
      display: block;
      max-width: none;
      max-height: none;
    }
    
    .drift-bounding-box {
      position: absolute;
      pointer-events: none;
    }
    `;
    
    */
		var RULES =
			".drift-bounding-box,.drift-zoom-pane{position:absolute;pointer-events:none}@keyframes noop{0%{zoom:1}}@-webkit-keyframes noop{0%{zoom:1}}.drift-zoom-pane.drift-open{display:block}.drift-zoom-pane.drift-closing,.drift-zoom-pane.drift-opening{animation:noop 1ms;-webkit-animation:noop 1ms}.drift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.drift-zoom-pane-loader{display:none}.drift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}";
		function injectBaseStylesheet() {
			if (document.querySelector(".drift-base-styles")) {
				return;
			}

			var styleEl = document.createElement("style");
			styleEl.type = "text/css";
			styleEl.classList.add("drift-base-styles");
			styleEl.appendChild(document.createTextNode(RULES));
			var head = document.head;
			head.insertBefore(styleEl, head.firstChild);
		} // CONCATENATED MODULE: ./node_modules/drift-zoom/es/util/throwIfMissing.js
		//# sourceMappingURL=injectBaseStylesheet.js.map
		function throwIfMissing() {
			throw new Error("Missing parameter");
		} // CONCATENATED MODULE: ./node_modules/drift-zoom/es/BoundingBox.js
		//# sourceMappingURL=throwIfMissing.js.map
		function BoundingBox_classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function BoundingBox_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function BoundingBox_createClass(Constructor, protoProps, staticProps) {
			if (protoProps)
				BoundingBox_defineProperties(Constructor.prototype, protoProps);
			if (staticProps) BoundingBox_defineProperties(Constructor, staticProps);
			return Constructor;
		}

		var BoundingBox = /*#__PURE__*/ (function () {
			function BoundingBox(options) {
				BoundingBox_classCallCheck(this, BoundingBox);

				this.isShowing = false;
				var _options$namespace = options.namespace,
					namespace = _options$namespace === void 0 ? null : _options$namespace,
					_options$zoomFactor = options.zoomFactor,
					zoomFactor =
						_options$zoomFactor === void 0
							? throwIfMissing()
							: _options$zoomFactor,
					_options$containerEl = options.containerEl,
					containerEl =
						_options$containerEl === void 0
							? throwIfMissing()
							: _options$containerEl;
				this.settings = {
					namespace: namespace,
					zoomFactor: zoomFactor,
					containerEl: containerEl,
				};
				this.openClasses = this._buildClasses("open");

				this._buildElement();
			}

			BoundingBox_createClass(BoundingBox, [
				{
					key: "_buildClasses",
					value: function _buildClasses(suffix) {
						var classes = ["drift-".concat(suffix)];
						var ns = this.settings.namespace;

						if (ns) {
							classes.push("".concat(ns, "-").concat(suffix));
						}

						return classes;
					},
				},
				{
					key: "_buildElement",
					value: function _buildElement() {
						this.el = document.createElement("div");
						addClasses(this.el, this._buildClasses("bounding-box"));
					},
				},
				{
					key: "show",
					value: function show(zoomPaneWidth, zoomPaneHeight) {
						this.isShowing = true;
						this.settings.containerEl.appendChild(this.el);
						var style = this.el.style;
						style.width = "".concat(
							Math.round(zoomPaneWidth / this.settings.zoomFactor),
							"px"
						);
						style.height = "".concat(
							Math.round(zoomPaneHeight / this.settings.zoomFactor),
							"px"
						);
						addClasses(this.el, this.openClasses);
					},
				},
				{
					key: "hide",
					value: function hide() {
						if (this.isShowing) {
							this.settings.containerEl.removeChild(this.el);
						}

						this.isShowing = false;
						removeClasses(this.el, this.openClasses);
					},
				},
				{
					key: "setPosition",
					value: function setPosition(
						percentageOffsetX,
						percentageOffsetY,
						triggerRect
					) {
						var pageXOffset = window.pageXOffset;
						var pageYOffset = window.pageYOffset;
						var inlineLeft =
							triggerRect.left +
							percentageOffsetX * triggerRect.width -
							this.el.clientWidth / 2 +
							pageXOffset;
						var inlineTop =
							triggerRect.top +
							percentageOffsetY * triggerRect.height -
							this.el.clientHeight / 2 +
							pageYOffset;

						if (inlineLeft < triggerRect.left + pageXOffset) {
							inlineLeft = triggerRect.left + pageXOffset;
						} else if (
							inlineLeft + this.el.clientWidth >
							triggerRect.left + triggerRect.width + pageXOffset
						) {
							inlineLeft =
								triggerRect.left +
								triggerRect.width -
								this.el.clientWidth +
								pageXOffset;
						}

						if (inlineTop < triggerRect.top + pageYOffset) {
							inlineTop = triggerRect.top + pageYOffset;
						} else if (
							inlineTop + this.el.clientHeight >
							triggerRect.top + triggerRect.height + pageYOffset
						) {
							inlineTop =
								triggerRect.top +
								triggerRect.height -
								this.el.clientHeight +
								pageYOffset;
						}

						this.el.style.left = "".concat(inlineLeft, "px");
						this.el.style.top = "".concat(inlineTop, "px");
					},
				},
			]);

			return BoundingBox;
		})(); // CONCATENATED MODULE: ./node_modules/drift-zoom/es/Trigger.js

		//# sourceMappingURL=BoundingBox.js.map
		function Trigger_classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function Trigger_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function Trigger_createClass(Constructor, protoProps, staticProps) {
			if (protoProps)
				Trigger_defineProperties(Constructor.prototype, protoProps);
			if (staticProps) Trigger_defineProperties(Constructor, staticProps);
			return Constructor;
		}

		var Trigger = /*#__PURE__*/ (function () {
			function Trigger() {
				var options =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: {};

				Trigger_classCallCheck(this, Trigger);

				this._show = this._show.bind(this);
				this._hide = this._hide.bind(this);
				this._handleEntry = this._handleEntry.bind(this);
				this._handleMovement = this._handleMovement.bind(this);
				var _options$el = options.el,
					el = _options$el === void 0 ? throwIfMissing() : _options$el,
					_options$zoomPane = options.zoomPane,
					zoomPane =
						_options$zoomPane === void 0 ? throwIfMissing() : _options$zoomPane,
					_options$sourceAttrib = options.sourceAttribute,
					sourceAttribute =
						_options$sourceAttrib === void 0
							? throwIfMissing()
							: _options$sourceAttrib,
					_options$handleTouch = options.handleTouch,
					handleTouch =
						_options$handleTouch === void 0
							? throwIfMissing()
							: _options$handleTouch,
					_options$onShow = options.onShow,
					onShow = _options$onShow === void 0 ? null : _options$onShow,
					_options$onHide = options.onHide,
					onHide = _options$onHide === void 0 ? null : _options$onHide,
					_options$hoverDelay = options.hoverDelay,
					hoverDelay = _options$hoverDelay === void 0 ? 0 : _options$hoverDelay,
					_options$touchDelay = options.touchDelay,
					touchDelay = _options$touchDelay === void 0 ? 0 : _options$touchDelay,
					_options$hoverBoundin = options.hoverBoundingBox,
					hoverBoundingBox =
						_options$hoverBoundin === void 0
							? throwIfMissing()
							: _options$hoverBoundin,
					_options$touchBoundin = options.touchBoundingBox,
					touchBoundingBox =
						_options$touchBoundin === void 0
							? throwIfMissing()
							: _options$touchBoundin,
					_options$namespace = options.namespace,
					namespace = _options$namespace === void 0 ? null : _options$namespace,
					_options$zoomFactor = options.zoomFactor,
					zoomFactor =
						_options$zoomFactor === void 0
							? throwIfMissing()
							: _options$zoomFactor,
					_options$boundingBoxC = options.boundingBoxContainer,
					boundingBoxContainer =
						_options$boundingBoxC === void 0
							? throwIfMissing()
							: _options$boundingBoxC;
				this.settings = {
					el: el,
					zoomPane: zoomPane,
					sourceAttribute: sourceAttribute,
					handleTouch: handleTouch,
					onShow: onShow,
					onHide: onHide,
					hoverDelay: hoverDelay,
					touchDelay: touchDelay,
					hoverBoundingBox: hoverBoundingBox,
					touchBoundingBox: touchBoundingBox,
					namespace: namespace,
					zoomFactor: zoomFactor,
					boundingBoxContainer: boundingBoxContainer,
				};

				if (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) {
					this.boundingBox = new BoundingBox({
						namespace: this.settings.namespace,
						zoomFactor: this.settings.zoomFactor,
						containerEl: this.settings.boundingBoxContainer,
					});
				}

				this.enabled = true;

				this._bindEvents();
			}

			Trigger_createClass(Trigger, [
				{
					key: "_preventDefault",
					value: function _preventDefault(event) {
						event.preventDefault();
					},
				},
				{
					key: "_preventDefaultAllowTouchScroll",
					value: function _preventDefaultAllowTouchScroll(event) {
						if (
							!this.settings.touchDelay ||
							!this._isTouchEvent(event) ||
							this.isShowing
						) {
							event.preventDefault();
						}
					},
				},
				{
					key: "_isTouchEvent",
					value: function _isTouchEvent(event) {
						return !!event.touches;
					},
				},
				{
					key: "_bindEvents",
					value: function _bindEvents() {
						this.settings.el.addEventListener(
							"mouseenter",
							this._handleEntry,
							false
						);
						this.settings.el.addEventListener("mouseleave", this._hide, false);
						this.settings.el.addEventListener(
							"mousemove",
							this._handleMovement,
							false
						);

						if (this.settings.handleTouch) {
							this.settings.el.addEventListener(
								"touchstart",
								this._handleEntry,
								false
							);
							this.settings.el.addEventListener("touchend", this._hide, false);
							this.settings.el.addEventListener(
								"touchmove",
								this._handleMovement,
								false
							);
						} else {
							this.settings.el.addEventListener(
								"touchstart",
								this._preventDefault,
								false
							);
							this.settings.el.addEventListener(
								"touchend",
								this._preventDefault,
								false
							);
							this.settings.el.addEventListener(
								"touchmove",
								this._preventDefault,
								false
							);
						}
					},
				},
				{
					key: "_unbindEvents",
					value: function _unbindEvents() {
						this.settings.el.removeEventListener(
							"mouseenter",
							this._handleEntry,
							false
						);
						this.settings.el.removeEventListener(
							"mouseleave",
							this._hide,
							false
						);
						this.settings.el.removeEventListener(
							"mousemove",
							this._handleMovement,
							false
						);

						if (this.settings.handleTouch) {
							this.settings.el.removeEventListener(
								"touchstart",
								this._handleEntry,
								false
							);
							this.settings.el.removeEventListener(
								"touchend",
								this._hide,
								false
							);
							this.settings.el.removeEventListener(
								"touchmove",
								this._handleMovement,
								false
							);
						} else {
							this.settings.el.removeEventListener(
								"touchstart",
								this._preventDefault,
								false
							);
							this.settings.el.removeEventListener(
								"touchend",
								this._preventDefault,
								false
							);
							this.settings.el.removeEventListener(
								"touchmove",
								this._preventDefault,
								false
							);
						}
					},
				},
				{
					key: "_handleEntry",
					value: function _handleEntry(e) {
						this._preventDefaultAllowTouchScroll(e);

						this._lastMovement = e;

						if (e.type == "mouseenter" && this.settings.hoverDelay) {
							this.entryTimeout = setTimeout(
								this._show,
								this.settings.hoverDelay
							);
						} else if (this.settings.touchDelay) {
							this.entryTimeout = setTimeout(
								this._show,
								this.settings.touchDelay
							);
						} else {
							this._show();
						}
					},
				},
				{
					key: "_show",
					value: function _show() {
						if (!this.enabled) {
							return;
						}

						var onShow = this.settings.onShow;

						if (onShow && typeof onShow === "function") {
							onShow();
						}

						this.settings.zoomPane.show(
							this.settings.el.getAttribute(this.settings.sourceAttribute),
							this.settings.el.clientWidth,
							this.settings.el.clientHeight
						);

						if (this._lastMovement) {
							var touchActivated = this._lastMovement.touches;

							if (
								(touchActivated && this.settings.touchBoundingBox) ||
								(!touchActivated && this.settings.hoverBoundingBox)
							) {
								this.boundingBox.show(
									this.settings.zoomPane.el.clientWidth,
									this.settings.zoomPane.el.clientHeight
								);
							}
						}

						this._handleMovement();
					},
				},
				{
					key: "_hide",
					value: function _hide(e) {
						if (e) {
							this._preventDefaultAllowTouchScroll(e);
						}

						this._lastMovement = null;

						if (this.entryTimeout) {
							clearTimeout(this.entryTimeout);
						}

						if (this.boundingBox) {
							this.boundingBox.hide();
						}

						var onHide = this.settings.onHide;

						if (onHide && typeof onHide === "function") {
							onHide();
						}

						this.settings.zoomPane.hide();
					},
				},
				{
					key: "_handleMovement",
					value: function _handleMovement(e) {
						if (e) {
							this._preventDefaultAllowTouchScroll(e);

							this._lastMovement = e;
						} else if (this._lastMovement) {
							e = this._lastMovement;
						} else {
							return;
						}

						var movementX;
						var movementY;

						if (e.touches) {
							var firstTouch = e.touches[0];
							movementX = firstTouch.clientX;
							movementY = firstTouch.clientY;
						} else {
							movementX = e.clientX;
							movementY = e.clientY;
						}

						var el = this.settings.el;
						var rect = el.getBoundingClientRect();
						var offsetX = movementX - rect.left;
						var offsetY = movementY - rect.top;
						var percentageOffsetX = offsetX / this.settings.el.clientWidth;
						var percentageOffsetY = offsetY / this.settings.el.clientHeight;

						if (this.boundingBox) {
							this.boundingBox.setPosition(
								percentageOffsetX,
								percentageOffsetY,
								rect
							);
						}

						this.settings.zoomPane.setPosition(
							percentageOffsetX,
							percentageOffsetY,
							rect
						);
					},
				},
				{
					key: "isShowing",
					get: function get() {
						return this.settings.zoomPane.isShowing;
					},
				},
			]);

			return Trigger;
		})(); // CONCATENATED MODULE: ./node_modules/drift-zoom/es/ZoomPane.js

		//# sourceMappingURL=Trigger.js.map
		function ZoomPane_classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function ZoomPane_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function ZoomPane_createClass(Constructor, protoProps, staticProps) {
			if (protoProps)
				ZoomPane_defineProperties(Constructor.prototype, protoProps);
			if (staticProps) ZoomPane_defineProperties(Constructor, staticProps);
			return Constructor;
		}

		// All officially-supported browsers have this, but it's easy to
		// account for, just in case.

		var divStyle = document.createElement("div").style;
		var HAS_ANIMATION =
			typeof document === "undefined"
				? false
				: "animation" in divStyle || "webkitAnimation" in divStyle;

		var ZoomPane = /*#__PURE__*/ (function () {
			function ZoomPane() {
				var options =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: {};

				ZoomPane_classCallCheck(this, ZoomPane);

				this._completeShow = this._completeShow.bind(this);
				this._completeHide = this._completeHide.bind(this);
				this._handleLoad = this._handleLoad.bind(this);
				this.isShowing = false;
				var _options$container = options.container,
					container = _options$container === void 0 ? null : _options$container,
					_options$zoomFactor = options.zoomFactor,
					zoomFactor =
						_options$zoomFactor === void 0
							? throwIfMissing()
							: _options$zoomFactor,
					_options$inline = options.inline,
					inline =
						_options$inline === void 0 ? throwIfMissing() : _options$inline,
					_options$namespace = options.namespace,
					namespace = _options$namespace === void 0 ? null : _options$namespace,
					_options$showWhitespa = options.showWhitespaceAtEdges,
					showWhitespaceAtEdges =
						_options$showWhitespa === void 0
							? throwIfMissing()
							: _options$showWhitespa,
					_options$containInlin = options.containInline,
					containInline =
						_options$containInlin === void 0
							? throwIfMissing()
							: _options$containInlin,
					_options$inlineOffset = options.inlineOffsetX,
					inlineOffsetX =
						_options$inlineOffset === void 0 ? 0 : _options$inlineOffset,
					_options$inlineOffset2 = options.inlineOffsetY,
					inlineOffsetY =
						_options$inlineOffset2 === void 0 ? 0 : _options$inlineOffset2,
					_options$inlineContai = options.inlineContainer,
					inlineContainer =
						_options$inlineContai === void 0
							? document.body
							: _options$inlineContai;
				this.settings = {
					container: container,
					zoomFactor: zoomFactor,
					inline: inline,
					namespace: namespace,
					showWhitespaceAtEdges: showWhitespaceAtEdges,
					containInline: containInline,
					inlineOffsetX: inlineOffsetX,
					inlineOffsetY: inlineOffsetY,
					inlineContainer: inlineContainer,
				};
				this.openClasses = this._buildClasses("open");
				this.openingClasses = this._buildClasses("opening");
				this.closingClasses = this._buildClasses("closing");
				this.inlineClasses = this._buildClasses("inline");
				this.loadingClasses = this._buildClasses("loading");

				this._buildElement();
			}

			ZoomPane_createClass(ZoomPane, [
				{
					key: "_buildClasses",
					value: function _buildClasses(suffix) {
						var classes = ["drift-".concat(suffix)];
						var ns = this.settings.namespace;

						if (ns) {
							classes.push("".concat(ns, "-").concat(suffix));
						}

						return classes;
					},
				},
				{
					key: "_buildElement",
					value: function _buildElement() {
						this.el = document.createElement("div");
						addClasses(this.el, this._buildClasses("zoom-pane"));
						var loaderEl = document.createElement("div");
						addClasses(loaderEl, this._buildClasses("zoom-pane-loader"));
						this.el.appendChild(loaderEl);
						this.imgEl = document.createElement("img");
						this.el.appendChild(this.imgEl);
					},
				},
				{
					key: "_setImageURL",
					value: function _setImageURL(imageURL) {
						this.imgEl.setAttribute("src", imageURL);
					},
				},
				{
					key: "_setImageSize",
					value: function _setImageSize(triggerWidth, triggerHeight) {
						this.imgEl.style.width = "".concat(
							triggerWidth * this.settings.zoomFactor,
							"px"
						);
						this.imgEl.style.height = "".concat(
							triggerHeight * this.settings.zoomFactor,
							"px"
						);
					}, // `percentageOffsetX` and `percentageOffsetY` must be percentages
					// expressed as floats between `0' and `1`.
				},
				{
					key: "setPosition",
					value: function setPosition(
						percentageOffsetX,
						percentageOffsetY,
						triggerRect
					) {
						var imgElWidth = this.imgEl.offsetWidth;
						var imgElHeight = this.imgEl.offsetHeight;
						var elWidth = this.el.offsetWidth;
						var elHeight = this.el.offsetHeight;
						var centreOfContainerX = elWidth / 2;
						var centreOfContainerY = elHeight / 2;
						var targetImgXToBeCentre = imgElWidth * percentageOffsetX;
						var targetImgYToBeCentre = imgElHeight * percentageOffsetY;
						var left = centreOfContainerX - targetImgXToBeCentre;
						var top = centreOfContainerY - targetImgYToBeCentre;
						var differenceBetweenContainerWidthAndImgWidth =
							elWidth - imgElWidth;
						var differenceBetweenContainerHeightAndImgHeight =
							elHeight - imgElHeight;
						var isContainerLargerThanImgX =
							differenceBetweenContainerWidthAndImgWidth > 0;
						var isContainerLargerThanImgY =
							differenceBetweenContainerHeightAndImgHeight > 0;
						var minLeft = isContainerLargerThanImgX
							? differenceBetweenContainerWidthAndImgWidth / 2
							: 0;
						var minTop = isContainerLargerThanImgY
							? differenceBetweenContainerHeightAndImgHeight / 2
							: 0;
						var maxLeft = isContainerLargerThanImgX
							? differenceBetweenContainerWidthAndImgWidth / 2
							: differenceBetweenContainerWidthAndImgWidth;
						var maxTop = isContainerLargerThanImgY
							? differenceBetweenContainerHeightAndImgHeight / 2
							: differenceBetweenContainerHeightAndImgHeight;

						if (this.el.parentElement === this.settings.inlineContainer) {
							// This may be needed in the future to deal with browser event
							// inconsistencies, but it's difficult to tell for sure.
							// let scrollX = isTouch ? 0 : window.scrollX;
							// let scrollY = isTouch ? 0 : window.scrollY;
							var scrollX = window.pageXOffset;
							var scrollY = window.pageYOffset;
							var inlineLeft =
								triggerRect.left +
								percentageOffsetX * triggerRect.width -
								elWidth / 2 +
								this.settings.inlineOffsetX +
								scrollX;
							var inlineTop =
								triggerRect.top +
								percentageOffsetY * triggerRect.height -
								elHeight / 2 +
								this.settings.inlineOffsetY +
								scrollY;

							if (this.settings.containInline) {
								if (inlineLeft < triggerRect.left + scrollX) {
									inlineLeft = triggerRect.left + scrollX;
								} else if (
									inlineLeft + elWidth >
									triggerRect.left + triggerRect.width + scrollX
								) {
									inlineLeft =
										triggerRect.left + triggerRect.width - elWidth + scrollX;
								}

								if (inlineTop < triggerRect.top + scrollY) {
									inlineTop = triggerRect.top + scrollY;
								} else if (
									inlineTop + elHeight >
									triggerRect.top + triggerRect.height + scrollY
								) {
									inlineTop =
										triggerRect.top + triggerRect.height - elHeight + scrollY;
								}
							}

							this.el.style.left = "".concat(inlineLeft, "px");
							this.el.style.top = "".concat(inlineTop, "px");
						}

						if (!this.settings.showWhitespaceAtEdges) {
							if (left > minLeft) {
								left = minLeft;
							} else if (left < maxLeft) {
								left = maxLeft;
							}

							if (top > minTop) {
								top = minTop;
							} else if (top < maxTop) {
								top = maxTop;
							}
						}

						this.imgEl.style.transform = "translate("
							.concat(left, "px, ")
							.concat(top, "px)");
						this.imgEl.style.webkitTransform = "translate("
							.concat(left, "px, ")
							.concat(top, "px)");
					},
				},
				{
					key: "_removeListenersAndResetClasses",
					value: function _removeListenersAndResetClasses() {
						this.el.removeEventListener(
							"animationend",
							this._completeShow,
							false
						);
						this.el.removeEventListener(
							"animationend",
							this._completeHide,
							false
						);
						this.el.removeEventListener(
							"webkitAnimationEnd",
							this._completeShow,
							false
						);
						this.el.removeEventListener(
							"webkitAnimationEnd",
							this._completeHide,
							false
						);
						removeClasses(this.el, this.openClasses);
						removeClasses(this.el, this.closingClasses);
					},
				},
				{
					key: "show",
					value: function show(imageURL, triggerWidth, triggerHeight) {
						this._removeListenersAndResetClasses();

						this.isShowing = true;
						addClasses(this.el, this.openClasses);

						if (this.imgEl.getAttribute("src") != imageURL) {
							addClasses(this.el, this.loadingClasses);
							this.imgEl.addEventListener("load", this._handleLoad, false);

							this._setImageURL(imageURL);
						}

						this._setImageSize(triggerWidth, triggerHeight);

						if (this._isInline) {
							this._showInline();
						} else {
							this._showInContainer();
						}

						if (HAS_ANIMATION) {
							this.el.addEventListener(
								"animationend",
								this._completeShow,
								false
							);
							this.el.addEventListener(
								"webkitAnimationEnd",
								this._completeShow,
								false
							);
							addClasses(this.el, this.openingClasses);
						}
					},
				},
				{
					key: "_showInline",
					value: function _showInline() {
						this.settings.inlineContainer.appendChild(this.el);
						addClasses(this.el, this.inlineClasses);
					},
				},
				{
					key: "_showInContainer",
					value: function _showInContainer() {
						this.settings.container.appendChild(this.el);
					},
				},
				{
					key: "hide",
					value: function hide() {
						this._removeListenersAndResetClasses();

						this.isShowing = false;

						if (HAS_ANIMATION) {
							this.el.addEventListener(
								"animationend",
								this._completeHide,
								false
							);
							this.el.addEventListener(
								"webkitAnimationEnd",
								this._completeHide,
								false
							);
							addClasses(this.el, this.closingClasses);
						} else {
							removeClasses(this.el, this.openClasses);
							removeClasses(this.el, this.inlineClasses);
						}
					},
				},
				{
					key: "_completeShow",
					value: function _completeShow() {
						this.el.removeEventListener(
							"animationend",
							this._completeShow,
							false
						);
						this.el.removeEventListener(
							"webkitAnimationEnd",
							this._completeShow,
							false
						);
						removeClasses(this.el, this.openingClasses);
					},
				},
				{
					key: "_completeHide",
					value: function _completeHide() {
						this.el.removeEventListener(
							"animationend",
							this._completeHide,
							false
						);
						this.el.removeEventListener(
							"webkitAnimationEnd",
							this._completeHide,
							false
						);
						removeClasses(this.el, this.openClasses);
						removeClasses(this.el, this.closingClasses);
						removeClasses(this.el, this.inlineClasses);
						this.el.setAttribute("style", ""); // The window could have been resized above or below `inline`
						// limits since the ZoomPane was shown. Because of this, we
						// can't rely on `this._isInline` here.

						if (this.el.parentElement === this.settings.container) {
							this.settings.container.removeChild(this.el);
						} else if (
							this.el.parentElement === this.settings.inlineContainer
						) {
							this.settings.inlineContainer.removeChild(this.el);
						}
					},
				},
				{
					key: "_handleLoad",
					value: function _handleLoad() {
						this.imgEl.removeEventListener("load", this._handleLoad, false);
						removeClasses(this.el, this.loadingClasses);
					},
				},
				{
					key: "_isInline",
					get: function get() {
						var inline = this.settings.inline;
						return (
							inline === true ||
							(typeof inline === "number" && window.innerWidth <= inline)
						);
					},
				},
			]);

			return ZoomPane;
		})(); // CONCATENATED MODULE: ./node_modules/drift-zoom/es/Drift.js

		//# sourceMappingURL=ZoomPane.js.map
		function Drift_classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function Drift_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function Drift_createClass(Constructor, protoProps, staticProps) {
			if (protoProps) Drift_defineProperties(Constructor.prototype, protoProps);
			if (staticProps) Drift_defineProperties(Constructor, staticProps);
			return Constructor;
		}

		var Drift = /*#__PURE__*/ (function () {
			function Drift(triggerEl) {
				var options =
					arguments.length > 1 && arguments[1] !== undefined
						? arguments[1]
						: {};

				Drift_classCallCheck(this, Drift);

				this.VERSION = "1.4.1";
				this.triggerEl = triggerEl;
				this.destroy = this.destroy.bind(this);

				if (!isDOMElement(this.triggerEl)) {
					throw new TypeError(
						"`new Drift` requires a DOM element as its first argument."
					);
				} // Prefix for generated element class names (e.g. `my-ns` will
				// result in classes such as `my-ns-pane`. Default `drift-`
				// prefixed classes will always be added as well.

				var namespace = options["namespace"] || null; // Whether the ZoomPane should show whitespace when near the edges.

				var showWhitespaceAtEdges = options["showWhitespaceAtEdges"] || false; // Whether the inline ZoomPane should stay inside
				// the bounds of its image.

				var containInline = options["containInline"] || false; // How much to offset the ZoomPane from the
				// interaction point when inline.

				var inlineOffsetX = options["inlineOffsetX"] || 0;
				var inlineOffsetY = options["inlineOffsetY"] || 0; // A DOM element to append the inline ZoomPane to

				var inlineContainer = options["inlineContainer"] || document.body; // Which trigger attribute to pull the ZoomPane image source from.

				var sourceAttribute = options["sourceAttribute"] || "data-zoom"; // How much to magnify the trigger by in the ZoomPane.
				// (e.g., `zoomFactor: 3` will result in a 900 px wide ZoomPane imag
				// if the trigger is displayed at 300 px wide)

				var zoomFactor = options["zoomFactor"] || 3; // A DOM element to append the non-inline ZoomPane to.
				// Required if `inlinePane !== true`.

				var paneContainer =
					options["paneContainer"] === undefined
						? document.body
						: options["paneContainer"]; // When to switch to an inline ZoomPane. This can be a boolean or
				// an integer. If `true`, the ZoomPane will always be inline,
				// if `false`, it will switch to inline when `windowWidth <= inlinePane`

				var inlinePane = options["inlinePane"] || 375; // If `true`, touch events will trigger the zoom, like mouse events.

				var handleTouch =
					"handleTouch" in options ? !!options["handleTouch"] : true; // If present (and a function), this will be called
				// whenever the ZoomPane is shown.

				var onShow = options["onShow"] || null; // If present (and a function), this will be called
				// whenever the ZoomPane is hidden.

				var onHide = options["onHide"] || null; // Add base styles to the page. See the "Theming"
				// section of README.md for more information.

				var injectBaseStyles =
					"injectBaseStyles" in options ? !!options["injectBaseStyles"] : true; // An optional number that determines how long to wait before
				// showing the ZoomPane because of a `mouseenter` event.

				var hoverDelay = options["hoverDelay"] || 0; // An optional number that determines how long to wait before
				// showing the ZoomPane because of a `touchstart` event.
				// It's unlikely that you would want to use this option, since
				// "tap and hold" is much more intentional than a hover event.

				var touchDelay = options["touchDelay"] || 0; // If true, a bounding box will show the area currently being previewed
				// during mouse hover

				var hoverBoundingBox = options["hoverBoundingBox"] || false; // If true, a bounding box will show the area currently being previewed
				// during touch events

				var touchBoundingBox = options["touchBoundingBox"] || false; // A DOM element to append the bounding box to.

				var boundingBoxContainer =
					options["boundingBoxContainer"] || document.body;

				if (inlinePane !== true && !isDOMElement(paneContainer)) {
					throw new TypeError(
						"`paneContainer` must be a DOM element when `inlinePane !== true`"
					);
				}

				if (!isDOMElement(inlineContainer)) {
					throw new TypeError("`inlineContainer` must be a DOM element");
				}

				this.settings = {
					namespace: namespace,
					showWhitespaceAtEdges: showWhitespaceAtEdges,
					containInline: containInline,
					inlineOffsetX: inlineOffsetX,
					inlineOffsetY: inlineOffsetY,
					inlineContainer: inlineContainer,
					sourceAttribute: sourceAttribute,
					zoomFactor: zoomFactor,
					paneContainer: paneContainer,
					inlinePane: inlinePane,
					handleTouch: handleTouch,
					onShow: onShow,
					onHide: onHide,
					injectBaseStyles: injectBaseStyles,
					hoverDelay: hoverDelay,
					touchDelay: touchDelay,
					hoverBoundingBox: hoverBoundingBox,
					touchBoundingBox: touchBoundingBox,
					boundingBoxContainer: boundingBoxContainer,
				};

				if (this.settings.injectBaseStyles) {
					injectBaseStylesheet();
				}

				this._buildZoomPane();

				this._buildTrigger();
			}

			Drift_createClass(Drift, [
				{
					key: "_buildZoomPane",
					value: function _buildZoomPane() {
						this.zoomPane = new ZoomPane({
							container: this.settings.paneContainer,
							zoomFactor: this.settings.zoomFactor,
							showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
							containInline: this.settings.containInline,
							inline: this.settings.inlinePane,
							namespace: this.settings.namespace,
							inlineOffsetX: this.settings.inlineOffsetX,
							inlineOffsetY: this.settings.inlineOffsetY,
							inlineContainer: this.settings.inlineContainer,
						});
					},
				},
				{
					key: "_buildTrigger",
					value: function _buildTrigger() {
						this.trigger = new Trigger({
							el: this.triggerEl,
							zoomPane: this.zoomPane,
							handleTouch: this.settings.handleTouch,
							onShow: this.settings.onShow,
							onHide: this.settings.onHide,
							sourceAttribute: this.settings.sourceAttribute,
							hoverDelay: this.settings.hoverDelay,
							touchDelay: this.settings.touchDelay,
							hoverBoundingBox: this.settings.hoverBoundingBox,
							touchBoundingBox: this.settings.touchBoundingBox,
							namespace: this.settings.namespace,
							zoomFactor: this.settings.zoomFactor,
							boundingBoxContainer: this.settings.boundingBoxContainer,
						});
					},
				},
				{
					key: "setZoomImageURL",
					value: function setZoomImageURL(imageURL) {
						this.zoomPane._setImageURL(imageURL);
					},
				},
				{
					key: "disable",
					value: function disable() {
						this.trigger.enabled = false;
					},
				},
				{
					key: "enable",
					value: function enable() {
						this.trigger.enabled = true;
					},
				},
				{
					key: "destroy",
					value: function destroy() {
						this.trigger._hide();

						this.trigger._unbindEvents();
					},
				},
				{
					key: "isShowing",
					get: function get() {
						return this.zoomPane.isShowing;
					},
				},
				{
					key: "zoomFactor",
					get: function get() {
						return this.settings.zoomFactor;
					},
					set: function set(zf) {
						this.settings.zoomFactor = zf;
						this.zoomPane.settings.zoomFactor = zf;
						this.trigger.settings.zoomFactor = zf;
						this.boundingBox.settings.zoomFactor = zf;
					},
				},
			]);

			return Drift;
		})(); // Public API

		/* eslint-disable no-self-assign */

		Object.defineProperty(Drift.prototype, "isShowing", {
			get: function get() {
				return this.isShowing;
			},
		});
		Object.defineProperty(Drift.prototype, "zoomFactor", {
			get: function get() {
				return this.zoomFactor;
			},
			set: function set(value) {
				this.zoomFactor = value;
			},
		});
		Drift.prototype["setZoomImageURL"] = Drift.prototype.setZoomImageURL;
		Drift.prototype["disable"] = Drift.prototype.disable;
		Drift.prototype["enable"] = Drift.prototype.enable;
		Drift.prototype["destroy"] = Drift.prototype.destroy; // CONCATENATED MODULE: ./source/scripts/components/Youtube.js
		/* eslint-enable no-self-assign */
		//# sourceMappingURL=Drift.js.map
		const api = "https://www.youtube.com/iframe_api";
		let apiLoadedCallbacks = [];
		let apiLoaded = false;

		window.onYouTubeIframeAPIReady = () => {
			apiLoadedCallbacks.forEach((apiLoadedCallback) => apiLoadedCallback());
			apiLoadedCallbacks = [];
			apiLoaded = true;
		};

		class Youtube {
			constructor(_ref) {
				let { el, videoUrl, loop } = _ref;
				const regex =
					/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i; // eslint-disable-line no-useless-escape

				this.el = el;
				this.id = videoUrl.match(regex)[1] || null;
				this.onApiLoaded = this._onApiLoaded.bind(this);
				this.isReady = false;
				this.onReady = this._onReady.bind(this);
				this.onReadyCallback = null;
				this.loop = loop ? 1 : 0;
				this.onStateChange = this._onStateChange.bind(this);
				this.onPlayCallback = null;

				if (apiLoaded) {
					this._onApiLoaded();
				} else {
					apiLoadedCallbacks.push(this.onApiLoaded);
					script_default()(api);
				}
			}

			play() {
				return new Promise((resolve) => {
					this.onPlayCallback = resolve;

					if (this.isReady) {
						this.player.playVideo();
					} else {
						this.onReadyCallback = () => {
							this.player.playVideo();
						};
					}
				});
			}

			pause() {
				return new Promise((resolve) => {
					this.onPlayCallback = resolve;

					if (this.isReady) {
						this.player.pauseVideo();
					} else {
						this.onReadyCallback = () => {
							this.player.pauseVideo();
						};
					}
				});
			}

			autoplay() {
				return new Promise((resolve) => {
					this.onPlayCallback = resolve;

					if (this.isReady) {
						this.player.playVideo();
						this.player.mute();
					} else {
						this.onReadyCallback = () => {
							this.player.playVideo();
							this.player.mute();
						};
					}
				});
			}

			unload() {
				this.player.destroy();
			}

			_onApiLoaded() {
				const playerVars = {
					modestbranding: true,
					showinfo: false,
					controls: false,
					loop: this.loop,
					rel: 0,
				};

				if (this.loop) {
					// This is required to allow 'loop' to work based on the YouTube api
					playerVars.playlist = this.id;
				}

				this.player = new YT.Player(this.el, {
					videoId: this.id,
					playerVars,
					events: {
						onReady: this.onReady,
						onStateChange: this.onStateChange,
					},
				});
			}

			_onReady() {
				this.isReady = true;

				if (this.onReadyCallback) {
					this.onReadyCallback();
				}
			}

			_onStateChange(event) {
				const state = event.data;

				if (this.onPlayCallback && state === YT.PlayerState.BUFFERING) {
					this.onPlayCallback();
					this.onPlayCallback = null;
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/components/Vimeo.js
		const Vimeo_api = "https://player.vimeo.com/api/player.js";
		let Vimeo_apiLoaded = false;
		class VimeoPlayer {
			constructor(_ref) {
				let { el, videoUrl } = _ref;
				this.el = el;
				const urlParts = videoUrl.split("/");
				this.id = urlParts[urlParts.length - 1].split("?")[0];
				this.onReadyCallback = null;
				this.onApiLoaded = this._onApiLoaded.bind(this);
				this.onProgress = this._onProgress.bind(this);
				this.onProgressCallback = null;

				if (Vimeo_apiLoaded) {
					this._onApiLoaded();
				} else {
					script_default()(Vimeo_api, this.onApiLoaded);
				}
			}

			play() {
				return new Promise((resolve) => {
					this.onProgressCallback = resolve;

					if (Vimeo_apiLoaded) {
						this.player.on("play", this.onProgress);
						this.player.play();
					} else {
						this.onReadyCallback = () => {
							this.player.on("play", this.onProgress);
							this.player.play();
						};
					}
				});
			}

			pause() {
				return new Promise((resolve) => {
					this.onProgressCallback = resolve;

					if (Vimeo_apiLoaded) {
						this.player.on("pause", this.onProgress);
						this.player.pause();
					} else {
						this.onReadyCallback = () => {
							this.player.on("pause", this.onProgress);
							this.player.pause();
						};
					}
				});
			}

			autoplay() {
				return new Promise((resolve) => {
					this.onProgressCallback = resolve;

					if (Vimeo_apiLoaded) {
						this.player.on("play", this.onProgress);
						this.player.setVolume(0);
						this.player.play();
					} else {
						this.onReadyCallback = () => {
							this.player.on("play", this.onProgress);
							this.player.setVolume(0);
							this.player.play();
						};
					}
				});
			}

			unload() {
				this.player.unload().catch();
			}

			_onApiLoaded() {
				this.player = new window.Vimeo.Player(this.el, {
					id: this.id,
				});
				this.player.ready().then().catch();
				Vimeo_apiLoaded = true;

				if (this.onReadyCallback) {
					this.onReadyCallback();
				}
			}

			_onProgress() {
				this.player.off("play", this.onProgress);
				this.player.off("pause", this.onProgress);

				if (this.onProgressCallback) {
					this.onProgressCallback();
					this.onProgressCallback = null;
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/components/Video.js
		class Video {
			constructor(el, options) {
				this.el = el;
				this.options = options;
				this.platform = el.getAttribute("data-video").trim();
				this.playButton = el.querySelector("[data-video-play-button]");
				this.videoEl = el.querySelector("[data-video-element]");
				this.onPlayClick = this._onPlayClick.bind(this);
				this.onPauseClick = this._onPauseClick.bind(this);
				this.autoplay = this._autoplay.bind(this);
				this.video = null;
				this.videoData = {
					el: this.videoEl.childNodes[0],
					videoUrl: this.videoEl.getAttribute("data-video-url"),
					loop: this.options && this.options.loop,
				};

				switch (this.platform) {
					case "youtube":
						this.video = new Youtube(this.videoData);
						break;

					case "vimeo":
						this.video = new VimeoPlayer(this.videoData);
						break;

					default:
						this.video = null;
						break;
				}

				this.el.addEventListener("click", this.onPlayClick);

				if (this.playButton) {
					if (this.options && this.options.autoplay) {
						this.autoplay();
					}

					this.playButton.addEventListener("click", this.onPlayClick);
				}
			}

			_onPlayClick() {
				this.el.classList.add("video-loading");
				this.video.play().then(() => {
					this.el.classList.add("video-transitioning");
					setTimeout(() => {
						this.el.classList.remove("video-loading");
						this.el.classList.remove("video-transitioning");
						this.el.classList.add("video-playing");
					}, 200);
				});
			}

			_onPauseClick() {
				this.video.pause();
			}

			_autoplay() {
				this.el.classList.add("video-loading");
				this.video.autoplay().then(() => {
					this.el.classList.add("video-transitioning");
					setTimeout(() => {
						this.el.classList.remove("video-loading");
						this.el.classList.remove("video-transitioning");
						this.el.classList.add("video-playing");
					}, 200);
				});
			}

			play() {
				this._onPlayClick();
			}

			pause() {
				this._onPauseClick();
			}

			unload() {
				this.el.removeEventListener("click", this.onPlayClick);

				if (this.playButton) {
					this.playButton.removeEventListener("click", this.onPlayClick);
				}

				if (this.video) {
					this.video.unload();
				}
			}

			destroy() {
				this.unload();
			}
		}
		// EXTERNAL MODULE: ./node_modules/photoswipe/dist/photoswipe.js
		var photoswipe = __webpack_require__(832);
		var photoswipe_default = /*#__PURE__*/ __webpack_require__.n(photoswipe);
		// EXTERNAL MODULE: ./node_modules/photoswipe/dist/photoswipe-ui-default.js
		var photoswipe_ui_default = __webpack_require__(411);
		var photoswipe_ui_default_default = /*#__PURE__*/ __webpack_require__.n(
			photoswipe_ui_default
		); // CONCATENATED MODULE: ./source/scripts/components/ProductClickToZoom.js
		class ProductClickToZoom {
			constructor(_ref) {
				let {
					settings,
					slides,
					originalThumbnails,
					startIndex,
					selectGalleryIndex,
				} = _ref;
				this.settings = settings;
				this.photoswipeDialog = document.querySelector("[data-photoswipe]");
				this.thumbContainer = this.photoswipeDialog.querySelector(
					"[data-photoswipe-thumbs]"
				);
				this.thumbScroller = this.photoswipeDialog.querySelector(
					"[data-photoswipe-thumb-scroller]"
				);
				this.thumbScrollerButtons = this.photoswipeDialog.querySelectorAll(
					"[data-gallery-scroll-button]"
				);
				this.closeButton = this.photoswipeDialog.querySelector(
					".pswp__button--close"
				);
				this.selectedSlide = slides[startIndex];
				this.thumbScroller.innerHTML = "";
				this.thumbnails = [];
				let selectedIndex = startIndex; // Clone the original thumbnails into the photoswipe dialog

				originalThumbnails.forEach((thumb, thumbIndex) => {
					if (thumb.dataset.mediaType !== "image") {
						if (startIndex > thumbIndex) selectedIndex--;
						return;
					}

					const newThumb = thumb.cloneNode(true);
					this.thumbScroller.appendChild(newThumb);
					this.thumbnails.push(newThumb);
				});
				dist_index_es.watch(this.thumbContainer);
				this.selectedThumb = this.thumbContainer.querySelector(
					'[data-gallery-selected="true"]'
				);
				this.events = new EventHandler /* default */.Z(); // Set up options for initializing PhotoSwipe

				const photoswipeSlides = [];
				slides.forEach((slide) => {
					if (
						["video", "external_video", "model"].indexOf(
							slide.dataset.mediaType
						) > -1
					)
						return;
					photoswipeSlides.push({
						src: slide.dataset.zoom,
						msrc: slide.dataset.zoom,
						h: slide.dataset.imageHeight,
						w: slide.dataset.imageWidth,
					});
				}); // Adjust the bottom bar height to allow for the mobile thumbnails

				const bottomBarHeight = Layout.isGreaterThanBreakpoint("L", true)
					? 0
					: 75;
				const photoswipeOptions = {
					index: selectedIndex,
					barsSize: {
						top: 0,
						bottom: bottomBarHeight,
					},
					fullscreenEl: false,
					zoomEl: false,
					shareEl: false,
					counterEl: false,
					arrowEl: false,
					preloaderEl: false,
					closeOnScroll: false,
					showHideOpacity: true,
					history: false,
					loop: true,
					clickToCloseNonZoomable: false,
					timeToIdle: false,
					timeToIdleOutside: false,
				};

				if (
					this.settings.gallery_click_to_zoom === "always" ||
					(Layout.isGreaterThanBreakpoint("S", true) &&
						this.settings.gallery_click_to_zoom === "desktop") ||
					(Layout.isLessThanBreakpoint("S") &&
						this.settings.gallery_click_to_zoom === "mobile")
				) {
					photoswipeOptions.getThumbBoundsFn = () => {
						const pageYScroll =
							window.pageYOffset || document.documentElement.scrollTop;
						const bounds = this.selectedSlide
							.querySelector("[data-rimg]")
							.getBoundingClientRect();
						return {
							x: bounds.left,
							y: bounds.top + pageYScroll,
							w: bounds.width,
						};
					};
				}

				this.photoswipe = new (photoswipe_default())(
					this.photoswipeDialog,
					photoswipe_ui_default_default(),
					photoswipeSlides,
					photoswipeOptions
				);
				this.events.register(this.closeButton, "click", () =>
					this.photoswipe.close()
				); // The following fixes an issue on iOS12 and below, where click events were not registering

				this.events.register(this.closeButton, "touchstart", () =>
					this.photoswipe.close()
				);
				this.thumbnails.forEach((thumb, index) => {
					this.events.register(thumb, "click", () => {
						this.photoswipe.goTo(index);
					});
				});
				this.events.register(this.thumbScroller, "scroll", () =>
					this._handleScrollButtonVisibility()
				);
				this.events.register(this.thumbScrollerButtons[0], "click", () =>
					this._onScrollButtonClick(true)
				);
				this.events.register(this.thumbScrollerButtons[1], "click", () =>
					this._onScrollButtonClick(false)
				); // Photoswipe documentation claims that the closeOnVerticalDrag option is always false if
				// the mouse is used, which is what we want. Unfortunately that's not how it actually works,
				// so we need to dynamically update the setting when a mouse is detected.

				if (this.photoswipe.options.mouseUsed) {
					this.photoswipe.options.closeOnVerticalDrag = false;
				} else {
					this.photoswipe.listen("mouseUsed", () => {
						this.photoswipe.options.closeOnVerticalDrag = false;
					});
				}

				this.photoswipe.listen("afterChange", () => {
					const index = this.photoswipe.getCurrentIndex();

					if (this.selectedThumb) {
						this.selectedThumb.dataset.gallerySelected = false;
					}

					this.selectedThumb = this.thumbnails[index];
					this.selectedThumb.dataset.gallerySelected = true;
					const slideIndex =
						this.selectedThumb.getAttribute("data-gallery-index");
					const slide = slides[slideIndex];

					this._adjustMobileThumbPosition();

					this._handleScrollButtonVisibility();

					selectGalleryIndex(slideIndex);
					this.selectedSlide = slide;
				});
				this.photoswipe.listen("close", () => {
					removeTrapFocus(this.photoswipeDialog);
					this.selectedSlide.focus();
					this.photoswipe = null;
				});
				this.photoswipe.listen("destroy", () => {
					this.events.unregisterAll();
					this.photoswipe = null;
				}); // Detect if mouse is over the thumbnails, if it is allow scroll left/right

				this.events.register(this.thumbContainer, "mouseenter", () => {
					if (Layout.isLessThanBreakpoint("S")) {
						this.photoswipe.options.closeOnScroll = true;
					}
				});
				this.events.register(this.thumbContainer, "mouseleave", () => {
					if (Layout.isLessThanBreakpoint("S")) {
						this.photoswipe.options.closeOnScroll = false;
					}
				}); // If a user closes the dialog using the escape key, then we should focus
				// on the expand button.

				const closeEsc = (e) => {
					if (e.key === "Escape") {
						slides[0].parentNode.querySelector("[data-gallery-expand]").focus();
					}
				};

				this.events.register(window, "keydown", (e) => closeEsc(e));
				this.photoswipe.init();
				trapFocus(this.photoswipeDialog);
			}

			_adjustMobileThumbPosition() {
				// This brings the thumbnail into view if it is not visible on the screen after
				// a user swipes to a slide that it is tied to.
				if (Layout.isLessThanBreakpoint("S")) {
					const thumbBounds = this.selectedThumb.getBoundingClientRect();
					const thumbWrapperBounds = this.thumbScroller.getBoundingClientRect();

					if (
						thumbBounds.left + thumbBounds.width + 30 >
						thumbWrapperBounds.width
					) {
						this.thumbScroller.scrollLeft =
							this.selectedThumb.offsetLeft +
							thumbBounds.width -
							thumbWrapperBounds.width +
							35;
					} else if (
						this.selectedThumb.offsetLeft < this.thumbScroller.scrollLeft
					) {
						this.thumbScroller.scrollLeft = this.selectedThumb.offsetLeft - 35;
					}
				}
			}

			_handleScrollButtonVisibility() {
				if (Layout.isLessThanBreakpoint("S")) {
					// We use 4px here just to ensure the user has scrolled a little bit before
					// showing the buttons.
					if (this.thumbScroller.scrollLeft > 4) {
						this.thumbScrollerButtons[0].classList.add("visible");
					} else {
						this.thumbScrollerButtons[0].classList.remove("visible");
					}

					if (
						this.thumbScroller.scrollLeft <
						this.thumbScroller.scrollWidth - this.thumbScroller.clientWidth
					) {
						this.thumbScrollerButtons[1].classList.add("visible");
					} else {
						this.thumbScrollerButtons[1].classList.remove("visible");
					}
				} else {
					this.thumbScrollerButtons[0].classList.remove("visible");
					this.thumbScrollerButtons[1].classList.remove("visible");
				}
			}

			_onScrollButtonClick(scrollRight) {
				if (scrollRight) {
					this.thumbScroller.scrollLeft = this.thumbScroller.scrollLeft - 100;
				} else {
					this.thumbScroller.scrollLeft = this.thumbScroller.scrollLeft + 100;
				}
			}

			unload() {
				if (this.photoswipe) {
					this.photoswipe.destroy();
					this.photoswipe = null;
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/components/ProductGallery.js
		let loadPlyrStyles = null;
		class ProductGallery {
			constructor(_ref) {
				let { el, settings, isQuickshop, sectionContext } = _ref;
				this.el = el;
				this.settings = settings;
				this.isQuickshop = isQuickshop || false;
				this.sectionContext = sectionContext || "default";
				this.events = new EventHandler /* default */.Z();
				this.viewer = this.el.querySelector("[data-gallery-viewer]");
				this.navigation = this.el.querySelector("[data-gallery-navigation]");
				this.navScroller = this.el.querySelector("[data-gallery-scroller]");
				this.navScrollerButtons = this.el.querySelectorAll(
					"[data-gallery-scroll-button]"
				);
				this.figures = this.viewer.querySelectorAll("[data-gallery-figure]");
				this.thumbnails = this.navigation.querySelectorAll(
					"[data-gallery-thumbnail]"
				);
				this.zoomButton = this.viewer.querySelector("[data-gallery-expand]");
				this.selected = {
					figure: this.viewer.querySelector('[data-gallery-selected="true"]'),
					thumbnail: this.navigation.querySelector(
						'[data-gallery-selected="true"]'
					),
				};
				this.models = {};
				this.videos = {};
				this.selectedVideo = null;
				this.selectedModel = null;
				this.showingInitialSlide = true;
				this._setupSelectedVideo = this._setupSelectedVideo.bind(this);
				const features = [];

				if (this.el.querySelector('[data-media-type="video"]')) {
					if (!(loadPlyrStyles instanceof Promise)) {
						loadPlyrStyles = new Promise((resolve) => {
							const stylesheet = document.createElement("link");
							stylesheet.setAttribute("rel", "stylesheet");
							stylesheet.href =
								"https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css";
							stylesheet.onload = resolve;
							document.body.appendChild(stylesheet);
						});
					}

					features.push({
						name: "video-ui",
						version: "1.0",
						onLoad: () => loadPlyrStyles.then(() => this._setupSelectedVideo()),
					});
				}

				if (this.el.querySelector('[data-media-type="model"]')) {
					this.viewInYourSpaceEl = this.el.querySelector("[data-shopify-xr]");
					this.events.register(this.viewInYourSpaceEl, "click", () =>
						this._onViewInYourSpaceClick()
					);
					features.push({
						name: "model-viewer-ui",
						version: "1.0",
						onLoad: this._onModelLibraryLoad.bind(this),
					});
					features.push({
						name: "shopify-xr",
						version: "1.0",
					});
				}

				if (features.length) {
					window.Shopify.loadFeatures(features);
				}

				if (this.isQuickshop) {
					dist_index_es.watch(this.el); // Because of the way the quickshop is animated to open, if a video is first in the
					// gallery the height of the slide will not be correct, so we need to wait until all the
					// transitions end. This will only fire once, as opposed to listening to transitionend.

					if (this.figures[0].dataset.mediaType === "video") {
						setTimeout(() => this._setSlideHeight(), 800);
					}
				}

				this.events.register(this.navScroller, "click", (e) =>
					this._onThumbnailClick(e)
				);
				this.events.register(this.navScroller, "scroll", () =>
					this._handleScrollButtonVisibility()
				);
				this.events.register(this.navScrollerButtons[0], "click", () =>
					this._onScrollButtonClick(true)
				);
				this.events.register(this.navScrollerButtons[1], "click", () =>
					this._onScrollButtonClick(false)
				);

				if (this.settings.gallery_click_to_zoom !== "disabled") {
					const onZoomButtonClick = (e) => {
						e.stopPropagation();

						this._openImageZoom();
					};

					this.events.register(this.zoomButton, "click", (e) =>
						onZoomButtonClick(e)
					);
					this.events.register(this.viewer, "click", (e) =>
						onZoomButtonClick(e)
					);
				}

				this._onResize = this._onResize.bind(this);
				this.events.register(window, "resize", () => this._onResize());

				if (Layout.isLessThanBreakpoint("S")) {
					this._setupFlickity();

					this._handleScrollButtonVisibility();
				}

				this._selectMediaByEl(this.selected.figure);
			}

			selectMediaByVariant(variant) {
				if (!variant.featured_media) return;
				const slide = this.viewer.querySelector(
					`[data-media="${variant.featured_media.id}"]`
				);

				this._selectMediaByEl(slide);
			}

			unload() {
				this.events.unregisterAll();

				for (let i; i < this.figures.length; i++) {
					if (this.models[i]) {
						this.models[i].destroy();
					}

					if (this.videos[i]) {
						this.videos[i].destroy();
					}
				}

				if (this.isQuickshop) {
					dist_index_es.unwatch(this.el);
				}

				this._closeImageZoom();

				this._disableHoverZoom();

				this._disableFlickity();
			}

			_onModelLibraryLoad() {
				const onPlayListener = () => {
					if (this.flickity) {
						this.flickity.unbindDrag();
					}
				};

				const onPauseListener = () => {
					if (this.flickity) {
						this.flickity.bindDrag();
					}
				};

				this.el
					.querySelectorAll(".product-gallery--model")
					.forEach((figureEl) => {
						const modelEl = figureEl.querySelector("model-viewer");
						const { galleryIndex } = figureEl.dataset;
						const controls = ["zoom-in", "zoom-out"];
						if (document.fullscreenEnabled) controls.push("fullscreen");
						this.models[galleryIndex] = new Shopify.ModelViewerUI(modelEl, {
							controls,
						});
						this.events.register(
							modelEl,
							"shopify_model_viewer_ui_toggle_play",
							onPlayListener
						);
						this.events.register(
							modelEl,
							"shopify_model_viewer_ui_toggle_pause",
							onPauseListener
						);
					});
			}

			_onResize() {
				// If the resize was trigger by a fullscreen, do not do anything
				if (document.fullscreenElement) {
					return;
				}

				if (Layout.isGreaterThanBreakpoint("S", true)) {
					this._disableFlickity();
				} else {
					this._setupFlickity();
				}

				if (Layout.isGreaterThanBreakpoint("L", true) && !this.drift) {
					this._setupHoverZoom();
				} else if (Layout.isLessThanBreakpoint("L")) {
					this._disableHoverZoom();
				}

				this._adjustGalleryPositioning();

				this._handleScrollButtonVisibility();
			}

			_onThumbnailClick(e) {
				let button;
				this.showingInitialSlide = false; // The target will be the button itself if the user is using a keyboard to navigate, but
				// otherwise it will be the image that is clicked on.

				if (e.target.classList.contains("product-gallery--media-thumbnail")) {
					button = e.target;
				} else if (
					e.target.parentNode.parentNode.classList.contains(
						"product-gallery--media-thumbnail"
					)
				) {
					button = e.target.parentNode.parentNode;
				} else {
					return;
				}

				const selectedIndex = parseInt(button.dataset.galleryIndex, 10);

				if (this.flickity) {
					this.flickity.select(selectedIndex);
				} else {
					this._selectMediaByIndex(selectedIndex);
				}
			}

			_onViewInYourSpaceClick(e) {
				const { currentTarget } = e;
				const figure = this.viewer.querySelector(
					`[data-media="${currentTarget.dataset.shopifyModel3dId}"]`
				);

				this._selectMediaByEl(figure);
			}

			_selectMediaByEl(el) {
				this._selectMediaByIndex(parseInt(el.dataset.galleryIndex, 10));
			}

			_selectMediaByIndex(index) {
				const figure = this.figures[index];
				this.selected.figure.dataset.gallerySelected = false;
				this.selected.figure.setAttribute("aria-hidden", true);
				this.selected.figure = figure;
				this.selected.figure.dataset.gallerySelected = true;
				this.selected.figure.setAttribute("aria-hidden", false);
				const figureIndex = parseInt(
					this.selected.figure.dataset.galleryIndex,
					10
				);
				this.selected.thumbnail.dataset.gallerySelected = false;
				this.selected.thumbnail = this.thumbnails[figureIndex];
				this.selected.thumbnail.dataset.gallerySelected = true;
				const { media, mediaType } = this.selected.figure.dataset;
				this.viewer.dataset.selectedMediaType = mediaType;

				this._disableHoverZoom();

				if (this.selectedModel) {
					this.selectedModel.pause();
				}

				if (this.models[figure.dataset.galleryIndex]) {
					this.selectedModel = this.models[figure.dataset.galleryIndex];

					if (
						!document.documentElement.classList.contains("has-touch") &&
						!this.showingInitialSlide
					) {
						this.selectedModel.play();
					}
				}

				if (this.selectedVideo) {
					this.selectedVideo.pause();
				}

				if (this.viewInYourSpaceEl) {
					this.viewInYourSpaceEl.dataset.shopifyModel3dId =
						this.viewInYourSpaceEl.dataset.defaultModelId;
				}

				switch (mediaType) {
					case "model":
						this.viewInYourSpaceEl.dataset.shopifyModel3dId = media;
						break;

					case "video":
					case "external_video":
						this._setupSelectedVideo();

						break;

					case "image":
						this._setupHoverZoom();

						break;

					default:
						break;
				}

				if (this.flickity) {
					this.flickity.bindDrag();
					this.flickity.select(index);
				}

				this._adjustGalleryPositioning();
			}

			_setupSelectedVideo() {
				if (this.selectedVideo) {
					this.selectedVideo.pause();
				}

				const { mediaType, galleryIndex } = this.selected.figure.dataset;
				const shouldAutoplay =
					Layout.isGreaterThanBreakpoint("L", true) &&
					this.settings.gallery_video_autoplay &&
					!this.showingInitialSlide;

				if (mediaType === "video" || mediaType === "external_video") {
					let videoElement;

					if (this.videos[galleryIndex]) {
						this.selectedVideo = this.videos[galleryIndex];
						if (shouldAutoplay) this.selectedVideo.play();
					} else {
						if (mediaType === "video") {
							// Plyr hasn't loaded yet, will be called again after loadFeatures
							if (!Shopify.Plyr) return;
							videoElement = this.selected.figure.querySelector("video");
							this.selectedVideo = new Shopify.Plyr(videoElement, {
								loop: {
									active: this.settings.gallery_video_looping,
								},
							});
							if (shouldAutoplay) this.selectedVideo.play();
						} else {
							videoElement = this.selected.figure.querySelector("[data-video]");
							this.selectedVideo = new Video(videoElement, {
								loop: this.settings.gallery_video_looping,
							});
							if (shouldAutoplay) this.selectedVideo.play();
						}

						this.videos[galleryIndex] = this.selectedVideo;
					}

					this.selected.figure.focus();
				}
			}

			_setupHoverZoom() {
				if (
					this.settings.gallery_hover_zoom === "disabled" ||
					!Layout.isGreaterThanBreakpoint("L", true) ||
					this.selected.figure.dataset.mediaType !== "image" ||
					document.documentElement.classList.contains("has-touch")
				)
					return; // Only select the image loaded with JS

				const selectedImage = this.selected.figure.querySelector(
					'[data-rimg]:not([data-rimg="noscript"])'
				);
				selectedImage.setAttribute(
					"data-zoom",
					this.selected.figure.getAttribute("data-zoom")
				);
				this.drift = new Drift(selectedImage, {
					paneContainer:
						this.settings.gallery_hover_zoom === "separate"
							? this.el.querySelector("[data-zoomed-image]")
							: this.selected.figure,
					inlinePane: false,
					hoverBoundingBox: this.settings.gallery_hover_zoom === "separate",
					handleTouch: false,
					onShow: () => {
						if (this.settings.gallery_hover_zoom === "separate") {
							const productMain = document.querySelector(".product-main");
							const productAlt = document.querySelector(".product-form--alt");
							productMain.classList.add("product-gallery--fade");
							if (productAlt) productAlt.classList.add("product-gallery--fade");
						}
					},
					onHide: () => {
						if (this.settings.gallery_hover_zoom === "separate") {
							const productMain = document.querySelector(".product-main");
							const productAlt = document.querySelector(".product-form--alt");
							productMain.classList.remove("product-gallery--fade");
							if (productAlt)
								productAlt.classList.remove("product-gallery--fade");
						}
					},
				});
			}

			_disableHoverZoom() {
				if (this.drift) {
					this.drift.disable();
					this.drift = null;
				}
			}

			_setupFlickity() {
				if (this.flickity || !Layout.isLessThanBreakpoint("S")) return;
				this.flickity = new (js_default())(this.viewer, {
					accessibility: false,
					adaptiveHeight: true,
					cellSelector: ".product-gallery--media",
					contain: true,
					friction: 0.5,
					freeScroll: false,
					initialIndex: parseInt(this.selected.figure.dataset.galleryIndex, 10),
					lazyLoad: false,
					percentPosition: false,
					prevNextButtons: false,
					pageDots: false,
					selectedAttraction: 0.1,
					setGallerySize: false,
					wrapAround: true,
				});
				this.flickityEvent = this.events.register(
					this.viewer,
					"rimg:load",
					() => {
						this._setSlideHeight();
					}
				);
				this.flickity.on("change", (index) => {
					this.showingInitialSlide = false;

					this._selectMediaByEl(this.figures[index]);
				}); // Flickity controls the pointerdown event which prevents model-viewer-ui from
				// triggering .play() on mouseup. This returns this functionality.

				this.flickity.on("staticClick", (event, pointer, cellElement) => {
					const figure = cellElement.querySelector(".product-gallery--model");

					if (figure && this.models[figure.dataset.galleryIndex]) {
						const model = this.models[figure.dataset.galleryIndex];
						model.play();
					}
				});
				this.flickity.on("pointerDown", () => {
					// Removes the focus ring when swiping with touch device
					this.viewer.blur();
				}); // We need to disable the product zoom open if a user is swiping
				// This was an issue on mouse gestures, not on touch

				if (
					this.settings.gallery_click_to_zoom !== "disabled" &&
					document.documentElement.classList.contains("no-touch")
				) {
					this.flickity.on("dragEnd", () => {
						this.swiped = true;
					});
				}

				this._setSlideHeight();
			}

			_disableFlickity() {
				if (this.flickity) {
					this.flickity.destroy();
					this.flickity = null;
					this.events.unregister(this.flickityEvent);
				}
			}

			_setSlideHeight() {
				// this.navigation.classList.remove('loading'); // Use the stored image height for situations where the DOM is in a midway state.

				const containerHeight =
					this.storedImageHeight ||
					this.selected.figure.getBoundingClientRect().height;
				this.storedImageHeight = null;
				if (containerHeight === 0) return;
				this.viewer.style.height = `${containerHeight}px`;
			}

			_adjustGalleryPositioning() {
				if (this.settings.gallery_thumbnail_position === "left") {
					if (this.isQuickshop) {
						if (
							Layout.isGreaterThanBreakpoint("L", true) &&
							this.sectionContext === "default"
						) {
							this.el.dataset.productGalleryThumbnails = "left";
						} else {
							this.storedImageHeight =
								this.selected.figure.getBoundingClientRect().height;
							this.el.dataset.productGalleryThumbnails = "center";
						}
					} // We need to adjust the width of the thumbnails if they are positioned left
					// and they wrap into 2 columns. CSS flexbox does not cause the width of the
					// element to stretch. Looks like it's a problem with flexbox when wrapping columns:
					// https://stackoverflow.com/questions/33891709/when-flexbox-items-wrap-in-column-mode-container-does-not-grow-its-width
					// We want the thumbnails to always be placed 'below' for the shoppable image, ie: 'default'

					if (
						this.sectionContext === "default" &&
						(Layout.isGreaterThanBreakpoint("L", true) ||
							(Layout.isGreaterThanBreakpoint("S", true) && !this.isQuickshop))
					) {
						if (this.el.firstChild !== this.navigation) {
							const activeButton = document.activeElement;
							this.el.insertBefore(this.navigation, this.viewer);
							activeButton.focus(); // This prevents loss of focus if one of the thumbnails are selected
						} // When switching layouts in the editor sometimes we need to wait for a few milliseconds
						// before positioning the thumbs. The Quickshop is even a bit slower.

						setTimeout(
							() => {
								const leftmostBounds =
									this.thumbnails[0].getBoundingClientRect();
								const thumbStyle =
									this.thumbnails[0].currentStyle ||
									window.getComputedStyle(this.thumbnails[0]);
								const thumbMargin = parseInt(thumbStyle.marginLeft, 10) * 2;
								const wrapped = Array.prototype.some.call(
									this.thumbnails,
									(thumb) =>
										thumb.getBoundingClientRect().left > leftmostBounds.left
								);

								if (wrapped) {
									this.navigation.style.width = `${
										(leftmostBounds.width + thumbMargin) * 2
									}px`;
									this.navigation.style.maxWidth = `${
										(leftmostBounds.width + thumbMargin) * 2
									}px`;
								}

								this._setSlideHeight();
							},
							this.isQuickshop ? 500 : 100
						);
					} else {
						if (this.el.firstElementChild === this.navigation) {
							this.el.appendChild(this.navigation);
						}

						this.navigation.style.width = "";
						this.navigation.style.maxWidth = "";

						this._setSlideHeight();
					}

					if (Layout.isLessThanBreakpoint("S")) {
						this._adjustMobileThumbnailPosition();
					}
				} else {
					this._setSlideHeight();

					this._adjustMobileThumbnailPosition();
				}
			}

			_adjustMobileThumbnailPosition() {
				// This brings the thumbnail into view if it is not visible on the screen after
				// a user swipes to a slide that it is tied to. Only important on mobile.
				if (Layout.isLessThanBreakpoint("S")) {
					const thumbBounds = this.selected.thumbnail.getBoundingClientRect();
					const thumbWrapperBounds = this.navScroller.getBoundingClientRect();

					if (
						this.selected.thumbnail.offsetLeft +
							thumbBounds.width +
							30 -
							this.navScroller.scrollLeft >
						thumbWrapperBounds.width
					) {
						this.navScroller.scrollLeft =
							this.selected.thumbnail.offsetLeft +
							thumbBounds.width -
							thumbWrapperBounds.width +
							35;
					} else if (
						this.selected.thumbnail.offsetLeft < this.navScroller.scrollLeft
					) {
						this.navScroller.scrollLeft =
							this.selected.thumbnail.offsetLeft - 35;
					}
				}
			}

			_handleScrollButtonVisibility() {
				if (Layout.isLessThanBreakpoint("S")) {
					// We use 4px here just to ensure the user has scrolled a little bit before
					// showing the buttons.
					if (this.navScroller.scrollLeft > 4) {
						this.navScrollerButtons[0].classList.add("visible");
					} else {
						this.navScrollerButtons[0].classList.remove("visible");
					}

					if (
						this.navScroller.scrollLeft <
						this.navScroller.scrollWidth - this.navScroller.clientWidth
					) {
						this.navScrollerButtons[1].classList.add("visible");
					} else {
						this.navScrollerButtons[1].classList.remove("visible");
					}
				} else {
					this.navScrollerButtons[0].classList.remove("visible");
					this.navScrollerButtons[1].classList.remove("visible");
				}
			}

			_onScrollButtonClick(scrollRight) {
				if (scrollRight) {
					this.navScroller.scrollLeft = this.navScroller.scrollLeft - 100;
				} else {
					this.navScroller.scrollLeft = this.navScroller.scrollLeft + 100;
				}
			}

			_closeImageZoom() {
				if (this.imageZoom) {
					this.imageZoom.unload();
					this.imageZoom = null;
				}
			}

			_openImageZoom() {
				if (
					this.selected.figure.dataset.mediaType !== "image" ||
					(Layout.isGreaterThanBreakpoint("L") &&
						this.settings.gallery_click_to_zoom === "mobile") ||
					(Layout.isLessThanBreakpoint("L") &&
						this.settings.gallery_click_to_zoom === "desktop")
				)
					return;

				if (this.swiped) {
					this.swiped = false;
					return;
				}

				this._closeImageZoom();

				this.imageZoom = new ProductClickToZoom({
					settings: this.settings,
					slides: this.figures,
					originalThumbnails: this.thumbnails,
					startIndex: parseInt(this.selected.figure.dataset.galleryIndex, 10),
					selectGalleryIndex: (index) => this._selectMediaByIndex(index),
				});
			}
		} // CONCATENATED MODULE: ./source/scripts/helpers/PaymentTerms.js
		class PaymentTerms {
			constructor(el) {
				this._el = el;
				this._reference = this._el.querySelector(
					"[data-payment-terms-reference] shopify-payment-terms"
				);
				this._target = this._el.querySelector("[data-payment-terms-target]");
				if (!this._reference || !this._target) return;
				this._input = document.createElement("input");
				this._input.name = "id";
				this._input.type = "hidden";

				this._target.appendChild(this._input);

				this._target.appendChild(this._reference);

				this._target.style.display = null;
			}

			update(variantId) {
				if (!this._reference || !this._target) return;
				this._input.value = variantId;

				this._input.dispatchEvent(
					new Event("change", {
						bubbles: true,
					})
				);
			}
		} // CONCATENATED MODULE: ./source/scripts/components/ProductDetails.js
		class ProductDetails {
			constructor(options) {
				this.$window = jquery_default()(window);
				this.$formArea = options.$formArea;
				this.$details = options.$details;
				this.context = options.context;
				this.settings = options.settings;
				this.product = options.product;
				this.useHistory = options.useHistory;
				this.sectionId = options.sectionId;
				this.el = options.productEl;
				this.events = new EventHandler /* default */.Z();
				this.url = window.location.search;
				this.urlParams = new URLSearchParams(this.url);
				this.paymentTerms = new PaymentTerms(this.el);
				this.variantSelection = this.el.querySelector(
					"[data-variant-selection]"
				);
				this.select_first_available_variant =
					this.settings.select_first_available_variant;
				this.recipientFormEl = this.el.querySelector("[data-recipient-form]");
				this.surfacePickUpEl = this.el.querySelector("[data-surface-pick-up]");
				this.requestFormEl = this.el.querySelector(
					"[data-product-request-form]"
				);

				if (this.recipientFormEl) {
					this.recipientForm = new pxs_gift_card_recipient_form_dist_index_es(
						this.el
					);
				}

				if (this.surfacePickUpEl) {
					this.surfacePickUp = new shopify_surface_pick_up_dist_index_es(
						this.surfacePickUpEl
					);
				}

				if (this.requestFormEl) {
					this.requestFormSKU = this.requestFormEl.querySelector(
						"[data-request-form-sku]"
					);
					this.requestFormVariant = this.requestFormEl.querySelector(
						"[data-request-form-variant]"
					);
					this.requestFormVariantID = this.requestFormEl.querySelector(
						"[data-request-form-variant-id]"
					);
					new Forms(this.requestFormEl); // eslint-disable-next-line max-len

					if (
						!this.select_first_available_variant &&
						this.requestFormVariant &&
						this.requestFormVariantID
					) {
						this.requestFormVariant.removeAttribute("name");
						this.requestFormVariantID.removeAttribute("name");
					}

					this.events.register(this.requestFormEl, "submit", () => {
						const message = this.requestFormEl.querySelector(
							"[data-product-request-form-message]"
						);

						if (message.value === "") {
							message.classList.add("form-field-filled");
							message.innerHTML = this.context.request_message_empty;
						}
					});
					this.events.register(window, "load", () => {
						if (this.urlParams.get("contact_posted")) {
							this.requestFormEl.scrollIntoView({
								behavior: "smooth",
								block: "start",
							});
						}
					});
				}

				if (this.product) {
					// if ('media' in this.product) {
					this.gallery = new ProductGallery({
						el: options.gallery,
						sectionContext: options.sectionContext,
						settings: this.settings,
						isQuickshop: options.isQuickshop,
					});
					// }
				}

				if (!jquery_default()(this.$formArea).length) return;

				if (this.variantSelection) {
					this.isDefaultVariant = !!this.variantSelection.querySelector(
						"[data-variants].variant-selection__variants--default"
					);
					this.variantSelection.getVariant().then((variant) => {
						if (this.surfacePickUp) {
							this.surfacePickUp.load(variant ? variant.id : null);
						}

						this._updateBadge(variant);

						this._updatePrice(variant);

						if (!variant) {
							this._showPriceRange();

							this._updateSKU();
						}

						this.events.register(
							this.variantSelection,
							"variant-change",
							(event) => this._switchVariant(event.detail)
						);
					});
				}

				this.modal = new Modal({
					onClose: () => this.modal.unload(),
					modalId: 1,
				});

				if (this.surfacePickUp) {
					this.surfacePickUp.onModalRequest((contents) => {
						let container = this.$formArea[0].querySelector(
							"[data-surface-pick-up-modal-contents]"
						);
						this.variantSelection.getVariant().then((variant) => {
							const variantTitle = !this.isDefaultVariant
								? `<div class="surface-pick-up-modal__variant">${variant.title}</div>`
								: "";
							const modalContents = `
            <div class="surface-pick-up-modal__header">
              <h2 class="surface-pick-up-modal__title">${this.product.title}</h2>
              ${variantTitle}
            </div>
            ${contents}
            `;

							if (!container) {
								container = document.createElement("div");
								container.setAttribute(
									"data-surface-pick-up-modal-contents",
									""
								);
								container.style.display = "none";
								container.innerHTML = modalContents;
								this.$formArea[0].appendChild(container);
							} else {
								container.innerHTML = modalContents;
							}

							this.modal.open(
								"[data-surface-pick-up-modal-contents]",
								"surface-pick-up"
							);
						});
					});
				}

				this.addToCartFlyout = null;
				this.atcCallbacks = options.atcCallbacks; // Form

				this.$form = this.$formArea.find("[data-product-form]");
				this.$productAtcButton = this.$formArea.find("[data-product-atc]");
				this.$productVariants = this.$form.find("[data-variants]");
				this.$productOptions = this.$form.find("[data-product-option]");
				this.productPricing = this.$details[0].querySelector(
					"[data-product-pricing]"
				);
				this.detailsLink = this.$formArea[0].querySelector(
					"[data-product-details-link]"
				);
				this.quantitySelector = this.el.querySelector(
					"[data-quantity-selector]"
				);

				if (this.detailsLink) {
					this.detailsBaseHref = this.detailsLink.getAttribute("href");
				}

				this.variantFields = {
					$priceContainer: this.$details.find("[data-price-container]"),
					$priceMoney: this.$details.find(
						"[data-price-container] [data-price]"
					),
					$compareAtPrice: this.$details.find("[data-price-compare-container]"),
					$compareAtPriceMoney: this.$details.find(
						"[data-price-compare-container] [data-price-compare]"
					),
					$badge: this.$details.find("[data-badge-sales]"),
					$badgeRange: this.$details.find("[data-badge-sales-range]"),
					$badgeSingle: this.$details.find("[data-badge-sales-single]"),
					$sku: this.$details.find("[data-product-sku]"),
					stockLevels: this.$details[0].querySelectorAll("[data-stock-level]"),
					unitPrice: this.$details[0].querySelector("[data-unit-price]"),
					totalQuantity: this.$details[0].querySelector(
						"[data-total-quantity]"
					),
					unitPriceAmount: this.$details[0].querySelector(
						"[data-unit-price-amount]"
					),
					unitPriceMeasure: this.$details[0].querySelector(
						"[data-unit-price-measure]"
					),
					taxLine: this.$details[0].querySelector("[data-tax-line]"),
					hiddenComparePrice: this.$details[0].querySelector(
						"[data-compare-price-hidden]"
					),
					hiddenCurrentPrice: this.$details[0].querySelector(
						"[data-current-price-hidden]"
					),
					hiddenComparePriceRange: this.$details[0].querySelector(
						"[data-compare-price-range-hidden]"
					),
					hiddenCurrentPriceRange: this.$details[0].querySelector(
						"[data-current-price-range-hidden]"
					),
				};

				if (this.quantitySelector) {
					this.productQuantityBox = new QuantitySelector({
						quantityField: this.quantitySelector,
					});
				}

				this.forms = new Forms(this.$form);

				if (this.product) {
					this._bindEvents();
				}
			}

			unload() {
				if (this.$form) {
					this.$form.off(`.product-details-${this.sectionId}`);
				}

				if (this.forms) {
					this.forms.unload();
				}

				if (this.gallery) {
					this.gallery.unload();
				}

				if (this.messageBanner) {
					this.messageBanner.unload();
				}

				this.events.unregisterAll();
			}

			_bindEvents() {
				this.$form.on(`submit.product-details-${this.sectionId}`, (event) =>
					this._addToCartFlyout(event)
				);
			}

			_switchVariant(data) {
				const { variant } = data;

				if (this.productPricing) {
					if (!variant) {
						this.productPricing.style.visibility = "hidden";
					} else {
						this.productPricing.style.visibility = "visible";
					}
				} // Update main select

				this.$productVariants.val(variant.id);

				if (this.gallery) {
					this.gallery.selectMediaByVariant(variant);
				}

				if (this.surfacePickUp) {
					this.surfacePickUp.load(variant.id);
				} // Update Variant information

				this._updatePrice(variant);

				this._updateSKU(variant);

				this._updateBadge(variant);

				this._updateButton(variant);

				this._updateSwatchLabel(variant);

				this._updateFullDetailsLink(variant);

				this._updateUnitPrice(variant);

				this._updateStockLevels(variant);

				this.paymentTerms.update(variant.id);

				if (Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (this.useHistory) {
					const url = `${this.product.handle}?${jquery_default().param({
						variant: variant.id,
					})}`;
					history.replaceState({}, "variant", url);
				}

				if (this.requestFormEl && !this.urlParams.get("contact_posted")) {
					this.requestFormVariant.value = variant.title;
					this.requestFormVariantID.value = variant.id;

					if (this.requestFormSKU.value === "") {
						this.requestFormSKU.removeAttribute("name");
					} else {
						this.requestFormSKU.setAttribute("name", "contact[sku]");
					}

					if (!this.select_first_available_variant) {
						this.requestFormVariant.setAttribute("name", "contact[variant]");
						this.requestFormVariantID.setAttribute("name", "contact[id]");
					}
				}
			}

			_updateStockLevels(variant) {
				this.variantFields.stockLevels.forEach((el) => {
					const stockLevelVariantId = Number(el.dataset.stockVariantId);

					if (variant.id === stockLevelVariantId) {
						el.setAttribute("data-stock-variant-selected", "true");
					} else {
						el.setAttribute("data-stock-variant-selected", "false");
					}
				});
			}

			_updatePrice(variant) {
				if (!this.productPricing) {
					return;
				}

				const compareAtPrice = this.variantFields.hiddenComparePrice.innerHTML;
				const currentPrice = this.variantFields.hiddenCurrentPrice.innerHTML;
				this.variantFields.$compareAtPrice[0].innerHTML = compareAtPrice;
				this.variantFields.$priceContainer[0].innerHTML = currentPrice;
				this.variantFields.$priceMoney = this.$details.find(
					"[data-price-container] [data-price]"
				);
				this.variantFields.$compareAtPriceMoney = this.$details.find(
					"[data-price-compare-container] [data-price-compare]"
				); // Update compare at price

				const hasComparePrice =
					!!variant.compare_at_price &&
					variant.compare_at_price > variant.price;
				this.variantFields.$compareAtPrice.toggleClass(
					"visible",
					hasComparePrice
				);
				this.variantFields.$compareAtPriceMoney.text(
					Shopify.formatMoney(
						variant.compare_at_price,
						this.settings.money_format
					)
				); // Update price

				this.variantFields.$priceMoney.text(
					Shopify.formatMoney(variant.price, this.settings.money_format)
				);
			}

			_showPriceRange() {
				this._updateBadge(false);

				const currentPriceIsRange = this.product.price_varies;
				const currentCompareAtPriceIsRange = this.product.variants.some(
					(variant) =>
						(variant.compare_at_price || variant.price) !==
						this.product.compare_at_price
				);
				const currentPrice = currentPriceIsRange
					? this.variantFields.hiddenCurrentPriceRange.innerHTML
					: this.variantFields.hiddenCurrentPrice.innerHTML;
				const compareAtPrice = currentCompareAtPriceIsRange
					? this.variantFields.hiddenComparePriceRange.innerHTML
					: this.variantFields.hiddenComparePrice.innerHTML;
				const shouldDisplayCompareAtPrice =
					this.product.compare_at_price_max > this.product.price_min;
				this.variantFields.$compareAtPrice.toggleClass(
					"visible",
					shouldDisplayCompareAtPrice
				);
				this.variantFields.$compareAtPrice[0].innerHTML = compareAtPrice;
				this.variantFields.$priceContainer[0].innerHTML = currentPrice;
			}

			_updateSKU() {
				let variant =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: false;

				if (variant) {
					if (variant.sku === "") {
						this.variantFields.$sku.parent().addClass("product-sku--empty");
					} else {
						this.variantFields.$sku.parent().removeClass("product-sku--empty");
						this.variantFields.$sku.parent().show();
					}

					this.variantFields.$sku.text(variant.sku);

					if (this.requestFormEl && !this.urlParams.get("contact_posted")) {
						this.requestFormSKU.value = variant.sku;
					}
				} else {
					this.variantFields.$sku.parent().hide();
				}
			}

			_updateBadge() {
				let variant =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: false;

				if (!variant) {
					const priceSaved = this.product.compare_at_price
						? this.product.compare_at_price_max - this.product.price_min
						: 0;

					if (priceSaved <= 0) {
						this.variantFields.$badge.toggle(false);
					} else {
						this.variantFields.$badgeSingle.toggle(false);
						this.variantFields.$badgeRange.toggle(!!priceSaved);
						this.variantFields.$badge.toggle(!!priceSaved);
					}
				} else {
					const priceSaved = variant.compare_at_price
						? variant.compare_at_price - variant.price
						: 0;

					if (priceSaved <= 0) {
						this.variantFields.$badge.toggle(false);
					} else {
						this.variantFields.$badgeRange.toggle(false);
						this.variantFields.$badgeSingle.toggle(!!priceSaved);
						this.variantFields.$badge.toggle(!!priceSaved);
						const $badgeMoneySaved = this.variantFields.$badgeSingle.find(
							"[data-price-money-saved]"
						);
						const $badgePercentSaved = this.variantFields.$badgeSingle.find(
							"[data-price-percent-saved]"
						);

						if ($badgeMoneySaved.length) {
							// Update badge if it shows money saved
							$badgeMoneySaved.text(
								Shopify.formatMoney(priceSaved, this.settings.money_format)
							);
						}

						if ($badgePercentSaved.length) {
							// Update badge if it shows percentiles
							const percentileSaved = Math.round(
								(priceSaved * 100) / variant.compare_at_price
							);
							$badgePercentSaved.text(percentileSaved);
						}
					}
				}
			}

			_updateButton(variant) {
				if (!variant) {
					this.$productAtcButton.text(this.context.product_unavailable);
					this.$productAtcButton.addClass("disabled").prop("disabled", true);
				} else if (variant.available) {
					if (
						this.$productAtcButton[0].hasAttribute("data-product-atc-preorder")
					) {
						this.$productAtcButton.text(this.context.product_preorder);
					} else {
						this.$productAtcButton.text(this.context.product_available);
					}

					this.$productAtcButton
						.removeClass("disabled")
						.prop("disabled", false);
				} else {
					this.$productAtcButton.text(this.context.product_sold_out);
					this.$productAtcButton.addClass("disabled").prop("disabled", true);
				}
			}

			_updateSwatchLabel(variant) {
				if (this.settings.swatches_enable) {
					const swatchLabel = this.$form[0].querySelector(
						"[data-option-swatch-value]"
					);

					if (swatchLabel) {
						swatchLabel.innerText =
							variant.options[
								parseInt(swatchLabel.dataset.optionSwatchValue, 10)
							];
					}
				}
			}

			_updateFullDetailsLink(variant) {
				if (this.detailsLink) {
					this.detailsLink.setAttribute(
						"href",
						`${this.detailsBaseHref}?variant=${variant.id}`
					);
				}
			}

			_updateUnitPrice(variant) {
				if (this.variantFields.unitPrice && variant.unit_price_measurement) {
					this.variantFields.totalQuantity.innerHTML = `${variant.unit_price_measurement.quantity_value}${variant.unit_price_measurement.quantity_unit}`;
					this.variantFields.unitPriceAmount.innerHTML = Shopify.formatMoney(
						variant.unit_price,
						this.settings.money_format
					);

					if (variant.unit_price_measurement.reference_value === 1) {
						this.variantFields.unitPriceMeasure.innerHTML =
							variant.unit_price_measurement.reference_unit;
					} else {
						this.variantFields.unitPriceMeasure.innerHTML = `${variant.unit_price_measurement.reference_value}${variant.unit_price_measurement.reference_unit}`;
					}

					this.variantFields.unitPrice.classList.remove("hidden");
				} else if (this.variantFields.unitPrice) {
					this.variantFields.unitPrice.classList.add("hidden");
				}

				if (this.variantFields.taxLine) {
					if (variant.taxable) {
						this.variantFields.taxLine.classList.remove("hidden");
					} else {
						this.variantFields.taxLine.classList.add("hidden");
					}
				}
			}

			_addToCartFlyout(event) {
				event.preventDefault();

				if (this.recipientFormEl) {
					this.recipientFormEl.classList.remove("recipient-form--has-errors");
				}

				this.variantSelection.getVariant().then((variant) => {
					if (!variant) {
						this.messageBanner = new MessageBanner(
							this.context.select_variant,
							"error"
						);
						this.$form
							.get(0)
							.classList.add("product-form--error-option-unselected");
						return;
					}

					if (this.addToCartFlyout) {
						this.addToCartFlyout.unload();
					}

					const formData = this.$form.serializeArray();
					const options = {
						atcButton: this.$productAtcButton[0],
						settings: {
							moneyFormat: this.settings.money_format,
							cartRedirection: this.settings.cart_redirection,
						},
					};
					this.addToCartFlyout = new AddToCartFlyout(
						formData,
						options,
						this.atcCallbacks
					);
				});
			}
		} // CONCATENATED MODULE: ./source/scripts/helpers/ProductReviews.js
		const initShopifyProductReviews = () => {
			if (!window.SPR) {
				return;
			}

			window.SPR.registerCallbacks();
			window.SPR.initRatingHandler();
			window.SPR.initDomEls();
			window.SPR.loadProducts();
			window.SPR.loadBadges();
		};
		/* harmony default export */ const ProductReviews = {
			initShopifyProductReviews,
		}; // CONCATENATED MODULE: ./source/scripts/components/ProductQuickshop.js
		class ProductQuickshop {
			constructor(options) {
				this.$el = options.$el;
				this.id = options.id;
				this.sectionContext = options.sectionContext;
				this.initialVariant = options.initialVariant || null;
				this.quickShopSelector = options.quickShopSelector
					? options.quickShopSelector
					: `#shopify-section-${this.id} [data-product-quickshop]`;
				this.$quickShop = jquery_default()(this.quickShopSelector);
				this.quickshopSpinner =
					this.$quickShop[0].querySelector(".quickshop-spinner");
				this.modalClass = options.modalClass;
				this.loaded = false;
				this.richText = null;
				this.productDetails = null;
				this.trigger = options.trigger;
				this.isOpen = false;
				this.openingAddToCart = false;
				this.modal = options.modal ? options.modal : null;
				this.quickshopContainer = options.quickshopContainer
					? options.quickshopContainer
					: null;
				this.view = options.view ? options.view : "product-quickshop";
				this.url = options.productUrl
					? options.productUrl
					: this.$el.data("product-quickshop-url");
				this.modalCallbacks = {
					onOpen: this._open.bind(this),
					onClose: this._close.bind(this),
				};
				this.atcCallbacks = {
					onInit: this._onATCInit.bind(this),
					onError: this._onATCError.bind(this),
					onSuccess: this._onATCSuccess.bind(this),
					onClose: this._onATCClose.bind(this),
				};

				this._initialize();
			}

			_initialize() {
				if (this.modal == null) {
					this.modal = new Modal(this.modalCallbacks);
					this.modal.open(this.quickShopSelector, this.modalClass);
				}

				this.isOpen = true;
				let $quickShopModalContent = this.modal.$modalInner.find(
					"[data-modal-content]"
				);

				if (this.quickshopContainer) {
					$quickShopModalContent = jquery_default()(this.quickshopContainer);
				}

				fetch(
					this.url.indexOf("?") >= 0
						? `${this.url}&view=quickshop`
						: `${this.url}?view=quickshop`
				)
					.then((response) => response.text()) // Return text string of the HTML
					.then((data) => {
						// Convert the HTML string into a document object
						const parser = new DOMParser();
						const doc = parser.parseFromString(data, "text/html"); // Locate the product wrapper

						const productSection = doc.querySelector("[data-product-wrapper]"); // Locate the product settings

						const staticProduct = doc.querySelector(
							'[data-section-type="static-product"]'
						); // Converts JSON into object for us to grab the settings

						this.productSettings = JSON.parse(staticProduct.innerHTML); // Stop populating the modal if it was closed before the content was loaded

						if (!this.isOpen) {
							return;
						}

						$quickShopModalContent.html(productSection.innerHTML); // Inserting product wrapper into modal

						initShopifyProductReviews();
						setupRippleEffect($quickShopModalContent[0]);

						if (window.Shopify && Shopify.PaymentButton) {
							Shopify.PaymentButton.init();
						}

						this.$message = $quickShopModalContent.find(
							"[data-product-quickshop-message]"
						);
						this.$formArea = $quickShopModalContent.find(
							"[data-product-form-area]"
						);
						this.gallery = $quickShopModalContent[0].querySelector(
							"[data-product-gallery]"
						);
						this.$details = $quickShopModalContent.find(
							"[data-product-details]"
						);
						this.$description = $quickShopModalContent.find(
							"[data-product-description]"
						);
						this.productEl = $quickShopModalContent[0];
						this.context = this.productSettings.context;
						this.settings = this.productSettings.settings;
						this.product = this.productSettings.product;

						this._onQuickshopLoaded();
					})
					.catch();
			}

			_onQuickshopLoaded() {
				if (this.loaded) {
					return;
				}

				if (this.$description && this.$description.length) {
					this.richText = new RichText(this.$description);
				}

				const options = {
					$formArea: this.$formArea,
					gallery: this.gallery,
					$details: this.$details,
					atcCallbacks: this.atcCallbacks,
					context: this.productSettings.context,
					sectionContext: this.sectionContext,
					settings: this.productSettings.settings,
					product: this.productSettings.product,
					useHistory: false,
					isQuickshop: true,
					initialVariant: this.initialVariant,
					productEl: this.productEl,
				};
				this.modal.position();
				this.modal.finishedLoading();
				this.loaded = true;
				window.requestAnimationFrame(() => {
					this.productDetails = new ProductDetails(options);
				});
			}

			_open() {
				// do nothing
			}

			_close() {
				if (!this.openingAddToCart) {
					this.trigger.focus();
				}

				this.loaded = false;
				this.isOpen = false;
				this.$quickShop.empty();
				this.$quickShop.html(this.quickshopSpinner);

				this._toggleMessage("", false);

				this.modal.unload();
			}

			_toggleMessage(message, isVisible) {
				if (this.$message) {
					this.$message.html(message).toggleClass("visible", isVisible);
				}
			}

			_onATCInit() {
				this.openingAddToCart = true;
				this.$message.removeClass("visible");
			}

			_onATCError(error) {
				const $content = jquery_default()(
					`<div class="product-message--error" tabindex="-1">${error}</div>`
				);

				this._toggleMessage($content, true);

				$content.focus();
			}

			_onATCSuccess() {
				this._close();
			}

			_onATCClose() {
				// Do nothing
			}

			unload() {
				if (this.isLoaded) {
					return this._close().then(() => {
						if (this.productDetails) {
							this.productDetails.unload();
						}

						if (this.richText) {
							this.richText.unload();
						}
					});
				}

				return Promise.resolve();
			}
		} // CONCATENATED MODULE: ./source/scripts/components/GridItemSwatches.js
		let swatchGap = null;
		class GridItemSwatches {
			constructor(options) {
				this.el = options.el;
				this.setInitialVariant = options.setInitialVariant;
				this.expanded = false;
				this.swatchImages = {};
				this.swatchVariantIds = {};
				this.selectedImage = null;
				this.state = {};
				this.events = new EventHandler /* default */.Z();
				this.data = JSON.parse(
					this.el.querySelector("[data-swatch-data]").innerHTML
				);
				this.variants = this.data.variants;
				this.swatchesContainer = this.el.querySelector(
					"[data-swatches-container]"
				);
				this.cardLinks = this.el.querySelectorAll("[data-product-page-link]");
				this.cardLinkHref = this.cardLinks[0].getAttribute("href");
				this.activeControlTime = 0;
				this.activeControl = this.swatchesContainer.querySelector("[checked]");
				this.isPreselected = !!this.activeControl;
				this.swatches =
					this.swatchesContainer.querySelectorAll("[data-swatch]");
				this.swatchCount = this.swatches.length;
				this.swatchCountWrapper = this.el.querySelector(
					"[data-swatch-count-wrapper]"
				);
				this.swatchCount = this.swatchCountWrapper.querySelector(
					"[data-swatch-count]"
				);
				this.swatchWidths = Array.prototype.map.call(
					this.swatches,
					(swatch) => swatch.getBoundingClientRect().width
				);
				this.resize();
				this.el.querySelector("[data-swatches]").classList.add("processed");
				this.originalImages = {
					primary: this.el.querySelector(".productitem--image-primary"),
					alternate: this.el.querySelector(".productitem--image-alternate"),
				};
				this.disableUnavailable(); // +/- button expansion events

				this.events.register(
					window,
					"resize",
					just_debounce_default()(() => this.resize(), 50)
				);
				this.events.register(this.swatchCountWrapper, "click", () =>
					this._toggleExpanded()
				); // Image injection events

				this.injectImagesMouseoverEvent = this.events.register(
					this.el,
					"mouseover",
					() => this._injectImages()
				);
				this.injectImagesFocusinEvent = this.events.register(
					this.el,
					"focusin",
					() => this._injectImages()
				); // Image/swatch switching events

				this.events.register(this.swatchesContainer, "mouseover", (e) =>
					this._handleMouseOver(e)
				);
				this.events.register(this.swatchesContainer, "mouseleave", (e) =>
					this._handleMouseLeave(e)
				);
				this.events.register(this.swatchesContainer, "click", (e) =>
					this._handleClick(e)
				);
				this.events.register(this.swatchesContainer, "change", (e) =>
					this._handleChange(e)
				);
				this.events.register(this.swatchesContainer, "focusin", (e) =>
					this._handleSwatchFocus(e)
				);
			}

			disableUnavailable() {
				if (!this.variants) {
					return;
				}

				const availableSwatches = {};
				this.variants.forEach((variant) => {
					if (variant.available) {
						availableSwatches[variant[this.data.swatchOptionKey]] = true;
					}
				});
				const swatchInputs = this.swatchesContainer.querySelectorAll(
					'input[name="swatch"]'
				);
				swatchInputs.forEach((swatch) => {
					if (!(swatch.value in availableSwatches)) {
						swatch.classList.add("swatch-disabled");

						if (!swatch.classList.contains("sold_out_option--selectable")) {
							swatch.disabled = true;
						}
					}
				});
			}

			resize() {
				if (this.expanded) this._toggleExpanded();
				const availableWidth =
					this.swatchesContainer.getBoundingClientRect().width -
					parseInt(
						window.getComputedStyle(this.swatchesContainer).paddingRight,
						10
					);
				let newShowSwatchCount = this.swatches.length;
				let cumulativeWidth = 0;

				for (let i = 0; i < this.swatches.length; i++) {
					if (
						cumulativeWidth + this.getSwatchGap() + this.swatchWidths[i] <
						availableWidth
					) {
						cumulativeWidth += swatchGap + this.swatchWidths[i];
					} else {
						newShowSwatchCount = i;
						break;
					}
				}

				if (newShowSwatchCount === this.showSwatchCount) return;
				this.showSwatchCount = newShowSwatchCount;
				this.swatches.forEach((swatch, index) => {
					if (index < this.showSwatchCount) {
						swatch.classList.add("productitem--swatches-swatch-visible");
						swatch.classList.remove("productitem--swatches-swatch-hidden");
					} else {
						swatch.classList.remove("productitem--swatches-swatch-visible");
						swatch.classList.add("productitem--swatches-swatch-hidden");
					}
				});
				this.swatchCountWrapper.style.left = `${cumulativeWidth}px`;

				if (this.swatches.length > this.showSwatchCount) {
					this.swatchCountWrapper.style.display = "flex";
					this.swatchCount.innerText = `+${
						this.swatches.length - this.showSwatchCount
					}`;
				} else {
					this.swatchCountWrapper.style.display = "none";
				}
			}

			_injectImages() {
				this.events.unregister(this.injectImagesFocusinEvent);
				this.events.unregister(this.injectImagesMouseoverEvent);
				shopify_asyncview_dist_index_es
					.load(this.cardLinkHref, "product-swatch-data")
					.then((_ref) => {
						let { data } = _ref;
						if (this.imagesInjected) return;
						this.imagesInjected = true;
						const tempContainer = document.createDocumentFragment();

						if (data.featuredImage) {
							const tempEl = document.createElement("div");
							tempEl.innerHTML = data.featuredImage;
							const img = tempEl.querySelector("img");
							tempContainer.appendChild(img);
							this.featuredImage = img;
						}

						data.swatches.forEach((_ref2) => {
							let { swatchValue, imageString, variantId } = _ref2;
							this.swatchVariantIds[swatchValue] = variantId;

							if (imageString) {
								const tempEl = document.createElement("div");
								tempEl.innerHTML = imageString;
								const img = tempEl.querySelector("img");
								tempContainer.appendChild(img);
								this.swatchImages[swatchValue] = img;
							}
						});
						const imagesContainer = this.el.querySelector(
							"[data-product-item-image]"
						);
						const salesBadge =
							imagesContainer.querySelector("[data-badge-sales]");
						imagesContainer.insertBefore(tempContainer, salesBadge);
						dist_index_es.watch(imagesContainer);

						this._setState({
							swatchName: this.activeControl ? this.activeControl.value : null,
							primaryImage: this.originalImages.primary,
							hideAlternateImage: !!this.activeControl,
						});
					});
			}

			_setState(_ref3) {
				let { swatchName, primaryImage, hideAlternateImage } = _ref3;
				const oldPrimaryImg = this.state.primaryImage;
				const href = swatchName
					? `${this.cardLinkHref}?variant=${this.swatchVariantIds[swatchName]}`
					: this.cardLinkHref;
				this.cardLinks.forEach((link) => link.setAttribute("href", href));
				this.setInitialVariant(
					this.swatchVariantIds[swatchName] || this.variants[0].id
				);

				if (oldPrimaryImg) {
					oldPrimaryImg.classList.remove("productitem--image-primary");
					oldPrimaryImg.style.visibility = "";
				}

				if (primaryImage) {
					primaryImage.classList.add("productitem--image-primary");
					primaryImage.style.visibility = hideAlternateImage ? "visible" : "";
				}

				if (this.originalImages.alternate) {
					this.originalImages.alternate.style.visibility = hideAlternateImage
						? "hidden"
						: "";
				}

				this.state = {
					swatchName,
					primaryImage,
					hideAlternateImage,
				};
			}

			_handleChange(_ref4) {
				let { target } = _ref4;
				this.activeControlTime = Date.now();
				this.activeControl = target;
				const swatchName = target.value;
				this.selectedImage =
					this.swatchImages[swatchName] || this.originalImages.primary;

				this._setState({
					swatchName,
					primaryImage: this.selectedImage,
					hideAlternateImage: true,
				});
			}

			_handleClick(_ref5) {
				let { target } = _ref5;

				if (
					target === this.activeControl &&
					this.activeControlTime + 150 < Date.now()
				) {
					// Allow deselection, if swatch has been active for more than the threshold
					// because we can't guarantee the order of the click and change events
					target.checked = false;
					this.activeControl = null;
					this.selectedImage = null; // Swaps in featured image if card was rendered on server with preselected swatch variant image.

					if (this.isPreselected && this.featuredImage) {
						this.originalImages.primary = this.featuredImage;
						this.isPreselected = false;
					}

					this._setState({
						swatchName: null,
						primaryImage: this.state.primaryImage,
						hideAlternateImage: true,
					});
				}
			}

			_handleMouseOver(event) {
				if (event.target.hasAttribute("data-swatch-tooltip")) {
					this._setState({
						swatchName: this.state.swatchName,
						primaryImage:
							this.swatchImages[event.target.dataset.swatchTooltip] ||
							this.originalImages.primary,
						hideAlternateImage: true,
					});
				}
			}

			_handleMouseLeave(_ref6) {
				let { target } = _ref6;

				if (target.hasAttribute("data-swatches-container")) {
					this._setState({
						swatchName: this.state.swatchName,
						primaryImage: this.selectedImage || this.originalImages.primary,
						hideAlternateImage: !!this.selectedImage,
					});
				}
			}

			_handleSwatchFocus(_ref7) {
				let { target } = _ref7;

				if (
					this.expanded === false &&
					target.nextElementSibling.classList.contains(
						"productitem--swatches-swatch-hidden"
					)
				) {
					this._toggleExpanded();
				}
			}

			_toggleExpanded() {
				const swatchesEl = this.el.querySelector("[data-swatches]");

				if (this.expanded) {
					this.expanded = false;
					swatchesEl.classList.remove("productitem--swatches-expanded");
					this.swatchCount.innerText = `+${
						this.swatches.length - this.showSwatchCount
					}`;
				} else {
					this.expanded = true;
					swatchesEl.classList.add("productitem--swatches-expanded");
				}
			} // Getters are used to avoid having to get these properties for every card on the page

			getSwatchGap() {
				if (swatchGap === null) {
					swatchGap = parseInt(
						window
							.getComputedStyle(this.swatches[0])
							.getPropertyValue("margin-right"),
						10
					);
				}

				return swatchGap;
			}

			unload() {
				this.events.unregisterAll();
			}
		} // CONCATENATED MODULE: ./source/scripts/components/ProductCompare.js
		const storageKey = "pxuProductCompareV3";
		const MAX_COMPARE_PRODUCTS = 3;

		class ProductCompare {
			constructor() {
				this._hasToggle = !!document.querySelector("[data-compare-toggle]");
				this.breadCrumb = document.querySelector(
					"[data-product-compare-breadcrumb-data]"
				);

				if (this.breadCrumb) {
					this.breadCrumbData = JSON.parse(this.breadCrumb.innerHTML);
				}

				this._state = this._getState();
				this._onUpdateCallbacks = [];
				this._onEnableChangeCallbacks = []; // update returnBreadcrumb immediately before user navigates to a new page

				document.addEventListener("visibilitychange", () => {
					if (document.visibilityState === "hidden") {
						this._state.returnBreadcrumb = this._getReturnBreadcrumb();

						this._save();
					}
				});
			}
			/**
			 *
			 * @param {String} param0.handle Handle to add
			 * @param {Object} param0.data Additional product data to add (title, image, etc).
			 * Will persist until product is removed or session ends
			 */

			add(_ref) {
				let { handle, data } = _ref;

				this._state.products.push({
					handle,
					data,
				});

				this._runUpdateCallbacks();

				this._save();
			}
			/**
			 *
			 * @param {String} handle Handle to remove from product compare
			 */

			remove(handle) {
				this._state.products = this._state.products.filter(
					(product) => product.handle !== handle
				);

				this._runUpdateCallbacks();

				if (!this._state.products.length) {
					this._onRemoveLastProduct();
				}

				this._save();
			}
			/**
			 * Removes all products from compare
			 */

			removeAll() {
				this._state.products = [];

				this._runUpdateCallbacks();

				this._onRemoveLastProduct();

				this._save();
			}
			/**
			 *
			 * @param {String} handle Handle to check
			 * @returns Boolean, true if handle is currently added to product compare
			 */

			includes(handle) {
				return this._state.products.some(
					(product) => product.handle === handle
				);
			}
			/**
			 *
			 * @param {Function} fn Add a callback function to run every time a product is added or removed
			 */

			runOnUpdate(fn) {
				this._onUpdateCallbacks.push(fn);
			}
			/**
			 *
			 * @param {Function} fn Remove a previously added callback function
			 */

			removeRunOnUpdate(fn) {
				this._onUpdateCallbacks = this._onUpdateCallbacks.filter(
					(cb) => cb !== fn
				);
			}

			get enabled() {
				return this._state.enabled;
			}

			enable() {
				if (this._state.enabled) return;
				this._state.enabled = true;

				this._runEnableChangeCallbacks();

				this._save();
			}

			disable() {
				if (!this._state.enabled) return;
				this._state.enabled = false;

				this._runEnableChangeCallbacks();

				if (this._state.products.length) {
					this.removeAll();
				}

				this._save();
			}

			addRunOnEnableChange(fn) {
				this._onEnableChangeCallbacks.push(fn);
			}
			/**
			 *
			 * @param {Function} fn Remove a previously added callback function
			 */

			removeRunOnEnableChange(fn) {
				this._onEnableChangeCallbacks = this._onEnableChangeCallbacks.filter(
					(cb) => cb !== fn
				);
			}

			get products() {
				return this._state.products;
			}

			get atProductLimit() {
				return this._state.products.length >= MAX_COMPARE_PRODUCTS;
			}

			get returnBreadcrumb() {
				return this._state.returnBreadcrumb;
			}

			_runUpdateCallbacks() {
				const data = {
					products: this._state.products,
					atProductLimit: this.atProductLimit,
				};

				this._onUpdateCallbacks.forEach((cb) => cb(data));
			}

			_runEnableChangeCallbacks() {
				this._onEnableChangeCallbacks.forEach((cb) => cb(this.enabled));
			}

			_onRemoveLastProduct() {
				if (this._hasToggle) return;
				this.disable();
			}

			_getReturnBreadcrumb() {
				if (this.breadCrumbData && this.breadCrumbData.update) {
					return {
						url: window.location.href,
						title: this.breadCrumbData.title,
					};
				}

				return this._state.returnBreadcrumb;
			}

			_getState() {
				const savedState = this._load();

				if (savedState) {
					const enabled =
						this._hasToggle || savedState.products.length
							? savedState.enabled
							: false;
					return {
						...savedState,
						enabled,
					};
				}

				return {
					products: [],
					returnBreadcrumb: null,
					enabled: false,
				};
			}

			_load() {
				try {
					return JSON.parse(sessionStorage.getItem(storageKey));
				} catch (e) {
					return null;
				}
			}

			_save() {
				sessionStorage.setItem(storageKey, JSON.stringify(this._state));
			}
		}

		/* harmony default export */ const components_ProductCompare =
			new ProductCompare(); // CONCATENATED MODULE: ./source/scripts/components/Checkbox.js
		class Checkbox {
			constructor(el) {
				this.checkmark = el.querySelector(".checkmark");
				this.checkmarkCheck = el.querySelector(".checkmark__check");
				this.checkmarkIndeterminate = el.querySelector(
					".checkmark__indeterminate"
				);
				const state = "unchecked";
				this.fillAnimation = transition({
					el: this.checkmark,
					state,
				});
				this.checkAnimation = transition({
					el: this.checkmarkCheck,
					state,
				});
				this.indeterminateCheckAnimation = transition({
					el: this.checkmarkIndeterminate,
					state,
				});
			}

			check() {
				this.fillAnimation.animateTo("checked");
				this.checkAnimation.animateTo("checked");
			}

			uncheck() {
				this.fillAnimation.animateTo("unchecked");
				this.checkAnimation.animateTo("unchecked");
			}

			setIndeterminate() {
				this.fillAnimation.animateTo("indeterminate");
				this.indeterminateCheckAnimation.animateTo("indeterminate");
			}

			unsetIndeterminate() {
				this.fillAnimation.animateTo("unchecked");
				this.indeterminateCheckAnimation.animateTo("unchecked");
			}

			set disabled(disabled) {
				this.checkmark.classList.toggle("checkmark--disabled", disabled);
			}

			unload() {
				this.fillAnimation.unload();
				this.checkAnimation.unload();
				this.indeterminateCheckAnimation.unload();
			}
		} // CONCATENATED MODULE: ./source/scripts/components/ProductGridItem.js
		class ProductGridItem {
			constructor(options) {
				this.el = options.el;
				this.$el = jquery_default()(options.el);
				this.id = options.id;
				this.disableActionsToggle =
					"disableActionsToggle" in options
						? options.disableActionsToggle
						: false;
				this.productQuickshop = null;
				this.quickshopInitialVariant = null;
				this.quickBuySettings = null;
				this.actionsOpen = false;
				this.defaultView = options.grid_list;
				this.events = new EventHandler /* default */.Z();

				if (options.lazy) {
					this.lazyLoader = new LazyLoader_LazyLoader(this.$el[0], () =>
						this._init()
					);
				} else {
					this._init();
				}
			}

			_init() {
				this.$window = jquery_default()(window);
				this.$html = jquery_default()("html");
				this.content = this.el.querySelector("[data-product-item-content]");
				this.actions = this.el.querySelector("[data-product-actions]");
				this.swatchesEl = this.el.querySelector("[data-swatches]");
				this.quickBuyEl = this.el.querySelector("[data-quick-buy]");
				this.quickshopSlimEl = this.el.querySelector("[data-quickshop-slim]");
				this.quickshopFullEl = this.el.querySelector("[data-quickshop-full]");
				this.compareCheckbox = this.el.querySelector("[data-compare-checkbox]");
				this.compareItem = this.el.querySelector("[data-compare-item]");
				this.compareItemWrapper = this.el.querySelector(
					"[data-compare-item-wrapper]"
				);
				this.hasProductActions = this.actions !== null;
				this._addToCart = this._addToCart.bind(this);
				this._actionsToggle = this._actionsToggle.bind(this);
				this._openQuickShop = this._openQuickShop.bind(this);

				if (this.hasProductActions) {
					this._setSortByQueryParameters();

					if (
						!this.disableActionsToggle &&
						this.$html.hasClass("no-touch") &&
						this.defaultView !== "list-view"
					) {
						this.events.register(this.el, "mouseenter", (e) =>
							this._actionsToggle(e)
						);
						this.events.register(this.el, "mouseleave", (e) =>
							this._actionsToggle(e)
						);
						this.events.register(this.el, "focusin", (e) =>
							this._actionsToggle(e)
						);
					} // $scripts checks existence of script in header before attempting to inject

					script_default()(
						jquery_default()("[data-scripts]").data("shopify-api-url"),
						() => {
							this.events.register(this.quickBuyEl, "click", (e) =>
								this._addToCart(e)
							);
							this.events.register(this.quickshopSlimEl, "click", (e) =>
								this._openQuickShop(e)
							);
							this.events.register(this.quickshopFullEl, "click", (e) =>
								this._openQuickShop(e)
							);
						}
					);
				}

				this.expandAnimation = transition({
					el: this.content,
					state: "closed",
				});

				if (this.compareCheckbox) {
					this.compareData = JSON.parse(
						this.el.querySelector("[data-product-compare-data]").innerHTML
					);
					this.expandCheckboxAnimation = transition({
						el: this.compareItemWrapper,
						state: "closed",
					});
					this.compareItemCheckbox = new Checkbox(this.compareItem);
					this.events.register(this.compareCheckbox, "change", () =>
						this._updateProductCompare(this.compareCheckbox.checked)
					);

					const onUpdate = (_ref) => {
						let { atProductLimit } = _ref;

						if (components_ProductCompare.includes(this.compareData.handle)) {
							this.compareCheckbox.disabled = false;
							this.compareItemCheckbox.disabled = false;
							this.compareItem.classList.add("productitem__compare--enabled");
							this.compareItem.classList.remove(
								"productitem__compare--disabled"
							);
							this.compareCheckbox.checked = true;
							this.compareItemCheckbox.check();
						} else {
							this.compareCheckbox.checked = false;
							this.compareItemCheckbox.uncheck();
							this.compareCheckbox.disabled = atProductLimit;
							this.compareItemCheckbox.disabled = atProductLimit;
							this.compareItem.classList.toggle(
								"productitem__compare--enabled",
								!atProductLimit
							);
							this.compareItem.classList.toggle(
								"productitem__compare--disabled",
								atProductLimit
							);
						}
					};

					onUpdate({
						atProductLimit: components_ProductCompare.atProductLimit,
					});
					components_ProductCompare.runOnUpdate(onUpdate);

					const onEnableChange = (enabled) => {
						if (enabled) {
							this._showCompareCheckbox();
						} else if (!this.actionsOpen) {
							this._hideCompareCheckbox();
						}
					};

					onEnableChange(components_ProductCompare.enabled);
					components_ProductCompare.addRunOnEnableChange(onEnableChange);
				}

				if (this.quickbuyEl !== null) {
					this._initQuickBuy();
				}

				this._objectFitPolyfill();

				if (this.swatchesEl) {
					this.swatches = new GridItemSwatches({
						el: this.$el[0],
						setInitialVariant: (id) => {
							this.quickshopInitialVariant = id;
						},
						product: this.product,
					});
				}
			}

			_updateProductCompare(checkedForCompare) {
				const { handle, title, image, imageAspectRatio, url } =
					this.compareData; // Ignore onboarding content

				if (!handle) return;

				if (checkedForCompare) {
					components_ProductCompare.enable();
					components_ProductCompare.add({
						handle,
						data: {
							title,
							image,
							imageAspectRatio,
							url,
						},
					});
				} else {
					components_ProductCompare.remove(handle);
				}
			}
			/**
			 * Make Shopify aware of releavent collection search info
			 *  - tag
			 *  - vendor
			 *  - pagination
			 *  - sorting criteria
			 *
			 * @private
			 */

			_setSortByQueryParameters() {
				Shopify.queryParams = {};

				if (location.search.length) {
					for (
						let i = 0, aCouples = location.search.substr(1).split("&");
						i < aCouples.length;
						i++
					) {
						const aKeyValue = aCouples[i].split("="); // Reset the page number when we apply (i.e. don't add it to params)

						if (aKeyValue.length > 1 && aKeyValue[0] !== "page") {
							Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
								aKeyValue[1];
						}
					}
				}
			}

			_initQuickBuy() {
				try {
					this.quickBuySettings = JSON.parse(
						this.$el.find("[data-quick-buy-settings]").text()
					);
				} catch (error) {
					console.warn(
						`Quick buy: invalid QuickBuy data found. ${error.message}`
					);
				}
			}

			_openQuickShop(event) {
				event.preventDefault();
				const leftThumbsClass = event.currentTarget.hasAttribute(
					"data-thumbs-left"
				)
					? " quickshop-thumbs-left"
					: "";
				const modalClass = event.currentTarget.hasAttribute(
					"data-quickshop-full"
				)
					? `quickshop-full${leftThumbsClass}`
					: "quickshop-slim";

				if (this.productQuickshop) {
					this.productQuickshop.unload();
				}

				this.productQuickshop = new ProductQuickshop({
					$el: this.$el,
					id: this.id,
					modalClass,
					trigger: this.$el.find(".productitem--title a"),
					initialVariant: this.quickshopInitialVariant,
				});
			}

			_isObjectFitAvailable() {
				return "objectFit" in document.documentElement.style;
			}

			_objectFitPolyfill() {
				if (this._isObjectFitAvailable()) {
					return;
				}

				const $figure = jquery_default()("[data-product-item-image]", this.$el);
				const featuredSrc = jquery_default()(
					"img:not(.productitem--image-alternate)",
					$figure
				).attr("src");
				const alternateSrc = jquery_default()(
					".productitem--image-alternate",
					$figure
				).attr("src");
				$figure.addClass("product-item-image-no-objectfit");
				$figure.css("background-image", `url("${featuredSrc}")`);

				if (alternateSrc) {
					this.events.register(this.el, "mouseover", () => {
						$figure.css("background-image", `url("${alternateSrc}")`);
					});
					this.events.register(this.el, "mouseleave", () => {
						$figure.css("background-image", `url("${featuredSrc}")`);
					});
				}
			}
			/**
			 * Get height of element, and combined height of element + actions
			 *
			 * @returns 
			 * @private
			 */

			_getHeights() {
				const { height } = this.el.getBoundingClientRect();
				const actionsHeight = this.actions.getBoundingClientRect().height;
				return {
					heightBase: height,
					heightExpanded: height + actionsHeight,
				};
			}

			_actionsToggle(event) {
				if (!Layout.isGreaterThanBreakpoint("M")) return;
				const $currentTarget = jquery_default()(event.currentTarget);
				const $target = jquery_default()(event.target);
				let openProductItem = false; // This function gets called on the element as well as the document focusin, so we want to
				// be extra careful that we are inside the product card in question. We want the product card
				// to close if another product card has received focus.

				const productHasFocus =
					this.$el.is($currentTarget) ||
					this.$el.is($target) ||
					this.$el.is($target.parents(".productgrid--item").first()) ||
					(event.type === "focusin" && $target[0].contains(this.$el[0]));

				if (event.type === "mouseenter" || event.type === "mouseleave") {
					openProductItem = event.type === "mouseenter";
				} else if (productHasFocus) {
					openProductItem = true;
				}

				if (openProductItem) {
					this._showActions();
				} else {
					this._hideActions();
				}
			}

			_showActions() {
				if (this.actionsOpen) {
					return;
				}

				const { heightBase, heightExpanded } = this._getHeights();

				this._showCompareCheckbox().then((compareHeight) => {
					this.el.style.setProperty("--base-height", `${heightBase}px`);
					this.el.style.setProperty(
						"--open-height",
						`${heightExpanded + compareHeight}px`
					); // Store set the outer grid item to be open so it knows to adjust its z-index

					this.el.setAttribute("data-open", ""); // Start animation, and transition base height to expanded height (in CSS)

					this.expandAnimation.animateTo("open");
					this.focusinEvent = this.events.register(document, "focusin", (e) =>
						this._actionsToggle(e)
					);
					this.actionsOpen = true;
				});
			}

			_hideActions() {
				this.expandAnimation.animateTo("closed").then(() => {
					this.el.style.removeProperty("--base-height");
					this.el.removeAttribute("data-open");
				});

				this._hideCompareCheckbox();

				if (this.focusinEvent) {
					this.events.unregister(this.focusinEvent);
				}

				this.actionsOpen = false;
			}

			_showCompareCheckbox() {
				if (
					!this.expandCheckboxAnimation ||
					this.expandCheckboxAnimation.state === "open"
				) {
					// Checkbox doesn't exist or is already visible and included in card height
					return Promise.resolve(0);
				}

				return new Promise((resolve) => {
					this.expandCheckboxAnimation.animateTo("open", {
						onStart: (_ref2) => {
							let { el } = _ref2;
							const { scrollHeight } = el.querySelector("[data-compare-item]");
							this.el.style.setProperty(
								"--compare-height",
								`${scrollHeight}px`
							);
							resolve(scrollHeight);
						},
					});
				});
			}

			_hideCompareCheckbox() {
				if (!this.expandCheckboxAnimation) return; // Start animation and transition checkbox height

				if (!components_ProductCompare.enabled) {
					this.expandCheckboxAnimation.animateTo("closed").then(() => {
						this.el.style.setProperty("--compare-height", "0px");
					});
				}
			}

			_addToCart(event) {
				event.preventDefault();

				if (this.addToCartFlyout) {
					this.addToCartFlyout.unload();
				}

				const atcButton = event.currentTarget;
				const variantID = atcButton.getAttribute("data-variant-id");
				const formData = [
					{
						name: "id",
						value: variantID,
					},
					{
						name: "quantity",
						value: 1,
					},
				];
				const options = {
					atcButton,
					settings: {
						moneyFormat: this.quickBuySettings.money_format,
						cartRedirection: this.quickBuySettings.cart_redirection,
					},
				};
				this.addToCartFlyout = new AddToCartFlyout(formData, options);
			}

			unload() {
				this.events.unregisterAll();

				if (this.productQuickshop) {
					this.productQuickshop.unload();
				}

				document.removeEventListener("focusin", this._actionsToggle);

				if (this.swatches) {
					this.swatches.unload();
				}

				if (this.lazyLoader) {
					this.lazyLoader.unload();
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/Accordion.js
		const makeBlock = (el) => ({
			animation: transition({
				el,
				state: "open",
				stateAttribute: "data-accordion-state",
				stateChangeAttribute: "data-accordion-animation",
			}),
			isOpen: true,
		});

		const setOpenHeight = (el) => {
			el.style.setProperty("--menu-open-height", `${el.scrollHeight}px`);
		};

		class Accordion {
			constructor(el) {
				let options =
					arguments.length > 1 && arguments[1] !== undefined
						? arguments[1]
						: {};
				this.el = el;
				this.options = {
					content: "[data-accordion-content]",
					animate: true,
					onStart: () => {},
					...options,
				};
				this.blocks = new Map();
			}

			closeAll() {
				let options =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: {};
				this.el
					.querySelectorAll(this.options.content)
					.forEach((block) => this.close(block, options));
			}

			openAll() {
				let options =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: {};
				this.el
					.querySelectorAll(this.options.content)
					.forEach((block) => this.open(block, options));
			}

			open(el) {
				let options =
					arguments.length > 1 && arguments[1] !== undefined
						? arguments[1]
						: {};

				this._open(el, options);
			}

			close(el) {
				let options =
					arguments.length > 1 && arguments[1] !== undefined
						? arguments[1]
						: {};

				this._close(el, options);
			}

			toggle(el) {
				let options =
					arguments.length > 1 && arguments[1] !== undefined
						? arguments[1]
						: {};

				const { isOpen } = this._getBlock(el);

				if (isOpen) {
					this._close(el, options);
				} else {
					this._open(el, options);
				}
			}

			unload() {
				this.blocks.forEach((_ref) => {
					let { animation } = _ref;
					return animation.unload();
				});
			}

			_getBlock(el) {
				const block = el.matches(this.options.content)
					? el
					: el.querySelector(this.options.content);

				if (!this.blocks.has(block)) {
					this.blocks.set(block, makeBlock(block));
				}

				return this.blocks.get(block);
			}

			_open(el, _ref2) {
				let { onComplete = () => {}, force = !this.options.animate } = _ref2;

				const block = this._getBlock(el);

				if (block.isOpen) return;
				block.isOpen = true;
				this.options.onStart({
					el: block.animation.el,
					state: "open",
				});
				block.animation
					.animateTo("open", {
						force,
						onStart: (_ref3) => {
							let { el } = _ref3;
							return setOpenHeight(el);
						},
					})
					.then((state) => {
						if (state === "open") {
							onComplete();
						}
					});
			}

			_close(el, _ref4) {
				let { onComplete = () => {}, force = !this.options.animate } = _ref4;

				const block = this._getBlock(el);

				if (!block.isOpen) return;
				block.isOpen = false;
				this.options.onStart({
					el: block.animation.el,
					state: "closed",
				});
				setOpenHeight(block.animation.el);
				block.animation
					.animateTo("closed", {
						force,
					})
					.then((state) => {
						if (state === "closed") {
							onComplete();
						}
					});
			}
		} // CONCATENATED MODULE: ./source/scripts/components/FilterGroups.js
		class FilterGroups {
			constructor(el, options) {
				this.el = el;
				this.filterGroupsSetting = options.groups;
				this.filterStyleSetting = options.style;
				this.Accordion = new Accordion(el);

				this._closeAllGroups(); // Filter group selectors

				this.activeMenuClass = "filter-group-active";
				this.activeButtonClass = "productgrid--sidebar-button-active";
				this.buttonSelector = "[data-filter-group-trigger]";
				this.listSelector = "[data-accordion-content]";
				this.buttonTriggers = this.el.querySelectorAll(this.buttonSelector);
				this.events = new EventHandler /* default */.Z();
				this.buttonTriggers.forEach((button) =>
					this.events.register(button, "click", (e) => this._toggleGroup(e))
				);

				this._init();
			}

			_init() {
				if (!this.el.querySelector(this.listSelector)) return;

				if (this.filterStyleSetting === "tags" && cjs.max("S")) {
					this._openFirst();

					return;
				}

				switch (this.filterGroupsSetting) {
					case "expand_all":
						this._openAllGroups();

						break;

					case "expand_first":
						this._openFirst();

						break;

					default:
						this._closeAllGroups();

						break;
				}
			}

			_openFirst() {
				const button = this.el.querySelector(this.buttonSelector);
				const list = button.parentElement.querySelector(this.listSelector);
				this.openGroup(button, list, true);
			}

			_openAllGroups() {
				this.buttonTriggers.forEach((button) => {
					const list = button.parentElement.querySelector(this.listSelector);
					this.openGroup(button, list, true);
				});
			}

			_closeAllGroups() {
				this.Accordion.closeAll({
					force: true,
				});
			}

			_toggleGroup(event) {
				const button = event.target;
				const list = button.parentElement.querySelector(this.listSelector);
				list.classList.contains(this.activeMenuClass)
					? this._closeGroup(button, list)
					: this.openGroup(button, list);
			}

			openGroup(button, list) {
				let force =
					arguments.length > 2 && arguments[2] !== undefined
						? arguments[2]
						: false;
				list.classList.add(this.activeMenuClass);
				button.classList.add(this.activeButtonClass);

				const onComplete = () => {
					button.setAttribute("aria-expanded", true);
				};

				this.Accordion.open(list, {
					onComplete,
					force,
				});
			}

			_closeGroup(button, list) {
				list.classList.remove(this.activeMenuClass);
				button.classList.remove(this.activeButtonClass);

				const onComplete = () => {
					button.setAttribute("aria-expanded", false);
				};

				this.Accordion.close(list, {
					onComplete,
				});
			}

			unload() {
				this.events.unregisterAll();
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/StaticCollection.js
		class StaticCollection {
			constructor(section) {
				this.section = section;
				this.$el = jquery_default()(section.el);
				this.el = section.el;
				this.view = null; // sub collection section slideshow

				this.flickity = null;
				this.handleEvents = new EventHandler /* default */.Z();
				this.subcollectionSlideshow = this.el.querySelector(
					'[data-subcollections-layout="slideshow"]'
				);
				this.slides = this.el.querySelectorAll(
					"[data-subcollections-grid-item]"
				);

				if (this._shouldInitFlickity(cjs)) {
					this._initFlickity();
				} else {
					this._destroyFlickity();
				}

				this.context = section.data.context;
				this.showFilterProductCount = section.data.show_filter_product_count;
				this.productCount = section.data.product_count;
				this.filterGroups = section.data.filter_groups;
				this.filterStyle = section.data.filter_style;
				this.noMatchedProductsText = section.data.no_matched_products_text;
				this.collectionUrl = this.context.collectionUrl;
				this.currentTags = this.context.current_tags;
				this.$focusItem = null;
				this.defaultView = this.context.grid_list;
				this.postMessage = section.postMessage;
				this.filterType = section.data.filter_type;
				this.filtersContentSelector = "[data-productgrid-filters-content]";
				this.filterGroupSelector = "[data-productgrid-sidebar-group]";
				this.sortContent = "[data-productgrid-sort-content]";
				this.$sortTrigger = this.$el.find("[data-productgrid-trigger-sort]");
				this.$sortTriggerButton = this.$el.find(
					"[data-productgrid-trigger-sort-button]"
				);
				this.$sortTriggerModal = this.$el.find("[data-productgrid-modal-sort]");
				this.$filtersTrigger = this.$el.find(
					"[data-productgrid-trigger-filters]"
				);
				this.$filtersContent = this.$el.find(this.filtersContentSelector);
				this.$allTags = this.$filtersContent.find(
					".filter-item a:not([data-filter-toggle])"
				);
				this.$advancedTags = this.$el.find("[data-tag-advanced] a");
				this.$additionalTags = this.$el.find("[data-filter-toggle]");
				this.$viewToggle = this.$el.find("[data-collection-view]");
				this.gridContainer = this.el.querySelector(".productgrid--outer");
				this.$description = this.$el.find("[data-collection-description]");
				this.filterCheckboxes = this.el.querySelectorAll(
					".filter-icon--checkbox"
				);
				this.stickyUtils = this.el.querySelector("[data-sticky-utils]");
				this.stickyUtilsIntersectionTarget = this.el.querySelector(
					"[data-utils-intersection-target]"
				);
				this.header = document.querySelector("[data-site-header]");
				this.stickyHeaderClass = "site-header-sticky";
				this.compareToggle = this.el.querySelector("[data-compare-toggle]");
				this._changeSorting = this._changeSorting.bind(this);
				this._changeSortingButton = this._changeSortingButton.bind(this);
				this._showSortModal = this._showSortModal.bind(this);
				this._showFiltersModal = this._showFiltersModal.bind(this);
				this._activateTag = this._activateTag.bind(this);
				this._advancedTags = this._advancedTags.bind(this);
				this._toggleTags = this._toggleTags.bind(this);
				this._toggleView = this._toggleView.bind(this);
				this._checkListView = this._checkListView.bind(this);
				this.events = [
					this.$sortTrigger.on("change.collection", this._changeSorting),
					this.$sortTriggerButton.on(
						"click.collection",
						this._changeSortingButton
					),
					this.$sortTriggerModal.on("click.collection", this._showSortModal),
					this.$filtersTrigger.on("click.collection", this._showFiltersModal),
					this.$allTags.on("click.collection", (e) =>
						this._activateTag(e.currentTarget)
					),
					this.$additionalTags.on("click.collection", this._toggleTags),
					this.$viewToggle.on("click.collection", this._toggleView),
				];

				if (this.$description.length) {
					this.richText = new RichText(this.$description);
				} // Product items

				this.productItems = [];
				this.fillAnimations = {};
				this.checkAnimations = {};

				this._initAnimations();

				this._setSortByQueryParameters();

				this._checkListView();

				if (this.section.data.enable_product_compare) {
					this._initProductCompare();
				}

				if (cjs.max("S")) {
					this._initProductGridUtils();
				} // Save all tag handles on the page

				this.handleEls = section.el.querySelectorAll("[data-handle]");
				this.handles = [];
				this.handleEls.forEach((current) => {
					this.handles.push(current.dataset.handle);
				});
				this.modal = new Modal();

				if (this.$filtersContent.length > 0) {
					const options = {
						groups: this.filterGroups,
						style: this.filterStyle,
					};
					this.filterGroupAccordions = new FilterGroups(
						this.$filtersContent[0],
						options
					);

					this._initTags();
				}

				this.handleBreakpointChange = (breakpoints) =>
					this.onBreakpointChange(breakpoints);

				cjs.onChange(this.handleBreakpointChange);
			}

			_initProductCompare() {
				const onEnableChange = (enabled) => {
					this.compareToggle.checked = enabled;
				};

				onEnableChange(components_ProductCompare.enabled);
				components_ProductCompare.addRunOnEnableChange(onEnableChange);
				this.handleEvents.register(this.compareToggle, "change", () => {
					if (this.compareToggle.checked) {
						components_ProductCompare.enable();
					} else {
						components_ProductCompare.disable();
					}
				});
			}
			/**
			 * Initialize animations on checkbox container
			 * using filter tag as JSON key
			 */

			_initAnimations() {
				this.filterCheckboxes.forEach((el) => {
					const tagHandle = el.dataset.handle;
					const checkmark = el.querySelector(".checkmark");
					const checkmarkCheck = el.querySelector(".checkmark__check");
					let state = "unchecked";

					if (el.closest(".filter-item").dataset.filterActive === "true") {
						state = "checked";
					}

					const fillAnimation = transition({
						el: checkmark,
						state,
					});
					const checkAnimation = transition({
						el: checkmarkCheck,
						state,
					});
					this.fillAnimations[tagHandle] = fillAnimation;
					this.checkAnimations[tagHandle] = checkAnimation;
				});
			}

			onSectionUnload() {
				this._destroyFlickity();

				cjs.offChange(this.handleBreakpointChange);
				this.handleEvents.unregisterAll();
				this.events.forEach(($el) => $el.off(".collection"));
				this.modal.unload();
				Object.keys(this.fillAnimations).forEach((key) => {
					this.fillAnimations[key].unload();
					this.checkAnimations[key].unload();
				});
				this.productItems.forEach((productItem) => {
					productItem.unload();
				});

				if (this.$filtersContent.length > 0) {
					this.filterGroupAccordions.unload();
				}

				if (this.observer) {
					this.observer.disconnect();
				}
			}

			_initFlickity() {
				if (this.flickity) {
					return;
				}

				this.flickity = new (js_default())(this.subcollectionSlideshow, {
					autoPlay: 0,
					accessibility: true,
					cellAlign: "left",
					cellSelector: "[data-subcollections-grid-item]",
					groupCells: true,
					contain: true,
					pageDots: false,
					arrowShape:
						"M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z",
				});
				const viewport =
					this.subcollectionSlideshow.querySelector(".flickity-viewport");
				const slider =
					this.subcollectionSlideshow.querySelector(".flickity-slider");
				const sliderWrapper = document.createElement("div");
				sliderWrapper.classList.add("flickity-slider--wrapper");
				viewport.appendChild(sliderWrapper);
				sliderWrapper.appendChild(slider);
				this.handleEvents.register(
					this.subcollectionSlideshow,
					"rimg:load",
					() => {
						if (this.flickity) {
							this.flickity.resize();
						}
					}
				);
			}

			_destroyFlickity() {
				if (!this.flickity) {
					return;
				}

				this.flickity.destroy();
				this.flickity = null;
			}

			_initProductItems() {
				let view =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: "grid-view";
				const $productItems = this.$el.find("[data-product-item]");
				$productItems.each((i, productItem) => {
					this.productItems.push(
						new ProductGridItem({
							el: productItem,
							id: this.section.id,
							lazy: true,
							grid_list: view,
						})
					);
				});
			}

			_shouldInitFlickity(breakpoint) {
				if (
					(breakpoint.max("XXXS") && this.slides.length > 3) ||
					(breakpoint.max("M") && this.slides.length >= 5) ||
					(breakpoint.min("L") && this.slides.length > 7)
				) {
					return true;
				} else if (this.subcollectionSlideshow) {
					return false;
				}
			}
			/**
			 * Open Tags/Filters modal (on mobile)
			 *
			 * @param event
			 * @private
			 */

			_showFiltersModal(event) {
				event.preventDefault();
				this.$focusItem = jquery_default()(event.currentTarget);
				this.modal.open(this.filtersContentSelector, "productgrid-filters");
			}
			/**
			 * Open Sort by modal (on mobile)
			 *
			 * @param event
			 * @private
			 */

			_showSortModal(event) {
				event.preventDefault();
				this.$focusItem = jquery_default()(event.currentTarget);
				this.modal.open(this.sortContent, "productgrid-sort");
			}

			_deactivateTags(currentFilterItem) {
				const currentGroup = currentFilterItem.closest("[data-filter-group]");
				const activeTags = currentGroup.querySelectorAll(
					'[data-filter-active="true"]'
				);
				activeTags.forEach((el) => {
					const itemTag = el.dataset.handle;
					currentGroup.querySelector(
						`.filter-item[data-handle='${itemTag}']`
					).dataset.filterActive = false;

					if (this.fillAnimations[itemTag] && this.checkAnimations[itemTag]) {
						this.fillAnimations[itemTag].animateTo("unchecked");
						this.checkAnimations[itemTag].animateTo("unchecked");
					}
				});
			}
			/**
			 * Style a tag as active after click, before page transition
			 *
			 * @param event
			 * @private
			 */

			_activateTag(target) {
				event.preventDefault();
				const href = target.getAttribute("href");
				const filterItem = target.closest(".filter-item");
				const filterItemTag = filterItem.dataset.handle;
				const isDisabled = filterItem.classList.contains(
					"filter-item--disabled"
				);

				if (isDisabled) {
					return;
				}

				let animateTo = "checked";

				if (filterItem.dataset.filterActive === "true") {
					animateTo = "unchecked";
				}

				this._deactivateTags(filterItem);

				if (animateTo === "checked") {
					filterItem.dataset.filterActive = true;
				} else {
					filterItem.dataset.filterActive = false;
				}

				if (
					this.fillAnimations[filterItemTag] &&
					this.checkAnimations[filterItemTag]
				) {
					this.fillAnimations[filterItemTag].animateTo(animateTo);
					this.checkAnimations[filterItemTag].animateTo(animateTo).then(() => {
						if (this.$advancedTags.length === 0) {
							location.href = href;
						} else {
							this._advancedTags(jquery_default()(target));
						}
					});
				} else {
					// If the animation is not registered to the tag, it is a swatch and should
					// go straight to the advanced tags function
					this._advancedTags(jquery_default()(target));
				}
			}
			/**
			 * Used by advanced tags to concatenate tag searches
			 *
			 * @param event
			 * @private
			 */

			_advancedTags(link) {
				const $target = link.parent();
				const $filtersContent = $target.closest("nav");
				const filterGroups = $filtersContent.find("[data-filter-group]");
				const filterHandles = []; // Build the filter for the url based on what is in the dom

				filterGroups.each((index, filterGroup) => {
					const selectedItems = filterGroup.querySelectorAll(
						'[data-filter-active="true"]'
					);

					if (selectedItems.length) {
						filterHandles.push(jquery_default()(selectedItems).data("handle"));
					}
				});
				/*
          If any of the current tags are not available on the page, it may be a menu item
          filtered by a non-grouped tag, so this tag should be added to the filters.
        */

				if (this.currentTags.length) {
					this.currentTags.forEach((tag) => {
						if (!this.handles.includes(tag)) filterHandles.push(tag);
					});
				}

				this._updateLocation(filterHandles.join("+"));
			}

			_updateLocation(filter) {
				if (this.collectionUrl.indexOf("vendors") > -1) {
					location.href = `${this.collectionUrl}&constraint=${filter}`;
				} else {
					location.href = `${this.collectionUrl}/${filter}`;
				}
			}
			/**
			 * Expand / Collapse additional tags in the sidebar
			 *
			 * @param event
			 * @private
			 */

			_toggleTags(event) {
				event.preventDefault();
				const $trigger = jquery_default()(event.currentTarget);
				const $items = $trigger.parent().siblings("[data-hidden-default]");
				const siblingsVisible = $trigger.data("filter-toggle");
				$items.toggleClass("filter-item--hidden", siblingsVisible);
				$trigger
					.data("filter-toggle", !siblingsVisible)
					.text(
						!siblingsVisible ? this.context.see_less : this.context.see_more
					);

				if (this.modal.isOpen()) {
					this.modal.position();
				}
			}
			/**
			 * Make Shopify aware of releavent collection search info
			 *  - tag
			 *  - vendor
			 *  - pagination
			 *  - sorting criteria
			 *
			 * @private
			 */

			_setSortByQueryParameters() {
				Shopify.queryParams = {};

				if (location.search.length) {
					for (
						let i = 0, aCouples = location.search.substr(1).split("&");
						i < aCouples.length;
						i++
					) {
						const aKeyValue = aCouples[i].split("="); // Reset the page number when we apply (i.e. don't add it to params)

						if (aKeyValue.length > 1 && aKeyValue[0] !== "page") {
							Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
								decodeURIComponent(aKeyValue[1]);
						}
					}
				}
			}
			/**
			 * Sort by opens a modal on mobile, this handles button events
			 *
			 * @param event
			 * @private
			 */

			_changeSortingButton(event) {
				const activeClass = "utils-sortby--modal-button--active";
				jquery_default()(event.currentTarget)
					.addClass(activeClass)
					.parent()
					.siblings()
					.find(`.${activeClass}`)
					.removeClass(activeClass);

				this._changeSorting(event);
			}
			/**
			 * Change sorting of collection
			 *
			 * @param event
			 * @private
			 */

			_changeSorting(event) {
				event.preventDefault();
				const $target = jquery_default()(event.currentTarget);
				Shopify.queryParams.sort_by = $target.val();
				location.search = jQuery
					.param(Shopify.queryParams)
					.replace(/\+/g, "%20");
			}
			/**
			 * Toggle grid or list view
			 *
			 */

			_toggleView(event) {
				const $target = jquery_default()(event.currentTarget);
				Shopify.queryParams.grid_list = $target.data("collection-view");
				location.search = jQuery
					.param(Shopify.queryParams)
					.replace(/\+/g, "%20");
			}
			/**
			 * Check grid/list view toggle query parameters
			 *
			 */

			_checkListView() {
				const view = Shopify.queryParams.grid_list
					? Shopify.queryParams.grid_list
					: this.defaultView;
				this.$el.find('[href*="&grid_list"]').attr("href", (i, url) => {
					let href = url;

					if (url.indexOf("?") < 0) {
						const replaceIndex = url.indexOf("&");
						const firstHalf = url.substr(0, replaceIndex);
						const secondHalf = url.substr(replaceIndex + 1);
						href = firstHalf.concat("?", secondHalf);
					}

					href = href.replace("grid_list", `grid_list=${view}`);
					return href;
				});
				this.$el.find(".utils-viewtoggle-button").removeClass("active");
				jquery_default()(`[data-collection-view=${view}]`).addClass("active");
				const className = view.replace("-", "");
				if (this.gridContainer !== null) {
					this.gridContainer.classList.add(`productgrid-${className}`);

					if (className === "listview") {
						this.gridContainer.classList.remove("productgrid-gridview");
					} else {
						this.gridContainer.classList.remove("productgrid-listview");
					}
				}

				this.view = view;

				this._initProductItems(view);
			}

			_initTags() {
				const inactiveTags = this.$filtersContent[0].querySelectorAll(
					'[data-filter-active="false"]'
				);
				const activeTags = this.$filtersContent[0].querySelectorAll(
					'[data-filter-active="true"]'
				);
				activeTags.forEach((tag) => {
					if (tag.querySelector(".filter-item--swatch-wrapper") === null) {
						this._addProductCount(tag, true);
					}

					this._openActiveGroup(tag);
				});
				inactiveTags.forEach((tag) => {
					this._addProductCount(tag, false);
				});
			}
			/**
			 * Get & set the product counts for each filter tag in the sidebar
			 *
			 */

			_addProductCount(tag, active) {
				if (
					this.filterType === "faceted" ||
					(this.showFilterProductCount === false &&
						this.filterStyle !== "groups")
				)
					return;
				const productCountEl = tag.querySelector(
					"[data-filtered-product-count]"
				);
				if (this.collectionUrl.includes("/collections/vendors")) return;

				if (active) {
					productCountEl.innerHTML = `(${this.productCount})`;
				} else {
					const tagLinkEl = tag.querySelector("a");
					let url = tagLinkEl.getAttribute("href");
					url = url.split("?")[0];
					shopify_asyncview_dist_index_es
						.load(url, "ajax-product-count")
						.then((_ref) => {
							if (!_ref) return;
							const { data } = _ref;
							const count = data.product_count;
							productCountEl.innerHTML = `(${count})`;

							if (count === 0) {
								const title = this.noMatchedProductsText.replace(
									"*tag*",
									tag.dataset.tagTitle
								);
								tag.classList.add("filter-item--disabled");
								tagLinkEl.ariaDisabled = true;
								tagLinkEl.title = title;
							}
						});
				}
			}

			_openActiveGroup(tag) {
				const button =
					this.filterStyle === "tags"
						? this.el.querySelector(this.filtersContentSelector)
						: tag
								.closest(this.filterGroupSelector)
								.querySelector("[data-filter-group-trigger]");
				const list = tag.closest("[data-accordion-content]");
				this.filterGroupAccordions.openGroup(button, list, true);
				const tagIsHidden = "hiddenDefault" in tag.dataset;

				if (tagIsHidden) {
					const toggle = tag.parentElement.querySelector(
						'[data-filter-toggle="false"]'
					);
					toggle.click();
				}
			}

			_initProductGridUtils() {
				const header = document.querySelector("[data-site-header-main]");
				const body = document.querySelector("body");
				const headerHeight = `${header.offsetHeight}px`;
				/*
          The utility bar should be positioned directly below the header when it is sticky.
          Then, we use the negative header height value to tell the IntersectionObserver when the utility bar
          has become sticky. If the header isn't sticky, place the utility bar at the top of the window.
        */

				if (body.classList.contains(this.stickyHeaderClass)) {
					this.stickyUtils.style.top = headerHeight;
					this.stickyUtilsIntersectionTarget.style.top = `-${headerHeight}`;
				} else {
					this.stickyUtils.style.top = "0";
					this.stickyUtilsIntersectionTarget.style.top = "0";
				}

				this._observeHeaders(this.el);
			}
			/**
			 * Sets up an intersection observer to notify when the utility bar
			 * becomes sticky/not-sticky.
			 *
			 */

			_observeHeaders() {
				this.observer = new IntersectionObserver((records, observer) => {
					records.forEach((record) => {
						const targetInfo = record.boundingClientRect;
						const stickyTarget = record.target.parentElement.querySelector(
							"[data-sticky-utils]"
						);
						const rootBoundsInfo = record.rootBounds; // Started sticking.

						if (targetInfo.bottom < rootBoundsInfo.top) {
							this.postMessage(
								"collection-page:collection-utils-sticky-change",
								{
									stuck: true,
									target: stickyTarget,
								}
							);

							this._handleStickyChange({
								stuck: true,
								target: stickyTarget,
							});
						} // Stopped sticking.

						if (
							targetInfo.bottom >= rootBoundsInfo.top &&
							targetInfo.bottom < rootBoundsInfo.bottom
						) {
							this.postMessage(
								"collection-page:collection-utils-sticky-change",
								{
									stuck: false,
									target: stickyTarget,
								}
							);

							this._handleStickyChange({
								stuck: false,
								target: stickyTarget,
							});
						}
					});
				}); // Add the top sentinels to each section and attach an observer.

				this.observer.observe(
					document.querySelector("[data-utils-intersection-target]")
				);
			}

			_fireEvent(stuck, target) {
				// Inform the header that it should remove its box-shadow once the utility bar has become sticky.
				this.postMessage("collection-page:collection-utils-sticky-change", {
					stuck,
					target,
				});
			}

			_handleStickyChange(data) {
				const { stuck, target } = data;
				target.classList.toggle("productgrid--utils-box-shadow", stuck);
			}

			onBreakpointChange(breakpoints) {
				if (this.observer) {
					this.observer.disconnect();
				}

				if (breakpoints.current.max("S")) {
					this.headerTransitionEnd = () => {
						this._initProductGridUtils();

						this.header.removeEventListener(
							"transitionend",
							this.headerTransitionEnd
						);
					};

					this.header.addEventListener(
						"transitionend",
						this.headerTransitionEnd
					);
				}

				if (this._shouldInitFlickity(cjs)) {
					this._initFlickity();
				} else {
					this._destroyFlickity();
				}
			}
		} // CONCATENATED MODULE: ./node_modules/@pixelunion/shopify-cross-border/dist/index.es.js
		function shopify_cross_border_dist_index_es_classCallCheck(
			instance,
			Constructor
		) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function shopify_cross_border_dist_index_es_defineProperties(
			target,
			props
		) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function shopify_cross_border_dist_index_es_createClass(
			Constructor,
			protoProps,
			staticProps
		) {
			if (protoProps)
				shopify_cross_border_dist_index_es_defineProperties(
					Constructor.prototype,
					protoProps
				);
			if (staticProps)
				shopify_cross_border_dist_index_es_defineProperties(
					Constructor,
					staticProps
				);
			return Constructor;
		}

		function getDefaultExportFromCjs(x) {
			return x &&
				x.__esModule &&
				Object.prototype.hasOwnProperty.call(x, "default")
				? x["default"]
				: x;
		}

		function index_es_createCommonjsModule(fn) {
			var module = { exports: {} };
			return fn(module, module.exports), module.exports;
		}

		var index_es_EventHandler_1 = index_es_createCommonjsModule(function (
			module,
			exports
		) {
			exports.__esModule = true;

			var EventHandler =
				/** @class */
				(function () {
					function EventHandler() {
						this.events = [];
					}

					EventHandler.prototype.register = function (el, event, listener) {
						if (!el || !event || !listener) return null;
						this.events.push({
							el: el,
							event: event,
							listener: listener,
						});
						el.addEventListener(event, listener);
						return {
							el: el,
							event: event,
							listener: listener,
						};
					};

					EventHandler.prototype.unregister = function (_a) {
						var el = _a.el,
							event = _a.event,
							listener = _a.listener;
						if (!el || !event || !listener) return null;
						this.events = this.events.filter(function (e) {
							return (
								el !== e.el || event !== e.event || listener !== e.listener
							);
						});
						el.removeEventListener(event, listener);
						return {
							el: el,
							event: event,
							listener: listener,
						};
					};

					EventHandler.prototype.unregisterAll = function () {
						this.events.forEach(function (_a) {
							var el = _a.el,
								event = _a.event,
								listener = _a.listener;
							return el.removeEventListener(event, listener);
						});
						this.events = [];
					};

					return EventHandler;
				})();

			exports["default"] = EventHandler;
		});

		var Events = /*@__PURE__*/ getDefaultExportFromCjs(index_es_EventHandler_1);

		var selectors = {
			disclosureList: "[data-disclosure-list]",
			disclosureToggle: "[data-disclosure-toggle]",
			disclosureInput: "[data-disclosure-input]",
			disclosureOptions: "[data-disclosure-option]",
		};
		var classes = {
			listVisible: "disclosure-list--visible",
			alternateDrop: "disclosure-list--alternate-drop",
		};

		var Disclosure = /*#__PURE__*/ (function () {
			function Disclosure(el) {
				shopify_cross_border_dist_index_es_classCallCheck(this, Disclosure);

				this.el = el;
				this.events = new Events();
				this.cache = {};

				this._cacheSelectors();

				this._connectOptions();

				this._connectToggle();

				this._onFocusOut();
			}

			shopify_cross_border_dist_index_es_createClass(Disclosure, [
				{
					key: "_cacheSelectors",
					value: function _cacheSelectors() {
						this.cache = {
							disclosureList: this.el.querySelector(selectors.disclosureList),
							disclosureToggle: this.el.querySelector(
								selectors.disclosureToggle
							),
							disclosureInput: this.el.querySelector(selectors.disclosureInput),
							disclosureOptions: this.el.querySelectorAll(
								selectors.disclosureOptions
							),
						};
					},
				},
				{
					key: "_connectToggle",
					value: function _connectToggle() {
						var _this = this;

						this.events.register(
							this.cache.disclosureToggle,
							"click",
							function (e) {
								var ariaExpanded =
									e.currentTarget.getAttribute("aria-expanded") === "true";
								e.currentTarget.setAttribute("aria-expanded", !ariaExpanded);

								_this.cache.disclosureList.classList.remove(
									classes.alternateDrop
								);

								_this.cache.disclosureList.classList.toggle(
									classes.listVisible
								);

								window.requestAnimationFrame(function () {
									var _this$cache$disclosur =
											_this.cache.disclosureList.getBoundingClientRect(),
										left = _this$cache$disclosur.left,
										width = _this$cache$disclosur.width;

									var _window = window,
										innerWidth = _window.innerWidth;
									var gutter = 30;

									if (left + width + gutter > innerWidth) {
										_this.cache.disclosureList.classList.add(
											classes.alternateDrop
										);
									}
								});
							}
						);
					},
				},
				{
					key: "_connectOptions",
					value: function _connectOptions() {
						var _this2 = this;

						var options = this.cache.disclosureOptions;

						for (var i = 0; i < options.length; i++) {
							var option = options[i];
							this.events.register(option, "click", function (e) {
								e.preventDefault();

								const localeCode = e.currentTarget.dataset.value;
								let currentPath = window.location.pathname; // Get current page URL
								// Extract the first part of the path (locale) to check if it's a language prefix
								const pathParts = currentPath.split("/").filter((part) => part); // Remove empty segments
								const currentLocale = pathParts[0] || "/"; // First part of the path

								// Check if the first part of the path is a language code (like 'es' or 'fr')
								const supportedLocales = ["es"]; // Add all supported languages here
								if (supportedLocales.includes(currentLocale)) {
									pathParts.shift(); // Remove the locale part from the path
								}

								// Reconstruct the correct path without the old locale
								currentPath = "/" + pathParts.join("/");

								document.cookie = `selectedLocale=${localeCode}; path=/; max-age=31536000`; // 1 year
								// Apply the new locale
								if (localeCode === "en") {
									window.location.href = currentPath; // English does not need a locale prefix
								} else {
									window.location.href = `/${localeCode}${currentPath}`;
								}
							});
						}
					},
				},
				{
					key: "_onFocusOut",
					value: function _onFocusOut() {
						var _this3 = this;

						this.events.register(
							this.cache.disclosureToggle,
							"focusout",
							function (e) {
								var disclosureLostFocus = !_this3.el.contains(e.relatedTarget);

								if (disclosureLostFocus) {
									_this3._hideList();
								}
							}
						);
						this.events.register(
							this.cache.disclosureList,
							"focusout",
							function (e) {
								var childInFocus = e.currentTarget.contains(e.relatedTarget);

								var isVisible = _this3.cache.disclosureList.classList.contains(
									classes.listVisible
								);

								if (isVisible && !childInFocus) {
									_this3._hideList();
								}
							}
						);
						this.events.register(this.el, "keyup", function (e) {
							if (e.defaultPrevented) {
								return; // Do nothing if the event was already processed
							}

							if (e.key !== "Escape" || e.key !== "Esc") return;

							_this3._hideList();

							_this3.cache.disclosureToggle.focus();
						});
						this.events.register(document.body, "click", function (e) {
							var isOption = _this3.el.contains(e.target);

							var isVisible = _this3.cache.disclosureList.classList.contains(
								classes.listVisible
							);

							if (isVisible && !isOption) {
								_this3._hideList();
							}
						});
					},
				},
				{
					key: "_submitForm",
					value: function _submitForm(value) {
						this.cache.disclosureInput.value = value;
						this.el.closest("form").submit();
					},
				},
				{
					key: "_hideList",
					value: function _hideList() {
						this.cache.disclosureList.classList.remove(classes.listVisible);
						this.cache.disclosureToggle.setAttribute("aria-expanded", false);
					},
				},
				{
					key: "unload",
					value: function unload() {
						this.events.unregisterAll();
					},
				},
			]);

			return Disclosure;
		})();

		if (!Element.prototype.matches) {
			Element.prototype.matches =
				Element.prototype.msMatchesSelector ||
				Element.prototype.webkitMatchesSelector;
		}

		if (!Element.prototype.closest) {
			Element.prototype.closest = function closest(s) {
				var el = this;

				do {
					if (el.matches(s)) return el;
					el = el.parentElement || el.parentNode;
				} while (el !== null && el.nodeType === 1);

				return null;
			};
		}

		/* harmony default export */ const shopify_cross_border_dist_index_es =
			Disclosure; // CONCATENATED MODULE: ./source/scripts/sections/StaticFooter.js

		class StaticFooter {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				this.el = section.el;
				this.countryDisclosureEls = this.el.querySelectorAll(
					"[data-disclosure-country]"
				);
				this.localeDisclosureEls = this.el.querySelectorAll(
					"[data-disclosure-locale]"
				);
				this.accordionTrigger = "[data-accordion-trigger]";
				this.disclosures = [];
				this.Accordion = new Accordion(this.el, {
					onStart: (_ref) => {
						let { el, state } = _ref;
						el.parentNode.parentNode.querySelector(
							this.accordionTrigger
						).dataset.accordionTrigger = state;
					},
				});

				if (cjs.max("M")) {
					this.Accordion.closeAll({
						force: true,
					});
				}

				this.forms = new Forms(this.$el);

				if (this.countryDisclosureEls.length > 0) {
					this.countryDisclosureEls.forEach((disclosureEl) => {
						this.disclosures.push(
							new shopify_cross_border_dist_index_es(disclosureEl)
						);
					});
				}

				if (this.localeDisclosureEls.length > 0) {
					this.localeDisclosureEls.forEach((disclosureEl) => {
						this.disclosures.push(
							new shopify_cross_border_dist_index_es(disclosureEl)
						);
					});
				} // Handle Accordion interaction when window size changes

				cjs.onChange((breakpoints) => this.onBreakpointChange(breakpoints));

				this._bindEvents();
			}

			_bindEvents() {
				this.$el.on("click.footer", this.accordionTrigger, (event) => {
					event.preventDefault();

					this._toggleAccordion(
						jquery_default()(event.currentTarget).parent()[0]
					);
				});
			}

			onSectionUnload() {
				this.$el.off(".footer");
				this.forms.unload();
				this.disclosures.forEach((disclosure) => disclosure.unload());
				this.Accordion.unload();
			}

			onSectionBlockSelect(block) {
				if (block.el.classList.contains("has-accordion"))
					this._toggleAccordion(block);
			}

			onSectionBlockDeselect(block) {
				if (block.el.classList.contains("has-accordion"))
					this._toggleAccordion(block);
			}

			_toggleAccordion(block) {
				if (cjs.min("L")) return;
				this.Accordion.toggle(block);
			}

			onBreakpointChange(breakpoints) {
				if (breakpoints.current.min("L")) {
					this.Accordion.openAll({
						force: true,
					});
				} else if (
					breakpoints.previous.min("L") &&
					breakpoints.current.max("M")
				) {
					this.Accordion.closeAll({
						force: true,
					});
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/components/StickyHeader.js
		class StickyHeader {
			constructor(options, settings) {
				this.body = document.querySelector("body");
				this.header = document.querySelector("[data-site-header]");
				this.menu = this.header.querySelector("[data-site-navigation]");
				this.menuToggle = options.menuToggle;
				this.postMessage = options.postMessage;
				this.settings = settings;
				this.transitioning = false;
				this.lastToggle = Date.now() - 1000;
				this.stickyClass = "site-header-sticky";
				this.scrolledClass = "site-header-sticky--scrolled";
				this.navOpenClass = "site-header-nav--open";
				this.events = new EventHandler /* default */.Z();
				this._toggleStickyHeader = this._toggleStickyHeader.bind(this);
				this._toggleMenu = this._toggleMenu.bind(this);

				if (this.settings.sticky_header) {
					this.body.classList.add(this.stickyClass);
					window.requestAnimationFrame(() => {
						// If browser doesn't support sticky, we don't want any of the sticky functionality.
						if (
							window.getComputedStyle(this.header).position.indexOf("sticky") >
							-1
						) {
							this.observer = new IntersectionObserver((entries) =>
								this._toggleStickyHeader(entries)
							);
							this.observer.observe(
								document.querySelector("[data-header-intersection-target]")
							);

							this.toggleClick = (event) => {
								event.preventDefault();
								if (Layout.isGreaterThanBreakpoint("M")) this._toggleMenu();
							};

							this.menuToggle.addEventListener("click", this.toggleClick);
						}
					});
				}
			}

			closeNavigation() {
				if (this.transitioning) {
					return;
				}

				this.menuToggle.classList.remove("active");

				this.navTransitionOutEvent = () => {
					this.header.classList.remove(this.navOpenClass);
					this.transitioning = false;
					this.menu.removeEventListener(
						"transitionend",
						this.navTransitionOutEvent
					);
				};

				this.menu.addEventListener("transitionend", this.navTransitionOutEvent);
				this.transitioning = true;
				this.menu.setAttribute(
					"style",
					`margin-top: -${this.menu.getBoundingClientRect().height}px;`
				);
				this.postMessage("nav:close-all");
			}

			openNavigation() {
				let onOpen =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: () => {};

				if (
					this.transitioning ||
					this.header.classList.contains(this.navOpenClass)
				) {
					onOpen();
					return;
				}

				this.menuToggle.classList.add("active");

				this.navTransitionInEvent = () => {
					this.transitioning = false;
					this.menu.removeEventListener(
						"transitionend",
						this.navTransitionInEvent
					);
					onOpen();
				};

				this.menu.addEventListener("transitionend", this.navTransitionInEvent);
				this.transitioning = true; // We need to wait for the browser to set the display to 'block' before we set the margin
				// This will help with ensuring the different animations/transitions happen in sequence
				// and not at the same time.

				window.requestAnimationFrame(() => {
					this.header.classList.add(this.navOpenClass);
					window.requestAnimationFrame(() => {
						this.menu.setAttribute("style", "margin-top: 0;");
					});
				});
			}

			_toggleMenu() {
				if (this.header.classList.contains(this.navOpenClass)) {
					this.closeNavigation();
				} else {
					this.openNavigation();
				}
			}
			/**
			 * Sticky header only shows as sticky after scroll
			 *
			 * @private
			 */

			_toggleStickyHeader(entries) {
				if (ScrollLock.isLocked || !Layout.isGreaterThanBreakpoint("M")) {
					return;
				}

				const shouldShrink = !entries[0].isIntersecting; // Sticky header is scrolled, is and is visible -- nothing more to do!

				if (
					shouldShrink &&
					this.header.classList.contains(this.scrolledClass)
				) {
					return;
				} // We also check to make sure the toggle hasnt activated recently to stop jerky transitions

				if (this.lastToggle + 250 > Date.now()) {
					return;
				}

				this.lastToggle = Date.now();

				if (shouldShrink) {
					this._shrink();
				} else {
					this._expand();
				}
			}

			_shrink() {
				this.closeNavigation();
				this.header.classList.add(this.scrolledClass);
			}

			_expand() {
				this.openNavigation();
				this.header.classList.remove(this.scrolledClass);
				this.menuToggle.classList.remove("active");
			}

			unload() {
				this.body.classList.remove(this.stickyClass);
				this.body.classList.remove(this.scrolledClass);

				if (this.observer) {
					this.observer.disconnect();
				}

				this.menuToggle.removeEventListener("click", this.toggleClick);
				this.events.unregisterAll();
			}
		} // CONCATENATED MODULE: ./source/scripts/components/navigation/NavMobileSubMenus.js
		class NavMobileSubMenus {
			constructor(el) {
				this.$el = jquery_default()(el);
				this.Accordion = new Accordion(el);
				this.closeAllSubmenus(); // Sub menu selectors

				this.activeMenuClass = "navmenu-link-parent-active";
				this.activeMenu = `.${this.activeMenuClass}`;
				this.linkClass = "navmenu-link-parent";
				this.linkSelector = `.${this.linkClass}`;
				this.navTrigger = "[data-navmenu-parent]";
				this.subMenu = "[data-navmenu-submenu]";
				this.buttonClass = "navmenu-button";
				this.buttonSelector = `.${this.buttonClass}`;

				this._bindEvents();
			}

			unload() {
				this.$el.off(".mobile-nav");
				this.Accordion.unload();
			}

			closeSubMenus(current) {
				const $current = jquery_default()(current);
				$current.find(this.activeMenu).each((index, el) => {
					this._closeSubmenu(jquery_default()(el));
				});
			}

			closeAllSubmenus() {
				this.Accordion.closeAll({
					force: true,
				});
			}

			_bindEvents() {
				// Prevent focus state from applying on mouse click
				this.$el.on("mousedown.mobile-nav", ".navmenu-link", (event) => {
					event.preventDefault();
				});
				this.$el.on(
					"click.mobile-nav",
					`${this.navTrigger} > .navmenu-link-parent`,
					this._linkClicked.bind(this)
				);
				this.$el.on(
					"click.mobile-nav",
					`${this.navTrigger} > .navmenu-button`,
					(event) => {
						event.preventDefault();

						this._toggleSubmenu(event);
					}
				);
			}

			_linkClicked(event) {
				const $target = jquery_default()(event.currentTarget);

				if (!$target.hasClass(this.activeMenuClass)) {
					event.preventDefault();

					this._openSubmenu($target);
				}
			}

			_toggleSubmenu(event) {
				const $target = jquery_default()(event.currentTarget);
				const $link = $target.hasClass(this.linkClass)
					? $target
					: $target.siblings(this.linkSelector).first();

				if ($link.hasClass(this.activeMenuClass)) {
					this._closeSubmenu($target);
				} else {
					this._openSubmenu($target);
				}
			}

			_openSubmenu($target) {
				const $menu = $target.siblings(this.subMenu).first();
				const $link = $target.hasClass(this.linkClass)
					? $target
					: $target.siblings(this.linkSelector).first();
				const $button = $target.hasClass(this.buttonClass)
					? $target
					: $target.siblings(this.buttonSelector).first();
				$link.addClass(this.activeMenuClass);

				const onComplete = () => {
					$link.attr("aria-expanded", true);
					$button.attr("aria-expanded", true);
				};

				this.Accordion.open($menu[0], {
					onComplete,
				});
			}

			_closeSubmenu($target) {
				const $menu = $target.siblings(this.subMenu).first();
				const $link = $target.hasClass(this.linkClass)
					? $target
					: $target.siblings(this.linkSelector).first();
				const $button = $target.hasClass(this.buttonClass)
					? $target
					: $target.siblings(this.buttonSelector).first();
				$link.removeClass(this.activeMenuClass);

				const onComplete = () => {
					$link.attr("aria-expanded", false);
					$button.attr("aria-expanded", false);
				};

				this.Accordion.close($menu[0], {
					onComplete,
				});
				this.closeSubMenus($menu);
			}
		} // CONCATENATED MODULE: ./source/scripts/components/navigation/NavMobile.js
		class NavMobile {
			constructor(elements) {
				this.el = elements.el;
				this.toggleOpen = elements.toggleOpen;
				this.mobileNav = this.el.querySelector("[data-mobile-nav]");
				this.navPanel = this.el.querySelector("[data-mobile-nav-panel]");
				this.navOverlay = this.el.querySelector("[data-mobile-nav-overlay]");
				this.toggleClose = this.el.querySelector("[data-mobile-nav-close]");
				this.announcementBar = document.querySelector(
					"[data-announcement-bar]"
				);
				this.isOpen = false;
				this.subMenus = null;
				this.events = new EventHandler /* default */.Z(); // Revert navigation to original state on breakpoint change

				this.breakpointHandler = this.onBreakpointChange.bind(this);
				cjs.onChange(this.breakpointHandler);
				this.navPanelAnimation = transition({
					el: this.navPanel,
					state: "closed",
				});
				this.navOverlayAnimation = transition({
					el: this.navOverlay,
					state: "closed",
				});
				this.events.register(this.toggleOpen, "click", (e) => this._open(e));
			}

			unload() {
				this.events.unregisterAll();
				cjs.offChange(this.breakpointHandler);
				ScrollLock.unlock();
			}

			onBreakpointChange() {
				if (cjs.min("L") && this.isOpen) {
					this._close();
				}
			}

			_open(e) {
				e.preventDefault();

				if (cjs.min("L")) {
					return;
				}

				ScrollLock.lock(this.navPanel);

				if (this.announcementBar) {
					this.announcementBar.style.setProperty(
						"--index-announcement-bar",
						"1100"
					);
				}

				this.isOpen = true; // Activate Submenu handler

				this.subMenus = new NavMobileSubMenus(this.navPanel);
				this.mobileNav.dataset.open = "true";
				this.navPanelAnimation.animateTo("open");
				this.navOverlayAnimation.animateTo("open");
				this.mobileNav.focus();
				trapFocus(this.mobileNav);
				this.overlayClickEvent = this.events.register(
					this.navOverlay,
					"click",
					(e) => this._close(e)
				);
				this.toggleCloseEvent = this.events.register(
					this.toggleClose,
					"click",
					(e) => this._close(e)
				);
				this.overlayTouchEvent = this.events.register(
					this.navOverlay,
					"touchmove",
					(e) => e.preventDefault()
				);
				this.closeEsc = this.events.register(window, "keydown", (e) => {
					if (e.key === "Escape") {
						this._close(e);
					}
				});
			}

			_close(e) {
				if (e) e.preventDefault();
				this.navPanelAnimation.animateTo("closed");
				this.navOverlayAnimation.animateTo("closed").then(() => {
					this.mobileNav.dataset.open = "false";
					removeTrapFocus(this.mobileNav);
					this.toggleOpen.focus();

					if (this.announcementBar) {
						this.announcementBar.style.setProperty(
							"--index-announcement-bar",
							""
						);
					}
				});
				ScrollLock.unlock();
				this.isOpen = false; // Close any open drop down menus

				if (this.subMenus) {
					this.subMenus.closeSubMenus(this.navPanel);
					this.subMenus.closeAllSubmenus(); // Unbind Mobile sub menus

					this.subMenus.unload();
				}

				this.events.unregister(this.overlayClickEvent);
				this.events.unregister(this.overlayTouchEvent);
				this.events.unregister(this.toggleCloseEvent);
				this.events.unregister(this.closeEsc);
			}
		} // CONCATENATED MODULE: ./source/scripts/helpers/site-main-dimmer.js
		const el = document.querySelector("[data-site-main-dimmer]");
		const site_main_dimmer_animation = transition({
			el,
			state: "closed",
		});
		const openers = new Set();
		const disableAnimations = "reduceAnimations" in document.body.dataset;
		function dim(requestor) {
			if (disableAnimations) return;
			if (openers.has(requestor)) return;
			openers.add(requestor);
			site_main_dimmer_animation.animateTo("open");
		}
		function clear(requestor) {
			openers.delete(requestor);
			if (openers.size) return;
			site_main_dimmer_animation.animateTo("closed", {
				force: disableAnimations,
			});
		} // CONCATENATED MODULE: ./source/scripts/components/navigation/NavDesktopParent.js
		// eslint-disable-line import/no-cycle

		class NavDesktopParent {
			constructor(el, options) {
				this.listitem = el;
				this.link = null;
				this.submenu = null;
				this._isOpen = false;
				this.menu = null;
				this.parentMenu = options.parentMenu;
				this.closeSiblings = this.parentMenu.closeSiblings;
				this.details = el.querySelector("[data-navmenu-details]");
				const { children } = this.details;

				for (let i = 0; i < children.length; i++) {
					if (children[i].classList.contains("navmenu-link")) {
						this.link = children[i];
					} else if (children[i].classList.contains("navmenu-submenu")) {
						this.submenu = children[i];
					}
				}

				this.animation = transition({
					el: this.submenu,
					state: "closed",
				});

				this.open = () => {
					this._open();
				};

				this.close = () => {
					this._close();
				};

				this.closeEsc = (e) => {
					if (e.key === "Escape") {
						this.link.focus();
						this.close();
					}
				};

				this.closeTimer = null;
				this.openTimer = null;

				this.mouseover = () => {
					clearTimeout(this.closeTimer);

					if (!this.submenu.classList.contains("navmenu-depth-3")) {
						this.openTimer = setTimeout(this.open, 200);
					} else {
						this.open();
					}
				};

				this.mouseout = () => {
					clearTimeout(this.openTimer);
					this.closeTimer = setTimeout(this.close, 400);
				};

				this.click = (e) => {
					e.stopPropagation();
					const clickedParent = e.target.closest(".navmenu-link-parent"); // If the link being clicked is a parent link, then take control of the navigation

					if (clickedParent && clickedParent.dataset.href) {
						e.preventDefault(); // if already open, continue to link destination

						if (this._isOpen) {
							window.location = clickedParent.dataset.href;
							return;
						} // If the submenu isn't open, open it

						this.open();
					}
				};

				this.focusin = (e) => {
					e.stopPropagation();

					if (e.target.classList.contains("navmenu-link-parent")) {
						this.closeSiblings(this);
					}
				};

				this.touchend = (e) => {
					e.target.focus();
					this.click(e);
				};

				this.listitem.addEventListener("mouseover", this.mouseover);
				this.listitem.addEventListener("mouseout", this.mouseout);
				this.details.addEventListener("touchend", this.touchend);
				this.details.addEventListener("click", this.click);
				this.listitem.addEventListener("focusin", this.focusin);
				document.body.addEventListener("click", this.close);
				document.body.addEventListener("focusin", this.close);
			}

			get isOpen() {
				return this._isOpen;
			}

			forceOpen() {
				return this._open(true);
			}

			forceClose() {
				return this._close(true);
			}

			_open() {
				if (this._isOpen) return;
				this._isOpen = true;
				this.details.setAttribute("open", "open");
				dim(this);
				this.closeSiblings(this);
				window.addEventListener("keydown", this.closeEsc);

				if (!this.menu) {
					this.menu = new NavDesktopMenu(this.submenu);
				}

				this.animation
					.animateTo("open", {
						hold: true,
						onStart: (_ref) => {
							let { el } = _ref;
							let height = 0;

							for (let i = 0; i < el.children.length; i++) {
								height += el.children[i].offsetHeight;
							}

							this.listitem.style.setProperty(
								"--menu-open-height",
								`${height}px`
							);
							const isMeganav = this.listitem.closest(
								"[data-navmenu-meganav-type]"
							); // Check for alternate side dropdown

							const bounds = this.submenu.getBoundingClientRect();

							if (
								bounds.right > document.documentElement.clientWidth &&
								!isMeganav
							) {
								this.listitem.classList.add("alternate-drop");
							}
						},
					})
					.then((state) => {
						if (state === "open") {
							this.link.setAttribute("aria-expanded", true);
						}
					});
			}

			_close() {
				let force =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: false;
				if (!this._isOpen) return;

				if (this.menu) {
					this.menu.unload();
					this.menu = null;
				}

				this._isOpen = false;
				window.removeEventListener("keydown", this.closeEsc);
				clear(this);
				this.listitem.classList.remove("navmenu-item--preselected");
				this.animation
					.animateTo("closed", {
						force,
					})
					.then((state) => {
						if (state === "closed") {
							this.listitem.classList.remove("alternate-drop");
							this.link.setAttribute("aria-expanded", false);
							this.parentMenu.openSelectedBlock();
							this.details.removeAttribute("open");
						}
					});
			}

			unload() {
				this.forceClose();
				this.listitem.removeEventListener("mouseover", this.mouseover);
				this.listitem.removeEventListener("mouseout", this.mouseout);
				this.listitem.removeEventListener("touchend", this.touchend);
				this.listitem.removeEventListener("click", this.click);
				this.listitem.removeEventListener("focusin", this.focusin);
				window.removeEventListener("keydown", this.closeEsc);
				document.body.removeEventListener("click", this.bodyClose);
				document.body.removeEventListener("focusin", this.focusInClose);
				this.animation.unload();
			}
		} // CONCATENATED MODULE: ./source/scripts/components/navigation/NavDesktopMeganavParent.js
		// eslint-disable-line import/no-cycle

		// eslint-disable-line import/no-cycle

		class NavDesktopMeganavParent extends NavDesktopParent {
			constructor(el, options) {
				super(el, options);
				this.enableSubmenu =
					this.listitem.dataset.navmenuMeganavType === "meganav-sidenav";
			}

			get content() {
				return this.submenu.querySelector(".navmenu-meganav-wrapper");
			}

			get openHeight() {
				return this._openHeight;
			}

			get blockId() {
				return this.submenu.dataset.meganavId;
			}

			mouseout() {
				// This prevents the menu from closing on mouseout when it's selected in the TE
				if (!this.parentMenu.shouldBlockClose(this)) return;
				this.timer = setTimeout(this.close, 400);
			}

			_open() {
				let force =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: false;
				if (this._isOpen) return;
				this._isOpen = true;
				this.details.setAttribute("open", "open");
				window.addEventListener("keydown", this.closeEsc);

				if (this.enableSubmenu && !this.menu) {
					this.menu = new NavDesktopMenu(
						this.listitem.querySelector("[data-navmenu]")
					);
					this.menu.preselectFirstItem();
				} // Handles the special meganav to meganav transition behaviour, where
				// the drawer appears to stay open and transition from old to new height

				const resolveOpenMeganavs = new Promise((resolve) => {
					const { openMeganav } = this.parentMenu;

					if (openMeganav) {
						// Set height to start transitioning from: the open height of the previous meganav
						this.listitem.style.setProperty(
							"--menu-closed-height",
							`${openMeganav.openHeight}px`
						); // Inject old meganav ghost content

						const meganavGhostContent = openMeganav.content.cloneNode(true);
						const { width, left } = openMeganav.content.getBoundingClientRect();
						meganavGhostContent.classList.add("meganav-ghost"); // Set styles to absolutely position ghost content correctly

						meganavGhostContent.style.left = `${left}px`;
						meganavGhostContent.style.width = `${width}px`;
						this.submenu.appendChild(meganavGhostContent);
						dim(this); // Jump to ghost state

						this.animation
							.animateTo("ghost", {
								force: true,
							}) // Close other meganav
							.then(() => this.parentMenu.openMeganav.forceClose())
							.then(resolve);
					} else {
						// If no other meganavs are open we can start immediately.
						this.listitem.style.setProperty("--menu-closed-height", 0);
						dim(this);
						resolve();
					}
				});
				resolveOpenMeganavs
					.then(() => this.closeSiblings(this))
					.then(() =>
						this.animation.animateTo("open", {
							force,
							hold: !force,
							onStart: (_ref) => {
								let { el } = _ref;
								const wrapper = el.querySelector(".navmenu-meganav-wrapper");
								const maxHeight = parseInt(
									window.getComputedStyle(wrapper).maxHeight,
									10
								);
								const height = isFinite(maxHeight)
									? Math.min(wrapper.scrollHeight, maxHeight)
									: wrapper.scrollHeight;
								this.listitem.style.setProperty(
									"--menu-open-height",
									`${height}px`
								);
								this._openHeight = height;
							},
						})
					)
					.then(() => {
						this.link.setAttribute("aria-expanded", true);
						this.parentMenu.openMeganav = this; // Rapid mouse movement can sometimes cancel animation before ghost is removed,
						// so when things finally settle make sure we're removing all ghosts.

						this.submenu.querySelectorAll(".meganav-ghost").forEach((ghost) => {
							ghost.parentNode.removeChild(ghost);
						});
					});
			}

			_close() {
				let force =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: false;

				// You would expect to see something like this to avoid "double closing" menus,
				// but in practice it works more reliably to always run when the function is called,
				// to avoid out-of-sync situations.
				// if (!this._isOpen) return Promise.resolve();
				if (this.menu) {
					this.menu.unload();
					this.menu = null;
				}

				if (this.parentMenu.openMeganav === this) {
					this.parentMenu.openMeganav = null;
				}

				this._isOpen = false;
				window.removeEventListener("keydown", this.closeEsc);
				this.listitem.style.setProperty("--menu-closed-height", 0);
				clear(this);
				return this.animation
					.animateTo("closed", {
						force,
					})
					.then(() => {
						this.link.setAttribute("aria-expanded", false);
						this.parentMenu.openSelectedBlock();
					});
			}
		} // CONCATENATED MODULE: ./source/scripts/components/navigation/NavDesktopMenu.js
		// eslint-disable-line import/no-cycle

		// eslint-disable-line import/no-cycle

		class NavDesktopMenu {
			constructor(_ref) {
				let { children } = _ref;
				this.parents = [];
				this.children = children; // Meganav, if any, that is fully open (not animating).

				this._openMeganav = null; // Meganav, if any, that is selected for editing in the TE.

				this._selectedBlock = null;
				this._megaNavs = null;

				this.closeSiblings = (current) => {
					this.parents.forEach((parent) => {
						if (parent !== current) {
							parent.close();
						}
					});
				};

				for (let i = 0; i < this.children.length; i++) {
					const child = this.children[i];

					if (child.dataset.navmenuMeganavTrigger !== undefined) {
						this.parents.push(
							new NavDesktopMeganavParent(child, {
								parentMenu: this,
							})
						);
					} else if (child.dataset.navmenuParent !== undefined) {
						this.parents.push(
							new NavDesktopParent(child, {
								parentMenu: this,
							})
						);
					} else if (child.classList.contains("navmenu-item")) {
						child.addEventListener("focusin", this.closeSiblings);
					}
				}
			}

			get openMeganav() {
				return this._openMeganav;
			}

			set openMeganav(meganav) {
				this._openMeganav = meganav;
			}

			selectBlock(id) {
				// This is TE only, so only initialize the first time a block is selected
				if (!this._megaNavs) {
					this._megaNavs = {};
					this.parents
						.filter((parent) => parent instanceof NavDesktopMeganavParent)
						.forEach((megaNav) => {
							this._megaNavs[megaNav.blockId] = megaNav;
						});
				}

				const newSelectedBlock = this._megaNavs[id];
				if (this._selectedBlock === newSelectedBlock) return;

				if (this._selectedBlock) {
					this._selectedBlock.close();
				}

				this._selectedBlock = this._megaNavs[id]; // Force open give a better experience when changing settings.
				// Otherwise the selected block visibly closes and reopens after every
				// settings change.

				this._selectedBlock.forceOpen();
			}

			openSelectedBlock() {
				if (
					this._selectedBlock &&
					this.parents.filter((parent) => parent.isOpen).length === 0
				) {
					this._selectedBlock.open();
				}
			} // If a block is open and selected in the TE and no other blocks are open
			// we don't want to close it when we normally would.

			shouldBlockClose(block) {
				if (
					block === this._selectedBlock &&
					this.parents.filter((parent) => parent.isOpen).length === 1
				) {
					return false;
				}

				return true;
			}

			preselectFirstItem() {
				const firstParent = this.parents[0];
				if (!firstParent) return;

				if (firstParent.listitem === this.children[0]) {
					firstParent.listitem.classList.add("navmenu-item--preselected");
					firstParent.open();
				}
			}

			closeAllMenus() {
				this._selectedBlock = null;
				this.parents.forEach((parent) => parent.close());
			}

			unload() {
				this.parents.forEach((parent) => {
					parent.unload();
				});

				for (let i = 0; i < this.children.length; i++) {
					this.children[i].removeEventListener("focusin", this.closeSiblings);
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/components/search/SearchForm.js
		function sanitizeCategory(value) {
			return value.replace(/(tag|product_type):(searchfilter_)?/, "");
		}

		class SearchForm {
			constructor(container) {
				let options =
					arguments.length > 1 && arguments[1] !== undefined
						? arguments[1]
						: {};
				this.container = container;
				this.form = this.container.querySelector("[data-live-search-form]");
				this.filter = this.container.querySelector("[data-live-search-filter]");
				this.isLiveSearch = options.liveSearch ? options.liveSearch : false;

				this.setCategory =
					options.setCategory ||
					(() => {
						/* do nothing */
					});

				this.events = new EventHandler /* default */.Z();
				this.events.register(this.form, "submit", (e) => this.submitHandler(e));

				if (this.filter) {
					this.filterLabel = this.container.querySelector(
						"[data-live-search-filter-label]"
					); // page-search-form uses a hidden input to persist the filter, in which case
					// this.filter exists, but this.filterLabel does not.

					if (this.filterLabel) {
						this.setCategory(this.filterLabel.value);
						this.events.register(this.filter, "change", (e) => {
							const { value } = e.target;

							if (value) {
								const newValue = sanitizeCategory(value);
								this.filterLabel.innerHTML = newValue;
								this.setCategory(newValue);
								this.form.classList.add("live-search-filter-active");
							} else {
								this.filterLabel.innerHTML = e.target.dataset.filterAll;
								this.form.classList.remove("live-search-filter-active");
								this.setCategory("");
							}
						});
					}

					const hideFilterIfMobile = () => {
						if (Layout.isLessThanBreakpoint("S")) {
							this.filter.value = "";
							this.form.classList.remove("live-search-filter-active");

							if (this.filterLabel) {
								this.filterLabel.innerHTML = this.filter.dataset.filterAll;
							}
						}
					};

					hideFilterIfMobile();
					Layout.onBreakpointChange(() => hideFilterIfMobile());
				}
			}

			unload() {
				this.events.unregisterAll();
			}

			submitHandler(event) {
				event.preventDefault();
				const form = event.currentTarget.cloneNode(true);
				const termsInput = form.querySelector("[name=q]");
				form.style.position = "absolute";
				form.style.left = "-1000px";
				form.style.bottom = "-1000px";
				form.style.visibility = "hidden";
				let terms = termsInput.value;

				if (this.isLiveSearch && !terms) {
					return;
				} // Add field filter
				// Filter should always come before the input terms,
				// otherwise Shopify won't return the expected results.

				terms =
					this.filter && this.filter.value
						? `${this.filter.value} AND ${terms}`
						: terms; // Update value

				termsInput.value = terms; // Forms must be in the browser context in order to submit

				window.document.body.appendChild(form);
				form.submit();
			}
		} // CONCATENATED MODULE: ./source/scripts/components/search/LiveSearch.js
		class LiveSearch {
			constructor(els, settings) {
				this.$el = jquery_default()(els.el);
				this.$header = jquery_default()(els.header);
				this.closeEvents = new EventHandler /* default */.Z();
				this.closeEventRequestors = new Set();
				this.settings = settings;
				this.enableImages = this.settings.enable_images;
				this.mobileSearchBar = this.settings.show_mobile_search_bar;
				this.category = "";
				this.$input = this.$el.find("[data-live-search-input]");
				this.$button = this.$el.find("[data-live-search-submit]");
				this.$takeOverButton = this.$el.find(
					"[data-live-search-takeover-cancel]"
				);
				this.$filter = this.$el.find("[data-live-search-filter]");
				this.$flyDown = this.$el.find("[data-live-search-flydown]");
				this.$searchResults = this.$flyDown.find("[data-live-search-results]");
				this.$searchPlaceholder = this.$flyDown.find(
					"[data-live-search-placeholder]"
				);
				this.$quickLinks = this.$flyDown.find("[data-live-search-quick-links]");

				this._onClose = () => {};

				this.disableAnimations = "reduceAnimations" in document.body.dataset;
				this.animationFlyDown = transition({
					el: this.$flyDown.get(0),
					state: "closed",
				});
				this.animationSearchResults = transition({
					el: this.$searchResults.get(0),
					state: "closed",
				});
				this.animationTakeover = transition({
					el: this.$el[0],
					state: "closed",
				});

				if (this.$quickLinks.length) {
					this.animationQuickLinks = transition({
						el: this.$quickLinks.get(0),
						state: "closed",
					});
				}

				this.staticSearch = new SearchForm(this.$el[0], {
					liveSearch: true,
					setCategory: (category) => {
						this.category = category;
					},
				});
				this._search = this._search.bind(this);
				this._documentFocus = this._documentFocus.bind(this);

				this._closeEsc = (e) => {
					if (e.key === "Escape") {
						e.stopPropagation();

						this._closeFlyDown(true);

						this._closeTakeOver();
					}
				};

				this.events = [
					this.$input.on(
						"keyup.live-search",
						just_debounce_default()(this._search, 250)
					),
					this.$input.on("focus.live-search", (event) => {
						event.stopPropagation();

						this._onSearchFocus(event);
					}),
					this.$takeOverButton.on("click.live-search", (event) => {
						event.preventDefault();

						this._closeFlyDown(true);

						this._closeTakeOver();
					}),
					this.$filter.on("change.live-search", (event) => {
						const terms = this.$input.val();
						const hasTerms = terms.length > 0;
						if (!hasTerms) return;

						this._search(event);
					}),
					jquery_default()(window).on(
						"resize",
						just_debounce_default()(() => {
							// Only recalculate and open flydown if the flydown is already open.
							// This helps to prevent quick links from opening on resize.
							if (this._isFlydownOpen) this._openFlyDown();
						}, 250)
					),
				];
			}

			open() {
				// If is XS, pop the search out into a Takeover screen
				if (Layout.isLessThanBreakpoint("S")) {
					this._openTakeOver();
				}

				this._openFlyDown();

				this.$input.focus();
			}

			set onClose(onClose) {
				this._onClose = onClose;
			}

			unload() {
				this.events.forEach(($el) => $el.off(".live-search"));
				this.closeEvents.unregisterAll();
				this.closeEventRequestors.clear();

				if (this.settings.use_dimmer) {
					clear(this);
				}

				this.staticSearch.unload();
				ScrollLock.unlock();
			}

			get _terms() {
				return this.$input.val();
			}

			get _hasTerms() {
				return this._terms.trim().length > 0;
			}

			get _isFlydownOpen() {
				return this.$flyDown.attr("data-animation-state") === "open";
			}

			_onSearchFocus(event) {
				this.$el.addClass("live-search--focused"); // If is XS, pop the search out into a Takeover screen

				if (Layout.isLessThanBreakpoint("S")) {
					if (!this._hasTerms) return;

					this._openTakeOver();
				}

				this._search(event);
			}

			_search(event) {
				// Ignore non character key strokes
				const invalidKeyStrokes = [
					"Alt",
					"ArrowRight",
					"ArrowLeft",
					"ArrowUp",
					"ArrowDown",
					"Capslock",
					"Control",
					"Escape",
					"Meta",
					"Shift",
					"Tab",
					"Enter",
				];

				if (event.key && invalidKeyStrokes.indexOf(event.key) !== -1) {
					return;
				}

				let terms = this._terms; // If is XS, pop the search out into a Takeover screen

				if (Layout.isLessThanBreakpoint("S")) {
					this._openTakeOver();
				}

				this._toggleButton(this._hasTerms);

				if (this._hasTerms) {
					// Clear previous results
					this.$searchResults.html("");

					this._openFlyDown(true);

					const filter = this.$filter[0]; // Filter should always come before the input terms, otherwise Shopify won't
					// return the expected results. Explicitly use an `AND` so splitting in Liquid becomes easier.
					// https://help.shopify.com/en/manual/online-store/storefront-search#prefix-search

					terms =
						filter && filter.value ? `${filter.value} AND ${terms}` : terms;
					fetch(
						`${
							window.Theme.routes.predictive_search_url
						}?q=${encodeURIComponent(terms)}&section_id=predictive-search`
					)
						.then((response) => {
							if (!response.ok) {
								throw new Error(response.status);
							}

							return response.text();
						})
						.then((html) => {
							this.$searchResults.html(html);
							dist_index_es.watch(this.$searchResults[0]);

							this._openFlyDown();

							this._toggleButton(false);
						})
						.catch((error) => {
							throw error;
						});
				} else if (this.$quickLinks.length) {
					this._openFlyDown();
				} else {
					this._closeFlyDown(true);
				}
			}

			_searchError(response) {
				console.warn("Search had error");
				console.log(response.message, response.error, response.event);

				this._toggleButton(false);
			}
			/**
			 * Toggles search button while processing
			 *
			 * @param disable
			 * @private
			 */

			_toggleButton(disable) {
				if (disable) {
					this.$button.addClass("search-icon--processing").attr("disabled");
				} else {
					this.$button
						.removeClass("search-icon--processing")
						.removeAttr("disabled");
				}
			}

			_shouldOpenFlyDown() {
				let placeholder =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: false;
				if (placeholder) return true;
				const hasTerms = this.$input.val().length > 0;
				const hasNoResults =
					this.$searchResults.find("[data-live-search-no-products]").length > 0;
				const hasResults = this.$searchResults.children().length > 0;
				const hasQuickLinks = this.$quickLinks.length;
				return (
					(hasTerms && (hasResults || hasNoResults)) ||
					(!hasTerms && hasQuickLinks)
				);
			}

			_registerCloseEvents(requestor) {
				if (this.closeEventRequestors.size === 0) {
					this.closeEvents.register(window, "keydown", this._closeEsc);
					this.closeEvents.register(document, "focusin", this._documentFocus);
					this.closeEvents.register(
						document,
						"touchstart",
						this._documentFocus
					);
					this.closeEvents.register(document, "click", this._documentFocus);
				}

				this.closeEventRequestors.add(requestor);
			}

			_unregisterCloseEvents(requestor) {
				this.closeEventRequestors.delete(requestor);
				if (this.closeEventRequestors.size) return;
				this.closeEvents.unregisterAll();

				this._onClose();
			}

			_openFlyDown() {
				let placeholder =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: false;
				if (!this._shouldOpenFlyDown(placeholder)) return;

				const resize = (_ref) => {
					let { el } = _ref;
					// When this function is called, element is `display: block; height: 0;`
					// but the wrapper's scrollHeight is the height we want to transition to
					const container = el.querySelector(":scope > .visible");
					const scrollHeight = container ? container.scrollHeight : 0;
					el.style.setProperty("--open-height", `${scrollHeight}px`); // Ensure the flydown height doesn't exceed the viewport/body

					const viewportHeight = el.closest("[data-site-header]")
						? document.documentElement.clientHeight
						: document.documentElement.scrollHeight;
					const topPos =
						container.getBoundingClientRect().top +
						(el.closest("[data-site-header]") ? 0 : window.scrollY);
					const offset = 30;
					const maxHeight = viewportHeight - topPos - offset;
					el.style.setProperty("--flydown-max-height", `${maxHeight}px`);
				};

				this._updateFlyDown(placeholder);

				if (!this.$flyDown.data("is-open")) {
					this._registerCloseEvents("flydown");

					if (this.settings.use_dimmer) {
						dim(this);
					}

					this.$flyDown.data("is-open", true);
					this.animationFlyDown
						.animateTo("open", {
							force: this.disableAnimations,
							onStart: resize,
						})
						.then(() => this.$el.addClass("live-search--active"));
				} else {
					resize({
						el: this.$flyDown.get(0),
					});
				}
			}

			_updateFlyDown() {
				let placeholder =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: false;
				const hasTerms = this.$input.val().length > 0;
				const hasNoResults =
					this.$searchResults.find("[data-live-search-no-products]").length > 0;
				const hasResults = this.$searchResults.children().length > 0;
				const hasQuickLinks = this.$quickLinks.length;

				if (placeholder) {
					this.$searchResults.removeClass("visible");
					this.$quickLinks.removeClass("visible");
					this.$searchPlaceholder.addClass("visible");

					if (this.animationQuickLinks) {
						this.animationQuickLinks.animateTo("hidden", {
							force: this.disableAnimations,
						});
					}

					this.animationSearchResults.animateTo("hidden", {
						force: this.disableAnimations,
					});
				} else if (hasTerms && (hasNoResults || hasResults)) {
					this.$searchPlaceholder.removeClass("visible");
					this.$quickLinks.removeClass("visible");
					this.$searchResults.addClass("visible");

					if (this.animationQuickLinks) {
						this.animationQuickLinks.animateTo("hidden", {
							force: this.disableAnimations,
						});
					}

					this.animationSearchResults.animateTo("visible", {
						force: this.disableAnimations,
					});
				} else if (hasQuickLinks) {
					this.$searchPlaceholder.removeClass("visible");
					this.$searchResults.removeClass("visible");
					this.$quickLinks.addClass("visible");
					this.animationSearchResults.animateTo("hidden", {
						force: this.disableAnimations,
					});
					this.animationQuickLinks.animateTo("visible", {
						force: this.disableAnimations,
					});
				}
			}
			/**
			 * Close the FlyDown when no longer needed
			 *  - Keep focus styling if input is still being interacted with
			 *
			 * @param retainFocus
			 * @private
			 */

			_closeFlyDown() {
				let retainFocus =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: false;

				if (!this.$flyDown.data("is-open")) {
					return;
				}

				this._unregisterCloseEvents("flydown");

				clear(this);
				this.$flyDown.data("is-open", false);
				this.$searchPlaceholder.removeClass("visible");
				this.$quickLinks.removeClass("visible");
				this.$searchResults.removeClass("visible");

				if (this.animationQuickLinks) {
					this.animationQuickLinks.animateTo("closed", {
						force: this.disableAnimations,
					});
				}

				this.animationSearchResults.animateTo("closed", {
					force: this.disableAnimations,
				});
				this.animationFlyDown
					.animateTo("closed", {
						force: this.disableAnimations,
						onStart: (_ref2) => {
							let { el } = _ref2;
							return el.style.setProperty("--open-height", "0");
						},
					})
					.then(() => {
						this.$el.removeClass("live-search--active");

						if (!retainFocus) {
							this.$el.removeClass("live-search--focused");
						}
					});
			}

			_openTakeOver() {
				if (this.animationTakeover.state === "open") return;

				if (this.$header.hasClass("search--section")) {
					document.body.classList.add("search-takeover-active");
				}

				ScrollLock.lock(this.$el[0]);
				this.$el.addClass("live-search--takeover");
				document.body.classList.add("mobile-search-takeover-active");

				this._registerCloseEvents("takeover");

				if (this.settings.use_dimmer) {
					dim(this);
				}

				if (this.mobileSearchBar) {
					// "Expand out" style
					const el = this.$el[0];
					const { top, right, left, width } = el.getBoundingClientRect();
					el.style.setProperty(
						"--live-search-takeover-initial-top",
						`${top}px`
					);
					el.style.setProperty(
						"--live-search-takeover-initial-right",
						`${window.innerWidth - right}px`
					);
					el.style.setProperty(
						"--live-search-takeover-initial-left",
						`${left}px`
					);
					el.style.setProperty(
						"--live-search-takeover-initial-width",
						`${width}px`
					);
					el.parentNode.style.height = `${
						el.parentNode.getBoundingClientRect().height
					}px`;
					this.animationTakeover.animateTo("open", {
						force: this.disableAnimations,
					});
				} else {
					// "Slide up" style
					this.animationTakeover.animateTo("open", {
						force: this.disableAnimations,
						hold: true,
					});
				}
			}

			_closeTakeOver() {
				if (this.animationTakeover.state === "closed") return;

				this._unregisterCloseEvents("takeover");

				if (this.settings.use_dimmer) {
					clear(this);
				}

				this.animationTakeover
					.animateTo("closed", {
						force: this.disableAnimations,
					})
					.then(() => {
						ScrollLock.unlock();
						document.body.classList.remove("search-takeover-active");
						document.body.classList.remove("mobile-search-takeover-active");
						this.$el.removeClass("live-search--takeover");

						if (this.mobileSearchBar) {
							this.$el[0].parentNode.style.height = "";
						}
					});
			}
			/**
			 * When the focus element has changed, either by clicking, touching, or tabbing
			 * check to see if it is within the flydown
			 *
			 * @param event
			 * @private
			 */

			_documentFocus(event) {
				const $closest = jquery_default()(event.target).closest(
					"[data-live-search]"
				);

				if ($closest[0] === this.$el[0]) {
					return;
				}

				this._closeFlyDown();

				this._closeTakeOver();
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/StaticHeader.js
		class StaticHeader {
			constructor(section) {
				this.el = section.el;
				this.settings = section.data.settings;
				this.postMessage = section.postMessage;
				this.headerSearch = null;
				this.scripts = document.querySelector("[data-scripts]");
				this.menuToggle = this.el.querySelector("[data-menu-toggle]");
				this.cartCount = this.el.querySelector("[data-header-cart-count]");
				this.searchField = this.el.querySelector("[data-live-search]");
				this.siteNavigation = this.el.querySelector("[data-site-navigation]");
				this.desktopNavigation =
					this.siteNavigation.querySelector("ul.navmenu-depth-1");
				this.headerTools = this.siteNavigation.querySelector(
					"[data-header-actions]"
				);
				this.stickyHeader = new StickyHeader(
					{
						header: this.el,
						menuToggle: this.menuToggle,
						postMessage: this.postMessage,
					},
					this.settings
				);
				this.navMobile = new NavMobile({
					el: this.el,
					toggleOpen: this.menuToggle,
				});
				this.navDesktop = new NavDesktopMenu(
					document.querySelector(".site-navigation > [data-navmenu]")
				);
				this.forms = new Forms(this.el);
				this.events = new EventHandler /* default */.Z();

				if (this.settings.live_search.enable) {
					script_default()(this.scripts.dataset.shopifyApiUrl, () => {
						this.headerSearch = new LiveSearch(
							{
								el: this.searchField,
								header: this.el,
							},
							{
								...this.settings.live_search,
								use_dimmer: true,
							}
						);
						this.mobileSearchButtonEl = section.el.querySelector(
							"[data-mobile-search-button]"
						);

						if (this.mobileSearchButtonEl) {
							const disableAnimations =
								"reduceAnimations" in document.body.dataset;
							this.mobileSearchButtonAnimation = transition({
								el: this.mobileSearchButtonEl,
								state: "visible",
							});
							this.events.register(this.mobileSearchButtonEl, "click", (e) => {
								e.stopPropagation();
								this.headerSearch.open();
								this.mobileSearchButtonAnimation.animateTo("hidden", {
									force: disableAnimations,
								});
							});

							this.headerSearch.onClose = () => {
								this.mobileSearchButtonAnimation.animateTo("visible", {
									force: disableAnimations,
								});
								this.mobileSearchButtonEl.focus();
							};
						}
					});
				} else {
					this.headerSearch = new SearchForm(this.searchField);
				}

				this.events.register(window, "cartcount:update", (event) => {
					this.cartCount.dataset.headerCartCount = event.detail.item_count;

					if (event.detail.item_count > 0) {
						this.cartCount.classList.add("visible");
					} else {
						this.cartCount.classList.remove("visible");
					}
				});
			}

			onSectionSelect() {
				this.stickyHeader.openNavigation();
			}

			onSectionDeselect() {
				this._closeAllNavigation();
			}

			onSectionUnload() {
				this.stickyHeader.unload();
				this.navMobile.unload();
				this.navDesktop.unload();
				this.forms.unload();
				this.headerSearch.unload();
				this.events.unregisterAll();
			}

			onSectionMessage(name, data) {
				if (name === "nav:close-all" && Layout.isGreaterThanBreakpoint("M")) {
					this._closeAllNavigation();
				}
				/*
          This event gets dispatched from StaticCollection.js > _fireEvent()
          It should fire when the collection page's utility bar becomes sticky
          the box-shadow on the header should be removed and placed on the
          utility bar instead.
        */

				if (name === "collection-page:collection-utils-sticky-change") {
					this._handleStickyChange(data);
				}
			}

			onSectionBlockSelect(block) {
				if (!Layout.isGreaterThanBreakpoint("M")) {
					return;
				}

				this.stickyHeader.openNavigation(() => {
					this.navDesktop.selectBlock(block.id);
				});
			}

			onSectionBlockDeselect() {
				this._closeAllNavigation();
			}

			_closeAllNavigation() {
				this.navDesktop.closeAllMenus();
			}
			/*
        Remove the box-shadow when the collection page's utility bar has become sticky.
        This only needs to happen if the sticky header is enabled and if the header
        background colour is the same as the body background colour. Otherwise, no box-shadow is shown.
      */

			_handleStickyChange(data) {
				if (!this.settings.sticky_header || !this.settings.has_box_shadow)
					return;
				const { stuck, target } = data;
				this.el.classList.toggle("site-header-wrapper--no-shadow", stuck);
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/StaticPassword.js
		class StaticPassword {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				this.modalForms = null;
				this.newsletterForm = null;
				this.modalContents = "[data-passwordentry]";
				this.$newsletterForm = this.$el.find("[data-password-newsletter]");
				this.modalOpen = this.onModalOpen.bind(this);
				this.modalClose = this.onModalClose.bind(this);
				this._openModal = this._openModal.bind(this);
				this.modal = new Modal({
					onOpen: this.modalOpen,
					onClose: this.modalClose,
				});

				if (this.$newsletterForm) {
					this.newsletterForm = new Forms(this.$newsletterForm);
				}

				this._checkForPasswordAttempt();

				this._bindEvents();
			}

			onSectionUnload() {
				this.$el.off(".static-password");

				if (this.newsletterForm) {
					this.newsletterForm.unload();
				}

				if (this.modalForms) {
					this.modalForms.unload();
				}
			}

			onModalOpen() {
				const $contents = jquery_default()("[data-passwordentry-contents]");
				this.modalForms = new Forms($contents);
			}

			onModalClose() {
				this.modalForms.unload();
				this.modalForms = null;
			}

			_bindEvents() {
				this.$el.on(
					"click.static-password",
					"[data-passwordentry-toggle]",
					this._openModal
				);
			}

			_openModal() {
				this.modal.open(this.modalContents, "passwordentry");
			}

			_checkForPasswordAttempt() {
				if (!jquery_default()("[data-passwordentry-errors]").length) {
					return;
				}

				this._openModal();
			}
		} // CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-complementary-products/dist/index.es.js
		/*!
		 * @pixelunion/pxs-complementary-products v3.5.3
		 * (c) 2022 Pixel Union
		 */

		function index_es_typeof(obj) {
			"@babel/helpers - typeof";

			return (
				(index_es_typeof =
					"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
						? function (obj) {
								return typeof obj;
						  }
						: function (obj) {
								return obj &&
									"function" == typeof Symbol &&
									obj.constructor === Symbol &&
									obj !== Symbol.prototype
									? "symbol"
									: typeof obj;
						  }),
				index_es_typeof(obj)
			);
		}

		function pxs_complementary_products_dist_index_es_classCallCheck(
			instance,
			Constructor
		) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function pxs_complementary_products_dist_index_es_defineProperties(
			target,
			props
		) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function pxs_complementary_products_dist_index_es_createClass(
			Constructor,
			protoProps,
			staticProps
		) {
			if (protoProps)
				pxs_complementary_products_dist_index_es_defineProperties(
					Constructor.prototype,
					protoProps
				);
			if (staticProps)
				pxs_complementary_products_dist_index_es_defineProperties(
					Constructor,
					staticProps
				);
			Object.defineProperty(Constructor, "prototype", {
				writable: false,
			});
			return Constructor;
		}

		var commonjsGlobal =
			typeof globalThis !== "undefined"
				? globalThis
				: typeof window !== "undefined"
				? window
				: typeof __webpack_require__.g !== "undefined"
				? __webpack_require__.g
				: typeof self !== "undefined"
				? self
				: {};

		function index_es_unwrapExports(x) {
			return x &&
				x.__esModule &&
				Object.prototype.hasOwnProperty.call(x, "default")
				? x["default"]
				: x;
		}

		function dist_index_es_createCommonjsModule(fn, module) {
			return (
				(module = { exports: {} }), fn(module, module.exports), module.exports
			);
		}

		var dist_index_es_EventHandler_1 = dist_index_es_createCommonjsModule(
			function (module, exports) {
				exports.__esModule = true;
				var EventHandler = /** @class */ (function () {
					function EventHandler() {
						this.events = [];
					}
					EventHandler.prototype.register = function (el, event, listener) {
						if (!el || !event || !listener) return null;
						this.events.push({ el: el, event: event, listener: listener });
						el.addEventListener(event, listener);
						return { el: el, event: event, listener: listener };
					};
					EventHandler.prototype.unregister = function (_a) {
						var el = _a.el,
							event = _a.event,
							listener = _a.listener;
						if (!el || !event || !listener) return null;
						this.events = this.events.filter(function (e) {
							return (
								el !== e.el || event !== e.event || listener !== e.listener
							);
						});
						el.removeEventListener(event, listener);
						return { el: el, event: event, listener: listener };
					};
					EventHandler.prototype.unregisterAll = function () {
						this.events.forEach(function (_a) {
							var el = _a.el,
								event = _a.event,
								listener = _a.listener;
							return el.removeEventListener(event, listener);
						});
						this.events = [];
					};
					return EventHandler;
				})();
				exports["default"] = EventHandler;
			}
		);

		var dist_index_es_EventHandler = index_es_unwrapExports(
			dist_index_es_EventHandler_1
		);

		/*!
		 * @pixelunion/shopify-asyncview v2.0.5
		 * (c) 2020 Pixel Union
		 */

		function _classCallCheck$1(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function _defineProperties$1(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function _createClass$1(Constructor, protoProps, staticProps) {
			if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
			if (staticProps) _defineProperties$1(Constructor, staticProps);
			return Constructor;
		}

		function index_es_defineProperty(obj, key, value) {
			if (key in obj) {
				Object.defineProperty(obj, key, {
					value: value,
					enumerable: true,
					configurable: true,
					writable: true,
				});
			} else {
				obj[key] = value;
			}

			return obj;
		}

		function index_es_ownKeys(object, enumerableOnly) {
			var keys = Object.keys(object);

			if (Object.getOwnPropertySymbols) {
				var symbols = Object.getOwnPropertySymbols(object);
				if (enumerableOnly)
					symbols = symbols.filter(function (sym) {
						return Object.getOwnPropertyDescriptor(object, sym).enumerable;
					});
				keys.push.apply(keys, symbols);
			}

			return keys;
		}

		function index_es_objectSpread2(target) {
			for (var i = 1; i < arguments.length; i++) {
				var source = arguments[i] != null ? arguments[i] : {};

				if (i % 2) {
					index_es_ownKeys(Object(source), true).forEach(function (key) {
						index_es_defineProperty(target, key, source[key]);
					});
				} else if (Object.getOwnPropertyDescriptors) {
					Object.defineProperties(
						target,
						Object.getOwnPropertyDescriptors(source)
					);
				} else {
					index_es_ownKeys(Object(source)).forEach(function (key) {
						Object.defineProperty(
							target,
							key,
							Object.getOwnPropertyDescriptor(source, key)
						);
					});
				}
			}

			return target;
		}

		function index_es_slicedToArray(arr, i) {
			return (
				index_es_arrayWithHoles(arr) ||
				index_es_iterableToArrayLimit(arr, i) ||
				dist_index_es_unsupportedIterableToArray(arr, i) ||
				index_es_nonIterableRest()
			);
		}

		function index_es_arrayWithHoles(arr) {
			if (Array.isArray(arr)) return arr;
		}

		function index_es_iterableToArrayLimit(arr, i) {
			if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr)))
				return;
			var _arr = [];
			var _n = true;
			var _d = false;
			var _e = undefined;

			try {
				for (
					var _i = arr[Symbol.iterator](), _s;
					!(_n = (_s = _i.next()).done);
					_n = true
				) {
					_arr.push(_s.value);

					if (i && _arr.length === i) break;
				}
			} catch (err) {
				_d = true;
				_e = err;
			} finally {
				try {
					if (!_n && _i["return"] != null) _i["return"]();
				} finally {
					if (_d) throw _e;
				}
			}

			return _arr;
		}

		function dist_index_es_unsupportedIterableToArray(o, minLen) {
			if (!o) return;
			if (typeof o === "string")
				return dist_index_es_arrayLikeToArray(o, minLen);
			var n = Object.prototype.toString.call(o).slice(8, -1);
			if (n === "Object" && o.constructor) n = o.constructor.name;
			if (n === "Map" || n === "Set") return Array.from(n);
			if (
				n === "Arguments" ||
				/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
			)
				return dist_index_es_arrayLikeToArray(o, minLen);
		}

		function dist_index_es_arrayLikeToArray(arr, len) {
			if (len == null || len > arr.length) len = arr.length;

			for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

			return arr2;
		}

		function index_es_nonIterableRest() {
			throw new TypeError(
				"Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
			);
		}

		var index_es_deferred = {};

		var index_es_AsyncView = /*#__PURE__*/ (function () {
			function AsyncView() {
				_classCallCheck$1(this, AsyncView);
			}

			_createClass$1(AsyncView, null, [
				{
					key: "load",

					/**
					 * Load the template given by the provided URL into the provided
					 * view
					 *
					 * @param {string} url - The url to load
					 * @param {object} query - An object containing additional query parameters of the URL
					 * @param {string} query.view - A required query parameter indicating which view to load
					 * @param {object} [options] - Config options
					 * @param {string} [options.hash] - A hash of the current page content
					 */
					value: function load(url) {
						var query =
							arguments.length > 1 && arguments[1] !== undefined
								? arguments[1]
								: {};
						var options =
							arguments.length > 2 && arguments[2] !== undefined
								? arguments[2]
								: {};

						if (!("view" in query)) {
							return Promise.reject(
								new Error("'view' not found in 'query' parameter")
							);
						}

						var querylessUrl = url.replace(/\?[^#]+/, "");
						var queryParamsString = new RegExp(/.+\?([^#]+)/).exec(url);
						var queryParams = query;

						if (queryParamsString && queryParamsString.length >= 2) {
							queryParamsString[1].split("&").forEach(function (param) {
								var _param$split = param.split("="),
									_param$split2 = index_es_slicedToArray(_param$split, 2),
									key = _param$split2[0],
									value = _param$split2[1];

								queryParams[key] = value;
							});
						} // NOTE: We're adding an additional timestamp to the query.
						// This is to prevent certain browsers from returning cached
						// versions of the url we are requesting.
						// See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4

						var cachebustingParams = index_es_objectSpread2({}, queryParams, {
							_: new Date().getTime(),
						});

						var hashUrl = querylessUrl.replace(
							/([^#]+)(.*)/,
							function (match, address, hash) {
								return ""
									.concat(address, "?")
									.concat(
										Object.keys(queryParams)
											.sort()
											.map(function (key) {
												return ""
													.concat(key, "=")
													.concat(encodeURIComponent(queryParams[key]));
											})
											.join("&")
									)
									.concat(hash);
							}
						);
						var requestUrl = querylessUrl.replace(
							/([^#]+)(.*)/,
							function (match, address, hash) {
								return ""
									.concat(address, "?")
									.concat(
										Object.keys(cachebustingParams)
											.sort()
											.map(function (key) {
												return ""
													.concat(key, "=")
													.concat(encodeURIComponent(cachebustingParams[key]));
											})
											.join("&")
									)
									.concat(hash);
							}
						);
						var promise = new Promise(function (resolve, reject) {
							var data;

							if (hashUrl in index_es_deferred) {
								resolve(index_es_deferred[hashUrl]);
								return;
							}

							index_es_deferred[hashUrl] = promise;

							if (options.hash) {
								data = sessionStorage.getItem(hashUrl);

								if (data) {
									var deserialized = JSON.parse(data);

									if (options.hash === deserialized.options.hash) {
										delete index_es_deferred[hashUrl];
										resolve(deserialized);
										return;
									}
								}
							}

							var xhr = new XMLHttpRequest();
							xhr.open("GET", requestUrl, true);

							xhr.onload = function () {
								var el = xhr.response;
								var newOptions = {};
								var optionsEl = el.querySelector("[data-options]");

								if (optionsEl && optionsEl.innerHTML) {
									newOptions = JSON.parse(
										el.querySelector("[data-options]").innerHTML
									);
								}

								var htmlEls = el.querySelectorAll("[data-html]");
								var newHtml = {};

								if (
									htmlEls.length === 1 &&
									htmlEls[0].getAttribute("data-html") === ""
								) {
									newHtml = htmlEls[0].innerHTML;
								} else {
									for (var i = 0; i < htmlEls.length; i++) {
										newHtml[htmlEls[i].getAttribute("data-html")] =
											htmlEls[i].innerHTML;
									}
								}

								var dataEls = el.querySelectorAll("[data-data]");
								var newData = {};

								if (
									dataEls.length === 1 &&
									dataEls[0].getAttribute("data-data") === ""
								) {
									newData = JSON.parse(dataEls[0].innerHTML);
								} else {
									for (var _i = 0; _i < dataEls.length; _i++) {
										newData[dataEls[_i].getAttribute("data-data")] = JSON.parse(
											dataEls[_i].innerHTML
										);
									}
								}

								if (options.hash) {
									try {
										sessionStorage.setItem(
											hashUrl,
											JSON.stringify({
												options: newOptions,
												data: newData,
												html: newHtml,
											})
										);
									} catch (error) {
										console.error(error);
									}
								}

								delete index_es_deferred[hashUrl];
								resolve({
									data: newData,
									html: newHtml,
								});
							};

							xhr.onerror = function () {
								delete index_es_deferred[hashUrl];
								reject();
							};

							xhr.responseType = "document";
							xhr.send();
						});
						return promise;
					},
				},
			]);

			return AsyncView;
		})();

		var evEmitter = dist_index_es_createCommonjsModule(function (module) {
			/**
			 * EvEmitter v1.1.0
			 * Lil' event emitter
			 * MIT License
			 */

			/* jshint unused: true, undef: true, strict: true */

			(function (global, factory) {
				// universal module definition
				/* jshint strict: false */ /* globals define, module, window */ if (
					module.exports
				) {
					// CommonJS - Browserify, Webpack
					module.exports = factory();
				} else {
					// Browser globals
					global.EvEmitter = factory();
				}
			})(typeof window != "undefined" ? window : commonjsGlobal, function () {
				function EvEmitter() {}

				var proto = EvEmitter.prototype;

				proto.on = function (eventName, listener) {
					if (!eventName || !listener) {
						return;
					}
					// set events hash
					var events = (this._events = this._events || {});
					// set listeners array
					var listeners = (events[eventName] = events[eventName] || []);
					// only add once
					if (listeners.indexOf(listener) == -1) {
						listeners.push(listener);
					}

					return this;
				};

				proto.once = function (eventName, listener) {
					if (!eventName || !listener) {
						return;
					}
					// add event
					this.on(eventName, listener);
					// set once flag
					// set onceEvents hash
					var onceEvents = (this._onceEvents = this._onceEvents || {});
					// set onceListeners object
					var onceListeners = (onceEvents[eventName] =
						onceEvents[eventName] || {});
					// set flag
					onceListeners[listener] = true;

					return this;
				};

				proto.off = function (eventName, listener) {
					var listeners = this._events && this._events[eventName];
					if (!listeners || !listeners.length) {
						return;
					}
					var index = listeners.indexOf(listener);
					if (index != -1) {
						listeners.splice(index, 1);
					}

					return this;
				};

				proto.emitEvent = function (eventName, args) {
					var listeners = this._events && this._events[eventName];
					if (!listeners || !listeners.length) {
						return;
					}
					// copy over to avoid interference if .off() in listener
					listeners = listeners.slice(0);
					args = args || [];
					// once stuff
					var onceListeners = this._onceEvents && this._onceEvents[eventName];

					for (var i = 0; i < listeners.length; i++) {
						var listener = listeners[i];
						var isOnce = onceListeners && onceListeners[listener];
						if (isOnce) {
							// remove listener
							// remove before trigger to prevent recursion
							this.off(eventName, listener);
							// unset once flag
							delete onceListeners[listener];
						}
						// trigger listener
						listener.apply(this, args);
					}

					return this;
				};

				proto.allOff = function () {
					delete this._events;
					delete this._onceEvents;
				};

				return EvEmitter;
			});
		});

		var getSize = dist_index_es_createCommonjsModule(function (module) {
			/*!
			 * getSize v2.0.3
			 * measure size of elements
			 * MIT license
			 */

			/* jshint browser: true, strict: true, undef: true, unused: true */
			/* globals console: false */

			(function (window, factory) {
				/* jshint strict: false */ /* globals define, module */ if (
					module.exports
				) {
					// CommonJS
					module.exports = factory();
				} else {
					// browser global
					window.getSize = factory();
				}
			})(window, function factory() {
				// -------------------------- helpers -------------------------- //

				// get a number from a string, not a percentage
				function getStyleSize(value) {
					var num = parseFloat(value);
					// not a percent like '100%', and a number
					var isValid = value.indexOf("%") == -1 && !isNaN(num);
					return isValid && num;
				}

				function noop() {}

				var logError =
					typeof console == "undefined"
						? noop
						: function (message) {
								console.error(message);
						  };

				// -------------------------- measurements -------------------------- //

				var measurements = [
					"paddingLeft",
					"paddingRight",
					"paddingTop",
					"paddingBottom",
					"marginLeft",
					"marginRight",
					"marginTop",
					"marginBottom",
					"borderLeftWidth",
					"borderRightWidth",
					"borderTopWidth",
					"borderBottomWidth",
				];

				var measurementsLength = measurements.length;

				function getZeroSize() {
					var size = {
						width: 0,
						height: 0,
						innerWidth: 0,
						innerHeight: 0,
						outerWidth: 0,
						outerHeight: 0,
					};
					for (var i = 0; i < measurementsLength; i++) {
						var measurement = measurements[i];
						size[measurement] = 0;
					}
					return size;
				}

				// -------------------------- getStyle -------------------------- //

				/**
				 * getStyle, get style of element, check for Firefox bug
				 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
				 */
				function getStyle(elem) {
					var style = getComputedStyle(elem);
					if (!style) {
						logError(
							"Style returned " +
								style +
								". Are you running this code in a hidden iframe on Firefox? " +
								"See https://bit.ly/getsizebug1"
						);
					}
					return style;
				}

				// -------------------------- setup -------------------------- //

				var isSetup = false;

				var isBoxSizeOuter;

				/**
				 * setup
				 * check isBoxSizerOuter
				 * do on first getSize() rather than on page load for Firefox bug
				 */
				function setup() {
					// setup once
					if (isSetup) {
						return;
					}
					isSetup = true;

					// -------------------------- box sizing -------------------------- //

					/**
					 * Chrome & Safari measure the outer-width on style.width on border-box elems
					 * IE11 & Firefox<29 measures the inner-width
					 */
					var div = document.createElement("div");
					div.style.width = "200px";
					div.style.padding = "1px 2px 3px 4px";
					div.style.borderStyle = "solid";
					div.style.borderWidth = "1px 2px 3px 4px";
					div.style.boxSizing = "border-box";

					var body = document.body || document.documentElement;
					body.appendChild(div);
					var style = getStyle(div);
					// round value for browser zoom. desandro/masonry#928
					isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
					getSize.isBoxSizeOuter = isBoxSizeOuter;

					body.removeChild(div);
				}

				// -------------------------- getSize -------------------------- //

				function getSize(elem) {
					setup();

					// use querySeletor if elem is string
					if (typeof elem == "string") {
						elem = document.querySelector(elem);
					}

					// do not proceed on non-objects
					if (!elem || typeof elem != "object" || !elem.nodeType) {
						return;
					}

					var style = getStyle(elem);

					// if hidden, everything is 0
					if (style.display == "none") {
						return getZeroSize();
					}

					var size = {};
					size.width = elem.offsetWidth;
					size.height = elem.offsetHeight;

					var isBorderBox = (size.isBorderBox =
						style.boxSizing == "border-box");

					// get all measurements
					for (var i = 0; i < measurementsLength; i++) {
						var measurement = measurements[i];
						var value = style[measurement];
						var num = parseFloat(value);
						// any 'auto', 'medium' value will be 0
						size[measurement] = !isNaN(num) ? num : 0;
					}

					var paddingWidth = size.paddingLeft + size.paddingRight;
					var paddingHeight = size.paddingTop + size.paddingBottom;
					var marginWidth = size.marginLeft + size.marginRight;
					var marginHeight = size.marginTop + size.marginBottom;
					var borderWidth = size.borderLeftWidth + size.borderRightWidth;
					var borderHeight = size.borderTopWidth + size.borderBottomWidth;

					var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

					// overwrite width and height if we can get it from style
					var styleWidth = getStyleSize(style.width);
					if (styleWidth !== false) {
						size.width =
							styleWidth +
							// add padding and border unless it's already including it
							(isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
					}

					var styleHeight = getStyleSize(style.height);
					if (styleHeight !== false) {
						size.height =
							styleHeight +
							// add padding and border unless it's already including it
							(isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
					}

					size.innerWidth = size.width - (paddingWidth + borderWidth);
					size.innerHeight = size.height - (paddingHeight + borderHeight);

					size.outerWidth = size.width + marginWidth;
					size.outerHeight = size.height + marginHeight;

					return size;
				}

				return getSize;
			});
		});

		var matchesSelector = dist_index_es_createCommonjsModule(function (module) {
			/**
			 * matchesSelector v2.0.2
			 * matchesSelector( element, '.selector' )
			 * MIT license
			 */

			/*jshint browser: true, strict: true, undef: true, unused: true */

			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory();
				} else {
					// browser global
					window.matchesSelector = factory();
				}
			})(window, function factory() {
				var matchesMethod = (function () {
					var ElemProto = window.Element.prototype;
					// check for the standard method name first
					if (ElemProto.matches) {
						return "matches";
					}
					// check un-prefixed
					if (ElemProto.matchesSelector) {
						return "matchesSelector";
					}
					// check vendor prefixes
					var prefixes = ["webkit", "moz", "ms", "o"];

					for (var i = 0; i < prefixes.length; i++) {
						var prefix = prefixes[i];
						var method = prefix + "MatchesSelector";
						if (ElemProto[method]) {
							return method;
						}
					}
				})();

				return function matchesSelector(elem, selector) {
					return elem[matchesMethod](selector);
				};
			});
		});

		var utils = dist_index_es_createCommonjsModule(function (module) {
			/**
			 * Fizzy UI utils v2.0.7
			 * MIT license
			 */

			/*jshint browser: true, undef: true, unused: true, strict: true */

			(function (window, factory) {
				// universal module definition
				/*jshint strict: false */ /*globals define, module, require */ if (
					module.exports
				) {
					// CommonJS
					module.exports = factory(window, matchesSelector);
				} else {
					// browser global
					window.fizzyUIUtils = factory(window, window.matchesSelector);
				}
			})(window, function factory(window, matchesSelector) {
				var utils = {};

				// ----- extend ----- //

				// extends objects
				utils.extend = function (a, b) {
					for (var prop in b) {
						a[prop] = b[prop];
					}
					return a;
				};

				// ----- modulo ----- //

				utils.modulo = function (num, div) {
					return ((num % div) + div) % div;
				};

				// ----- makeArray ----- //

				var arraySlice = Array.prototype.slice;

				// turn element or nodeList into an array
				utils.makeArray = function (obj) {
					if (Array.isArray(obj)) {
						// use object if already an array
						return obj;
					}
					// return empty array if undefined or null. #6
					if (obj === null || obj === undefined) {
						return [];
					}

					var isArrayLike =
						typeof obj == "object" && typeof obj.length == "number";
					if (isArrayLike) {
						// convert nodeList to array
						return arraySlice.call(obj);
					}

					// array of single index
					return [obj];
				};

				// ----- removeFrom ----- //

				utils.removeFrom = function (ary, obj) {
					var index = ary.indexOf(obj);
					if (index != -1) {
						ary.splice(index, 1);
					}
				};

				// ----- getParent ----- //

				utils.getParent = function (elem, selector) {
					while (elem.parentNode && elem != document.body) {
						elem = elem.parentNode;
						if (matchesSelector(elem, selector)) {
							return elem;
						}
					}
				};

				// ----- getQueryElement ----- //

				// use element as selector string
				utils.getQueryElement = function (elem) {
					if (typeof elem == "string") {
						return document.querySelector(elem);
					}
					return elem;
				};

				// ----- handleEvent ----- //

				// enable .ontype to trigger from .addEventListener( elem, 'type' )
				utils.handleEvent = function (event) {
					var method = "on" + event.type;
					if (this[method]) {
						this[method](event);
					}
				};

				// ----- filterFindElements ----- //

				utils.filterFindElements = function (elems, selector) {
					// make array of elems
					elems = utils.makeArray(elems);
					var ffElems = [];

					elems.forEach(function (elem) {
						// check that elem is an actual element
						if (!(elem instanceof HTMLElement)) {
							return;
						}
						// add elem if no selector
						if (!selector) {
							ffElems.push(elem);
							return;
						}
						// filter & find items if we have a selector
						// filter
						if (matchesSelector(elem, selector)) {
							ffElems.push(elem);
						}
						// find children
						var childElems = elem.querySelectorAll(selector);
						// concat childElems to filterFound array
						for (var i = 0; i < childElems.length; i++) {
							ffElems.push(childElems[i]);
						}
					});

					return ffElems;
				};

				// ----- debounceMethod ----- //

				utils.debounceMethod = function (_class, methodName, threshold) {
					threshold = threshold || 100;
					// original method
					var method = _class.prototype[methodName];
					var timeoutName = methodName + "Timeout";

					_class.prototype[methodName] = function () {
						var timeout = this[timeoutName];
						clearTimeout(timeout);

						var args = arguments;
						var _this = this;
						this[timeoutName] = setTimeout(function () {
							method.apply(_this, args);
							delete _this[timeoutName];
						}, threshold);
					};
				};

				// ----- docReady ----- //

				utils.docReady = function (callback) {
					var readyState = document.readyState;
					if (readyState == "complete" || readyState == "interactive") {
						// do async to allow for other scripts to run. metafizzy/flickity#441
						setTimeout(callback);
					} else {
						document.addEventListener("DOMContentLoaded", callback);
					}
				};

				// ----- htmlInit ----- //

				// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
				utils.toDashed = function (str) {
					return str
						.replace(/(.)([A-Z])/g, function (match, $1, $2) {
							return $1 + "-" + $2;
						})
						.toLowerCase();
				};

				var console = window.console;
				/**
				 * allow user to initialize classes via [data-namespace] or .js-namespace class
				 * htmlInit( Widget, 'widgetName' )
				 * options are parsed from data-namespace-options
				 */
				utils.htmlInit = function (WidgetClass, namespace) {
					utils.docReady(function () {
						var dashedNamespace = utils.toDashed(namespace);
						var dataAttr = "data-" + dashedNamespace;
						var dataAttrElems = document.querySelectorAll("[" + dataAttr + "]");
						var jsDashElems = document.querySelectorAll(
							".js-" + dashedNamespace
						);
						var elems = utils
							.makeArray(dataAttrElems)
							.concat(utils.makeArray(jsDashElems));
						var dataOptionsAttr = dataAttr + "-options";
						var jQuery = window.jQuery;

						elems.forEach(function (elem) {
							var attr =
								elem.getAttribute(dataAttr) ||
								elem.getAttribute(dataOptionsAttr);
							var options;
							try {
								options = attr && JSON.parse(attr);
							} catch (error) {
								// log error, do not initialize
								if (console) {
									console.error(
										"Error parsing " +
											dataAttr +
											" on " +
											elem.className +
											": " +
											error
									);
								}
								return;
							}
							// initialize
							var instance = new WidgetClass(elem, options);
							// make available via $().data('namespace')
							if (jQuery) {
								jQuery.data(elem, namespace, instance);
							}
						});
					});
				};

				// -----  ----- //

				return utils;
			});
		});

		var cell = dist_index_es_createCommonjsModule(function (module) {
			// Flickity.Cell
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(window, getSize);
				} else {
					// browser global
					window.Flickity = window.Flickity || {};
					window.Flickity.Cell = factory(window, window.getSize);
				}
			})(window, function factory(window, getSize) {
				function Cell(elem, parent) {
					this.element = elem;
					this.parent = parent;

					this.create();
				}

				var proto = Cell.prototype;

				proto.create = function () {
					this.element.style.position = "absolute";
					this.element.setAttribute("aria-hidden", "true");
					this.x = 0;
					this.shift = 0;
					this.element.style[this.parent.originSide] = 0;
				};

				proto.destroy = function () {
					// reset style
					this.unselect();
					this.element.style.position = "";
					var side = this.parent.originSide;
					this.element.style[side] = "";
					this.element.style.transform = "";
					this.element.removeAttribute("aria-hidden");
				};

				proto.getSize = function () {
					this.size = getSize(this.element);
				};

				proto.setPosition = function (x) {
					this.x = x;
					this.updateTarget();
					this.renderPosition(x);
				};

				// setDefaultTarget v1 method, backwards compatibility, remove in v3
				proto.updateTarget = proto.setDefaultTarget = function () {
					var marginProperty =
						this.parent.originSide == "left" ? "marginLeft" : "marginRight";
					this.target =
						this.x +
						this.size[marginProperty] +
						this.size.width * this.parent.cellAlign;
				};

				proto.renderPosition = function (x) {
					// render position of cell with in slider
					var sideOffset = this.parent.originSide === "left" ? 1 : -1;

					var adjustedX = this.parent.options.percentPosition
						? x * sideOffset * (this.parent.size.innerWidth / this.size.width)
						: x * sideOffset;

					this.element.style.transform =
						"translateX(" + this.parent.getPositionValue(adjustedX) + ")";
				};

				proto.select = function () {
					this.element.classList.add("is-selected");
					this.element.removeAttribute("aria-hidden");
				};

				proto.unselect = function () {
					this.element.classList.remove("is-selected");
					this.element.setAttribute("aria-hidden", "true");
				};

				/**
				 * @param {Integer} shift - 0, 1, or -1
				 */
				proto.wrapShift = function (shift) {
					this.shift = shift;
					this.renderPosition(this.x + this.parent.slideableWidth * shift);
				};

				proto.remove = function () {
					this.element.parentNode.removeChild(this.element);
				};

				return Cell;
			});
		});

		var slide = dist_index_es_createCommonjsModule(function (module) {
			// slide
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory();
				} else {
					// browser global
					window.Flickity = window.Flickity || {};
					window.Flickity.Slide = factory();
				}
			})(window, function factory() {
				function Slide(parent) {
					this.parent = parent;
					this.isOriginLeft = parent.originSide == "left";
					this.cells = [];
					this.outerWidth = 0;
					this.height = 0;
				}

				var proto = Slide.prototype;

				proto.addCell = function (cell) {
					this.cells.push(cell);
					this.outerWidth += cell.size.outerWidth;
					this.height = Math.max(cell.size.outerHeight, this.height);
					// first cell stuff
					if (this.cells.length == 1) {
						this.x = cell.x; // x comes from first cell
						var beginMargin = this.isOriginLeft ? "marginLeft" : "marginRight";
						this.firstMargin = cell.size[beginMargin];
					}
				};

				proto.updateTarget = function () {
					var endMargin = this.isOriginLeft ? "marginRight" : "marginLeft";
					var lastCell = this.getLastCell();
					var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
					var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
					this.target =
						this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
				};

				proto.getLastCell = function () {
					return this.cells[this.cells.length - 1];
				};

				proto.select = function () {
					this.cells.forEach(function (cell) {
						cell.select();
					});
				};

				proto.unselect = function () {
					this.cells.forEach(function (cell) {
						cell.unselect();
					});
				};

				proto.getCellElements = function () {
					return this.cells.map(function (cell) {
						return cell.element;
					});
				};

				return Slide;
			});
		});

		var animate = dist_index_es_createCommonjsModule(function (module) {
			// animate
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(window, utils);
				} else {
					// browser global
					window.Flickity = window.Flickity || {};
					window.Flickity.animatePrototype = factory(
						window,
						window.fizzyUIUtils
					);
				}
			})(window, function factory(window, utils) {
				// -------------------------- animate -------------------------- //

				var proto = {};

				proto.startAnimation = function () {
					if (this.isAnimating) {
						return;
					}

					this.isAnimating = true;
					this.restingFrames = 0;
					this.animate();
				};

				proto.animate = function () {
					this.applyDragForce();
					this.applySelectedAttraction();

					var previousX = this.x;

					this.integratePhysics();
					this.positionSlider();
					this.settle(previousX);
					// animate next frame
					if (this.isAnimating) {
						var _this = this;
						requestAnimationFrame(function animateFrame() {
							_this.animate();
						});
					}
				};

				proto.positionSlider = function () {
					var x = this.x;
					// wrap position around
					if (this.options.wrapAround && this.cells.length > 1) {
						x = utils.modulo(x, this.slideableWidth);
						x -= this.slideableWidth;
						this.shiftWrapCells(x);
					}

					this.setTranslateX(x, this.isAnimating);
					this.dispatchScrollEvent();
				};

				proto.setTranslateX = function (x, is3d) {
					x += this.cursorPosition;
					// reverse if right-to-left and using transform
					x = this.options.rightToLeft ? -x : x;
					var translateX = this.getPositionValue(x);
					// use 3D transforms for hardware acceleration on iOS
					// but use 2D when settled, for better font-rendering
					this.slider.style.transform = is3d
						? "translate3d(" + translateX + ",0,0)"
						: "translateX(" + translateX + ")";
				};

				proto.dispatchScrollEvent = function () {
					var firstSlide = this.slides[0];
					if (!firstSlide) {
						return;
					}
					var positionX = -this.x - firstSlide.target;
					var progress = positionX / this.slidesWidth;
					this.dispatchEvent("scroll", null, [progress, positionX]);
				};

				proto.positionSliderAtSelected = function () {
					if (!this.cells.length) {
						return;
					}
					this.x = -this.selectedSlide.target;
					this.velocity = 0; // stop wobble
					this.positionSlider();
				};

				proto.getPositionValue = function (position) {
					if (this.options.percentPosition) {
						// percent position, round to 2 digits, like 12.34%
						return (
							Math.round((position / this.size.innerWidth) * 10000) * 0.01 + "%"
						);
					} else {
						// pixel positioning
						return Math.round(position) + "px";
					}
				};

				proto.settle = function (previousX) {
					// keep track of frames where x hasn't moved
					var isResting =
						!this.isPointerDown &&
						Math.round(this.x * 100) == Math.round(previousX * 100);
					if (isResting) {
						this.restingFrames++;
					}
					// stop animating if resting for 3 or more frames
					if (this.restingFrames > 2) {
						this.isAnimating = false;
						delete this.isFreeScrolling;
						// render position with translateX when settled
						this.positionSlider();
						this.dispatchEvent("settle", null, [this.selectedIndex]);
					}
				};

				proto.shiftWrapCells = function (x) {
					// shift before cells
					var beforeGap = this.cursorPosition + x;
					this._shiftCells(this.beforeShiftCells, beforeGap, -1);
					// shift after cells
					var afterGap =
						this.size.innerWidth -
						(x + this.slideableWidth + this.cursorPosition);
					this._shiftCells(this.afterShiftCells, afterGap, 1);
				};

				proto._shiftCells = function (cells, gap, shift) {
					for (var i = 0; i < cells.length; i++) {
						var cell = cells[i];
						var cellShift = gap > 0 ? shift : 0;
						cell.wrapShift(cellShift);
						gap -= cell.size.outerWidth;
					}
				};

				proto._unshiftCells = function (cells) {
					if (!cells || !cells.length) {
						return;
					}
					for (var i = 0; i < cells.length; i++) {
						cells[i].wrapShift(0);
					}
				};

				// -------------------------- physics -------------------------- //

				proto.integratePhysics = function () {
					this.x += this.velocity;
					this.velocity *= this.getFrictionFactor();
				};

				proto.applyForce = function (force) {
					this.velocity += force;
				};

				proto.getFrictionFactor = function () {
					return (
						1 -
						this.options[
							this.isFreeScrolling ? "freeScrollFriction" : "friction"
						]
					);
				};

				proto.getRestingPosition = function () {
					// my thanks to Steven Wittens, who simplified this math greatly
					return this.x + this.velocity / (1 - this.getFrictionFactor());
				};

				proto.applyDragForce = function () {
					if (!this.isDraggable || !this.isPointerDown) {
						return;
					}
					// change the position to drag position by applying force
					var dragVelocity = this.dragX - this.x;
					var dragForce = dragVelocity - this.velocity;
					this.applyForce(dragForce);
				};

				proto.applySelectedAttraction = function () {
					// do not attract if pointer down or no slides
					var dragDown = this.isDraggable && this.isPointerDown;
					if (dragDown || this.isFreeScrolling || !this.slides.length) {
						return;
					}
					var distance = this.selectedSlide.target * -1 - this.x;
					var force = distance * this.options.selectedAttraction;
					this.applyForce(force);
				};

				return proto;
			});
		});

		var flickity = dist_index_es_createCommonjsModule(function (module) {
			// Flickity main
			/* eslint-disable max-params */
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						evEmitter,
						getSize,
						utils,
						cell,
						slide,
						animate
					);
				} else {
					// browser global
					var _Flickity = window.Flickity;

					window.Flickity = factory(
						window,
						window.EvEmitter,
						window.getSize,
						window.fizzyUIUtils,
						_Flickity.Cell,
						_Flickity.Slide,
						_Flickity.animatePrototype
					);
				}
			})(
				window,
				function factory(
					window,
					EvEmitter,
					getSize,
					utils,
					Cell,
					Slide,
					animatePrototype
				) {
					// vars
					var jQuery = window.jQuery;
					var getComputedStyle = window.getComputedStyle;
					var console = window.console;

					function moveElements(elems, toElem) {
						elems = utils.makeArray(elems);
						while (elems.length) {
							toElem.appendChild(elems.shift());
						}
					}

					// -------------------------- Flickity -------------------------- //

					// globally unique identifiers
					var GUID = 0;
					// internal store of all Flickity intances
					var instances = {};

					function Flickity(element, options) {
						var queryElement = utils.getQueryElement(element);
						if (!queryElement) {
							if (console) {
								console.error(
									"Bad element for Flickity: " + (queryElement || element)
								);
							}
							return;
						}
						this.element = queryElement;
						// do not initialize twice on same element
						if (this.element.flickityGUID) {
							var instance = instances[this.element.flickityGUID];
							if (instance) instance.option(options);
							return instance;
						}

						// add jQuery
						if (jQuery) {
							this.$element = jQuery(this.element);
						}
						// options
						this.options = utils.extend({}, this.constructor.defaults);
						this.option(options);

						// kick things off
						this._create();
					}

					Flickity.defaults = {
						accessibility: true,
						// adaptiveHeight: false,
						cellAlign: "center",
						// cellSelector: undefined,
						// contain: false,
						freeScrollFriction: 0.075, // friction when free-scrolling
						friction: 0.28, // friction when selecting
						namespaceJQueryEvents: true,
						// initialIndex: 0,
						percentPosition: true,
						resize: true,
						selectedAttraction: 0.025,
						setGallerySize: true,
						// watchCSS: false,
						// wrapAround: false
					};

					// hash of methods triggered on _create()
					Flickity.createMethods = [];

					var proto = Flickity.prototype;
					// inherit EventEmitter
					utils.extend(proto, EvEmitter.prototype);

					proto._create = function () {
						// add id for Flickity.data
						var id = (this.guid = ++GUID);
						this.element.flickityGUID = id; // expando
						instances[id] = this; // associate via id
						// initial properties
						this.selectedIndex = 0;
						// how many frames slider has been in same position
						this.restingFrames = 0;
						// initial physics properties
						this.x = 0;
						this.velocity = 0;
						this.originSide = this.options.rightToLeft ? "right" : "left";
						// create viewport & slider
						this.viewport = document.createElement("div");
						this.viewport.className = "flickity-viewport";
						this._createSlider();

						if (this.options.resize || this.options.watchCSS) {
							window.addEventListener("resize", this);
						}

						// add listeners from on option
						for (var eventName in this.options.on) {
							var listener = this.options.on[eventName];
							this.on(eventName, listener);
						}

						Flickity.createMethods.forEach(function (method) {
							this[method]();
						}, this);

						if (this.options.watchCSS) {
							this.watchCSS();
						} else {
							this.activate();
						}
					};

					/**
					 * set options
					 * @param {Object} opts - options to extend
					 */
					proto.option = function (opts) {
						utils.extend(this.options, opts);
					};

					proto.activate = function () {
						if (this.isActive) {
							return;
						}
						this.isActive = true;
						this.element.classList.add("flickity-enabled");
						if (this.options.rightToLeft) {
							this.element.classList.add("flickity-rtl");
						}

						this.getSize();
						// move initial cell elements so they can be loaded as cells
						var cellElems = this._filterFindCellElements(this.element.children);
						moveElements(cellElems, this.slider);
						this.viewport.appendChild(this.slider);
						this.element.appendChild(this.viewport);
						// get cells from children
						this.reloadCells();

						if (this.options.accessibility) {
							// allow element to focusable
							this.element.tabIndex = 0;
							// listen for key presses
							this.element.addEventListener("keydown", this);
						}

						this.emitEvent("activate");
						this.selectInitialIndex();
						// flag for initial activation, for using initialIndex
						this.isInitActivated = true;
						// ready event. #493
						this.dispatchEvent("ready");
					};

					// slider positions the cells
					proto._createSlider = function () {
						// slider element does all the positioning
						var slider = document.createElement("div");
						slider.className = "flickity-slider";
						slider.style[this.originSide] = 0;
						this.slider = slider;
					};

					proto._filterFindCellElements = function (elems) {
						return utils.filterFindElements(elems, this.options.cellSelector);
					};

					// goes through all children
					proto.reloadCells = function () {
						// collection of item elements
						this.cells = this._makeCells(this.slider.children);
						this.positionCells();
						this._getWrapShiftCells();
						this.setGallerySize();
					};

					/**
					 * turn elements into Flickity.Cells
					 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
					 * @returns {Array} items - collection of new Flickity Cells
					 */
					proto._makeCells = function (elems) {
						var cellElems = this._filterFindCellElements(elems);

						// create new Flickity for collection
						var cells = cellElems.map(function (cellElem) {
							return new Cell(cellElem, this);
						}, this);

						return cells;
					};

					proto.getLastCell = function () {
						return this.cells[this.cells.length - 1];
					};

					proto.getLastSlide = function () {
						return this.slides[this.slides.length - 1];
					};

					// positions all cells
					proto.positionCells = function () {
						// size all cells
						this._sizeCells(this.cells);
						// position all cells
						this._positionCells(0);
					};

					/**
					 * position certain cells
					 * @param {Integer} index - which cell to start with
					 */
					proto._positionCells = function (index) {
						index = index || 0;
						// also measure maxCellHeight
						// start 0 if positioning all cells
						this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
						var cellX = 0;
						// get cellX
						if (index > 0) {
							var startCell = this.cells[index - 1];
							cellX = startCell.x + startCell.size.outerWidth;
						}
						var len = this.cells.length;
						for (var i = index; i < len; i++) {
							var cell = this.cells[i];
							cell.setPosition(cellX);
							cellX += cell.size.outerWidth;
							this.maxCellHeight = Math.max(
								cell.size.outerHeight,
								this.maxCellHeight
							);
						}
						// keep track of cellX for wrap-around
						this.slideableWidth = cellX;
						// slides
						this.updateSlides();
						// contain slides target
						this._containSlides();
						// update slidesWidth
						this.slidesWidth = len
							? this.getLastSlide().target - this.slides[0].target
							: 0;
					};

					/**
					 * cell.getSize() on multiple cells
					 * @param {Array} cells - cells to size
					 */
					proto._sizeCells = function (cells) {
						cells.forEach(function (cell) {
							cell.getSize();
						});
					};

					// --------------------------  -------------------------- //

					proto.updateSlides = function () {
						this.slides = [];
						if (!this.cells.length) {
							return;
						}

						var slide = new Slide(this);
						this.slides.push(slide);
						var isOriginLeft = this.originSide == "left";
						var nextMargin = isOriginLeft ? "marginRight" : "marginLeft";

						var canCellFit = this._getCanCellFit();

						this.cells.forEach(function (cell, i) {
							// just add cell if first cell in slide
							if (!slide.cells.length) {
								slide.addCell(cell);
								return;
							}

							var slideWidth =
								slide.outerWidth -
								slide.firstMargin +
								(cell.size.outerWidth - cell.size[nextMargin]);

							if (canCellFit.call(this, i, slideWidth)) {
								slide.addCell(cell);
							} else {
								// doesn't fit, new slide
								slide.updateTarget();

								slide = new Slide(this);
								this.slides.push(slide);
								slide.addCell(cell);
							}
						}, this);
						// last slide
						slide.updateTarget();
						// update .selectedSlide
						this.updateSelectedSlide();
					};

					proto._getCanCellFit = function () {
						var groupCells = this.options.groupCells;
						if (!groupCells) {
							return function () {
								return false;
							};
						} else if (typeof groupCells == "number") {
							// group by number. 3 -> [0,1,2], [3,4,5], ...
							var number = parseInt(groupCells, 10);
							return function (i) {
								return i % number !== 0;
							};
						}
						// default, group by width of slide
						// parse '75%
						var percentMatch =
							typeof groupCells == "string" && groupCells.match(/^(\d+)%$/);
						var percent = percentMatch
							? parseInt(percentMatch[1], 10) / 100
							: 1;
						return function (i, slideWidth) {
							/* eslint-disable-next-line no-invalid-this */
							return slideWidth <= (this.size.innerWidth + 1) * percent;
						};
					};

					// alias _init for jQuery plugin .flickity()
					proto._init = proto.reposition = function () {
						this.positionCells();
						this.positionSliderAtSelected();
					};

					proto.getSize = function () {
						this.size = getSize(this.element);
						this.setCellAlign();
						this.cursorPosition = this.size.innerWidth * this.cellAlign;
					};

					var cellAlignShorthands = {
						// cell align, then based on origin side
						center: {
							left: 0.5,
							right: 0.5,
						},
						left: {
							left: 0,
							right: 1,
						},
						right: {
							right: 0,
							left: 1,
						},
					};

					proto.setCellAlign = function () {
						var shorthand = cellAlignShorthands[this.options.cellAlign];
						this.cellAlign = shorthand
							? shorthand[this.originSide]
							: this.options.cellAlign;
					};

					proto.setGallerySize = function () {
						if (this.options.setGallerySize) {
							var height =
								this.options.adaptiveHeight && this.selectedSlide
									? this.selectedSlide.height
									: this.maxCellHeight;
							this.viewport.style.height = height + "px";
						}
					};

					proto._getWrapShiftCells = function () {
						// only for wrap-around
						if (!this.options.wrapAround) {
							return;
						}
						// unshift previous cells
						this._unshiftCells(this.beforeShiftCells);
						this._unshiftCells(this.afterShiftCells);
						// get before cells
						// initial gap
						var gapX = this.cursorPosition;
						var cellIndex = this.cells.length - 1;
						this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
						// get after cells
						// ending gap between last cell and end of gallery viewport
						gapX = this.size.innerWidth - this.cursorPosition;
						// start cloning at first cell, working forwards
						this.afterShiftCells = this._getGapCells(gapX, 0, 1);
					};

					proto._getGapCells = function (gapX, cellIndex, increment) {
						// keep adding cells until the cover the initial gap
						var cells = [];
						while (gapX > 0) {
							var cell = this.cells[cellIndex];
							if (!cell) {
								break;
							}
							cells.push(cell);
							cellIndex += increment;
							gapX -= cell.size.outerWidth;
						}
						return cells;
					};

					// ----- contain ----- //

					// contain cell targets so no excess sliding
					proto._containSlides = function () {
						if (
							!this.options.contain ||
							this.options.wrapAround ||
							!this.cells.length
						) {
							return;
						}
						var isRightToLeft = this.options.rightToLeft;
						var beginMargin = isRightToLeft ? "marginRight" : "marginLeft";
						var endMargin = isRightToLeft ? "marginLeft" : "marginRight";
						var contentWidth =
							this.slideableWidth - this.getLastCell().size[endMargin];
						// content is less than gallery size
						var isContentSmaller = contentWidth < this.size.innerWidth;
						// bounds
						var beginBound =
							this.cursorPosition + this.cells[0].size[beginMargin];
						var endBound =
							contentWidth - this.size.innerWidth * (1 - this.cellAlign);
						// contain each cell target
						this.slides.forEach(function (slide) {
							if (isContentSmaller) {
								// all cells fit inside gallery
								slide.target = contentWidth * this.cellAlign;
							} else {
								// contain to bounds
								slide.target = Math.max(slide.target, beginBound);
								slide.target = Math.min(slide.target, endBound);
							}
						}, this);
					};

					// -----  ----- //

					/**
					 * emits events via eventEmitter and jQuery events
					 * @param {String} type - name of event
					 * @param {Event} event - original event
					 * @param {Array} args - extra arguments
					 */
					proto.dispatchEvent = function (type, event, args) {
						var emitArgs = event ? [event].concat(args) : args;
						this.emitEvent(type, emitArgs);

						if (jQuery && this.$element) {
							// default trigger with type if no event
							type += this.options.namespaceJQueryEvents ? ".flickity" : "";
							var $event = type;
							if (event) {
								// create jQuery event
								var jQEvent = new jQuery.Event(event);
								jQEvent.type = type;
								$event = jQEvent;
							}
							this.$element.trigger($event, args);
						}
					};

					// -------------------------- select -------------------------- //

					/**
					 * @param {Integer} index - index of the slide
					 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
					 * @param {Boolean} isInstant - will immediately set position at selected cell
					 */
					proto.select = function (index, isWrap, isInstant) {
						if (!this.isActive) {
							return;
						}
						index = parseInt(index, 10);
						this._wrapSelect(index);

						if (this.options.wrapAround || isWrap) {
							index = utils.modulo(index, this.slides.length);
						}
						// bail if invalid index
						if (!this.slides[index]) {
							return;
						}
						var prevIndex = this.selectedIndex;
						this.selectedIndex = index;
						this.updateSelectedSlide();
						if (isInstant) {
							this.positionSliderAtSelected();
						} else {
							this.startAnimation();
						}
						if (this.options.adaptiveHeight) {
							this.setGallerySize();
						}
						// events
						this.dispatchEvent("select", null, [index]);
						// change event if new index
						if (index != prevIndex) {
							this.dispatchEvent("change", null, [index]);
						}
						// old v1 event name, remove in v3
						this.dispatchEvent("cellSelect");
					};

					// wraps position for wrapAround, to move to closest slide. #113
					proto._wrapSelect = function (index) {
						var len = this.slides.length;
						var isWrapping = this.options.wrapAround && len > 1;
						if (!isWrapping) {
							return index;
						}
						var wrapIndex = utils.modulo(index, len);
						// go to shortest
						var delta = Math.abs(wrapIndex - this.selectedIndex);
						var backWrapDelta = Math.abs(wrapIndex + len - this.selectedIndex);
						var forewardWrapDelta = Math.abs(
							wrapIndex - len - this.selectedIndex
						);
						if (!this.isDragSelect && backWrapDelta < delta) {
							index += len;
						} else if (!this.isDragSelect && forewardWrapDelta < delta) {
							index -= len;
						}
						// wrap position so slider is within normal area
						if (index < 0) {
							this.x -= this.slideableWidth;
						} else if (index >= len) {
							this.x += this.slideableWidth;
						}
					};

					proto.previous = function (isWrap, isInstant) {
						this.select(this.selectedIndex - 1, isWrap, isInstant);
					};

					proto.next = function (isWrap, isInstant) {
						this.select(this.selectedIndex + 1, isWrap, isInstant);
					};

					proto.updateSelectedSlide = function () {
						var slide = this.slides[this.selectedIndex];
						// selectedIndex could be outside of slides, if triggered before resize()
						if (!slide) {
							return;
						}
						// unselect previous selected slide
						this.unselectSelectedSlide();
						// update new selected slide
						this.selectedSlide = slide;
						slide.select();
						this.selectedCells = slide.cells;
						this.selectedElements = slide.getCellElements();
						// HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
						// Remove in v3?
						this.selectedCell = slide.cells[0];
						this.selectedElement = this.selectedElements[0];
					};

					proto.unselectSelectedSlide = function () {
						if (this.selectedSlide) {
							this.selectedSlide.unselect();
						}
					};

					proto.selectInitialIndex = function () {
						var initialIndex = this.options.initialIndex;
						// already activated, select previous selectedIndex
						if (this.isInitActivated) {
							this.select(this.selectedIndex, false, true);
							return;
						}
						// select with selector string
						if (initialIndex && typeof initialIndex == "string") {
							var cell = this.queryCell(initialIndex);
							if (cell) {
								this.selectCell(initialIndex, false, true);
								return;
							}
						}

						var index = 0;
						// select with number
						if (initialIndex && this.slides[initialIndex]) {
							index = initialIndex;
						}
						// select instantly
						this.select(index, false, true);
					};

					/**
					 * select slide from number or cell element
					 * @param {[Element, Number]} value - zero-based index or element to select
					 * @param {Boolean} isWrap - enables wrapping around for extra index
					 * @param {Boolean} isInstant - disables slide animation
					 */
					proto.selectCell = function (value, isWrap, isInstant) {
						// get cell
						var cell = this.queryCell(value);
						if (!cell) {
							return;
						}

						var index = this.getCellSlideIndex(cell);
						this.select(index, isWrap, isInstant);
					};

					proto.getCellSlideIndex = function (cell) {
						// get index of slides that has cell
						for (var i = 0; i < this.slides.length; i++) {
							var slide = this.slides[i];
							var index = slide.cells.indexOf(cell);
							if (index != -1) {
								return i;
							}
						}
					};

					// -------------------------- get cells -------------------------- //

					/**
					 * get Flickity.Cell, given an Element
					 * @param {Element} elem - matching cell element
					 * @returns {Flickity.Cell} cell - matching cell
					 */
					proto.getCell = function (elem) {
						// loop through cells to get the one that matches
						for (var i = 0; i < this.cells.length; i++) {
							var cell = this.cells[i];
							if (cell.element == elem) {
								return cell;
							}
						}
					};

					/**
					 * get collection of Flickity.Cells, given Elements
					 * @param {[Element, Array, NodeList]} elems - multiple elements
					 * @returns {Array} cells - Flickity.Cells
					 */
					proto.getCells = function (elems) {
						elems = utils.makeArray(elems);
						var cells = [];
						elems.forEach(function (elem) {
							var cell = this.getCell(elem);
							if (cell) {
								cells.push(cell);
							}
						}, this);
						return cells;
					};

					/**
					 * get cell elements
					 * @returns {Array} cellElems
					 */
					proto.getCellElements = function () {
						return this.cells.map(function (cell) {
							return cell.element;
						});
					};

					/**
					 * get parent cell from an element
					 * @param {Element} elem - child element
					 * @returns {Flickit.Cell} cell - parent cell
					 */
					proto.getParentCell = function (elem) {
						// first check if elem is cell
						var cell = this.getCell(elem);
						if (cell) {
							return cell;
						}
						// try to get parent cell elem
						elem = utils.getParent(elem, ".flickity-slider > *");
						return this.getCell(elem);
					};

					/**
					 * get cells adjacent to a slide
					 * @param {Integer} adjCount - number of adjacent slides
					 * @param {Integer} index - index of slide to start
					 * @returns {Array} cells - array of Flickity.Cells
					 */
					proto.getAdjacentCellElements = function (adjCount, index) {
						if (!adjCount) {
							return this.selectedSlide.getCellElements();
						}
						index = index === undefined ? this.selectedIndex : index;

						var len = this.slides.length;
						if (1 + adjCount * 2 >= len) {
							return this.getCellElements();
						}

						var cellElems = [];
						for (var i = index - adjCount; i <= index + adjCount; i++) {
							var slideIndex = this.options.wrapAround
								? utils.modulo(i, len)
								: i;
							var slide = this.slides[slideIndex];
							if (slide) {
								cellElems = cellElems.concat(slide.getCellElements());
							}
						}
						return cellElems;
					};

					/**
					 * select slide from number or cell element
					 * @param {[Element, String, Number]} selector - element, selector string, or index
					 * @returns {Flickity.Cell} - matching cell
					 */
					proto.queryCell = function (selector) {
						if (typeof selector == "number") {
							// use number as index
							return this.cells[selector];
						}
						if (typeof selector == "string") {
							// do not select invalid selectors from hash: #123, #/. #791
							if (selector.match(/^[#.]?[\d/]/)) {
								return;
							}
							// use string as selector, get element
							selector = this.element.querySelector(selector);
						}
						// get cell from element
						return this.getCell(selector);
					};

					// -------------------------- events -------------------------- //

					proto.uiChange = function () {
						this.emitEvent("uiChange");
					};

					// keep focus on element when child UI elements are clicked
					proto.childUIPointerDown = function (event) {
						// HACK iOS does not allow touch events to bubble up?!
						if (event.type != "touchstart") {
							event.preventDefault();
						}
						this.focus();
					};

					// ----- resize ----- //

					proto.onresize = function () {
						this.watchCSS();
						this.resize();
					};

					utils.debounceMethod(Flickity, "onresize", 150);

					proto.resize = function () {
						// #1177 disable resize behavior when animating or dragging for iOS 15
						if (!this.isActive || this.isAnimating || this.isDragging) {
							return;
						}
						this.getSize();
						// wrap values
						if (this.options.wrapAround) {
							this.x = utils.modulo(this.x, this.slideableWidth);
						}
						this.positionCells();
						this._getWrapShiftCells();
						this.setGallerySize();
						this.emitEvent("resize");
						// update selected index for group slides, instant
						// TODO: position can be lost between groups of various numbers
						var selectedElement =
							this.selectedElements && this.selectedElements[0];
						this.selectCell(selectedElement, false, true);
					};

					// watches the :after property, activates/deactivates
					proto.watchCSS = function () {
						var watchOption = this.options.watchCSS;
						if (!watchOption) {
							return;
						}

						var afterContent = getComputedStyle(this.element, ":after").content;
						// activate if :after { content: 'flickity' }
						if (afterContent.indexOf("flickity") != -1) {
							this.activate();
						} else {
							this.deactivate();
						}
					};

					// ----- keydown ----- //

					// go previous/next if left/right keys pressed
					proto.onkeydown = function (event) {
						// only work if element is in focus
						var isNotFocused =
							document.activeElement && document.activeElement != this.element;
						if (!this.options.accessibility || isNotFocused) {
							return;
						}

						var handler = Flickity.keyboardHandlers[event.keyCode];
						if (handler) {
							handler.call(this);
						}
					};

					Flickity.keyboardHandlers = {
						// left arrow
						37: function () {
							var leftMethod = this.options.rightToLeft ? "next" : "previous";
							this.uiChange();
							this[leftMethod]();
						},
						// right arrow
						39: function () {
							var rightMethod = this.options.rightToLeft ? "previous" : "next";
							this.uiChange();
							this[rightMethod]();
						},
					};

					// ----- focus ----- //

					proto.focus = function () {
						// TODO remove scrollTo once focus options gets more support
						// https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus ...
						//    #Browser_compatibility
						var prevScrollY = window.pageYOffset;
						this.element.focus({ preventScroll: true });
						// hack to fix scroll jump after focus, #76
						if (window.pageYOffset != prevScrollY) {
							window.scrollTo(window.pageXOffset, prevScrollY);
						}
					};

					// -------------------------- destroy -------------------------- //

					// deactivate all Flickity functionality, but keep stuff available
					proto.deactivate = function () {
						if (!this.isActive) {
							return;
						}
						this.element.classList.remove("flickity-enabled");
						this.element.classList.remove("flickity-rtl");
						this.unselectSelectedSlide();
						// destroy cells
						this.cells.forEach(function (cell) {
							cell.destroy();
						});
						this.element.removeChild(this.viewport);
						// move child elements back into element
						moveElements(this.slider.children, this.element);
						if (this.options.accessibility) {
							this.element.removeAttribute("tabIndex");
							this.element.removeEventListener("keydown", this);
						}
						// set flags
						this.isActive = false;
						this.emitEvent("deactivate");
					};

					proto.destroy = function () {
						this.deactivate();
						window.removeEventListener("resize", this);
						this.allOff();
						this.emitEvent("destroy");
						if (jQuery && this.$element) {
							jQuery.removeData(this.element, "flickity");
						}
						delete this.element.flickityGUID;
						delete instances[this.guid];
					};

					// -------------------------- prototype -------------------------- //

					utils.extend(proto, animatePrototype);

					// -------------------------- extras -------------------------- //

					/**
					 * get Flickity instance from element
					 * @param {[Element, String]} elem - element or selector string
					 * @returns {Flickity} - Flickity instance
					 */
					Flickity.data = function (elem) {
						elem = utils.getQueryElement(elem);
						var id = elem && elem.flickityGUID;
						return id && instances[id];
					};

					utils.htmlInit(Flickity, "flickity");

					if (jQuery && jQuery.bridget) {
						jQuery.bridget("flickity", Flickity);
					}

					// set internal jQuery, for Webpack + jQuery v3, #478
					Flickity.setJQuery = function (jq) {
						jQuery = jq;
					};

					Flickity.Cell = Cell;
					Flickity.Slide = Slide;

					return Flickity;
				}
			);
		});

		var unipointer = dist_index_es_createCommonjsModule(function (module) {
			/*!
			 * Unipointer v2.4.0
			 * base class for doing one thing with pointer event
			 * MIT license
			 */

			/*jshint browser: true, undef: true, unused: true, strict: true */

			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */ /*global define, module, require */ if (
					module.exports
				) {
					// CommonJS
					module.exports = factory(window, evEmitter);
				} else {
					// browser global
					window.Unipointer = factory(window, window.EvEmitter);
				}
			})(window, function factory(window, EvEmitter) {
				function noop() {}

				function Unipointer() {}

				// inherit EvEmitter
				var proto = (Unipointer.prototype = Object.create(EvEmitter.prototype));

				proto.bindStartEvent = function (elem) {
					this._bindStartEvent(elem, true);
				};

				proto.unbindStartEvent = function (elem) {
					this._bindStartEvent(elem, false);
				};

				/**
				 * Add or remove start event
				 * @param {Boolean} isAdd - remove if falsey
				 */
				proto._bindStartEvent = function (elem, isAdd) {
					// munge isAdd, default to true
					isAdd = isAdd === undefined ? true : isAdd;
					var bindMethod = isAdd ? "addEventListener" : "removeEventListener";

					// default to mouse events
					var startEvent = "mousedown";
					if ("ontouchstart" in window) {
						// HACK prefer Touch Events as you can preventDefault on touchstart to
						// disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
						startEvent = "touchstart";
					} else if (window.PointerEvent) {
						// Pointer Events
						startEvent = "pointerdown";
					}
					elem[bindMethod](startEvent, this);
				};

				// trigger handler methods for events
				proto.handleEvent = function (event) {
					var method = "on" + event.type;
					if (this[method]) {
						this[method](event);
					}
				};

				// returns the touch that we're keeping track of
				proto.getTouch = function (touches) {
					for (var i = 0; i < touches.length; i++) {
						var touch = touches[i];
						if (touch.identifier == this.pointerIdentifier) {
							return touch;
						}
					}
				};

				// ----- start event ----- //

				proto.onmousedown = function (event) {
					// dismiss clicks from right or middle buttons
					var button = event.button;
					if (button && button !== 0 && button !== 1) {
						return;
					}
					this._pointerDown(event, event);
				};

				proto.ontouchstart = function (event) {
					this._pointerDown(event, event.changedTouches[0]);
				};

				proto.onpointerdown = function (event) {
					this._pointerDown(event, event);
				};

				/**
				 * pointer start
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 */
				proto._pointerDown = function (event, pointer) {
					// dismiss right click and other pointers
					// button = 0 is okay, 1-4 not
					if (event.button || this.isPointerDown) {
						return;
					}

					this.isPointerDown = true;
					// save pointer identifier to match up touch events
					this.pointerIdentifier =
						pointer.pointerId !== undefined
							? // pointerId for pointer events, touch.indentifier for touch events
							  pointer.pointerId
							: pointer.identifier;

					this.pointerDown(event, pointer);
				};

				proto.pointerDown = function (event, pointer) {
					this._bindPostStartEvents(event);
					this.emitEvent("pointerDown", [event, pointer]);
				};

				// hash of events to be bound after start event
				var postStartEvents = {
					mousedown: ["mousemove", "mouseup"],
					touchstart: ["touchmove", "touchend", "touchcancel"],
					pointerdown: ["pointermove", "pointerup", "pointercancel"],
				};

				proto._bindPostStartEvents = function (event) {
					if (!event) {
						return;
					}
					// get proper events to match start event
					var events = postStartEvents[event.type];
					// bind events to node
					events.forEach(function (eventName) {
						window.addEventListener(eventName, this);
					}, this);
					// save these arguments
					this._boundPointerEvents = events;
				};

				proto._unbindPostStartEvents = function () {
					// check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
					if (!this._boundPointerEvents) {
						return;
					}
					this._boundPointerEvents.forEach(function (eventName) {
						window.removeEventListener(eventName, this);
					}, this);

					delete this._boundPointerEvents;
				};

				// ----- move event ----- //

				proto.onmousemove = function (event) {
					this._pointerMove(event, event);
				};

				proto.onpointermove = function (event) {
					if (event.pointerId == this.pointerIdentifier) {
						this._pointerMove(event, event);
					}
				};

				proto.ontouchmove = function (event) {
					var touch = this.getTouch(event.changedTouches);
					if (touch) {
						this._pointerMove(event, touch);
					}
				};

				/**
				 * pointer move
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 * @private
				 */
				proto._pointerMove = function (event, pointer) {
					this.pointerMove(event, pointer);
				};

				// public
				proto.pointerMove = function (event, pointer) {
					this.emitEvent("pointerMove", [event, pointer]);
				};

				// ----- end event ----- //

				proto.onmouseup = function (event) {
					this._pointerUp(event, event);
				};

				proto.onpointerup = function (event) {
					if (event.pointerId == this.pointerIdentifier) {
						this._pointerUp(event, event);
					}
				};

				proto.ontouchend = function (event) {
					var touch = this.getTouch(event.changedTouches);
					if (touch) {
						this._pointerUp(event, touch);
					}
				};

				/**
				 * pointer up
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 * @private
				 */
				proto._pointerUp = function (event, pointer) {
					this._pointerDone();
					this.pointerUp(event, pointer);
				};

				// public
				proto.pointerUp = function (event, pointer) {
					this.emitEvent("pointerUp", [event, pointer]);
				};

				// ----- pointer done ----- //

				// triggered on pointer up & pointer cancel
				proto._pointerDone = function () {
					this._pointerReset();
					this._unbindPostStartEvents();
					this.pointerDone();
				};

				proto._pointerReset = function () {
					// reset properties
					this.isPointerDown = false;
					delete this.pointerIdentifier;
				};

				proto.pointerDone = noop;

				// ----- pointer cancel ----- //

				proto.onpointercancel = function (event) {
					if (event.pointerId == this.pointerIdentifier) {
						this._pointerCancel(event, event);
					}
				};

				proto.ontouchcancel = function (event) {
					var touch = this.getTouch(event.changedTouches);
					if (touch) {
						this._pointerCancel(event, touch);
					}
				};

				/**
				 * pointer cancel
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 * @private
				 */
				proto._pointerCancel = function (event, pointer) {
					this._pointerDone();
					this.pointerCancel(event, pointer);
				};

				// public
				proto.pointerCancel = function (event, pointer) {
					this.emitEvent("pointerCancel", [event, pointer]);
				};

				// -----  ----- //

				// utility function for getting x/y coords from event
				Unipointer.getPointerPoint = function (pointer) {
					return {
						x: pointer.pageX,
						y: pointer.pageY,
					};
				};

				// -----  ----- //

				return Unipointer;
			});
		});

		var unidragger = dist_index_es_createCommonjsModule(function (module) {
			/*!
			 * Unidragger v2.4.0
			 * Draggable base class
			 * MIT license
			 */

			/*jshint browser: true, unused: true, undef: true, strict: true */

			(function (window, factory) {
				// universal module definition
				/*jshint strict: false */ /*globals define, module, require */ if (
					module.exports
				) {
					// CommonJS
					module.exports = factory(window, unipointer);
				} else {
					// browser global
					window.Unidragger = factory(window, window.Unipointer);
				}
			})(window, function factory(window, Unipointer) {
				// -------------------------- Unidragger -------------------------- //

				function Unidragger() {}

				// inherit Unipointer & EvEmitter
				var proto = (Unidragger.prototype = Object.create(
					Unipointer.prototype
				));

				// ----- bind start ----- //

				proto.bindHandles = function () {
					this._bindHandles(true);
				};

				proto.unbindHandles = function () {
					this._bindHandles(false);
				};

				/**
				 * Add or remove start event
				 * @param {Boolean} isAdd
				 */
				proto._bindHandles = function (isAdd) {
					// munge isAdd, default to true
					isAdd = isAdd === undefined ? true : isAdd;
					// bind each handle
					var bindMethod = isAdd ? "addEventListener" : "removeEventListener";
					var touchAction = isAdd ? this._touchActionValue : "";
					for (var i = 0; i < this.handles.length; i++) {
						var handle = this.handles[i];
						this._bindStartEvent(handle, isAdd);
						handle[bindMethod]("click", this);
						// touch-action: none to override browser touch gestures. metafizzy/flickity#540
						if (window.PointerEvent) {
							handle.style.touchAction = touchAction;
						}
					}
				};

				// prototype so it can be overwriteable by Flickity
				proto._touchActionValue = "none";

				// ----- start event ----- //

				/**
				 * pointer start
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 */
				proto.pointerDown = function (event, pointer) {
					var isOkay = this.okayPointerDown(event);
					if (!isOkay) {
						return;
					}
					// track start event position
					// Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
					this.pointerDownPointer = {
						pageX: pointer.pageX,
						pageY: pointer.pageY,
					};

					event.preventDefault();
					this.pointerDownBlur();
					// bind move and end events
					this._bindPostStartEvents(event);
					this.emitEvent("pointerDown", [event, pointer]);
				};

				// nodes that have text fields
				var cursorNodes = {
					TEXTAREA: true,
					INPUT: true,
					SELECT: true,
					OPTION: true,
				};

				// input types that do not have text fields
				var clickTypes = {
					radio: true,
					checkbox: true,
					button: true,
					submit: true,
					image: true,
					file: true,
				};

				// dismiss inputs with text fields. flickity#403, flickity#404
				proto.okayPointerDown = function (event) {
					var isCursorNode = cursorNodes[event.target.nodeName];
					var isClickType = clickTypes[event.target.type];
					var isOkay = !isCursorNode || isClickType;
					if (!isOkay) {
						this._pointerReset();
					}
					return isOkay;
				};

				// kludge to blur previously focused input
				proto.pointerDownBlur = function () {
					var focused = document.activeElement;
					// do not blur body for IE10, metafizzy/flickity#117
					var canBlur = focused && focused.blur && focused != document.body;
					if (canBlur) {
						focused.blur();
					}
				};

				// ----- move event ----- //

				/**
				 * drag move
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 */
				proto.pointerMove = function (event, pointer) {
					var moveVector = this._dragPointerMove(event, pointer);
					this.emitEvent("pointerMove", [event, pointer, moveVector]);
					this._dragMove(event, pointer, moveVector);
				};

				// base pointer move logic
				proto._dragPointerMove = function (event, pointer) {
					var moveVector = {
						x: pointer.pageX - this.pointerDownPointer.pageX,
						y: pointer.pageY - this.pointerDownPointer.pageY,
					};
					// start drag if pointer has moved far enough to start drag
					if (!this.isDragging && this.hasDragStarted(moveVector)) {
						this._dragStart(event, pointer);
					}
					return moveVector;
				};

				// condition if pointer has moved far enough to start drag
				proto.hasDragStarted = function (moveVector) {
					return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
				};

				// ----- end event ----- //

				/**
				 * pointer up
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 */
				proto.pointerUp = function (event, pointer) {
					this.emitEvent("pointerUp", [event, pointer]);
					this._dragPointerUp(event, pointer);
				};

				proto._dragPointerUp = function (event, pointer) {
					if (this.isDragging) {
						this._dragEnd(event, pointer);
					} else {
						// pointer didn't move enough for drag to start
						this._staticClick(event, pointer);
					}
				};

				// -------------------------- drag -------------------------- //

				// dragStart
				proto._dragStart = function (event, pointer) {
					this.isDragging = true;
					// prevent clicks
					this.isPreventingClicks = true;
					this.dragStart(event, pointer);
				};

				proto.dragStart = function (event, pointer) {
					this.emitEvent("dragStart", [event, pointer]);
				};

				// dragMove
				proto._dragMove = function (event, pointer, moveVector) {
					// do not drag if not dragging yet
					if (!this.isDragging) {
						return;
					}

					this.dragMove(event, pointer, moveVector);
				};

				proto.dragMove = function (event, pointer, moveVector) {
					event.preventDefault();
					this.emitEvent("dragMove", [event, pointer, moveVector]);
				};

				// dragEnd
				proto._dragEnd = function (event, pointer) {
					// set flags
					this.isDragging = false;
					// re-enable clicking async
					setTimeout(
						function () {
							delete this.isPreventingClicks;
						}.bind(this)
					);

					this.dragEnd(event, pointer);
				};

				proto.dragEnd = function (event, pointer) {
					this.emitEvent("dragEnd", [event, pointer]);
				};

				// ----- onclick ----- //

				// handle all clicks and prevent clicks when dragging
				proto.onclick = function (event) {
					if (this.isPreventingClicks) {
						event.preventDefault();
					}
				};

				// ----- staticClick ----- //

				// triggered after pointer down & up with no/tiny movement
				proto._staticClick = function (event, pointer) {
					// ignore emulated mouse up clicks
					if (this.isIgnoringMouseUp && event.type == "mouseup") {
						return;
					}

					this.staticClick(event, pointer);

					// set flag for emulated clicks 300ms after touchend
					if (event.type != "mouseup") {
						this.isIgnoringMouseUp = true;
						// reset flag after 300ms
						setTimeout(
							function () {
								delete this.isIgnoringMouseUp;
							}.bind(this),
							400
						);
					}
				};

				proto.staticClick = function (event, pointer) {
					this.emitEvent("staticClick", [event, pointer]);
				};

				// ----- utils ----- //

				Unidragger.getPointerPoint = Unipointer.getPointerPoint;

				// -----  ----- //

				return Unidragger;
			});
		});

		var drag = dist_index_es_createCommonjsModule(function (module) {
			// drag
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(window, flickity, unidragger, utils);
				} else {
					// browser global
					window.Flickity = factory(
						window,
						window.Flickity,
						window.Unidragger,
						window.fizzyUIUtils
					);
				}
			})(window, function factory(window, Flickity, Unidragger, utils) {
				// ----- defaults ----- //

				utils.extend(Flickity.defaults, {
					draggable: ">1",
					dragThreshold: 3,
				});

				// ----- create ----- //

				Flickity.createMethods.push("_createDrag");

				// -------------------------- drag prototype -------------------------- //

				var proto = Flickity.prototype;
				utils.extend(proto, Unidragger.prototype);
				proto._touchActionValue = "pan-y";

				// --------------------------  -------------------------- //

				proto._createDrag = function () {
					this.on("activate", this.onActivateDrag);
					this.on("uiChange", this._uiChangeDrag);
					this.on("deactivate", this.onDeactivateDrag);
					this.on("cellChange", this.updateDraggable);
					// TODO updateDraggable on resize? if groupCells & slides change
				};

				proto.onActivateDrag = function () {
					this.handles = [this.viewport];
					this.bindHandles();
					this.updateDraggable();
				};

				proto.onDeactivateDrag = function () {
					this.unbindHandles();
					this.element.classList.remove("is-draggable");
				};

				proto.updateDraggable = function () {
					// disable dragging if less than 2 slides. #278
					if (this.options.draggable == ">1") {
						this.isDraggable = this.slides.length > 1;
					} else {
						this.isDraggable = this.options.draggable;
					}
					if (this.isDraggable) {
						this.element.classList.add("is-draggable");
					} else {
						this.element.classList.remove("is-draggable");
					}
				};

				// backwards compatibility
				proto.bindDrag = function () {
					this.options.draggable = true;
					this.updateDraggable();
				};

				proto.unbindDrag = function () {
					this.options.draggable = false;
					this.updateDraggable();
				};

				proto._uiChangeDrag = function () {
					delete this.isFreeScrolling;
				};

				// -------------------------- pointer events -------------------------- //

				proto.pointerDown = function (event, pointer) {
					if (!this.isDraggable) {
						this._pointerDownDefault(event, pointer);
						return;
					}
					var isOkay = this.okayPointerDown(event);
					if (!isOkay) {
						return;
					}

					this._pointerDownPreventDefault(event);
					this.pointerDownFocus(event);
					// blur
					if (document.activeElement != this.element) {
						// do not blur if already focused
						this.pointerDownBlur();
					}

					// stop if it was moving
					this.dragX = this.x;
					this.viewport.classList.add("is-pointer-down");
					// track scrolling
					this.pointerDownScroll = getScrollPosition();
					window.addEventListener("scroll", this);

					this._pointerDownDefault(event, pointer);
				};

				// default pointerDown logic, used for staticClick
				proto._pointerDownDefault = function (event, pointer) {
					// track start event position
					// Safari 9 overrides pageX and pageY. These values needs to be copied. #779
					this.pointerDownPointer = {
						pageX: pointer.pageX,
						pageY: pointer.pageY,
					};
					// bind move and end events
					this._bindPostStartEvents(event);
					this.dispatchEvent("pointerDown", event, [pointer]);
				};

				var focusNodes = {
					INPUT: true,
					TEXTAREA: true,
					SELECT: true,
				};

				proto.pointerDownFocus = function (event) {
					var isFocusNode = focusNodes[event.target.nodeName];
					if (!isFocusNode) {
						this.focus();
					}
				};

				proto._pointerDownPreventDefault = function (event) {
					var isTouchStart = event.type == "touchstart";
					var isTouchPointer = event.pointerType == "touch";
					var isFocusNode = focusNodes[event.target.nodeName];
					if (!isTouchStart && !isTouchPointer && !isFocusNode) {
						event.preventDefault();
					}
				};

				// ----- move ----- //

				proto.hasDragStarted = function (moveVector) {
					return Math.abs(moveVector.x) > this.options.dragThreshold;
				};

				// ----- up ----- //

				proto.pointerUp = function (event, pointer) {
					delete this.isTouchScrolling;
					this.viewport.classList.remove("is-pointer-down");
					this.dispatchEvent("pointerUp", event, [pointer]);
					this._dragPointerUp(event, pointer);
				};

				proto.pointerDone = function () {
					window.removeEventListener("scroll", this);
					delete this.pointerDownScroll;
				};

				// -------------------------- dragging -------------------------- //

				proto.dragStart = function (event, pointer) {
					if (!this.isDraggable) {
						return;
					}
					this.dragStartPosition = this.x;
					this.startAnimation();
					window.removeEventListener("scroll", this);
					this.dispatchEvent("dragStart", event, [pointer]);
				};

				proto.pointerMove = function (event, pointer) {
					var moveVector = this._dragPointerMove(event, pointer);
					this.dispatchEvent("pointerMove", event, [pointer, moveVector]);
					this._dragMove(event, pointer, moveVector);
				};

				proto.dragMove = function (event, pointer, moveVector) {
					if (!this.isDraggable) {
						return;
					}
					event.preventDefault();

					this.previousDragX = this.dragX;
					// reverse if right-to-left
					var direction = this.options.rightToLeft ? -1 : 1;
					if (this.options.wrapAround) {
						// wrap around move. #589
						moveVector.x %= this.slideableWidth;
					}
					var dragX = this.dragStartPosition + moveVector.x * direction;

					if (!this.options.wrapAround && this.slides.length) {
						// slow drag
						var originBound = Math.max(
							-this.slides[0].target,
							this.dragStartPosition
						);
						dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
						var endBound = Math.min(
							-this.getLastSlide().target,
							this.dragStartPosition
						);
						dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
					}

					this.dragX = dragX;

					this.dragMoveTime = new Date();
					this.dispatchEvent("dragMove", event, [pointer, moveVector]);
				};

				proto.dragEnd = function (event, pointer) {
					if (!this.isDraggable) {
						return;
					}
					if (this.options.freeScroll) {
						this.isFreeScrolling = true;
					}
					// set selectedIndex based on where flick will end up
					var index = this.dragEndRestingSelect();

					if (this.options.freeScroll && !this.options.wrapAround) {
						// if free-scroll & not wrap around
						// do not free-scroll if going outside of bounding slides
						// so bounding slides can attract slider, and keep it in bounds
						var restingX = this.getRestingPosition();
						this.isFreeScrolling =
							-restingX > this.slides[0].target &&
							-restingX < this.getLastSlide().target;
					} else if (!this.options.freeScroll && index == this.selectedIndex) {
						// boost selection if selected index has not changed
						index += this.dragEndBoostSelect();
					}
					delete this.previousDragX;
					// apply selection
					// TODO refactor this, selecting here feels weird
					// HACK, set flag so dragging stays in correct direction
					this.isDragSelect = this.options.wrapAround;
					this.select(index);
					delete this.isDragSelect;
					this.dispatchEvent("dragEnd", event, [pointer]);
				};

				proto.dragEndRestingSelect = function () {
					var restingX = this.getRestingPosition();
					// how far away from selected slide
					var distance = Math.abs(
						this.getSlideDistance(-restingX, this.selectedIndex)
					);
					// get closet resting going up and going down
					var positiveResting = this._getClosestResting(restingX, distance, 1);
					var negativeResting = this._getClosestResting(restingX, distance, -1);
					// use closer resting for wrap-around
					var index =
						positiveResting.distance < negativeResting.distance
							? positiveResting.index
							: negativeResting.index;
					return index;
				};

				/**
				 * given resting X and distance to selected cell
				 * get the distance and index of the closest cell
				 * @param {Number} restingX - estimated post-flick resting position
				 * @param {Number} distance - distance to selected cell
				 * @param {Integer} increment - +1 or -1, going up or down
				 * @returns {Object} - { distance: {Number}, index: {Integer} }
				 */
				proto._getClosestResting = function (restingX, distance, increment) {
					var index = this.selectedIndex;
					var minDistance = Infinity;
					var condition =
						this.options.contain && !this.options.wrapAround
							? // if contain, keep going if distance is equal to minDistance
							  function (dist, minDist) {
									return dist <= minDist;
							  }
							: function (dist, minDist) {
									return dist < minDist;
							  };
					while (condition(distance, minDistance)) {
						// measure distance to next cell
						index += increment;
						minDistance = distance;
						distance = this.getSlideDistance(-restingX, index);
						if (distance === null) {
							break;
						}
						distance = Math.abs(distance);
					}
					return {
						distance: minDistance,
						// selected was previous index
						index: index - increment,
					};
				};

				/**
				 * measure distance between x and a slide target
				 * @param {Number} x - horizontal position
				 * @param {Integer} index - slide index
				 * @returns {Number} - slide distance
				 */
				proto.getSlideDistance = function (x, index) {
					var len = this.slides.length;
					// wrap around if at least 2 slides
					var isWrapAround = this.options.wrapAround && len > 1;
					var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
					var slide = this.slides[slideIndex];
					if (!slide) {
						return null;
					}
					// add distance for wrap-around slides
					var wrap = isWrapAround
						? this.slideableWidth * Math.floor(index / len)
						: 0;
					return x - (slide.target + wrap);
				};

				proto.dragEndBoostSelect = function () {
					// do not boost if no previousDragX or dragMoveTime
					if (
						this.previousDragX === undefined ||
						!this.dragMoveTime ||
						// or if drag was held for 100 ms
						new Date() - this.dragMoveTime > 100
					) {
						return 0;
					}

					var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
					var delta = this.previousDragX - this.dragX;
					if (distance > 0 && delta > 0) {
						// boost to next if moving towards the right, and positive velocity
						return 1;
					} else if (distance < 0 && delta < 0) {
						// boost to previous if moving towards the left, and negative velocity
						return -1;
					}
					return 0;
				};

				// ----- staticClick ----- //

				proto.staticClick = function (event, pointer) {
					// get clickedCell, if cell was clicked
					var clickedCell = this.getParentCell(event.target);
					var cellElem = clickedCell && clickedCell.element;
					var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
					this.dispatchEvent("staticClick", event, [
						pointer,
						cellElem,
						cellIndex,
					]);
				};

				// ----- scroll ----- //

				proto.onscroll = function () {
					var scroll = getScrollPosition();
					var scrollMoveX = this.pointerDownScroll.x - scroll.x;
					var scrollMoveY = this.pointerDownScroll.y - scroll.y;
					// cancel click/tap if scroll is too much
					if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
						this._pointerDone();
					}
				};

				// ----- utils ----- //

				function getScrollPosition() {
					return {
						x: window.pageXOffset,
						y: window.pageYOffset,
					};
				}

				// -----  ----- //

				return Flickity;
			});
		});

		var prevNextButton = dist_index_es_createCommonjsModule(function (module) {
			// prev/next buttons
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(window, flickity, unipointer, utils);
				} else {
					// browser global
					factory(
						window,
						window.Flickity,
						window.Unipointer,
						window.fizzyUIUtils
					);
				}
			})(window, function factory(window, Flickity, Unipointer, utils) {
				var svgURI = "http://www.w3.org/2000/svg";

				// -------------------------- PrevNextButton -------------------------- //

				function PrevNextButton(direction, parent) {
					this.direction = direction;
					this.parent = parent;
					this._create();
				}

				PrevNextButton.prototype = Object.create(Unipointer.prototype);

				PrevNextButton.prototype._create = function () {
					// properties
					this.isEnabled = true;
					this.isPrevious = this.direction == -1;
					var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
					this.isLeft = this.direction == leftDirection;

					var element = (this.element = document.createElement("button"));
					element.className = "flickity-button flickity-prev-next-button";
					element.className += this.isPrevious ? " previous" : " next";
					// prevent button from submitting form http://stackoverflow.com/a/10836076/182183
					element.setAttribute("type", "button");
					// init as disabled
					this.disable();

					element.setAttribute(
						"aria-label",
						this.isPrevious ? "Previous" : "Next"
					);

					// create arrow
					var svg = this.createSVG();
					element.appendChild(svg);
					// events
					this.parent.on("select", this.update.bind(this));
					this.on(
						"pointerDown",
						this.parent.childUIPointerDown.bind(this.parent)
					);
				};

				PrevNextButton.prototype.activate = function () {
					this.bindStartEvent(this.element);
					this.element.addEventListener("click", this);
					// add to DOM
					this.parent.element.appendChild(this.element);
				};

				PrevNextButton.prototype.deactivate = function () {
					// remove from DOM
					this.parent.element.removeChild(this.element);
					// click events
					this.unbindStartEvent(this.element);
					this.element.removeEventListener("click", this);
				};

				PrevNextButton.prototype.createSVG = function () {
					var svg = document.createElementNS(svgURI, "svg");
					svg.setAttribute("class", "flickity-button-icon");
					svg.setAttribute("viewBox", "0 0 100 100");
					var path = document.createElementNS(svgURI, "path");
					var pathMovements = getArrowMovements(this.parent.options.arrowShape);
					path.setAttribute("d", pathMovements);
					path.setAttribute("class", "arrow");
					// rotate arrow
					if (!this.isLeft) {
						path.setAttribute("transform", "translate(100, 100) rotate(180) ");
					}
					svg.appendChild(path);
					return svg;
				};

				// get SVG path movmement
				function getArrowMovements(shape) {
					// use shape as movement if string
					if (typeof shape == "string") {
						return shape;
					}
					// create movement string
					return (
						"M " +
						shape.x0 +
						",50" +
						" L " +
						shape.x1 +
						"," +
						(shape.y1 + 50) +
						" L " +
						shape.x2 +
						"," +
						(shape.y2 + 50) +
						" L " +
						shape.x3 +
						",50 " +
						" L " +
						shape.x2 +
						"," +
						(50 - shape.y2) +
						" L " +
						shape.x1 +
						"," +
						(50 - shape.y1) +
						" Z"
					);
				}

				PrevNextButton.prototype.handleEvent = utils.handleEvent;

				PrevNextButton.prototype.onclick = function () {
					if (!this.isEnabled) {
						return;
					}
					this.parent.uiChange();
					var method = this.isPrevious ? "previous" : "next";
					this.parent[method]();
				};

				// -----  ----- //

				PrevNextButton.prototype.enable = function () {
					if (this.isEnabled) {
						return;
					}
					this.element.disabled = false;
					this.isEnabled = true;
				};

				PrevNextButton.prototype.disable = function () {
					if (!this.isEnabled) {
						return;
					}
					this.element.disabled = true;
					this.isEnabled = false;
				};

				PrevNextButton.prototype.update = function () {
					// index of first or last slide, if previous or next
					var slides = this.parent.slides;
					// enable is wrapAround and at least 2 slides
					if (this.parent.options.wrapAround && slides.length > 1) {
						this.enable();
						return;
					}
					var lastIndex = slides.length ? slides.length - 1 : 0;
					var boundIndex = this.isPrevious ? 0 : lastIndex;
					var method =
						this.parent.selectedIndex == boundIndex ? "disable" : "enable";
					this[method]();
				};

				PrevNextButton.prototype.destroy = function () {
					this.deactivate();
					this.allOff();
				};

				// -------------------------- Flickity prototype -------------------------- //

				utils.extend(Flickity.defaults, {
					prevNextButtons: true,
					arrowShape: {
						x0: 10,
						x1: 60,
						y1: 50,
						x2: 70,
						y2: 40,
						x3: 30,
					},
				});

				Flickity.createMethods.push("_createPrevNextButtons");
				var proto = Flickity.prototype;

				proto._createPrevNextButtons = function () {
					if (!this.options.prevNextButtons) {
						return;
					}

					this.prevButton = new PrevNextButton(-1, this);
					this.nextButton = new PrevNextButton(1, this);

					this.on("activate", this.activatePrevNextButtons);
				};

				proto.activatePrevNextButtons = function () {
					this.prevButton.activate();
					this.nextButton.activate();
					this.on("deactivate", this.deactivatePrevNextButtons);
				};

				proto.deactivatePrevNextButtons = function () {
					this.prevButton.deactivate();
					this.nextButton.deactivate();
					this.off("deactivate", this.deactivatePrevNextButtons);
				};

				// --------------------------  -------------------------- //

				Flickity.PrevNextButton = PrevNextButton;

				return Flickity;
			});
		});

		var pageDots = dist_index_es_createCommonjsModule(function (module) {
			// page dots
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(window, flickity, unipointer, utils);
				} else {
					// browser global
					factory(
						window,
						window.Flickity,
						window.Unipointer,
						window.fizzyUIUtils
					);
				}
			})(window, function factory(window, Flickity, Unipointer, utils) {
				function PageDots(parent) {
					this.parent = parent;
					this._create();
				}

				PageDots.prototype = Object.create(Unipointer.prototype);

				PageDots.prototype._create = function () {
					// create holder element
					this.holder = document.createElement("ol");
					this.holder.className = "flickity-page-dots";
					// create dots, array of elements
					this.dots = [];
					// events
					this.handleClick = this.onClick.bind(this);
					this.on(
						"pointerDown",
						this.parent.childUIPointerDown.bind(this.parent)
					);
				};

				PageDots.prototype.activate = function () {
					this.setDots();
					this.holder.addEventListener("click", this.handleClick);
					this.bindStartEvent(this.holder);
					// add to DOM
					this.parent.element.appendChild(this.holder);
				};

				PageDots.prototype.deactivate = function () {
					this.holder.removeEventListener("click", this.handleClick);
					this.unbindStartEvent(this.holder);
					// remove from DOM
					this.parent.element.removeChild(this.holder);
				};

				PageDots.prototype.setDots = function () {
					// get difference between number of slides and number of dots
					var delta = this.parent.slides.length - this.dots.length;
					if (delta > 0) {
						this.addDots(delta);
					} else if (delta < 0) {
						this.removeDots(-delta);
					}
				};

				PageDots.prototype.addDots = function (count) {
					var fragment = document.createDocumentFragment();
					var newDots = [];
					var length = this.dots.length;
					var max = length + count;

					for (var i = length; i < max; i++) {
						var dot = document.createElement("li");
						dot.className = "dot";
						dot.setAttribute("aria-label", "Page dot " + (i + 1));
						fragment.appendChild(dot);
						newDots.push(dot);
					}

					this.holder.appendChild(fragment);
					this.dots = this.dots.concat(newDots);
				};

				PageDots.prototype.removeDots = function (count) {
					// remove from this.dots collection
					var removeDots = this.dots.splice(this.dots.length - count, count);
					// remove from DOM
					removeDots.forEach(function (dot) {
						this.holder.removeChild(dot);
					}, this);
				};

				PageDots.prototype.updateSelected = function () {
					// remove selected class on previous
					if (this.selectedDot) {
						this.selectedDot.className = "dot";
						this.selectedDot.removeAttribute("aria-current");
					}
					// don't proceed if no dots
					if (!this.dots.length) {
						return;
					}
					this.selectedDot = this.dots[this.parent.selectedIndex];
					this.selectedDot.className = "dot is-selected";
					this.selectedDot.setAttribute("aria-current", "step");
				};

				PageDots.prototype.onTap = // old method name, backwards-compatible
					PageDots.prototype.onClick = function (event) {
						var target = event.target;
						// only care about dot clicks
						if (target.nodeName != "LI") {
							return;
						}

						this.parent.uiChange();
						var index = this.dots.indexOf(target);
						this.parent.select(index);
					};

				PageDots.prototype.destroy = function () {
					this.deactivate();
					this.allOff();
				};

				Flickity.PageDots = PageDots;

				// -------------------------- Flickity -------------------------- //

				utils.extend(Flickity.defaults, {
					pageDots: true,
				});

				Flickity.createMethods.push("_createPageDots");

				var proto = Flickity.prototype;

				proto._createPageDots = function () {
					if (!this.options.pageDots) {
						return;
					}
					this.pageDots = new PageDots(this);
					// events
					this.on("activate", this.activatePageDots);
					this.on("select", this.updateSelectedPageDots);
					this.on("cellChange", this.updatePageDots);
					this.on("resize", this.updatePageDots);
					this.on("deactivate", this.deactivatePageDots);
				};

				proto.activatePageDots = function () {
					this.pageDots.activate();
				};

				proto.updateSelectedPageDots = function () {
					this.pageDots.updateSelected();
				};

				proto.updatePageDots = function () {
					this.pageDots.setDots();
				};

				proto.deactivatePageDots = function () {
					this.pageDots.deactivate();
				};

				// -----  ----- //

				Flickity.PageDots = PageDots;

				return Flickity;
			});
		});

		var player = dist_index_es_createCommonjsModule(function (module) {
			// player & autoPlay
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(evEmitter, utils, flickity);
				} else {
					// browser global
					factory(window.EvEmitter, window.fizzyUIUtils, window.Flickity);
				}
			})(window, function factory(EvEmitter, utils, Flickity) {
				// -------------------------- Player -------------------------- //

				function Player(parent) {
					this.parent = parent;
					this.state = "stopped";
					// visibility change event handler
					this.onVisibilityChange = this.visibilityChange.bind(this);
					this.onVisibilityPlay = this.visibilityPlay.bind(this);
				}

				Player.prototype = Object.create(EvEmitter.prototype);

				// start play
				Player.prototype.play = function () {
					if (this.state == "playing") {
						return;
					}
					// do not play if page is hidden, start playing when page is visible
					var isPageHidden = document.hidden;
					if (isPageHidden) {
						document.addEventListener(
							"visibilitychange",
							this.onVisibilityPlay
						);
						return;
					}

					this.state = "playing";
					// listen to visibility change
					document.addEventListener(
						"visibilitychange",
						this.onVisibilityChange
					);
					// start ticking
					this.tick();
				};

				Player.prototype.tick = function () {
					// do not tick if not playing
					if (this.state != "playing") {
						return;
					}

					var time = this.parent.options.autoPlay;
					// default to 3 seconds
					time = typeof time == "number" ? time : 3000;
					var _this = this;
					// HACK: reset ticks if stopped and started within interval
					this.clear();
					this.timeout = setTimeout(function () {
						_this.parent.next(true);
						_this.tick();
					}, time);
				};

				Player.prototype.stop = function () {
					this.state = "stopped";
					this.clear();
					// remove visibility change event
					document.removeEventListener(
						"visibilitychange",
						this.onVisibilityChange
					);
				};

				Player.prototype.clear = function () {
					clearTimeout(this.timeout);
				};

				Player.prototype.pause = function () {
					if (this.state == "playing") {
						this.state = "paused";
						this.clear();
					}
				};

				Player.prototype.unpause = function () {
					// re-start play if paused
					if (this.state == "paused") {
						this.play();
					}
				};

				// pause if page visibility is hidden, unpause if visible
				Player.prototype.visibilityChange = function () {
					var isPageHidden = document.hidden;
					this[isPageHidden ? "pause" : "unpause"]();
				};

				Player.prototype.visibilityPlay = function () {
					this.play();
					document.removeEventListener(
						"visibilitychange",
						this.onVisibilityPlay
					);
				};

				// -------------------------- Flickity -------------------------- //

				utils.extend(Flickity.defaults, {
					pauseAutoPlayOnHover: true,
				});

				Flickity.createMethods.push("_createPlayer");
				var proto = Flickity.prototype;

				proto._createPlayer = function () {
					this.player = new Player(this);

					this.on("activate", this.activatePlayer);
					this.on("uiChange", this.stopPlayer);
					this.on("pointerDown", this.stopPlayer);
					this.on("deactivate", this.deactivatePlayer);
				};

				proto.activatePlayer = function () {
					if (!this.options.autoPlay) {
						return;
					}
					this.player.play();
					this.element.addEventListener("mouseenter", this);
				};

				// Player API, don't hate the ... thanks I know where the door is

				proto.playPlayer = function () {
					this.player.play();
				};

				proto.stopPlayer = function () {
					this.player.stop();
				};

				proto.pausePlayer = function () {
					this.player.pause();
				};

				proto.unpausePlayer = function () {
					this.player.unpause();
				};

				proto.deactivatePlayer = function () {
					this.player.stop();
					this.element.removeEventListener("mouseenter", this);
				};

				// ----- mouseenter/leave ----- //

				// pause auto-play on hover
				proto.onmouseenter = function () {
					if (!this.options.pauseAutoPlayOnHover) {
						return;
					}
					this.player.pause();
					this.element.addEventListener("mouseleave", this);
				};

				// resume auto-play on hover off
				proto.onmouseleave = function () {
					this.player.unpause();
					this.element.removeEventListener("mouseleave", this);
				};

				// -----  ----- //

				Flickity.Player = Player;

				return Flickity;
			});
		});

		var addRemoveCell = dist_index_es_createCommonjsModule(function (module) {
			// add, remove cell
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(window, flickity, utils);
				} else {
					// browser global
					factory(window, window.Flickity, window.fizzyUIUtils);
				}
			})(window, function factory(window, Flickity, utils) {
				// append cells to a document fragment
				function getCellsFragment(cells) {
					var fragment = document.createDocumentFragment();
					cells.forEach(function (cell) {
						fragment.appendChild(cell.element);
					});
					return fragment;
				}

				// -------------------------- add/remove cell prototype -------------------------- //

				var proto = Flickity.prototype;

				/**
				 * Insert, prepend, or append cells
				 * @param {[Element, Array, NodeList]} elems - Elements to insert
				 * @param {Integer} index - Zero-based number to insert
				 */
				proto.insert = function (elems, index) {
					var cells = this._makeCells(elems);
					if (!cells || !cells.length) {
						return;
					}
					var len = this.cells.length;
					// default to append
					index = index === undefined ? len : index;
					// add cells with document fragment
					var fragment = getCellsFragment(cells);
					// append to slider
					var isAppend = index == len;
					if (isAppend) {
						this.slider.appendChild(fragment);
					} else {
						var insertCellElement = this.cells[index].element;
						this.slider.insertBefore(fragment, insertCellElement);
					}
					// add to this.cells
					if (index === 0) {
						// prepend, add to start
						this.cells = cells.concat(this.cells);
					} else if (isAppend) {
						// append, add to end
						this.cells = this.cells.concat(cells);
					} else {
						// insert in this.cells
						var endCells = this.cells.splice(index, len - index);
						this.cells = this.cells.concat(cells).concat(endCells);
					}

					this._sizeCells(cells);
					this.cellChange(index, true);
				};

				proto.append = function (elems) {
					this.insert(elems, this.cells.length);
				};

				proto.prepend = function (elems) {
					this.insert(elems, 0);
				};

				/**
				 * Remove cells
				 * @param {[Element, Array, NodeList]} elems - ELements to remove
				 */
				proto.remove = function (elems) {
					var cells = this.getCells(elems);
					if (!cells || !cells.length) {
						return;
					}

					var minCellIndex = this.cells.length - 1;
					// remove cells from collection & DOM
					cells.forEach(function (cell) {
						cell.remove();
						var index = this.cells.indexOf(cell);
						minCellIndex = Math.min(index, minCellIndex);
						utils.removeFrom(this.cells, cell);
					}, this);

					this.cellChange(minCellIndex, true);
				};

				/**
				 * logic to be run after a cell's size changes
				 * @param {Element} elem - cell's element
				 */
				proto.cellSizeChange = function (elem) {
					var cell = this.getCell(elem);
					if (!cell) {
						return;
					}
					cell.getSize();

					var index = this.cells.indexOf(cell);
					this.cellChange(index);
				};

				/**
				 * logic any time a cell is changed: added, removed, or size changed
				 * @param {Integer} changedCellIndex - index of the changed cell, optional
				 * @param {Boolean} isPositioningSlider - Positions slider after selection
				 */
				proto.cellChange = function (changedCellIndex, isPositioningSlider) {
					var prevSelectedElem = this.selectedElement;
					this._positionCells(changedCellIndex);
					this._getWrapShiftCells();
					this.setGallerySize();
					// update selectedIndex
					// try to maintain position & select previous selected element
					var cell = this.getCell(prevSelectedElem);
					if (cell) {
						this.selectedIndex = this.getCellSlideIndex(cell);
					}
					this.selectedIndex = Math.min(
						this.slides.length - 1,
						this.selectedIndex
					);

					this.emitEvent("cellChange", [changedCellIndex]);
					// position slider
					this.select(this.selectedIndex);
					// do not position slider after lazy load
					if (isPositioningSlider) {
						this.positionSliderAtSelected();
					}
				};

				// -----  ----- //

				return Flickity;
			});
		});

		var lazyload = dist_index_es_createCommonjsModule(function (module) {
			// lazyload
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(window, flickity, utils);
				} else {
					// browser global
					factory(window, window.Flickity, window.fizzyUIUtils);
				}
			})(window, function factory(window, Flickity, utils) {
				Flickity.createMethods.push("_createLazyload");
				var proto = Flickity.prototype;

				proto._createLazyload = function () {
					this.on("select", this.lazyLoad);
				};

				proto.lazyLoad = function () {
					var lazyLoad = this.options.lazyLoad;
					if (!lazyLoad) {
						return;
					}
					// get adjacent cells, use lazyLoad option for adjacent count
					var adjCount = typeof lazyLoad == "number" ? lazyLoad : 0;
					var cellElems = this.getAdjacentCellElements(adjCount);
					// get lazy images in those cells
					var lazyImages = [];
					cellElems.forEach(function (cellElem) {
						var lazyCellImages = getCellLazyImages(cellElem);
						lazyImages = lazyImages.concat(lazyCellImages);
					});
					// load lazy images
					lazyImages.forEach(function (img) {
						new LazyLoader(img, this);
					}, this);
				};

				function getCellLazyImages(cellElem) {
					// check if cell element is lazy image
					if (cellElem.nodeName == "IMG") {
						var lazyloadAttr = cellElem.getAttribute("data-flickity-lazyload");
						var srcAttr = cellElem.getAttribute("data-flickity-lazyload-src");
						var srcsetAttr = cellElem.getAttribute(
							"data-flickity-lazyload-srcset"
						);
						if (lazyloadAttr || srcAttr || srcsetAttr) {
							return [cellElem];
						}
					}
					// select lazy images in cell
					var lazySelector =
						"img[data-flickity-lazyload], " +
						"img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]";
					var imgs = cellElem.querySelectorAll(lazySelector);
					return utils.makeArray(imgs);
				}

				// -------------------------- LazyLoader -------------------------- //

				/**
				 * class to handle loading images
				 * @param {Image} img - Image element
				 * @param {Flickity} flickity - Flickity instance
				 */
				function LazyLoader(img, flickity) {
					this.img = img;
					this.flickity = flickity;
					this.load();
				}

				LazyLoader.prototype.handleEvent = utils.handleEvent;

				LazyLoader.prototype.load = function () {
					this.img.addEventListener("load", this);
					this.img.addEventListener("error", this);
					// get src & srcset
					var src =
						this.img.getAttribute("data-flickity-lazyload") ||
						this.img.getAttribute("data-flickity-lazyload-src");
					var srcset = this.img.getAttribute("data-flickity-lazyload-srcset");
					// set src & serset
					this.img.src = src;
					if (srcset) {
						this.img.setAttribute("srcset", srcset);
					}
					// remove attr
					this.img.removeAttribute("data-flickity-lazyload");
					this.img.removeAttribute("data-flickity-lazyload-src");
					this.img.removeAttribute("data-flickity-lazyload-srcset");
				};

				LazyLoader.prototype.onload = function (event) {
					this.complete(event, "flickity-lazyloaded");
				};

				LazyLoader.prototype.onerror = function (event) {
					this.complete(event, "flickity-lazyerror");
				};

				LazyLoader.prototype.complete = function (event, className) {
					// unbind events
					this.img.removeEventListener("load", this);
					this.img.removeEventListener("error", this);

					var cell = this.flickity.getParentCell(this.img);
					var cellElem = cell && cell.element;
					this.flickity.cellSizeChange(cellElem);

					this.img.classList.add(className);
					this.flickity.dispatchEvent("lazyLoad", event, cellElem);
				};

				// -----  ----- //

				Flickity.LazyLoader = LazyLoader;

				return Flickity;
			});
		});

		var index_es_js = dist_index_es_createCommonjsModule(function (module) {
			/*!
			 * Flickity v2.3.0
			 * Touch, responsive, flickable carousels
			 *
			 * Licensed GPLv3 for open source use
			 * or Flickity Commercial License for commercial use
			 *
			 * https://flickity.metafizzy.co
			 * Copyright 2015-2021 Metafizzy
			 */

			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						flickity,
						drag,
						prevNextButton,
						pageDots,
						player,
						addRemoveCell,
						lazyload
					);
				}
			})(window, function factory(Flickity) {
				return Flickity;
			});
		});

		var ComplementaryProducts = /*#__PURE__*/ (function () {
			function ComplementaryProducts(options) {
				pxs_complementary_products_dist_index_es_classCallCheck(
					this,
					ComplementaryProducts
				);

				this.sectionEl = options.sectionEl;
				this.sectionId = options.sectionId;
				this.events = new dist_index_es_EventHandler();
				this.productId = options.productId;
				this.includeIndicatorDots = options.includeIndicatorDots || false;
				this.recommendationsRoute = options.productRecommendationsRoute;
				this.limit = options.limit;
				var defaultArrowShape = {
					x0: 10,
					x1: 60,
					y1: 50,
					x2: 65,
					y2: 45,
					x3: 20,
				};
				this.arrowShape = options.arrowShape || defaultArrowShape;
				this.recommendationsEl = this.sectionEl.querySelector(
					"[data-complementary-products]"
				);
				this.loadRecommendations();
			}

			pxs_complementary_products_dist_index_es_createClass(
				ComplementaryProducts,
				[
					{
						key: "loadRecommendations",
						value: function loadRecommendations() {
							var _this = this;

							var url = ""
								.concat(this.recommendationsRoute, "?section_id=")
								.concat(this.sectionId, "&limit=")
								.concat(this.limit, "&product_id=")
								.concat(this.productId, "&intent=complementary");
							index_es_AsyncView
								.load(url, {
									view: "",
								})
								.then(function (_ref) {
									var html = _ref.html;
									if (
										index_es_typeof(html) === "object" &&
										Object.keys(html).length === 0
									)
										return;

									if (html.trim().length === 0) {
										_this.recommendationsEl.classList.add(
											"complementary-products--no-recommendations"
										);

										return;
									}

									_this.recommendationsEl.innerHTML = html;

									if (!dist_index_es.instance) {
										dist_index_es.init();
									}

									dist_index_es.watch(_this.recommendationsEl);

									var slider =
										_this.recommendationsEl.querySelector("[data-slider]");

									var slides =
										_this.recommendationsEl.querySelectorAll("[data-slide]");

									if (slides.length > 1) {
										_this.slider = new index_es_js(slider, {
											cellSelector: "[data-slide]",
											accessibility: false,
											adaptiveHeight: false,
											autoPlay: false,
											cellAlign: "left",
											contain: true,
											imagesLoaded: true,
											pageDots: _this.includeIndicatorDots,
											wrapAround: true,
											arrowShape: _this.arrowShape,
										});

										_this.events.register(slider, "rimg:load", function () {
											_this.slider.resize();
										});
									}
								});
						},
					},
					{
						key: "unload",
						value: function unload() {
							this.slider.destroy();
						},
					},
				]
			);

			return ComplementaryProducts;
		})();

		/* harmony default export */ const pxs_complementary_products_dist_index_es =
			ComplementaryProducts; // CONCATENATED MODULE: ./source/scripts/sections/Product.js

		class Product {
			constructor(section) {
				let options =
					arguments.length > 1 && arguments[1] !== undefined
						? arguments[1]
						: {};
				this.section = section;
				this.sectionId = section.id;
				this.el = this.section.el;
				this.$el = jquery_default()(this.section.el);
				this.context = section.data.context;
				this.settings = section.data.settings;
				this.product = section.data.product;
				this.productRecommendationLimit =
					section.data.product_recommendation_limit;
				this.richText = null;
				this.readmoreText = null;
				this.reviewForm = null; // History

				this.isThemeEditor = window.Shopify && window.Shopify.designMode;
				this.useHistory =
					"useHistory" in options
						? options.useHistory
						: !!(!this.isThemeEditor && history.replaceState); // Complementary products

				const complementaryProductsEl = this.el.querySelector(
					"[data-complementary-products]"
				);

				if (complementaryProductsEl) {
					this.complementaryProducts =
						new pxs_complementary_products_dist_index_es({
							sectionEl: this.el,
							sectionId: this.sectionId,
							productId: this.product.id,
							productRecommendationsRoute:
								window.Theme.routes.product_recommendations_url,
							includeIndicatorDots: true,
							limit: this.productRecommendationLimit,
							arrowShape:
								"M 65.29,11.99 L 27.28,50 L 65.3,87.99 L 70.25,83.06 L 37.19,50 L 70.26,16.94 L 65.29,11.99 Z",
						});
				}

				const gallery = this.$el.find("[data-product-gallery]")[0];
				const productWrapper = this.$el.find("[data-product-wrapper]"); // Product details

				this.$details = this.$el.find("[data-product-details]"); // Product description

				this.$description = this.$el.find("[data-product-description]");
				this.$readmore = this.$el.find("[data-product-readmore]"); // Product form containers

				this.$formRegular = this.$el.find("[data-product-form-regular]");
				this.$formAlt = this.$el.find("[data-product-form-alt]"); // Product form area

				this.$formArea = this.$el.find("[data-product-form-area]"); // Move product form and information on breakpoint change

				this.layoutHandler = this.onBreakpointChange.bind(this);
				Layout.onBreakpointChange(this.layoutHandler);

				if (productWrapper.hasClass("product__container--three-columns")) {
					this._moveForm();
				}

				if (this.$description.length) {
					this.richText = new RichText(this.$description);
				}

				if (this.$readmore.length) {
					this.readmoreText = new RichText(this.$readmore);
				} // Instantiate ProductDetails after Shopify API is loaded

				script_default()(
					jquery_default()("[data-scripts]").data("shopify-api-url"),
					() => {
						this.productDetails = new ProductDetails({
							$formArea: this.$formArea,
							$details: this.$details,
							gallery,
							context: this.context,
							settings: this.settings,
							product: this.product,
							useHistory: this.useHistory,
							sectionId: section.id,
							productEl: this.$el[0],
						});
					}
				);
			}

			onSectionUnload() {
				Layout.offBreakpointChange(this.layoutHandler);

				if (this.productDetails) {
					this.productDetails.unload();
				}

				if (this.richText) {
					this.richText.unload();
				}

				if (this.readmoreText) {
					this.readmoreText.unload();
				}

				if (this.reviewForm) {
					this.reviewForm.unload();
				}
			}

			onBreakpointChange() {
				if (this.$formAlt.length) {
					this._moveForm();
				}
			}
			/**
			 * Move product form if is a three column layout
			 * @private
			 */

			_moveForm() {
				if (Layout.isGreaterThanBreakpoint("M")) {
					if (!jquery_default().contains(this.$formAlt[0], this.$formArea[0])) {
						const $form = this.$formArea.detach();
						this.$formAlt.append($form);
					}
				} else if (
					!jquery_default().contains(this.$formRegular[0], this.$formArea[0])
				) {
					const $form = this.$formArea.detach();
					this.$formRegular.append($form);
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/StaticProduct.js
		class StaticProduct extends Product {} // CONCATENATED MODULE: ./source/scripts/helpers/ScrollLink.js
		class ScrollLink {
			constructor() {
				this.events = new EventHandler /* default */.Z();
				this.els = [];
				this.lastTop = 0;
				this.lastLeft = 0;
				this.ticking = false;
				this.driver = null;
				this.settledTimeout = null;
			}

			add(el) {
				if (this.els.includes(el)) return;
				this.els.push(el);
				this.events.register(el, "scroll", (e) => {
					if (this.driver === null) {
						this.driver = e.target;

						this._unsetScrollSnapTypes();
					} // Ignore scroll events on driven element

					if (this.driver && e.target !== this.driver) {
						e.preventDefault();
						return;
					}

					this.lastTop = e.target.scrollTop;
					this.lastLeft = e.target.scrollLeft;
					clearTimeout(this.settledTimeout);

					if (!this.ticking) {
						window.requestAnimationFrame(() => {
							this._updateScroll();

							this.ticking = false;
							this.settledTimeout = setTimeout(() => {
								this.driver = null;

								this._resetScrollSnapTypes();
							}, 50);
						});
					}

					this.ticking = true;
				});
			}

			unload() {
				this.events.unregisterAll();
			}

			syncAll() {
				this._updateScroll();
			}

			_updateScroll() {
				this.els.forEach((el) => {
					if (el === this.driver) return;
					el.scrollTop = this.lastTop;
					el.scrollLeft = this.lastLeft;
				});
			}

			_unsetScrollSnapTypes() {
				this.els.forEach((el) => {
					if (el === this.driver) return;
					el.style.scrollSnapType = "none";
				});
			}

			_resetScrollSnapTypes() {
				this.els.forEach((el) => {
					el.style.scrollSnapType = null;
				});
			}
		} // CONCATENATED MODULE: ./source/scripts/components/ShowMoreToggle.js
		const noOverflowClass = "show-more__content-wrapper--no-overflow";
		class ShowMoreToggle {
			constructor(_ref) {
				let { el, context } = _ref;
				this.context = context;
				this.wrapper = el.querySelector("[data-show-more-content-wrapper]");
				this.toggle = el.querySelector("[data-show-more-toggle]");

				if (this.wrapper && this.toggle) {
					this.events = new EventHandler /* default */.Z();
					this.menuIsOpen = false;
					this.menuTransition = transition({
						el: this.wrapper,
						state: "closed",
						stateAttribute: "data-show-more-state",
						stateChangeAttribute: "data-show-more-animation",
					});
					this.events.register(this.toggle, "click", () => {
						if (this.menuIsOpen) {
							this._closeMenu();
						} else {
							this._openMenu();
						}
					});

					this.onBreakpointChange = () => this._closeMenu();

					cjs.onChange(this.onBreakpointChange);
					this.checkOverflow();
				}
			}

			unload() {
				if (this.events) this.events.unregisterAll();
				cjs.offChange(this.onBreakpointChange);
			}

			checkOverflow() {
				this._closeMenu(true);
			}

			_checkOverflow() {
				const { height } = this.wrapper.getBoundingClientRect();
				const { scrollHeight } = this.wrapper; // Round up to account for rounding in scrollHeight

				const noOverflow = Math.ceil(scrollHeight) <= Math.ceil(height);
				this.wrapper.classList.toggle(noOverflowClass, noOverflow);
			}

			_openMenu() {
				this.menuIsOpen = true;
				this.toggle.innerHTML = this.context.see_less;
				const { height: closedHeight } = this.wrapper.getBoundingClientRect();
				this.wrapper.style.setProperty("--closed-height", `${closedHeight}px`);
				this.wrapper.style.maxHeight = "none";
				this.menuTransition.animateTo("open", {
					onStart: () => {
						const { height: menuToggleHeight } =
							this.toggle.getBoundingClientRect();
						const openHeight = this.wrapper.scrollHeight + menuToggleHeight;
						this.wrapper.style.setProperty("--open-height", `${openHeight}px`);
					},
				});
			}

			_closeMenu(force) {
				this.menuIsOpen = false;
				this.toggle.innerHTML = this.context.see_more;
				this.wrapper.classList.remove(noOverflowClass);
				this.menuTransition
					.animateTo("closed", {
						force,
					})
					.then(() => {
						this.wrapper.style.removeProperty("--closed-height");
						this.wrapper.style.maxHeight = null;

						this._checkOverflow();
					});
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/StaticProductCompare.js
		/**
		 * Gets comma separated product handles from `compare` query parameter
		 * @returns [String] Product handles
		 */

		const getCompareHandles = () => {
			const { searchParams } = new URL(window.location);
			const handles = searchParams.get("compare");

			if (typeof handles === "string" && handles !== "") {
				return handles.split(",");
			}

			return [];
		};

		const updateUrlForHandles = (handles) => {
			if (window.Shopify && window.Shopify.designMode) return;
			const [productHandle, ...compareHandles] = handles;
			const url = new URL(window.location);
			url.searchParams.set("compare", compareHandles.join(","));

			if (productHandle) {
				url.pathname = url.pathname.replace(/\/[^/]+$/, `/${productHandle}`);
			}

			history.replaceState({}, "", url);
		};

		const generateBaseUrl = (rootUrl) => {
			const separator = /\/$/.test(rootUrl) ? "" : "/";
			return `${rootUrl}${separator}products`;
		};

		const lastRowClass = "product-compare__table-row--last";
		class StaticProductCompare {
			constructor(section) {
				this.sectionId = section.id;
				this.el = section.el;
				this.data = section.data;
				this.baseUrl = generateBaseUrl(section.data.root_url);
				this.templateCells = {};
				this.productItems = [];
				this.showMoreToggles = [];
				this.descriptionItems = [];
				this.filterLabels = {};
				this.filterGroups = section.data.filter_groups;
				this.activeFilterIds = new Map();
				this.filterCheckboxes = new Map();
				this.events = new EventHandler /* default */.Z();
				this.filtersModal = new Modal({
					onBeforeOpen: () => this._onBeforeFiltersModalOpen(),
					onClose: () => this._onFiltersModalClose(),
				});
				this.allRows = this.el.querySelectorAll(
					'[data-compare-row-type="info"], [data-compare-row-type="heading"]'
				);
				this.infoRows = this.el.querySelectorAll(
					'[data-compare-row-type="info"]'
				);
				this.headingRows = this.el.querySelectorAll(
					'[data-compare-row-type="heading"]'
				);

				this._initCell(this.el);

				this.table = this.el.querySelector("[data-compare-table]");
				const productCardRow = this.infoRows[0];
				const firstNonProductCardRow = this.allRows[1];
				const emptyMessage = this.el.querySelector("[data-compare-empty]"); // @pixelunion/animations requires the transitionend events to fire on
				// the element to which the animation is attached, but due to the table
				// structure and the use of sticky on `th` cells we are attaching the
				// animation to the `tr` and applying that animation the all `th` descendants.
				// For this to work, we need to dispatch a synthetic transitionend event on
				// the `tr` itself. Similarly we apply some animations to the entire table
				// but the actual transition is performed on individual rows.

				const eventsToSynthetize = [
					{
						target: productCardRow,
						newTarget: this.table,
					},
					{
						target: firstNonProductCardRow,
						newTarget: this.table,
					},
				];
				eventsToSynthetize.forEach((_ref) => {
					let { target, newTarget } = _ref;
					this.events.register(target, "transitionend", (e) => {
						if (e.target !== target) return;
						newTarget.dispatchEvent(new Event("transitionend"));
					});
				});
				this.clearAllFadeAnimation = transition({
					el: this.table,
					state: "visible",
					stateAttribute: "data-fade-animation-state",
					stateChangeAttribute: "data-fade-animation",
				});
				this.emptyMessageAnimation = transition({
					el: emptyMessage,
					state: "hidden",
					stateAttribute: "data-animation-state",
					stateChangeAttribute: "data-animation",
				});

				this.animateToEmptyState = () => {
					this._removeAllFilters();

					this._disableFilters();

					this.stickyObserver.disconnect();
					this.stickyBarAnimation.animateTo("up");
					this.clearAllFadeAnimation
						.animateTo("only-cards", {
							force: this.allRows.length < 2,
						})
						.then(() => this.clearAllFadeAnimation.animateTo("hidden"))
						.then(() =>
							this.emptyMessageAnimation.animateTo("visible", {
								onStart: () => {
									document.documentElement.scroll(0, 0);
								},
							})
						);
				};

				this._registerProductRemoveEvents(this.el);

				this.scrollLink = new ScrollLink();
				this.scrollLink.add(
					this.el.querySelector("[data-compare-table-scroll-wrapper]")
				);
				this.filtersEl = this.el.querySelector("[data-compare-filters]");

				if (this.filtersEl) {
					const options = {
						groups: this.filterGroups,
					};
					this.filterGroupAccordions = new FilterGroups(
						this.filtersEl,
						options
					);
					this.filtersEl
						.querySelectorAll("[data-filter-checkbox-for]")
						.forEach((checkboxEl) => {
							this.filterCheckboxes.set(
								checkboxEl.dataset.filterCheckboxFor,
								new Checkbox(checkboxEl)
							);
						});
					this.filtersModalButton = this.el.querySelector(
						"[data-compare-open-filter-modal-button]"
					);
					this.events.register(this.filtersModalButton, "click", () =>
						this.filtersModal.open(
							"[data-compare-filters-modal-target]",
							"productgrid-filters"
						)
					);
					this.mobileActiveFiltersTarget = this.el.querySelector(
						"[data-compare-mobile-active-filters-target]"
					);
					this.activeFiltersContainer = this.el.querySelector(
						"[data-compare-active-filters-container]"
					);
					this.activeFiltersEl = this.activeFiltersContainer.querySelector(
						"[data-compare-active-filters]"
					);
					this.removeFilterTemplate = this.activeFiltersContainer.querySelector(
						"[data-compare-filter-remove-template]"
					);
					this.clearAllFiltersTemplate =
						this.activeFiltersContainer.querySelector(
							"[data-compare-filter-clear-all-template]"
						);
					this.events.register(this.activeFiltersEl, "click", (e) => {
						const filterToRemove = e.target.closest(
							"[data-product-compare-filter-remove]"
						);
						if (!filterToRemove) return; // prevent modal from interpreting this click event as outside the modal
						// when it does a DOM trace from the by-then removed elements.

						e.stopPropagation();
						const id = filterToRemove.dataset.productCompareFilterRemove;

						if (id === "") {
							this._removeAllFilters();

							return;
						}

						document.getElementById(id).checked = false;

						this._updateFilter({
							checked: false,
							id,
						});
					});
				}

				this.events.register(this.filtersEl, "change", (e) => {
					const id = e.target.value;
					this.filterLabels[id] = e.target.labels[0].innerText;

					this._updateFilter({
						checked: e.target.checked,
						id,
					});
				});
				const compareHandles = getCompareHandles();
				this.allHandles = [section.data.handle, ...compareHandles];

				this._updateBreadcrumbs();

				if (!compareHandles.length) {
					this._injectStickyBar();

					return;
				} // Add required columns first, so the table size
				// is correct immediately, without having to load
				// the compared products

				this._addBlankColumns(compareHandles.length);

				this._setProductCountVar(this.allHandles.length);

				Promise.all(this._fetchCompareProducts(compareHandles)).then(() =>
					this._injectStickyBar()
				);
			}

			onSectionUnload() {
				this.productItems.forEach((productItem) => {
					productItem.unload();
				});
				this.events.unregisterAll();

				if (this.filterGroups) {
					this.filterGroupAccordions.unload();
				}

				this.filterCheckboxes.forEach((checkbox) => checkbox.unload());
				this.stickyBarAnimation.unload();
				this.clearAllFadeAnimation.unload();
				this.scrollLink.unload();
				this.stickyBar.remove();

				if (this.tableObserver) {
					this.tableObserver.disconnect();
				}

				if (this.stickyObserver) {
					this.stickyObserver.disconnect();
				}
			}

			_registerProductRemoveEvents(el) {
				this.events.register(
					el.querySelector("[data-compare-clear-all]"),
					"click",
					() => {
						this.animateToEmptyState();
						components_ProductCompare.removeAll();
					}
				);
				this.events.register(el, "click", (e) => {
					const removeButton = e.target.closest("[data-compare-remove]");
					if (!removeButton) return;

					this._removeHandle(removeButton.dataset.compareRemove);
				});
			}

			_injectStickyBar() {
				const barTemplate = this.el.querySelector(
					"[data-compare-sticky-bar-template]"
				).content;
				const barTable = barTemplate.querySelector("[data-compare-table]");
				barTable.appendChild(this.infoRows[0].cloneNode(true));

				this._addScrollStops(barTemplate, this.allHandles.length - 2);

				document.querySelector("[data-site-header]").append(barTemplate);
				this.stickyBar = document.querySelector("[data-compare-sticky-bar]");
				this.stickyBarRow = this.stickyBar.querySelector(
					'[data-compare-row-type="info"]'
				);

				this._initProductItems(this.stickyBar);

				setupRippleEffect(this.stickyBar);

				this._registerProductRemoveEvents(this.stickyBar);

				this.scrollLink.add(
					this.stickyBar.querySelector("[data-compare-table-scroll-wrapper]")
				);
				const productCardRow = this.infoRows[0];
				this.stickyBarAnimation = transition({
					el: document.querySelector("[data-compare-sticky-bar]"),
					state: "up",
					stateAttribute: "data-sticky-animation-state",
					stateChangeAttribute: "data-sticky-animation",
				});

				const animateToDown = () =>
					this.stickyBarAnimation.animateTo("down", {
						onStart: () => this.scrollLink.syncAll(),
					});

				this.tableObserver = null; // We recreate this observer each time to ensure the margin
				// accurately reflects the bar height but don't account
				// for screen resizes because it still works acceptably
				// if the margin isn't perfect.

				const createTableObserver = () => {
					const { top, height } = this.stickyBar.getBoundingClientRect();
					this.tableObserver = new IntersectionObserver(
						(_ref2) => {
							let [entry] = _ref2;

							if (!entry.isIntersecting) {
								this.stickyBarAnimation.animateTo("up");
								return;
							}

							animateToDown();
						},
						{
							rootMargin: `-${top + height}px 0px 0px 0px`,
							threshold: 0,
						}
					);
					this.tableObserver.observe(this.table);
				};

				const hasStickyHeader =
					document.body.classList.contains("site-header-sticky");
				this.stickyObserver = new IntersectionObserver(
					(_ref3) => {
						let [entry] = _ref3;

						if (!entry.isIntersecting) {
							animateToDown().then(createTableObserver);
							return;
						}

						if (this.tableObserver) {
							this.tableObserver.disconnect();
							this.tableObserver = null;
						}

						this.stickyBarAnimation.animateTo("up");
					},
					{
						rootMargin: `${hasStickyHeader ? "-100" : "0"}px 0px 0px 0px`,
						threshold: 0,
					}
				);
				this.stickyObserver.observe(productCardRow);
			}

			_setProductCountVar(count) {
				// Set this on the body so it also applies
				// to the cards in the sticky bar in the header
				document.body.style.setProperty(
					"--compare-products-count",
					Math.max(count, 2)
				);
			}
			/**
			 * @param {Integer} n Number of blank columns to add
			 */

			_addBlankColumns(n) {
				this.infoRows.forEach((row) => {
					const templateCell = row.querySelector(
						"[data-compare-cell-placeholder]"
					);
					this.templateCells[row.dataset.compareRowId] =
						templateCell.parentNode.removeChild(templateCell);

					for (let i = 0; i < n; i++) {
						row.appendChild(templateCell.cloneNode(true));
					}
				});
				this.headingRows.forEach((row) => {
					const heading = row.querySelector("[data-compare-heading]");
					heading.colSpan += n - 1; // allow for removed placeholder column
				});

				this._addScrollStops(this.el, n - 1);
			}

			_addScrollStops(el, n) {
				const scrollStop = el.querySelector("[data-compare-scroll-stop]");

				for (let i = 0; i < n; i++) {
					scrollStop.after(scrollStop.cloneNode(true));
				}
			}
			/**
			 * Removes product from compare
			 * @param {String} handle Handle to remove
			 */

			_removeHandle(handle) {
				if (this.allHandles.length === 1) {
					this.animateToEmptyState();
					components_ProductCompare.remove(handle);

					this._setProductCountVar(this.allHandles.length);

					return;
				}

				this._removeColumn(handle);

				this.allHandles = this.allHandles.filter((h) => h !== handle);

				this._setProductCountVar(this.allHandles.length);

				updateUrlForHandles(this.allHandles);
				components_ProductCompare.remove(handle);
			}
			/**
			 *
			 * @param {String} handle Handle for product to remove from table
			 */

			_removeColumn(handle) {
				const insertPlaceholders = this.allHandles.length <= 2;
				[this.stickyBarRow, ...this.infoRows].forEach((row) => {
					const cell = row.querySelectorAll("[data-compare-cell]")[
						this.allHandles.indexOf(handle)
					];

					if (insertPlaceholders) {
						cell.parentNode.append(
							this.templateCells[row.dataset.compareRowId].cloneNode(true)
						);
					}

					cell.remove();
				});

				if (!insertPlaceholders) {
					this.headingRows.forEach((row) => {
						const heading = row.querySelector("[data-compare-heading]");
						heading.colSpan--;
					});
					[this.stickyBar, this.el].forEach((el) => {
						// Scrollstops are identical, doesn't matter which one we remove.
						el.querySelector("[data-compare-scroll-stop]").remove();
					});
					this.showMoreToggles.forEach((toggle) => toggle.checkOverflow());
				}

				const productItemImages = this.el.querySelectorAll(
					"[data-product-item-image] img"
				);
				dist_index_es.instance.update(productItemImages);
			}
			/**
			 * Fetches data and populates the table based on a list of product handles.
			 *
			 * @param {[String]} handles Product handles for which to fetch data
			 */

			_fetchCompareProducts(handles) {
				return handles.map((handle, index) =>
					shopify_asyncview_dist_index_es
						.load(`${this.baseUrl}/${handle}`, this.sectionId, {
							view: "compare",
						})
						.then((_ref4) => {
							let { html } = _ref4;
							const parser = new DOMParser();
							const sourceEl = parser.parseFromString(html, "text/html"); // offset index to account for initial product

							this._populateContent(sourceEl, index + 1);
						})
				);
			}
			/**
			 * Populates content in this section's table
			 *
			 * @param {HTMLElement} source Element containing all source rows and cells
			 * @param {integer} columnIndex Index of target column for content
			 */

			_populateContent(source, columnIndex) {
				source
					.querySelectorAll('[data-compare-row-type="info"]')
					.forEach((row) => {
						const { compareRowId } = row.dataset; // Source data is always in the first cell

						const cellHTML = row.querySelector("[data-compare-cell]").innerHTML;
						const targetRow = this.el.querySelector(
							`[data-compare-row-id="${compareRowId}"]`
						);
						const targetCell = targetRow.querySelectorAll(
							"[data-compare-cell]"
						)[columnIndex];
						targetCell.innerHTML = cellHTML;
						targetCell
							.querySelectorAll("[data-compare-remove-on-populate")
							.forEach((el) => el.remove());

						this._initCell(targetCell);
					});
				this.showMoreToggles.forEach((toggle) => toggle.checkOverflow());
			}

			_updateBreadcrumbs() {
				const breadcrumb = this.el.querySelector("[data-compare-breadcrumb]");

				if (!components_ProductCompare.returnBreadcrumb) {
					breadcrumb.remove();
					return;
				}

				const { url, title } = components_ProductCompare.returnBreadcrumb;
				breadcrumb.href = url;

				if (title) {
					const breadcrumbText = breadcrumb.querySelector(
						"[data-compare-breadcrumb-text]"
					);
					breadcrumbText.innerHTML = this.data.breadcrumb.replace(
						"** location **",
						title
					);
				}

				const placeholders = this.el.querySelectorAll(
					"[data-compare-placeholder-link]"
				);
				placeholders.forEach((placeholder) => {
					placeholder.href = url;
				});
			}

			_removeAllFilters() {
				this.activeFilterIds.forEach((_, id) => {
					document.getElementById(id).checked = false;

					this._updateFilter({
						checked: false,
						id,
					});
				});
			}

			_disableFilters() {
				this.filtersDisabled = true;
				this.filtersEl
					.querySelectorAll("[data-compare-filter-checkbox]")
					.forEach((checkbox) => {
						checkbox.disabled = true;
					});
			}

			_updateFilter(_ref5) {
				let { checked, id } = _ref5;
				if (this.filtersDisabled) return;

				if (checked) {
					this.activeFilterIds.set(id, true);
					this.filterCheckboxes.get(id).check();
				} else {
					this.activeFilterIds.delete(id);
					this.filterCheckboxes.get(id).uncheck();
				}

				this._updateAppliedFilters();

				this._updateActiveFilterCount();

				const activeFilterCount = this.activeFilterIds.size;

				if (activeFilterCount === 0) {
					// show all rows
					this.allRows.forEach((row) => {
						row.style.display = "";
						row.classList.remove(lastRowClass);
					});
					return;
				}

				this.infoRows.forEach((row) => {
					if ("compareIgnoreFilter" in row.dataset) return;
					row.style.display = this.activeFilterIds.has(row.dataset.compareRowId)
						? ""
						: "none";
				});

				this._updateHeadersDisplay();
			}

			_updateAppliedFilters() {
				this.activeFiltersEl.innerHTML = "";
				this.activeFilterIds.forEach((_, id) => {
					const removeFilter =
						this.removeFilterTemplate.cloneNode(true).content;
					removeFilter.firstElementChild.dataset.productCompareFilterRemove =
						id;
					removeFilter.querySelector(
						"[data-compare-filter-remove-text]"
					).innerHTML = this.filterLabels[id];
					this.activeFiltersEl.append(removeFilter);
				});

				if (this.activeFilterIds.size) {
					this.activeFiltersContainer.style.display = "";
					this.activeFiltersEl.append(
						this.clearAllFiltersTemplate.cloneNode(true).content
					);
				} else {
					this.activeFiltersContainer.style.display = "none";
				}
			}

			_updateActiveFilterCount() {
				const filterText = this.el.querySelector("[data-compare-filter-text]");

				if (this.activeFilterIds.size > 0) {
					const filterTextString = this.data.filter_count.replace(
						"** count **",
						this.activeFilterIds.size
					);
					filterText.innerHTML = filterTextString;
				} else {
					filterText.innerHTML = this.data.filter_count_zero;
				}
			}
			/**
			 * Update visibility of header rows in table depending on visibility
			 * of info rows
			 */

			_updateHeadersDisplay() {
				let lastHeadingRow = null;
				let showLastHeading = false;
				let lastDisplayedRow = null;

				const updateHeadingDisplay = () => {
					if (lastHeadingRow) {
						lastHeadingRow.style.display = showLastHeading ? "" : "none";
					}
				};

				const updateLastDisplayedRow = () => {
					if (lastDisplayedRow) {
						lastDisplayedRow.classList.add(lastRowClass);
					}
				};

				this.allRows.forEach((row) => {
					row.classList.remove(lastRowClass);

					if (row.dataset.compareRowType === "heading") {
						updateHeadingDisplay();
						updateLastDisplayedRow();
						lastHeadingRow = row;
						showLastHeading = false;
						lastDisplayedRow = null;
					} else if (
						this.activeFilterIds.has(row.dataset.compareRowId) ||
						"compareIgnoreFilter" in row.dataset
					) {
						lastDisplayedRow = row;
						showLastHeading = true;
					}
				});
				updateHeadingDisplay();
				updateLastDisplayedRow();
			}
			/**
			 * Move active filters element into sidebar so it appears in the modal
			 */

			_onBeforeFiltersModalOpen() {
				this.mobileActiveFiltersTarget.before(this.activeFiltersEl);
			}
			/**
			 * Move active filters element back into normal location
			 */

			_onFiltersModalClose() {
				this.activeFiltersContainer.append(this.activeFiltersEl);
			}

			_initCell(el) {
				const productItemDescription = el.querySelector(
					"[data-compare-description]"
				);

				if (productItemDescription) {
					this.descriptionItems.push(new RichText(productItemDescription));
					this.showMoreToggles.push(
						new ShowMoreToggle({
							el,
							context: this.data.context,
						})
					);
				}

				this._initProductItems(el);

				setupRippleEffect(el);
			}

			_initProductItems(el) {
				const productItemEls = el.querySelectorAll("[data-product-item]");
				productItemEls.forEach((productItem) => {
					dist_index_es.watch(el);
					this.productItems.push(
						new ProductGridItem({
							el: productItem,
							id: this.sectionId,
							disableActionsToggle: true,
							lazy: false,
						})
					);
				});

				if (productItemEls.length && window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/components/ProductRowScroller.js
		class ProductRowScroller {
			constructor(productRow) {
				this.$window = $(window);
				this.flickity = null;
				this.productRow = productRow;
				this.$productRow = $(this.productRow); // Activate flickity on mobile

				this._mobileSlider = this._mobileSlider.bind(this);
				Layout.onBreakpointChange(this._mobileSlider);

				this._mobileSlider();
			}

			unload() {
				Layout.offBreakpointChange(this._mobileSlider);

				this._destroyFlickity();
			}

			_initFlickity() {
				this.flickity = new (js_default())(this.productRow, {
					cellSelector: ".productgrid--item",
					contain: true,
					freeScroll: true,
					percentPosition: false,
					prevNextButtons: false,
					pageDots: false,
					setGallerySize: false,
				});

				this._bindSlider();
			}

			_destroyFlickity() {
				if (!this.flickity) {
					return;
				}

				this.$window.off(".product-row");
				this.$productRow.off(".product-row");
				this.flickity.destroy();
				this.flickity = null;
			}

			_mobileSlider() {
				// If is Large layout, attempt to destroy flickity
				if (Layout.isGreaterThanBreakpoint("M")) {
					this._destroyFlickity();

					return;
				} // Is XS/S/M, and flickity is init'd -- do nothing

				if (this.flickity) {
					return;
				} // Is XS/S/M, and flickity is not init'd

				this._initFlickity();
			}

			_bindSlider() {
				const $slider = this.$productRow.find(".flickity-slider");
				this.$window.on(
					"resize.product-row",
					just_debounce_default()(() => {
						this.$productRow.trigger("heightUpdate.product-row");
					})
				);
				this.flickity.on("cellSelect", () => {
					this.$productRow.trigger("heightUpdate.product-row");
				});
				this.$productRow.on("heightUpdate.product-row", () => {
					if (!this.flickity) {
						return;
					}

					$slider.height(Math.ceil(this.flickity.maxCellHeight));
				}); // Sets the Slider to the height of the first slide

				this.$productRow.trigger("heightUpdate.product-row");
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/StaticProductRecommendations.js
		// eslint-disable-line

		class StaticProductRecommendations {
			constructor(section) {
				this.section = section;
				this.productId = section.data.productId;
				this.limit = section.data.settings.limit;
				this.recommendedProducts = [];
				this.productsScroller = null;
				this.sectionId = section.data.sectionId;
				this.recommendationContainer = document.querySelector(
					"[data-product-recommendations]"
				);
				this.recommendUrl = `${window.Theme.routes.product_recommendations_url}?section_id=${this.sectionId}&limit=${this.limit}&product_id=${this.productId}`;
				this._loadRecommendations = this._loadRecommendations.bind(this);
				this._resizeRowScroller = this._resizeRowScroller.bind(this);

				this._loadRecommendations();
			}

			_loadRecommendations() {
				shopify_asyncview_dist_index_es
					.load(this.recommendUrl, {
						view: "",
					})
					.then((_ref) => {
						let { html } = _ref;
						this.recommendationContainer.innerHTML = html;
						dist_index_es.watch(this.recommendationContainer);
						const productItems = this.recommendationContainer.querySelectorAll(
							"[data-product-item]"
						);
						const productItemLazyLoad = Layout.isGreaterThanBreakpoint(
							"L",
							true
						);

						if (productItems.length) {
							productItems.forEach((productItem) => {
								this.recommendedProducts.push(
									new ProductGridItem({
										el: productItem,
										id: this.section.id,
										lazy: productItemLazyLoad,
									})
								);
							});
							initShopifyProductReviews();

							if (window.Shopify && Shopify.PaymentButton) {
								Shopify.PaymentButton.init();
							}

							this.recommendationContainer.addEventListener(
								"rimg:load",
								this._resizeRowScroller
							);
							this.productsScroller = new ProductRowScroller(
								this.section.el.querySelector("[data-product-row]")
							);
						}
					});
			}

			_resizeRowScroller() {
				if (this.productsScroller && this.productsScroller.flickity) {
					this.productsScroller.flickity.resize();
				}
			}

			onSectionUnload() {
				if (this.productsScroller) {
					this.productsScroller.unload();
				}

				this.recommendedProducts.forEach((productItem) => {
					productItem.unload();
				});
				this.recommendationContainer.removeEventListener(
					"rimg:load",
					this._resizeRowScroller
				);
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/StaticRecentlyViewed.js
		class StaticRecentlyViewed {
			constructor(section) {
				this.namespace = "pxu";
				this.maxRecentlyViewed = 30; // Store a max of 30 items

				this.maxStorageTime = 30 * 24 * 3600; // Store items for 30 days only

				this.version = `${section.data.currency}-${window.Theme.routes.root_url}`; // Version key is used to update localstorage when format changes

				this.storageKey = `${this.namespace}-recentlyViewed-${this.version}`;
				this.$el = jquery_default()(section.el);
				this.time = section.data.time;
				this.flickity = null;
				this.recentlyViewed = section.data.recently_viewed_info;
				this.cardSettings = section.data.product_card_settings;

				if (this.recentlyViewed && this.time) {
					this.recentlyViewed.timestamp = Math.round(
						new Date().getTime() / 1000
					);
				}

				this.slideImageLoaded = this._onSlideImageLoaded.bind(this);
				let recentlyViewed = [];

				if (this.time) {
					recentlyViewed = this._getRecentlyViewed();

					if (this.recentlyViewed) {
						this.removeRecentlyViewed(
							this.recentlyViewed.handle,
							recentlyViewed
						);
						recentlyViewed.push(this.recentlyViewed);
					}

					const promises = this._setRecentlyViewed(recentlyViewed); // Wait until promises are resolved before inserting markup into the DOM

					jquery_default()
						.when(...promises)
						.done(() => {
							if (recentlyViewed.length) {
								const cardsMarkup = this._getRecentlyViewedCards();

								const cardsData = this._getRecentlyViewed();

								this.$el
									.find("[data-recently-viewed-container]")
									.append(cardsMarkup);
								cardsData.forEach((productData) => {
									const timestamp = this.timeSince(productData.timestamp);
									jquery_default()(
										`[data-product-handle=${productData.handle}]`
									).prepend(timestamp);
								});
								dist_index_es.watch(this.$el[0]);
								this.$carousel = this.$el.find(
									".product-recently-viewed__content"
								);
								this.slides = ".product-recently-viewed-card";

								if (this.$carousel.find(this.slides).length > 1) {
									this._initSlider();
								}
							} else {
								this.$el
									.find(".product-recently-viewed--section")
									.addClass("hide");
							}
						});
				} else {
					if (this.recentlyViewed) {
						recentlyViewed.push(this.recentlyViewed);

						this._setRecentlyViewed(recentlyViewed);
					}

					this.$el.find(".product-recently-viewed--section").addClass("hide");
				}

				this.bindEvents();
			}

			bindEvents() {
				this.$el.on("click", "[data-remove-recently-viewed]", (event) => {
					const $target = jquery_default()(event.currentTarget);
					const handle = $target
						.closest("[data-product-handle]")
						.data("product-handle");

					const recentlyViewed = this._getRecentlyViewed();

					this.removeRecentlyViewed(handle, recentlyViewed);

					this._setRecentlyViewed(recentlyViewed);

					$target.parents("[data-recently-viewed-card]").addClass("hide-card");
					$target
						.parents("[data-recently-viewed-card]")
						.nextAll()
						.addClass("move-card");
					setTimeout(() => {
						let index = $target.parents("[data-recently-viewed-card]").index();

						if (index !== 0) {
							index--;
						}

						$target
							.parents("[data-recently-viewed-card]")
							.nextAll()
							.removeClass("move-card");

						if ($target.parents("[data-recently-viewed-card]").length) {
							this.flickity.remove(
								$target.parents("[data-recently-viewed-card]")
							);
						}

						this.flickity.selectCell(index);
					}, 500);
				});
				this.$el.on("click", "[data-clear-recently-viewed]", () => {
					this.clearRecentlyViewed();
				});
			}

			timeSince(timestamp) {
				const now = Math.round(new Date().getTime() / 1000);
				const secondsPast = now - timestamp;
				const { lang } = document.documentElement;
				const options = {
					month: "long",
				};

				if (secondsPast < 60) {
					const secondsAgo = parseInt(secondsPast, 10);
					return secondsAgo === 1
						? `${secondsAgo} ${this.time.second} ${this.time.ago}`
						: `${secondsAgo} ${this.time.seconds} ${this.time.ago}`;
				}

				if (secondsPast < 3600) {
					const minutesAgo = parseInt(secondsPast / 60, 10);
					return minutesAgo === 1
						? `${minutesAgo} ${this.time.minute} ${this.time.ago}`
						: `${minutesAgo} ${this.time.minutes} ${this.time.ago}`;
				}

				if (secondsPast <= 86400) {
					const hoursAgo = parseInt(secondsPast / 3600, 10);
					return hoursAgo === 1
						? `${hoursAgo} ${this.time.hour} ${this.time.ago}`
						: `${hoursAgo} ${this.time.hours} ${this.time.ago}`;
				}

				const date = new Date(timestamp * 1000);
				const currentDate = new Date(now * 1000);
				const day = date.getDate();
				const month = date.toLocaleDateString(lang, options);
				const year =
					date.getFullYear() === currentDate.getFullYear()
						? ""
						: `, ${date.getFullYear()}`;
				return `${month} ${day} ${year}`;
			}

			removeRecentlyViewed(handle, recentlyViewed) {
				for (let i = 0; i < recentlyViewed.length; i++) {
					if (recentlyViewed[i].handle === handle) {
						recentlyViewed.splice(i, 1);
					}
				}

				this._setRecentlyViewed(recentlyViewed);

				const cards = sessionStorage.getItem(this.storageKey)
					? JSON.parse(sessionStorage.getItem(this.storageKey))
					: {};
				delete cards[handle];
				sessionStorage.setItem(this.storageKey, JSON.stringify(cards));

				if (recentlyViewed.length === 0) {
					this.$el.find(".product-recently-viewed--section").addClass("hide");
				}

				if (this.$carousel) {
					this.$carousel[0].removeEventListener(
						"rimg:load",
						this.slideImageLoaded
					);
				}
			}

			clearRecentlyViewed() {
				localStorage.removeItem(this.storageKey);
				sessionStorage.removeItem(this.storageKey);
				this.$el.find("[data-recently-viewed-card]").remove();
				this.$el.find(".product-recently-viewed--section").addClass("hide");
			}

			_onSlideImageLoaded() {
				this.flickity.resize();
			}

			_initSlider() {
				this.flickityOptions = {
					autoPlay: 0,
					accessibility: true,
					cellAlign: "left",
					cellSelector: this.slides,
					groupCells: true,
					pageDots: false,
					contain: true,
					arrowShape: {
						x0: 10,
						x1: 60,
						y1: 50,
						x2: 65,
						y2: 45,
						x3: 20,
					},
				};
				this.flickity = new (js_default())(
					this.$carousel[0],
					this.flickityOptions
				);
				this.$carousel[0].addEventListener("rimg:load", this.slideImageLoaded);
			}
			/**
			 * Store recently viewed products
			 *
			 * @param {Object[]} productData - recently viewed products
			 * @param {number} productData[].timestamp - indicating when product was added to productData
			 * @param {string} productData[].handle - Shopify product handle
			 * @private
			 */

			_setRecentlyViewed(productData) {
				const now = Math.floor(Date.now() / 1000); // Unix timestamp for current date

				const minStorageTimestamp = now - this.maxStorageTime;
				const filteredData = productData.filter(
					(item) => item.timestamp > minStorageTimestamp
				);

				if (filteredData.length > this.maxRecentlyViewed) {
					const removeCount = filteredData.length - this.maxRecentlyViewed;
					filteredData.splice(0, removeCount); // Remove oldest if more than max number have been stored
				}

				try {
					localStorage.setItem(this.storageKey, JSON.stringify(filteredData));
				} catch (error) {
					console.warn(error);
				} // Retrieve markup for recently viewed cards and store in session

				try {
					const handles = filteredData ? filteredData.map((x) => x.handle) : [];
					let storedCards = sessionStorage.getItem(this.storageKey)
						? JSON.parse(sessionStorage.getItem(this.storageKey))
						: {};

					if (storedCards.cardSettings) {
						Object.keys(storedCards.cardSettings).forEach((key) => {
							if (storedCards.cardSettings[key] !== this.cardSettings[key]) {
								storedCards = {};
								sessionStorage.removeItem(this.storageKey);
							}
						});
					}

					storedCards.cardSettings = this.cardSettings;
					const promises = handles.map((handle) => {
						if (storedCards[handle]) {
							return null;
						}

						const fetchUrl = `${window.Theme.routes.all_products_collection_url}/products/${handle}?view=recently-viewed`;
						return jquery_default()
							.get(fetchUrl)
							.then((response) => {
								if (response) {
									storedCards[handle] = response;

									try {
										sessionStorage.setItem(
											this.storageKey,
											JSON.stringify(storedCards)
										);
									} catch (error) {
										console.warn(error);
									}
								}
							})
							.catch((error) => console.error("Error:", error));
					});
					return promises;
				} catch (error) {
					console.warn(error);
					return false;
				}
			}
			/**
			 * Get stored recently viewed products
			 *
			 * @returns {Array}
			 * @private
			 */

			_getRecentlyViewed() {
				try {
					const recentlyViewed = localStorage.getItem(this.storageKey)
						? JSON.parse(localStorage.getItem(this.storageKey))
						: [];
					return recentlyViewed;
				} catch (error) {
					console.warn(error);
					return [];
				}
			}

			_getRecentlyViewedCards() {
				const cards = sessionStorage.getItem(this.storageKey)
					? JSON.parse(sessionStorage.getItem(this.storageKey))
					: {};
				const orderedItems = localStorage.getItem(this.storageKey)
					? JSON.parse(localStorage.getItem(this.storageKey))
					: {};
				const markup = [];

				for (let i = orderedItems.length - 1; i >= 0; i--) {
					const cardKey = orderedItems[i].handle; // When store password is enabled and viewing the product page in preview
					// mode, product cards for products which have been deleted from the admin
					// will return the password page. Before inserting the card markup, we
					// need to check that it contains a product.

					const domParser = new DOMParser();
					const card = domParser.parseFromString(cards[cardKey], "text/html");

					if (card.querySelector(".productgrid--item")) {
						markup.push(cards[cardKey]);
					}
				}

				return markup.join("");
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/StaticSearch.js
		class StaticSearch {
			constructor(section) {
				this.section = section;
				this.el = section.el;
				this.searchField = this.el.querySelector("[data-live-search]"); // Product items

				this.productItems = [];
				const productItems = this.el.querySelectorAll("[data-product-item]");
				productItems.forEach((productItem) => {
					this.productItems.push(
						new ProductGridItem({
							el: productItem,
							id: this.section.id,
							lazy: true,
						})
					);
				});
				this.searchForm = new SearchForm(this.searchField);
			}

			onSectionUnload() {
				this.searchForm.unload();
				this.productItems.forEach((productItem) => {
					productItem.unload();
				});
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/StaticUtilityBar.js
		class StaticUtilityBar {
			constructor(section) {
				this.el = section.el; // Utility Menu Variables

				this.mobileUtilityMenuEl = section.el.querySelector(
					"[data-utility-menu-mobile]"
				);
				this.mobileNavContentEl = null;
				this.mobileElChildren = [];
				this.documentFragmentMenu = document.createDocumentFragment();
				this.mobileLayout = section.data.settings.mobile_layout;
				this._loadMobileNavItems = this._loadMobileNavItems.bind(this); // Utility Bar Variables - Disclosure & Social List

				this.mobileUtilityBarEl = section.el.querySelector(
					"[data-utility-bar-mobile]"
				);
				this.mobileUtilityContentEl = null;
				this.mobileUtilityChildren = [];
				this.mobileUtilityPlacement = document.querySelector(
					"[data-utility-mobile]"
				);
				this.documentFragmentDisclosure = document.createDocumentFragment();
				this._loadMobileUtilityItems = this._loadMobileUtilityItems.bind(this);
				this.mobileScrollHeight = document.querySelector(
					"[data-mobile-nav-content]"
				);
				this.mobileUtilitySocial = document.querySelector(
					"[data-utility-social-mobile]"
				);
				this.countryDisclosureEl = this.el.querySelector(
					"[data-disclosure-country]"
				);
				this.localeDisclosureEl = this.el.querySelector(
					"[data-disclosure-locale]"
				);
				this.disclosures = [];

				if (this.mobileUtilityMenuEl) {
					this._loadMobileNavItems();

					window.addEventListener(
						"shopify:section:load",
						this._loadMobileNavItems
					);
				}

				if (this.mobileUtilityBarEl) {
					this._loadMobileUtilityItems();

					window.addEventListener(
						"shopify:section:load",
						this._loadMobileUtilityItems
					);
				}

				if (this.countryDisclosureEl) {
					this.disclosures.push(
						new shopify_cross_border_dist_index_es(this.countryDisclosureEl)
					);
				}

				if (this.localeDisclosureEl) {
					this.disclosures.push(
						new shopify_cross_border_dist_index_es(this.localeDisclosureEl)
					);
				}

				if (this.mobileUtilitySocial) {
					this.mobileScrollHeight.classList.add("utility-social-enabled");
				}
			}

			onSectionUnload() {
				window.removeEventListener(
					"shopify:section:load",
					this._loadMobileNavItems
				);
				window.removeEventListener(
					"shopify:section:load",
					this._loadMobileUtilityItems
				);

				if (this.mobileNavContentEl) {
					this.mobileElChildren.forEach((child) =>
						this.mobileNavContentEl.removeChild(child)
					);
				}

				if (this.mobileUtilityContentEl) {
					this.mobileUtilityChildren.forEach((child) =>
						this.mobileUtilityPlacement.removeChild(child)
					);
				}

				this.disclosures.forEach((disclosure) => disclosure.unload());
			}

			_loadMobileNavItems() {
				const inDom = this.mobileElChildren.some((child) =>
					document.body.contains(child)
				); // If utility nav already exists in mobile flyout, return

				if (inDom) return;
				this.mobileNavContentEl = document.querySelector(
					"[data-mobile-nav-content]"
				);
				this.mobileElChildren = [];

				if (this.mobileNavContentEl) {
					const { children } = this.mobileUtilityMenuEl;

					for (let i = 0; i < children.length; i++) {
						const clone = children[i].cloneNode(true);
						this.mobileElChildren.push(clone);
						this.documentFragmentMenu.appendChild(clone);
					}

					if (this.mobileLayout === "below") {
						this.mobileNavContentEl.appendChild(this.documentFragmentMenu);
						this.mobileNavContentEl.classList.add("utility-nav-below");
					} else {
						this.mobileNavContentEl.insertBefore(
							this.documentFragmentMenu,
							this.mobileNavContentEl.firstElementChild
						);
					}
				}
			}

			_loadMobileUtilityItems() {
				const inDom = this.mobileUtilityChildren.some((child) =>
					document.body.contains(child)
				); // If utility content already exists in mobile flyout, return

				if (inDom) return;
				this.mobileUtilityContentEl = document.querySelector(
					"[data-utility-bar-mobile]"
				);
				this.mobileUtilityChildren = [];

				if (this.mobileUtilityContentEl) {
					const { children } = this.mobileUtilityContentEl;

					for (let i = 0; i < children.length; i++) {
						const clone = children[i].cloneNode(true);
						this.mobileUtilityChildren.push(clone);
						this.documentFragmentDisclosure.appendChild(clone);
					}

					this.mobileUtilityPlacement.appendChild(
						this.documentFragmentDisclosure
					);
					const countryDisclosureElMobile =
						this.mobileUtilityPlacement.querySelector(
							"[data-disclosure-country]"
						);
					const localeDisclosureElMobile =
						this.mobileUtilityPlacement.querySelector(
							"[data-disclosure-locale]"
						);

					if (countryDisclosureElMobile) {
						this.disclosures.push(
							new shopify_cross_border_dist_index_es(countryDisclosureElMobile)
						);
					}

					if (localeDisclosureElMobile) {
						this.disclosures.push(
							new shopify_cross_border_dist_index_es(localeDisclosureElMobile)
						);
					}
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/StaticSubCollectionsMenuList.js
		class StaticSubCollectionsMenuList {
			constructor(section) {
				this.el = section.el;
				this.context = section.data.context;
				this.handleEvents = new EventHandler /* default */.Z();
				this.accordionTrigger = "[data-accordion-trigger]";
				this.mobileAccordionOpen = this.el.querySelector(
					".mobile-accordion__open--true"
				);
				this.Accordion = new Accordion(this.el, {
					content: "[data-accordion-content]",
					onStart: (_ref) => {
						let { el, state } = _ref;
						el.parentNode.querySelector(
							this.accordionTrigger
						).dataset.accordionTrigger = state;
					},
				});

				if (this.mobileAccordionOpen) {
					this.Accordion.openAll({
						force: true,
					});
				} else if (cjs.max("XS")) {
					this.Accordion.closeAll({
						force: true,
					});

					this._addAccordionClickEvent();
				} // Handle Accordion interaction when window size changes

				cjs.onChange((breakpoints) => this.onBreakpointChange(breakpoints));
			}

			onSectionUnload() {
				this.Accordion.unload();
				this.handleEvents.unregisterAll();
			}

			onSectionBlockSelect(block) {
				this._toggleAccordion(block.el);
			}

			onSectionBlockDeselect(block) {
				this._toggleAccordion(block.el);
			}

			_addAccordionClickEvent() {
				this.el.querySelectorAll(this.accordionTrigger).forEach((el) => {
					this.handleEvents.register(el, "click", (event) => {
						event.preventDefault();

						this._toggleAccordion(event.currentTarget.parentNode);
					});
				});
			}

			_toggleAccordion(block) {
				if (cjs.min("S")) return;
				this.Accordion.toggle(block);
			}

			onBreakpointChange(breakpoints) {
				if (breakpoints.current.min("S") || this.mobileAccordionOpen) {
					this.Accordion.openAll({
						force: true,
					});
					this.handleEvents.unregisterAll();
				} else if (
					breakpoints.previous.min("S") &&
					breakpoints.current.max("XS")
				) {
					this.Accordion.closeAll({
						force: true,
					});

					this._addAccordionClickEvent();
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/components/FeaturedCollection.js
		class FeaturedCollection {
			constructor(_ref) {
				let { el, sectionId } = _ref;
				this.el = el;
				this.contentWrapperEl = el.querySelector("[data-content-wrapper]");
				this.contentEl = el.querySelector("[data-content]");
				this.events = new EventHandler /* default */.Z();
				this._resizeObserver = new ResizeObserver(() => {
					let foundTransitionEnd = false;
					this.events.register(this.el, "transitionend", () => {
						foundTransitionEnd = true;
					});
					setTimeout(() => {
						if (foundTransitionEnd) return;

						if (this.flickity && "resize" in this.flickity) {
							this.flickity.resize();
						}
					}, 500);
				});
				/*
				 * We keep reference to the original layout of the collection
				 * because dependent upon viewport width, we may need to enforce
				 * one layout over the other.
				 */

				this.initialLayout = this.contentEl.dataset.layout; // Product items

				this.productItems = [];
				const productItemsEls = this.el.querySelectorAll("[data-product-item]");
				productItemsEls.forEach((productItemEl) => {
					this._resizeObserver.observe(
						productItemEl.querySelector(".productitem__container")
					);

					this.productItems.push(
						new ProductGridItem({
							el: productItemEl,
							id: sectionId,
							lazy: false,
						})
					);
				});

				if (this.initialLayout === "slideshow") {
					window.requestAnimationFrame(() => this._initializeFlickity());
				} else {
					this.onBreakpointChange = () => {
						const useSlideshow = Layout.isLessThanBreakpoint("XL");

						if (useSlideshow) {
							this._initializeFlickity();
						} else {
							this._destroyFlickity();
						}
					};

					Layout.onBreakpointChange(this.onBreakpointChange);

					if (Layout.isLessThanBreakpoint("XL")) {
						window.requestAnimationFrame(() => this._initializeFlickity());
					}
				}
			}

			unload() {
				this.productItems.forEach((productItem) => productItem.unload());
				Layout.offBreakpointChange(this.onBreakpointChange);
				this.events.unregisterAll();

				this._destroyFlickity();
			}

			_initializeFlickity() {
				if (this.flickity) return; // Already initialized

				this.contentEl.dataset.layout = "slideshow";
				this.flickity = new (js_default())(this.contentEl, {
					autoPlay: 0,
					accessibility: true,
					cellAlign: "left",
					cellSelector: ".productgrid--item",
					groupCells: true,
					pageDots: false,
					contain: true,
					arrowShape:
						"M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z",
				});
				const { resize } = js_default().prototype;
				const viewport = this.contentEl.querySelector(".flickity-viewport");
				const slider = this.contentEl.querySelector(".flickity-slider");
				/*
				 * We must wrap Flickity's slider element to allow the usage of
				 * clip, and clip-path to obscure the overflow product items.
				 * To use clip, and clip-path, the clipped element must be absolutely
				 * positioned. In this case, the only native Flickity element
				 * that is absolutely positioned is the slider; but, it moves with the first
				 * slide rather than remaining in the viewport removing it as a candidate.
				 * Therefore, it is necessary to include a wrapper element that we can
				 * absolutely position that remains within the viewport.
				 * The only thing we need to watch out for is that the elements
				 * are moved in a non-destructive manner.
				 */

				const sliderWrapper = document.createElement("div");
				sliderWrapper.classList.add("flickity-slider--wrapper");
				viewport.appendChild(sliderWrapper);
				sliderWrapper.appendChild(slider);

				this.flickity.resize = function r() {
					viewport.style.height = "";
					resize.call(this);
				};

				this.events.register(this.el, "transitionend", () =>
					this.flickity.resize()
				);
			}

			_destroyFlickity() {
				if (!this.flickity) return; // Already uninitialized

				this.contentEl.dataset.layout = this.initialLayout;
				const viewport = this.contentEl.querySelector(".flickity-viewport");
				const slider = this.contentEl.querySelector(".flickity-slider");
				/*
				 * Remember to move the Flickity native elements back
				 * into the correct DOM layout, before removing the added
				 * wrapper.
				 */

				const sliderWrapper = this.contentEl.querySelector(
					".flickity-slider--wrapper"
				);
				viewport.appendChild(slider);
				viewport.removeChild(sliderWrapper);
				this.flickity.destroy();
				this.flickity = null;
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/StaticSubcollectionsFeaturedCollection.js
		class StaticSubcollectionsFeaturedCollection {
			constructor(section) {
				const collectionEls = section.el.querySelectorAll(
					"[data-featured-collection]"
				);
				this.collections = Array.prototype.map.call(
					collectionEls,
					(collectionEl) =>
						new FeaturedCollection({
							el: collectionEl,
							sectionId: section.id,
						})
				);
				this.showMoreToggle = new ShowMoreToggle({
					el: section.el,
					context: section.data.context,
				});
			}

			onSectionUnload() {
				this.collections.forEach((collection) => collection.unload());
				this.showMoreToggle.unload();
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/FacetedFilterCollection.js
		class FacetedFilterCollection extends StaticCollection {
			constructor(section) {
				super(section);
				this.el = section.el;
				this.filterInputs = null;
				this.filterEvents = new EventHandler /* default */.Z();
				this.updateTimeout = null;
				this._initFilterEvents = this._initFilterEvents.bind(this);
				this._updatePrice = this._updatePrice.bind(this);
				this._buildFilterQuery = this._buildFilterQuery.bind(this);
				this.filterGroups = section.data.filter_groups;
				this.filterStyle = section.data.filter_style;
				this.filtersContentSelector = "[data-productgrid-sidebar]";
				this.filtersContent = this.el.querySelector(
					this.filtersContentSelector
				);
				this.filterRange = this.el.querySelectorAll("[data-filter-range]");
				this.rangeNames = [];
				this.filterRange.forEach((el) => {
					this.rangeNames.push(el.name);
				});
				this.allowedQueryParams = ["view", "sort_by", "grid_list"];

				if (this.filtersContent) {
					const options = {
						groups: this.filterGroups,
						style: this.filterStyle,
					};
					this.filterGroupAccordions = new FilterGroups(
						this.filtersContent,
						options
					);

					this._initFilters();
				}

				this.forms = new Forms(this.el);

				this._initFilterEvents();
			}

			_initFilterEvents() {
				/* For radio buttons */
				this.filterInputs = this.el.querySelectorAll("[data-filter-input]");
				this.filterInputs.forEach((filter) => {
					this.filterEvents.register(filter, "click", (e) => {
						e.preventDefault();
						const target = e.currentTarget;
						if (target.dataset.hasOwnProperty("disabled")) return;
						const handle = target.getAttribute("data-handle");
						let animateTo = "checked";

						if (target.getAttribute("data-filter-active")) {
							animateTo = "unchecked";
							target.removeAttribute("data-filter-active");
						} else {
							target.setAttribute("data-filter-active", "");
						}

						if (this.fillAnimations[handle] && this.checkAnimations[handle]) {
							this.fillAnimations[handle].animateTo(animateTo);
							this.checkAnimations[handle].animateTo(animateTo);
						}

						this.getFilteredResults(e.currentTarget);
					});
				});
				/* For range input */

				this.filterRange.forEach((filter) => {
					this.filterEvents.register(filter, "keyup", (e) =>
						this._updatePrice(e.currentTarget)
					);
					this.filterEvents.register(filter, "change", (e) =>
						this._updatePrice(e.currentTarget)
					);
				});
				this.filterAccordionButton = this.el.querySelectorAll(
					"[data-filter-group-trigger]"
				);
				this.filterAccordionButton.forEach((filter) => {
					this.filterEvents.register(filter, "click", (e) => {
						e.preventDefault();
					});
				});
			}
			/*
			 * Initialize animations on checkbox container
			 * using filter tag as JSON key
			 */

			_initAnimations() {
				this.filterCheckboxes.forEach((el) => {
					const tagHandle = el.dataset.handle;
					const checkmark = el.querySelector(".checkmark");
					const checkmarkCheck = el.querySelector(".checkmark__check");
					let state = "unchecked";

					if (
						el.closest("[data-filter-input]").getAttribute("data-filter-active")
					) {
						state = "checked";
					}

					const fillAnimation = transition({
						el: checkmark,
						state,
					});
					const checkAnimation = transition({
						el: checkmarkCheck,
						state,
					});
					this.fillAnimations[tagHandle] = fillAnimation;
					this.checkAnimations[tagHandle] = checkAnimation;
				});
			}

			_initFilters() {
				const activePriceFilter = this.el.querySelector(
					"[data-filter-group-range]"
				);
				this.filterRange.forEach((priceInput) => {
					if (priceInput.value.length > 0) {
						activePriceFilter.setAttribute("data-filter-open", "true");
					}
				});
				const activeFilters = this.el.querySelectorAll(
					'[data-filter-open="true"]'
				);
				activeFilters.forEach((filter) => {
					this._openActiveGroup(filter);
				});
			}

			_openActiveGroup(filter) {
				const button = filter
					.closest("[data-filter-group]")
					.querySelector("[data-filter-group-trigger]");
				const list = filter.closest("[data-accordion-content]");
				this.filterGroupAccordions.openGroup(button, list, true);
			}

			_buildFilterQuery(element) {
				let searchParameters; // If input is price range, the url_to_add property is not available, so we
				// need to build the query manually

				if (
					element.classList.contains("collection-filters__filter-range-input")
				) {
					const currentSearch = window.location.search.replace("?", "");
					const formData = new FormData(element.closest("form"));
					const newSearch = new URLSearchParams(formData).toString(); // Filter through current search string to see if price range input already exists,
					// if it does, create new string without current price range parameters

					const splitCurrentSearch = currentSearch.split("&");
					let filteredCurrentSearch = splitCurrentSearch.filter((search) => {
						if (
							search.includes(this.rangeNames[0]) ||
							search.includes(this.rangeNames[1])
						) {
							return false;
						}

						return true;
					});
					filteredCurrentSearch = filteredCurrentSearch.join("&"); // If current search parameters exist, append new search parameters
					// on to existing parameters

					if (filteredCurrentSearch.length > 0) {
						searchParameters = `${filteredCurrentSearch}&${newSearch}`;
					} else {
						searchParameters = `${newSearch}`;
					}
				} else {
					// If input is a link, build searchParameters using dataset URL
					const elementUrl = element.dataset.url;
					let decodedElementUrl = null;

					if (elementUrl[0] === "/") {
						searchParameters = elementUrl.split("?")[1];
					} else {
						decodedElementUrl = decodeURIComponent(elementUrl);
						searchParameters = decodedElementUrl.split("?")[1];
					}

					if (!searchParameters) {
						searchParameters = "";
					}
				} // We have to account for the sortby and view params stored in Shopify.queryParams

				const shopifyQueryParams = Object.entries(Shopify.queryParams);
				let shopifyQueries = [];
				shopifyQueryParams.forEach((query) => {
					// Make sure we're not duplicating any search parameters
					if (
						!searchParameters.includes(query[0]) &&
						this.allowedQueryParams.includes(query[0])
					) {
						shopifyQueries.push(query.join("="));
					}
				});
				shopifyQueries = shopifyQueries.join("&");
				let urlQueryString = "";

				if (shopifyQueries && searchParameters) {
					urlQueryString = `?${searchParameters}&${shopifyQueries}`;
				} else if (searchParameters && !shopifyQueries) {
					urlQueryString = `?${searchParameters}`;
				} else {
					urlQueryString = `?${shopifyQueries}`;
				}

				return urlQueryString;
			}

			_updatePrice(element) {
				// cancel any pending requests
				if (this.updateTimeout !== null) {
					clearTimeout(this.updateTimeout);
				} // Wait for user to finish entering input before reloading page

				this.updateTimeout = setTimeout(() => {
					this.getFilteredResults(element);
				}, 2000);
			}
			/**
			 * Change sorting of collection
			 *
			 * @param event
			 * @private
			 */

			_changeSorting(event) {
				event.preventDefault();
				const target = event.currentTarget;
				const url = new URL(window.location);
				url.searchParams.set("sort_by", target.value);
				window.location.search = url.search;
			}
			/**
			 * Toggle grid or list view
			 *
			 */

			_toggleView(event) {
				const target = event.currentTarget;
				const url = new URL(window.location);
				url.searchParams.set("grid_list", target.dataset.collectionView);
				window.location.search = url.search;
			}
			/**
			 * Make Shopify aware of releavent collection search info
			 *  - tag
			 *  - vendor
			 *  - pagination
			 *  - sorting criteria
			 *
			 * @private
			 */

			_setSortByQueryParameters() {
				Shopify.queryParams = {}; // We should only update Shopify.queryParams with grid/list view, sortby and view
				// so we'll create an allow-list of params

				const allowedQueryParams = ["view", "sort_by", "grid_list"];
				const queryPairs = location.search.substr(1).split("&");

				if (location.search.length) {
					queryPairs.forEach((query) => {
						const queryKeyValue = query.split("=");

						if (
							queryKeyValue.length > 1 &&
							allowedQueryParams.includes(queryKeyValue[0])
						) {
							Shopify.queryParams[decodeURIComponent(queryKeyValue[0])] =
								decodeURIComponent(queryKeyValue[1]);
						}
					});
				}
			}

			_stringifyShopifyQueries() {
				const shopifyQueryParams = Object.entries(Shopify.queryParams);
				let shopifyQueries = [];
				shopifyQueryParams.forEach((query) => {
					shopifyQueries.push(query.join("="));
				});
				shopifyQueries = shopifyQueries.join("&");
				return shopifyQueries;
			}

			getFilteredResults(element) {
				const filterQuery = this._buildFilterQuery(element);

				window.location.search = filterQuery;
			}

			onSectionUnload() {
				super.onSectionUnload();
				this.filterEvents.unregisterAll();
				this.forms.unload();
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/FacetedFilterSearch.js
		class FacetedFilterSearch extends StaticSearch {
			constructor(section) {
				super(section);
				this.el = section.el;
				this.filterInputs = null;
				this.filterEvents = new EventHandler /* default */.Z();
				this.updateTimeout = null;
				this._initFilterEvents = this._initFilterEvents.bind(this);
				this._updatePrice = this._updatePrice.bind(this);
				this._buildFilterQuery = this._buildFilterQuery.bind(this);
				this.filterGroups = section.data.filter_groups;
				this.filterStyle = "faceted";
				this.filtersContentSelector = "[data-productgrid-sidebar]";
				this.filtersContent = this.el.querySelector(
					this.filtersContentSelector
				);
				this.filtersTrigger = this.el.querySelector(
					"[data-productgrid-trigger-filters]"
				);
				this.filterRange = this.el.querySelectorAll("[data-filter-range]");
				this.filterCheckboxes = this.el.querySelectorAll(
					".filter-icon--checkbox"
				);
				this.rangeNames = [];
				this.fillAnimations = {};
				this.checkAnimations = {};
				this.modal = new Modal();
				this.filterEvents.register(this.filtersTrigger, "click", (e) => {
					this._showFiltersModal(e);
				});

				this._initAnimations();

				this.filterRange.forEach((el) => {
					this.rangeNames.push(el.name);
				});

				if (this.filtersContent) {
					const options = {
						groups: this.filterGroups,
						style: this.filterStyle,
					};
					this.filterGroupAccordions = new FilterGroups(
						this.filtersContent,
						options
					);

					this._initFilters();
				}

				this.forms = new Forms(this.el);

				this._initFilterEvents();
			}

			_initFilterEvents() {
				/* For radio buttons */
				this.filterInputs = this.el.querySelectorAll("[data-filter-input]");
				this.filterInputs.forEach((filter) => {
					this.filterEvents.register(filter, "click", (e) => {
						e.preventDefault();
						const target = e.currentTarget;
						if (target.dataset.hasOwnProperty("disabled")) return;
						const handle = target.getAttribute("data-handle");
						let animateTo = "checked";

						if (target.getAttribute("data-filter-active")) {
							animateTo = "unchecked";
							target.removeAttribute("data-filter-active");
						} else {
							target.setAttribute("data-filter-active", "");
						}

						if (this.fillAnimations[handle] && this.checkAnimations[handle]) {
							this.fillAnimations[handle].animateTo(animateTo);
							this.checkAnimations[handle].animateTo(animateTo);
						}

						this.getFilteredResults(e.currentTarget);
					});
				});
				/* For range input */

				this.filterRange.forEach((filter) => {
					this.filterEvents.register(filter, "keyup", (e) =>
						this._updatePrice(e.currentTarget)
					);
					this.filterEvents.register(filter, "change", (e) =>
						this._updatePrice(e.currentTarget)
					);
				});
				this.filterAccordionButton = this.el.querySelectorAll(
					"[data-filter-group-trigger]"
				);
				this.filterAccordionButton.forEach((filter) => {
					this.filterEvents.register(filter, "click", (e) => {
						e.preventDefault();
					});
				});
			}
			/*
			 * Initialize animations on checkbox container
			 * using filter tag as JSON key
			 */

			_initAnimations() {
				this.filterCheckboxes.forEach((el) => {
					const tagHandle = el.dataset.handle;
					const checkmark = el.querySelector(".checkmark");
					const checkmarkCheck = el.querySelector(".checkmark__check");
					let state = "unchecked";

					if (
						el.closest("[data-filter-input]").getAttribute("data-filter-active")
					) {
						state = "checked";
					}

					const fillAnimation = transition({
						el: checkmark,
						state,
					});
					const checkAnimation = transition({
						el: checkmarkCheck,
						state,
					});
					this.fillAnimations[tagHandle] = fillAnimation;
					this.checkAnimations[tagHandle] = checkAnimation;
				});
			}

			_initFilters() {
				const activePriceFilter = this.el.querySelector(
					"[data-filter-group-range]"
				);
				this.filterRange.forEach((priceInput) => {
					if (priceInput.value.length > 0) {
						activePriceFilter.setAttribute("data-filter-open", "true");
					}
				});
				const activeFilters = this.el.querySelectorAll(
					'[data-filter-open="true"]'
				);
				activeFilters.forEach((filter) => {
					this._openActiveGroup(filter);
				});
			}

			_showFiltersModal(event) {
				event.preventDefault();
				this.focusItem = event.currentTarget;
				this.modal.open(this.filtersContentSelector, "productgrid-filters");
			}

			_openActiveGroup(filter) {
				const button = filter
					.closest("[data-filter-group]")
					.querySelector("[data-filter-group-trigger]");
				const list = filter.closest("[data-accordion-content]");
				this.filterGroupAccordions.openGroup(button, list, true);
			}

			_buildFilterQuery(element) {
				let searchParameters; // If input is price range, the url_to_add property is not available, so we
				// need to build the query manually

				if (
					element.classList.contains("collection-filters__filter-range-input")
				) {
					const currentSearch = window.location.search.replace("?", "");
					const formData = new FormData(element.closest("form"));
					const newSearch = new URLSearchParams(formData).toString(); // Filter through current search string to see if price range input already exists,
					// if it does, create new string without current price range parameters

					const splitCurrentSearch = currentSearch.split("&");
					let filteredCurrentSearch = splitCurrentSearch.filter((search) => {
						if (
							search.includes(this.rangeNames[0]) ||
							search.includes(this.rangeNames[1])
						) {
							return false;
						}

						return true;
					});
					filteredCurrentSearch = filteredCurrentSearch.join("&"); // If current search parameters exist, append new search parameters
					// on to existing parameters

					if (filteredCurrentSearch.length > 0) {
						searchParameters = `${filteredCurrentSearch}&${newSearch}`;
					} else {
						searchParameters = `${newSearch}`;
					}
				} else {
					// If input is a link, build searchParameters using dataset URL
					const elementUrl = element.dataset.url;
					const decodedElementUrl = decodeURIComponent(elementUrl);
					searchParameters = decodedElementUrl.split("?")[1];

					if (!searchParameters) {
						searchParameters = "";
					}
				}

				let urlQueryString = "";

				if (searchParameters) {
					urlQueryString = `?${searchParameters}`;
				}

				return urlQueryString;
			}

			_updatePrice(element) {
				// cancel any pending requests
				if (this.updateTimeout !== null) {
					clearTimeout(this.updateTimeout);
				} // Wait for user to finish entering input before reloading page

				this.updateTimeout = setTimeout(() => {
					this.getFilteredResults(element);
				}, 2000);
			}

			getFilteredResults(element) {
				const filterQuery = this._buildFilterQuery(element);

				window.location.search = filterQuery;
			}

			onSectionUnload() {
				super.onSectionUnload();
				this.filterEvents.unregisterAll();
				this.forms.unload();
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/DynamicBlogPosts.js
		class DynamicTwitterFeed {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				this.$window = jquery_default()(window);
				this.flickity = null;
				this.$blogPosts = this.$el.find("[data-blog-posts]"); // Activate flickity on mobile

				this._mobileSlider = this._mobileSlider.bind(this);
				Layout.onBreakpointChange(this._mobileSlider);

				this._mobileSlider();
			}
			/**
			 * Unbind events when section is re-drawn
			 */

			onSectionUnload() {
				Layout.offBreakpointChange(this._mobileSlider);

				this._destroyFlickity();
			}

			_initFlickity() {
				this.flickity = new (js_default())(this.$blogPosts[0], {
					cellSelector: ".article--excerpt-wrapper",
					contain: true,
					freeScroll: true,
					percentPosition: false,
					prevNextButtons: false,
					pageDots: false,
					setGallerySize: false,
				});

				this._bindSlider();
			}

			_destroyFlickity() {
				if (!this.flickity) {
					return;
				}

				this.$window.off(".blog-posts");
				this.$blogPosts.off(".blog-posts");
				this.flickity.destroy();
				this.flickity = null;
			}

			_mobileSlider() {
				// If is Large layout, attempt to destroy flickity
				if (Layout.isGreaterThanBreakpoint("M")) {
					this._destroyFlickity();

					return;
				} // Is XS/S/M, and flickity is init'd -- do nothing

				if (this.flickity) {
					return;
				} // Is XS/S/M, and flickity is not init'd

				this._initFlickity();
			}

			_bindSlider() {
				const $slider = this.$blogPosts.find(".flickity-slider");
				this.$window.on(
					"resize.blog-posts",
					just_debounce_default()(() => {
						this.$blogPosts.trigger("heightUpdate.blog-posts");
					})
				);
				this.flickity.on("cellSelect", () => {
					this.$blogPosts.trigger("heightUpdate.blog-posts");
				});
				this.$blogPosts.on("heightUpdate.blog-posts", () => {
					if (!this.flickity) {
						return;
					}

					$slider.height(Math.ceil(this.flickity.maxCellHeight));
				}); // Sets the Slider to the height of the first slide

				this.$blogPosts.trigger("heightUpdate.blog-posts");
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/DynamicPromoBlocks.js
		// Adjusts the height of the block so it can contain the wrapper within it

		const adjustHeight = (block) => {
			const $block = jquery_default()(block);
			const $wrapper = $block.find(".promo-block--content-wrapper");
			const padding = window
				.getComputedStyle($block[0], null)
				.getPropertyValue("padding-top")
				.replace("px", "");

			if ($block.innerHeight() - padding * 2 < $wrapper.innerHeight()) {
				$block.css({
					height: `${$wrapper.innerHeight() + padding * 2}px`,
				});
				$wrapper.css({
					transform: "none",
					top: "auto",
				});
			}
		}; // Removes height settings on the block because they only need to be there for small screens

		const resetHeight = (block) => {
			const $block = jquery_default()(block);
			const $wrapper = $block.find(".promo-block--content-wrapper");
			$block.css({
				height: "",
			});
			$wrapper.css({
				transform: "",
				top: "",
			});
		};

		class DynamicPromoBlocks {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				this.content = "[data-promo-block-content]";
				this.expandedClass = "promo-block--expanded";
				this.compressBlocks = section.data.compress_blocks; // Revert navigation to original state on breakpoint change

				this.layoutHandler = this.onBreakpointChange.bind(this);
				Layout.onBreakpointChange(this.layoutHandler);
				this._blockInteraction = this._blockInteraction.bind(this);
				this.$el.on("click.promo-block", this.content, this._blockInteraction);

				if (!this.compressBlocks && Layout.isLessThanBreakpoint("S")) {
					this.$el.find(this.content).each((index, block) => {
						adjustHeight(block);
					});
				}

				if (!this.compressBlocks) {
					jquery_default()(window).on("resize", () => {
						this.$el.find(this.content).each((index, block) => {
							if (Layout.isLessThanBreakpoint("S")) {
								adjustHeight(block);
							} else {
								resetHeight(block);
							}
						});
					});
				}
			}
			/**
			 * Remove block's toggled state and attributes when leaving mobile
			 */

			onBreakpointChange() {
				if (!Layout.isLessThanBreakpoint("S")) {
					this.$el.find(`.${this.expandedClass}`).each((i, content) => {
						this._collapse(content);
					});
					this.$el.find(this.content).each((index, block) => {
						resetHeight(block);
					});
				} else if (!this.compressBlocks) {
					this.$el.find(this.content).each((index, block) => {
						adjustHeight(block);
					});
				}
			}
			/**
			 * Unbind events when section is re-drawn
			 */

			onSectionUnload() {
				this.$el.off(".promo-block");
				Layout.offBreakpointChange(this.layoutHandler);
			}
			/**
			 * Callback to open block on mobile from the TE
			 *
			 * @param block
			 */

			onSectionBlockSelect(block) {
				if (!Layout.isLessThanBreakpoint("S")) return;

				this._expand(block.el.querySelector(this.content));
			}
			/**
			 * Callback to close block on mobile from the TE
			 *
			 * @param block
			 */

			onSectionBlockDeselect(block) {
				if (!Layout.isLessThanBreakpoint("S")) return;

				this._collapse(block.el.querySelector(this.content));
			}
			/**
			 * Expand a block on first click, then allow it to behave as normal
			 *
			 * @param event
			 * @private
			 */

			_blockInteraction(event) {
				const content = event.currentTarget;
				const clicked = content.getAttribute("data-clicked"); // On second click, or on desktop, don't interfere with block

				if (
					clicked ||
					!Layout.isLessThanBreakpoint("S") ||
					!this.compressBlocks
				) {
					return;
				}

				event.preventDefault();
				content.setAttribute("data-clicked", "clicked");

				this._expand(content);
			}
			/**
			 * Expand promo block
			 *
			 * @param content
			 * @private
			 */

			_expand(content) {
				if (!this.compressBlocks) {
					return;
				}

				const $content = jquery_default()(content);
				$content.addClass("animating animating-in").one("trend", () => {
					$content
						.removeClass("animating animating-in")
						.addClass(this.expandedClass)
						.off("trend");
					adjustHeight($content);
				});
			}
			/**
			 * Collapse a block
			 *
			 * @param content
			 * @private
			 */

			_collapse(content) {
				if (!this.compressBlocks) {
					return;
				}

				const $content = jquery_default()(content);
				$content.addClass("animating animating-out").one("trend", () => {
					$content
						.removeClass(`animating animating-out ${this.expandedClass}`)
						.off("trend");
					content.removeAttribute("data-clicked");
					resetHeight($content);
				});
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/DynamicFeaturedCollection.js
		class DynamicFeaturedCollection {
			constructor(section) {
				const collectionEl = section.el.querySelector(
					"[data-featured-collection]"
				);
				this.featuredCollection = new FeaturedCollection({
					el: collectionEl,
					sectionId: section.id,
				});
			}

			onSectionUnload() {
				this.featuredCollection.unload();
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/DynamicMenuList.js
		class DynamicMenuList {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				this.context = section.data.context;
				this.accordionTrigger = "[data-accordion-trigger]";
				this.seeMoreTrigger = "[data-menulist-toggle]";
				this.Accordion = new Accordion(this.$el[0], {
					content: ".menulist-menu--initial[data-accordion-content]",
					onStart: (_ref) => {
						let { el, state } = _ref;
						el.parentNode.querySelector(
							this.accordionTrigger
						).dataset.accordionTrigger = state;
					},
				});
				this.seeMore = new Accordion(this.$el[0], {
					content: ".menulist-menu--show-more[data-accordion-content]",
					onStart: (_ref2) => {
						let { el, state } = _ref2;
						el.parentNode.querySelector(this.seeMoreTrigger).innerHTML =
							state === "open" ? this.context.see_less : this.context.see_more;
					},
				});

				if (cjs.max("XS")) {
					this.Accordion.closeAll({
						force: true,
					});
				}

				this.seeMore.closeAll({
					force: true,
				}); // Handle Accordion interaction when window size changes

				cjs.onChange((breakpoints) => this.onBreakpointChange(breakpoints));

				this._bindEvents();
			}

			_bindEvents() {
				this.$el.on("click.menu-list", this.accordionTrigger, (event) => {
					event.preventDefault();

					this._toggleAccordion(event.currentTarget.parentNode);
				});
				this.$el.on("click.menu-list", this.seeMoreTrigger, (event) => {
					event.preventDefault();
					this.seeMore.toggle(event.currentTarget.parentNode);
				});
			}

			onSectionUnload() {
				this.$el.off(".menu-list");
				this.Accordion.unload();
				this.seeMore.unload();
			}

			onSectionBlockSelect(block) {
				this._toggleAccordion(block.el);
			}

			onSectionBlockDeselect(block) {
				this._toggleAccordion(block.el);
			}

			_toggleAccordion(block) {
				if (cjs.min("S")) return;
				this.Accordion.toggle(block);
			}

			onBreakpointChange(breakpoints) {
				if (breakpoints.current.min("S")) {
					this.Accordion.openAll({
						force: true,
					});
				} else if (
					breakpoints.previous.min("S") &&
					breakpoints.current.max("XS")
				) {
					this.Accordion.closeAll({
						force: true,
					});
				}
			}
		}
		// EXTERNAL MODULE: ./node_modules/twitter-fetcher/js/twitterFetcher_min.js
		var twitterFetcher_min = __webpack_require__(637);
		var twitterFetcher_min_default =
			/*#__PURE__*/ __webpack_require__.n(twitterFetcher_min); // CONCATENATED MODULE: ./source/scripts/sections/DynamicTwitterFeed.js
		class DynamicTwitterFeed_DynamicTwitterFeed {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				this.settings = section.data;

				this._load();
			}

			_load() {
				this.$window = jquery_default()(window);
				this.flickity = null;
				this.$content = this.$el.find("[data-twitter-content]");
				this.$wrapper = this.$el.find("[data-twitter-wrapper]");
				this.$tweets = this.$el.find("[data-tweet-content]");
				this.$template = jquery_default()(this.settings.template);
				const { onboarding, username, retweets, images } = this.settings;
				const locale = this.settings.locale || "en"; // Activate flickity on mobile

				this._mobileSlider = this._mobileSlider.bind(this);
				Layout.onBreakpointChange(this._mobileSlider);

				this._mobileSlider();

				if (onboarding || !username) {
					return;
				}

				twitterFetcher_min_default().fetch({
					profile: {
						screenName: username,
					},
					maxTweets: 3,
					enableLinks: true,
					showUser: true,
					showTime: true,
					dataOnly: false,
					useEmoji: true,
					showImages: images,
					showRetweet: retweets,
					lang: locale,
					customCallback: (tweets) => this._renderTweets(tweets),
					showInteraction: false,
				});
			}
			/**
			 * Unbind events when section is re-drawn
			 */

			onSectionUnload() {
				this.$window.off(".twitter");
				this.$content.off(".twitter");
				Layout.offBreakpointChange(this._mobileSlider);

				this._destroyFlickity();
			}

			_initFlickity() {
				this.flickity = new (js_default())(this.$content[0], {
					cellSelector: "[data-tweet-content]",
					contain: true,
					freeScroll: true,
					percentPosition: false,
					prevNextButtons: false,
					pageDots: false,
					setGallerySize: false,
				});

				this._bindSlider();
			}

			_destroyFlickity() {
				if (!this.flickity) {
					return;
				}

				this.flickity.destroy();
				this.flickity = null;
			}

			_mobileSlider() {
				// If is Large layout, attempt to destroy flickity
				if (Layout.isGreaterThanBreakpoint("S")) {
					this._destroyFlickity();

					return;
				} // Is XS/S/M, and flickity is init'd -- do nothing

				if (this.flickity) {
					return;
				} // Is XS/S/M, and flickity is not init'd

				this._initFlickity();
			}

			_bindSlider() {
				const $slider = this.$content.find(".flickity-slider");
				this.$window.on(
					"resize.twitter",
					just_debounce_default()(() => {
						this.$content.trigger("heightUpdate.twitter");
					})
				);
				this.flickity.on("cellSelect", () => {
					this.$content.trigger("heightUpdate.twitter");
				});
				this.$content.on("heightUpdate.twitter", () => {
					if (!this.flickity) {
						return;
					}

					$slider.height(Math.ceil(this.flickity.maxCellHeight));
				}); // Sets the Slider to the height of the first slide

				this.$content.trigger("heightUpdate.twitter");
			}
			/**
			 * Retrieve information about user who tweeted
			 *
			 * @param el
			 * @returns 
			 * @private
			 */

			_extractAuthor(el) {
				const $el = jquery_default()(el);
				const link = $el.find("a").attr("href");
				const name = $el.find('[data-scribe="element:name"]').text();
				const screenName = $el
					.find('[data-scribe="element:screen_name"]')
					.text();
				const $avatar = $el.find("img");
				return {
					$avatar,
					link,
					name,
					screenName,
				};
			}
			/**
			 * Retrieve link to tweet, and when it was tweeted
			 *
			 * @param el
			 * @returns 
			 * @private
			 */

			_extractMeta(el) {
				const $el = jquery_default()(el);
				const link = $el.find("a").attr("href");
				const postedAt = $el.text();
				return {
					link,
					postedAt,
				};
			}

			_extractWrapperClass() {
				const wrapperClass = this.$wrapper
					.attr("class")
					.match(/tweet--count-\d+$/);

				if (wrapperClass) {
					return wrapperClass[0];
				}

				return "";
			}

			_renderTweets(tweets) {
				const tweetsLength = tweets.length;
				if (!tweets || !tweetsLength) return;
				const tweetsArray = [];
				const wrapperClass = `tweet--count-${tweetsLength}`;
				tweets.forEach((tweet) => {
					const $tweet = jquery_default()(tweet);
					const $template = this.$template.clone();

					const authorInfo = this._extractAuthor($tweet[0]);

					const meta = this._extractMeta($tweet[2]);

					const content = $tweet[1]; // Render header

					$template.find(".tweet--header").attr("href", authorInfo.link);
					$template.find(".tweet--header-image").html(authorInfo.$avatar);
					$template.find(".tweet--header-name").text(authorInfo.name);
					$template
						.find(".tweet--header-screenname")
						.text(authorInfo.screenName); // Render content

					$template
						.find(".tweet--content")
						.append($tweet[3] ? $tweet[3] : null)
						.append(content); // Render footer

					$template
						.find(".tweet--footer")
						.attr("href", meta.link)
						.find(".tweet--footer--posted")
						.text(meta.postedAt);
					tweetsArray.push($template);
				});
				this.$wrapper.css("min-height", this.$wrapper.height());
				this.$tweets
					.fadeOut()
					.promise()
					.then(() => {
						this._destroyFlickity();

						this.$tweets.remove();
						this.$content.append(tweetsArray);
						this.$wrapper
							.removeClass(this._extractWrapperClass())
							.addClass(wrapperClass)
							.css("min-height", "");
						this.$tweets = this.$el.find("[data-tweet-content]");

						this._mobileSlider();
					});
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/DynamicCollectionList.js
		class DynamicCollectionList {
			constructor(section) {
				this.el = section.el;
				const collectionListImages = this.el.querySelectorAll(
					"[data-collection-image]"
				);
				cjs.onChange((breakpoints) => {
					if (
						breakpoints.previous.max("L") &&
						breakpoints.current.value === "S"
					) {
						for (let i = 0; i < collectionListImages.length; i++) {
							dist_index_es.instance.update(collectionListImages[i]);
						}
					}
				});
			}
		} // CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-countdown-timer/dist/index.es.js
		/*!
		 * @pixelunion/pxs-countdown-timer v3.0.0
		 * (c) 2023 Pixel Union
		 */

		function pxs_countdown_timer_dist_index_es_classCallCheck(
			instance,
			Constructor
		) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}
		function pxs_countdown_timer_dist_index_es_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}
		function pxs_countdown_timer_dist_index_es_createClass(
			Constructor,
			protoProps,
			staticProps
		) {
			if (protoProps)
				pxs_countdown_timer_dist_index_es_defineProperties(
					Constructor.prototype,
					protoProps
				);
			if (staticProps)
				pxs_countdown_timer_dist_index_es_defineProperties(
					Constructor,
					staticProps
				);
			Object.defineProperty(Constructor, "prototype", {
				writable: false,
			});
			return Constructor;
		}

		var CountdownTimer = /*#__PURE__*/ (function () {
			function CountdownTimer(sectionEl) {
				pxs_countdown_timer_dist_index_es_classCallCheck(this, CountdownTimer);
				this.container = sectionEl;
				this.previousSiblingSection = this.container.previousElementSibling;
				this.nextSiblingSection = this.container.nextElementSibling;
				this.countDownTimerEl = this.container.querySelector(
					"[data-countdown-timer]"
				);
				this.countDownEl =
					this.countDownTimerEl.querySelector("[data-countdown]");
				this.daysEl = this.countDownTimerEl.querySelector("[data-days]");
				this.hoursEl = this.countDownTimerEl.querySelector("[data-hours]");
				this.minutesEl = this.countDownTimerEl.querySelector("[data-minutes]");
				this.secondsEl = this.countDownTimerEl.querySelector("[data-seconds]");
				this.dateTimeEl = this.countDownTimerEl.querySelector("[data-time]");

				// `Date.parse()` is usually discouraged, however, it's okay in this case
				// since we know the string we're passing in is ISO 8601 compliant.
				this.targetDate = Date.parse(this.dateTimeEl.dateTime);
				this.daysInMs = 1000 * 60 * 60 * 24;
				this.hoursInMs = this.daysInMs / 24;
				this.minutesInMs = this.hoursInMs / 60;
				this.secondsInMs = this.minutesInMs / 60;
				this.timeoutId = null;
				this.isLoading = true;
				this.startTimer();
			}
			pxs_countdown_timer_dist_index_es_createClass(CountdownTimer, [
				{
					key: "updateLoadingState",
					value: function updateLoadingState() {
						this.countDownTimerEl.classList.remove("countdown-timer--loading");
					},

					/**
					 * Implements a self-adjusting timer.
					 *
					 * setTimeout has no guarantees that it will be accurate. Therefore,
					 * we'll calculate how much "drift" (i.e. delay per each iteration of setTimeout)
					 * has occurred and keep adjusting the setTimeout delay accordingly.
					 */
				},
				{
					key: "startTimer",
					value: function startTimer() {
						var _this = this;
						var interval = 1000;
						var expectedTime = Date.now() + interval;

						// setTimeout removes everything from the main thread and causes delays.
						// No need to run it if countdown has completed.
						if (this.targetDate <= Date.now()) {
							this.updateLoadingState();
							this.handleCountDownComplete();
							return;
						}
						var countDown = function countDown() {
							var currentDate = Date.now();
							var timeDiff = _this.targetDate - currentDate;
							if (timeDiff <= 0) {
								_this.stopTimer();
								_this.handleCountDownComplete();
								return;
							}
							var remainingTime = _this.convertTime(timeDiff);
							var drift = currentDate - expectedTime;
							expectedTime += interval;
							if (_this.isLoading) _this.updateLoadingState();
							_this.updateDom(remainingTime);
							_this.timeoutId = setTimeout(
								countDown,
								Math.max(0, interval - drift)
							);
						};
						this.timeoutId = setTimeout(countDown, interval);
					},
				},
				{
					key: "stopTimer",
					value: function stopTimer() {
						clearTimeout(this.timeoutId);
					},
				},
				{
					key: "convertTime",
					value: function convertTime(timeInMs) {
						var days = parseInt(timeInMs / this.daysInMs, 10);
						timeInMs -= days * this.daysInMs;
						var hours = parseInt(timeInMs / this.hoursInMs, 10);
						timeInMs -= hours * this.hoursInMs;
						var minutes = parseInt(timeInMs / this.minutesInMs, 10);
						timeInMs -= minutes * this.minutesInMs;
						var seconds = parseInt(timeInMs / this.secondsInMs, 10);
						return {
							days: days,
							hours: hours,
							minutes: minutes,
							seconds: seconds,
						};
					},
				},
				{
					key: "updateDom",
					value: function updateDom(dateObj) {
						var days = dateObj.days,
							hours = dateObj.hours,
							minutes = dateObj.minutes,
							seconds = dateObj.seconds;

						// Avoid using `innerText` or `innerHTML` as they trigger computationally expensive reflows.
						// https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent#differences_from_innertext.
						this.daysEl.textContent = days;
						this.hoursEl.textContent = hours;
						this.minutesEl.textContent = minutes;
						this.secondsEl.textContent = seconds;
					},
				},
				{
					key: "handleCountDownComplete",
					value: function handleCountDownComplete() {
						this.updateDom({
							days: 0,
							hours: 0,
							minutes: 0,
							seconds: 0,
						});
						this.countDownTimerEl.classList.add("countdown-timer--complete");
					},
				},
			]);
			return CountdownTimer;
		})();

		/* harmony default export */ const pxs_countdown_timer_dist_index_es =
			CountdownTimer; // CONCATENATED MODULE: ./source/scripts/sections/DynamicCountdownTimer.js

		class DynamicCountdownTimer {
			constructor(section) {
				this.el = section.el;
				this.product = this.el.querySelector("[data-product-item]");
				new pxs_countdown_timer_dist_index_es(this.el);
				setupRippleEffect(this.el);

				if (this.product) {
					this.productItems = new ProductGridItem({
						el: this.product,
						id: section.id,
					});
				}
			}

			onSectionUnload() {
				if (this.product) {
					this.productItems.unload();
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/DynamicProduct.js
		class DynamicProduct extends Product {
			constructor(section) {
				super(section, {
					useHistory: false,
				});
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/DynamicRichText.js
		class DynamicRichText {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				this.rte = [];
				this.$el.find("[data-rte]").each((i, el) => {
					this.rte.push(new RichText(jquery_default()(el)));
				});
			}
			/**
			 * Unbind events when section is re-drawn
			 */

			onSectionUnload() {
				this.rte.forEach((richTextArea) => {
					richTextArea.unload();
				});
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/DynamicSearch.js
		class DynamicSearch {
			constructor(section) {
				this.el = section.el;
				this.settings = section.data.settings;
				this.search = null;
				this.scripts = document.querySelector("[data-scripts]");
				this.searchField = this.el.querySelector("[data-live-search]");
				this.forms = new Forms(this.el);

				if (this.settings.live_search.enable) {
					script_default()(this.scripts.dataset.shopifyApiUrl, () => {
						this.search = new LiveSearch(
							{
								el: this.searchField,
								header: this.el,
							},
							{
								...this.settings.live_search,
								use_dimmer: false,
							}
						);
					});
				} else {
					this.search = new SearchForm(this.searchField);
				}
			}

			onSectionUnload() {
				this.search.unload();
				this.forms.unload();
			}
		} // CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-slideshow/dist/index.es.js
		/*!
		 * @pixelunion/pxs-slideshow v2.0.0
		 * (c) 2023 Pixel Union
		 */

		function pxs_slideshow_dist_index_es_classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function pxs_slideshow_dist_index_es_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function pxs_slideshow_dist_index_es_createClass(
			Constructor,
			protoProps,
			staticProps
		) {
			if (protoProps)
				pxs_slideshow_dist_index_es_defineProperties(
					Constructor.prototype,
					protoProps
				);
			if (staticProps)
				pxs_slideshow_dist_index_es_defineProperties(Constructor, staticProps);
			return Constructor;
		}

		var index_es_commonjsGlobal =
			typeof globalThis !== "undefined"
				? globalThis
				: typeof window !== "undefined"
				? window
				: typeof __webpack_require__.g !== "undefined"
				? __webpack_require__.g
				: typeof self !== "undefined"
				? self
				: {};

		function dist_index_es_unwrapExports(x) {
			return x &&
				x.__esModule &&
				Object.prototype.hasOwnProperty.call(x, "default")
				? x["default"]
				: x;
		}

		function pxs_slideshow_dist_index_es_createCommonjsModule(fn, module) {
			return (
				(module = { exports: {} }), fn(module, module.exports), module.exports
			);
		}

		var index_es_evEmitter = pxs_slideshow_dist_index_es_createCommonjsModule(
			function (module) {
				/**
				 * EvEmitter v1.1.0
				 * Lil' event emitter
				 * MIT License
				 */

				/* jshint unused: true, undef: true, strict: true */

				(function (global, factory) {
					// universal module definition
					/* jshint strict: false */ /* globals define, module, window */
					if (module.exports) {
						// CommonJS - Browserify, Webpack
						module.exports = factory();
					} else {
						// Browser globals
						global.EvEmitter = factory();
					}
				})(
					typeof window != "undefined" ? window : index_es_commonjsGlobal,
					function () {
						function EvEmitter() {}

						var proto = EvEmitter.prototype;

						proto.on = function (eventName, listener) {
							if (!eventName || !listener) {
								return;
							}
							// set events hash
							var events = (this._events = this._events || {});
							// set listeners array
							var listeners = (events[eventName] = events[eventName] || []);
							// only add once
							if (listeners.indexOf(listener) == -1) {
								listeners.push(listener);
							}

							return this;
						};

						proto.once = function (eventName, listener) {
							if (!eventName || !listener) {
								return;
							}
							// add event
							this.on(eventName, listener);
							// set once flag
							// set onceEvents hash
							var onceEvents = (this._onceEvents = this._onceEvents || {});
							// set onceListeners object
							var onceListeners = (onceEvents[eventName] =
								onceEvents[eventName] || {});
							// set flag
							onceListeners[listener] = true;

							return this;
						};

						proto.off = function (eventName, listener) {
							var listeners = this._events && this._events[eventName];
							if (!listeners || !listeners.length) {
								return;
							}
							var index = listeners.indexOf(listener);
							if (index != -1) {
								listeners.splice(index, 1);
							}

							return this;
						};

						proto.emitEvent = function (eventName, args) {
							var listeners = this._events && this._events[eventName];
							if (!listeners || !listeners.length) {
								return;
							}
							// copy over to avoid interference if .off() in listener
							listeners = listeners.slice(0);
							args = args || [];
							// once stuff
							var onceListeners =
								this._onceEvents && this._onceEvents[eventName];

							for (var i = 0; i < listeners.length; i++) {
								var listener = listeners[i];
								var isOnce = onceListeners && onceListeners[listener];
								if (isOnce) {
									// remove listener
									// remove before trigger to prevent recursion
									this.off(eventName, listener);
									// unset once flag
									delete onceListeners[listener];
								}
								// trigger listener
								listener.apply(this, args);
							}

							return this;
						};

						proto.allOff = function () {
							delete this._events;
							delete this._onceEvents;
						};

						return EvEmitter;
					}
				);
			}
		);

		var index_es_getSize = pxs_slideshow_dist_index_es_createCommonjsModule(
			function (module) {
				/*!
				 * getSize v2.0.3
				 * measure size of elements
				 * MIT license
				 */

				/* jshint browser: true, strict: true, undef: true, unused: true */
				/* globals console: false */

				(function (window, factory) {
					/* jshint strict: false */ /* globals define, module */
					if (module.exports) {
						// CommonJS
						module.exports = factory();
					} else {
						// browser global
						window.getSize = factory();
					}
				})(window, function factory() {
					// -------------------------- helpers -------------------------- //

					// get a number from a string, not a percentage
					function getStyleSize(value) {
						var num = parseFloat(value);
						// not a percent like '100%', and a number
						var isValid = value.indexOf("%") == -1 && !isNaN(num);
						return isValid && num;
					}

					function noop() {}

					var logError =
						typeof console == "undefined"
							? noop
							: function (message) {
									console.error(message);
							  };

					// -------------------------- measurements -------------------------- //

					var measurements = [
						"paddingLeft",
						"paddingRight",
						"paddingTop",
						"paddingBottom",
						"marginLeft",
						"marginRight",
						"marginTop",
						"marginBottom",
						"borderLeftWidth",
						"borderRightWidth",
						"borderTopWidth",
						"borderBottomWidth",
					];

					var measurementsLength = measurements.length;

					function getZeroSize() {
						var size = {
							width: 0,
							height: 0,
							innerWidth: 0,
							innerHeight: 0,
							outerWidth: 0,
							outerHeight: 0,
						};
						for (var i = 0; i < measurementsLength; i++) {
							var measurement = measurements[i];
							size[measurement] = 0;
						}
						return size;
					}

					// -------------------------- getStyle -------------------------- //

					/**
					 * getStyle, get style of element, check for Firefox bug
					 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
					 */
					function getStyle(elem) {
						var style = getComputedStyle(elem);
						if (!style) {
							logError(
								"Style returned " +
									style +
									". Are you running this code in a hidden iframe on Firefox? " +
									"See https://bit.ly/getsizebug1"
							);
						}
						return style;
					}

					// -------------------------- setup -------------------------- //

					var isSetup = false;

					var isBoxSizeOuter;

					/**
					 * setup
					 * check isBoxSizerOuter
					 * do on first getSize() rather than on page load for Firefox bug
					 */
					function setup() {
						// setup once
						if (isSetup) {
							return;
						}
						isSetup = true;

						// -------------------------- box sizing -------------------------- //

						/**
						 * Chrome & Safari measure the outer-width on style.width on border-box elems
						 * IE11 & Firefox<29 measures the inner-width
						 */
						var div = document.createElement("div");
						div.style.width = "200px";
						div.style.padding = "1px 2px 3px 4px";
						div.style.borderStyle = "solid";
						div.style.borderWidth = "1px 2px 3px 4px";
						div.style.boxSizing = "border-box";

						var body = document.body || document.documentElement;
						body.appendChild(div);
						var style = getStyle(div);
						// round value for browser zoom. desandro/masonry#928
						isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
						getSize.isBoxSizeOuter = isBoxSizeOuter;

						body.removeChild(div);
					}

					// -------------------------- getSize -------------------------- //

					function getSize(elem) {
						setup();

						// use querySeletor if elem is string
						if (typeof elem == "string") {
							elem = document.querySelector(elem);
						}

						// do not proceed on non-objects
						if (!elem || typeof elem != "object" || !elem.nodeType) {
							return;
						}

						var style = getStyle(elem);

						// if hidden, everything is 0
						if (style.display == "none") {
							return getZeroSize();
						}

						var size = {};
						size.width = elem.offsetWidth;
						size.height = elem.offsetHeight;

						var isBorderBox = (size.isBorderBox =
							style.boxSizing == "border-box");

						// get all measurements
						for (var i = 0; i < measurementsLength; i++) {
							var measurement = measurements[i];
							var value = style[measurement];
							var num = parseFloat(value);
							// any 'auto', 'medium' value will be 0
							size[measurement] = !isNaN(num) ? num : 0;
						}

						var paddingWidth = size.paddingLeft + size.paddingRight;
						var paddingHeight = size.paddingTop + size.paddingBottom;
						var marginWidth = size.marginLeft + size.marginRight;
						var marginHeight = size.marginTop + size.marginBottom;
						var borderWidth = size.borderLeftWidth + size.borderRightWidth;
						var borderHeight = size.borderTopWidth + size.borderBottomWidth;

						var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

						// overwrite width and height if we can get it from style
						var styleWidth = getStyleSize(style.width);
						if (styleWidth !== false) {
							size.width =
								styleWidth +
								// add padding and border unless it's already including it
								(isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
						}

						var styleHeight = getStyleSize(style.height);
						if (styleHeight !== false) {
							size.height =
								styleHeight +
								// add padding and border unless it's already including it
								(isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
						}

						size.innerWidth = size.width - (paddingWidth + borderWidth);
						size.innerHeight = size.height - (paddingHeight + borderHeight);

						size.outerWidth = size.width + marginWidth;
						size.outerHeight = size.height + marginHeight;

						return size;
					}

					return getSize;
				});
			}
		);

		var index_es_matchesSelector =
			pxs_slideshow_dist_index_es_createCommonjsModule(function (module) {
				/**
				 * matchesSelector v2.0.2
				 * matchesSelector( element, '.selector' )
				 * MIT license
				 */

				/*jshint browser: true, strict: true, undef: true, unused: true */

				(function (window, factory) {
					// universal module definition
					if (module.exports) {
						// CommonJS
						module.exports = factory();
					} else {
						// browser global
						window.matchesSelector = factory();
					}
				})(window, function factory() {
					var matchesMethod = (function () {
						var ElemProto = window.Element.prototype;
						// check for the standard method name first
						if (ElemProto.matches) {
							return "matches";
						}
						// check un-prefixed
						if (ElemProto.matchesSelector) {
							return "matchesSelector";
						}
						// check vendor prefixes
						var prefixes = ["webkit", "moz", "ms", "o"];

						for (var i = 0; i < prefixes.length; i++) {
							var prefix = prefixes[i];
							var method = prefix + "MatchesSelector";
							if (ElemProto[method]) {
								return method;
							}
						}
					})();

					return function matchesSelector(elem, selector) {
						return elem[matchesMethod](selector);
					};
				});
			});

		var index_es_utils = pxs_slideshow_dist_index_es_createCommonjsModule(
			function (module) {
				/**
				 * Fizzy UI utils v2.0.7
				 * MIT license
				 */

				/*jshint browser: true, undef: true, unused: true, strict: true */

				(function (window, factory) {
					// universal module definition
					/*jshint strict: false */ /*globals define, module, require */

					if (module.exports) {
						// CommonJS
						module.exports = factory(window, index_es_matchesSelector);
					} else {
						// browser global
						window.fizzyUIUtils = factory(window, window.matchesSelector);
					}
				})(window, function factory(window, matchesSelector) {
					var utils = {};

					// ----- extend ----- //

					// extends objects
					utils.extend = function (a, b) {
						for (var prop in b) {
							a[prop] = b[prop];
						}
						return a;
					};

					// ----- modulo ----- //

					utils.modulo = function (num, div) {
						return ((num % div) + div) % div;
					};

					// ----- makeArray ----- //

					var arraySlice = Array.prototype.slice;

					// turn element or nodeList into an array
					utils.makeArray = function (obj) {
						if (Array.isArray(obj)) {
							// use object if already an array
							return obj;
						}
						// return empty array if undefined or null. #6
						if (obj === null || obj === undefined) {
							return [];
						}

						var isArrayLike =
							typeof obj == "object" && typeof obj.length == "number";
						if (isArrayLike) {
							// convert nodeList to array
							return arraySlice.call(obj);
						}

						// array of single index
						return [obj];
					};

					// ----- removeFrom ----- //

					utils.removeFrom = function (ary, obj) {
						var index = ary.indexOf(obj);
						if (index != -1) {
							ary.splice(index, 1);
						}
					};

					// ----- getParent ----- //

					utils.getParent = function (elem, selector) {
						while (elem.parentNode && elem != document.body) {
							elem = elem.parentNode;
							if (matchesSelector(elem, selector)) {
								return elem;
							}
						}
					};

					// ----- getQueryElement ----- //

					// use element as selector string
					utils.getQueryElement = function (elem) {
						if (typeof elem == "string") {
							return document.querySelector(elem);
						}
						return elem;
					};

					// ----- handleEvent ----- //

					// enable .ontype to trigger from .addEventListener( elem, 'type' )
					utils.handleEvent = function (event) {
						var method = "on" + event.type;
						if (this[method]) {
							this[method](event);
						}
					};

					// ----- filterFindElements ----- //

					utils.filterFindElements = function (elems, selector) {
						// make array of elems
						elems = utils.makeArray(elems);
						var ffElems = [];

						elems.forEach(function (elem) {
							// check that elem is an actual element
							if (!(elem instanceof HTMLElement)) {
								return;
							}
							// add elem if no selector
							if (!selector) {
								ffElems.push(elem);
								return;
							}
							// filter & find items if we have a selector
							// filter
							if (matchesSelector(elem, selector)) {
								ffElems.push(elem);
							}
							// find children
							var childElems = elem.querySelectorAll(selector);
							// concat childElems to filterFound array
							for (var i = 0; i < childElems.length; i++) {
								ffElems.push(childElems[i]);
							}
						});

						return ffElems;
					};

					// ----- debounceMethod ----- //

					utils.debounceMethod = function (_class, methodName, threshold) {
						threshold = threshold || 100;
						// original method
						var method = _class.prototype[methodName];
						var timeoutName = methodName + "Timeout";

						_class.prototype[methodName] = function () {
							var timeout = this[timeoutName];
							clearTimeout(timeout);

							var args = arguments;
							var _this = this;
							this[timeoutName] = setTimeout(function () {
								method.apply(_this, args);
								delete _this[timeoutName];
							}, threshold);
						};
					};

					// ----- docReady ----- //

					utils.docReady = function (callback) {
						var readyState = document.readyState;
						if (readyState == "complete" || readyState == "interactive") {
							// do async to allow for other scripts to run. metafizzy/flickity#441
							setTimeout(callback);
						} else {
							document.addEventListener("DOMContentLoaded", callback);
						}
					};

					// ----- htmlInit ----- //

					// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
					utils.toDashed = function (str) {
						return str
							.replace(/(.)([A-Z])/g, function (match, $1, $2) {
								return $1 + "-" + $2;
							})
							.toLowerCase();
					};

					var console = window.console;
					/**
					 * allow user to initialize classes via [data-namespace] or .js-namespace class
					 * htmlInit( Widget, 'widgetName' )
					 * options are parsed from data-namespace-options
					 */
					utils.htmlInit = function (WidgetClass, namespace) {
						utils.docReady(function () {
							var dashedNamespace = utils.toDashed(namespace);
							var dataAttr = "data-" + dashedNamespace;
							var dataAttrElems = document.querySelectorAll(
								"[" + dataAttr + "]"
							);
							var jsDashElems = document.querySelectorAll(
								".js-" + dashedNamespace
							);
							var elems = utils
								.makeArray(dataAttrElems)
								.concat(utils.makeArray(jsDashElems));
							var dataOptionsAttr = dataAttr + "-options";
							var jQuery = window.jQuery;

							elems.forEach(function (elem) {
								var attr =
									elem.getAttribute(dataAttr) ||
									elem.getAttribute(dataOptionsAttr);
								var options;
								try {
									options = attr && JSON.parse(attr);
								} catch (error) {
									// log error, do not initialize
									if (console) {
										console.error(
											"Error parsing " +
												dataAttr +
												" on " +
												elem.className +
												": " +
												error
										);
									}
									return;
								}
								// initialize
								var instance = new WidgetClass(elem, options);
								// make available via $().data('namespace')
								if (jQuery) {
									jQuery.data(elem, namespace, instance);
								}
							});
						});
					};

					// -----  ----- //

					return utils;
				});
			}
		);

		var index_es_cell = pxs_slideshow_dist_index_es_createCommonjsModule(
			function (module) {
				// Flickity.Cell
				(function (window, factory) {
					// universal module definition
					/* jshint strict: false */
					if (module.exports) {
						// CommonJS
						module.exports = factory(window, index_es_getSize);
					} else {
						// browser global
						window.Flickity = window.Flickity || {};
						window.Flickity.Cell = factory(window, window.getSize);
					}
				})(window, function factory(window, getSize) {
					function Cell(elem, parent) {
						this.element = elem;
						this.parent = parent;

						this.create();
					}

					var proto = Cell.prototype;

					proto.create = function () {
						this.element.style.position = "absolute";
						this.element.setAttribute("aria-hidden", "true");
						this.x = 0;
						this.shift = 0;
					};

					proto.destroy = function () {
						// reset style
						this.unselect();
						this.element.style.position = "";
						var side = this.parent.originSide;
						this.element.style[side] = "";
					};

					proto.getSize = function () {
						this.size = getSize(this.element);
					};

					proto.setPosition = function (x) {
						this.x = x;
						this.updateTarget();
						this.renderPosition(x);
					};

					// setDefaultTarget v1 method, backwards compatibility, remove in v3
					proto.updateTarget = proto.setDefaultTarget = function () {
						var marginProperty =
							this.parent.originSide == "left" ? "marginLeft" : "marginRight";
						this.target =
							this.x +
							this.size[marginProperty] +
							this.size.width * this.parent.cellAlign;
					};

					proto.renderPosition = function (x) {
						// render position of cell with in slider
						var side = this.parent.originSide;
						this.element.style[side] = this.parent.getPositionValue(x);
					};

					proto.select = function () {
						this.element.classList.add("is-selected");
						this.element.removeAttribute("aria-hidden");
					};

					proto.unselect = function () {
						this.element.classList.remove("is-selected");
						this.element.setAttribute("aria-hidden", "true");
					};

					/**
					 * @param {Integer} factor - 0, 1, or -1
					 **/
					proto.wrapShift = function (shift) {
						this.shift = shift;
						this.renderPosition(this.x + this.parent.slideableWidth * shift);
					};

					proto.remove = function () {
						this.element.parentNode.removeChild(this.element);
					};

					return Cell;
				});
			}
		);

		var index_es_slide = pxs_slideshow_dist_index_es_createCommonjsModule(
			function (module) {
				// slide
				(function (window, factory) {
					// universal module definition
					/* jshint strict: false */
					if (module.exports) {
						// CommonJS
						module.exports = factory();
					} else {
						// browser global
						window.Flickity = window.Flickity || {};
						window.Flickity.Slide = factory();
					}
				})(window, function factory() {
					function Slide(parent) {
						this.parent = parent;
						this.isOriginLeft = parent.originSide == "left";
						this.cells = [];
						this.outerWidth = 0;
						this.height = 0;
					}

					var proto = Slide.prototype;

					proto.addCell = function (cell) {
						this.cells.push(cell);
						this.outerWidth += cell.size.outerWidth;
						this.height = Math.max(cell.size.outerHeight, this.height);
						// first cell stuff
						if (this.cells.length == 1) {
							this.x = cell.x; // x comes from first cell
							var beginMargin = this.isOriginLeft
								? "marginLeft"
								: "marginRight";
							this.firstMargin = cell.size[beginMargin];
						}
					};

					proto.updateTarget = function () {
						var endMargin = this.isOriginLeft ? "marginRight" : "marginLeft";
						var lastCell = this.getLastCell();
						var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
						var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
						this.target =
							this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
					};

					proto.getLastCell = function () {
						return this.cells[this.cells.length - 1];
					};

					proto.select = function () {
						this.cells.forEach(function (cell) {
							cell.select();
						});
					};

					proto.unselect = function () {
						this.cells.forEach(function (cell) {
							cell.unselect();
						});
					};

					proto.getCellElements = function () {
						return this.cells.map(function (cell) {
							return cell.element;
						});
					};

					return Slide;
				});
			}
		);

		var index_es_animate = pxs_slideshow_dist_index_es_createCommonjsModule(
			function (module) {
				// animate
				(function (window, factory) {
					// universal module definition
					/* jshint strict: false */
					if (module.exports) {
						// CommonJS
						module.exports = factory(window, index_es_utils);
					} else {
						// browser global
						window.Flickity = window.Flickity || {};
						window.Flickity.animatePrototype = factory(
							window,
							window.fizzyUIUtils
						);
					}
				})(window, function factory(window, utils) {
					// -------------------------- animate -------------------------- //

					var proto = {};

					proto.startAnimation = function () {
						if (this.isAnimating) {
							return;
						}

						this.isAnimating = true;
						this.restingFrames = 0;
						this.animate();
					};

					proto.animate = function () {
						this.applyDragForce();
						this.applySelectedAttraction();

						var previousX = this.x;

						this.integratePhysics();
						this.positionSlider();
						this.settle(previousX);
						// animate next frame
						if (this.isAnimating) {
							var _this = this;
							requestAnimationFrame(function animateFrame() {
								_this.animate();
							});
						}
					};

					proto.positionSlider = function () {
						var x = this.x;
						// wrap position around
						if (this.options.wrapAround && this.cells.length > 1) {
							x = utils.modulo(x, this.slideableWidth);
							x = x - this.slideableWidth;
							this.shiftWrapCells(x);
						}

						this.setTranslateX(x, this.isAnimating);
						this.dispatchScrollEvent();
					};

					proto.setTranslateX = function (x, is3d) {
						x += this.cursorPosition;
						// reverse if right-to-left and using transform
						x = this.options.rightToLeft ? -x : x;
						var translateX = this.getPositionValue(x);
						// use 3D tranforms for hardware acceleration on iOS
						// but use 2D when settled, for better font-rendering
						this.slider.style.transform = is3d
							? "translate3d(" + translateX + ",0,0)"
							: "translateX(" + translateX + ")";
					};

					proto.dispatchScrollEvent = function () {
						var firstSlide = this.slides[0];
						if (!firstSlide) {
							return;
						}
						var positionX = -this.x - firstSlide.target;
						var progress = positionX / this.slidesWidth;
						this.dispatchEvent("scroll", null, [progress, positionX]);
					};

					proto.positionSliderAtSelected = function () {
						if (!this.cells.length) {
							return;
						}
						this.x = -this.selectedSlide.target;
						this.velocity = 0; // stop wobble
						this.positionSlider();
					};

					proto.getPositionValue = function (position) {
						if (this.options.percentPosition) {
							// percent position, round to 2 digits, like 12.34%
							return (
								Math.round((position / this.size.innerWidth) * 10000) * 0.01 +
								"%"
							);
						} else {
							// pixel positioning
							return Math.round(position) + "px";
						}
					};

					proto.settle = function (previousX) {
						// keep track of frames where x hasn't moved
						if (
							!this.isPointerDown &&
							Math.round(this.x * 100) == Math.round(previousX * 100)
						) {
							this.restingFrames++;
						}
						// stop animating if resting for 3 or more frames
						if (this.restingFrames > 2) {
							this.isAnimating = false;
							delete this.isFreeScrolling;
							// render position with translateX when settled
							this.positionSlider();
							this.dispatchEvent("settle", null, [this.selectedIndex]);
						}
					};

					proto.shiftWrapCells = function (x) {
						// shift before cells
						var beforeGap = this.cursorPosition + x;
						this._shiftCells(this.beforeShiftCells, beforeGap, -1);
						// shift after cells
						var afterGap =
							this.size.innerWidth -
							(x + this.slideableWidth + this.cursorPosition);
						this._shiftCells(this.afterShiftCells, afterGap, 1);
					};

					proto._shiftCells = function (cells, gap, shift) {
						for (var i = 0; i < cells.length; i++) {
							var cell = cells[i];
							var cellShift = gap > 0 ? shift : 0;
							cell.wrapShift(cellShift);
							gap -= cell.size.outerWidth;
						}
					};

					proto._unshiftCells = function (cells) {
						if (!cells || !cells.length) {
							return;
						}
						for (var i = 0; i < cells.length; i++) {
							cells[i].wrapShift(0);
						}
					};

					// -------------------------- physics -------------------------- //

					proto.integratePhysics = function () {
						this.x += this.velocity;
						this.velocity *= this.getFrictionFactor();
					};

					proto.applyForce = function (force) {
						this.velocity += force;
					};

					proto.getFrictionFactor = function () {
						return (
							1 -
							this.options[
								this.isFreeScrolling ? "freeScrollFriction" : "friction"
							]
						);
					};

					proto.getRestingPosition = function () {
						// my thanks to Steven Wittens, who simplified this math greatly
						return this.x + this.velocity / (1 - this.getFrictionFactor());
					};

					proto.applyDragForce = function () {
						if (!this.isDraggable || !this.isPointerDown) {
							return;
						}
						// change the position to drag position by applying force
						var dragVelocity = this.dragX - this.x;
						var dragForce = dragVelocity - this.velocity;
						this.applyForce(dragForce);
					};

					proto.applySelectedAttraction = function () {
						// do not attract if pointer down or no slides
						var dragDown = this.isDraggable && this.isPointerDown;
						if (dragDown || this.isFreeScrolling || !this.slides.length) {
							return;
						}
						var distance = this.selectedSlide.target * -1 - this.x;
						var force = distance * this.options.selectedAttraction;
						this.applyForce(force);
					};

					return proto;
				});
			}
		);

		var index_es_flickity = pxs_slideshow_dist_index_es_createCommonjsModule(
			function (module) {
				// Flickity main
				(function (window, factory) {
					// universal module definition
					/* jshint strict: false */
					if (module.exports) {
						// CommonJS
						module.exports = factory(
							window,
							index_es_evEmitter,
							index_es_getSize,
							index_es_utils,
							index_es_cell,
							index_es_slide,
							index_es_animate
						);
					} else {
						// browser global
						var _Flickity = window.Flickity;

						window.Flickity = factory(
							window,
							window.EvEmitter,
							window.getSize,
							window.fizzyUIUtils,
							_Flickity.Cell,
							_Flickity.Slide,
							_Flickity.animatePrototype
						);
					}
				})(
					window,
					function factory(
						window,
						EvEmitter,
						getSize,
						utils,
						Cell,
						Slide,
						animatePrototype
					) {
						// vars
						var jQuery = window.jQuery;
						var getComputedStyle = window.getComputedStyle;
						var console = window.console;

						function moveElements(elems, toElem) {
							elems = utils.makeArray(elems);
							while (elems.length) {
								toElem.appendChild(elems.shift());
							}
						}

						// -------------------------- Flickity -------------------------- //

						// globally unique identifiers
						var GUID = 0;
						// internal store of all Flickity intances
						var instances = {};

						function Flickity(element, options) {
							var queryElement = utils.getQueryElement(element);
							if (!queryElement) {
								if (console) {
									console.error(
										"Bad element for Flickity: " + (queryElement || element)
									);
								}
								return;
							}
							this.element = queryElement;
							// do not initialize twice on same element
							if (this.element.flickityGUID) {
								var instance = instances[this.element.flickityGUID];
								instance.option(options);
								return instance;
							}

							// add jQuery
							if (jQuery) {
								this.$element = jQuery(this.element);
							}
							// options
							this.options = utils.extend({}, this.constructor.defaults);
							this.option(options);

							// kick things off
							this._create();
						}

						Flickity.defaults = {
							accessibility: true,
							// adaptiveHeight: false,
							cellAlign: "center",
							// cellSelector: undefined,
							// contain: false,
							freeScrollFriction: 0.075, // friction when free-scrolling
							friction: 0.28, // friction when selecting
							namespaceJQueryEvents: true,
							// initialIndex: 0,
							percentPosition: true,
							resize: true,
							selectedAttraction: 0.025,
							setGallerySize: true,
							// watchCSS: false,
							// wrapAround: false
						};

						// hash of methods triggered on _create()
						Flickity.createMethods = [];

						var proto = Flickity.prototype;
						// inherit EventEmitter
						utils.extend(proto, EvEmitter.prototype);

						proto._create = function () {
							// add id for Flickity.data
							var id = (this.guid = ++GUID);
							this.element.flickityGUID = id; // expando
							instances[id] = this; // associate via id
							// initial properties
							this.selectedIndex = 0;
							// how many frames slider has been in same position
							this.restingFrames = 0;
							// initial physics properties
							this.x = 0;
							this.velocity = 0;
							this.originSide = this.options.rightToLeft ? "right" : "left";
							// create viewport & slider
							this.viewport = document.createElement("div");
							this.viewport.className = "flickity-viewport";
							this._createSlider();

							if (this.options.resize || this.options.watchCSS) {
								window.addEventListener("resize", this);
							}

							// add listeners from on option
							for (var eventName in this.options.on) {
								var listener = this.options.on[eventName];
								this.on(eventName, listener);
							}

							Flickity.createMethods.forEach(function (method) {
								this[method]();
							}, this);

							if (this.options.watchCSS) {
								this.watchCSS();
							} else {
								this.activate();
							}
						};

						/**
						 * set options
						 * @param {Object} opts
						 */
						proto.option = function (opts) {
							utils.extend(this.options, opts);
						};

						proto.activate = function () {
							if (this.isActive) {
								return;
							}
							this.isActive = true;
							this.element.classList.add("flickity-enabled");
							if (this.options.rightToLeft) {
								this.element.classList.add("flickity-rtl");
							}

							this.getSize();
							// move initial cell elements so they can be loaded as cells
							var cellElems = this._filterFindCellElements(
								this.element.children
							);
							moveElements(cellElems, this.slider);
							this.viewport.appendChild(this.slider);
							this.element.appendChild(this.viewport);
							// get cells from children
							this.reloadCells();

							if (this.options.accessibility) {
								// allow element to focusable
								this.element.tabIndex = 0;
								// listen for key presses
								this.element.addEventListener("keydown", this);
							}

							this.emitEvent("activate");
							this.selectInitialIndex();
							// flag for initial activation, for using initialIndex
							this.isInitActivated = true;
							// ready event. #493
							this.dispatchEvent("ready");
						};

						// slider positions the cells
						proto._createSlider = function () {
							// slider element does all the positioning
							var slider = document.createElement("div");
							slider.className = "flickity-slider";
							slider.style[this.originSide] = 0;
							this.slider = slider;
						};

						proto._filterFindCellElements = function (elems) {
							return utils.filterFindElements(elems, this.options.cellSelector);
						};

						// goes through all children
						proto.reloadCells = function () {
							// collection of item elements
							this.cells = this._makeCells(this.slider.children);
							this.positionCells();
							this._getWrapShiftCells();
							this.setGallerySize();
						};

						/**
						 * turn elements into Flickity.Cells
						 * @param {Array or NodeList or HTMLElement} elems
						 * @returns {Array} items - collection of new Flickity Cells
						 */
						proto._makeCells = function (elems) {
							var cellElems = this._filterFindCellElements(elems);

							// create new Flickity for collection
							var cells = cellElems.map(function (cellElem) {
								return new Cell(cellElem, this);
							}, this);

							return cells;
						};

						proto.getLastCell = function () {
							return this.cells[this.cells.length - 1];
						};

						proto.getLastSlide = function () {
							return this.slides[this.slides.length - 1];
						};

						// positions all cells
						proto.positionCells = function () {
							// size all cells
							this._sizeCells(this.cells);
							// position all cells
							this._positionCells(0);
						};

						/**
						 * position certain cells
						 * @param {Integer} index - which cell to start with
						 */
						proto._positionCells = function (index) {
							index = index || 0;
							// also measure maxCellHeight
							// start 0 if positioning all cells
							this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
							var cellX = 0;
							// get cellX
							if (index > 0) {
								var startCell = this.cells[index - 1];
								cellX = startCell.x + startCell.size.outerWidth;
							}
							var len = this.cells.length;
							for (var i = index; i < len; i++) {
								var cell = this.cells[i];
								cell.setPosition(cellX);
								cellX += cell.size.outerWidth;
								this.maxCellHeight = Math.max(
									cell.size.outerHeight,
									this.maxCellHeight
								);
							}
							// keep track of cellX for wrap-around
							this.slideableWidth = cellX;
							// slides
							this.updateSlides();
							// contain slides target
							this._containSlides();
							// update slidesWidth
							this.slidesWidth = len
								? this.getLastSlide().target - this.slides[0].target
								: 0;
						};

						/**
						 * cell.getSize() on multiple cells
						 * @param {Array} cells
						 */
						proto._sizeCells = function (cells) {
							cells.forEach(function (cell) {
								cell.getSize();
							});
						};

						// --------------------------  -------------------------- //

						proto.updateSlides = function () {
							this.slides = [];
							if (!this.cells.length) {
								return;
							}

							var slide = new Slide(this);
							this.slides.push(slide);
							var isOriginLeft = this.originSide == "left";
							var nextMargin = isOriginLeft ? "marginRight" : "marginLeft";

							var canCellFit = this._getCanCellFit();

							this.cells.forEach(function (cell, i) {
								// just add cell if first cell in slide
								if (!slide.cells.length) {
									slide.addCell(cell);
									return;
								}

								var slideWidth =
									slide.outerWidth -
									slide.firstMargin +
									(cell.size.outerWidth - cell.size[nextMargin]);

								if (canCellFit.call(this, i, slideWidth)) {
									slide.addCell(cell);
								} else {
									// doesn't fit, new slide
									slide.updateTarget();

									slide = new Slide(this);
									this.slides.push(slide);
									slide.addCell(cell);
								}
							}, this);
							// last slide
							slide.updateTarget();
							// update .selectedSlide
							this.updateSelectedSlide();
						};

						proto._getCanCellFit = function () {
							var groupCells = this.options.groupCells;
							if (!groupCells) {
								return function () {
									return false;
								};
							} else if (typeof groupCells == "number") {
								// group by number. 3 -> [0,1,2], [3,4,5], ...
								var number = parseInt(groupCells, 10);
								return function (i) {
									return i % number !== 0;
								};
							}
							// default, group by width of slide
							// parse '75%
							var percentMatch =
								typeof groupCells == "string" && groupCells.match(/^(\d+)%$/);
							var percent = percentMatch
								? parseInt(percentMatch[1], 10) / 100
								: 1;
							return function (i, slideWidth) {
								return slideWidth <= (this.size.innerWidth + 1) * percent;
							};
						};

						// alias _init for jQuery plugin .flickity()
						proto._init = proto.reposition = function () {
							this.positionCells();
							this.positionSliderAtSelected();
						};

						proto.getSize = function () {
							this.size = getSize(this.element);
							this.setCellAlign();
							this.cursorPosition = this.size.innerWidth * this.cellAlign;
						};

						var cellAlignShorthands = {
							// cell align, then based on origin side
							center: {
								left: 0.5,
								right: 0.5,
							},
							left: {
								left: 0,
								right: 1,
							},
							right: {
								right: 0,
								left: 1,
							},
						};

						proto.setCellAlign = function () {
							var shorthand = cellAlignShorthands[this.options.cellAlign];
							this.cellAlign = shorthand
								? shorthand[this.originSide]
								: this.options.cellAlign;
						};

						proto.setGallerySize = function () {
							if (this.options.setGallerySize) {
								var height =
									this.options.adaptiveHeight && this.selectedSlide
										? this.selectedSlide.height
										: this.maxCellHeight;
								this.viewport.style.height = height + "px";
							}
						};

						proto._getWrapShiftCells = function () {
							// only for wrap-around
							if (!this.options.wrapAround) {
								return;
							}
							// unshift previous cells
							this._unshiftCells(this.beforeShiftCells);
							this._unshiftCells(this.afterShiftCells);
							// get before cells
							// initial gap
							var gapX = this.cursorPosition;
							var cellIndex = this.cells.length - 1;
							this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
							// get after cells
							// ending gap between last cell and end of gallery viewport
							gapX = this.size.innerWidth - this.cursorPosition;
							// start cloning at first cell, working forwards
							this.afterShiftCells = this._getGapCells(gapX, 0, 1);
						};

						proto._getGapCells = function (gapX, cellIndex, increment) {
							// keep adding cells until the cover the initial gap
							var cells = [];
							while (gapX > 0) {
								var cell = this.cells[cellIndex];
								if (!cell) {
									break;
								}
								cells.push(cell);
								cellIndex += increment;
								gapX -= cell.size.outerWidth;
							}
							return cells;
						};

						// ----- contain ----- //

						// contain cell targets so no excess sliding
						proto._containSlides = function () {
							if (
								!this.options.contain ||
								this.options.wrapAround ||
								!this.cells.length
							) {
								return;
							}
							var isRightToLeft = this.options.rightToLeft;
							var beginMargin = isRightToLeft ? "marginRight" : "marginLeft";
							var endMargin = isRightToLeft ? "marginLeft" : "marginRight";
							var contentWidth =
								this.slideableWidth - this.getLastCell().size[endMargin];
							// content is less than gallery size
							var isContentSmaller = contentWidth < this.size.innerWidth;
							// bounds
							var beginBound =
								this.cursorPosition + this.cells[0].size[beginMargin];
							var endBound =
								contentWidth - this.size.innerWidth * (1 - this.cellAlign);
							// contain each cell target
							this.slides.forEach(function (slide) {
								if (isContentSmaller) {
									// all cells fit inside gallery
									slide.target = contentWidth * this.cellAlign;
								} else {
									// contain to bounds
									slide.target = Math.max(slide.target, beginBound);
									slide.target = Math.min(slide.target, endBound);
								}
							}, this);
						};

						// -----  ----- //

						/**
						 * emits events via eventEmitter and jQuery events
						 * @param {String} type - name of event
						 * @param {Event} event - original event
						 * @param {Array} args - extra arguments
						 */
						proto.dispatchEvent = function (type, event, args) {
							var emitArgs = event ? [event].concat(args) : args;
							this.emitEvent(type, emitArgs);

							if (jQuery && this.$element) {
								// default trigger with type if no event
								type += this.options.namespaceJQueryEvents ? ".flickity" : "";
								var $event = type;
								if (event) {
									// create jQuery event
									var jQEvent = jQuery.Event(event);
									jQEvent.type = type;
									$event = jQEvent;
								}
								this.$element.trigger($event, args);
							}
						};

						// -------------------------- select -------------------------- //

						/**
						 * @param {Integer} index - index of the slide
						 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
						 * @param {Boolean} isInstant - will immediately set position at selected cell
						 */
						proto.select = function (index, isWrap, isInstant) {
							if (!this.isActive) {
								return;
							}
							index = parseInt(index, 10);
							this._wrapSelect(index);

							if (this.options.wrapAround || isWrap) {
								index = utils.modulo(index, this.slides.length);
							}
							// bail if invalid index
							if (!this.slides[index]) {
								return;
							}
							var prevIndex = this.selectedIndex;
							this.selectedIndex = index;
							this.updateSelectedSlide();
							if (isInstant) {
								this.positionSliderAtSelected();
							} else {
								this.startAnimation();
							}
							if (this.options.adaptiveHeight) {
								this.setGallerySize();
							}
							// events
							this.dispatchEvent("select", null, [index]);
							// change event if new index
							if (index != prevIndex) {
								this.dispatchEvent("change", null, [index]);
							}
							// old v1 event name, remove in v3
							this.dispatchEvent("cellSelect");
						};

						// wraps position for wrapAround, to move to closest slide. #113
						proto._wrapSelect = function (index) {
							var len = this.slides.length;
							var isWrapping = this.options.wrapAround && len > 1;
							if (!isWrapping) {
								return index;
							}
							var wrapIndex = utils.modulo(index, len);
							// go to shortest
							var delta = Math.abs(wrapIndex - this.selectedIndex);
							var backWrapDelta = Math.abs(
								wrapIndex + len - this.selectedIndex
							);
							var forewardWrapDelta = Math.abs(
								wrapIndex - len - this.selectedIndex
							);
							if (!this.isDragSelect && backWrapDelta < delta) {
								index += len;
							} else if (!this.isDragSelect && forewardWrapDelta < delta) {
								index -= len;
							}
							// wrap position so slider is within normal area
							if (index < 0) {
								this.x -= this.slideableWidth;
							} else if (index >= len) {
								this.x += this.slideableWidth;
							}
						};

						proto.previous = function (isWrap, isInstant) {
							this.select(this.selectedIndex - 1, isWrap, isInstant);
						};

						proto.next = function (isWrap, isInstant) {
							this.select(this.selectedIndex + 1, isWrap, isInstant);
						};

						proto.updateSelectedSlide = function () {
							var slide = this.slides[this.selectedIndex];
							// selectedIndex could be outside of slides, if triggered before resize()
							if (!slide) {
								return;
							}
							// unselect previous selected slide
							this.unselectSelectedSlide();
							// update new selected slide
							this.selectedSlide = slide;
							slide.select();
							this.selectedCells = slide.cells;
							this.selectedElements = slide.getCellElements();
							// HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
							// Remove in v3?
							this.selectedCell = slide.cells[0];
							this.selectedElement = this.selectedElements[0];
						};

						proto.unselectSelectedSlide = function () {
							if (this.selectedSlide) {
								this.selectedSlide.unselect();
							}
						};

						proto.selectInitialIndex = function () {
							var initialIndex = this.options.initialIndex;
							// already activated, select previous selectedIndex
							if (this.isInitActivated) {
								this.select(this.selectedIndex, false, true);
								return;
							}
							// select with selector string
							if (initialIndex && typeof initialIndex == "string") {
								var cell = this.queryCell(initialIndex);
								if (cell) {
									this.selectCell(initialIndex, false, true);
									return;
								}
							}

							var index = 0;
							// select with number
							if (initialIndex && this.slides[initialIndex]) {
								index = initialIndex;
							}
							// select instantly
							this.select(index, false, true);
						};

						/**
						 * select slide from number or cell element
						 * @param {Element or Number} elem
						 */
						proto.selectCell = function (value, isWrap, isInstant) {
							// get cell
							var cell = this.queryCell(value);
							if (!cell) {
								return;
							}

							var index = this.getCellSlideIndex(cell);
							this.select(index, isWrap, isInstant);
						};

						proto.getCellSlideIndex = function (cell) {
							// get index of slides that has cell
							for (var i = 0; i < this.slides.length; i++) {
								var slide = this.slides[i];
								var index = slide.cells.indexOf(cell);
								if (index != -1) {
									return i;
								}
							}
						};

						// -------------------------- get cells -------------------------- //

						/**
						 * get Flickity.Cell, given an Element
						 * @param {Element} elem
						 * @returns {Flickity.Cell} item
						 */
						proto.getCell = function (elem) {
							// loop through cells to get the one that matches
							for (var i = 0; i < this.cells.length; i++) {
								var cell = this.cells[i];
								if (cell.element == elem) {
									return cell;
								}
							}
						};

						/**
						 * get collection of Flickity.Cells, given Elements
						 * @param {Element, Array, NodeList} elems
						 * @returns {Array} cells - Flickity.Cells
						 */
						proto.getCells = function (elems) {
							elems = utils.makeArray(elems);
							var cells = [];
							elems.forEach(function (elem) {
								var cell = this.getCell(elem);
								if (cell) {
									cells.push(cell);
								}
							}, this);
							return cells;
						};

						/**
						 * get cell elements
						 * @returns {Array} cellElems
						 */
						proto.getCellElements = function () {
							return this.cells.map(function (cell) {
								return cell.element;
							});
						};

						/**
						 * get parent cell from an element
						 * @param {Element} elem
						 * @returns {Flickit.Cell} cell
						 */
						proto.getParentCell = function (elem) {
							// first check if elem is cell
							var cell = this.getCell(elem);
							if (cell) {
								return cell;
							}
							// try to get parent cell elem
							elem = utils.getParent(elem, ".flickity-slider > *");
							return this.getCell(elem);
						};

						/**
						 * get cells adjacent to a slide
						 * @param {Integer} adjCount - number of adjacent slides
						 * @param {Integer} index - index of slide to start
						 * @returns {Array} cells - array of Flickity.Cells
						 */
						proto.getAdjacentCellElements = function (adjCount, index) {
							if (!adjCount) {
								return this.selectedSlide.getCellElements();
							}
							index = index === undefined ? this.selectedIndex : index;

							var len = this.slides.length;
							if (1 + adjCount * 2 >= len) {
								return this.getCellElements();
							}

							var cellElems = [];
							for (var i = index - adjCount; i <= index + adjCount; i++) {
								var slideIndex = this.options.wrapAround
									? utils.modulo(i, len)
									: i;
								var slide = this.slides[slideIndex];
								if (slide) {
									cellElems = cellElems.concat(slide.getCellElements());
								}
							}
							return cellElems;
						};

						/**
						 * select slide from number or cell element
						 * @param {Element, Selector String, or Number} selector
						 */
						proto.queryCell = function (selector) {
							if (typeof selector == "number") {
								// use number as index
								return this.cells[selector];
							}
							if (typeof selector == "string") {
								// do not select invalid selectors from hash: #123, #/. #791
								if (selector.match(/^[#\.]?[\d\/]/)) {
									return;
								}
								// use string as selector, get element
								selector = this.element.querySelector(selector);
							}
							// get cell from element
							return this.getCell(selector);
						};

						// -------------------------- events -------------------------- //

						proto.uiChange = function () {
							this.emitEvent("uiChange");
						};

						// keep focus on element when child UI elements are clicked
						proto.childUIPointerDown = function (event) {
							// HACK iOS does not allow touch events to bubble up?!
							if (event.type != "touchstart") {
								event.preventDefault();
							}
							this.focus();
						};

						// ----- resize ----- //

						proto.onresize = function () {
							this.watchCSS();
							this.resize();
						};

						utils.debounceMethod(Flickity, "onresize", 150);

						proto.resize = function () {
							if (!this.isActive) {
								return;
							}
							this.getSize();
							// wrap values
							if (this.options.wrapAround) {
								this.x = utils.modulo(this.x, this.slideableWidth);
							}
							this.positionCells();
							this._getWrapShiftCells();
							this.setGallerySize();
							this.emitEvent("resize");
							// update selected index for group slides, instant
							// TODO: position can be lost between groups of various numbers
							var selectedElement =
								this.selectedElements && this.selectedElements[0];
							this.selectCell(selectedElement, false, true);
						};

						// watches the :after property, activates/deactivates
						proto.watchCSS = function () {
							var watchOption = this.options.watchCSS;
							if (!watchOption) {
								return;
							}

							var afterContent = getComputedStyle(
								this.element,
								":after"
							).content;
							// activate if :after { content: 'flickity' }
							if (afterContent.indexOf("flickity") != -1) {
								this.activate();
							} else {
								this.deactivate();
							}
						};

						// ----- keydown ----- //

						// go previous/next if left/right keys pressed
						proto.onkeydown = function (event) {
							// only work if element is in focus
							var isNotFocused =
								document.activeElement &&
								document.activeElement != this.element;
							if (!this.options.accessibility || isNotFocused) {
								return;
							}

							var handler = Flickity.keyboardHandlers[event.keyCode];
							if (handler) {
								handler.call(this);
							}
						};

						Flickity.keyboardHandlers = {
							// left arrow
							37: function () {
								var leftMethod = this.options.rightToLeft ? "next" : "previous";
								this.uiChange();
								this[leftMethod]();
							},
							// right arrow
							39: function () {
								var rightMethod = this.options.rightToLeft
									? "previous"
									: "next";
								this.uiChange();
								this[rightMethod]();
							},
						};

						// ----- focus ----- //

						proto.focus = function () {
							// TODO remove scrollTo once focus options gets more support
							// https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Browser_compatibility
							var prevScrollY = window.pageYOffset;
							this.element.focus({ preventScroll: true });
							// hack to fix scroll jump after focus, #76
							if (window.pageYOffset != prevScrollY) {
								window.scrollTo(window.pageXOffset, prevScrollY);
							}
						};

						// -------------------------- destroy -------------------------- //

						// deactivate all Flickity functionality, but keep stuff available
						proto.deactivate = function () {
							if (!this.isActive) {
								return;
							}
							this.element.classList.remove("flickity-enabled");
							this.element.classList.remove("flickity-rtl");
							this.unselectSelectedSlide();
							// destroy cells
							this.cells.forEach(function (cell) {
								cell.destroy();
							});
							this.element.removeChild(this.viewport);
							// move child elements back into element
							moveElements(this.slider.children, this.element);
							if (this.options.accessibility) {
								this.element.removeAttribute("tabIndex");
								this.element.removeEventListener("keydown", this);
							}
							// set flags
							this.isActive = false;
							this.emitEvent("deactivate");
						};

						proto.destroy = function () {
							this.deactivate();
							window.removeEventListener("resize", this);
							this.allOff();
							this.emitEvent("destroy");
							if (jQuery && this.$element) {
								jQuery.removeData(this.element, "flickity");
							}
							delete this.element.flickityGUID;
							delete instances[this.guid];
						};

						// -------------------------- prototype -------------------------- //

						utils.extend(proto, animatePrototype);

						// -------------------------- extras -------------------------- //

						/**
						 * get Flickity instance from element
						 * @param {Element} elem
						 * @returns {Flickity}
						 */
						Flickity.data = function (elem) {
							elem = utils.getQueryElement(elem);
							var id = elem && elem.flickityGUID;
							return id && instances[id];
						};

						utils.htmlInit(Flickity, "flickity");

						if (jQuery && jQuery.bridget) {
							jQuery.bridget("flickity", Flickity);
						}

						// set internal jQuery, for Webpack + jQuery v3, #478
						Flickity.setJQuery = function (jq) {
							jQuery = jq;
						};

						Flickity.Cell = Cell;
						Flickity.Slide = Slide;

						return Flickity;
					}
				);
			}
		);

		var index_es_unipointer = pxs_slideshow_dist_index_es_createCommonjsModule(
			function (module) {
				/*!
				 * Unipointer v2.3.0
				 * base class for doing one thing with pointer event
				 * MIT license
				 */

				/*jshint browser: true, undef: true, unused: true, strict: true */

				(function (window, factory) {
					// universal module definition
					/* jshint strict: false */ /*global define, module, require */
					if (module.exports) {
						// CommonJS
						module.exports = factory(window, index_es_evEmitter);
					} else {
						// browser global
						window.Unipointer = factory(window, window.EvEmitter);
					}
				})(window, function factory(window, EvEmitter) {
					function noop() {}

					function Unipointer() {}

					// inherit EvEmitter
					var proto = (Unipointer.prototype = Object.create(
						EvEmitter.prototype
					));

					proto.bindStartEvent = function (elem) {
						this._bindStartEvent(elem, true);
					};

					proto.unbindStartEvent = function (elem) {
						this._bindStartEvent(elem, false);
					};

					/**
					 * Add or remove start event
					 * @param {Boolean} isAdd - remove if falsey
					 */
					proto._bindStartEvent = function (elem, isAdd) {
						// munge isAdd, default to true
						isAdd = isAdd === undefined ? true : isAdd;
						var bindMethod = isAdd ? "addEventListener" : "removeEventListener";

						// default to mouse events
						var startEvent = "mousedown";
						if (window.PointerEvent) {
							// Pointer Events
							startEvent = "pointerdown";
						} else if ("ontouchstart" in window) {
							// Touch Events. iOS Safari
							startEvent = "touchstart";
						}
						elem[bindMethod](startEvent, this);
					};

					// trigger handler methods for events
					proto.handleEvent = function (event) {
						var method = "on" + event.type;
						if (this[method]) {
							this[method](event);
						}
					};

					// returns the touch that we're keeping track of
					proto.getTouch = function (touches) {
						for (var i = 0; i < touches.length; i++) {
							var touch = touches[i];
							if (touch.identifier == this.pointerIdentifier) {
								return touch;
							}
						}
					};

					// ----- start event ----- //

					proto.onmousedown = function (event) {
						// dismiss clicks from right or middle buttons
						var button = event.button;
						if (button && button !== 0 && button !== 1) {
							return;
						}
						this._pointerDown(event, event);
					};

					proto.ontouchstart = function (event) {
						this._pointerDown(event, event.changedTouches[0]);
					};

					proto.onpointerdown = function (event) {
						this._pointerDown(event, event);
					};

					/**
					 * pointer start
					 * @param {Event} event
					 * @param {Event or Touch} pointer
					 */
					proto._pointerDown = function (event, pointer) {
						// dismiss right click and other pointers
						// button = 0 is okay, 1-4 not
						if (event.button || this.isPointerDown) {
							return;
						}

						this.isPointerDown = true;
						// save pointer identifier to match up touch events
						this.pointerIdentifier =
							pointer.pointerId !== undefined
								? // pointerId for pointer events, touch.indentifier for touch events
								  pointer.pointerId
								: pointer.identifier;

						this.pointerDown(event, pointer);
					};

					proto.pointerDown = function (event, pointer) {
						this._bindPostStartEvents(event);
						this.emitEvent("pointerDown", [event, pointer]);
					};

					// hash of events to be bound after start event
					var postStartEvents = {
						mousedown: ["mousemove", "mouseup"],
						touchstart: ["touchmove", "touchend", "touchcancel"],
						pointerdown: ["pointermove", "pointerup", "pointercancel"],
					};

					proto._bindPostStartEvents = function (event) {
						if (!event) {
							return;
						}
						// get proper events to match start event
						var events = postStartEvents[event.type];
						// bind events to node
						events.forEach(function (eventName) {
							window.addEventListener(eventName, this);
						}, this);
						// save these arguments
						this._boundPointerEvents = events;
					};

					proto._unbindPostStartEvents = function () {
						// check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
						if (!this._boundPointerEvents) {
							return;
						}
						this._boundPointerEvents.forEach(function (eventName) {
							window.removeEventListener(eventName, this);
						}, this);

						delete this._boundPointerEvents;
					};

					// ----- move event ----- //

					proto.onmousemove = function (event) {
						this._pointerMove(event, event);
					};

					proto.onpointermove = function (event) {
						if (event.pointerId == this.pointerIdentifier) {
							this._pointerMove(event, event);
						}
					};

					proto.ontouchmove = function (event) {
						var touch = this.getTouch(event.changedTouches);
						if (touch) {
							this._pointerMove(event, touch);
						}
					};

					/**
					 * pointer move
					 * @param {Event} event
					 * @param {Event or Touch} pointer
					 * @private
					 */
					proto._pointerMove = function (event, pointer) {
						this.pointerMove(event, pointer);
					};

					// public
					proto.pointerMove = function (event, pointer) {
						this.emitEvent("pointerMove", [event, pointer]);
					};

					// ----- end event ----- //

					proto.onmouseup = function (event) {
						this._pointerUp(event, event);
					};

					proto.onpointerup = function (event) {
						if (event.pointerId == this.pointerIdentifier) {
							this._pointerUp(event, event);
						}
					};

					proto.ontouchend = function (event) {
						var touch = this.getTouch(event.changedTouches);
						if (touch) {
							this._pointerUp(event, touch);
						}
					};

					/**
					 * pointer up
					 * @param {Event} event
					 * @param {Event or Touch} pointer
					 * @private
					 */
					proto._pointerUp = function (event, pointer) {
						this._pointerDone();
						this.pointerUp(event, pointer);
					};

					// public
					proto.pointerUp = function (event, pointer) {
						this.emitEvent("pointerUp", [event, pointer]);
					};

					// ----- pointer done ----- //

					// triggered on pointer up & pointer cancel
					proto._pointerDone = function () {
						this._pointerReset();
						this._unbindPostStartEvents();
						this.pointerDone();
					};

					proto._pointerReset = function () {
						// reset properties
						this.isPointerDown = false;
						delete this.pointerIdentifier;
					};

					proto.pointerDone = noop;

					// ----- pointer cancel ----- //

					proto.onpointercancel = function (event) {
						if (event.pointerId == this.pointerIdentifier) {
							this._pointerCancel(event, event);
						}
					};

					proto.ontouchcancel = function (event) {
						var touch = this.getTouch(event.changedTouches);
						if (touch) {
							this._pointerCancel(event, touch);
						}
					};

					/**
					 * pointer cancel
					 * @param {Event} event
					 * @param {Event or Touch} pointer
					 * @private
					 */
					proto._pointerCancel = function (event, pointer) {
						this._pointerDone();
						this.pointerCancel(event, pointer);
					};

					// public
					proto.pointerCancel = function (event, pointer) {
						this.emitEvent("pointerCancel", [event, pointer]);
					};

					// -----  ----- //

					// utility function for getting x/y coords from event
					Unipointer.getPointerPoint = function (pointer) {
						return {
							x: pointer.pageX,
							y: pointer.pageY,
						};
					};

					// -----  ----- //

					return Unipointer;
				});
			}
		);

		var index_es_unidragger = pxs_slideshow_dist_index_es_createCommonjsModule(
			function (module) {
				/*!
				 * Unidragger v2.3.0
				 * Draggable base class
				 * MIT license
				 */

				/*jshint browser: true, unused: true, undef: true, strict: true */

				(function (window, factory) {
					// universal module definition
					/*jshint strict: false */ /*globals define, module, require */

					if (module.exports) {
						// CommonJS
						module.exports = factory(window, index_es_unipointer);
					} else {
						// browser global
						window.Unidragger = factory(window, window.Unipointer);
					}
				})(window, function factory(window, Unipointer) {
					// -------------------------- Unidragger -------------------------- //

					function Unidragger() {}

					// inherit Unipointer & EvEmitter
					var proto = (Unidragger.prototype = Object.create(
						Unipointer.prototype
					));

					// ----- bind start ----- //

					proto.bindHandles = function () {
						this._bindHandles(true);
					};

					proto.unbindHandles = function () {
						this._bindHandles(false);
					};

					/**
					 * Add or remove start event
					 * @param {Boolean} isAdd
					 */
					proto._bindHandles = function (isAdd) {
						// munge isAdd, default to true
						isAdd = isAdd === undefined ? true : isAdd;
						// bind each handle
						var bindMethod = isAdd ? "addEventListener" : "removeEventListener";
						var touchAction = isAdd ? this._touchActionValue : "";
						for (var i = 0; i < this.handles.length; i++) {
							var handle = this.handles[i];
							this._bindStartEvent(handle, isAdd);
							handle[bindMethod]("click", this);
							// touch-action: none to override browser touch gestures. metafizzy/flickity#540
							if (window.PointerEvent) {
								handle.style.touchAction = touchAction;
							}
						}
					};

					// prototype so it can be overwriteable by Flickity
					proto._touchActionValue = "none";

					// ----- start event ----- //

					/**
					 * pointer start
					 * @param {Event} event
					 * @param {Event or Touch} pointer
					 */
					proto.pointerDown = function (event, pointer) {
						var isOkay = this.okayPointerDown(event);
						if (!isOkay) {
							return;
						}
						// track start event position
						this.pointerDownPointer = pointer;

						event.preventDefault();
						this.pointerDownBlur();
						// bind move and end events
						this._bindPostStartEvents(event);
						this.emitEvent("pointerDown", [event, pointer]);
					};

					// nodes that have text fields
					var cursorNodes = {
						TEXTAREA: true,
						INPUT: true,
						SELECT: true,
						OPTION: true,
					};

					// input types that do not have text fields
					var clickTypes = {
						radio: true,
						checkbox: true,
						button: true,
						submit: true,
						image: true,
						file: true,
					};

					// dismiss inputs with text fields. flickity#403, flickity#404
					proto.okayPointerDown = function (event) {
						var isCursorNode = cursorNodes[event.target.nodeName];
						var isClickType = clickTypes[event.target.type];
						var isOkay = !isCursorNode || isClickType;
						if (!isOkay) {
							this._pointerReset();
						}
						return isOkay;
					};

					// kludge to blur previously focused input
					proto.pointerDownBlur = function () {
						var focused = document.activeElement;
						// do not blur body for IE10, metafizzy/flickity#117
						var canBlur = focused && focused.blur && focused != document.body;
						if (canBlur) {
							focused.blur();
						}
					};

					// ----- move event ----- //

					/**
					 * drag move
					 * @param {Event} event
					 * @param {Event or Touch} pointer
					 */
					proto.pointerMove = function (event, pointer) {
						var moveVector = this._dragPointerMove(event, pointer);
						this.emitEvent("pointerMove", [event, pointer, moveVector]);
						this._dragMove(event, pointer, moveVector);
					};

					// base pointer move logic
					proto._dragPointerMove = function (event, pointer) {
						var moveVector = {
							x: pointer.pageX - this.pointerDownPointer.pageX,
							y: pointer.pageY - this.pointerDownPointer.pageY,
						};
						// start drag if pointer has moved far enough to start drag
						if (!this.isDragging && this.hasDragStarted(moveVector)) {
							this._dragStart(event, pointer);
						}
						return moveVector;
					};

					// condition if pointer has moved far enough to start drag
					proto.hasDragStarted = function (moveVector) {
						return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
					};

					// ----- end event ----- //

					/**
					 * pointer up
					 * @param {Event} event
					 * @param {Event or Touch} pointer
					 */
					proto.pointerUp = function (event, pointer) {
						this.emitEvent("pointerUp", [event, pointer]);
						this._dragPointerUp(event, pointer);
					};

					proto._dragPointerUp = function (event, pointer) {
						if (this.isDragging) {
							this._dragEnd(event, pointer);
						} else {
							// pointer didn't move enough for drag to start
							this._staticClick(event, pointer);
						}
					};

					// -------------------------- drag -------------------------- //

					// dragStart
					proto._dragStart = function (event, pointer) {
						this.isDragging = true;
						// prevent clicks
						this.isPreventingClicks = true;
						this.dragStart(event, pointer);
					};

					proto.dragStart = function (event, pointer) {
						this.emitEvent("dragStart", [event, pointer]);
					};

					// dragMove
					proto._dragMove = function (event, pointer, moveVector) {
						// do not drag if not dragging yet
						if (!this.isDragging) {
							return;
						}

						this.dragMove(event, pointer, moveVector);
					};

					proto.dragMove = function (event, pointer, moveVector) {
						event.preventDefault();
						this.emitEvent("dragMove", [event, pointer, moveVector]);
					};

					// dragEnd
					proto._dragEnd = function (event, pointer) {
						// set flags
						this.isDragging = false;
						// re-enable clicking async
						setTimeout(
							function () {
								delete this.isPreventingClicks;
							}.bind(this)
						);

						this.dragEnd(event, pointer);
					};

					proto.dragEnd = function (event, pointer) {
						this.emitEvent("dragEnd", [event, pointer]);
					};

					// ----- onclick ----- //

					// handle all clicks and prevent clicks when dragging
					proto.onclick = function (event) {
						if (this.isPreventingClicks) {
							event.preventDefault();
						}
					};

					// ----- staticClick ----- //

					// triggered after pointer down & up with no/tiny movement
					proto._staticClick = function (event, pointer) {
						// ignore emulated mouse up clicks
						if (this.isIgnoringMouseUp && event.type == "mouseup") {
							return;
						}

						this.staticClick(event, pointer);

						// set flag for emulated clicks 300ms after touchend
						if (event.type != "mouseup") {
							this.isIgnoringMouseUp = true;
							// reset flag after 300ms
							setTimeout(
								function () {
									delete this.isIgnoringMouseUp;
								}.bind(this),
								400
							);
						}
					};

					proto.staticClick = function (event, pointer) {
						this.emitEvent("staticClick", [event, pointer]);
					};

					// ----- utils ----- //

					Unidragger.getPointerPoint = Unipointer.getPointerPoint;

					// -----  ----- //

					return Unidragger;
				});
			}
		);

		var index_es_drag = pxs_slideshow_dist_index_es_createCommonjsModule(
			function (module) {
				// drag
				(function (window, factory) {
					// universal module definition
					/* jshint strict: false */
					if (module.exports) {
						// CommonJS
						module.exports = factory(
							window,
							index_es_flickity,
							index_es_unidragger,
							index_es_utils
						);
					} else {
						// browser global
						window.Flickity = factory(
							window,
							window.Flickity,
							window.Unidragger,
							window.fizzyUIUtils
						);
					}
				})(window, function factory(window, Flickity, Unidragger, utils) {
					// ----- defaults ----- //

					utils.extend(Flickity.defaults, {
						draggable: ">1",
						dragThreshold: 3,
					});

					// ----- create ----- //

					Flickity.createMethods.push("_createDrag");

					// -------------------------- drag prototype -------------------------- //

					var proto = Flickity.prototype;
					utils.extend(proto, Unidragger.prototype);
					proto._touchActionValue = "pan-y";

					// --------------------------  -------------------------- //

					var isTouch = "createTouch" in document;
					var isTouchmoveScrollCanceled = false;

					proto._createDrag = function () {
						this.on("activate", this.onActivateDrag);
						this.on("uiChange", this._uiChangeDrag);
						this.on("deactivate", this.onDeactivateDrag);
						this.on("cellChange", this.updateDraggable);
						// TODO updateDraggable on resize? if groupCells & slides change
						// HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
						// #457, RubaXa/Sortable#973
						if (isTouch && !isTouchmoveScrollCanceled) {
							window.addEventListener("touchmove", function () {});
							isTouchmoveScrollCanceled = true;
						}
					};

					proto.onActivateDrag = function () {
						this.handles = [this.viewport];
						this.bindHandles();
						this.updateDraggable();
					};

					proto.onDeactivateDrag = function () {
						this.unbindHandles();
						this.element.classList.remove("is-draggable");
					};

					proto.updateDraggable = function () {
						// disable dragging if less than 2 slides. #278
						if (this.options.draggable == ">1") {
							this.isDraggable = this.slides.length > 1;
						} else {
							this.isDraggable = this.options.draggable;
						}
						if (this.isDraggable) {
							this.element.classList.add("is-draggable");
						} else {
							this.element.classList.remove("is-draggable");
						}
					};

					// backwards compatibility
					proto.bindDrag = function () {
						this.options.draggable = true;
						this.updateDraggable();
					};

					proto.unbindDrag = function () {
						this.options.draggable = false;
						this.updateDraggable();
					};

					proto._uiChangeDrag = function () {
						delete this.isFreeScrolling;
					};

					// -------------------------- pointer events -------------------------- //

					proto.pointerDown = function (event, pointer) {
						if (!this.isDraggable) {
							this._pointerDownDefault(event, pointer);
							return;
						}
						var isOkay = this.okayPointerDown(event);
						if (!isOkay) {
							return;
						}

						this._pointerDownPreventDefault(event);
						this.pointerDownFocus(event);
						// blur
						if (document.activeElement != this.element) {
							// do not blur if already focused
							this.pointerDownBlur();
						}

						// stop if it was moving
						this.dragX = this.x;
						this.viewport.classList.add("is-pointer-down");
						// track scrolling
						this.pointerDownScroll = getScrollPosition();
						window.addEventListener("scroll", this);

						this._pointerDownDefault(event, pointer);
					};

					// default pointerDown logic, used for staticClick
					proto._pointerDownDefault = function (event, pointer) {
						// track start event position
						// Safari 9 overrides pageX and pageY. These values needs to be copied. #779
						this.pointerDownPointer = {
							pageX: pointer.pageX,
							pageY: pointer.pageY,
						};
						// bind move and end events
						this._bindPostStartEvents(event);
						this.dispatchEvent("pointerDown", event, [pointer]);
					};

					var focusNodes = {
						INPUT: true,
						TEXTAREA: true,
						SELECT: true,
					};

					proto.pointerDownFocus = function (event) {
						var isFocusNode = focusNodes[event.target.nodeName];
						if (!isFocusNode) {
							this.focus();
						}
					};

					proto._pointerDownPreventDefault = function (event) {
						var isTouchStart = event.type == "touchstart";
						var isTouchPointer = event.pointerType == "touch";
						var isFocusNode = focusNodes[event.target.nodeName];
						if (!isTouchStart && !isTouchPointer && !isFocusNode) {
							event.preventDefault();
						}
					};

					// ----- move ----- //

					proto.hasDragStarted = function (moveVector) {
						return Math.abs(moveVector.x) > this.options.dragThreshold;
					};

					// ----- up ----- //

					proto.pointerUp = function (event, pointer) {
						delete this.isTouchScrolling;
						this.viewport.classList.remove("is-pointer-down");
						this.dispatchEvent("pointerUp", event, [pointer]);
						this._dragPointerUp(event, pointer);
					};

					proto.pointerDone = function () {
						window.removeEventListener("scroll", this);
						delete this.pointerDownScroll;
					};

					// -------------------------- dragging -------------------------- //

					proto.dragStart = function (event, pointer) {
						if (!this.isDraggable) {
							return;
						}
						this.dragStartPosition = this.x;
						this.startAnimation();
						window.removeEventListener("scroll", this);
						this.dispatchEvent("dragStart", event, [pointer]);
					};

					proto.pointerMove = function (event, pointer) {
						var moveVector = this._dragPointerMove(event, pointer);
						this.dispatchEvent("pointerMove", event, [pointer, moveVector]);
						this._dragMove(event, pointer, moveVector);
					};

					proto.dragMove = function (event, pointer, moveVector) {
						if (!this.isDraggable) {
							return;
						}
						event.preventDefault();

						this.previousDragX = this.dragX;
						// reverse if right-to-left
						var direction = this.options.rightToLeft ? -1 : 1;
						if (this.options.wrapAround) {
							// wrap around move. #589
							moveVector.x = moveVector.x % this.slideableWidth;
						}
						var dragX = this.dragStartPosition + moveVector.x * direction;

						if (!this.options.wrapAround && this.slides.length) {
							// slow drag
							var originBound = Math.max(
								-this.slides[0].target,
								this.dragStartPosition
							);
							dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
							var endBound = Math.min(
								-this.getLastSlide().target,
								this.dragStartPosition
							);
							dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
						}

						this.dragX = dragX;

						this.dragMoveTime = new Date();
						this.dispatchEvent("dragMove", event, [pointer, moveVector]);
					};

					proto.dragEnd = function (event, pointer) {
						if (!this.isDraggable) {
							return;
						}
						if (this.options.freeScroll) {
							this.isFreeScrolling = true;
						}
						// set selectedIndex based on where flick will end up
						var index = this.dragEndRestingSelect();

						if (this.options.freeScroll && !this.options.wrapAround) {
							// if free-scroll & not wrap around
							// do not free-scroll if going outside of bounding slides
							// so bounding slides can attract slider, and keep it in bounds
							var restingX = this.getRestingPosition();
							this.isFreeScrolling =
								-restingX > this.slides[0].target &&
								-restingX < this.getLastSlide().target;
						} else if (
							!this.options.freeScroll &&
							index == this.selectedIndex
						) {
							// boost selection if selected index has not changed
							index += this.dragEndBoostSelect();
						}
						delete this.previousDragX;
						// apply selection
						// TODO refactor this, selecting here feels weird
						// HACK, set flag so dragging stays in correct direction
						this.isDragSelect = this.options.wrapAround;
						this.select(index);
						delete this.isDragSelect;
						this.dispatchEvent("dragEnd", event, [pointer]);
					};

					proto.dragEndRestingSelect = function () {
						var restingX = this.getRestingPosition();
						// how far away from selected slide
						var distance = Math.abs(
							this.getSlideDistance(-restingX, this.selectedIndex)
						);
						// get closet resting going up and going down
						var positiveResting = this._getClosestResting(
							restingX,
							distance,
							1
						);
						var negativeResting = this._getClosestResting(
							restingX,
							distance,
							-1
						);
						// use closer resting for wrap-around
						var index =
							positiveResting.distance < negativeResting.distance
								? positiveResting.index
								: negativeResting.index;
						return index;
					};

					/**
					 * given resting X and distance to selected cell
					 * get the distance and index of the closest cell
					 * @param {Number} restingX - estimated post-flick resting position
					 * @param {Number} distance - distance to selected cell
					 * @param {Integer} increment - +1 or -1, going up or down
					 * @returns {Object} - { distance: {Number}, index: {Integer} }
					 */
					proto._getClosestResting = function (restingX, distance, increment) {
						var index = this.selectedIndex;
						var minDistance = Infinity;
						var condition =
							this.options.contain && !this.options.wrapAround
								? // if contain, keep going if distance is equal to minDistance
								  function (d, md) {
										return d <= md;
								  }
								: function (d, md) {
										return d < md;
								  };
						while (condition(distance, minDistance)) {
							// measure distance to next cell
							index += increment;
							minDistance = distance;
							distance = this.getSlideDistance(-restingX, index);
							if (distance === null) {
								break;
							}
							distance = Math.abs(distance);
						}
						return {
							distance: minDistance,
							// selected was previous index
							index: index - increment,
						};
					};

					/**
					 * measure distance between x and a slide target
					 * @param {Number} x
					 * @param {Integer} index - slide index
					 */
					proto.getSlideDistance = function (x, index) {
						var len = this.slides.length;
						// wrap around if at least 2 slides
						var isWrapAround = this.options.wrapAround && len > 1;
						var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
						var slide = this.slides[slideIndex];
						if (!slide) {
							return null;
						}
						// add distance for wrap-around slides
						var wrap = isWrapAround
							? this.slideableWidth * Math.floor(index / len)
							: 0;
						return x - (slide.target + wrap);
					};

					proto.dragEndBoostSelect = function () {
						// do not boost if no previousDragX or dragMoveTime
						if (
							this.previousDragX === undefined ||
							!this.dragMoveTime ||
							// or if drag was held for 100 ms
							new Date() - this.dragMoveTime > 100
						) {
							return 0;
						}

						var distance = this.getSlideDistance(
							-this.dragX,
							this.selectedIndex
						);
						var delta = this.previousDragX - this.dragX;
						if (distance > 0 && delta > 0) {
							// boost to next if moving towards the right, and positive velocity
							return 1;
						} else if (distance < 0 && delta < 0) {
							// boost to previous if moving towards the left, and negative velocity
							return -1;
						}
						return 0;
					};

					// ----- staticClick ----- //

					proto.staticClick = function (event, pointer) {
						// get clickedCell, if cell was clicked
						var clickedCell = this.getParentCell(event.target);
						var cellElem = clickedCell && clickedCell.element;
						var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
						this.dispatchEvent("staticClick", event, [
							pointer,
							cellElem,
							cellIndex,
						]);
					};

					// ----- scroll ----- //

					proto.onscroll = function () {
						var scroll = getScrollPosition();
						var scrollMoveX = this.pointerDownScroll.x - scroll.x;
						var scrollMoveY = this.pointerDownScroll.y - scroll.y;
						// cancel click/tap if scroll is too much
						if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
							this._pointerDone();
						}
					};

					// ----- utils ----- //

					function getScrollPosition() {
						return {
							x: window.pageXOffset,
							y: window.pageYOffset,
						};
					}

					// -----  ----- //

					return Flickity;
				});
			}
		);

		var index_es_prevNextButton =
			pxs_slideshow_dist_index_es_createCommonjsModule(function (module) {
				// prev/next buttons
				(function (window, factory) {
					// universal module definition
					/* jshint strict: false */
					if (module.exports) {
						// CommonJS
						module.exports = factory(
							window,
							index_es_flickity,
							index_es_unipointer,
							index_es_utils
						);
					} else {
						// browser global
						factory(
							window,
							window.Flickity,
							window.Unipointer,
							window.fizzyUIUtils
						);
					}
				})(window, function factory(window, Flickity, Unipointer, utils) {
					var svgURI = "http://www.w3.org/2000/svg";

					// -------------------------- PrevNextButton -------------------------- //

					function PrevNextButton(direction, parent) {
						this.direction = direction;
						this.parent = parent;
						this._create();
					}

					PrevNextButton.prototype = Object.create(Unipointer.prototype);

					PrevNextButton.prototype._create = function () {
						// properties
						this.isEnabled = true;
						this.isPrevious = this.direction == -1;
						var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
						this.isLeft = this.direction == leftDirection;

						var element = (this.element = document.createElement("button"));
						element.className = "flickity-button flickity-prev-next-button";
						element.className += this.isPrevious ? " previous" : " next";
						// prevent button from submitting form http://stackoverflow.com/a/10836076/182183
						element.setAttribute("type", "button");
						// init as disabled
						this.disable();

						element.setAttribute(
							"aria-label",
							this.isPrevious ? "Previous" : "Next"
						);

						// create arrow
						var svg = this.createSVG();
						element.appendChild(svg);
						// events
						this.parent.on("select", this.update.bind(this));
						this.on(
							"pointerDown",
							this.parent.childUIPointerDown.bind(this.parent)
						);
					};

					PrevNextButton.prototype.activate = function () {
						this.bindStartEvent(this.element);
						this.element.addEventListener("click", this);
						// add to DOM
						this.parent.element.appendChild(this.element);
					};

					PrevNextButton.prototype.deactivate = function () {
						// remove from DOM
						this.parent.element.removeChild(this.element);
						// click events
						this.unbindStartEvent(this.element);
						this.element.removeEventListener("click", this);
					};

					PrevNextButton.prototype.createSVG = function () {
						var svg = document.createElementNS(svgURI, "svg");
						svg.setAttribute("class", "flickity-button-icon");
						svg.setAttribute("viewBox", "0 0 100 100");
						var path = document.createElementNS(svgURI, "path");
						var pathMovements = getArrowMovements(
							this.parent.options.arrowShape
						);
						path.setAttribute("d", pathMovements);
						path.setAttribute("class", "arrow");
						// rotate arrow
						if (!this.isLeft) {
							path.setAttribute(
								"transform",
								"translate(100, 100) rotate(180) "
							);
						}
						svg.appendChild(path);
						return svg;
					};

					// get SVG path movmement
					function getArrowMovements(shape) {
						// use shape as movement if string
						if (typeof shape == "string") {
							return shape;
						}
						// create movement string
						return (
							"M " +
							shape.x0 +
							",50" +
							" L " +
							shape.x1 +
							"," +
							(shape.y1 + 50) +
							" L " +
							shape.x2 +
							"," +
							(shape.y2 + 50) +
							" L " +
							shape.x3 +
							",50 " +
							" L " +
							shape.x2 +
							"," +
							(50 - shape.y2) +
							" L " +
							shape.x1 +
							"," +
							(50 - shape.y1) +
							" Z"
						);
					}

					PrevNextButton.prototype.handleEvent = utils.handleEvent;

					PrevNextButton.prototype.onclick = function () {
						if (!this.isEnabled) {
							return;
						}
						this.parent.uiChange();
						var method = this.isPrevious ? "previous" : "next";
						this.parent[method]();
					};

					// -----  ----- //

					PrevNextButton.prototype.enable = function () {
						if (this.isEnabled) {
							return;
						}
						this.element.disabled = false;
						this.isEnabled = true;
					};

					PrevNextButton.prototype.disable = function () {
						if (!this.isEnabled) {
							return;
						}
						this.element.disabled = true;
						this.isEnabled = false;
					};

					PrevNextButton.prototype.update = function () {
						// index of first or last slide, if previous or next
						var slides = this.parent.slides;
						// enable is wrapAround and at least 2 slides
						if (this.parent.options.wrapAround && slides.length > 1) {
							this.enable();
							return;
						}
						var lastIndex = slides.length ? slides.length - 1 : 0;
						var boundIndex = this.isPrevious ? 0 : lastIndex;
						var method =
							this.parent.selectedIndex == boundIndex ? "disable" : "enable";
						this[method]();
					};

					PrevNextButton.prototype.destroy = function () {
						this.deactivate();
						this.allOff();
					};

					// -------------------------- Flickity prototype -------------------------- //

					utils.extend(Flickity.defaults, {
						prevNextButtons: true,
						arrowShape: {
							x0: 10,
							x1: 60,
							y1: 50,
							x2: 70,
							y2: 40,
							x3: 30,
						},
					});

					Flickity.createMethods.push("_createPrevNextButtons");
					var proto = Flickity.prototype;

					proto._createPrevNextButtons = function () {
						if (!this.options.prevNextButtons) {
							return;
						}

						this.prevButton = new PrevNextButton(-1, this);
						this.nextButton = new PrevNextButton(1, this);

						this.on("activate", this.activatePrevNextButtons);
					};

					proto.activatePrevNextButtons = function () {
						this.prevButton.activate();
						this.nextButton.activate();
						this.on("deactivate", this.deactivatePrevNextButtons);
					};

					proto.deactivatePrevNextButtons = function () {
						this.prevButton.deactivate();
						this.nextButton.deactivate();
						this.off("deactivate", this.deactivatePrevNextButtons);
					};

					// --------------------------  -------------------------- //

					Flickity.PrevNextButton = PrevNextButton;

					return Flickity;
				});
			});

		var index_es_pageDots = pxs_slideshow_dist_index_es_createCommonjsModule(
			function (module) {
				// page dots
				(function (window, factory) {
					// universal module definition
					/* jshint strict: false */
					if (module.exports) {
						// CommonJS
						module.exports = factory(
							window,
							index_es_flickity,
							index_es_unipointer,
							index_es_utils
						);
					} else {
						// browser global
						factory(
							window,
							window.Flickity,
							window.Unipointer,
							window.fizzyUIUtils
						);
					}
				})(window, function factory(window, Flickity, Unipointer, utils) {
					function PageDots(parent) {
						this.parent = parent;
						this._create();
					}

					PageDots.prototype = Object.create(Unipointer.prototype);

					PageDots.prototype._create = function () {
						// create holder element
						this.holder = document.createElement("ol");
						this.holder.className = "flickity-page-dots";
						// create dots, array of elements
						this.dots = [];
						// events
						this.handleClick = this.onClick.bind(this);
						this.on(
							"pointerDown",
							this.parent.childUIPointerDown.bind(this.parent)
						);
					};

					PageDots.prototype.activate = function () {
						this.setDots();
						this.holder.addEventListener("click", this.handleClick);
						this.bindStartEvent(this.holder);
						// add to DOM
						this.parent.element.appendChild(this.holder);
					};

					PageDots.prototype.deactivate = function () {
						this.holder.removeEventListener("click", this.handleClick);
						this.unbindStartEvent(this.holder);
						// remove from DOM
						this.parent.element.removeChild(this.holder);
					};

					PageDots.prototype.setDots = function () {
						// get difference between number of slides and number of dots
						var delta = this.parent.slides.length - this.dots.length;
						if (delta > 0) {
							this.addDots(delta);
						} else if (delta < 0) {
							this.removeDots(-delta);
						}
					};

					PageDots.prototype.addDots = function (count) {
						var fragment = document.createDocumentFragment();
						var newDots = [];
						var length = this.dots.length;
						var max = length + count;

						for (var i = length; i < max; i++) {
							var dot = document.createElement("li");
							dot.className = "dot";
							dot.setAttribute("aria-label", "Page dot " + (i + 1));
							fragment.appendChild(dot);
							newDots.push(dot);
						}

						this.holder.appendChild(fragment);
						this.dots = this.dots.concat(newDots);
					};

					PageDots.prototype.removeDots = function (count) {
						// remove from this.dots collection
						var removeDots = this.dots.splice(this.dots.length - count, count);
						// remove from DOM
						removeDots.forEach(function (dot) {
							this.holder.removeChild(dot);
						}, this);
					};

					PageDots.prototype.updateSelected = function () {
						// remove selected class on previous
						if (this.selectedDot) {
							this.selectedDot.className = "dot";
							this.selectedDot.removeAttribute("aria-current");
						}
						// don't proceed if no dots
						if (!this.dots.length) {
							return;
						}
						this.selectedDot = this.dots[this.parent.selectedIndex];
						this.selectedDot.className = "dot is-selected";
						this.selectedDot.setAttribute("aria-current", "step");
					};

					PageDots.prototype.onTap = // old method name, backwards-compatible
						PageDots.prototype.onClick = function (event) {
							var target = event.target;
							// only care about dot clicks
							if (target.nodeName != "LI") {
								return;
							}

							this.parent.uiChange();
							var index = this.dots.indexOf(target);
							this.parent.select(index);
						};

					PageDots.prototype.destroy = function () {
						this.deactivate();
						this.allOff();
					};

					Flickity.PageDots = PageDots;

					// -------------------------- Flickity -------------------------- //

					utils.extend(Flickity.defaults, {
						pageDots: true,
					});

					Flickity.createMethods.push("_createPageDots");

					var proto = Flickity.prototype;

					proto._createPageDots = function () {
						if (!this.options.pageDots) {
							return;
						}
						this.pageDots = new PageDots(this);
						// events
						this.on("activate", this.activatePageDots);
						this.on("select", this.updateSelectedPageDots);
						this.on("cellChange", this.updatePageDots);
						this.on("resize", this.updatePageDots);
						this.on("deactivate", this.deactivatePageDots);
					};

					proto.activatePageDots = function () {
						this.pageDots.activate();
					};

					proto.updateSelectedPageDots = function () {
						this.pageDots.updateSelected();
					};

					proto.updatePageDots = function () {
						this.pageDots.setDots();
					};

					proto.deactivatePageDots = function () {
						this.pageDots.deactivate();
					};

					// -----  ----- //

					Flickity.PageDots = PageDots;

					return Flickity;
				});
			}
		);

		var index_es_player = pxs_slideshow_dist_index_es_createCommonjsModule(
			function (module) {
				// player & autoPlay
				(function (window, factory) {
					// universal module definition
					/* jshint strict: false */
					if (module.exports) {
						// CommonJS
						module.exports = factory(
							index_es_evEmitter,
							index_es_utils,
							index_es_flickity
						);
					} else {
						// browser global
						factory(window.EvEmitter, window.fizzyUIUtils, window.Flickity);
					}
				})(window, function factory(EvEmitter, utils, Flickity) {
					// -------------------------- Player -------------------------- //

					function Player(parent) {
						this.parent = parent;
						this.state = "stopped";
						// visibility change event handler
						this.onVisibilityChange = this.visibilityChange.bind(this);
						this.onVisibilityPlay = this.visibilityPlay.bind(this);
					}

					Player.prototype = Object.create(EvEmitter.prototype);

					// start play
					Player.prototype.play = function () {
						if (this.state == "playing") {
							return;
						}
						// do not play if page is hidden, start playing when page is visible
						var isPageHidden = document.hidden;
						if (isPageHidden) {
							document.addEventListener(
								"visibilitychange",
								this.onVisibilityPlay
							);
							return;
						}

						this.state = "playing";
						// listen to visibility change
						document.addEventListener(
							"visibilitychange",
							this.onVisibilityChange
						);
						// start ticking
						this.tick();
					};

					Player.prototype.tick = function () {
						// do not tick if not playing
						if (this.state != "playing") {
							return;
						}

						var time = this.parent.options.autoPlay;
						// default to 3 seconds
						time = typeof time == "number" ? time : 3000;
						var _this = this;
						// HACK: reset ticks if stopped and started within interval
						this.clear();
						this.timeout = setTimeout(function () {
							_this.parent.next(true);
							_this.tick();
						}, time);
					};

					Player.prototype.stop = function () {
						this.state = "stopped";
						this.clear();
						// remove visibility change event
						document.removeEventListener(
							"visibilitychange",
							this.onVisibilityChange
						);
					};

					Player.prototype.clear = function () {
						clearTimeout(this.timeout);
					};

					Player.prototype.pause = function () {
						if (this.state == "playing") {
							this.state = "paused";
							this.clear();
						}
					};

					Player.prototype.unpause = function () {
						// re-start play if paused
						if (this.state == "paused") {
							this.play();
						}
					};

					// pause if page visibility is hidden, unpause if visible
					Player.prototype.visibilityChange = function () {
						var isPageHidden = document.hidden;
						this[isPageHidden ? "pause" : "unpause"]();
					};

					Player.prototype.visibilityPlay = function () {
						this.play();
						document.removeEventListener(
							"visibilitychange",
							this.onVisibilityPlay
						);
					};

					// -------------------------- Flickity -------------------------- //

					utils.extend(Flickity.defaults, {
						pauseAutoPlayOnHover: true,
					});

					Flickity.createMethods.push("_createPlayer");
					var proto = Flickity.prototype;

					proto._createPlayer = function () {
						this.player = new Player(this);

						this.on("activate", this.activatePlayer);
						this.on("uiChange", this.stopPlayer);
						this.on("pointerDown", this.stopPlayer);
						this.on("deactivate", this.deactivatePlayer);
					};

					proto.activatePlayer = function () {
						if (!this.options.autoPlay) {
							return;
						}
						this.player.play();
						this.element.addEventListener("mouseenter", this);
					};

					// Player API, don't hate the ... thanks I know where the door is

					proto.playPlayer = function () {
						this.player.play();
					};

					proto.stopPlayer = function () {
						this.player.stop();
					};

					proto.pausePlayer = function () {
						this.player.pause();
					};

					proto.unpausePlayer = function () {
						this.player.unpause();
					};

					proto.deactivatePlayer = function () {
						this.player.stop();
						this.element.removeEventListener("mouseenter", this);
					};

					// ----- mouseenter/leave ----- //

					// pause auto-play on hover
					proto.onmouseenter = function () {
						if (!this.options.pauseAutoPlayOnHover) {
							return;
						}
						this.player.pause();
						this.element.addEventListener("mouseleave", this);
					};

					// resume auto-play on hover off
					proto.onmouseleave = function () {
						this.player.unpause();
						this.element.removeEventListener("mouseleave", this);
					};

					// -----  ----- //

					Flickity.Player = Player;

					return Flickity;
				});
			}
		);

		var index_es_addRemoveCell =
			pxs_slideshow_dist_index_es_createCommonjsModule(function (module) {
				// add, remove cell
				(function (window, factory) {
					// universal module definition
					/* jshint strict: false */
					if (module.exports) {
						// CommonJS
						module.exports = factory(window, index_es_flickity, index_es_utils);
					} else {
						// browser global
						factory(window, window.Flickity, window.fizzyUIUtils);
					}
				})(window, function factory(window, Flickity, utils) {
					// append cells to a document fragment
					function getCellsFragment(cells) {
						var fragment = document.createDocumentFragment();
						cells.forEach(function (cell) {
							fragment.appendChild(cell.element);
						});
						return fragment;
					}

					// -------------------------- add/remove cell prototype -------------------------- //

					var proto = Flickity.prototype;

					/**
					 * Insert, prepend, or append cells
					 * @param {Element, Array, NodeList} elems
					 * @param {Integer} index
					 */
					proto.insert = function (elems, index) {
						var cells = this._makeCells(elems);
						if (!cells || !cells.length) {
							return;
						}
						var len = this.cells.length;
						// default to append
						index = index === undefined ? len : index;
						// add cells with document fragment
						var fragment = getCellsFragment(cells);
						// append to slider
						var isAppend = index == len;
						if (isAppend) {
							this.slider.appendChild(fragment);
						} else {
							var insertCellElement = this.cells[index].element;
							this.slider.insertBefore(fragment, insertCellElement);
						}
						// add to this.cells
						if (index === 0) {
							// prepend, add to start
							this.cells = cells.concat(this.cells);
						} else if (isAppend) {
							// append, add to end
							this.cells = this.cells.concat(cells);
						} else {
							// insert in this.cells
							var endCells = this.cells.splice(index, len - index);
							this.cells = this.cells.concat(cells).concat(endCells);
						}

						this._sizeCells(cells);
						this.cellChange(index, true);
					};

					proto.append = function (elems) {
						this.insert(elems, this.cells.length);
					};

					proto.prepend = function (elems) {
						this.insert(elems, 0);
					};

					/**
					 * Remove cells
					 * @param {Element, Array, NodeList} elems
					 */
					proto.remove = function (elems) {
						var cells = this.getCells(elems);
						if (!cells || !cells.length) {
							return;
						}

						var minCellIndex = this.cells.length - 1;
						// remove cells from collection & DOM
						cells.forEach(function (cell) {
							cell.remove();
							var index = this.cells.indexOf(cell);
							minCellIndex = Math.min(index, minCellIndex);
							utils.removeFrom(this.cells, cell);
						}, this);

						this.cellChange(minCellIndex, true);
					};

					/**
					 * logic to be run after a cell's size changes
					 * @param {Element} elem - cell's element
					 */
					proto.cellSizeChange = function (elem) {
						var cell = this.getCell(elem);
						if (!cell) {
							return;
						}
						cell.getSize();

						var index = this.cells.indexOf(cell);
						this.cellChange(index);
					};

					/**
					 * logic any time a cell is changed: added, removed, or size changed
					 * @param {Integer} changedCellIndex - index of the changed cell, optional
					 */
					proto.cellChange = function (changedCellIndex, isPositioningSlider) {
						var prevSelectedElem = this.selectedElement;
						this._positionCells(changedCellIndex);
						this._getWrapShiftCells();
						this.setGallerySize();
						// update selectedIndex
						// try to maintain position & select previous selected element
						var cell = this.getCell(prevSelectedElem);
						if (cell) {
							this.selectedIndex = this.getCellSlideIndex(cell);
						}
						this.selectedIndex = Math.min(
							this.slides.length - 1,
							this.selectedIndex
						);

						this.emitEvent("cellChange", [changedCellIndex]);
						// position slider
						this.select(this.selectedIndex);
						// do not position slider after lazy load
						if (isPositioningSlider) {
							this.positionSliderAtSelected();
						}
					};

					// -----  ----- //

					return Flickity;
				});
			});

		var index_es_lazyload = pxs_slideshow_dist_index_es_createCommonjsModule(
			function (module) {
				// lazyload
				(function (window, factory) {
					// universal module definition
					/* jshint strict: false */
					if (module.exports) {
						// CommonJS
						module.exports = factory(window, index_es_flickity, index_es_utils);
					} else {
						// browser global
						factory(window, window.Flickity, window.fizzyUIUtils);
					}
				})(window, function factory(window, Flickity, utils) {
					Flickity.createMethods.push("_createLazyload");
					var proto = Flickity.prototype;

					proto._createLazyload = function () {
						this.on("select", this.lazyLoad);
					};

					proto.lazyLoad = function () {
						var lazyLoad = this.options.lazyLoad;
						if (!lazyLoad) {
							return;
						}
						// get adjacent cells, use lazyLoad option for adjacent count
						var adjCount = typeof lazyLoad == "number" ? lazyLoad : 0;
						var cellElems = this.getAdjacentCellElements(adjCount);
						// get lazy images in those cells
						var lazyImages = [];
						cellElems.forEach(function (cellElem) {
							var lazyCellImages = getCellLazyImages(cellElem);
							lazyImages = lazyImages.concat(lazyCellImages);
						});
						// load lazy images
						lazyImages.forEach(function (img) {
							new LazyLoader(img, this);
						}, this);
					};

					function getCellLazyImages(cellElem) {
						// check if cell element is lazy image
						if (cellElem.nodeName == "IMG") {
							var lazyloadAttr = cellElem.getAttribute(
								"data-flickity-lazyload"
							);
							var srcAttr = cellElem.getAttribute("data-flickity-lazyload-src");
							var srcsetAttr = cellElem.getAttribute(
								"data-flickity-lazyload-srcset"
							);
							if (lazyloadAttr || srcAttr || srcsetAttr) {
								return [cellElem];
							}
						}
						// select lazy images in cell
						var lazySelector =
							"img[data-flickity-lazyload], " +
							"img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]";
						var imgs = cellElem.querySelectorAll(lazySelector);
						return utils.makeArray(imgs);
					}

					// -------------------------- LazyLoader -------------------------- //

					/**
					 * class to handle loading images
					 */
					function LazyLoader(img, flickity) {
						this.img = img;
						this.flickity = flickity;
						this.load();
					}

					LazyLoader.prototype.handleEvent = utils.handleEvent;

					LazyLoader.prototype.load = function () {
						this.img.addEventListener("load", this);
						this.img.addEventListener("error", this);
						// get src & srcset
						var src =
							this.img.getAttribute("data-flickity-lazyload") ||
							this.img.getAttribute("data-flickity-lazyload-src");
						var srcset = this.img.getAttribute("data-flickity-lazyload-srcset");
						// set src & serset
						this.img.src = src;
						if (srcset) {
							this.img.setAttribute("srcset", srcset);
						}
						// remove attr
						this.img.removeAttribute("data-flickity-lazyload");
						this.img.removeAttribute("data-flickity-lazyload-src");
						this.img.removeAttribute("data-flickity-lazyload-srcset");
					};

					LazyLoader.prototype.onload = function (event) {
						this.complete(event, "flickity-lazyloaded");
					};

					LazyLoader.prototype.onerror = function (event) {
						this.complete(event, "flickity-lazyerror");
					};

					LazyLoader.prototype.complete = function (event, className) {
						// unbind events
						this.img.removeEventListener("load", this);
						this.img.removeEventListener("error", this);

						var cell = this.flickity.getParentCell(this.img);
						var cellElem = cell && cell.element;
						this.flickity.cellSizeChange(cellElem);

						this.img.classList.add(className);
						this.flickity.dispatchEvent("lazyLoad", event, cellElem);
					};

					// -----  ----- //

					Flickity.LazyLoader = LazyLoader;

					return Flickity;
				});
			}
		);

		var dist_index_es_js = pxs_slideshow_dist_index_es_createCommonjsModule(
			function (module) {
				/*!
				 * Flickity v2.2.1
				 * Touch, responsive, flickable carousels
				 *
				 * Licensed GPLv3 for open source use
				 * or Flickity Commercial License for commercial use
				 *
				 * https://flickity.metafizzy.co
				 * Copyright 2015-2019 Metafizzy
				 */

				(function (window, factory) {
					// universal module definition
					/* jshint strict: false */
					if (module.exports) {
						// CommonJS
						module.exports = factory(
							index_es_flickity,
							index_es_drag,
							index_es_prevNextButton,
							index_es_pageDots,
							index_es_player,
							index_es_addRemoveCell,
							index_es_lazyload
						);
					}
				})(window, function factory(Flickity) {
					/*jshint strict: false*/
					return Flickity;
				});
			}
		);

		var flickityFade = pxs_slideshow_dist_index_es_createCommonjsModule(
			function (module) {
				/**
				 * Flickity fade v1.0.0
				 * Fade between Flickity slides
				 */

				/* jshint browser: true, undef: true, unused: true */

				(function (window, factory) {
					// universal module definition
					/*globals define, module, require */
					if (module.exports) {
						// CommonJS
						module.exports = factory(dist_index_es_js, index_es_utils);
					} else {
						// browser global
						factory(window.Flickity, window.fizzyUIUtils);
					}
				})(index_es_commonjsGlobal, function factory(Flickity, utils) {
					// ---- Slide ---- //

					var Slide = Flickity.Slide;

					var slideUpdateTarget = Slide.prototype.updateTarget;
					Slide.prototype.updateTarget = function () {
						slideUpdateTarget.apply(this, arguments);
						if (!this.parent.options.fade) {
							return;
						}
						// position cells at selected target
						var slideTargetX = this.target - this.x;
						var firstCellX = this.cells[0].x;
						this.cells.forEach(function (cell) {
							var targetX = cell.x - firstCellX - slideTargetX;
							cell.renderPosition(targetX);
						});
					};

					Slide.prototype.setOpacity = function (alpha) {
						this.cells.forEach(function (cell) {
							cell.element.style.opacity = alpha;
						});
					};

					// ---- Flickity ---- //

					var proto = Flickity.prototype;

					Flickity.createMethods.push("_createFade");

					proto._createFade = function () {
						this.fadeIndex = this.selectedIndex;
						this.prevSelectedIndex = this.selectedIndex;
						this.on("select", this.onSelectFade);
						this.on("dragEnd", this.onDragEndFade);
						this.on("settle", this.onSettleFade);
						this.on("activate", this.onActivateFade);
						this.on("deactivate", this.onDeactivateFade);
					};

					var updateSlides = proto.updateSlides;
					proto.updateSlides = function () {
						updateSlides.apply(this, arguments);
						if (!this.options.fade) {
							return;
						}
						// set initial opacity
						this.slides.forEach(function (slide, i) {
							var alpha = i == this.selectedIndex ? 1 : 0;
							slide.setOpacity(alpha);
						}, this);
					};

					/* ---- events ---- */

					proto.onSelectFade = function () {
						// in case of resize, keep fadeIndex within current count
						this.fadeIndex = Math.min(
							this.prevSelectedIndex,
							this.slides.length - 1
						);
						this.prevSelectedIndex = this.selectedIndex;
					};

					proto.onSettleFade = function () {
						delete this.didDragEnd;
						if (!this.options.fade) {
							return;
						}
						// set full and 0 opacity on selected & faded slides
						this.selectedSlide.setOpacity(1);
						var fadedSlide = this.slides[this.fadeIndex];
						if (fadedSlide && this.fadeIndex != this.selectedIndex) {
							this.slides[this.fadeIndex].setOpacity(0);
						}
					};

					proto.onDragEndFade = function () {
						// set flag
						this.didDragEnd = true;
					};

					proto.onActivateFade = function () {
						if (this.options.fade) {
							this.element.classList.add("is-fade");
						}
					};

					proto.onDeactivateFade = function () {
						if (!this.options.fade) {
							return;
						}
						this.element.classList.remove("is-fade");
						// reset opacity
						this.slides.forEach(function (slide) {
							slide.setOpacity("");
						});
					};

					/* ---- position & fading ---- */

					var positionSlider = proto.positionSlider;
					proto.positionSlider = function () {
						if (!this.options.fade) {
							positionSlider.apply(this, arguments);
							return;
						}

						this.fadeSlides();
						this.dispatchScrollEvent();
					};

					var positionSliderAtSelected = proto.positionSliderAtSelected;
					proto.positionSliderAtSelected = function () {
						if (this.options.fade) {
							// position fade slider at origin
							this.setTranslateX(0);
						}
						positionSliderAtSelected.apply(this, arguments);
					};

					proto.fadeSlides = function () {
						if (this.slides.length < 2) {
							return;
						}
						// get slides to fade-in & fade-out
						var indexes = this.getFadeIndexes();
						var fadeSlideA = this.slides[indexes.a];
						var fadeSlideB = this.slides[indexes.b];
						var distance = this.wrapDifference(
							fadeSlideA.target,
							fadeSlideB.target
						);
						var progress = this.wrapDifference(fadeSlideA.target, -this.x);
						progress = progress / distance;

						fadeSlideA.setOpacity(1 - progress);
						fadeSlideB.setOpacity(progress);

						// hide previous slide
						var fadeHideIndex = indexes.a;
						if (this.isDragging) {
							fadeHideIndex = progress > 0.5 ? indexes.a : indexes.b;
						}
						var isNewHideIndex =
							this.fadeHideIndex != undefined &&
							this.fadeHideIndex != fadeHideIndex &&
							this.fadeHideIndex != indexes.a &&
							this.fadeHideIndex != indexes.b;
						if (isNewHideIndex) {
							// new fadeHideSlide set, hide previous
							this.slides[this.fadeHideIndex].setOpacity(0);
						}
						this.fadeHideIndex = fadeHideIndex;
					};

					proto.getFadeIndexes = function () {
						if (!this.isDragging && !this.didDragEnd) {
							return {
								a: this.fadeIndex,
								b: this.selectedIndex,
							};
						}
						if (this.options.wrapAround) {
							return this.getFadeDragWrapIndexes();
						} else {
							return this.getFadeDragLimitIndexes();
						}
					};

					proto.getFadeDragWrapIndexes = function () {
						var distances = this.slides.map(function (slide, i) {
							return this.getSlideDistance(-this.x, i);
						}, this);
						var absDistances = distances.map(function (distance) {
							return Math.abs(distance);
						});
						var minDistance = Math.min.apply(Math, absDistances);
						var closestIndex = absDistances.indexOf(minDistance);
						var distance = distances[closestIndex];
						var len = this.slides.length;

						var delta = distance >= 0 ? 1 : -1;
						return {
							a: closestIndex,
							b: utils.modulo(closestIndex + delta, len),
						};
					};

					proto.getFadeDragLimitIndexes = function () {
						// calculate closest previous slide
						var dragIndex = 0;
						for (var i = 0; i < this.slides.length - 1; i++) {
							var slide = this.slides[i];
							if (-this.x < slide.target) {
								break;
							}
							dragIndex = i;
						}
						return {
							a: dragIndex,
							b: dragIndex + 1,
						};
					};

					proto.wrapDifference = function (a, b) {
						var diff = b - a;

						if (!this.options.wrapAround) {
							return diff;
						}

						var diffPlus = diff + this.slideableWidth;
						var diffMinus = diff - this.slideableWidth;
						if (Math.abs(diffPlus) < Math.abs(diff)) {
							diff = diffPlus;
						}
						if (Math.abs(diffMinus) < Math.abs(diff)) {
							diff = diffMinus;
						}
						return diff;
					};

					// ---- wrapAround ---- //

					var _getWrapShiftCells = proto._getWrapShiftCells;
					proto._getWrapShiftCells = function () {
						if (!this.options.fade) {
							_getWrapShiftCells.apply(this, arguments);
						}
					};

					var shiftWrapCells = proto.shiftWrapCells;
					proto.shiftWrapCells = function () {
						if (!this.options.fade) {
							shiftWrapCells.apply(this, arguments);
						}
					};

					return Flickity;
				});
			}
		);

		var pxs_slideshow_dist_index_es_EventHandler_1 =
			pxs_slideshow_dist_index_es_createCommonjsModule(function (
				module,
				exports
			) {
				exports.__esModule = true;
				var EventHandler = /** @class */ (function () {
					function EventHandler() {
						this.events = [];
					}
					EventHandler.prototype.register = function (el, event, listener) {
						if (!el || !event || !listener) return null;
						this.events.push({ el: el, event: event, listener: listener });
						el.addEventListener(event, listener);
						return { el: el, event: event, listener: listener };
					};
					EventHandler.prototype.unregister = function (_a) {
						var el = _a.el,
							event = _a.event,
							listener = _a.listener;
						if (!el || !event || !listener) return null;
						this.events = this.events.filter(function (e) {
							return (
								el !== e.el || event !== e.event || listener !== e.listener
							);
						});
						el.removeEventListener(event, listener);
						return { el: el, event: event, listener: listener };
					};
					EventHandler.prototype.unregisterAll = function () {
						this.events.forEach(function (_a) {
							var el = _a.el,
								event = _a.event,
								listener = _a.listener;
							return el.removeEventListener(event, listener);
						});
						this.events = [];
					};
					return EventHandler;
				})();
				exports["default"] = EventHandler;
			});

		var pxs_slideshow_dist_index_es_EventHandler = dist_index_es_unwrapExports(
			pxs_slideshow_dist_index_es_EventHandler_1
		);

		var Slideshow = /*#__PURE__*/ (function () {
			function Slideshow(section) {
				var _this = this;

				pxs_slideshow_dist_index_es_classCallCheck(this, Slideshow);

				this.el = section.el;
				this.settings = section.data;
				this.paginationClicked = false;
				this.events = new pxs_slideshow_dist_index_es_EventHandler();
				this.slideshowContainer = this.el.querySelector("[data-slideshow]");
				this.carousel = this.el.querySelector("[data-slideshow-wrapper]");
				this.slides = this.el.querySelectorAll("[data-slideshow-slide]");
				this.pagination = this.el.querySelector("[data-slideshow-pagination]");
				this.paginationButtons = this.pagination
					? this.pagination.querySelectorAll("[data-slide-button]")
					: null;
				this.counter = this.el.querySelector("[data-slide-counter]");
				this.el.style.setProperty(
					"--slide-text-color",
					"".concat(this.slides[0].dataset.textColor)
				);

				if (this.carousel && this.slides.length > 1) {
					this.flickity = new flickityFade(this.carousel, {
						accessibility: false,
						// Flickity's inherent "accessibility" actually makes it worse
						adaptiveHeight: true,
						autoPlay: this.settings.enable_autoplay
							? this.settings.autoplay_interval * 1000
							: false,
						cellAlign: "left",
						cellSelector: "[data-slideshow-slide]",
						contain: true,
						fade: this.settings.transition_fade,
						imagesLoaded: true,
						pageDots: this.settings.show_pagination,
						pauseAutoPlayOnHover: true,
						selectedAttraction: this.settings.slide_attraction
							? parseFloat(this.settings.slide_attraction)
							: 0.03,
						friction: this.settings.slide_friction
							? parseFloat(this.settings.slide_friction)
							: 0.3,
						wrapAround: true,
						arrowShape: {
							x0: 10,
							x1: 60,
							y1: 50,
							x2: 65,
							y2: 45,
							x3: 20,
						},
					});
					this.prevNextButtons = this.el.querySelectorAll(
						".flickity-prev-next-button"
					);

					if (this.prevNextButtons.length === 2) {
						this.prevNextButtons[0].setAttribute(
							"aria-label",
							this.settings.previous_text
						);
						this.prevNextButtons[1].setAttribute(
							"aria-label",
							this.settings.next_text
						);
					}

					this._updateTabindex();

					this._positionNavigation();

					this._updateCounter(1);

					this.flickity.on("change", function (index) {
						_this.el.style.setProperty(
							"--slide-text-color",
							"".concat(_this.slides[index].dataset.textColor)
						);

						_this._updatePagination();

						_this._positionNavigation();

						_this._updateTabindex();

						_this._updateCounter(index + 1);
					}); // On any interaction on the slideshow, we want it to pause

					this.flickity.on("pointerDown", function () {
						_this.slideshowContainer.setAttribute("data-flickity-paused", true);

						_this.flickity.pausePlayer();
					});
					this.events.register(this.carousel, "rimg:load", function () {
						_this.flickity.resize();

						_this._positionNavigation();
					}); // As soon as the slideshow receives keyboard or mouse focus, we want it to pause

					this.events.register(this.carousel, "focusin", function () {
						_this.slideshowContainer.setAttribute("data-flickity-paused", true);

						_this.flickity.pausePlayer();
					});
					this.events.register(window, "resize", function () {
						_this._positionNavigation();
					}); // We want to focus on the new slide if the pagination buttons were clicked
					// If we don't wait until "settle" then the slideshow experiences a weird jump issue

					this.flickity.on("settle", function (index) {
						if (_this.paginationClicked) {
							_this.slides[index].focus();

							_this.paginationClicked = false;
						}
					}); // We had to add in our own pagination buttons since the flickity ones
					// are not elements that can be tabbed to. This replicates their behaviour.

					if (this.pagination) {
						var _loop = function _loop(i) {
							_this.events.register(
								_this.paginationButtons[i],
								"click",
								function () {
									var index = parseInt(
										_this.paginationButtons[i].dataset.slideButton,
										10
									);

									_this.flickity.pausePlayer();

									_this.slideshowContainer.setAttribute(
										"data-flickity-paused",
										true
									);

									_this.flickity.select(index, true, false);

									_this.paginationClicked = true;
								}
							);
						};

						for (var i = 0; i < this.paginationButtons.length; i++) {
							_loop(i);
						}
					}
				}
			}

			pxs_slideshow_dist_index_es_createClass(Slideshow, [
				{
					key: "_updatePagination",
					value: function _updatePagination() {
						if (this.pagination) {
							for (var i = 0; i < this.paginationButtons.length; i++) {
								this.paginationButtons[i].dataset.selected = "false";
								this.paginationButtons[i].setAttribute(
									"aria-selected",
									"false"
								);
							}

							this.paginationButtons[
								this.flickity.selectedIndex
							].dataset.selected = "true";
							this.paginationButtons[this.flickity.selectedIndex].setAttribute(
								"aria-selected",
								"true"
							);
						}
					},
				},
				{
					key: "_positionNavigation",
					value: function _positionNavigation() {
						if (this.settings.mobile_navigation_adjust) {
							var arrowButtons = this.el.querySelectorAll(
								".flickity-prev-next-button"
							);
							var currentSlideheight =
								this.flickity.selectedElement.querySelector(
									"[data-slide-image-wrapper]"
								).offsetHeight;

							if (arrowButtons) {
								var top = "50%";

								if (this.viewportIsMobile()) {
									top = "".concat(currentSlideheight / 2, "px");
								}

								arrowButtons[0].style.top = top;
								arrowButtons[1].style.top = top;
							}

							if (this.pagination) {
								var _top = "auto";

								if (this.viewportIsMobile()) {
									var content = this.flickity.selectedElement.querySelector(
										"[data-slide-content]"
									);

									if (content) {
										_top = "".concat(currentSlideheight, "px");
									} else {
										var paginationHeight = this.pagination.offsetHeight; // If no content, and mobile, offset by height of dots, and the bottom gutter

										_top = "".concat(
											currentSlideheight - paginationHeight,
											"px"
										);
									}
								}

								this.pagination.style.top = _top;
							}
						}
					},
				},
				{
					key: "_updateTabindex",
					value: function _updateTabindex() {
						// We need to remove tabindex from the slides that are not currently
						// selected, so that slides not currently shown cannot receive keyboard focus.
						for (var i = 0; i < this.slides.length; i++) {
							var links = this.slides[i].querySelectorAll("a");

							for (var j = 0; j < links.length; j++) {
								links[j].setAttribute(
									"tabindex",
									i === this.flickity.selectedIndex ? "0" : "-1"
								);
							}
						}
					}, // This updates the counter which is used for accessibility. This gets read out to a user
					// who uses a screen reader every time the slide changes.
				},
				{
					key: "_updateCounter",
					value: function _updateCounter(index) {
						var counterText = this.counter.dataset.counterTemplate
							.replace("", index)
							.replace("", this.slides.length);
						this.counter.innerHTML = counterText;
					}, // This method can be overridden by the theme if the breakpoint is different than 720.
				},
				{
					key: "viewportIsMobile",
					value: function viewportIsMobile() {
						return window.innerWidth < 720;
					},
				},
				{
					key: "onSectionUnload",
					value: function onSectionUnload() {
						this.events.unregisterAll();
						this.flickity.destroy();
					},
				},
				{
					key: "onSectionBlockSelect",
					value: function onSectionBlockSelect(e) {
						var slideIndex = e.el.dataset.slideIndex;
						this.flickity.select(slideIndex);
						this.flickity.pausePlayer();
						this.flickity.resize();
					},
				},
				{
					key: "onSectionBlockDeselect",
					value: function onSectionBlockDeselect() {
						if (this.settings.enable_autoplay) {
							this.flickity.playPlayer();
						}
					},
				},
			]);

			return Slideshow;
		})();

		/* harmony default export */ const pxs_slideshow_dist_index_es = Slideshow; // CONCATENATED MODULE: ./source/scripts/helpers/LoadInAnimations.js

		const LoadInAnimations_classes = {
			block: "pxu-lia-block",
			element: "pxu-lia-element",
			playBlock: "pxu-lia-block--play",
			resetBlock: "pxu-lia-block--reset",
			playSection: "pxu-lia-section--play",
			resetSection: "pxu-lia-section--reset",
		};
		const mappingSelector = '[type="application/pxs-animation-mapping+json"]';
		/**
		 * Find common parent of this block and the closest animation mapping block.
		 *
		 * @param {HTMLElement} node Block from which to begin search.
		 */

		const getMappingParentFromBlock = (_ref) => {
			let { parentNode } = _ref;
			return parentNode.querySelector(mappingSelector)
				? parentNode
				: getMappingParentFromBlock(parentNode);
		};

		const LoadInAnimations_reset = (block, elements) => {
			block.style.animationName = "none";
			block.classList.add(LoadInAnimations_classes.resetBlock);
			elements.forEach((element) => {
				element.style.animationName = "none";
			});
		};

		const removeReset = (block, elements) => {
			block.style.animationName = "";
			block.classList.remove(LoadInAnimations_classes.resetBlock);
			elements.forEach((element) => {
				element.style.animationName = "";
			});
		};

		const play = (block, elements) => {
			block.style.animationPlayState = "running";
			block.classList.add(LoadInAnimations_classes.playBlock);
			elements.forEach((element) => {
				element.style.animationPlayState = "running";
			});
		};

		const pause = (block, elements) => {
			block.style.animationPlayState = "";
			block.classList.remove(LoadInAnimations_classes.playBlock);
			elements.forEach((element) => {
				element.style.animationPlayState = "";
			});
		};
		/**
		 * Play, or reset animations for a collection of blocks.
		 *
		 * @param {[HTMLElement]} blocks Blocks to process
		 * @param {String} state One of 'play' or 'reset'.
		 */

		const loadInAnimations = function (blocks) {
			let state =
				arguments.length > 1 && arguments[1] !== undefined
					? arguments[1]
					: "play";
			const callNextFrame = [];

			if (state === "reset") {
				blocks.forEach((block) => {
					const elements = block.querySelectorAll(
						`.${LoadInAnimations_classes.element}`
					);
					pause(block, elements);
					LoadInAnimations_reset(block, elements);
					callNextFrame.push(() => {
						removeReset(block, elements);
					});
				});
				const section = getMappingParentFromBlock(blocks[0]);
				section.classList.remove(LoadInAnimations_classes.playSection);
				section.classList.add(LoadInAnimations_classes.resetSection);
				callNextFrame.push(() => {
					section.classList.remove(LoadInAnimations_classes.resetSection);
				});
			} else {
				blocks.forEach((block, blockIndex) => {
					// Set sequence for blocks
					block.style.setProperty("--pxu-lia-outer-sequence", blockIndex); // Set sequence for sub elements (heading, text, button, etc)

					const elements = block.querySelectorAll(
						`.${LoadInAnimations_classes.element}`
					);
					elements.forEach((element, elementIndex) => {
						element.style.setProperty("--pxu-lia-inner-sequence", elementIndex);
					});

					if (block.classList.contains(LoadInAnimations_classes.playBlock)) {
						LoadInAnimations_reset(block, elements);
						callNextFrame.push(() => {
							removeReset(block, elements);
							play(block, elements);
						});
					} else {
						play(block, elements);
					}

					const section = getMappingParentFromBlock(blocks[0]);

					if (
						section.classList.contains(LoadInAnimations_classes.playSection)
					) {
						section.classList.add(LoadInAnimations_classes.resetSection);
						callNextFrame.push(() => {
							section.classList.remove(LoadInAnimations_classes.resetSection);
							section.classList.add(LoadInAnimations_classes.playSection);
						});
					} else {
						section.classList.add(LoadInAnimations_classes.playSection);
					}
				});
			}

			window.requestAnimationFrame(() => callNextFrame.forEach((fn) => fn()));
		};
		/**
		 * Manually trigger load-in animations. Existing animations will be reset and replayed.
		 *
		 * @param {[HTMLElement]} blocks Blocks for which to play animations
		 */

		const playLoadInAnimations = (blocks) => loadInAnimations(blocks, "play");
		/**
		 * Manually reset load-in animations to initial state.
		 *
		 * @param {[HTMLElement]} blocks Blocks for which to reset animations
		 */

		const resetLoadInAnimations = (blocks) => loadInAnimations(blocks, "reset");

		const intersectionCallback = (entries, observer) => {
			const toAnimate = new Map();
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					// Animations only run once so stop observing
					observer.unobserve(entry.target); // Find all blocks on same level that are now intersecting and arrange by parent section

					const parentSequence = getMappingParentFromBlock(entry.target);
					const existingSiblings = toAnimate.get(parentSequence);
					toAnimate.set(
						parentSequence,
						existingSiblings
							? [...existingSiblings, entry.target]
							: [entry.target]
					);
				}
			});
			toAnimate.forEach((blocks, parent) =>
				playLoadInAnimations(blocks, parent)
			);
		};

		let blockObserver = null;
		/**
		 * Removes blocks from the global intersection observer for load in animations.
		 *
		 * @param {[HTMLElement]} blocks Blocks to stop observing for automatic load-in-animation play
		 */

		const removeLoadInAnimationsAutoplay = (blocks) =>
			blocks.forEach(
				(block) => blockObserver && blockObserver.unobserve(block)
			);

		const initLoadInAnimationsAutoplay = () => {
			// This assumes that animated elements are arranged by section,
			// block, and element. Animations are triggered when blocks
			// enter view, and are sequenced within sections by block and by subElement.
			// Sequencing information is applied as custom properties that can be referenced in css.
			blockObserver = new IntersectionObserver(intersectionCallback, {
				threshold: 0.3,
			});

			if (!("reduceAnimations" in document.body.dataset)) {
				const observe = (parent) => {
					parent
						.querySelectorAll(`.${LoadInAnimations_classes.block}`)
						.forEach((block) => blockObserver.observe(block));
				};

				observe(document);
			}
		}; // CONCATENATED MODULE: ./source/scripts/sections/DynamicSlideshow.js

		class DynamicSlideshow extends pxs_slideshow_dist_index_es {
			constructor(section) {
				super(section);
				this.carouselContainer = this.carousel.parentNode;
				this.slideWrappers = this.carousel.querySelectorAll(
					"[data-slide-image-wrapper]"
				);
				this.header = document.querySelector(".site-header");
				this.announcementBar = document.querySelector(".announcement-bar"); // Fit screen

				if (
					this.carouselContainer.classList.contains(
						"slideshow--height-fit_screen"
					) ||
					this.carouselContainer.classList.contains(
						"slideshow--height-fit_screen-mobile"
					)
				) {
					this._setupCCSVariables();

					this.events.register(window, "resize", () =>
						this._setupCCSVariables()
					);

					this._positionNavigation();
				} // We are manually playing load in animations when
				// changing slides, so prevent automatic play.

				removeLoadInAnimationsAutoplay(this.slides);
				playLoadInAnimations([this.slides[0]]);

				if (this.flickity) {
					this.flickity.on("change", (index) => {
						// This is a delay to fake waiting until the slide has fully changed.
						// Waiting until 'settle' is a bit too long.
						setTimeout(() => {
							resetLoadInAnimations(
								Array.prototype.filter.call(this.slides, (el, i) => i !== index)
							);
						}, 100);
						setTimeout(() => {
							playLoadInAnimations([this.slides[index]]);
						}, 150);

						this._setContentHeight();

						this._positionNavigation();
					});
				}
			}

			_setContentHeight() {
				const currentSlide = this.slides[this.flickity.selectedIndex];
				const slideContent = currentSlide.querySelector(
					".slideshow-slide__content"
				); // Determine absolute height

				const getAbsoluteHeight = (el) => {
					el = typeof el === "string" ? document.querySelector(el) : el;
					const styles = window.getComputedStyle(el);
					const margin =
						parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
					return Math.ceil(el.offsetHeight + margin);
				};

				const currentSlideContentHeight = getAbsoluteHeight(slideContent);
				this.el.style.setProperty(
					"--content-height",
					`${currentSlideContentHeight}px`
				);
			}

			_setupCCSVariables() {
				const currentHeaderHeight = this.header.offsetHeight;
				let currentAnnouncementHeight = 0; // Check for the announcement bar

				if (this.announcementBar) {
					currentAnnouncementHeight =
						document.querySelector(".announcement-bar").offsetHeight;
				}

				this.el.style.setProperty(
					"--header-height",
					`${currentHeaderHeight - currentAnnouncementHeight}px`
				);

				this._setContentHeight();

				this.flickity.resize();
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/DynamicVideo.js
		class DynamicVideo {
			constructor(section) {
				this.el = section.el;
				this.autoplay = section.data.autoplay;
				this.init();
			}

			init() {
				const videoEl = this.el.querySelector("[data-video]");
				this.hasPlayed = false;

				if (videoEl) {
					this.video = new Video(videoEl);
				}

				if (this.video && this.autoplay) {
					const thresholds = {
						play: 0.5,
						pause: 0.2,
					};
					this.playPauseObserver = new IntersectionObserver(
						(entries) => {
							const { intersectionRatio, isIntersecting } = entries[0];

							if (
								intersectionRatio >= thresholds.play &&
								isIntersecting &&
								!this.hasPlayed
							) {
								// videoEl has just scrolled into view and is at least 50% visible: play video
								this.video._autoplay();

								this.hasPlayed = true;
							} else if (
								intersectionRatio <= thresholds.pause &&
								isIntersecting === false
							) {
								// videoEl has scrolled out of view and is less than 20% visible: pause video
								this.video._onPauseClick();
							}
						},
						{
							threshold: [thresholds.pause, thresholds.play],
						}
					);
					this.playPauseObserver.observe(videoEl);
				}
			}

			onSectionUnload() {
				if (this.video) {
					this.video.unload();
				}

				if (this.playPauseObserver) {
					this.playPauseObserver.disconnect();
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/DynamicNewsletter.js
		class DynamicNewsletter {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				this.forms = new Forms(this.$el);
			}

			onSectionUnload() {
				this.forms.unload();
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/DynamicHighlightsBanner.js
		class DynamicHighlightsBanner {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				this.$window = jquery_default()(window);
				this.$carousel = this.$el.find("[data-highlights-slider]");
				this.slides = "[data-highlights-block]";
				this.flickity = null;
				this.flickityOptions = null;

				if (
					this.$carousel.length > 0 &&
					this.$carousel.find(this.slides).length > 1
				) {
					this._initSlider();
				}

				cjs.onChange((breakpoints) => this.onBreakpointChange(breakpoints));
			}

			_initSlider() {
				this.flickityOptions = {
					autoPlay: 0,
					accessibility: true,
					cellAlign: "left",
					cellSelector: this.slides,
					pageDots: false,
					prevNextButtons: false,
					contain: true,
				};

				this._bindFlickity();
			}

			onSectionUnload() {
				this._destroyFlickity();

				this.$window.off(".twitter");
			}

			_bindFlickity() {
				if (cjs.max("M") && this.flickity === null && this.$carousel[0]) {
					this.flickity = new (js_default())(
						this.$carousel[0],
						this.flickityOptions
					);
				}
			}

			_destroyFlickity() {
				if (!this.flickity) {
					return;
				}

				this.flickity.destroy();
				this.flickity = null;
			}

			onBreakpointChange(breakpoints) {
				if (breakpoints.current.min("M") && this.flickity) {
					this._destroyFlickity();
				} else if (breakpoints.previous.min("M")) {
					this._bindFlickity();
				}
			}
		} // CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-shoppable-image/dist/index.es.js
		/*!
		 * @pixelunion/pxs-shoppable-image v1.0.0
		 * (c) 2023 Pixel Union
		 */

		function pxs_shoppable_image_dist_index_es_classCallCheck(
			instance,
			Constructor
		) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function pxs_shoppable_image_dist_index_es_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function pxs_shoppable_image_dist_index_es_createClass(
			Constructor,
			protoProps,
			staticProps
		) {
			if (protoProps)
				pxs_shoppable_image_dist_index_es_defineProperties(
					Constructor.prototype,
					protoProps
				);
			if (staticProps)
				pxs_shoppable_image_dist_index_es_defineProperties(
					Constructor,
					staticProps
				);
			return Constructor;
		}

		function pxs_shoppable_image_dist_index_es_unwrapExports(x) {
			return x &&
				x.__esModule &&
				Object.prototype.hasOwnProperty.call(x, "default")
				? x["default"]
				: x;
		}

		function pxs_shoppable_image_dist_index_es_createCommonjsModule(
			fn,
			module
		) {
			return (
				(module = { exports: {} }), fn(module, module.exports), module.exports
			);
		}

		var pxs_shoppable_image_dist_index_es_EventHandler_1 =
			pxs_shoppable_image_dist_index_es_createCommonjsModule(function (
				module,
				exports
			) {
				exports.__esModule = true;
				var EventHandler = /** @class */ (function () {
					function EventHandler() {
						this.events = [];
					}
					EventHandler.prototype.register = function (el, event, listener) {
						if (!el || !event || !listener) return null;
						this.events.push({ el: el, event: event, listener: listener });
						el.addEventListener(event, listener);
						return { el: el, event: event, listener: listener };
					};
					EventHandler.prototype.unregister = function (_a) {
						var el = _a.el,
							event = _a.event,
							listener = _a.listener;
						if (!el || !event || !listener) return null;
						this.events = this.events.filter(function (e) {
							return (
								el !== e.el || event !== e.event || listener !== e.listener
							);
						});
						el.removeEventListener(event, listener);
						return { el: el, event: event, listener: listener };
					};
					EventHandler.prototype.unregisterAll = function () {
						this.events.forEach(function (_a) {
							var el = _a.el,
								event = _a.event,
								listener = _a.listener;
							return el.removeEventListener(event, listener);
						});
						this.events = [];
					};
					return EventHandler;
				})();
				exports["default"] = EventHandler;
			});

		var pxs_shoppable_image_dist_index_es_EventHandler =
			pxs_shoppable_image_dist_index_es_unwrapExports(
				pxs_shoppable_image_dist_index_es_EventHandler_1
			);

		var ShoppableImage = /*#__PURE__*/ (function () {
			function ShoppableImage(section) {
				pxs_shoppable_image_dist_index_es_classCallCheck(this, ShoppableImage);

				this.el = section.el;
				this.bounds = this.el.getBoundingClientRect();
				this.imageWrapper = this.el.querySelector(
					"[data-shoppable-image-wrapper]"
				);
				this.image = this.el.querySelector("[data-shoppable-image-img]");
				this.points = this.el.querySelectorAll("[data-hotspot]");
				this.tooltips = this.el.querySelectorAll("[data-tooltip-wrapper]");
				this.activeClass = "shoppable-image__hotspot--active";
				this.events = new pxs_shoppable_image_dist_index_es_EventHandler();
				this.window = window;
				this.hoverTimer = null;
				this.tooltipDelay = 300;
				this.windowScrollTimer = null;
				this.windowScrollEvent = null;

				this._bindEvents();
			}

			pxs_shoppable_image_dist_index_es_createClass(ShoppableImage, [
				{
					key: "_bindEvents",
					value: function _bindEvents() {
						var _this = this;

						this._positionElements();

						if (this.image) {
							this.events.register(this.image, "rimg:load", function (e) {
								return _this._positionElements();
							});
						}

						this.events.register(this.el, "touchend", function () {
							return _this._clearAllActive();
						});

						for (var i = 0; i < this.points.length; i++) {
							var point = this.points[i];
							var tooltip = this.tooltips[i];
							this.events.register(point, "click", function (e) {
								return _this._setActivePoint(e);
							});
							this.events.register(point, "touchend", function (e) {
								return _this._setActivePoint(e);
							});
							this.events.register(point, "mouseover", function (e) {
								return _this._setActivePoint(e);
							});
							this.events.register(point, "mouseout", function (e) {
								return _this._closeActivePoint(e);
							});
							this.events.register(point, "focus", function (e) {
								return _this._setActivePoint(e);
							});
							this.events.register(tooltip, "touchend", function (e) {
								return e.stopPropagation();
							});
							this.events.register(tooltip, "mouseover", function (e) {
								return _this._setActivePoint(e);
							});
							this.events.register(tooltip, "mouseout", function (e) {
								return _this._closeActivePoint(e);
							});
							this.events.register(tooltip, "focus", function (e) {
								return e.stopPropagation();
							});
						}
					},
				},
				{
					key: "_positionElements",
					value: function _positionElements() {
						this.positionHotspots();
						this.positionTooltips();
					},
				},
				{
					key: "_setActivePoint",
					value: function _setActivePoint(e) {
						e.stopPropagation();
						var target = e.currentTarget;
						var point = null; // We can reset the timer if we've re-entered the tooltip or the hotspot node

						if (this.hoverTimer !== null) {
							clearTimeout(this.hoverTimer);
							this.hoverTimer = null;
						}

						point = target.closest("[data-hotspot]");

						if (
							e.type === "touchend" &&
							point.classList.contains(this.activeClass)
						) {
							point.classList.remove(this.activeClass);
							return;
						}

						if (
							e.type === "click" &&
							point.classList.contains(this.activeClass)
						) {
							return;
						}

						if (!point.classList.contains(this.activeClass)) {
							var activeTooltip = this.el.querySelector(
								".".concat(this.activeClass)
							);

							if (activeTooltip) {
								activeTooltip.classList.remove(this.activeClass);
							} // Reposition the tooltip in case the user has scrolled or otherwise changed
							// conditions

							this.positionTooltips();
							point.classList.add(this.activeClass);
						}
					},
				},
				{
					key: "_closeActivePoint",
					value: function _closeActivePoint(e) {
						var _this2 = this;

						var target = e.currentTarget;
						var point = null;
						point = target.closest("[data-hotspot]"); // We can clear the timer because we'll be setting a new one

						if (this.hoverTimer !== null) {
							clearTimeout(this.hoverTimer);
						} // Set a timer so we don't instantly close the tooltip on each mouse event
						// We can clear this timer if the mouse re-enters the hotspot node or the tooltip node
						// so that it doesn't close right away

						this.hoverTimer = setTimeout(function () {
							point.classList.remove(_this2.activeClass);
						}, this.tooltipDelay);
					},
				},
				{
					key: "_clearAllActive",
					value: function _clearAllActive() {
						var activeTooltip = this.el.querySelector(
							".".concat(this.activeClass)
						);

						if (activeTooltip) {
							activeTooltip.classList.remove(this.activeClass);
						}
					},
				},
				{
					key: "_resetTooltips",
					value: function _resetTooltips() {
						this.tooltips.forEach(function (tooltip) {
							tooltip.classList.remove("tooltip--overflow-top");
							tooltip.classList.remove("tooltip--overflow-right");
							tooltip.classList.remove("tooltip--overflow-bottom");
							tooltip.classList.remove("tooltip--overflow-left");
							tooltip.style.top = null;
							tooltip.style.right = null;
							tooltip.style.bottom = null;
							tooltip.style.left = null;
						});
					},
				},
				{
					key: "positionHotspots",
					value: function positionHotspots() {
						var _this3 = this;

						//  Reposition points which overflow the bounds of the image
						this.points.forEach(function (point) {
							var ySetting = parseInt(point.dataset.hotspotYAxis, 10);
							var xSetting = parseInt(point.dataset.hotspotXAxis, 10);
							var pointBounds = point.getBoundingClientRect();

							var imageBounds = _this3.imageWrapper.getBoundingClientRect();

							var yDifference = imageBounds.height - pointBounds.height;
							var yPercentage = (yDifference / imageBounds.height) * ySetting;
							point.style.bottom = "".concat(yPercentage, "%");
							var xDifference = imageBounds.width - pointBounds.width;
							var xPercentage = (xDifference / imageBounds.width) * xSetting;
							point.style.left = "".concat(xPercentage, "%");
							point.style.visibility = "visible";
						});
					},
				},
				{
					key: "positionTooltips",
					value: function positionTooltips() {
						var _this4 = this;

						// Reposition any tooltips that are overflowing the viewport
						// We update this each time the tooltip opens, so we also
						// need to unset any 'overflow' classes or styles if conditions
						// have changed
						this._resetTooltips();

						var imageWrapperRightBound =
							this.imageWrapper.getBoundingClientRect().right;
						this.tooltips.forEach(function (tooltip) {
							var elementBounds = tooltip.getBoundingClientRect();
							var style = window.getComputedStyle
								? getComputedStyle(tooltip, null)
								: tooltip.currentStyle;
							var marginTop = parseInt(style.marginTop, 10) || 0;
							var marginRight = parseInt(style.marginRight, 10) || 0;
							var marginBottom = parseInt(style.marginBottom, 10) || 0;
							var marginLeft = parseInt(style.marginLeft, 10) || 0;
							var topBounds = elementBounds.top - marginTop;
							var rightBounds = elementBounds.right + marginRight;
							var bottomBounds = elementBounds.bottom + marginBottom;
							var leftBounds = elementBounds.left - marginLeft;

							if (rightBounds >= imageWrapperRightBound) {
								tooltip.classList.add("tooltip--overflow-right");
								var difference = imageWrapperRightBound - rightBounds;
								tooltip.style.left = "".concat(difference, "px");
							}

							if (leftBounds <= 0) {
								tooltip.classList.add("tooltip--overflow-left");

								var _difference = Math.abs(leftBounds);

								tooltip.style.left = "".concat(_difference, "px");
							}

							if (topBounds <= 0) {
								// This should never happen because tooltips are always below
								// the hotspot node, but in case there's a theme-specific case where
								// this can happen, we'll add a class if it overflows the top of the
								// viewport
								tooltip.classList.add("tooltip--overflow-top");
							}

							if (bottomBounds >= _this4.window.innerHeight) {
								tooltip.classList.add("tooltip--overflow-bottom");

								var _difference2 = _this4.window.innerHeight - bottomBounds;

								tooltip.style.top = "".concat(_difference2, "px");
							}
						});
					},
				},
				{
					key: "onSectionBlockSelect",
					value: function onSectionBlockSelect(block) {
						var _this5 = this;

						this._clearAllActive();

						var scrollEvent = false;
						this.windowScrollEvent = this.events.register(
							this.window,
							"scroll",
							function () {
								scrollEvent = true;

								if (_this5.windowScrollTimer !== null) {
									clearTimeout(_this5.windowScrollTimer);
								}

								_this5.windowScrollTimer = setTimeout(function () {
									_this5.positionTooltips();

									block.el.classList.add(_this5.activeClass);
									_this5.windowScrollTimer = null;
								}, 200);
							}
						);

						if (scrollEvent === false) {
							this.positionTooltips();
							block.el.classList.add(this.activeClass);
						}
					},
				},
				{
					key: "onSectionBlockDeselect",
					value: function onSectionBlockDeselect(block) {
						this.events.unregister(this.windowScrollEvent);
						this.windowScrollEvent = null;
						block.el.classList.remove(this.activeClass);
					},
				},
				{
					key: "onSectionUnload",
					value: function onSectionUnload() {
						this.events.unregisterAll();
					},
				},
			]);

			return ShoppableImage;
		})();

		/* harmony default export */ const pxs_shoppable_image_dist_index_es =
			ShoppableImage; // CONCATENATED MODULE: ./source/scripts/sections/DynamicShoppableImage.js

		class DynamicShoppableImage extends pxs_shoppable_image_dist_index_es {
			constructor(section) {
				super(section);
				this.modalSelector = `[data-hotspot-modal-id='${section.id}']`;
				this.modalEl = document.querySelector(this.modalSelector);
				this.modalWrapper = document.querySelector(
					`[data-hotspot-section-id='${section.id}']`
				);
				this.quickShopSelector = `[data-hotspot-section-id='${section.id}'] [data-hotspot-modal-quickshop]`;
				this.quickshopSpinner = this.modalEl.querySelector(
					this.quickShopSelector
				).innerHTML;
				this.isOpen = false;
				this.modalSidebar = this.modalWrapper.querySelector(
					"[data-hotspot-modal-sidebar]"
				);
				this.modalSidebarItems = this.modalWrapper.querySelectorAll(
					"[data-hotspot-modal-sidebar-item]"
				);
				this.sidebarArrow = this.modalEl.querySelector("[data-sidebar-arrow]");
				this.sidebarItemActiveClass = "active-item";
				this.qsTrigger = null;
				this.modal = new Modal({
					onClose: () => this.unload(),
				});
				this.points.forEach((point) => {
					this.events.register(point, "animationend", (e) => {
						if (e.animationName === "slide-fade-y" && e.elapsedTime > 0) {
							point.classList.add("shoppable-image__hotspot--pulse");
							point.classList.remove("pxu-lia-element");
							point.style.animationPlayState = "";
						}
					});
				});
				this.tooltips.forEach((tooltip) => {
					this.events.register(tooltip, "click", (e) => this.onTooltipClick(e));
				});
				this.modalSidebarItems.forEach((item) => {
					this.events.register(item, "click", (e) =>
						this.onSidebarItemClick(e)
					);
				});
			}

			onTooltipClick(event) {
				event.preventDefault();
				const productUrl = event.currentTarget
					.querySelector("[data-tooltip]")
					.getAttribute("href");
				const productId =
					event.currentTarget.closest("[data-hotspot]").dataset.hotspotProduct;
				this.points.forEach((point) => {
					if (point.dataset.hotspotProduct === productId) {
						this.qsTrigger = point;
					}
				});

				if (productUrl === "#") {
					return;
				}

				this.modal.open(this.modalSelector, "quickshop-full hotspot__modal");
				const selectedItem = this.modalWrapper.querySelector(
					`[data-product-id='${productId}']`
				);
				selectedItem.classList.add(this.sidebarItemActiveClass);
				this.positionSidebarArrow(selectedItem);
				this.isOpen = true;

				this._fetchQuickshop(productId, productUrl);
			}

			onSidebarItemClick(event) {
				event.preventDefault();
				const currentSidebarItem = event.currentTarget;
				const productUrl = currentSidebarItem.dataset.productQuickshopUrl;
				const productId = currentSidebarItem.dataset.productId;
				const activeSidebarItems = this.modalWrapper.querySelectorAll(
					`.${this.sidebarItemActiveClass}`
				);
				this.modalWrapper.querySelector(
					"[data-hotspot-modal-quickshop]"
				).innerHTML = this.quickshopSpinner;
				this.positionSidebarArrow(currentSidebarItem);
				activeSidebarItems.forEach((item) => {
					item.classList.remove(this.sidebarItemActiveClass);
				});
				currentSidebarItem.classList.add(this.sidebarItemActiveClass);

				if (productUrl && productId) {
					this._fetchQuickshop(productId, productUrl);
				}
			}

			positionSidebarArrow(selectedItem) {
				const itemImg = selectedItem.querySelector(
					"[data-modal-sidebar-image]"
				);
				const imgBounds = itemImg.getBoundingClientRect();
				const selectedItemTop = selectedItem.offsetTop;
				const middlePoint = selectedItemTop + imgBounds.height / 2;
				this.sidebarArrow.style.top = `${middlePoint}px`;
			}

			_fetchQuickshop(productId, productUrl) {
				const quickshopContainer = this.modal.$modalInner[0].querySelector(
					"[data-hotspot-modal-quickshop]"
				);
				const $quickshopEl = this.modal.$modalInner.find(
					"[data-hotspot-modal-sidebar-item]"
				);
				const spinnerContainer = this.modalWrapper.querySelector(
					".productitem-quickshop"
				);

				if (spinnerContainer) {
					spinnerContainer.style.display = "block";
				}

				this.productQuickshop = new ProductQuickshop({
					$el: $quickshopEl,
					id: this.sectionId,
					modal: this.modal,
					sectionContext: "shoppable-image",
					trigger: jquery_default()(this.qsTrigger),
					quickshopContainer,
					quickShopSelector: this.quickShopSelector,
					productUrl,
					view: "product-shoppable-img-qs",
				});
			}

			unload() {
				if (this.productQuickshop) {
					this.productQuickshop.unload();
				}

				const activeSidebarItems = this.modalWrapper.querySelectorAll(
					`.${this.sidebarItemActiveClass}`
				);
				activeSidebarItems.forEach((item) => {
					item.classList.remove(this.sidebarItemActiveClass);
				});
			}
		} // CONCATENATED MODULE: ./source/scripts/sections/DynamicTestimonials.js
		class DynamicTestimonials {
			constructor(section) {
				this.$el = section.el;
				this.$window = $(window);
				this.flickity = null;
				this.events = new EventHandler /* default */.Z();
				this.carousel = this.$el.querySelector(".testimonials");
				this.slides = this.$el.querySelectorAll(".testimonial");

				this.onBreakpointChange = () => {
					if (
						(cjs.max("XS") && this.slides.length > 1) ||
						(cjs.max("L") && this.slides.length >= 3) ||
						(cjs.min("XL") && this.slides.length > 3)
					) {
						this._initFlickity();
					} else {
						this._destroyFlickity();
					}
				};

				this.onBreakpointChange();
				cjs.onChange(this.onBreakpointChange);
			}

			onSectionUnload() {
				this._destroyFlickity();

				cjs.offChange(this.onBreakpointChange);
				this.events.unregisterAll();
			}

			_initFlickity() {
				if (this.Flickity) {
					return;
				}

				this.flickity = new (js_default())(this.carousel, {
					autoPlay: 0,
					accessibility: true,
					cellAlign: "left",
					cellSelector: ".testimonial",
					groupCells: true,
					pageDots: true,
					contain: true,
					adaptiveHeight: false,
					arrowShape:
						"M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z",
				});
				this.events.register(this.carousel, "rimg:load", () => {
					this.flickity.resize();
				});
			}

			_destroyFlickity() {
				if (!this.flickity) {
					return;
				}

				this.flickity.destroy();
				this.flickity = null;
			}
		} // CONCATENATED MODULE: ./source/scripts/templates/Account.js
		class Account {
			constructor() {
				this.$accountContents = jquery_default()("[data-template-account]");
				this.$loginContent = jquery_default()("[data-template-account-login]");
				this.$addressesContent = jquery_default()(
					"[data-template-account-addresses]"
				);
				this.$addressButtonFocus = null;
				this._loginToggle = this._loginToggle.bind(this);

				if (this.$loginContent.length) {
					this._initLoginPage();
				}

				if (this.$addressesContent.length) {
					this._initAddressPage();
				}

				if (this.$accountContents.length) {
					this._init();
				}
			}

			_init() {
				new Forms(this.$accountContents);
			}

			_initLoginPage() {
				this.$loginToggle = this.$loginContent.find("[data-login-toggle]");
				this.$login = this.$loginContent.find("[data-account-login-main]");
				this.$recovery = this.$loginContent.find(
					"[data-account-login-recovery]"
				);
				this.$recoveryHasMessage = this.$recovery.find(
					"[data-recovery-has-message]"
				);
				this.$loginToggle.on("click", this._loginToggle);

				if (this.$recoveryHasMessage.length) {
					this._loginToggle();
				}
			}

			_loginToggle() {
				let event =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: null;

				if (event) {
					event.preventDefault();
				}

				this.$login.toggleClass("visible");
				this.$recovery.toggleClass("visible");
			}

			_initAddressPage() {
				const $customerAddresses =
					this.$addressesContent.find("[data-address-id]");
				this.$addressesContent.on("click", "[data-edit-address]", (event) => {
					const $target = jquery_default()(event.currentTarget);
					const itemId = $target.attr("data-edit-address");
					$customerAddresses.removeClass("visible");
					this.$addressButtonFocus = $target;
					jquery_default()(`[data-address-id="${itemId}"]`)
						.addClass("visible")
						.find(".form-field-input")
						.eq(0)
						.focus();
				});
				this.$addressesContent.on("click", "[data-edit-address-cancel]", () => {
					$customerAddresses.removeClass("visible");
					jquery_default()('[data-address-id="new"]').addClass("visible"); // Return focus to last used button

					this.$addressButtonFocus.focus();
					this.$addressButtonFocus = null;
				});
				this.$addressesContent.on("click", "[data-delete-address]", (event) => {
					const itemId = jquery_default()(event.target).attr(
						"data-delete-address"
					);
					Shopify.CustomerAddress.destroy(itemId, "");
				});
				$customerAddresses.each((i, el) => {
					const id = jquery_default()(el).attr("data-address-id");
					const countryEl = `customer_addr_${id}_country`;
					const provinceEl = `customer_addr_${id}_province`;
					const options = {
						hideElement: `address_province_container_${id}`,
					}; // Initiate provinces for address forms

					new Shopify.CountryProvinceSelector(countryEl, provinceEl, options);
				});
			}
		} // CONCATENATED MODULE: ./source/scripts/templates/Contact.js
		class Contact {
			constructor() {
				this.$contactContents = jquery_default()("[data-template-contact]");

				if (this.$contactContents.length) {
					new Forms(this.$contactContents);
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/templates/GiftCard.js
		class GiftCard {
			constructor() {
				this.el = document.querySelector(".template-giftcard");
				this.$el = jquery_default()(this.el);
				this.qrCode = this.el.querySelector("[data-giftcard-qr]");
				this.giftCardCode = this.el.querySelector("[data-giftcard-code]");

				this._bindEvents();

				this.addQrCode();
			}

			addQrCode() {
				return new QRCode(this.qrCode, {
					text: jquery_default()(this.qrCode).data("giftcard-qr"),
					width: 120,
					height: 120,
				});
			}

			_bindEvents() {
				this.$el.on("click", "[data-giftcard-print]", () => {
					window.print();
				}); // Auto-select gift card code on click, based on ID passed to the function

				this.$el.on("click", "[data-giftcard-code]", () => {
					this._selectText();
				});
			}

			_selectText() {
				let range = "";
				let selection;

				if (document.body.createTextRange) {
					// ms method
					range = document.body.createTextRange();
					range.moveToElementText(this.giftCardCode);
					range.select();
				} else if (window.getSelection) {
					// moz, opera, webkit method
					selection = window.getSelection();
					range = document.createRange();
					range.selectNodeContents(this.giftCardCode);
					selection.removeAllRanges();
					selection.addRange(range);
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/templates/Page.js
		class Page {
			constructor() {
				this.$pageContent = jquery_default()("[data-template-page]");

				if (this.$pageContent.length) {
					new RichText(this.$pageContent);
				}
			}
		} // CONCATENATED MODULE: ./source/scripts/templates/Order.js
		class Order {
			constructor() {
				this.el = document.querySelector(".template-order");
				this.checkboxEls = this.el.querySelectorAll("[data-checkbox]");
				this.atcButton = this.el.querySelector("[data-atc-button]");
				this.selectAllCheckbox = this.el.querySelector(
					"[data-select-all-checkbox]"
				);
				this.selectAllCheckboxInput = this.el.querySelector(
					"[data-select-all-checkbox-input]"
				);
				this.selectItemsCountEl = this.el.querySelector(
					"[data-select-items-count]"
				);
				this.lineCheckboxInputs = this.el.querySelectorAll(
					"[data-line-checkbox-input]"
				);
				if (!this.selectAllCheckboxInput) return;
				this.lineCheckboxInputsArray = Array.from(this.lineCheckboxInputs);
				this.data = JSON.parse(
					this.el.querySelector("[data-order-line-items-data]").innerHTML
				);
				this.settings = JSON.parse(
					this.el.querySelector("[data-settings]").innerHTML
				);
				this.itemsToAddToCart = [];
				this.messageBanner = null;
				this.lastCheckedIndex = null;
				this.currentCheckedIndex = null; // We need to create a `Checkbox` instance for each checkbox and access them individually.
				// `this.map` is what will hold each input element along with its `Checkbox` instance.

				this.map = new Map();
				this.events = new EventHandler /* default */.Z();

				this._init();
			}

			get _selectedLines() {
				return this.el.querySelectorAll("[data-line-checkbox-input]:checked");
			}

			get _allLineCheckboxesAreChecked() {
				return (
					this.lineCheckboxInputsArray.filter((inputEl) => !inputEl.checked)
						.length === 0
				);
			}

			get _noCheckboxIsChecked() {
				return (
					this.lineCheckboxInputsArray.filter((inputEl) => inputEl.checked)
						.length === 0
				);
			}

			_init() {
				this.checkboxEls.forEach((el) => {
					this.map.set(el, new Checkbox(el));
				});

				this._bindCheckboxEvents();

				this.events.register(this.atcButton, "click", (event) => {
					this._selectItemsToAddToCart();

					this._addToCart(event);
				});
			}

			_bindCheckboxEvents() {
				this.events.register(this.selectAllCheckboxInput, "change", () => {
					const isChecked = this.selectAllCheckboxInput.checked;

					this._onCheckboxChange(this.selectAllCheckboxInput, isChecked);

					this.lineCheckboxInputs.forEach((inputEl) => {
						inputEl.checked = isChecked;

						this._onCheckboxChange(inputEl, isChecked);
					});

					this._onCheckboxStateUpdate();
				});
				this.lineCheckboxInputs.forEach((inputEl) => {
					this.events.register(inputEl, "change", () => {
						const isInputElChecked = inputEl.checked;

						this._onCheckboxChange(inputEl, isInputElChecked);

						if (isInputElChecked) this._updateCheckedIndexes(inputEl);

						this._onCheckboxStateUpdate();
					});
				}); // Shift + click multi-select feature

				this.events.register(document, "click", (event) => {
					if (!event.shiftKey || event.target.nodeName !== "INPUT") return;
					window.requestAnimationFrame(() => {
						if (
							this.lastCheckedIndex !== null &&
							this.currentCheckedIndex !== null
						) {
							const lastCheckedIndexState =
								this.lineCheckboxInputsArray[this.lastCheckedIndex].checked;
							let start = null;
							let end = null;

							if (this.lastCheckedIndex < this.currentCheckedIndex) {
								start = this.lastCheckedIndex;
								end = this.currentCheckedIndex;
							} else {
								start = this.currentCheckedIndex;
								end = this.lastCheckedIndex;
							}

							for (let i = start; i < end; i++) {
								const el = this.lineCheckboxInputsArray[i];
								el.checked = lastCheckedIndexState;

								this._onCheckboxChange(el, lastCheckedIndexState);
							}

							this._onCheckboxStateUpdate();

							this._resetCheckedIndexes();
						}
					});
				});
			}

			_updateCheckedIndexes(el) {
				// Checking for `null` since `this.lastCheckedIndex` can have a value of `0`
				if (this.lastCheckedIndex === null) {
					this.lastCheckedIndex = this.lineCheckboxInputsArray.indexOf(el);
				} else {
					this.currentCheckedIndex = this.lineCheckboxInputsArray.indexOf(el);
				}
			}

			_resetCheckedIndexes() {
				this.lastCheckedIndex = null;
				this.currentCheckedIndex = null;
			}

			_onCheckboxChange(el, isChecked) {
				let isIndeterminate =
					arguments.length > 2 && arguments[2] !== undefined
						? arguments[2]
						: false;
				const targetEl = el.parentElement;

				if (isChecked) {
					this.map.get(targetEl).unsetIndeterminate();
					this.map.get(targetEl).check();
					el.closest("[data-order-row]")?.classList.add("checkbox-selected");
				} else if (isIndeterminate) {
					this.map.get(targetEl).uncheck();
					this.map.get(targetEl).setIndeterminate();
					el.closest("[data-order-row]")?.classList.add("checkbox-selected");
				} else {
					this.map.get(targetEl).uncheck();
					this.map.get(targetEl).unsetIndeterminate();
					el.closest("[data-order-row]")?.classList.remove("checkbox-selected");
				}
			}

			_onCheckboxStateUpdate() {
				let isChecked = false;
				let isIndeterminate = false;

				if (this._allLineCheckboxesAreChecked) {
					isChecked = true;
					isIndeterminate = false;
				} else if (!this._noCheckboxIsChecked) {
					isChecked = false;
					isIndeterminate = true;
				}

				this.selectAllCheckboxInput.checked = isChecked;
				this.selectAllCheckboxInput.indeterminate = isIndeterminate;

				this._onCheckboxChange(
					this.selectAllCheckboxInput,
					isChecked,
					isIndeterminate
				);

				if (this._noCheckboxIsChecked) {
					this._disableAtcButton();

					this.selectAllCheckbox.classList.remove("order-checkbox--active");
				} else {
					this._enableAtcButton();

					this.selectAllCheckbox.classList.add("order-checkbox--active");
					this.selectItemsCountEl.textContent = this._selectedLines.length;
				}
			}

			_selectItemsToAddToCart() {
				// Reset itemsToAddToCart list
				this.itemsToAddToCart.length = 0;
				const selectedOrderIds = [];

				this._selectedLines.forEach((line) => {
					selectedOrderIds.push(Number(line.getAttribute("data-line-item-id")));
				});

				this.data.forEach((item) => {
					if (selectedOrderIds.includes(item.id)) {
						// Shopify docs: https://shopify.dev/api/ajax/reference/cart
						this.itemsToAddToCart.push({
							id: item.variant_id,
							quantity: item.quantity,
							selling_plan: item.selling_plan_allocation
								? item.selling_plan_allocation.selling_plan.id
								: null,
						});
					}
				});
			}

			_addToCart(event) {
				// Stopping further propagation here is mainly to prevent the click event from bubbling as
				// it will cause an issue with the disclosures and message banner.
				event.stopPropagation();

				this._setAtcButtonProcessing();

				const formData = {
					items: this.itemsToAddToCart,
				};
				fetch(`${window.Theme.routes.cart_add_url}.js`, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(formData),
				})
					.then((response) => response.json())
					.then((data) => {
						this._removeAtcButtonProcessing();

						if (data.message === "Cart Error") {
							return Promise.reject(data);
						}

						return this._onSuccess();
					})
					.catch((error) => {
						this._showErrorBanner(error.description);
					});
			}

			_onSuccess() {
				return fetch(`${window.Theme.routes.cart_url}.js`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
					},
				})
					.then((response) => {
						if (!response.ok) {
							return Promise.reject(response);
						}

						return response.json();
					})
					.then((data) => {
						if (this.settings.cart_redirection) {
							location.href = window.Theme.routes.cart_url;
							return;
						} // Notify Header of new cart count

						const countEvent = new CustomEvent("cartcount:update", {
							detail: data,
						});
						window.dispatchEvent(countEvent);

						this._showSuccessBanner(this.settings.success_message);
					})
					.catch((error) => {
						this._showErrorBanner(error.message);
					});
			}

			_showSuccessBanner(successMsg) {
				this.messageBanner = new MessageBanner(successMsg, "success");
			}

			_showErrorBanner(errorMsg) {
				this.messageBanner = new MessageBanner(errorMsg, "error");
			}

			_enableAtcButton() {
				this.atcButton.classList.remove("disabled");
				this.atcButton.disabled = false;
			}

			_disableAtcButton() {
				this.atcButton.classList.add("disabled");
				this.atcButton.disabled = true;
			}

			_removeAtcButtonProcessing() {
				this.atcButton.classList.remove("processing");
				this.atcButton.disabled = false;
			}

			_setAtcButtonProcessing() {
				this.atcButton.classList.add("processing");
				this.atcButton.disabled = true;
			}
		} // CONCATENATED MODULE: ./source/scripts/components/ProductCompareDrawerContent.js
		class ProductCompareDrawerContent {
			constructor(el) {
				this.el = el;
				this.events = new EventHandler /* default */.Z();
				this.initialHTML = this.el.innerHTML;
				this.productTemplate = this.el.querySelector(
					"[data-product-compare-drawer-item-template]"
				);
				this.events.register(this.el, "click", (e) => {
					const compareDrawerRemoveButton = e.target.closest(
						"[data-product-compare-drawer-remove]"
					);

					if (compareDrawerRemoveButton) {
						this._removeProduct(
							compareDrawerRemoveButton.dataset.productCompareDrawerRemove
						);
					}
				});

				const onUpdate = (_ref) => {
					let { products } = _ref;

					this._reset();

					if (!products.length) {
						this.el.scroll(0, 0);
					}

					products.forEach((product) => this._addProduct(product));
					dist_index_es.watch(this.el);
				};

				onUpdate({
					products: components_ProductCompare.products,
				});
				components_ProductCompare.runOnUpdate(onUpdate);
			}

			unload() {
				this.events.unregisterAll();
			}

			_reset() {
				dist_index_es.unwatch(this.el);
				this.el.innerHTML = this.initialHTML;
			}

			_addProduct(_ref2) {
				let { handle, data } = _ref2;
				const newProduct = this.productTemplate.cloneNode(true).content;
				const newProductFragment = new DocumentFragment();
				const compareDrawerTitle = newProduct.querySelector(
					"[data-product-compare-drawer-title]"
				);
				const compareDrawerImage = newProduct.querySelector(
					"[data-product-compare-drawer-image]"
				);
				const compareDrawerRemove = newProduct.querySelector(
					"[data-product-compare-drawer-remove]"
				);
				const compareDrawerItemPlaceholder = this.el.querySelector(
					"[data-product-compare-drawer-item-placeholder]"
				);
				compareDrawerTitle.innerHTML = data.title;
				compareDrawerTitle.href = data.url;
				compareDrawerRemove.dataset.productCompareDrawerRemove = handle;
				compareDrawerImage.innerHTML = data.image;
				compareDrawerImage.style.setProperty(
					"--product-grid-item-image-aspect-ratio",
					data.imageAspectRatio
				);
				newProductFragment.append(newProduct);
				this.el.insertBefore(newProductFragment, compareDrawerItemPlaceholder);

				if (compareDrawerItemPlaceholder) {
					compareDrawerItemPlaceholder.remove();
				}
			}

			_removeProduct(handle) {
				components_ProductCompare.remove(handle);
			}
		} // CONCATENATED MODULE: ./source/scripts/components/ProductCompareFlyout.js
		const ProductCompareFlyout_storageKey = "pxuProductCompareFlyoutV1";
		class ProductCompareFlyout {
			constructor(el) {
				this.el = el;
				this.events = new EventHandler /* default */.Z();
				this.compareDrawerLink = this.el.querySelector(
					"[data-product-compare-drawer-link]"
				);
				this.compareDrawerLinkHref = this.compareDrawerLink.href;
				this.compareDrawerClearAllButton = this.el.querySelector(
					"[data-product-compare-clear-all]"
				);
				this.compareDrawerTitle = this.el.querySelector(
					"[data-product-compare-drawer-title]"
				);
				this.compareDrawerNotification = this.el.querySelector(
					"[data-product-compare-drawer-notification]"
				);
				this.compareDrawerCountOne =
					this.compareDrawerNotification.dataset.productCountOne;
				this.compareDrawerCountOther =
					this.compareDrawerNotification.dataset.productCountOther;
				this.compareDrawerHeader = this.el.querySelector(
					"[data-product-compare-drawer-header]"
				);
				this.compareDrawerContent = new ProductCompareDrawerContent(
					this.el.querySelector("[data-compare-drawer-items-container]")
				);
				this.preferredState = this._loadPreferredState() || "open";
				this.drawerAnimation = transition({
					state: "hidden",
					el: this.el,
				});
				this.events.register(window, "resize", () => {
					if (this.drawerAnimation.state === "hidden") return;

					this._updateDrawerPosition();
				});
				this.events.register(this.compareDrawerHeader, "click", () => {
					if (this.drawerAnimation.state === "open") {
						this._savePreferredState("closed");

						this._closeDrawer();
					} else {
						this._savePreferredState("open");

						this._openDrawer();
					}
				});
				this.events.register(this.compareDrawerClearAllButton, "click", () => {
					components_ProductCompare.removeAll();
				});
				let lastUpdateCount = components_ProductCompare.products.length;

				const onUpdate = (_ref) => {
					let { products } = _ref;

					if (products.length > 0) {
						if (products.length > lastUpdateCount) {
							// drawer should always open when a new product is added
							this._openDrawer();

							this._savePreferredState("open");
						} else {
							this._showDrawer();
						}
					} else {
						this._hideDrawer();
					}

					lastUpdateCount = products.length;

					this._updateDrawerCompareLink();

					this._updateDrawerNotification();
				};

				onUpdate({
					products: components_ProductCompare.products,
				});
				components_ProductCompare.runOnUpdate(onUpdate);
			}

			unload() {
				this.events.unregisterAll();
				this.compareDrawerContent.unload();
				this.drawerAnimation.unload();
			}

			_showDrawer() {
				this.drawerAnimation.animateTo(this.preferredState, {
					onStart: () => {
						this._updateDrawerPosition();
					},
				});
			}

			_openDrawer() {
				this.drawerAnimation.animateTo("open", {
					onStart: () => {
						this._updateDrawerPosition();
					},
				});

				this._updateDrawerCompareLink();

				this._updateDrawerNotification();
			}

			_hideDrawer() {
				this.drawerAnimation.animateTo("hidden");
			}

			_closeDrawer() {
				this.drawerAnimation.animateTo("closed");

				this._updateDrawerCompareLink();

				this._updateDrawerNotification();
			}

			_updateDrawerPosition() {
				this.el.style.setProperty(
					"--compare-drawer-header-height",
					`${this.compareDrawerHeader.offsetHeight}px`
				);
			}

			_updateDrawerNotification() {
				if (components_ProductCompare.products.length === 1) {
					this.compareDrawerNotification.innerHTML = this.compareDrawerCountOne;
				} else {
					const compareDrawerNotificationString =
						this.compareDrawerCountOther.replace(
							"** count **",
							components_ProductCompare.products.length
						);
					this.compareDrawerNotification.innerHTML =
						compareDrawerNotificationString;
				}
			}

			_updateDrawerCompareLink() {
				const compareDrawerLinkText =
					this.compareDrawerLink.dataset.productCompareDrawerLinkText; // Default locale will end in `/`, other locales will end in `/de` for example

				const separator = /\/$/.test(this.compareDrawerLinkHref) ? "" : "/";
				const [firstProduct, ...otherProducts] =
					components_ProductCompare.products;

				if (components_ProductCompare.products.length > 1) {
					this.compareDrawerLink.classList.remove("disabled");
				} else {
					this.compareDrawerLink.classList.add("disabled");
				}

				if (components_ProductCompare.products.length > 0) {
					this.compareDrawerLink.innerHTML = `${compareDrawerLinkText} (${components_ProductCompare.products.length})`;
				} else {
					this.compareDrawerLink.innerHTML = `${compareDrawerLinkText}`;
				}

				if (!firstProduct) return;
				const otherProductHandles = otherProducts
					.map((_ref2) => {
						let { handle } = _ref2;
						return handle;
					})
					.join(",");
				this.compareDrawerLink.href = `${this.compareDrawerLinkHref}${separator}products/${firstProduct.handle}?view=compare&compare=${otherProductHandles}`;
			}

			_loadPreferredState() {
				try {
					return JSON.parse(
						sessionStorage.getItem(ProductCompareFlyout_storageKey)
					);
				} catch (e) {
					return null;
				}
			}

			_savePreferredState(state) {
				this.preferredState = state;
				sessionStorage.setItem(
					ProductCompareFlyout_storageKey,
					JSON.stringify(state)
				);
			}
		} // CONCATENATED MODULE: ./source/scripts/helpers/FlickityTouchFix.js
		// This is a helper class to fix a touch issue that came up in flickity
		// on iOS devices as of version 13. It should smooth out some of the scroll
		// and swipe issues that flickity is having on that version of iOS.
		const flickityTouchFix = () => {
			let touchingSlider = false;
			let touchStartCoordsX = 0;

			const onTouchStart = (e) => {
				if (e.target.closest && e.target.closest(".flickity-slider")) {
					touchingSlider = true;
					touchStartCoordsX = e.touches[0].pageX;
				} else {
					touchingSlider = false;
				}
			};

			const onTouchMove = (e) => {
				if (!(touchingSlider && e.cancelable)) {
					return;
				}

				if (Math.abs(e.touches[0].pageX - touchStartCoordsX) > 10) {
					e.preventDefault();
				}
			};

			document.body.addEventListener("touchstart", onTouchStart);
			document.body.addEventListener("touchmove", onTouchMove, {
				passive: false,
			});
		};

		/* harmony default export */ const FlickityTouchFix = flickityTouchFix; // CONCATENATED MODULE: ./source/scripts/helpers/ContainSwatchTooltips.js
		function setTooltipOffset(target) {
			const margin = 10;
			const { innerWidth } = window;
			const { x, width } = target.getBoundingClientRect();
			const tooltipWidth = parseFloat(
				window.getComputedStyle(target, ":after").width
			);
			const required = tooltipWidth * 0.5;
			let available = 0;
			let offset = 0;

			if (x < innerWidth * 0.5) {
				// Closer to left side of screen
				available = x + width * 0.5 - margin;
				offset = required - available;
			} else {
				available = innerWidth - x - width * 0.5 - margin;
				offset = available - required;
			}

			target.style.setProperty(
				"--swatch-tooltip-offset",
				`${required >= available ? offset : 0}px`
			);
		}

		function handleMouseover(_ref) {
			let { target } = _ref;
			// We need to check for dataset, because IE11 doesn't support
			// the dataset property for certain elements like svgs
			if (target.dataset && !target.dataset.swatchTooltip) return;
			window.requestAnimationFrame(() => setTooltipOffset(target));
		}

		class ContainSwatchTooltips {
			constructor() {
				window.addEventListener("mouseover", handleMouseover);
			}

			unload() {
				window.removeEventListener("mouseover", handleMouseover);
			}
		} // CONCATENATED MODULE: ./source/scripts/Empire.js
		// jQuery plugins

		// eslint-disable-line

		// eslint-disable-line
		// Global imports

		// Shared sections

		// Responsive Images

		// eslint-disable-line
		// Section Manager

		// Polyfills

		// Static Sections

		// Dynamic sections

		// Templates

		// Flickity iOS fix

		const initEmpire = () => {
			initLoadInAnimationsAutoplay();
			dist_index_es.init('[data-rimg="lazy"]', {
				round: 1,
			});

			const initRipple = () => setupRippleEffect(document);

			if ("requestIdleCallback" in window) {
				window.requestIdleCallback(initRipple);
			} else {
				initRipple();
			}

			const sections = new Sections(); // Static sections

			sections.register(
				"static-header",
				(section) => new StaticHeader(section)
			);
			sections.register(
				"static-announcement",
				(section) => new StaticAnnouncement(section)
			);
			sections.register(
				"static-footer",
				(section) => new StaticFooter(section)
			);
			sections.register(
				"static-article",
				(section) => new StaticArticle(section)
			);
			sections.register("static-blog", (section) => new StaticBlog(section));
			sections.register("static-cart", (section) => new StaticCart(section));
			sections.register(
				"static-collection",
				(section) => new StaticCollection(section)
			);
			sections.register(
				"static-collection-faceted-filters",
				(section) => new FacetedFilterCollection(section)
			);
			sections.register(
				"static-subcollections-menu",
				(section) => new StaticSubCollectionsMenuList(section)
			);
			sections.register(
				"static-password",
				(section) => new StaticPassword(section)
			);
			sections.register(
				"static-product",
				(section) => new StaticProduct(section)
			);
			sections.register(
				"static-product-compare",
				(section) => new StaticProductCompare(section)
			);
			sections.register(
				"static-product-recommendations",
				(section) => new StaticProductRecommendations(section)
			);
			sections.register(
				"static-recently-viewed",
				(section) => new StaticRecentlyViewed(section)
			);
			sections.register(
				"static-search",
				(section) => new StaticSearch(section)
			);
			sections.register(
				"static-search-faceted-filters",
				(section) => new FacetedFilterSearch(section)
			);
			sections.register(
				"static-utility-bar",
				(section) => new StaticUtilityBar(section)
			);
			sections.register(
				"static-subcollections-featured-collection",
				(section) => new StaticSubcollectionsFeaturedCollection(section)
			); // Dynamic sections (lazy loaded)

			sections.register(
				"dynamic-blog-posts",
				(section) => new DynamicTwitterFeed(section),
				{
					lazy: true,
				}
			);
			sections.register(
				"dynamic-promo-mosaic",
				(section) => new DynamicPromoBlocks(section),
				{
					lazy: true,
				}
			);
			sections.register(
				"dynamic-menu-list",
				(section) => new DynamicMenuList(section),
				{
					lazy: true,
				}
			);
			sections.register(
				"dynamic-twitter-feed",
				(section) => new DynamicTwitterFeed_DynamicTwitterFeed(section),
				{
					lazy: true,
				}
			);
			sections.register(
				"dynamic-collection-list",
				(section) => new DynamicCollectionList(section),
				{
					lazy: true,
				}
			);
			sections.register(
				"dynamic-countdown-timer",
				(section) => new DynamicCountdownTimer(section),
				{
					lazy: true,
				}
			);
			sections.register(
				"dynamic-featured-collection",
				(section) => new DynamicFeaturedCollection(section),
				{
					lazy: true,
				}
			);
			sections.register(
				"dynamic-featured-product",
				(section) => new DynamicProduct(section),
				{
					lazy: true,
				}
			);
			sections.register(
				"dynamic-rich-text",
				(section) => new DynamicRichText(section),
				{
					lazy: true,
				}
			);
			sections.register(
				"dynamic-page",
				(section) => new DynamicRichText(section),
				{
					lazy: true,
				}
			);
			sections.register(
				"dynamic-html",
				(section) => new DynamicRichText(section),
				{
					lazy: true,
				}
			);
			sections.register(
				"dynamic-search",
				(section) => new DynamicSearch(section),
				{
					lazy: true,
				}
			);
			sections.register(
				"dynamic-highlights-banner",
				(section) => new DynamicHighlightsBanner(section)
			);
			sections.register(
				"pxs-slideshow",
				(section) => new DynamicSlideshow(section),
				{
					lazy: true,
				}
			);
			sections.register(
				"dynamic-video",
				(section) => new DynamicVideo(section),
				{
					lazy: true,
				}
			);
			sections.register(
				"pxs-newsletter",
				(section) => new DynamicNewsletter(section),
				{
					lazy: true,
				}
			);
			sections.register("pxs-map", (section) => new index_es(section), {
				lazy: true,
			});
			sections.register(
				"pxs-shoppable-image",
				(section) => new DynamicShoppableImage(section),
				{
					lazy: false,
				}
			);
			sections.register(
				"dynamic-testimonials",
				(section) => new DynamicTestimonials(section),
				{
					lazy: true,
				}
			);
			sections.register("age-gate", (section) => new PageAgeGate(section));

			if (document.body.classList.contains("template-giftcard")) {
				new GiftCard();
			}

			if (document.querySelector("[data-template-account]")) {
				new Account();
			}

			if (document.querySelector("[data-template-contact]")) {
				new Contact();
			}

			if (document.body.classList.contains("template-page")) {
				new Page();
			}

			if (document.body.classList.contains("template-order")) {
				new Order();
			}

			if (document.querySelector("[data-swatch-tooltip]")) {
				new ContainSwatchTooltips();
			}

			const compareDrawer = document.querySelector(
				"[data-product-compare-drawer]"
			);

			if (compareDrawer) {
				new ProductCompareFlyout(compareDrawer);
			}
		};

		FlickityTouchFix();

		if (checkPolyfills.length) {
			script_default()(checkPolyfills, initEmpire);
		} else {
			initEmpire();
		}

		const ageGatePage = document.getElementById("age-gate-page");

		if (ageGatePage) {
			new SiteAgeGate(ageGatePage);
		}
	})();

	/******/
})();

// Easysearch Custom Start:
document.addEventListener("easysearch_init_native_search_page", function () {
	easysearch.toggleFitmentWidgetNATIVE = easysearch.toggleFitmentWidget;
	easysearch.toggleFitmentWidget = function (fitWidget, url) {
		this.toggleFitmentWidgetNATIVE(fitWidget, url);
		if (fitWidget && url) {
			fitWidget.querySelector(".easysearch-fitment-other-results").innerHTML =
				'<a href="' +
				url +
				'" class="easysearch-fitment-link">' +
				this.getPhrase(this.settings.form, "fitment_btn_other") +
				"</a>";
		}
		return false;
	};
});

document.addEventListener("easysearch_loaded", function () {
	let easyContainer = document.querySelector(".easyYMM.hidden");
	let garageOverlay = document.querySelector(".garage-easyYMM-popup-overlay");
	let easyBtn = document.querySelector(".easyContainer");
	let easyBtnMobile = document.querySelector(".easyContainer.mobile");
	let easyBtnSlideshow = document.querySelector(".easy-slideshow");
	document
		.getElementById("easysearch-search")
		.setAttribute(
			"style",
			"background: #334FB4 !important; line-height: 30px !important; font-size: 12px !important;"
		);
	const garagePopupContainer = document.querySelector(
		".garage-easyYMM-popup-container"
	);
	const easyYMMElement = garagePopupContainer.querySelector(".easyYMM");
	const vinToCollection = document.getElementById(
		"vin-to-collection-placeholder"
	);
	const vinToCollectionOr = document.getElementById("vin-to-collection-or");
	const addVehicleBtn = document.getElementById("add-vehicle-btn");
	const closeGarageBtn = document.querySelector(".garage-close-button");
	// const searchBtn = document.getElementById('easysearch-search');
	// const selectsHolder = document.querySelector('.easysearch-holder');
	// if (searchBtn && selectsHolder) {
	//   selectsHolder.appendChild(searchBtn);
	// }

	// function hideShopifyChat() {
	//   const shopifyChat = document.getElementById('shopify-chat');
	//   if (shopifyChat) {
	//     shopifyChat.style.display = 'none';
	//   }
	// }

	// // Function to show Shopify chat widget
	// function showShopifyChat() {
	//   const shopifyChat = document.getElementById('shopify-chat');
	//   if (shopifyChat) {
	//     shopifyChat.style.display = 'block';
	//   }
	// }

	// Attach event listener to the container
	// easyBtn.addEventListener("click", function (event) {
	//   // Check if "Change" or the container was clicked
	//   const target = event.target;
	//   console.log("the target", target);
	//   if (target.classList.contains("change-option") || target.closest("#easyBtn")) {

	//     // Setting this to true because the garage was opened from the nav bar--if on product
	//     // page then must navigate to the collections page in this case
	//     garageToCollections = true;
	//     toggleGaragePopup();
	//   }
	//   // hideShopifyChat();
	// });
	if (easyBtn) {
		easyBtn.onclick = (event) => {
			const target = event.target;
			if (
				target.classList.contains("change-option") ||
				target.closest("#easyBtn")
			) {
				garageToCollections = true;
				toggleGaragePopup();
			}
		};
	}

	easyBtnMobile.onclick = (event) => {
		// Check if "Change" or the container was clicked
		const target = event.target;
		if (
			target.classList.contains("change-option") ||
			target.closest("#easyBtn")
		) {
			// Setting this to true because the garage was opened from the nav bar--if on product
			// page then must navigate to the collections page in this case
			garageToCollections = true;
			toggleGaragePopup();
		}
		// hideShopifyChat();
	};

	//close window when clicked outside of window
	window.onclick = function (event) {
		if (event.target === garageOverlay) {
			let terms = JSON.parse(localStorage.getItem("searchTerms")) || [];
			if (
				document.getElementById("add-vehicle-btn").style.display === "none" &&
				terms.length > 0
			) {
				easyYMMElement.style.display = "none";
				vinToCollection.style.display = "none";
				vinToCollectionOr.style.display = "none";
				if (garagePopupContainer) {
					garagePopupContainer.classList.remove("no-bottom-radius");
				}
				document.getElementById("add-vehicle-btn").style.display = "flex";
				document.querySelector(".garage-block").style.display = "block";
				document.querySelector(".select-your-vehicle-header").style.display =
					"none";
			}
			toggleGaragePopup();
			// showShopifyChat();
		}
		if (event.target === document.querySelector(".garage-close-button")) {
			let terms = JSON.parse(localStorage.getItem("searchTerms")) || [];
			if (
				document.getElementById("add-vehicle-btn").style.display === "none" &&
				terms.length > 0
			) {
				easyYMMElement.style.display = "none";
				vinToCollection.style.display = "none";
				vinToCollectionOr.style.display = "none";
				if (garagePopupContainer) {
					garagePopupContainer.classList.remove("no-bottom-radius");
				}
				document.getElementById("add-vehicle-btn").style.display = "flex";
				document.querySelector(".garage-block").style.display = "block";
				document.querySelector(".select-your-vehicle-header").style.display =
					"none";
			}
			toggleGaragePopup();
			// showShopifyChat();
			// check window variable for edit info, if compare current active car ymm with it,
			// if no match, reload the page
			const vehicle = document.querySelector(".ss_megamenu_title_hero_link");
			let vehicleData = "";
			if (vehicle) {
				vehicleData = vehicle.textContent;
			}
			if (
				window.editCarState &&
				window.editCarState.open &&
				vehicleData !== window.editCarState.ymm
			) {
				if (window.location.href.includes("products")) {
					// Update fitment object before reload
					const searchTerms = getSearchTerms();
					if (searchTerms.length > 0) {
						const newFirstVehicle = searchTerms[0];
						const fields = [
							newFirstVehicle.year,
							newFirstVehicle.make,
							newFirstVehicle.model,
							newFirstVehicle.submodel,
							newFirstVehicle.engine,
						];
						const fitmentValue = fields
							.filter((f) => f && f.trim())
							.map((f) => f.trim() + "easysearch-preselect-delimiter")
							.join("");
						const expires = Date.now() + 365 * 24 * 60 * 60 * 1000;
						setFitmentObject({
							value: fitmentValue,
							expires: expires.toString(),
						});
					} else {
						localStorage.setItem(
							"easysearch-preselect-fitment",
							JSON.stringify({ value: "" })
						);
					}
					window.location.reload();
				} else {
					window.location.href = window.editCarState.url;
				}
			}
		}
	};

	// Add event listener for keydown (Esc key) to close the modal
	window.addEventListener("keydown", function (event) {
		if (event.key === "Escape") {
			// Escape key
			toggleGaragePopup();
			// showShopifyChat();
		}
	});

	let easyCustomMetafield = document.querySelector(
		".easysearch-custom-metafield"
	);
	let easyFitDetails = document.querySelector(
		".easysearch-fitment-widget .easysearch-fitment-details"
	);
	if (
		easyCustomMetafield &&
		easyCustomMetafield.textContent !== "" &&
		easyFitDetails
	) {
		let easyMetafieldOld = document.querySelector(
			".easysearch-custom-metafield div"
		);
		let easyMetafieldContent = document.querySelector(
			".easysearch-custom-metafield div"
		);
		if (easyMetafieldContent) {
			let easyMetafieldNew = easyMetafieldContent.textContent
				.split("•")
				.slice(1);
			easyMetafieldNew.forEach(function (element) {
				element = `•${element}`;
				const newElement = document.createElement("span");
				newElement.textContent = element;
				newElement.style.display = "block";
				easyCustomMetafield.append(newElement);
			});
			easyMetafieldOld.remove();
			easyFitDetails.append(easyCustomMetafield);
		}
	}

	// Easysearch Change Vehicle functionality
	// Overrides original Easysearch change vehicle click events
	let easysearchChangeVehicle = document.querySelector(
		".easysearch-fitment-change"
	);
	if (easysearchChangeVehicle) {
		easysearchChangeVehicle.addEventListener(
			"click",
			function (event) {
				event.stopImmediatePropagation(); // Prevents any other click handlers from running

				// If on product page, in this case must stay on this page and not navigate
				// to the collections page
				garageToCollections = false;
				toggleGaragePopup();
			},
			true
		); // Use capture phase to ensure this runs before the original
	}
});
// Easysearch Custom Finish


// Track search events for Intelligems
document.addEventListener("DOMContentLoaded", function () {
	const searchForm = document.querySelector("[data-live-search-form]");

	if (searchForm) {
		// Track form submission (when user hits Enter or clicks search button)
		searchForm.addEventListener("submit", function (e) {
			const searchInput = this.querySelector("[data-live-search-input]");
			const searchTerm = searchInput ? searchInput.value : "";

			window.igEvents = window.igEvents || [];
			window.igEvents.push({
				event: "searchSubmitted",
			});
		});

		// Track clicks on predictive search suggestions (event delegation for dynamic content)
		document.addEventListener("click", function (e) {
			const suggestionLink = e.target.closest(".search-flydown--product");

			if (suggestionLink) {
				const searchInput = document.querySelector("[data-live-search-input]");
				const searchTerm = searchInput ? searchInput.value : "";
				const productTitle = suggestionLink.querySelector(
					".search-flydown--product-title"
				);
				const productName = productTitle ? productTitle.textContent.trim() : "";

				window.igEvents = window.igEvents || [];
				window.igEvents.push({
					event: "searchSubmitted",
				});
			}
		});
	}
});